var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a4, b3) => {
  for (var prop in b3 || (b3 = {}))
    if (__hasOwnProp.call(b3, prop))
      __defNormalProp(a4, prop, b3[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b3)) {
      if (__propIsEnum.call(b3, prop))
        __defNormalProp(a4, prop, b3[prop]);
    }
  return a4;
};
var __spreadProps = (a4, b3) => __defProps(a4, __getOwnPropDescs(b3));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// ../../node_modules/@stitches/react/dist/index.mjs
import Z from "react";
var e = "colors";
var t = "sizes";
var r = "space";
var n = { gap: r, gridGap: r, columnGap: r, gridColumnGap: r, rowGap: r, gridRowGap: r, inset: r, insetBlock: r, insetBlockEnd: r, insetBlockStart: r, insetInline: r, insetInlineEnd: r, insetInlineStart: r, margin: r, marginTop: r, marginRight: r, marginBottom: r, marginLeft: r, marginBlock: r, marginBlockEnd: r, marginBlockStart: r, marginInline: r, marginInlineEnd: r, marginInlineStart: r, padding: r, paddingTop: r, paddingRight: r, paddingBottom: r, paddingLeft: r, paddingBlock: r, paddingBlockEnd: r, paddingBlockStart: r, paddingInline: r, paddingInlineEnd: r, paddingInlineStart: r, top: r, right: r, bottom: r, left: r, scrollMargin: r, scrollMarginTop: r, scrollMarginRight: r, scrollMarginBottom: r, scrollMarginLeft: r, scrollMarginX: r, scrollMarginY: r, scrollMarginBlock: r, scrollMarginBlockEnd: r, scrollMarginBlockStart: r, scrollMarginInline: r, scrollMarginInlineEnd: r, scrollMarginInlineStart: r, scrollPadding: r, scrollPaddingTop: r, scrollPaddingRight: r, scrollPaddingBottom: r, scrollPaddingLeft: r, scrollPaddingX: r, scrollPaddingY: r, scrollPaddingBlock: r, scrollPaddingBlockEnd: r, scrollPaddingBlockStart: r, scrollPaddingInline: r, scrollPaddingInlineEnd: r, scrollPaddingInlineStart: r, fontSize: "fontSizes", background: e, backgroundColor: e, backgroundImage: e, borderImage: e, border: e, borderBlock: e, borderBlockEnd: e, borderBlockStart: e, borderBottom: e, borderBottomColor: e, borderColor: e, borderInline: e, borderInlineEnd: e, borderInlineStart: e, borderLeft: e, borderLeftColor: e, borderRight: e, borderRightColor: e, borderTop: e, borderTopColor: e, caretColor: e, color: e, columnRuleColor: e, fill: e, outline: e, outlineColor: e, stroke: e, textDecorationColor: e, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: t, minBlockSize: t, maxBlockSize: t, inlineSize: t, minInlineSize: t, maxInlineSize: t, width: t, minWidth: t, maxWidth: t, height: t, minHeight: t, maxHeight: t, flexBasis: t, gridTemplateColumns: t, gridTemplateRows: t, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" };
var o = (e3, t3) => typeof t3 == "function" ? { "()": Function.prototype.toString.call(t3) } : t3;
var i = () => {
  const e3 = Object.create(null);
  return (t3, r2, ...n2) => {
    const i3 = ((e4) => JSON.stringify(e4, o))(t3);
    return i3 in e3 ? e3[i3] : e3[i3] = r2(t3, ...n2);
  };
};
var s = Symbol.for("sxs.internal");
var l = (e3, t3) => Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3));
var a = (e3) => {
  for (const t3 in e3)
    return true;
  return false;
};
var { hasOwnProperty: c } = Object.prototype;
var d = (e3) => e3.includes("-") ? e3 : e3.replace(/[A-Z]/g, (e4) => "-" + e4.toLowerCase());
var p = /\s+(?![^()]*\))/;
var u = (e3) => (t3) => e3(...typeof t3 == "string" ? String(t3).split(p) : [t3]);
var g = { appearance: (e3) => ({ WebkitAppearance: e3, appearance: e3 }), backfaceVisibility: (e3) => ({ WebkitBackfaceVisibility: e3, backfaceVisibility: e3 }), backdropFilter: (e3) => ({ WebkitBackdropFilter: e3, backdropFilter: e3 }), backgroundClip: (e3) => ({ WebkitBackgroundClip: e3, backgroundClip: e3 }), boxDecorationBreak: (e3) => ({ WebkitBoxDecorationBreak: e3, boxDecorationBreak: e3 }), clipPath: (e3) => ({ WebkitClipPath: e3, clipPath: e3 }), content: (e3) => ({ content: e3.includes('"') || e3.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e3) ? e3 : `"${e3}"` }), hyphens: (e3) => ({ WebkitHyphens: e3, hyphens: e3 }), maskImage: (e3) => ({ WebkitMaskImage: e3, maskImage: e3 }), maskSize: (e3) => ({ WebkitMaskSize: e3, maskSize: e3 }), textSizeAdjust: (e3) => ({ WebkitTextSizeAdjust: e3, textSizeAdjust: e3 }), userSelect: (e3) => ({ WebkitUserSelect: e3, userSelect: e3 }), marginBlock: u((e3, t3) => ({ marginBlockStart: e3, marginBlockEnd: t3 || e3 })), marginInline: u((e3, t3) => ({ marginInlineStart: e3, marginInlineEnd: t3 || e3 })), maxSize: u((e3, t3) => ({ maxBlockSize: e3, maxInlineSize: t3 || e3 })), minSize: u((e3, t3) => ({ minBlockSize: e3, minInlineSize: t3 || e3 })), paddingBlock: u((e3, t3) => ({ paddingBlockStart: e3, paddingBlockEnd: t3 || e3 })), paddingInline: u((e3, t3) => ({ paddingInlineStart: e3, paddingInlineEnd: t3 || e3 })) };
var f = /([\d.]+)([^]*)/;
var h = (e3, t3) => e3.length ? e3.reduce((e4, r2) => (e4.push(...t3.map((e5) => e5.includes("&") ? e5.replace(/&/g, /[ +>|~]/.test(r2) && /&.*&/.test(e5) ? `:is(${r2})` : r2) : r2 + " " + e5)), e4), []) : t3;
var m = (e3, t3) => e3 in b && typeof t3 == "string" ? t3.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t4, r2, n2, o2) => r2 + (n2 === "stretch" ? `-moz-available${o2};${d(e3)}:${r2}-webkit-fill-available` : `-moz-fit-content${o2};${d(e3)}:${r2}fit-content`) + o2) : String(t3);
var b = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 };
var S = (e3) => e3 ? e3 + "-" : "";
var y = (e3, t3, r2) => e3.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e4, n2, o2, i3, s4) => i3 == "$" == !!o2 ? e4 : (n2 || i3 == "--" ? "calc(" : "") + "var(--" + (i3 === "$" ? S(t3) + (s4.includes("$") ? "" : S(r2)) + s4.replace(/\$/g, "-") : s4) + ")" + (n2 || i3 == "--" ? "*" + (n2 || "") + (o2 || "1") + ")" : ""));
var k = /\s*,\s*(?![^()]*\))/;
var $ = Object.prototype.toString;
var x = (e3, t3, r2, n2, o2) => {
  let i3, s4, l2;
  const a4 = (e4, t4, r3) => {
    let c3, p2;
    const u3 = (e5) => {
      for (c3 in e5) {
        const j3 = c3.charCodeAt(0) === 64, R3 = j3 && Array.isArray(e5[c3]) ? e5[c3] : [e5[c3]];
        for (p2 of R3) {
          const e6 = /[A-Z]/.test(x3 = c3) ? x3 : x3.replace(/-[^]/g, (e7) => e7[1].toUpperCase()), R4 = typeof p2 == "object" && p2 && p2.toString === $ && (!n2.utils[e6] || !t4.length);
          if (e6 in n2.utils && !R4) {
            const t5 = n2.utils[e6];
            if (t5 !== s4) {
              s4 = t5, u3(t5(p2)), s4 = null;
              continue;
            }
          } else if (e6 in g) {
            const t5 = g[e6];
            if (t5 !== l2) {
              l2 = t5, u3(t5(p2)), l2 = null;
              continue;
            }
          }
          if (j3 && (b3 = c3.slice(1) in n2.media ? "@media " + n2.media[c3.slice(1)] : c3, c3 = b3.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e7, t5, r4, n3, o3, i4) => {
            const s5 = f.test(t5), l3 = 0.0625 * (s5 ? -1 : 1), [a5, c4] = s5 ? [n3, t5] : [t5, n3];
            return "(" + (r4[0] === "=" ? "" : r4[0] === ">" === s5 ? "max-" : "min-") + a5 + ":" + (r4[0] !== "=" && r4.length === 1 ? c4.replace(f, (e8, t6, n4) => Number(t6) + l3 * (r4 === ">" ? 1 : -1) + n4) : c4) + (o3 ? ") and (" + (o3[0] === ">" ? "min-" : "max-") + a5 + ":" + (o3.length === 1 ? i4.replace(f, (e8, t6, r5) => Number(t6) + l3 * (o3 === ">" ? -1 : 1) + r5) : i4) : "") + ")";
          })), R4) {
            const e7 = j3 ? r3.concat(c3) : [...r3], n3 = j3 ? [...t4] : h(t4, c3.split(k));
            i3 !== void 0 && o2(w(...i3)), i3 = void 0, a4(p2, n3, e7);
          } else
            i3 === void 0 && (i3 = [[], t4, r3]), c3 = j3 || c3.charCodeAt(0) !== 36 ? c3 : `--${S(n2.prefix)}${c3.slice(1).replace(/\$/g, "-")}`, p2 = R4 ? p2 : typeof p2 == "number" ? p2 && !(e6 in B) && c3.charCodeAt(0) !== 45 ? String(p2) + "px" : String(p2) : y(m(e6, p2 == null ? "" : p2), n2.prefix, n2.themeMap[e6]), i3[0].push(`${j3 ? `${c3} ` : `${d(c3)}:`}${p2}`);
        }
      }
      var b3, x3;
    };
    u3(e4), i3 !== void 0 && o2(w(...i3)), i3 = void 0;
  };
  a4(e3, t3, r2);
};
var w = (e3, t3, r2) => `${r2.map((e4) => `${e4}{`).join("")}${t3.length ? `${t3.join(",")}{` : ""}${e3.join(";")}${t3.length ? "}" : ""}${Array(r2.length ? r2.length + 1 : 0).join("}")}`;
var B = { animationIterationCount: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
var j = (e3) => String.fromCharCode(e3 + (e3 > 25 ? 39 : 97));
var R = (e3) => ((e4) => {
  let t3, r2 = "";
  for (t3 = Math.abs(e4); t3 > 52; t3 = t3 / 52 | 0)
    r2 = j(t3 % 52) + r2;
  return j(t3 % 52) + r2;
})(((e4, t3) => {
  let r2 = t3.length;
  for (; r2; )
    e4 = 33 * e4 ^ t3.charCodeAt(--r2);
  return e4;
})(5381, JSON.stringify(e3)) >>> 0);
var I = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"];
var C = (e3) => {
  if (e3.href && !e3.href.startsWith(location.origin))
    return false;
  try {
    return !!e3.cssRules;
  } catch (e4) {
    return false;
  }
};
var z = (e3) => {
  let t3;
  const r2 = () => {
    const { cssRules: e4 } = t3.sheet;
    return [].map.call(e4, (r3, n3) => {
      const { cssText: o2 } = r3;
      let i3 = "";
      if (o2.startsWith("--sxs"))
        return "";
      if (e4[n3 - 1] && (i3 = e4[n3 - 1].cssText).startsWith("--sxs")) {
        if (!r3.cssRules.length)
          return "";
        for (const e5 in t3.rules)
          if (t3.rules[e5].group === r3)
            return `--sxs{--sxs:${[...t3.rules[e5].cache].join(" ")}}${o2}`;
        return r3.cssRules.length ? `${i3}${o2}` : "";
      }
      return o2;
    }).join("");
  }, n2 = () => {
    if (t3) {
      const { rules: e4, sheet: r3 } = t3;
      if (!r3.deleteRule) {
        for (; Object(Object(r3.cssRules)[0]).type === 3; )
          r3.cssRules.splice(0, 1);
        r3.cssRules = [];
      }
      for (const t4 in e4)
        delete e4[t4];
    }
    const o2 = Object(e3).styleSheets || [];
    for (const e4 of o2)
      if (C(e4)) {
        for (let o3 = 0, i4 = e4.cssRules; i4[o3]; ++o3) {
          const s5 = Object(i4[o3]);
          if (s5.type !== 1)
            continue;
          const l2 = Object(i4[o3 + 1]);
          if (l2.type !== 4)
            continue;
          ++o3;
          const { cssText: a4 } = s5;
          if (!a4.startsWith("--sxs"))
            continue;
          const c3 = a4.slice(14, -3).trim().split(/\s+/), d4 = I[c3[0]];
          d4 && (t3 || (t3 = { sheet: e4, reset: n2, rules: {}, toString: r2 }), t3.rules[d4] = { group: l2, index: o3, cache: new Set(c3) });
        }
        if (t3)
          break;
      }
    if (!t3) {
      const o3 = (e4, t4) => ({ type: t4, cssRules: [], insertRule(e5, t5) {
        this.cssRules.splice(t5, 0, o3(e5, { import: 3, undefined: 1 }[(e5.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return e4 === "@media{}" ? `@media{${[].map.call(this.cssRules, (e5) => e5.cssText).join("")}}` : e4;
      } });
      t3 = { sheet: (() => {
        if (!e3)
          return o3("", "text/css");
        const t4 = document.createElement("style"), r3 = window.__webpack_nonce__ !== void 0 ? window.__webpack_nonce__ : window.nonce !== void 0 ? window.nonce : null;
        return r3 && t4.setAttribute("nonce", r3), (e3.head || e3).appendChild(t4).sheet;
      })(), rules: {}, reset: n2, toString: r2 };
    }
    const { sheet: i3, rules: s4 } = t3;
    for (let e4 = I.length - 1; e4 >= 0; --e4) {
      const t4 = I[e4];
      if (!s4[t4]) {
        const r3 = I[e4 + 1], n3 = s4[r3] ? s4[r3].index : i3.cssRules.length;
        i3.insertRule("@media{}", n3), i3.insertRule(`--sxs{--sxs:${e4}}`, n3), s4[t4] = { group: i3.cssRules[n3 + 1], index: n3, cache: new Set([e4]) };
      }
      v(s4[t4]);
    }
  };
  return n2(), t3;
};
var v = (e3) => {
  const t3 = e3.group;
  let r2 = t3.cssRules.length;
  e3.apply = (e4) => {
    try {
      t3.insertRule(e4, r2), ++r2;
    } catch (e5) {
    }
  };
};
var W = Symbol();
var E = i();
var O = (e3, t3) => E(e3, () => {
  const r2 = (r3, n3 = {}) => {
    let o2 = { type: null, composers: new Set() };
    for (const t4 of r3)
      if (t4 != null)
        if (t4[s]) {
          o2.type == null && (o2.type = t4[s].type);
          for (const e4 of t4[s].composers)
            o2.composers.add(e4);
        } else
          t4.constructor !== Object || t4.$$typeof ? o2.type == null && (o2.type = t4) : o2.composers.add(P(t4, e3, n3));
    return o2.type == null && (o2.type = "span"), o2.composers.size || o2.composers.add(["PJLV", {}, [], [], {}, []]), T(e3, o2, t3, n3);
  }, n2 = (...e4) => r2(e4);
  return n2.withConfig = (e4) => (...t4) => r2(t4, e4), n2;
});
var P = (_a2, o2, { componentId: i3, displayName: s4 }) => {
  var _b = _a2, { variants: e3, compoundVariants: t3, defaultVariants: r2 } = _b, n2 = __objRest(_b, ["variants", "compoundVariants", "defaultVariants"]);
  const l2 = i3 || R(n2), d4 = s4 ? "c-" + s4 : "c", p2 = `${S(o2.prefix)}${d4}-${l2}`, u3 = [], g2 = [], f2 = Object.create(null), h4 = [];
  for (const e4 in r2)
    f2[e4] = String(r2[e4]);
  if (typeof e3 == "object" && e3)
    for (const t4 in e3) {
      m4 = f2, b3 = t4, c.call(m4, b3) || (f2[t4] = "undefined");
      const r3 = e3[t4];
      for (const e4 in r3) {
        const n3 = { [t4]: String(e4) };
        String(e4) === "undefined" && h4.push(t4);
        const o3 = r3[e4], i4 = [n3, o3, !a(o3)];
        u3.push(i4);
      }
    }
  var m4, b3;
  if (typeof t3 == "object" && t3)
    for (const e4 of t3) {
      let _a3 = e4, { css: t4 } = _a3, r3 = __objRest(_a3, ["css"]);
      t4 = typeof t4 == "object" && t4 || {};
      for (const e5 in r3)
        r3[e5] = String(r3[e5]);
      const n3 = [r3, t4, !a(t4)];
      g2.push(n3);
    }
  return [p2, n2, u3, g2, f2, h4];
};
var T = (e3, t3, r2, { shouldForwardStitchesProp: n2 }) => {
  const [o2, i3, a4, c3] = M(t3.composers), d4 = typeof t3.type == "function" || t3.type.$$typeof ? ((e4) => {
    function t4() {
      for (let r3 = 0; r3 < t4[W].length; r3++) {
        const [n3, o3] = t4[W][r3];
        e4.rules[n3].apply(o3);
      }
      return t4[W] = [], null;
    }
    return t4[W] = [], t4.rules = {}, I.forEach((e5) => t4.rules[e5] = { apply: (r3) => t4[W].push([e5, r3]) }), t4;
  })(r2) : null, p2 = (d4 || r2).rules, u3 = `.${o2}${i3.length > 1 ? `:where(.${i3.slice(1).join(".")})` : ""}`, g2 = (s4) => {
    s4 = typeof s4 == "object" && s4 || A;
    const l2 = __objRest(s4, []), g3 = {};
    for (const e4 in a4)
      if (e4 in s4) {
        (n2 == null ? void 0 : n2(e4)) || delete l2[e4];
        let t4 = s4[e4];
        typeof t4 == "object" && t4 ? g3[e4] = __spreadValues({ "@initial": a4[e4] }, t4) : (t4 = String(t4), g3[e4] = t4 !== "undefined" || c3.has(e4) ? t4 : a4[e4]);
      } else
        g3[e4] = a4[e4];
    const f2 = new Set([...i3]);
    for (const [n3, o3, i4, s5] of t3.composers) {
      r2.rules.styled.cache.has(n3) || (r2.rules.styled.cache.add(n3), x(o3, [`.${n3}`], [], e3, (e4) => {
        p2.styled.apply(e4);
      }));
      const t4 = N(i4, g3, e3.media), l3 = N(s5, g3, e3.media, true);
      for (const o4 of t4)
        if (o4 !== void 0)
          for (const [t5, i5, s6] of o4) {
            const o5 = `${n3}-${R(i5)}-${t5}`;
            f2.add(o5);
            const l4 = (s6 ? r2.rules.resonevar : r2.rules.onevar).cache, a5 = s6 ? p2.resonevar : p2.onevar;
            l4.has(o5) || (l4.add(o5), x(i5, [`.${o5}`], [], e3, (e4) => {
              a5.apply(e4);
            }));
          }
      for (const t5 of l3)
        if (t5 !== void 0)
          for (const [o4, i5] of t5) {
            const t6 = `${n3}-${R(i5)}-${o4}`;
            f2.add(t6), r2.rules.allvar.cache.has(t6) || (r2.rules.allvar.cache.add(t6), x(i5, [`.${t6}`], [], e3, (e4) => {
              p2.allvar.apply(e4);
            }));
          }
    }
    const h4 = l2.css;
    if (typeof h4 == "object" && h4) {
      (n2 == null ? void 0 : n2("css")) || delete l2.css;
      const t4 = `${o2}-i${R(h4)}-css`;
      f2.add(t4), r2.rules.inline.cache.has(t4) || (r2.rules.inline.cache.add(t4), x(h4, [`.${t4}`], [], e3, (e4) => {
        p2.inline.apply(e4);
      }));
    }
    for (const e4 of String(s4.className || "").trim().split(/\s+/))
      e4 && f2.add(e4);
    const m4 = l2.className = [...f2].join(" ");
    return { type: t3.type, className: m4, selector: u3, props: l2, toString: () => m4, deferredInjector: d4 };
  };
  return l(g2, { className: o2, selector: u3, [s]: t3, toString: () => (r2.rules.styled.cache.has(o2) || g2(), o2) });
};
var M = (e3) => {
  let t3 = "";
  const r2 = [], n2 = {}, o2 = [];
  for (const [i3, , , , s4, l2] of e3) {
    t3 === "" && (t3 = i3), r2.push(i3), o2.push(...l2);
    for (const e4 in s4) {
      const t4 = s4[e4];
      (n2[e4] === void 0 || t4 !== "undefined" || l2.includes(t4)) && (n2[e4] = t4);
    }
  }
  return [t3, r2, n2, new Set(o2)];
};
var N = (e3, t3, r2, n2) => {
  const o2 = [];
  e:
    for (let [i3, s4, l2] of e3) {
      if (l2)
        continue;
      let e4, a4 = 0, c3 = false;
      for (e4 in i3) {
        const n3 = i3[e4];
        let o3 = t3[e4];
        if (o3 !== n3) {
          if (typeof o3 != "object" || !o3)
            continue e;
          {
            let e5, t4, i4 = 0;
            for (const s5 in o3) {
              if (n3 === String(o3[s5])) {
                if (s5 !== "@initial") {
                  const e6 = s5.slice(1);
                  (t4 = t4 || []).push(e6 in r2 ? r2[e6] : s5.replace(/^@media ?/, "")), c3 = true;
                }
                a4 += i4, e5 = true;
              }
              ++i4;
            }
            if (t4 && t4.length && (s4 = { ["@media " + t4.join(", ")]: s4 }), !e5)
              continue e;
          }
        }
      }
      (o2[a4] = o2[a4] || []).push([n2 ? "cv" : `${e4}-${i3[e4]}`, s4, c3]);
    }
  return o2;
};
var A = {};
var L = i();
var G = (e3, t3) => L(e3, () => (...r2) => {
  const n2 = () => {
    for (let n3 of r2) {
      n3 = typeof n3 == "object" && n3 || {};
      let r3 = R(n3);
      if (!t3.rules.global.cache.has(r3)) {
        if (t3.rules.global.cache.add(r3), "@import" in n3) {
          let e4 = [].indexOf.call(t3.sheet.cssRules, t3.rules.themed.group) - 1;
          for (let r4 of [].concat(n3["@import"]))
            r4 = r4.includes('"') || r4.includes("'") ? r4 : `"${r4}"`, t3.sheet.insertRule(`@import ${r4};`, e4++);
          delete n3["@import"];
        }
        x(n3, [], [], e3, (e4) => {
          t3.rules.global.apply(e4);
        });
      }
    }
    return "";
  };
  return l(n2, { toString: n2 });
});
var F = i();
var _ = (e3, t3) => F(e3, () => (r2) => {
  const n2 = `${S(e3.prefix)}k-${R(r2)}`, o2 = () => {
    if (!t3.rules.global.cache.has(n2)) {
      t3.rules.global.cache.add(n2);
      const o3 = [];
      x(r2, [], [], e3, (e4) => o3.push(e4));
      const i3 = `@keyframes ${n2}{${o3.join("")}}`;
      t3.rules.global.apply(i3);
    }
    return n2;
  };
  return l(o2, { get name() {
    return o2();
  }, toString: o2 });
});
var H = class {
  constructor(e3, t3, r2, n2) {
    this.token = e3 == null ? "" : String(e3), this.value = t3 == null ? "" : String(t3), this.scale = r2 == null ? "" : String(r2), this.prefix = n2 == null ? "" : String(n2);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + S(this.prefix) + S(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
};
var V = i();
var D = (e3, t3) => V(e3, () => (r2, n2) => {
  n2 = typeof r2 == "object" && r2 || Object(n2);
  const o2 = `.${r2 = (r2 = typeof r2 == "string" ? r2 : "") || `${S(e3.prefix)}t-${R(n2)}`}`, i3 = {}, s4 = [];
  for (const t4 in n2) {
    i3[t4] = {};
    for (const r3 in n2[t4]) {
      const o3 = `--${S(e3.prefix)}${t4}-${r3}`, l3 = y(String(n2[t4][r3]), e3.prefix, t4);
      i3[t4][r3] = new H(r3, l3, t4, e3.prefix), s4.push(`${o3}:${l3}`);
    }
  }
  const l2 = () => {
    if (s4.length && !t3.rules.themed.cache.has(r2)) {
      t3.rules.themed.cache.add(r2);
      const o3 = `${n2 === e3.theme ? ":root," : ""}.${r2}{${s4.join(";")}}`;
      t3.rules.themed.apply(o3);
    }
    return r2;
  };
  return __spreadProps(__spreadValues({}, i3), { get className() {
    return l2();
  }, selector: o2, toString: l2 });
});
var J = i();
var U;
var X = i();
var Y = (e3) => {
  const t3 = ((e4) => {
    let t4 = false;
    const r2 = J(e4, (e5) => {
      t4 = true;
      const r3 = "prefix" in (e5 = typeof e5 == "object" && e5 || {}) ? String(e5.prefix) : "", o2 = typeof e5.media == "object" && e5.media || {}, i3 = typeof e5.root == "object" ? e5.root || null : globalThis.document || null, s4 = typeof e5.theme == "object" && e5.theme || {}, l2 = { prefix: r3, media: o2, theme: s4, themeMap: typeof e5.themeMap == "object" && e5.themeMap || __spreadValues({}, n), utils: typeof e5.utils == "object" && e5.utils || {} }, a4 = z(i3), c3 = { css: O(l2, a4), globalCss: G(l2, a4), keyframes: _(l2, a4), createTheme: D(l2, a4), reset() {
        a4.reset(), c3.theme.toString();
      }, theme: {}, sheet: a4, config: l2, prefix: r3, getCssText: a4.toString, toString: a4.toString };
      return String(c3.theme = c3.createTheme(s4)), c3;
    });
    return t4 || r2.reset(), r2;
  })(e3);
  return t3.styled = (({ config: e4, sheet: t4 }) => X(e4, () => {
    const r2 = O(e4, t4), n2 = (e5, t5 = r2, { displayName: n3, shouldForwardStitchesProp: o3 } = {}) => {
      const i3 = t5(...e5), l2 = i3[s].type, a4 = o3 == null ? void 0 : o3("as"), c3 = Z.forwardRef((e6, t6) => {
        const r3 = (e6 == null ? void 0 : e6.as) && !a4 ? e6 == null ? void 0 : e6.as : l2, { props: n4, deferredInjector: o4 } = i3(e6);
        return a4 || delete n4.as, n4.ref = t6, o4 ? Z.createElement(Z.Fragment, null, Z.createElement(r3, n4), Z.createElement(o4, null)) : Z.createElement(r3, n4);
      });
      return c3.className = i3.className, c3.displayName = n3 || `Styled.${l2.displayName || l2.name || l2}`, c3.selector = i3.selector, c3.toString = () => i3.selector, c3[s] = i3[s], c3;
    }, o2 = (...e5) => n2(e5);
    return o2.withConfig = (e5) => (...t5) => {
      const o3 = r2.withConfig(e5);
      return n2(t5, o3, e5);
    }, o2;
  }))(t3), t3;
};
var q = () => U || (U = Y());
var re = (...e3) => q().styled(...e3);

// ../theme/colors/orange.ts
var orange = {
  orangeLight0: "#FF901A",
  orange100: "#FFF1D1",
  orange200: "#FFDFA3",
  orange300: "#FFC975",
  orange400: "#FFB453",
  orange500: "#FF901A",
  orange600: "#DB7013",
  orange700: "#B7540D",
  orange800: "#933B08",
  orange900: "#7A2A04",
  orangeDefault: "#FF8400"
};

// ../theme/colors/green.ts
var green = {
  green100: "#F3FCDC",
  green200: "#E5F9BB",
  green300: "#CCEC94",
  green400: "#B0DB75",
  green500: "#8BC34A",
  green600: "#6DA736",
  green700: "#538C25",
  green800: "#3B7117",
  green900: "#2A5D0E"
};

// ../theme/colors/blue.ts
var blue = {
  blue100: "#CFE6FE",
  blue200: "#A0CAFE",
  blue300: "#89AFF8",
  blue400: "#4C8FFB",
  blue500: "#1262FA",
  blue600: "#0D4BD7",
  blue700: "#0937B3",
  blue800: "#052790",
  blue900: "#031B77",
  surfaceBlue: "#027BB5",
  lightBlue: "#89B1FD"
};

// ../theme/colors/yellow.ts
var yellow = {
  yellow100: "#FFFACC",
  yellow200: "#FFF499",
  yellow300: "#FFEC66",
  yellow400: "#FFE43F",
  yellow500: "#FFD800",
  yellow600: "#DBB600",
  yellow700: "#B79500",
  yellow800: "#937600"
};

// ../theme/colors/red.ts
var red = {
  red100: "#FCD8CB",
  red200: "#FAAA99",
  red300: "#F27165",
  red400: "#E53F40",
  red500: "#D5071C",
  red600: "#B70527",
  red700: "#99032E",
  red800: "#7B022F",
  red900: "#660130",
  surfaceRed: "#CD0E0E"
};

// ../theme/colors/gray.ts
var gray = {
  gray0: "#ffffff",
  gray1: "#fafafa",
  gray2: "#f5f5f5",
  gray3: "#f0f0f0",
  gray4: "#d9d9d9",
  gray5: "#bfbfbf",
  gray6: "#8c8c8c",
  gray7: "#595959",
  gray8: "#434343",
  gray9: "#262626",
  gray10: "#1f1f1f",
  gray11: "#141414",
  gray12: "#000000",
  gray100: "#FAFAFB",
  gray200: "#EDEDED",
  gray300: "#C9C9C9",
  gray400: "#949494",
  gray500: "#4E4E4E",
  gray600: "#433939",
  gray700: "#38272A",
  gray800: "#262626",
  gray900: "#0E0E10",
  primaryGray: "#999999"
};

// ../theme/stitches.config.ts
var { styled, css, theme, createTheme, getCssText, globalCss, keyframes, config: config2, reset } = Y({
  theme: {
    colors: __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, gray), red), blue), green), yellow), orange), {
      hiContrast: "$gray800",
      loContrast: "white",
      diffContrastColor: "#FFFFFF",
      diffContrastBgColor: "#000000",
      accentPrimaryBgColor: "$orange500",
      accentContrastColor: "$gray12",
      highlightPrimaryBgColor: "rgba(255, 244, 232, 1)",
      accentSecondaryBgColor: "#FFE9D1",
      standingsLinkColor: "$gray6",
      ageRestrictTextColor: "#000000",
      statsContainerBackgroundColor: "$gray1",
      socialIconBgColor: "$gray2",
      socialIconColor: "$gray8",
      tournamentHeaderBgColor: "$gray2",
      matchRowBgColor: "$gray1",
      mainEventParticipantNameColor: "$gray12",
      secondaryMainEventParticipantNameColor: "$gray6",
      progressBarPrimaryBgColor: "#FFFFFF",
      dividerBorderColor: "$primaryGray",
      tabBorderColor: "rgba(217, 217, 217, 1)",
      oddsContainerPrimaryBgColor: "#FFFFFF",
      oddItemPrimaryBgColor: "$gray2",
      oddItemLabelColor: "$gray600",
      oddItemCoefficientColor: "$gray900",
      oddItemHoverColor: "$gray4",
      oddsSelectionBorderColor: "$gray7",
      oddsSelectionBackgroundColor: "$gray2",
      fansUnitedContainerPrimaryBgColor: "#FFFFFF",
      fansUnitedContentPrimaryBgColor: "#E6E6E6",
      fansUnitedPillHoverColor: "#F7F7F7",
      countryLogoBorderColor: "$gray3",
      sportEntityContainerPrimaryBgColor: "#FFFFFF",
      standingsTooltipContainerPrimaryBgColor: "$gray10",
      standingsTooltipContainerTextColor: "$gray0",
      standingsTooltipContainerDateTextColor: "$gray6",
      borderColor: "$primaryGray",
      filtersContainerPrimaryBackgroundColor: "#FFFFFF",
      liveMatchStatusColor: "$green500",
      fullTimeMatchStatusColor: "$primaryGray",
      pillBackgroundColor: "$gray1",
      pillActiveBackgroundColor: "$orange500",
      pillTextColor: "$gray9",
      pillActiveTextColor: "#FFFFFF",
      pillBorderColor: "$gray3",
      primaryBackgroundColor: "$gray2",
      rowBackgroundColor: "#FFFFFF",
      tabRowBackgroundColor: "$gray2",
      tableRightIndicatorColor: "rgba(0, 0, 0, 0.5)",
      highLighted: "#FFFCEA",
      surfaceBackgroundColor: "$gray1",
      sportEntityOneColor: "$surfaceBlue",
      sportEntityTwoColor: "$surfaceRed",
      sportEntityLesserStatBgColor: "$surfaceBackgroundColor",
      tooltipBackgroundColor: "$gray900",
      tooltipColor: "$loContrast",
      participantServerImageColor: "$gray500",
      rowBorderColor: "$primaryBackgroundColor",
      dropdownBorderColor: "$gray3",
      winBackgroundColor: "#B0DB75",
      loseBackgroundColor: "#F27165",
      drawBackgroundColor: "#C9C9C9",
      footballFieldTone: "$gray4",
      footballFieldLineColor: "$gray12",
      whiteTeamColorAlternative: "#F8F8F8",
      progressOneBgColor: "#FF8502",
      progressTwoBgColor: "$gray6",
      progressContainerBgColor: "$gray3",
      subHeaderBgColor: "$gray3",
      progressTextColor: "$gray6",
      progressHighlightedColor: "#000000",
      statusBadgeBgColor: "$gray4",
      statusBadgeTextColor: "$gray12",
      headerBoxShadowColor: "rgba(0, 0, 0, 0.05)",
      playerStatisticsColor: "$gray6",
      playerTeamColor: "$gray6",
      borderMultiSportColor: "$gray4",
      multiSportCommonColor: "$gray6",
      teamLostColor: "$gray6",
      gamePartColor: "#4CAF50",
      multiSportWinner: "#D80027",
      multiSportTextColor: "#121212",
      multisportHighlightColor: "$orange500",
      multiSportBgColor: "#FFFFFF",
      multiSportHoverColor: "$gray1",
      multiSportDropdownButtonBgColor: "$orange500",
      dropdownActiveDateBgColor: "$orange500",
      groupCountColor: "#618934",
      dropdownBtnColor: "#FFFFFF",
      dropdownActiveBgColor: "#FFF4E8",
      selectOptionBgColor: "#FFFFFF",
      selectOptionBorderColor: "$gray3",
      selectButtonSecondaryColor: "#9A9A9A",
      dropdownArrowIconColor: "#9A9A9A",
      dropdownCalendarIconColor: "#d9d9d9",
      liveIndicatorColor: "#4CAF50",
      postponedMatchColor: "#D92033",
      stakesBgColor: "$gray0",
      teamStakesBorderColor: "$gray4",
      stakesSelectionBgColor: "$gray2",
      stakesSelectedBgColor: "$gray12",
      selectedStakeColor: "$gray0",
      stakeInputBorderColor: "$orangeLight0",
      roundColor: "$gray6",
      tournamentBgColor: "$gray2",
      relegationColor: "#d01a1a",
      relegationPlayoff: "#ff6666",
      promotion: "#1262fa",
      promotionPlayoff: "#89aff8",
      championshipPlayoff: "#89aff8",
      tierTwo: "#2c782c",
      tierTwoPlayoff: "#52cc52",
      topPlayoff: "#89aff8",
      top: "#1262fa",
      knockoutBgColor: "$gray0",
      knockoutHeaderBgColor: "$gray1",
      knockoutHeaderBorderColor: "$gray3",
      knockoutGameBgColor: "$gray1",
      knockoutGameBorderColor: "$gray3",
      knockoutAggEventsBgColor: "$gray0",
      knockoutAggEventsBorderColor: "$gray3",
      lineupsHeaderContainerBgColor: "$gray4",
      collapsibleBgColor: "$gray3",
      lineupsRowEvenBgColor: "$gray0",
      lineupsRowOddBgColor: "$gray1",
      lineupsSecondaryTextColor: "$gray6",
      mobileTabsSelectedBgColor: "$gray4",
      lineupsPrimaryBackgroundColor: "$gray0",
      tabTextColor: "$gray12",
      tabActiveTextColor: "$gray12",
      tabBackgroundColor: "$gray3",
      tabActiveBackgroundColor: "$orangeDefault",
      tabMenuBorderColor: "$gray4",
      matchCenterPrimaryBackgroundColor: "$gray0",
      secondaryHeaderTextColor: "$gray6",
      timelineTabBackgroundColor: "$gray1",
      timelineBackgroundColor: "white",
      timelineLineColor: "$gray4",
      playerPrimaryBackgroundColor: "$gray0",
      playerSecondaryTextColor: "$gray6",
      playerBioBackgroundColor: "$gray2",
      playerBioTextColor: "$gray12",
      playerProfileBorderColor: "$gray3",
      upcomingMatch: "$gray5",
      winOutcomeBG: "$green500",
      drawOutcomeBG: "#FFB15F",
      lossOutcomeBG: "#E25160",
      overtimeBG: "#FFFF00",
      teamPrimaryBackgroundColor: "$gray0",
      teamSecondaryTextColor: "$gray6",
      emptyTeamImage: "$gray1",
      tableHeaderBG: "$gray1",
      tableBorderColor: "$gray3",
      tableRankHighlightColor: "$lightBlue"
    }),
    fonts: {
      untitled: "Untitled Sans, -apple-system, system-ui, sans-serif",
      sans: "Open Sans, sans-serif",
      primaryFontFamily: "$sans"
    },
    space: {
      0: "2px",
      1: "4px",
      2: "8px",
      "2_5": "12px",
      3: "16px",
      4: "20px",
      5: "24px",
      6: "32px",
      "6_5": "40px",
      7: "48px",
      8: "64px",
      9: "80px"
    },
    sizes: {
      1: "4px",
      2: "8px",
      "2_5": "12px",
      3: "16px",
      4: "20px",
      5: "24px",
      "5_5": "32px",
      6: "34px",
      "6_5": "42px",
      7: "48px",
      "7_5": "56px",
      8: "64px",
      9: "80px",
      10: "11px"
    },
    fontSizes: {
      1: "9px",
      2: "11px",
      "2_5": "12px",
      3: "14px",
      4: "16px",
      5: "20px",
      6: "24px",
      7: "28px",
      8: "32px",
      9: "36px"
    },
    radii: {
      0: "2px",
      1: "4px",
      2: "6px",
      3: "8px",
      4: "12px",
      "4_5": "16px",
      5: "24px",
      round: "50%",
      pill: "9999px"
    },
    zIndices: {
      1: "100",
      2: "200",
      3: "300",
      4: "400",
      max: "999"
    },
    invertColor: {
      filter: "invert(0)"
    }
  },
  media: {
    bp0: "(min-width: 300px)",
    bp1: "(min-width: 420px)",
    bp2: "(min-width: 768px)",
    bp3: "(min-width: 1024px)",
    bp4: "(min-width: 1200px)",
    bp5: "(min-width: 1800px)",
    motion: "(prefers-reduced-motion)",
    hover: "(any-hover: hover)",
    dark: "(prefers-color-scheme: dark)",
    light: "(prefers-color-scheme: light)"
  },
  utils: {
    p: (value) => ({
      padding: value
    }),
    pt: (value) => ({
      paddingTop: value
    }),
    pr: (value) => ({
      paddingRight: value
    }),
    pb: (value) => ({
      paddingBottom: value
    }),
    pl: (value) => ({
      paddingLeft: value
    }),
    px: (value) => ({
      paddingLeft: value,
      paddingRight: value
    }),
    py: (value) => ({
      paddingTop: value,
      paddingBottom: value
    }),
    m: (value) => ({
      margin: value
    }),
    mt: (value) => ({
      marginTop: value
    }),
    mr: (value) => ({
      marginRight: value
    }),
    mb: (value) => ({
      marginBottom: value
    }),
    ml: (value) => ({
      marginLeft: value
    }),
    mx: (value) => ({
      marginLeft: value,
      marginRight: value
    }),
    my: (value) => ({
      marginTop: value,
      marginBottom: value
    }),
    ta: (value) => ({ textAlign: value }),
    fd: (value) => ({ flexDirection: value }),
    fw: (value) => ({ flexWrap: value }),
    ai: (value) => ({ alignItems: value }),
    ac: (value) => ({ alignContent: value }),
    jc: (value) => ({ justifyContent: value }),
    as: (value) => ({ alignSelf: value }),
    fg: (value) => ({ flexGrow: value }),
    fs: (value) => ({ flexShrink: value }),
    fb: (value) => ({ flexBasis: value }),
    bc: (value) => ({
      backgroundColor: value
    }),
    br: (value) => ({
      borderRadius: value
    }),
    btrr: (value) => ({
      borderTopRightRadius: value
    }),
    bbrr: (value) => ({
      borderBottomRightRadius: value
    }),
    bblr: (value) => ({
      borderBottomLeftRadius: value
    }),
    btlr: (value) => ({
      borderTopLeftRadius: value
    }),
    bs: (value) => ({ boxShadow: value }),
    lh: (value) => ({ lineHeight: value }),
    ox: (value) => ({ overflowX: value }),
    oy: (value) => ({ overflowY: value }),
    pe: (value) => ({ pointerEvents: value }),
    us: (value) => ({
      WebkitUserSelect: value,
      userSelect: value
    }),
    userSelect: (value) => ({
      WebkitUserSelect: value,
      userSelect: value
    }),
    size: (value) => ({
      width: value,
      height: value
    }),
    appearance: (value) => ({
      WebkitAppearance: value,
      appearance: value
    }),
    backgroundClip: (value) => ({
      WebkitBackgroundClip: value,
      backgroundClip: value
    })
  }
});
var darkThemeStyles = {
  colors: {
    hiContrast: "white",
    loContrast: "$gray800",
    progressBarPrimaryBgColor: "$gray500",
    highLighted: "#4C5465",
    diffContrastColor: "#000000",
    diffContrastBgColor: "#FFFFFF",
    oddsContainerPrimaryBgColor: "#1F1F1F",
    oddItemPrimaryBgColor: "hsla(0, 0%, 100%, 0.15)",
    oddItemLabelColor: "$gray400",
    oddItemCoefficientColor: "$gray100",
    ageRestrictTextColor: "#FFFFFF",
    statsContainerBackgroundColor: "$gray9",
    socialIconBgColor: "$gray8",
    socialIconColor: "$gray4",
    tournamentHeaderBgColor: "$gray11",
    matchRowBgColor: "$gray9",
    mainEventParticipantNameColor: "$gray0",
    secondaryMainEventParticipantNameColor: "$gray6",
    countryLogoBorderColor: "$gray9",
    dividerBorderColor: "$gray8",
    sportEntityContainerPrimaryBgColor: "#1F1F1F",
    standingsTooltipContainerPrimaryBgColor: "$gray8",
    standingsTooltipContainerTextColor: "$gray0",
    standingsTooltipContainerDateTextColor: "$gray5",
    oddItemHoverColor: "$gray7",
    oddsSelectionBackgroundColor: "$gray8",
    fansUnitedContainerPrimaryBgColor: "#0E0E10",
    fansUnitedContentPrimaryBgColor: "$gray9",
    fansUnitedPillHoverColor: "#666666",
    tabRowBackgroundColor: "$gray800",
    primaryBackgroundColor: "#000000",
    borderColor: "#FFFFFF",
    filtersContainerPrimaryBackgroundColor: "#000000",
    liveMatchStatusColor: "$green500",
    fullTimeMatchStatusColor: "$primaryGray",
    pillBackgroundColor: "$gray9",
    pillTextColor: "#FFFFFF",
    pillBorderColor: "$gray7",
    footballFieldLineColor: "$gray1",
    rowBackgroundColor: "$gray10",
    tableRightIndicatorColor: "rgba(255, 255, 255, 0.5)",
    surfaceBackgroundColor: "$gray11",
    sportEntityOneColor: "$surfaceBlue",
    sportEntityTwoColor: "$surfaceRed",
    sportEntityLesserStatBgColor: "$surfaceBackgroundColor",
    tooltipBackgroundColor: "$gray100",
    tooltipColor: "$loContrast",
    rowBorderColor: "$primaryBackgroundColor",
    progressTwoBgColor: "$gray6",
    subHeaderBgColor: "$gray11",
    progressHighlightedColor: "$gray100",
    progressContainerBgColor: "$gray8",
    statusBadgeBgColor: "$gray8",
    statusBadgeTextColor: "$gray0",
    headerBoxShadowColor: "rgba(0, 0, 0, 0.25)",
    multiSportTextColor: "#FFFFFF",
    multiSportBgColor: "$gray11",
    multiSportHoverColor: "$gray10",
    borderMultiSportColor: "$gray8",
    dropdownBtnColor: "$gray9",
    dropdownActiveBgColor: "$gray8",
    dropdownBorderColor: "$gray7",
    selectOptionBgColor: "$gray9",
    selectOptionBorderColor: "#000000",
    dropdownArrowIconColor: "#F0F0F0",
    dropdownCalendarIconColor: "#d9d9d9",
    stakesBgColor: "#191919",
    teamStakesBorderColor: "$gray8",
    stakesSelectionBgColor: "$gray9",
    stakesSelectedBgColor: "$gray0",
    selectedStakeColor: "$gray12",
    tournamentBgColor: "$gray11",
    knockoutBgColor: "$gray10",
    knockoutHeaderBgColor: "$gray11",
    knockoutHeaderBorderColor: "$gray9",
    knockoutGameBgColor: "$gray9",
    knockoutGameBorderColor: "$gray8",
    knockoutAggEventsBgColor: "$gray7",
    knockoutAggEventsBorderColor: "$gray8",
    lineupsHeaderContainerBgColor: "$gray11",
    collapsibleBgColor: "$gray11",
    lineupsRowEvenBgColor: "$gray10",
    lineupsRowOddBgColor: "$gray11",
    lineupsSecondaryTextColor: "$gray6",
    mobileTabsSelectedBgColor: "$gray12",
    lineupsPrimaryBackgroundColor: "$gray10",
    tabTextColor: "$gray5",
    tabActiveTextColor: "$gray12",
    tabBackgroundColor: "$gray11",
    tabActiveBackgroundColor: "$orangeDefault",
    tabMenuBorderColor: "$gray10",
    matchCenterPrimaryBackgroundColor: "$gray10",
    secondaryHeaderTextColor: "$gray6",
    timelineTabBackgroundColor: "$gray11",
    timelineBackgroundColor: "$gray10",
    timelineLineColor: "$gray8",
    playerPrimaryBackgroundColor: "$gray10",
    playerSecondaryTextColor: "$gray6",
    playerBioBackgroundColor: "$gray8",
    playerBioTextColor: "$gray0",
    playerProfileBorderColor: "$gray8",
    upcomingMatch: "$gray5",
    winOutcomeBG: "$green500",
    drawOutcomeBG: "#FFB15F",
    lossOutcomeBG: "#E25160",
    overtimeBG: "#FFFF00",
    teamPrimaryBackgroundColor: "$gray10",
    teamSecondaryTextColor: "$gray6",
    emptyTeamImage: "$gray9",
    tableHeaderBG: "$gray11",
    tableBorderColor: "$gray12",
    tableRankHighlightColor: "$lightBlue"
  },
  invertColor: {
    filter: "invert(1)"
  }
};

// src/atoms/SMPImage.tsx
var livescoreEntityLogo = {
  width: "$5_5",
  height: "$5_5"
};
var tournamentLogo = {
  width: "32px",
  height: "32px"
};
var mobileTeamIcon = {
  width: "24px",
  height: "24px"
};
var SMPImage = styled("img", {
  verticalAlign: "middle",
  maxWidth: "100%",
  boxSizing: "border-box",
  variants: {
    size: {
      small: {
        size: "$2"
      },
      medium: {
        size: "$4"
      },
      large: {
        size: "$6"
      },
      extraLarge: {
        size: "$8"
      }
    },
    variant: {
      oddProviderLogo: {
        height: "26px",
        "@bp0": {
          maxWidth: "80px"
        },
        "@bp1": {
          maxWidth: "100px"
        }
      },
      sportEntityLogo: {
        size: "$6"
      },
      livescoreEntityLogo,
      tournamentLogo,
      mobileTeamIcon,
      mediumLivescoreEntityLogo: {
        width: "$5",
        height: "$5"
      },
      largeLivescoreEntityLogo: {
        width: "32px",
        height: "32px"
      },
      borderedLivescoreEntityLogo: __spreadProps(__spreadValues({}, livescoreEntityLogo), {
        border: "1px solid $borderColor"
      }),
      tennisParticipantLogo: __spreadProps(__spreadValues({}, livescoreEntityLogo), {
        filter: "$invertColor-filter"
      }),
      tennisParticipantPlayoffLogo: {
        width: "$5",
        height: "$5",
        filter: "$invertColor-filter"
      },
      tennisParticipantServer: __spreadProps(__spreadValues({}, livescoreEntityLogo), {
        size: "$10",
        mr: "$1",
        backgroundColor: "$participantServerImageColor",
        ml: "auto",
        br: "$round"
      }),
      stakesTeamLogo: {
        size: "$6_5"
      }
    }
  }
});

// src/atoms/SMPLinkWrapper.tsx
var SMPLinkWrapper = styled.withConfig({ componentId: "CommonWidget", displayName: "LinkWrapper" })("a", {
  display: "contents",
  textDecoration: "none",
  outline: "none",
  "&:hover, &:active, &:focus": {
    textDecoration: "none"
  }
});

// src/atoms/SMPSportEntity.tsx
var SMPSportEntity = styled.withConfig({ componentId: "CommonWidget", displayName: "SportEntity" })("a", {
  boxSizing: "border-box",
  display: "flex",
  fontFamily: "$primaryFontFamily",
  fontSize: "$3",
  alignItems: "center",
  flex: "1 1 0",
  gap: "$2",
  textDecoration: "none",
  outline: "none",
  variants: {
    direction: {
      row: {
        fd: "row"
      },
      column: {
        fd: "column"
      },
      rowReverse: {
        fd: "row-reverse"
      },
      columnReverse: {
        fd: "column-reverse"
      }
    },
    variant: {
      horizontal: {
        fd: "row",
        textAlign: "left",
        py: "$1"
      },
      horizontalReverse: {
        fd: "row-reverse",
        textAlign: "right"
      },
      vertical: {
        fd: "column",
        textAlign: "center"
      },
      tennisTeamDouble: {
        flex: "initial",
        fd: "row",
        textAlign: "left",
        py: "$1"
      }
    }
  }
});

// src/atoms/SMPFlex.tsx
var SMPFlex = styled.withConfig({ componentId: "CommonWidget", displayName: "SMPFlex" })("div", {
  boxSizing: "border-box",
  display: "flex",
  "&.filtersRow": {
    fd: "row",
    position: "relative",
    py: "$2_5",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  "&.filtersColumn": {
    fd: "column",
    pt: "$2_5",
    paddingLeft: "$3",
    position: "relative"
  },
  variants: {
    grid: {
      true: {
        display: "grid !important",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        [`& > ${SMPLinkWrapper} > :first-child`]: {
          justifyContent: "start"
        }
      }
    },
    align: {
      start: {
        alignItems: "flex-start"
      },
      center: {
        alignItems: "center !important"
      },
      end: {
        alignItems: "flex-end"
      },
      stretch: {
        alignItems: "stretch"
      }
    },
    justify: {
      start: {
        justifyContent: "flex-start !important"
      },
      center: {
        justifyContent: "center"
      },
      end: {
        justifyContent: "flex-end"
      },
      stretch: {
        justifyContent: "stretch"
      },
      spaceBetween: {
        justifyContent: "space-between !important"
      },
      spaceAround: {
        justifyContent: "space-around"
      },
      spaceEvenly: {
        justifyContent: "space-evenly"
      }
    },
    wrap: {
      wrap: {
        flexWrap: "wrap"
      },
      noWrap: {
        flexWrap: "nowrap"
      },
      wrapReverse: {
        flexWrap: "wrap-reverse"
      }
    },
    direction: {
      row: {
        flexDirection: "row"
      },
      column: {
        flexDirection: "column !important"
      },
      rowReverse: {
        flexDirection: "row-reverse"
      },
      columnReverse: {
        flexDirection: "column-reverse"
      }
    },
    basis: {
      auto: { flexBasis: "auto" }
    },
    grow: {
      0: { flexGrow: 0 },
      10: { flexGrow: 0.2 },
      1: { flexGrow: 1 },
      2: { flexGrow: 2 },
      3: { flexGrow: 3 },
      4: { flexGrow: 4 },
      5: { flexGrow: 5 }
    },
    shrink: {
      1: { flexShrink: 1 },
      2: { flexShrink: 2 },
      3: { flexShrink: 3 },
      4: { flexShrink: 4 },
      5: { flexShrink: 5 }
    },
    gap: {
      none: {
        gap: 0
      },
      sm: {
        gap: "$1"
      },
      md: {
        gap: "$2"
      },
      lg: {
        gap: "$3"
      },
      xl: {
        gap: "$4"
      },
      xxl: {
        gap: "$5"
      }
    },
    display: {
      flex: {
        display: "flex"
      },
      inline: {
        display: "inline-flex"
      },
      none: {
        display: "none"
      }
    },
    outlined: {
      true: {
        border: "1px solid $orange500"
      }
    },
    tennisEventInfo: {
      small: {},
      default: {
        py: "0",
        "& > *": {
          py: "$3",
          "&:nth-last-child(2)": {
            borderRight: "1px solid $primaryBackgroundColor"
          }
        }
      }
    },
    divider: {
      top: {
        borderTop: "1px solid $dividerBorderColor"
      },
      bottom: {
        borderBottom: "1px solid $dividerBorderColor"
      }
    },
    form: {
      true: {},
      false: {}
    },
    variant: {
      base: {
        fd: "row",
        ai: "normal",
        jc: "center"
      },
      score: {
        ai: "center",
        fd: "column",
        textAlign: "center"
      },
      odds1X2: {
        fd: "row",
        ai: "center",
        jc: "center",
        gap: "$2"
      },
      odds12Vertical: {
        fd: "column",
        gap: "$1",
        "& > *": {
          width: "100px"
        }
      },
      odd: {
        flex: "1 1 auto",
        bc: "$oddItemPrimaryBgColor",
        br: "2px",
        px: "$2",
        py: "7px",
        "&:hover": {
          bc: "$accentPrimaryBgColor",
          cursor: "pointer"
        }
      },
      tournament: {
        fd: "row",
        jc: "space-between"
      },
      livescoreMatch: {
        py: "$3",
        pr: "$3",
        [`& > ${SMPLinkWrapper} > div:first-child > :first-child`]: {
          padding: "$3"
        },
        [`& > div:first-child > ${SMPLinkWrapper} > :first-child`]: {
          padding: "$3"
        }
      },
      tabsContainer: {
        overflow: "auto",
        whiteSpace: "nowrap",
        scrollBehavior: "smooth",
        "&::-webkit-scrollbar": {
          display: "none"
        },
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "& svg:first-child": {
          width: "10px",
          position: "absolute",
          left: "6px",
          cursor: "pointer",
          transform: "translateY(5px)"
        },
        "& svg:last-child": {
          width: "10px",
          position: "absolute",
          right: "5px",
          cursor: "pointer",
          transform: "translateY(5px)"
        },
        "& svg:hover": {
          color: "orange",
          cursor: "pointer",
          transition: "color 0.3s"
        },
        "& svg:active": {
          height: "14px",
          transition: "height 0.3s",
          "transition-timing-function": "ease-out"
        }
      },
      standingsMarginals: {
        fd: "row",
        jc: "start",
        ai: "start",
        py: "$2_5",
        pr: "$4",
        pl: "$2_5"
      },
      header: {
        pt: "$2_5",
        px: "$3"
      },
      formWrapper: {
        fd: "row-reverse",
        jc: "start",
        gap: "$1"
      },
      column: {
        fd: "column"
      },
      standingsFilters: {
        position: "relative",
        fd: "row",
        pt: "$2_5",
        pb: "$2_5",
        bc: "$rowBackgroundColor",
        "@bp0": {
          pl: "$3",
          pr: "$3"
        },
        "@bp3": {
          px: "$4"
        }
      },
      centeredRow: {
        fd: "row",
        ai: "center",
        jc: "center"
      },
      fansUnitedContentWrapper: {
        fd: "column",
        ai: "center",
        borderTop: "2px solid $orange500",
        pt: "$2",
        pb: "$3",
        bc: "$fansUnitedContentPrimaryBgColor"
      },
      fansUnitedHeaderWrapper: {
        jc: "space-between",
        ai: "center",
        cursor: "pointer",
        px: "$2",
        py: "11px"
      },
      fansUnitedOutcome1X2: {
        fd: "column",
        ai: "center",
        jc: "center",
        gap: "$2",
        mt: "$2",
        width: "100%",
        "@bp1": {
          fd: "row",
          ai: "stretch",
          width: "auto"
        }
      },
      fansUnited1X2Pill: {
        flex: "1 1 auto",
        bc: "$oddItemPrimaryBgColor",
        br: "$1",
        px: "$2",
        py: "$1",
        jc: "center",
        width: "100%",
        "&:hover": {
          bc: "$fansUnitedPillHoverColor",
          cursor: "pointer",
          "& > *": {
            color: "$accentPrimaryBgColor"
          }
        },
        "@bp1": {
          width: "115px"
        }
      },
      tennisParticipantsCol: {
        width: "100%",
        flexDirection: "column"
      },
      tennisDoubleMatchMobileScore: {
        flexGrow: "unset",
        alignItems: "center",
        height: "calc(100% - (100% - $2_5) / 2 - $2_5)",
        py: "$1",
        "& > div": {
          height: "100%"
        }
      },
      even: {
        "&:nth-child(even)": {
          background: "$tabRowBackgroundColor"
        }
      },
      showMore: {
        ai: "center",
        "&:hover": {
          cursor: "pointer"
        }
      },
      footballMatchesH2HFilters: {
        position: "relative",
        fd: "row",
        pt: "$2_5",
        pb: "$2_5",
        mt: "2px",
        mb: "4px",
        bc: "$rowBackgroundColor",
        "@bp0": {
          pl: "$3"
        },
        "@bp3": {
          px: "$4"
        }
      },
      eventInfo: {
        display: "grid",
        gridTemplateColumns: "1fr minmax(20%, max-content) 1fr",
        alignItems: "center",
        [`${SMPSportEntity}`]: {
          py: 0
        }
      },
      gridGroupContrast: {
        backgroundColor: "$sportEntityContainerPrimaryBgColor",
        fd: "row",
        jc: "start",
        ai: "start",
        py: "$2_5",
        pr: "$4",
        pl: "$2_5"
      }
    }
  },
  defaultVariants: {
    variant: "base"
  },
  compoundVariants: [
    {
      variant: "livescoreMatch",
      tennisEventInfo: "default",
      css: {
        py: "0",
        [`& > ${SMPLinkWrapper} > div`]: {
          py: "$3",
          "&:first-child": {
            pl: "$2",
            "& > :first-child": {
              padding: "0"
            }
          },
          "&:last-child": {
            borderRight: "1px solid $primaryBackgroundColor"
          }
        }
      }
    },
    {
      variant: "livescoreMatch",
      tennisEventInfo: "small",
      css: {
        p: "0",
        [`& > ${SMPLinkWrapper} > div`]: {
          py: "$3",
          "&:first-child": {
            pl: "$2",
            "& > :first-child": {
              padding: "0"
            }
          },
          "&:last-child": {
            pr: "$3"
          }
        }
      }
    },
    {
      variant: "tournament",
      grid: true,
      css: {
        gridTemplateColumns: "minmax(0, 1fr) auto",
        "& > a > :first-child": {
          justifyContent: "start"
        }
      }
    },
    {
      variant: "livescoreMatch",
      form: true,
      grid: true,
      css: {
        gridTemplateColumns: "minmax(0, 1fr) auto auto",
        [`& > ${SMPLinkWrapper}`]: {
          "& > :nth-child(2)": {
            pr: "unset"
          },
          "& > :last-child": {
            pr: "$3"
          }
        }
      }
    },
    {
      variant: "tennisDoubleMatchMobileScore",
      align: "end",
      css: {
        alignItems: "flex-end"
      }
    },
    {
      variant: "tennisDoubleMatchMobileScore",
      divider: "bottom",
      css: {
        pt: "0",
        height: "calc((100% - $2_5) / 2 + $2_5 + 1px)",
        "& > div > a > div": {
          "& > :first-child": {
            height: "$2_5"
          },
          "& > :last-child": {
            height: "calc(100% - $2_5)"
          }
        }
      }
    }
  ]
});

// src/atoms/SMPContainer.tsx
var SMPContainer = styled.withConfig({ componentId: "CommonWidget", displayName: "SMPContainer" })("div", {
  boxSizing: "border-box",
  flexShrink: 0,
  fontFamily: "$primaryFontFamily",
  ml: "auto",
  mr: "auto",
  px: "$3",
  variants: {
    size: {
      "0": {
        maxWidth: "300px"
      },
      "1": {
        maxWidth: "430px"
      },
      "2": {
        maxWidth: "768px"
      },
      "3": {
        maxWidth: "1145px"
      },
      "4": {
        maxWidth: "none"
      },
      "5": {
        maxWidth: "2000px"
      },
      "6": {
        maxWidth: "4000px"
      }
    },
    live: {
      true: {
        position: "relative",
        "&::before": {
          content: "",
          width: "4px",
          top: "12%",
          height: "75%",
          background: "$green500",
          position: "absolute",
          borderRadius: "0 $3 $3 0"
        }
      }
    },
    variant: {
      oddsContainer: {
        backgroundColor: "$oddsContainerPrimaryBgColor",
        py: "$2"
      },
      transparentOddsContainer: {
        backgroundColor: "transparent",
        py: "$2"
      },
      oddItemContainer: {
        backgroundColor: "$oddItemPrimaryBgColor",
        px: "$2"
      },
      sportEntityContainer: {
        backgroundColor: "$sportEntityContainerPrimaryBgColor",
        py: "$3"
      },
      livescoreTournamentContainer: {},
      groupSectionTitleContainer: {},
      livescoreCompetitionContainer: {
        py: "$3"
      },
      livescoreMatchesContainer: {
        px: 0
      },
      paddinglessContainer: {
        px: 0
      },
      footballSingleEventContainer: {
        backgroundColor: "$sportEntityContainerPrimaryBgColor",
        pr: "$3",
        pl: 0,
        py: "$3"
      },
      footballSingleEventTournamentContainer: {
        pl: "$3",
        pr: "$3",
        pt: "$2",
        pb: "$1"
      },
      singleEventRoundContainer: {
        pl: "$3",
        pr: "$3",
        pb: "$3"
      },
      oddsContainerSingleLine: {
        px: "0",
        py: "$2",
        backgroundColor: "$oddsContainerPrimaryBgColor"
      }
    }
  },
  defaultVariants: {
    size: "4"
  },
  compoundVariants: [
    {
      variant: "sportEntityContainer",
      live: true,
      css: {
        position: "relative",
        "&::before": {
          content: "",
          width: "4px",
          top: "12%",
          left: "0",
          height: "75%",
          background: "$green500",
          position: "absolute",
          borderRadius: "0 $3 $3 0"
        }
      }
    }
  ]
});

// src/atoms/SMPText.tsx
var SMPText = styled.withConfig({ componentId: "CommonWidget", displayName: "TextContainer" })("span", {
  lineHeight: "1",
  margin: "0",
  fontWeight: 400,
  fontVariantNumeric: "tabular-nums",
  fontFamily: "$primaryFontFamily",
  "&.with-winner-badge": {
    maxWidth: "110px"
  },
  "&.with-ellipsis": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  variants: {
    gap: {
      mobile: {
        gap: " 12px"
      },
      desktop: {
        gap: " 16px"
      }
    },
    display: {
      block: {
        display: "block"
      },
      inline: {
        display: "inline"
      },
      none: {
        display: "none"
      },
      flex: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    },
    padding: {
      "pt-1": {
        pt: "$1"
      },
      "pt-3": {
        pt: "$3"
      },
      none: {
        p: "0px"
      }
    },
    size: {
      "1": {
        fontSize: "$1"
      },
      "2": {
        fontSize: "$2"
      },
      "2_5": {
        fontSize: "$2_5"
      },
      "3": {
        fontSize: "$3"
      },
      "4": {
        fontSize: "$4"
      },
      "5": {
        fontSize: "$5",
        letterSpacing: "-.015em"
      },
      "6": {
        fontSize: "$6",
        letterSpacing: "-.016em"
      },
      "7": {
        fontSize: "$7",
        letterSpacing: "-.031em",
        textIndent: "-.005em"
      },
      "8": {
        fontSize: "$8",
        letterSpacing: "-.034em",
        textIndent: "-.018em"
      },
      "9": {
        fontSize: "$9",
        letterSpacing: "-.055em",
        textIndent: "-.025em"
      },
      "really-small": {
        fontSize: "4.4px"
      }
    },
    textAlign: {
      left: {
        textAlign: "left"
      },
      center: {
        textAlign: "center"
      },
      right: {
        textAlign: "right"
      }
    },
    weight: {
      400: {
        fontWeight: 400
      },
      600: {
        fontWeight: 600
      },
      700: {
        fontWeight: 700
      },
      900: {
        fontWeight: 900
      }
    },
    width: {
      5: {
        width: "$5"
      }
    },
    pale: {
      true: {
        color: "$teamLostColor !important"
      }
    },
    variant: {
      tooltipText: {
        color: "#FFFFFF"
      },
      red: {
        color: "$red500"
      },
      blue: {
        color: "$blue500"
      },
      green: {
        color: "$green500"
      },
      orange: {
        color: "$orange500"
      },
      gray: {
        color: "$gray500"
      },
      primaryGray: {
        color: "$primaryGray"
      },
      contrast: {
        color: "$hiContrast"
      },
      accentText: {
        color: "$accentPrimaryBgColor"
      },
      accent: {
        color: "$accentPrimaryBgColor",
        backgroundColor: "$highlightPrimaryBgColor"
      },
      accentSecondary: {
        color: "$accentPrimaryBgColor",
        backgroundColor: "$accentSecondaryBgColor"
      },
      loContrast: {
        color: "$loContrast"
      },
      oddLabel: {
        fontSize: "12px",
        color: "$oddItemLabelColor",
        fontFamily: "$primaryFontFamily",
        textTransform: "uppercase"
      },
      oddCoefficient: {
        fontSize: "12px",
        color: "$oddItemCoefficientColor",
        fontWeight: "bold",
        ta: "right",
        fontFamily: "$primaryFontFamily"
      },
      live: {
        color: "$liveMatchStatusColor"
      },
      livescoreFullTime: {
        color: "$fullTimeMatchStatusColor"
      },
      tabLabel: {
        color: "$pillTextColor"
      },
      activeTabLabel: {
        color: "$pillActiveTextColor",
        fontWeight: "bold"
      },
      fansUnited1X2Label: {
        lineHeight: 1.3,
        fontSize: "$2",
        color: "$oddItemCoefficientColor",
        textAlign: "center",
        margin: "auto"
      },
      tennisSingleEventSeparator: {
        alignItems: "center",
        color: "$hiContrast"
      },
      tennisSingleEventLabel: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "$hiContrast"
      },
      diffContrast: {
        color: "$diffContrastColor"
      },
      showMore: {
        pt: "$4",
        pb: "$4",
        textDecoration: "underline",
        color: "$hiContrast",
        "&:hover": {
          cursor: "pointer",
          textDecoration: "none"
        },
        fontSize: "$3"
      },
      tooltip: {
        color: "$tooltipColor"
      },
      teamWinnerForm: {
        display: "flex !important",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        size: "$5",
        marginRight: "$3",
        fontSize: "$2",
        color: "Black",
        fontWeight: "bold"
      },
      matchesH2HTeamStyle: {
        color: "$hiContrast",
        opacity: "80%",
        fontWeight: "400"
      },
      matchesH2HSelectedTeamStyle: {
        fontWeight: "400",
        color: "$hiContrast"
      },
      scoreHeader: {
        width: "100%",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        color: "$hiContrast"
      }
    }
  },
  defaultVariants: {
    size: "$3",
    variant: "$contrast",
    display: "block"
  }
});

// src/atoms/SMPProviderLogo.tsx
var SMPProviderLogo = styled.withConfig({ displayName: "SMPProviderLogo" })("a", {
  display: "block",
  borderRadius: "$1",
  height: "100%",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  "&.disable-interaction": {
    cursor: "default"
  }
});

// src/atoms/SMPGroupCountBadge.tsx
var SMPGroupCountBadge = ({ eventsCounts }) => {
  return /* @__PURE__ */ React.createElement(SMPText, {
    style: {
      backgroundColor: "var(--colors-groupCountColor)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "14px",
      borderRadius: "50%",
      color: "#fff",
      fontSize: "11px",
      lineHeight: "16px",
      fontWeight: "700",
      padding: "3px 4px"
    }
  }, eventsCounts);
};

// src/atoms/SMPOddEntity.tsx
var SMPOddEntity = styled.withConfig({ componentId: "CommonWidget", displayName: "OddEntity" })("a", {
  boxSizing: "border-box",
  display: "flex",
  fontFamily: "$primaryFontFamily",
  textDecoration: "none",
  outline: "none",
  variants: {
    variant: {
      odd: {
        flex: "1 1 auto",
        bc: "$oddItemPrimaryBgColor",
        br: "$1",
        px: "$2",
        py: "$1",
        "&:hover": {
          bc: "$accentPrimaryBgColor",
          cursor: "pointer"
        }
      }
    }
  }
});

// src/atoms/SMPScore.tsx
var SMPScore = styled("a", {
  boxSizing: "border-box",
  display: "flex",
  fontFamily: "$primaryFontFamily",
  fontSize: "$3",
  alignItems: "center",
  flex: "0.5 1 0",
  gap: "$2",
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
  mt: "0px",
  variants: {
    padding: {
      top: {
        pt: "$1"
      },
      none: {
        p: "0px"
      }
    },
    direction: {
      row: {
        fd: "row"
      },
      column: {
        fd: "column"
      },
      rowReverse: {
        fd: "row-reverse"
      },
      columnReverse: {
        fd: "column-reverse"
      }
    },
    variant: {
      horizontal: {
        fd: "row",
        textAlign: "left"
      },
      vertical: {
        flex: "0.5 1 0",
        fd: "column",
        textAlign: "center",
        gap: "$2",
        mt: "10px"
      },
      responsive: {
        flex: "1 1 0",
        fd: "column",
        textAlign: "center",
        gap: "$3",
        mt: "0"
      }
    }
  }
});

// src/atoms/SMPIcon.tsx
var SMPIcon = styled("svg", {
  variants: {
    width: {
      "1": {
        width: "$1"
      },
      "2": {
        width: "$2"
      },
      "3": {
        width: "$3"
      },
      "4": {
        width: "$4"
      },
      "5": {
        width: "$5"
      }
    },
    height: {
      "1": {
        height: "$1"
      },
      "2": {
        height: "$2"
      },
      "3": {
        height: "$3"
      },
      "4": {
        height: "$4"
      },
      "5": {
        height: "$5"
      }
    },
    variant: {
      contrast: {
        color: "$hiContrast"
      }
    }
  },
  defaultVariants: {
    variant: "contrast"
  }
});

// src/atoms/icons/SMPWinIcon.tsx
var SMPWinIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("image", {
    width: "16",
    height: "16",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAYAAADHyrhzAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEqUlEQVR4nN2cP2jcVhyAv1zcDk2gztBAIYbzEArBkMsQDBric0dDiQ2mQlPsbp4Sz4Y6HjqfQwsdL52EhhBnCXTKeRHtlOvQLhlypktoFnXI3uG9p8qKTie9pz/v/EGI7056p/fd7/2R9Hu6REM4vtsFukAf+BzoTdk0Av6Q/49DLxjVf3SCS3UV7PjuIrAJrCEEdA2KGwMj4EWdciqX4fjuJvAAIaIOIuAp8CT0gkmVBVcmw/HdHeAQswgoywlCyqiKwoxlyEgY0KyENCfAvmmkaMuQHeIQ0R/YwlHoBY91d9aSIaNhCCzqfnGNjIEtnSjplN3B8d0h8Bw7RYAYsl/LH6wUhSNDDpXPsatZzGI/9ILjohsXkiFFvGL6RMlmnoZesFtkw5ky5lyEopCQy3kfXhARAL2l7ZV//3725295G83qQAfMvwjFYFanOlWG47uPgJ2qj6hlho7vTv1xM2XIHQa1HVJ7LCLmR5lMi4ypO1wAeo7vPs764KPRRDaPixgVaZbTs9RzkSFHj8Mmj6hFPvrB083kEfZOszO5+ukV3V03Hd/tJ9+IZcioeKh/WM1z81qXZ9/8yMbymm4R5+qbjIy5ioqb17r89PX3XP3kMw5W93SFbMpLEcB5GQ9MD7ApkiIUBkLi6OgAyLbTNTvEZsgSodAUEs9KVWTMRVTkiVAcrO5x5/qtMsV2VUeqZPR1D7ApiogAePn2lNf//FW2+PsAncTNHWspI+KH33/W+Yo+iMjo6+zdFA2IAHlm3gFu65ZQNw2JAMQg0sHS6xVNipD0OljYX7QgAmDROhktiQC4Xfq+SZ20KAJkZBizsbxmcrIEtC4CgAXTAjaW1zhY3Ytfv3x7WroMG0SAxu3FJGkROucGtogAAxlpEYoyQmwSAZoypolQFBFimwgwbCZ55AmxUQQwvry0vdKn5FzjTXTGuw/vuXfjbu52927c5d2H97yJzuL3LBUB8KuSUXpKriPEYhEARwuInEst1DCa13+oz7+88gXffrVhqwiAyQIi7UebokK+W9kuVFZbIkIvmHRk2mBkUlIVlWhRBIiE23g0GZmWZlKZlkUAnML/Ml5UUaJOpSwQASKPNJZxgmFTUZSpnC0iQi+IQMqQL06qKr1IJS0RAfCL+iM5A31S5TfkVdYiEZPQC+IgiGWEXqCWMVRGVqUtEgFwlHxxLttvaXvljIrzuJIzVctETNLpkFmZO0NqSGy7c/2Wzp2uOtlKNhHIPmvdp6KRJYllIkZpEZAhQ44sR+n3LxARkJktnHk9QyafVzbUWsbutOUXeRd3djE8ibOQ46zmochNpJfJsa+Yo/SmHEahF6znbZB72U/OPdapoUNtmDGwNWujoutN5jlCxsC6Ov/Io8xKpHkUUlgElFywJ4UMsTSNIUXhFUiKUrcKEn2I7cPuflkRYLaudQeRf21Tsxkj5hFaUwKjFc8yxXpA+4t0IsQC38IrFbOoZC28zKM8pPlkuQhxHea4aCeZR6VPSZAd7ENE1m2dzWeCuEJViQRFLc/PSDw74z4iWqoQM0F03LU9Q6O2h4kkkc2oh0iz7DK7OU3kvzHijt+o6mdlZPEfuW7vxPhilbAAAAAASUVORK5CYII="
  }));
};

// src/atoms/icons/SMPLossIcon.tsx
var SMPLossIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("pattern", {
    id: "loss",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 67 67"
  }, /* @__PURE__ */ React.createElement("image", {
    width: "67",
    height: "67",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAYAAADHyrhzAAAACXBIWXMAAC4jAAAuIwF4pT92AAAE+0lEQVR4nN2cPWwcRRTHf3c2toNsOIG0gGguWHJrC2mLiCK2TihNpDipUiBiFwhBkxgURBXHKYmQk4oihR0qKnKRaACtfCmoViLnFgnpOsQ1HDKCJICgmFl7fd6P2d03ex9/ybLPN/t27ndvPt7Mm61QkroNtw7UgWXgRWAppmgP2Ne/247nt+zXTqliy3C34daAVeAsCkC9gLk20AIe2oQjDqPbcFeBKygQNtQDdoG7jud3JA2Lweg23DVgk2IekFVNFJSWhLHCMLQnbFMuhH41gY2inpIbhu4Qd1D9wbBoy/H8m3kvzgVDe8MOUMt7Y4tqAxfzeEk16wXdhrsDPGA4QYAash/rLyyTjD1DD5UPGK5mkaYNx/PvmBY2gqFB7BE/URpm7Tqev25SMBXGiIMIZAQksc8YExAAa92Gey2tUFoHus3ogwi0ndapxsLQJNekazRg7XQbbuyXGwlDX7BtrUqDUw01P4pUnGfEXjAGWuo23JtRb5wYTXTzGEev6Nfp/lnqMc/Qo8dmmTUaoE584f3N5BrDO82W1mq34S6H/3EIQ3vFVcm7Tb91lsn5BTFbldk5EVshHfu8Yc8Q9YqZc+d5Yes2tc+/KAwkbEsYyKpeigCOw7gidYeZc+eZu34DgMrsXCEgYVuT8ws2gBx6RxVAt526hOVw5QPlBRJlywKQw1lp4BkiXhFV+UBZgSTZEgZSDzrSAMayhNVTly4nvm8KJAlEoMn5BaYW38xcxxhdAKiGNncKq/fxB/zz80+JZdKAmIAAOLh9i6c/PMpVzwgtg/KMZSmL//1xUAhIFhBPvv2mUF37tAQKxqKk1bxABggCUIPIxPU3Xv8U6T2PZ8942vqeKfcM1Zdeji1WmZpmZuVtKlPTzH74UapZWyC09qtY2vzJ4iHPv/teqj3LIABq1mCAOZA0lQACYDHzvklWFQVSEgjQnmFdeYGUCALIsaOWVwGQf3/9xaj8n1/eKxUElAgDVBg+8cprRmVPXbosFv6bqjQYpvOIQEWj3TwqBUZWEIHKBmIdRl4QgUoE0q6iEsesyBREWqdaEpDfq0DHhuUsscZv779TONoVUKuKyrkUVdagq2i0K6ROFZX2I6a80eeAgXQcz+9UddpgT8Ji0TB8gEBacDSatCQsPmewDJc2xc4CZOJVswmcgR7BEYyHEhYPPrvFk+/iP6hprGECRHjZrwlHMJoINZU4IFmDriQgwgFc0/H8HmgY+kVTyno/kLyVjwJiIZK9H/xxmJKgE1QeS95l7pMb/L3/Y+HKBx3mX19/JQ2i43j+6cP7hN/pNtw9RivPs6jWHc/fDV70xyZb5dZloOqEQUAfDD3nOFZgjLXR/4+oqHUDoZFliNVyPP/EgHEChh5Zxrm59IDIbOHI9QydfC421A6Z1uOOXyQt7qwjHMQNge5ENY9AiYn0eu6xx3gkvbUcz19JKpC47Od4fhtYYfQ71DZwMa2Q6XmTUfaQNrASxB9JynISaRSBGIOAjAf2NJAdRuPYhfEJpECZtgpCfciwD7sbWUFAsXOta6j862FqNm3UPCLXlKDQiWedYr3N4A/p9FAHfI1PKkZJ5Cy8zqPcpPzwvwfcRU2mCg//ok9J0B3sVVTWrc3m00GtUIlACGTl+RmhZ2dcQHmLBJgOquO29gwNaw8TCUs3oyVUmmWd9ObU0T9t1I5fS/pZGVH6Hw0cJWyPg8Q5AAAAAElFTkSuQmCC"
  }))), /* @__PURE__ */ React.createElement("path", {
    fill: "url(#loss)",
    d: "M0 0h16v16H0z"
  }));
};

// src/atoms/icons/SMPDrawIcon.tsx
var SMPDrawIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("pattern", {
    id: "draw",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 67 67"
  }, /* @__PURE__ */ React.createElement("image", {
    width: "67",
    height: "67",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAYAAADHyrhzAAAACXBIWXMAAC4jAAAuIwF4pT92AAADoUlEQVR4nO2cMVLbQBSGPzSENk4yk0k65wR4MpMiVcwJMK0alkYt+ATACQytUlg0SomZSZMig3KCKDdQl0wq5QYpdmXLRrYle6WVZX8zDFislsevt29Xq/e0R0W4nt8G2kAXeA505jSNgV/qe+gIOyjfOsleWR27nt8CesAnpADtNboLgQB4KFMc7WK4nt8DTpFClEEMeMCtI+xIZ8faxHA9XwCXrOcBRRkhRQl0dLa2GMoTBlQrwiwjoL+up6wshgqIQ2Q8qAvXjrCvVj15JTGUNwyB1qp/uERC4GQVL7GKnuB6/hC4p55CgJyyf6oLVojcnqGmynvqNSyW0XeEfZO3cS4xlBCPzF8o1RnPEfZZnoZLxdhwIRJyCbIwZjRECADhev7FskbLAuiAzRciYbAsqM4VQykpdFtkmKHr+XMvbqYY6oRBaSaZo4VcH2UyzzPmntAAOq7nX2X94slsooZHE71ilnezq9Qpz1Czx2WVFhnkyQWfHSYX1HeZrZue6/nd9IGxGMorzqu2yDBT/2/aM7bJKxJ6aisCmBbjtHpbasHYOywANXbahowxzXhVmnjGtnoFQDsJpIkYXWOm1INjACv1cGeb6YL0jK5RM+pBB6QYh4YNqQWu53ctmrNfsS6dfTTHi1cvX/Dxw3udXWby9dt33V22tItxcPCMt29e6+yyKg4LPzdpMK2dGCl2YqTYiZFiJ0aKnRgpdmJMCPeRiWNdXT3+/vOXz3dfdHVXJf8sIDJtRU0ILGTO5Q6ILGTaz7YTOcKOLJU2GJu2xjABTGaTwJgZ9eAHTMR4MGhIHRjBRIwR2ztURo6wY1BiqA8joyaZ4y75Ib0CvTVgiGkiR9hjJxiL4Qg7KWPYJq7TH2bvTa7ZHiJH2F76wJQYas0x1aDB9GcPZN219mn+zBKkY0XCEzHUzNLk4RIDmdnCmfsZKvm8qVPt2bzyi0WbO2c07ybuJmt4JCxMpFfJsY80I70pcIR9tKjBwm0/tfY4YvMDagicLGuUt95kkz0kBI6S+49FFKlE2kRBcgsBBQv2lCBDNiONIXcFUkKhRwWpGFL3abdfVAhYr65VIPOv6zRsQuQ6YqUlwVoVzyrFeoD5Ip0YWeCbu1IxCy218CqP8pLqk+Vi5D7MTd4guQitb0lQAfYcmXVb5vCJkDtUWkRIKOX9Gal3ZxwjvUWHMBEycJf2Do3SXiaSRg2jDjLNss3y4RSprxD5xC/Q/a6MLP4DC3b6mwiWcQoAAAAASUVORK5CYII="
  }))), /* @__PURE__ */ React.createElement("path", {
    fill: "url(#draw)",
    d: "M0 0h16v16H0z"
  }));
};

// src/atoms/icons/SMPCarretDownIcon.tsx
import React2 from "react";
var SMPCarretDownIcon = (props) => {
  return /* @__PURE__ */ React2.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React2.createElement("path", {
    "data-name": "Path 253",
    d: "M7.614 0H.386a.385.385 0 0 0-.271.658l3.614 3.614a.386.386 0 0 0 .542 0L7.885.658A.385.385 0 0 0 7.614 0Z",
    fill: "currentColor"
  }));
};

// src/atoms/icons/SMPChevronDownIcon.tsx
var SMPChevronDownIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("path", {
    d: "M3.46967 5.46967C3.76256 5.17678 4.23744 5.17678 4.53033 5.46967L8 8.93934L11.4697 5.46967C11.7626 5.17678 12.2374 5.17678 12.5303 5.46967C12.8232 5.76256 12.8232 6.23744 12.5303 6.53033L8.53033 10.5303C8.23744 10.8232 7.76256 10.8232 7.46967 10.5303L3.46967 6.53033C3.17678 6.23744 3.17678 5.76256 3.46967 5.46967Z",
    fill: "#FF901A"
  }));
};

// src/atoms/icons/SMPStandingsIcon.tsx
var SMPStandingsIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadProps(__spreadValues({}, props), {
    width: "4",
    height: "4"
  }), /* @__PURE__ */ React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M2.253,3.462A1.632,1.632,0,0,0,1.82,4.684l.273,4.122a2.313,2.313,0,0,0,2.3,2.147H5.881a5.606,5.606,0,0,0,4.724,4v1.691A3.724,3.724,0,0,0,7.57,20.333.666.666,0,0,0,8.236,21h6.072a.709.709,0,0,0,.667-.714,3.706,3.706,0,0,0-3.036-3.639V14.956a5.605,5.605,0,0,0,4.725-4h1.488a2.313,2.313,0,0,0,2.3-2.149l.273-4.118A1.634,1.634,0,0,0,19.092,2.94H17.262L17.331,1.7a.666.666,0,0,0-.665-.7H5.879a.666.666,0,0,0-.665.7L5.283,2.94H3.452a1.642,1.642,0,0,0-1.2.522Zm11.306,16.2H8.985a2.37,2.37,0,0,1,4.574,0Zm3.63-15.393h1.9a.3.3,0,0,1,.223.1.294.294,0,0,1,.079.222s0,0,0,0L19.12,8.714a.975.975,0,0,1-.967.906H16.888Zm-1.228-1.94-.408,7.279a4.285,4.285,0,0,1-8.493.546c-.035-.178-.1-1.03-.1-1.03l-.38-6.8ZM5.656,9.62H4.392a.974.974,0,0,1-.967-.9L3.15,4.592a.294.294,0,0,1,.079-.222.3.3,0,0,1,.223-.1h1.9Z",
    transform: "translate(-1.816 -1)",
    fill: "currentColor"
  }));
};

// src/atoms/icons/SMPArrowLeftIcon.tsx
var SMPArrowLeftIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadProps(__spreadValues({}, props), {
    height: "3",
    width: "2"
  }), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(-19.599 -9.969)"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(27.599 9.969) rotate(90)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/SMPArrowUpIcon.tsx
var SMPArrowUpIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadProps(__spreadValues({}, props), {
    height: "3",
    width: "2"
  }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", {
    id: "a"
  }, /* @__PURE__ */ React.createElement("path", {
    "data-name": "Rectangle 526",
    fill: "currentColor",
    d: "M0 0h12.399v7.064H0z"
  }))), /* @__PURE__ */ React.createElement("g", {
    "data-name": "Group 674",
    clipPath: "url(#a)"
  }, /* @__PURE__ */ React.createElement("path", {
    "data-name": "Path 198",
    d: "M12.4 6.076a1.3 1.3 0 0 0-.413-.652Q9.424 2.868 6.867.306a.855.855 0 0 0-.946-.252 1.012 1.012 0 0 0-.361.233Q2.918 2.918.285 5.558a.841.841 0 0 0-.224.942.826.826 0 0 0 .739.56.873.873 0 0 0 .727-.289q.606-.609 1.215-1.216L6.1 2.2a.762.762 0 0 1 .136-.127.57.57 0 0 0 .073.126q2.279 2.283 4.561 4.564a.866.866 0 0 0 .924.259.824.824 0 0 0 .565-.566l.044-.137Z",
    fill: "currentColor"
  })));
};

// src/atoms/icons/SMPArrowRightIcon.tsx
var SMPArrowRightIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadProps(__spreadValues({}, props), {
    height: "3",
    width: "2"
  }), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(0 14.041) rotate(-90)"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/SMPCalendarIcon.tsx
var SMPCalendarIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadProps(__spreadValues({}, props), {
    width: "3",
    height: "3",
    style: { color: props.color ? props.color : "#D9D9D9" }
  }), /* @__PURE__ */ React.createElement("g", {
    transform: "scale(1.2)"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M10.714,1.286H9.429V.429a.429.429,0,0,0-.857,0v.857H3.429V.429a.429.429,0,1,0-.857,0v.857H1.286A1.286,1.286,0,0,0,0,2.571v8.143A1.286,1.286,0,0,0,1.286,12h9.429A1.286,1.286,0,0,0,12,10.714V2.571A1.286,1.286,0,0,0,10.714,1.286Zm.429,9.429a.429.429,0,0,1-.429.429H1.286a.429.429,0,0,1-.429-.429V5.143H11.143Zm0-6.429H.857V2.571a.429.429,0,0,1,.429-.429H2.571V3a.429.429,0,0,0,.857,0V2.143H8.571V3a.429.429,0,0,0,.857,0V2.143h1.286a.429.429,0,0,1,.429.429V4.286Z",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(2.143 6)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M86.619,238.933h-.857a.429.429,0,1,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-85.333 -238.933)",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(5.143 6)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M206.086,238.933h-.857a.429.429,0,0,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-204.8 -238.933)",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(8.143 6)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M325.553,238.933H324.7a.429.429,0,0,0,0,.857h.857a.429.429,0,0,0,0-.857Z",
    transform: "translate(-324.267 -238.933)",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(2.143 7.714)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M86.619,307.2h-.857a.429.429,0,1,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-85.333 -307.2)",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(5.143 7.714)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M206.086,307.2h-.857a.429.429,0,0,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-204.8 -307.2)",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(8.143 7.714)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M325.553,307.2H324.7a.429.429,0,0,0,0,.857h.857a.429.429,0,0,0,0-.857Z",
    transform: "translate(-324.267 -307.2)",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(2.143 9.429)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M86.619,375.467h-.857a.429.429,0,1,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-85.333 -375.467)",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(5.143 9.429)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M206.086,375.467h-.857a.429.429,0,0,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-204.8 -375.467)",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("g", {
    transform: "translate(8.143 9.429)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M325.553,375.467H324.7a.429.429,0,0,0,0,.857h.857a.429.429,0,0,0,0-.857Z",
    transform: "translate(-324.267 -375.467)",
    fill: "currentColor"
  }))));
};

// src/atoms/SMPProgressBar.tsx
var ProgressBar = styled("div", {
  bc: "$progressBarPrimaryBgColor",
  borderRadius: "$1"
});
var ProgressBarContent = styled("div", {
  backgroundColor: "orange",
  height: "$1",
  borderRadius: "$1"
});
var SMPProgressBar = ({ value, css: css2 }) => {
  return /* @__PURE__ */ React.createElement(ProgressBar, {
    css: css2
  }, /* @__PURE__ */ React.createElement(ProgressBarContent, {
    style: { width: `${value}%` }
  }));
};

// src/atoms/SMPRulesColorCircle.tsx
var SMPRulesColorCircle = styled("span", {
  height: "12px",
  width: "12px",
  borderRadius: "$round",
  display: "inline-block",
  marginRight: "4px",
  variants: {
    rule: {
      top: {
        background: "$top"
      },
      topplayoff: {
        background: "$topPlayoff"
      },
      relegation: {
        background: "$relegationColor"
      },
      relegationplayoff: {
        background: "$relegationPlayoff"
      },
      promotion: {
        background: "$promotion"
      },
      promotionplayoff: {
        background: "$promotionPlayoff"
      },
      championshipplayoff: {
        background: "$championshipPlayoff"
      },
      tiertwo: {
        background: "$tierTwo"
      },
      tiertwoplayoff: {
        background: "$tierTwoPlayoff"
      },
      none: {
        background: "inherit"
      }
    }
  }
});

// src/atoms/SMPStandingsRow.tsx
var SMPStandingsRow = styled.withConfig({ componentId: "CommonWidget", displayName: "StandingsRow" })("div", {
  display: "flex",
  fd: "row",
  jc: "start",
  ai: "center",
  py: "8px",
  "@bp0": {
    pr: "$5"
  },
  "@bp2": {
    pr: "28px"
  },
  "@bp4": {
    pr: "38px"
  },
  bc: "$rowBackgroundColor",
  position: "relative",
  mb: "1px",
  boxSizing: "border-box",
  "&::before": {
    content: "",
    width: "4px",
    top: "4%",
    height: "90%",
    position: "absolute",
    borderRadius: "0 $3 $3 0"
  },
  variants: {
    rule: {
      top: {
        "&::before": {
          background: "$top"
        }
      },
      topplayoff: {
        "&::before": {
          background: "$topPlayoff"
        }
      },
      relegation: {
        "&::before": {
          background: "$relegationColor"
        }
      },
      relegationplayoff: {
        "&::before": {
          background: "$relegationPlayoff"
        }
      },
      promotion: {
        "&::before": {
          background: "$promotion"
        }
      },
      promotionplayoff: {
        "&::before": {
          background: "$promotionPlayoff"
        }
      },
      championshipplayoff: {
        "&::before": {
          background: "$championshipPlayoff"
        }
      },
      tiertwo: {
        "&::before": {
          background: "$tierTwo"
        }
      },
      tiertwoplayoff: {
        "&::before": {
          background: "$tierTwoPlayoff"
        }
      },
      none: {
        "&::before": {
          background: "inherit"
        }
      }
    }
  }
});

// src/atoms/SMPKnockoutMobileGameContainer.tsx
var SMPKnockoutMobileGameContainer = styled.withConfig({
  componentId: "CommonWidget",
  displayName: "KnockoutMobileGameContainer"
})("div", {
  display: "grid",
  alignItems: "center",
  position: "relative",
  width: "calc(100% - 16px)",
  "&::after": {
    content: "",
    height: "100%",
    position: "absolute",
    right: "-10px",
    width: "10px;",
    zIndex: "-1"
  },
  "&:nth-child(even)": {
    marginBottom: "10px"
  },
  variants: {
    firstGroup: {
      true: {
        top: "6px",
        "&:nth-child(even)": {
          marginBottom: "10px"
        }
      }
    },
    even: {
      true: {
        "&::after": {
          borderBottom: "1px solid $knockoutGameBorderColor",
          borderBottomRightRadius: "$1",
          bottom: "-50%"
        }
      }
    },
    odd: {
      true: {
        "&::after": {
          borderTop: "1px solid $knockoutGameBorderColor",
          borderTopRightRadius: "$1",
          top: "-50%",
          borderRight: "1px solid $knockoutGameBorderColor",
          borderBottomRightRadius: "$1"
        },
        "&::before": {
          borderTop: "1px solid",
          borderColor: "$knockoutGameBorderColor",
          content: "",
          height: "100%",
          position: "absolute",
          zIndex: "-1",
          right: "-19px",
          width: "9px"
        }
      }
    },
    removeConnectingLines: {
      true: {
        "&::after": {
          content: "",
          width: "0"
        }
      }
    },
    smallFinal: {
      true: {
        "&::before": {
          top: "-3px"
        }
      }
    },
    doublesVariant: {
      true: {
        ">div a": {
          alignItems: "center"
        }
      }
    },
    variant: {
      group: {},
      even: {},
      odd: {},
      test: {},
      removeConnectingLines: {},
      smallFinal: {},
      doublesVariant: {}
    }
  },
  compoundVariants: [
    {
      variant: "group",
      firstGroup: true,
      even: true,
      odd: true,
      css: {}
    }
  ]
});

// src/atoms/SMPKnockoutGameContainer.tsx
var SMPKnockoutGameContainer = styled.withConfig({ componentId: "CommonWidget", displayName: "KnockoutGameContainer" })("div", {
  display: "grid",
  alignItems: "center",
  position: "relative",
  "@bp0": {
    width: "calc(100% - 20px)",
    "&::after": {
      content: "",
      height: "100%",
      position: "absolute",
      right: "-10px",
      width: "10px;",
      zIndex: "-1"
    },
    "&:nth-child(even)": {
      marginBottom: "10px"
    }
  },
  "@bp2": {
    width: "100%",
    "> div a > span": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "110px"
    },
    "&::after": {
      content: "",
      height: "100%",
      position: "absolute",
      right: "-20px",
      width: "20px;",
      zIndex: "-1"
    },
    "&:nth-child(even)": {
      marginBottom: "0"
    }
  },
  variants: {
    firstGroup: {
      true: {
        top: "6px",
        "@bp0": {
          "&:nth-child(even)": {
            marginBottom: "10px"
          }
        },
        "@bp2": {
          "&:nth-child(even)": {
            marginBottom: "18px"
          }
        }
      }
    },
    even: {
      true: {
        "&::after": {
          borderBottom: "1px solid $knockoutGameBorderColor",
          borderBottomRightRadius: "$1",
          bottom: "-50%"
        }
      }
    },
    odd: {
      true: {
        "&::after": {
          borderTop: "1px solid $knockoutGameBorderColor",
          borderTopRightRadius: "$1",
          top: "-50%",
          borderRight: "1px solid $knockoutGameBorderColor",
          borderBottomRightRadius: "$1"
        },
        "@bp0": {
          "&::before": {
            borderTop: "1px solid",
            borderColor: "$knockoutGameBorderColor",
            content: "",
            height: "100%",
            position: "absolute",
            zIndex: "-1",
            right: "-19px",
            width: "9px"
          }
        },
        "@bp2": {
          "&::before": {
            borderTop: "1px solid",
            borderColor: "$knockoutGameBorderColor",
            content: "",
            height: "100%",
            position: "absolute",
            zIndex: "-1",
            right: "-50px",
            width: "30px"
          }
        }
      }
    },
    removeConnectingLines: {
      true: {
        "@bp0": {
          "&::after": {
            content: "",
            width: "0"
          }
        },
        "@bp2": {
          "&::after": {
            content: "",
            width: "1px"
          }
        }
      }
    },
    smallFinal: {
      true: {
        "@bp0": {
          "&::before": {
            top: "-3px"
          }
        },
        "@bp2": {
          "&::before": {
            top: "-62px"
          }
        }
      }
    },
    smallFinalWithTwoKnockoutGroups: {
      true: {
        "@bp0": {
          "&::before": {
            top: "-3px"
          }
        },
        "@bp2": {
          "&::before": {
            top: "0"
          }
        }
      }
    },
    doublesVariant: {
      true: {
        "@bp2": {
          width: "100%",
          ">div a": {
            alignItems: "center"
          },
          ">div a span": {
            height: "auto"
          }
        }
      }
    },
    variant: {
      group: {},
      even: {},
      odd: {},
      removeConnectingLines: {},
      smallFinal: {},
      smallFinalWithTwoKnockoutGroups: {},
      doublesVariant: {}
    }
  },
  compoundVariants: [
    {
      variant: "group",
      firstGroup: true,
      even: true,
      odd: true,
      css: {}
    }
  ]
});

// src/atoms/SMPKnockoutHeaderContainer.tsx
var SMPKnockoutHeaderContainer = styled.withConfig({ componentId: "CommonWidget", displayName: "KnockoutHeaderContainer" })("div", {
  boxSizing: "border-box",
  bc: "$knockoutHeaderBgColor",
  border: "1px solid $knockoutHeaderBorderColor",
  borderRadius: "$2",
  height: "48px",
  top: 0,
  zIndex: "2"
});

// src/atoms/SMPKnockoutSmallFinal.tsx
var SMPKnockoutSmallFinal = styled.withConfig({ componentId: "CommonWidget", displayName: "KnockoutSmallFinal" })("div", {
  border: "1px solid $knockoutHeaderBorderColor",
  py: "$2",
  px: "$2",
  borderRadius: "$2",
  alignItems: "center",
  bc: "$knockoutHeaderBgColor",
  marginBottom: "$2"
});

// src/atoms/SMPKnockoutDesktopContainer.tsx
var SMPKnockoutDesktopContainer = styled.withConfig({ componentId: "CommonWidget", displayName: "KnockoutDesktopContainer" })("div", {
  overflowX: "auto",
  overflowY: "hidden",
  scrollBehavior: "smooth",
  "> svg:nth-child(1)": {
    width: "10px",
    position: "absolute",
    zIndex: 20,
    color: "$hiContrast",
    top: "34px",
    left: "29px",
    cursor: "pointer"
  },
  "> svg:nth-child(1):hover, > svg:last-child:hover": {
    color: "$accentPrimaryBgColor",
    cursor: "pointer",
    transition: "color 0.3s"
  },
  "> svg:last-child": {
    width: "10px",
    position: "absolute",
    zIndex: 20,
    top: "34px",
    color: "$hiContrast",
    cursor: "pointer",
    right: "26px"
  }
});

// src/atoms/SMPKnockoutMobileContainer.tsx
var SMPKnockoutMobileContainer = styled.withConfig({ componentId: "CommonWidget", displayName: "KnockoutMobileContainer" })("div", {
  position: "relative",
  "> svg:nth-child(1)": {
    width: "10px",
    position: "absolute",
    zIndex: 2,
    top: "17px",
    left: "30px"
  },
  "> svg:nth-child(1):hover": {
    color: "orange",
    cursor: "pointer",
    transition: "color 0.3s"
  }
});

// src/atoms/SMPDivider.tsx
var SMPDivider = styled("hr", {
  display: "block",
  width: "100%",
  variants: {
    variant: {
      base: {
        borderTop: "1px solid $dividerBorderColor",
        borderBottom: "transparent",
        margin: "0px"
      }
    }
  },
  defaultVariants: {
    variant: "base"
  }
});

// src/atoms/icons/SMPBirthdateIcon.tsx
var SMPBirthdateIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M11.972,6.972,11.75,7V5.25a.75.75,0,1,0-1.5,0V7H7.75V5.25a.75.75,0,1,0-1.5,0V7H3.75V5.25a.75.75,0,1,0-1.5,0V7L2,6.972A1.994,1.994,0,0,0,0,8.944v6A1.013,1.013,0,0,0,1,16H13a1,1,0,0,0,1-1V8.972A2.024,2.024,0,0,0,11.972,6.972ZM12.5,14.5H1.5V12.263a3.937,3.937,0,0,0,1.5-.6,3.765,3.765,0,0,0,2,.668,3.768,3.768,0,0,0,2-.668,3.765,3.765,0,0,0,2,.668,3.768,3.768,0,0,0,2-.668,4.122,4.122,0,0,0,1.5.619Zm0-3.756a3.509,3.509,0,0,1-1.033-.581.75.75,0,0,0-.935,0A2.863,2.863,0,0,1,9,10.834a2.767,2.767,0,0,1-1.533-.671.75.75,0,0,0-.935,0A2.863,2.863,0,0,1,5,10.834a2.767,2.767,0,0,1-1.533-.671.75.75,0,0,0-.935,0,4.292,4.292,0,0,1-1.033.581V9A.5.5,0,0,1,2,8.5H12a.5.5,0,0,1,.5.5ZM11,3.472a1.249,1.249,0,0,0,1.25-1.249C12.25,1.532,11,0,11,0S9.75,1.56,9.75,2.25A1.226,1.226,0,0,0,11,3.472Zm-4,0A1.249,1.249,0,0,0,8.25,2.223C8.25,1.532,7,0,7,0S5.75,1.56,5.75,2.25A1.226,1.226,0,0,0,7,3.472Zm-4,0A1.249,1.249,0,0,0,4.25,2.223C4.25,1.532,3,0,3,0S1.75,1.56,1.75,2.25A1.226,1.226,0,0,0,3,3.472Z",
    fill: "currentColor"
  }));
};

// src/atoms/icons/SMPMatchesPlayedIcon.tsx
var SMPMatchesPlayedIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M19.973,5.341a1.725,1.725,0,0,0-.66-1.364L15.094.646A2.933,2.933,0,0,0,13.223,0h-.75a.744.744,0,0,0-.722.75,1.75,1.75,0,1,1-3.5,0A.749.749,0,0,0,7.5,0h-.75A3.029,3.029,0,0,0,4.882.647L.661,3.978A1.727,1.727,0,0,0,.387,6.424L1.948,8.35A1.763,1.763,0,0,0,4.4,8.621L5,8.15v5.6A2.253,2.253,0,0,0,7.251,16h5.472a2.253,2.253,0,0,0,2.25-2.25V8.15l.6.473a1.76,1.76,0,0,0,2.453-.271l1.562-1.926A1.57,1.57,0,0,0,19.973,5.341ZM18.5,5.316a.217.217,0,0,1-.052.139L16.886,7.382a.3.3,0,0,1-.205.092.241.241,0,0,1-.152-.056L14.31,5.667A.492.492,0,0,0,14,5.559a.5.5,0,0,0-.5.5v7.69a.75.75,0,0,1-.75.75h-5.5a.75.75,0,0,1-.75-.75V6.084a.5.5,0,0,0-.5-.5.492.492,0,0,0-.308.109L3.473,7.444a.209.209,0,0,1-.153.028.287.287,0,0,1-.207-.093l-1.561-1.9A.226.226,0,0,1,1.5,5.338a.23.23,0,0,1,.09-.181L5.781,1.825a1.678,1.678,0,0,1,.97-.325h.087a3.25,3.25,0,0,0,6.325,0h.086a1.529,1.529,0,0,1,.942.325l4.191,3.331A.2.2,0,0,1,18.5,5.316Z",
    transform: "translate(-0.001)",
    fill: "currentColor"
  }));
};

// src/atoms/icons/SMPMinutesIcon.tsx
var SMPMinutesIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M16,8A8,8,0,1,1,1.38,3.506.75.75,0,0,1,2.62,4.35,6.5,6.5,0,1,0,8.75,1.543V3.25A.755.755,0,0,1,7.972,4a.767.767,0,0,1-.75-.75V.75A.768.768,0,0,1,7.972,0,8.005,8.005,0,0,1,16,8ZM8.5,7.469A.731.731,0,0,1,7.469,8.5L4.969,6A.731.731,0,0,1,6,4.969Z",
    fill: "currentColor"
  }));
};

// src/atoms/icons/SMPYellowCardsIcon.tsx
var SMPYellowCardsIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: "12",
    height: "16",
    rx: "3",
    fill: "#fbbd08"
  }));
};

// src/atoms/icons/SMPRedCardsIcon.tsx
var SMPRedCardsIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: "12",
    height: "16",
    rx: "3",
    fill: "#d5071c"
  }));
};

// src/atoms/SMPLoader.tsx
var spinner = keyframes({
  to: {
    transform: "rotate(360deg)"
  }
});
var LoadingSpinner = styled("div", {
  width: "10px",
  height: "10px",
  borderWidth: 2,
  borderStyle: "solid",
  borderColor: "white",
  borderRadius: "$radii$round",
  animation: `${spinner}  0.6s linear infinite`,
  variants: {
    color: {
      spinner: {
        borderTopColor: "$pillActiveBackgroundColor"
      }
    },
    size: {
      "1": {
        size: "$2",
        height: "$2"
      },
      "2": {
        width: "$4",
        height: "$4"
      },
      "3": {
        width: "$6",
        height: "$6"
      },
      "4": {
        width: "$8",
        height: "$8"
      }
    },
    thickness: {
      "1": {
        borderWidth: 2
      },
      "2": {
        borderWidth: 4
      },
      "3": {
        borderWidth: 6
      },
      "4": {
        borderWidth: 8
      }
    }
  }
});
var SMPLoader = (props) => {
  const _a2 = props, { loaderMinHeight: minHeight } = _a2, rest = __objRest(_a2, ["loaderMinHeight"]);
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    justify: "center",
    align: "center",
    css: { minHeight }
  }, /* @__PURE__ */ React.createElement(LoadingSpinner, __spreadValues({}, rest)));
};

// src/atoms/SMPArrowButton.tsx
var ArrowButtonContainer = re("button", {
  padding: "$3 $1",
  backgroundColor: "#FFFFFF",
  cursor: "pointer",
  border: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "none",
  color: "inherit",
  font: "inherit",
  outline: "inherit",
  variants: {
    position: {
      left: {
        borderLeft: "1px solid $borderMultiSportColor",
        rotate: "180deg"
      },
      right: {
        borderLeft: "1px solid $borderMultiSportColor",
        borderRight: "1px solid $borderMultiSportColor"
      }
    }
  }
});
var SMPArrowButton = ({ onClick, variant }) => {
  return /* @__PURE__ */ React.createElement(ArrowButtonContainer, {
    position: variant,
    onClick
  }, /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "arrow_forward_ios"
  }, /* @__PURE__ */ React.createElement("mask", {
    id: "mask0_1838_194719",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, /* @__PURE__ */ React.createElement("rect", {
    id: "Bounding box",
    width: "24",
    height: "24",
    fill: "#D9D9D9"
  })), /* @__PURE__ */ React.createElement("g", {
    mask: "url(#mask0_1838_194719)"
  }, /* @__PURE__ */ React.createElement("path", {
    id: "arrow_forward_ios_2",
    d: "M8.025 22L6.25 20.225L14.475 12L6.25 3.775L8.025 2L18.025 12L8.025 22Z",
    fill: "#FF901A"
  })))));
};

// src/atoms/SMPSportIcon.tsx
import { getIconAsBgImage } from "@sportal365/smp-widget-utils";

// ../types/common.ts
var WidgetTypes;
(function(WidgetTypes3) {
  WidgetTypes3["TOURNAMENT"] = "tournament";
  WidgetTypes3["TEAM"] = "team";
  WidgetTypes3["PLAYER"] = "player";
  WidgetTypes3["EVENT"] = "event";
  WidgetTypes3["H2H"] = "h2h";
  WidgetTypes3["MULTISPORT"] = "multisport";
})(WidgetTypes || (WidgetTypes = {}));
var THEME_VARIANTS;
(function(THEME_VARIANTS3) {
  THEME_VARIANTS3["LIGHT"] = "light";
  THEME_VARIANTS3["DARK"] = "dark";
  THEME_VARIANTS3["CLIENT"] = "client";
})(THEME_VARIANTS || (THEME_VARIANTS = {}));
var LineupStatuses;
(function(LineupStatuses3) {
  LineupStatuses3["NOT_AVAILABLE"] = "NOT_AVAILABLE";
  LineupStatuses3["UNCONFIRMED"] = "UNCONFIRMED";
  LineupStatuses3["CONFIRMED"] = "CONFIRMED";
})(LineupStatuses || (LineupStatuses = {}));
var IMostDecoratedDataLabelsKeys;
(function(IMostDecoratedDataLabelsKeys3) {
  IMostDecoratedDataLabelsKeys3["FIRST_YELLOW_CARDS"] = "first_yellow_cards";
  IMostDecoratedDataLabelsKeys3["RED_CARDS"] = "red_cards";
  IMostDecoratedDataLabelsKeys3["TOTAL_CARDS"] = "total_cards";
  IMostDecoratedDataLabelsKeys3["YELLOW_CARDS"] = "yellow_cards";
})(IMostDecoratedDataLabelsKeys || (IMostDecoratedDataLabelsKeys = {}));
var ITopScorersDataLabelsKeys;
(function(ITopScorersDataLabelsKeys3) {
  ITopScorersDataLabelsKeys3["ASSISTS"] = "assists";
  ITopScorersDataLabelsKeys3["GOALS"] = "goals";
  ITopScorersDataLabelsKeys3["MINUTES"] = "minutes";
  ITopScorersDataLabelsKeys3["PENALTIES"] = "penalties";
  ITopScorersDataLabelsKeys3["PLAYED"] = "played";
  ITopScorersDataLabelsKeys3["RED_CARDS"] = "red_cards";
  ITopScorersDataLabelsKeys3["SCORED_FIRST"] = "scored_first";
  ITopScorersDataLabelsKeys3["YELLOW_CARDS"] = "yellow_cards";
  ITopScorersDataLabelsKeys3["MISSED_PENALTIES"] = "missed_penalties";
})(ITopScorersDataLabelsKeys || (ITopScorersDataLabelsKeys = {}));
var Movement;
(function(Movement3) {
  Movement3["UP"] = "UP";
  Movement3["DOWN"] = "DOWN";
  Movement3["NONE"] = "NONE";
})(Movement || (Movement = {}));
var OddsMarketTypes;
(function(OddsMarketTypes3) {
  OddsMarketTypes3["ONETWO"] = "12";
  OddsMarketTypes3["ONEXTWO"] = "1x2";
  OddsMarketTypes3["OVER_UNDER"] = "OVER_UNDER";
  OddsMarketTypes3["DOUBLE_CHANCE"] = "DOUBLE_CHANCE";
  OddsMarketTypes3["BOTH_TO_SCORE"] = "BOTH_TO_SCORE";
  OddsMarketTypes3["DRAW_NO_BET"] = "DRAW_NO_BET";
  OddsMarketTypes3["FIRST_TEAM_TO_SCORE"] = "FIRST_TEAM_TO_SCORE";
  OddsMarketTypes3["GAME_HANDICAP"] = "GAME_HANDICAP";
  OddsMarketTypes3["FIRST_HALF"] = "FIRST_HALF";
  OddsMarketTypes3["SECOND_HALF"] = "SECOND_HALF";
  OddsMarketTypes3["FULL_TIME"] = "FULL_TIME";
  OddsMarketTypes3["FIRST_HALF_GOALS"] = "FIRST_HALF_GOALS";
  OddsMarketTypes3["CORRECT_SCORE"] = "CORRECT_SCORE";
  OddsMarketTypes3["FIRST_PLAYER_TO_SCORE"] = "FIRST_PLAYER_TO_SCORE";
  OddsMarketTypes3["PLAYER_TO_SCORE_DURING_GAME"] = "PLAYER_TO_SCORE_DURING_GAME";
  OddsMarketTypes3["PLAYER_TO_RECEIVE_CARD"] = "PLAYER_TO_RECEIVE_CARD";
  OddsMarketTypes3["FIRST_HALF_AND_FINAL_RESULT"] = "FIRST_HALF_AND_FINAL_RESULT";
})(OddsMarketTypes || (OddsMarketTypes = {}));
var OddFormat;
(function(OddFormat3) {
  OddFormat3["FRACTIONAL"] = "FRACTIONAL";
  OddFormat3["DECIMAL"] = "DECIMAL";
  OddFormat3["MONEYLINE"] = "MONEYLINE";
})(OddFormat || (OddFormat = {}));
var OddsTypes;
(function(OddsTypes3) {
  OddsTypes3["PRE_EVENT"] = "PRE_EVENT";
  OddsTypes3["ALL"] = "ALL";
})(OddsTypes || (OddsTypes = {}));
var HeaderLabels;
(function(HeaderLabels3) {
  HeaderLabels3["OVERTIME"] = "overtime_short";
  HeaderLabels3["POINTS"] = "points_short";
  HeaderLabels3["SCORE"] = "score_short";
})(HeaderLabels || (HeaderLabels = {}));
var SocialLabels;
(function(SocialLabels3) {
  SocialLabels3["FACEBOOK"] = "facebook";
  SocialLabels3["TWITTER"] = "twitter";
  SocialLabels3["YOUTUBE"] = "youtube";
  SocialLabels3["WIKIPEDIA"] = "wikipedia";
  SocialLabels3["WEB"] = "web";
  SocialLabels3["INSTAGRAM"] = "instagram";
})(SocialLabels || (SocialLabels = {}));
var ParticipantType;
(function(ParticipantType3) {
  ParticipantType3["HOME"] = "HOME";
  ParticipantType3["AWAY"] = "AWAY";
})(ParticipantType || (ParticipantType = {}));
var TeamFormOutcomeTypes;
(function(TeamFormOutcomeTypes3) {
  TeamFormOutcomeTypes3["WIN"] = "win";
  TeamFormOutcomeTypes3["LOSS"] = "loss";
  TeamFormOutcomeTypes3["WIN_OVERTIME"] = "win_overtime";
  TeamFormOutcomeTypes3["LOSS_OVERTIME"] = "loss_overtime";
  TeamFormOutcomeTypes3["DRAW"] = "draw";
  TeamFormOutcomeTypes3["WIN_AFTER_PENALTY"] = "win_after_penalty";
  TeamFormOutcomeTypes3["LOSS_AFTER_PENALTY"] = "loss_after_penalty";
})(TeamFormOutcomeTypes || (TeamFormOutcomeTypes = {}));

// ../types/football.ts
var NameFormat;
(function(NameFormat3) {
  NameFormat3["LAST_NAME"] = "last_name";
  NameFormat3["INITIALS"] = "initials";
})(NameFormat || (NameFormat = {}));
var ScopeTypes;
(function(ScopeTypes4) {
  ScopeTypes4["FIRST_HALF"] = "FIRST_HALF";
  ScopeTypes4["SECOND_HALF"] = "SECOND_HALF";
  ScopeTypes4["ORDINARY_TIME"] = "ORDINARY_TIME";
  ScopeTypes4["FULL_TIME"] = "FULL_TIME";
  ScopeTypes4["ALL"] = "ALL";
})(ScopeTypes || (ScopeTypes = {}));
var LineupsStatus;
(function(LineupsStatus3) {
  LineupsStatus3["CONFIRMED"] = "CONFIRMED";
  LineupsStatus3["UNCONFIRMED"] = "UNCONFIRMED";
  LineupsStatus3["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(LineupsStatus || (LineupsStatus = {}));
var EventTypeCode;
(function(EventTypeCode3) {
  EventTypeCode3["YELLOW_CARD_RED"] = "YELLOW_RED_CARD";
  EventTypeCode3["PENALTY_SHOOTOUT_MISSED"] = "PENALTY_SHOOTOUT_MISSED";
  EventTypeCode3["PENALTY_SHOOTOUT_SCORED"] = "PENALTY_SHOOTOUT_SCORED";
  EventTypeCode3["SUBSTITUTION"] = "SUBSTITUTION";
  EventTypeCode3["GOAL"] = "GOAL";
  EventTypeCode3["RED_CARD"] = "RED_CARD";
  EventTypeCode3["PENALTY_MISS"] = "PENALTY_MISS";
  EventTypeCode3["YELLOW_CARD"] = "YELLOW_CARD";
  EventTypeCode3["ASSIST"] = "ASSIST";
  EventTypeCode3["PENALTY_GOAL"] = "PENALTY_GOAL";
  EventTypeCode3["OWN_GOAL"] = "OWN_GOAL";
  EventTypeCode3["DISALLOWED_GOAL"] = "DISALLOWED_GOAL";
  EventTypeCode3["DISALLOWED_MISSED_PENALTY"] = "DISALLOWED_MISSED_PENALTY";
  EventTypeCode3["DISALLOWED_PENALTY"] = "DISALLOWED_PENALTY";
  EventTypeCode3["DISALLOWED_OWN_GOAL"] = "DISALLOWED_OWN_GOAL";
  EventTypeCode3["KICKOFF"] = "KICKOFF";
  EventTypeCode3["HALFTIME"] = "HALFTIME";
  EventTypeCode3["START_SECOND_HALF"] = "START_SECOND_HALF";
  EventTypeCode3["FINISHED_FIRST_HALF"] = "FINISHED_FIRST_HALF";
  EventTypeCode3["FINISHED_AFTER_EXTRA_TIME"] = "FINISHED_AFTER_EXTRA_TIME";
  EventTypeCode3["FINISHED_AFTER_PENALTIES"] = "FINISHED_AFTER_PENALTIES";
  EventTypeCode3["OVERTIME_FIRST_HALF"] = "OVERTIME_FIRST_HALF";
  EventTypeCode3["OVERTIME_FIRST_HALF_END"] = "OVERTIME_FIRST_HALF_END";
  EventTypeCode3["OVERTIME_SECOND_HALF"] = "OVERTIME_SECOND_HALF";
  EventTypeCode3["INJURY_TIME"] = "INJURY_TIME";
  EventTypeCode3["FINISHED"] = "FINISHED";
})(EventTypeCode || (EventTypeCode = {}));

// ../types/basketball.ts
var AllTeamNameTypes;
(function(AllTeamNameTypes3) {
  AllTeamNameTypes3["threeLetterCode"] = "threeLetterCode";
  AllTeamNameTypes3["shortName"] = "shortName";
})(AllTeamNameTypes || (AllTeamNameTypes = {}));

// ../types/multisportApi.ts
var SportTypes;
(function(SportTypes3) {
  SportTypes3["ALL"] = "all";
  SportTypes3["FOOTBALL"] = "football";
  SportTypes3["BASKETBALL"] = "basketball";
  SportTypes3["TENNIS"] = "tennis";
  SportTypes3["CYCLING"] = "cycling";
  SportTypes3["HANDBALL"] = "handball";
  SportTypes3["ICE_HOCKEY"] = "ice_hockey";
  SportTypes3["MOTORSPORTS"] = "motorsports";
  SportTypes3["RUGBY_LEAGUE"] = "rugby_league";
  SportTypes3["CRICKET"] = "cricket";
  SportTypes3["ROLLER_HOCKEY"] = "roller_hockey";
})(SportTypes || (SportTypes = {}));
var StatusType;
(function(StatusType3) {
  StatusType3["FINISHED"] = "FINISHED";
  StatusType3["NOT_STARTED"] = "NOT_STARTED";
  StatusType3["LIVE"] = "LIVE";
  StatusType3["INTERRUPTED"] = "INTERRUPTED";
  StatusType3["CANCELED"] = "CANCELED";
  StatusType3["UNKNOWN"] = "UNKNOWN";
})(StatusType || (StatusType = {}));
var TennisCode;
(function(TennisCode3) {
  TennisCode3["GAME_SCORE"] = "gamescore";
  TennisCode3["SET_1"] = "set1";
  TennisCode3["SET_2"] = "set2";
  TennisCode3["SET_3"] = "set3";
  TennisCode3["SET_4"] = "set4";
  TennisCode3["SET_5"] = "set5";
  TennisCode3["SET_6"] = "set6";
})(TennisCode || (TennisCode = {}));
var WinnerType;
(function(WinnerType3) {
  WinnerType3["YES"] = "YES";
  WinnerType3["NO"] = "NO";
  WinnerType3["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(WinnerType || (WinnerType = {}));

// src/atoms/SMPSportIcon.tsx
var SMPSportIcon = ({ sport }) => {
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    style: {
      backgroundImage: `url("${getIconAsBgImage(`${sport === SportTypes.ALL ? "blue-check" : sport}`)}")`,
      height: "16px",
      width: "16px",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      padding: 0
    }
  });
};

// src/atoms/SMPCountBadge.tsx
var SMPCountBadge = ({ count }) => {
  return /* @__PURE__ */ React.createElement(SMPText, {
    weight: "700",
    style: {
      backgroundColor: "var(--colors-green500)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "14px",
      borderRadius: "50%",
      lineHeight: "16px",
      padding: "3px 4px",
      color: "white",
      fontSize: "11px"
    }
  }, count);
};

// src/atoms/SMPTooltip.tsx
var ARROW_SIZE = 8;
var SMPTooltip = styled.withConfig({ componentId: "CommonWidget", displayName: "SMPTooltip" })("div", {
  position: "absolute",
  bottom: `calc(100% + ${ARROW_SIZE}px + 2px)`,
  left: "50%",
  display: "none",
  borderRadius: "$1",
  padding: "$1 $2",
  backgroundColor: "$statusBadgeBgColor",
  color: "$statusBadgeTextColor",
  whiteSpace: "nowrap",
  fontSize: "$2_5",
  zIndex: "1000",
  cursor: "pointer",
  transform: "translateX(-50%)",
  "&::after": {
    content: '""',
    position: "absolute",
    top: "100%",
    left: "50%",
    border: `${ARROW_SIZE}px solid transparent`,
    borderTopColor: "$statusBadgeBgColor",
    transform: "translateX(-50%)",
    pointerEvents: "none"
  }
});

// src/atoms/SMPStatsWrapper.tsx
var SMPStatsWrapper = styled.withConfig({ componentId: "H2hWidget", displayName: "SMPStatsWrapper" })("div", {
  px: `calc(10px + $2)`,
  bc: "$sportEntityContainerPrimaryBgColor"
});

// src/atoms/SMPLoaderForStitchesBug.tsx
import React3 from "react";
var spinner2 = keyframes({
  to: {
    transform: "rotate(360deg)"
  }
});
var Container = styled("div", {
  position: "relative"
});
var Content = styled("div", {
  transition: "opacity 0.3s ease-in-out"
});
var Loader = styled("div", {
  position: "absolute",
  top: "50%",
  left: "50%",
  borderStyle: "solid",
  borderRadius: "50%",
  animation: `${spinner2} 1s linear infinite`,
  pointerEvents: "none",
  zIndex: 2,
  width: "34px",
  height: "34px",
  color: "var(--colors-pillActiveBackgroundColor)"
});
var SMPOpacitorContainer = ({ isLoading, children }) => {
  return /* @__PURE__ */ React3.createElement(Container, {
    className: "opacitor-container"
  }, /* @__PURE__ */ React3.createElement(Content, {
    style: { opacity: isLoading ? 0.01 : 1 }
  }, children), isLoading && /* @__PURE__ */ React3.createElement(Loader, null));
};

// src/atoms/icons/WebIcon.tsx
var WebIcon = ({ onClick }) => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "16",
    height: "16",
    onClick,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip0_4524_232524)"
  }, /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99961 1.6501C4.4926 1.6501 1.64961 4.49309 1.64961 8.0001C1.64961 11.5071 4.4926 14.3501 7.99961 14.3501C11.5066 14.3501 14.3496 11.5071 14.3496 8.0001C14.3496 4.49309 11.5066 1.6501 7.99961 1.6501ZM0.349609 8.0001C0.349609 3.77512 3.77463 0.350098 7.99961 0.350098C12.2246 0.350098 15.6496 3.77512 15.6496 8.0001C15.6496 12.2251 12.2246 15.6501 7.99961 15.6501C3.77463 15.6501 0.349609 12.2251 0.349609 8.0001Z",
    fill: "currentColor"
  }), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54466 0.535859C7.79739 0.288177 8.20183 0.288177 8.45456 0.535859C10.5003 2.54068 11.6496 5.21249 11.6496 8.0001C11.6496 10.7877 10.5003 13.4595 8.45456 15.4643C8.20183 15.712 7.79739 15.712 7.54466 15.4643C5.49892 13.4595 4.34961 10.7877 4.34961 8.0001C4.34961 5.21249 5.49892 2.54068 7.54466 0.535859ZM7.99961 1.94121C6.48163 3.64404 5.64961 5.78711 5.64961 8.0001C5.64961 10.2131 6.48163 12.3562 7.99961 14.059C9.51759 12.3562 10.3496 10.2131 10.3496 8.0001C10.3496 5.78711 9.51759 3.64404 7.99961 1.94121Z",
    fill: "currentColor"
  }), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.349609 8.0001C0.349609 7.64111 0.640624 7.3501 0.999609 7.3501H14.9996C15.3586 7.3501 15.6496 7.64111 15.6496 8.0001C15.6496 8.35908 15.3586 8.6501 14.9996 8.6501H0.999609C0.640624 8.6501 0.349609 8.35908 0.349609 8.0001Z",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", {
    id: "clip0_4524_232524"
  }, /* @__PURE__ */ React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/FacebookIcon.tsx
var FacebookIcon = ({ onClick }) => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "16",
    height: "16",
    onClick,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip0_4524_232549)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M6.38628 16.2087V8.45876H4V5.69368H6.38628V3.65482C6.38628 1.28915 7.81643 0 9.91829 0C10.925 0 11.7671 0.0753254 12.0183 0.108502V2.58125L10.5834 2.58196C9.44059 2.58196 9.22026 3.12718 9.22026 3.92755L9.20228 5.69226H11.9471L11.5915 8.45734H9.20228V16.2087H6.38628Z",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", {
    id: "clip0_4524_232549"
  }, /* @__PURE__ */ React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/InstagramIcon.tsx
var InstagramIcon = ({ onClick }) => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "16",
    height: "16",
    onClick,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip0_4524_232548)"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip1_4524_232548)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M8 1.44062C10.1375 1.44062 10.3906 1.45 11.2313 1.4875C12.0125 1.52187 12.4344 1.65313 12.7156 1.7625C13.0875 1.90625 13.3563 2.08125 13.6344 2.35938C13.9156 2.64063 14.0875 2.90625 14.2313 3.27813C14.3406 3.55938 14.4719 3.98437 14.5063 4.7625C14.5438 5.60625 14.5531 5.85938 14.5531 7.99375C14.5531 10.1313 14.5438 10.3844 14.5063 11.225C14.4719 12.0063 14.3406 12.4281 14.2313 12.7094C14.0875 13.0813 13.9125 13.35 13.6344 13.6281C13.3531 13.9094 13.0875 14.0813 12.7156 14.225C12.4344 14.3344 12.0094 14.4656 11.2313 14.5C10.3875 14.5375 10.1344 14.5469 8 14.5469C5.8625 14.5469 5.60938 14.5375 4.76875 14.5C3.9875 14.4656 3.56563 14.3344 3.28438 14.225C2.9125 14.0813 2.64375 13.9063 2.36563 13.6281C2.08438 13.3469 1.9125 13.0813 1.76875 12.7094C1.65938 12.4281 1.52813 12.0031 1.49375 11.225C1.45625 10.3813 1.44688 10.1281 1.44688 7.99375C1.44688 5.85625 1.45625 5.60312 1.49375 4.7625C1.52813 3.98125 1.65938 3.55938 1.76875 3.27813C1.9125 2.90625 2.0875 2.6375 2.36563 2.35938C2.64688 2.07813 2.9125 1.90625 3.28438 1.7625C3.56563 1.65313 3.99063 1.52187 4.76875 1.4875C5.60938 1.45 5.8625 1.44062 8 1.44062ZM8 0C5.82813 0 5.55625 0.009375 4.70313 0.046875C3.85313 0.084375 3.26875 0.221875 2.7625 0.41875C2.23438 0.625 1.7875 0.896875 1.34375 1.34375C0.896875 1.7875 0.625 2.23438 0.41875 2.75938C0.221875 3.26875 0.084375 3.85 0.046875 4.7C0.009375 5.55625 0 5.82813 0 8C0 10.1719 0.009375 10.4438 0.046875 11.2969C0.084375 12.1469 0.221875 12.7313 0.41875 13.2375C0.625 13.7656 0.896875 14.2125 1.34375 14.6563C1.7875 15.1 2.23438 15.375 2.75938 15.5781C3.26875 15.775 3.85 15.9125 4.7 15.95C5.55313 15.9875 5.825 15.9969 7.99688 15.9969C10.1688 15.9969 10.4406 15.9875 11.2938 15.95C12.1438 15.9125 12.7281 15.775 13.2344 15.5781C13.7594 15.375 14.2063 15.1 14.65 14.6563C15.0938 14.2125 15.3688 13.7656 15.5719 13.2406C15.7688 12.7313 15.9063 12.15 15.9438 11.3C15.9813 10.4469 15.9906 10.175 15.9906 8.00313C15.9906 5.83125 15.9813 5.55938 15.9438 4.70625C15.9063 3.85625 15.7688 3.27188 15.5719 2.76563C15.375 2.23438 15.1031 1.7875 14.6563 1.34375C14.2125 0.9 13.7656 0.625 13.2406 0.421875C12.7313 0.225 12.15 0.0875 11.3 0.05C10.4438 0.009375 10.1719 0 8 0Z",
    fill: "currentColor"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8 3.89062C5.73125 3.89062 3.89062 5.73125 3.89062 8C3.89062 10.2688 5.73125 12.1094 8 12.1094C10.2688 12.1094 12.1094 10.2688 12.1094 8C12.1094 5.73125 10.2688 3.89062 8 3.89062ZM8 10.6656C6.52813 10.6656 5.33437 9.47188 5.33437 8C5.33437 6.52813 6.52813 5.33437 8 5.33437C9.47188 5.33437 10.6656 6.52813 10.6656 8C10.6656 9.47188 9.47188 10.6656 8 10.6656Z",
    fill: "currentColor"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13.2312 3.72793C13.2312 4.25918 12.8 4.68731 12.2719 4.68731C11.7406 4.68731 11.3125 4.25606 11.3125 3.72793C11.3125 3.19668 11.7438 2.76855 12.2719 2.76855C12.8 2.76855 13.2312 3.19981 13.2312 3.72793Z",
    fill: "currentColor"
  }))), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", {
    id: "clip0_4524_232548"
  }, /* @__PURE__ */ React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("clipPath", {
    id: "clip1_4524_232548"
  }, /* @__PURE__ */ React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/TwitterIcon.tsx
var TwitterIcon = ({ onClick }) => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "16",
    height: "16",
    onClick,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip0_4524_232550)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M9.52176 6.77493L15.4782 0H14.0667L8.89513 5.88267L4.76443 0H0L6.2462 8.89562L0 16H1.41157L6.87288 9.78789L11.2356 16H16L9.52176 6.77493ZM7.58843 8.97398L6.95557 8.08847L1.91998 1.03971H4.088L8.15202 6.72775L8.78489 7.61411L14.0675 15.0075H11.8996L7.58843 8.97398Z",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", {
    id: "clip0_4524_232550"
  }, /* @__PURE__ */ React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/YouTubeIcon.tsx
var YouTubeIcon = ({ onClick }) => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "16",
    height: "16",
    onClick,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip0_4524_232551)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M15.8406 4.8002C15.8406 4.8002 15.6844 3.69707 15.2031 3.2127C14.5938 2.5752 13.9125 2.57207 13.6 2.53457C11.3625 2.37207 8.00313 2.37207 8.00313 2.37207H7.99687C7.99687 2.37207 4.6375 2.37207 2.4 2.53457C2.0875 2.57207 1.40625 2.5752 0.796875 3.2127C0.315625 3.69707 0.1625 4.8002 0.1625 4.8002C0.1625 4.8002 0 6.09707 0 7.39082V8.60332C0 9.89707 0.159375 11.1939 0.159375 11.1939C0.159375 11.1939 0.315625 12.2971 0.79375 12.7814C1.40313 13.4189 2.20313 13.3971 2.55938 13.4658C3.84063 13.5877 8 13.6252 8 13.6252C8 13.6252 11.3625 13.6189 13.6 13.4596C13.9125 13.4221 14.5938 13.4189 15.2031 12.7814C15.6844 12.2971 15.8406 11.1939 15.8406 11.1939C15.8406 11.1939 16 9.90019 16 8.60332V7.39082C16 6.09707 15.8406 4.8002 15.8406 4.8002ZM6.34688 10.0752V5.57832L10.6687 7.83457L6.34688 10.0752Z",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", {
    id: "clip0_4524_232551"
  }, /* @__PURE__ */ React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/TeamImagePlaceholderIcon.tsx
var TeamImagePlaceholderIcon = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    className: "w-6 h-6",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("mask", {
    id: "mask0_5331_311332",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, /* @__PURE__ */ React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "#D9D9D9"
  })), /* @__PURE__ */ React.createElement("g", {
    mask: "url(#mask0_5331_311332)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H8L12 0L16 4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V6H5V20ZM6 18H18L14.25 13L11.25 17L9 14L6 18ZM10.1 4H13.9L12 2.1L10.1 4Z",
    fill: "#BFBFBF"
  })));
};

// src/atoms/icons/ArrowLeftIcon.tsx
import React4 from "react";
var ArrowLeftIcon = ({ onClick }) => {
  return /* @__PURE__ */ React4.createElement("svg", {
    className: "h-4 w-2 text-dropdownArrowIconColor hover:text-pillActiveBackgroundColor",
    onClick
  }, /* @__PURE__ */ React4.createElement("g", {
    transform: "translate(-19.599 -9.969)"
  }, /* @__PURE__ */ React4.createElement("g", {
    transform: "translate(27.599 9.969) rotate(90)"
  }, /* @__PURE__ */ React4.createElement("path", {
    d: "M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/ArrowRightIcon.tsx
import React5 from "react";
var ArrowRightIcon = ({ onClick }) => {
  return /* @__PURE__ */ React5.createElement("svg", {
    className: "h-4 w-2 text-dropdownArrowIconColor hover:text-pillActiveBackgroundColor",
    onClick
  }, /* @__PURE__ */ React5.createElement("g", {
    transform: "translate(0 14.041) rotate(-90)"
  }, /* @__PURE__ */ React5.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /* @__PURE__ */ React5.createElement("path", {
    d: "M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/CalendarIcon.tsx
import React6 from "react";
var CalendarIcon = ({ onClick }) => {
  return /* @__PURE__ */ React6.createElement("svg", {
    className: "h-4 w-4 text-dropdownCalendarIconColor hover:text-pillActiveBackgroundColor",
    onClick
  }, /* @__PURE__ */ React6.createElement("g", {
    transform: "scale(1.2)"
  }, /* @__PURE__ */ React6.createElement("g", null, /* @__PURE__ */ React6.createElement("path", {
    d: "M10.714,1.286H9.429V.429a.429.429,0,0,0-.857,0v.857H3.429V.429a.429.429,0,1,0-.857,0v.857H1.286A1.286,1.286,0,0,0,0,2.571v8.143A1.286,1.286,0,0,0,1.286,12h9.429A1.286,1.286,0,0,0,12,10.714V2.571A1.286,1.286,0,0,0,10.714,1.286Zm.429,9.429a.429.429,0,0,1-.429.429H1.286a.429.429,0,0,1-.429-.429V5.143H11.143Zm0-6.429H.857V2.571a.429.429,0,0,1,.429-.429H2.571V3a.429.429,0,0,0,.857,0V2.143H8.571V3a.429.429,0,0,0,.857,0V2.143h1.286a.429.429,0,0,1,.429.429V4.286Z",
    fill: "currentColor"
  })), /* @__PURE__ */ React6.createElement("g", {
    transform: "translate(2.143 6)"
  }, /* @__PURE__ */ React6.createElement("path", {
    d: "M86.619,238.933h-.857a.429.429,0,1,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-85.333 -238.933)",
    fill: "currentColor"
  })), /* @__PURE__ */ React6.createElement("g", {
    transform: "translate(5.143 6)"
  }, /* @__PURE__ */ React6.createElement("path", {
    d: "M206.086,238.933h-.857a.429.429,0,0,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-204.8 -238.933)",
    fill: "currentColor"
  })), /* @__PURE__ */ React6.createElement("g", {
    transform: "translate(8.143 6)"
  }, /* @__PURE__ */ React6.createElement("path", {
    d: "M325.553,238.933H324.7a.429.429,0,0,0,0,.857h.857a.429.429,0,0,0,0-.857Z",
    transform: "translate(-324.267 -238.933)",
    fill: "currentColor"
  })), /* @__PURE__ */ React6.createElement("g", {
    transform: "translate(2.143 7.714)"
  }, /* @__PURE__ */ React6.createElement("path", {
    d: "M86.619,307.2h-.857a.429.429,0,1,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-85.333 -307.2)",
    fill: "currentColor"
  })), /* @__PURE__ */ React6.createElement("g", {
    transform: "translate(5.143 7.714)"
  }, /* @__PURE__ */ React6.createElement("path", {
    d: "M206.086,307.2h-.857a.429.429,0,0,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-204.8 -307.2)",
    fill: "currentColor"
  })), /* @__PURE__ */ React6.createElement("g", {
    transform: "translate(8.143 7.714)"
  }, /* @__PURE__ */ React6.createElement("path", {
    d: "M325.553,307.2H324.7a.429.429,0,0,0,0,.857h.857a.429.429,0,0,0,0-.857Z",
    transform: "translate(-324.267 -307.2)",
    fill: "currentColor"
  })), /* @__PURE__ */ React6.createElement("g", {
    transform: "translate(2.143 9.429)"
  }, /* @__PURE__ */ React6.createElement("path", {
    d: "M86.619,375.467h-.857a.429.429,0,1,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-85.333 -375.467)",
    fill: "currentColor"
  })), /* @__PURE__ */ React6.createElement("g", {
    transform: "translate(5.143 9.429)"
  }, /* @__PURE__ */ React6.createElement("path", {
    d: "M206.086,375.467h-.857a.429.429,0,0,0,0,.857h.857a.429.429,0,1,0,0-.857Z",
    transform: "translate(-204.8 -375.467)",
    fill: "currentColor"
  })), /* @__PURE__ */ React6.createElement("g", {
    transform: "translate(8.143 9.429)"
  }, /* @__PURE__ */ React6.createElement("path", {
    d: "M325.553,375.467H324.7a.429.429,0,0,0,0,.857h.857a.429.429,0,0,0,0-.857Z",
    transform: "translate(-324.267 -375.467)",
    fill: "currentColor"
  }))));
};

// src/atoms/icons/ArrowDownIcon.tsx
import React7 from "react";
import { classNames } from "@sportal365/smp-widget-utils";
var ArrowDownIcon = ({ isActive, onClick }) => {
  return /* @__PURE__ */ React7.createElement("svg", {
    className: classNames({
      "w-6 h-4 text-selectButtonSecondaryColor": true,
      "text-pillActiveBackgroundColor rotate-[180deg]": isActive
    }),
    onClick
  }, /* @__PURE__ */ React7.createElement("g", {
    transform: "translate(-4.599 -4.969)"
  }, /* @__PURE__ */ React7.createElement("g", {
    transform: "translate(10.599 10.969) rotate(0)"
  }, /* @__PURE__ */ React7.createElement("path", {
    d: "M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
};

// src/molecules/GameScore/GameScore.tsx
import { useContext, useMemo } from "react";

// ../constants/widgetIds.ts
var BASKETBALL_STANDINGS = "basketball-standings";

// ../constants/playoff.ts
var SMALL_FINAL = "Small Final";
var resultTypeForDisplaying = "TOTALSCORE";
var FINAL = "Final";

// src/atoms/icons/SMPCupIcon.tsx
var SMPCupIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("image", {
    width: "24",
    height: "24",
    xlinkHref: "data:image/svg+xml;base64,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"
  }));
};

// ../constants/sportType.ts
var Sports;
(function(Sports3) {
  Sports3["FOOTBALL"] = "football";
  Sports3["BASKETBALL"] = "basketball";
  Sports3["TENNIS"] = "tennis";
  Sports3["MULTISPORT"] = "multisport";
  Sports3["ICE_HOCKEY"] = "ice-hockey";
})(Sports || (Sports = {}));
var FootballStandingsElements;
(function(FootballStandingsElements3) {
  FootballStandingsElements3["MATCHES_PLAYED"] = "matches_played";
  FootballStandingsElements3["MATCHES_WON"] = "matches_won";
  FootballStandingsElements3["MATCH_LOSSES"] = "match_losses";
  FootballStandingsElements3["MATCH_DRAW"] = "match_draw";
  FootballStandingsElements3["GOAL_DIFFERENCE"] = "goal_difference";
  FootballStandingsElements3["POINTS"] = "points";
  FootballStandingsElements3["TEAM_FORM"] = "team_form";
})(FootballStandingsElements || (FootballStandingsElements = {}));
var TableVariants;
(function(TableVariants3) {
  TableVariants3["STATS"] = "stats_table";
  TableVariants3["STANDINGS"] = "standings";
  TableVariants3["DEFAULT"] = "default";
})(TableVariants || (TableVariants = {}));
var validForCustomSportsStyles = ["ice-hockey"];

// src/molecules/GameScore/GameScore.tsx
var getTextColor = (sport, showAggEvents, customColor) => {
  if (customColor) {
    return customColor;
  }
  if (validForCustomSportsStyles.includes(sport || "")) {
    return showAggEvents ? "var(--colors-gray0)" : "var(--colors-hiContrast)";
  }
  return "var(--colors-hiContrast)";
};
var GameScore = ({
  homeTeamScore,
  awayTeamScore,
  matchLink,
  matchUrlTarget,
  verticalAlign,
  fontWeight,
  variant = "contrast",
  homeTeamWeight,
  awayTeamWeight,
  handleEventClick,
  eventId,
  width,
  fontSize,
  delimiter = ":",
  header,
  penaltyShootoutScore,
  groupName,
  sport,
  showAggEvents,
  color
}) => {
  var _a2, _b, _c, _d2;
  const { dataWidgetId, dataWidgetSport } = useContext(ConfigContext);
  const actualHomeTeamWeight = (_a2 = homeTeamWeight != null ? homeTeamWeight : fontWeight) != null ? _a2 : Number(homeTeamScore) > Number(awayTeamScore) ? "700" : "400";
  const actualAwayTeamWeight = (_b = awayTeamWeight != null ? awayTeamWeight : fontWeight) != null ? _b : Number(awayTeamScore) > Number(homeTeamScore) ? "700" : "400";
  const style = { width: "auto", minWidth: void 0, maxWidth: void 0 };
  const textColorStyle = getTextColor(sport, showAggEvents, color);
  const textStyles = variant === "accentText" ? { fontSize, position: "relative" } : { fontSize, position: "relative", color: textColorStyle };
  if (width) {
    style.width = void 0;
    style.minWidth = width;
    style.maxWidth = parseInt(width) * 2 + "px";
  }
  const scoresWithPenaltyIndicator = useMemo(() => {
    if (typeof (penaltyShootoutScore == null ? void 0 : penaltyShootoutScore.home) === "number" && typeof penaltyShootoutScore.away === "number") {
      return {
        home: /* @__PURE__ */ React.createElement(React.Fragment, null, homeTeamScore, penaltyShootoutScore.home > penaltyShootoutScore.away && /* @__PURE__ */ React.createElement(Asterisk, null)),
        away: /* @__PURE__ */ React.createElement(React.Fragment, null, awayTeamScore, penaltyShootoutScore.away > penaltyShootoutScore.home && /* @__PURE__ */ React.createElement(Asterisk, null))
      };
    }
    return { home: homeTeamScore, away: awayTeamScore };
  }, [awayTeamScore, homeTeamScore, penaltyShootoutScore == null ? void 0 : penaltyShootoutScore.away, penaltyShootoutScore == null ? void 0 : penaltyShootoutScore.home]);
  const isPale = useMemo(() => {
    if (dataWidgetSport === Sports.BASKETBALL && dataWidgetId !== BASKETBALL_STANDINGS) {
      return {
        home: Number(actualHomeTeamWeight) < 700,
        away: Number(actualAwayTeamWeight) < 700
      };
    }
    return {
      home: Number(awayTeamScore) > Number(homeTeamScore),
      away: Number(homeTeamScore) > Number(awayTeamScore)
    };
  }, [dataWidgetSport, dataWidgetId, awayTeamScore, homeTeamScore, actualHomeTeamWeight, actualAwayTeamWeight]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, verticalAlign ? /* @__PURE__ */ React.createElement("a", {
    href: matchLink,
    target: matchUrlTarget,
    onClick: () => handleEventClick && eventId && handleEventClick(eventId),
    style: { display: "inline-flex", textDecoration: "none" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "column",
    align: "center",
    justify: "spaceBetween",
    style
  }, header !== void 0 && /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { width: "100%", height: "1em", fontSize: "$2_5" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "2_5",
    textAlign: "center",
    weight: "400",
    variant: "scoreHeader",
    pale: true
  }, header)), /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center",
    css: { height: "$5_5" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant,
    size: "3",
    weight: actualHomeTeamWeight,
    style: textStyles,
    pale: isPale.home
  }, (_c = scoresWithPenaltyIndicator.home) != null ? _c : "-")), Number(homeTeamScore) > Number(awayTeamScore) && groupName === FINAL && sport === Sports.ICE_HOCKEY ? /* @__PURE__ */ React.createElement(SMPFlex, {
    style: {
      position: "absolute",
      left: "100%",
      top: "28%",
      transform: "translate(-50%, -50%)"
    }
  }, /* @__PURE__ */ React.createElement(SMPCupIcon, {
    width: "5",
    height: "5"
  })) : null, /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center",
    css: { height: "$5_5" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant,
    size: "3",
    weight: actualAwayTeamWeight,
    style: textStyles,
    pale: isPale.away
  }, (_d2 = scoresWithPenaltyIndicator.away) != null ? _d2 : "-")), Number(awayTeamScore) > Number(homeTeamScore) && groupName === FINAL && sport === Sports.ICE_HOCKEY ? /* @__PURE__ */ React.createElement(SMPFlex, {
    style: {
      position: "absolute",
      left: "100%",
      top: "71%",
      transform: "translate(-50%, -50%)"
    }
  }, /* @__PURE__ */ React.createElement(SMPCupIcon, {
    width: "5",
    height: "5"
  })) : null)) : /* @__PURE__ */ React.createElement("a", {
    href: matchLink,
    target: matchUrlTarget,
    style: { display: "inline-flex", textDecoration: "none" },
    onClick: () => handleEventClick && eventId && handleEventClick(eventId)
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center",
    justify: "spaceAround"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: fontSize ? 3 : 6,
    weight: fontWeight != null ? fontWeight : "900"
  }, homeTeamScore, " ", delimiter, " ", awayTeamScore))));
};
var Asterisk = () => {
  return /* @__PURE__ */ React.createElement("span", {
    style: { position: "absolute", left: "8px" }
  }, "*");
};

// ../constants/generic.ts
var GenericSize;
(function(GenericSize2) {
  GenericSize2["LARGE"] = "large";
  GenericSize2["DEFAULT"] = "default";
  GenericSize2["SMALL"] = "small";
  GenericSize2["EXTRA_SMALL"] = "extra-small";
})(GenericSize || (GenericSize = {}));
var GenericAlign;
(function(GenericAlign2) {
  GenericAlign2["LEFT"] = "left";
  GenericAlign2["RIGHT"] = "right";
})(GenericAlign || (GenericAlign = {}));
var GenericLayout;
(function(GenericLayout2) {
  GenericLayout2["HORIZONTAL"] = "horizontal";
  GenericLayout2["VERTICAL"] = "vertical";
  GenericLayout2["VERTICAL_CONDENSED"] = "vertical-condensed";
})(GenericLayout || (GenericLayout = {}));
var INLINE_ODDS_BREAKPOINT = 900;
var FILTERS_BREAKPOINT = 968;
var TABULAR_WIDGET_BREAKPOINT_1 = 768;
var TABULAR_WIDGET_BREAKPOINT_2 = 393;
var MAX_MOBILE_WIDTH = 429;
var STANDINGS_DATA_ELEMENTS_BREAKPOINT = MAX_MOBILE_WIDTH;
var KNOCKOUT_GAME_MIN_WIDTH = 250;

// src/molecules/MatchScore/MatchScore.tsx
var MatchScore = ({
  homeTeamScore,
  awayTeamScore,
  matchLink,
  matchUrlTarget,
  fontWeight,
  variant = "contrast",
  homeTeamTiebreak,
  awayTeamTiebreak,
  homeTeamWeight,
  awayTeamWeight,
  handleEventClick,
  eventId,
  isMobile,
  header,
  width
}) => {
  const weight = fontWeight ? fontWeight : "700";
  const teamScoreHeight = width >= TABULAR_WIDGET_BREAKPOINT_2 ? "$5_5" : "calc(1em + 8px)";
  const homeTeamScorePassed = homeTeamScore !== void 0;
  const awayTeamScorePassed = awayTeamScore !== void 0;
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    justify: "start",
    css: {
      "@bp0": { width: "20px" },
      "@bp2": { width: isMobile ? "20px" : "26px" }
    }
  }, /* @__PURE__ */ React.createElement("a", {
    href: matchLink,
    target: matchUrlTarget,
    onClick: () => handleEventClick && eventId && handleEventClick(eventId),
    style: { display: "inline-flex", width: "100%", textDecoration: "none" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    style: { width: "100%" },
    variant: "column",
    align: "center",
    justify: "spaceAround"
  }, header !== void 0 && /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { width: "100%", height: "1em", fontSize: "$2_5" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "2_5",
    textAlign: "center",
    weight: "400",
    variant: "scoreHeader",
    pale: true
  }, header)), homeTeamScorePassed && /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center",
    justify: "center",
    style: { width: "100%" },
    css: { height: teamScoreHeight, fontSize: "$3" }
  }, homeTeamScore ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SMPText, {
    variant,
    size: "3",
    weight: homeTeamWeight != null ? homeTeamWeight : weight,
    pale: Number(homeTeamWeight != null ? homeTeamWeight : weight) < 700
  }, homeTeamScore), homeTeamTiebreak && /* @__PURE__ */ React.createElement(SMPText, {
    variant,
    size: "1",
    weight: homeTeamWeight != null ? homeTeamWeight : weight,
    css: { mb: "1em" },
    pale: Number(homeTeamWeight != null ? homeTeamWeight : weight) < 700
  }, homeTeamTiebreak)) : /* @__PURE__ */ React.createElement(SMPText, {
    variant,
    size: "3",
    pale: true
  }, "-")), awayTeamScorePassed && /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center",
    justify: "center",
    style: { width: "100%" },
    css: { height: teamScoreHeight, fontSize: "$3" }
  }, awayTeamScore ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SMPText, {
    variant,
    size: "3",
    weight: awayTeamWeight != null ? awayTeamWeight : weight,
    pale: Number(awayTeamWeight != null ? awayTeamWeight : weight) < 700
  }, awayTeamScore), awayTeamTiebreak && /* @__PURE__ */ React.createElement(SMPText, {
    variant,
    size: "1",
    weight: awayTeamWeight != null ? awayTeamWeight : weight,
    css: { mb: "1em" },
    pale: Number(awayTeamWeight != null ? awayTeamWeight : weight) < 700
  }, awayTeamTiebreak)) : /* @__PURE__ */ React.createElement(SMPText, {
    variant,
    size: "3",
    pale: true
  }, "-")))));
};

// src/molecules/GameTeam/GameTeam.tsx
import { classNames as classNames2, setNationalParticipantBorder, setParticipantBorder } from "@sportal365/smp-widget-utils";
import { useMemo as useMemo2 } from "react";

// ../constants/sportEntityVariant.ts
var VERTICAL = "vertical";
var HORIZONTAL = "horizontal";
var HORIZONTAL_REVERSE = "horizontalReverse";

// ../constants/winnerReasons.ts
var AGG = "agg";
var PEN = "pen";

// src/molecules/GameTeam/GameTeam.tsx
var getVariant = (sportEntityVariant, isMobile) => {
  if (isMobile) {
    return VERTICAL;
  }
  if (sportEntityVariant === "homeTeam") {
    return { "@initial": VERTICAL, "@bp1": HORIZONTAL_REVERSE };
  }
  if (sportEntityVariant === "awayTeam") {
    return { "@initial": VERTICAL, "@bp1": HORIZONTAL };
  }
  return { "@initial": VERTICAL, "@bp0": HORIZONTAL };
};
var toggleTooltip = (e3, show) => {
  if (e3.target instanceof HTMLElement === false) {
    return;
  }
  const winnerBadge = e3.target.closest(".winner-badge");
  if (!winnerBadge) {
    return;
  }
  const winnerBadgeTooltip = winnerBadge.nextElementSibling;
  if (winnerBadgeTooltip instanceof HTMLDivElement && winnerBadgeTooltip.classList.contains("winner-badge-tooltip")) {
    try {
      winnerBadgeTooltip.style.transform = "";
      winnerBadgeTooltip.style.display = show ? "inline-block" : "none";
      const widget = winnerBadgeTooltip.closest("[data-widget-id]") || winnerBadgeTooltip.getRootNode().firstChild;
      if (widget) {
        const winnerBadgeTooltipRect = winnerBadgeTooltip.getBoundingClientRect();
        const widgetRect = widget.getBoundingClientRect();
        if (winnerBadgeTooltipRect.right > widgetRect.right) {
          winnerBadgeTooltip.style.transform = `translateX(calc(-50% + -${winnerBadgeTooltipRect.right - widgetRect.right}px))`;
        }
      }
    } catch (e4) {
      console.error(e4);
    }
  }
};
var GameTeam = ({
  teamName,
  teamLogo,
  team,
  handleTeamClick,
  sportEntityVariant,
  teamLink,
  urlTarget,
  imageVariant,
  winnerId,
  winnerReason,
  isMobile,
  teamNamePreWrap,
  aggregateWinnerId,
  isWinner,
  textVariant,
  isNational,
  scoreDetails,
  sport,
  showAggEvents,
  showAggEventsList
}) => {
  const handleBadgeClick = (e3) => {
    e3.preventDefault();
    showAggEvents && showAggEvents(!showAggEventsList);
  };
  const winnerKnockoutBadge = useMemo2(() => {
    if (!isWinner) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("div", {
      style: { position: "relative" },
      onClick: handleBadgeClick
    }, /* @__PURE__ */ React.createElement(SMPText, {
      className: "winner-badge",
      size: "2",
      css: {
        display: "inline-flex",
        gap: "$1",
        br: "$1",
        p: "$1",
        backgroundColor: "$statusBadgeBgColor",
        color: "$statusBadgeTextColor",
        userSelect: "none"
      },
      onClick: (e3) => e3.preventDefault()
    }, AGG.toUpperCase(), /* @__PURE__ */ React.createElement("span", null, "\u2713")));
  }, [team == null ? void 0 : team.id, showAggEventsList, winnerId]);
  const winnerBadge = useMemo2(() => {
    var _a2, _b, _c, _d2, _e, _f, _g, _h;
    const teamId = team == null ? void 0 : team.id.toString();
    if (!(winnerReason === AGG && aggregateWinnerId === teamId) && !(winnerReason === PEN && winnerId === teamId)) {
      return null;
    }
    const showAdditionalInfo = !!scoreDetails;
    return /* @__PURE__ */ React.createElement("div", {
      style: { position: "relative" }
    }, /* @__PURE__ */ React.createElement(SMPText, {
      className: "winner-badge",
      size: "2",
      css: {
        display: "inline-flex",
        gap: "$1",
        br: "$1",
        p: "$1",
        backgroundColor: "$statusBadgeBgColor",
        color: "$statusBadgeTextColor",
        userSelect: "none"
      },
      onClick: (e3) => e3.preventDefault(),
      onPointerEnter: (e3) => toggleTooltip(e3, true),
      onPointerLeave: (e3) => toggleTooltip(e3, false)
    }, winnerReason == null ? void 0 : winnerReason.toUpperCase(), showAdditionalInfo && /* @__PURE__ */ React.createElement("span", null, "\u2713")), showAdditionalInfo && /* @__PURE__ */ React.createElement(SMPTooltip, {
      className: "winner-badge-tooltip"
    }, /* @__PURE__ */ React.createElement("span", {
      style: { fontWeight: winnerId === ((_a2 = scoreDetails.homeTeam) == null ? void 0 : _a2.id) && "bold" || void 0 }
    }, `${(_b = scoreDetails.homeTeam) == null ? void 0 : _b.name} ${(_d2 = (_c = scoreDetails[winnerReason === "agg" ? "aggregateScore" : "penaltyShootoutScore"]) == null ? void 0 : _c.home) != null ? _d2 : "0"}`), " - ", /* @__PURE__ */ React.createElement("span", {
      style: { fontWeight: winnerId === ((_e = scoreDetails.awayTeam) == null ? void 0 : _e.id) && "bold" || void 0 }
    }, `${(_g = (_f = scoreDetails[winnerReason === "agg" ? "aggregateScore" : "penaltyShootoutScore"]) == null ? void 0 : _f.away) != null ? _g : "0"} ${(_h = scoreDetails.awayTeam) == null ? void 0 : _h.name}`)));
  }, [aggregateWinnerId, scoreDetails, team == null ? void 0 : team.id, winnerId, winnerReason]);
  return /* @__PURE__ */ React.createElement("div", {
    onClick: () => handleTeamClick && team && handleTeamClick(team)
  }, /* @__PURE__ */ React.createElement(SMPSportEntity, {
    href: teamLink,
    target: urlTarget,
    variant: getVariant(sportEntityVariant, isMobile)
  }, /* @__PURE__ */ React.createElement(SMPImage, {
    variant: imageVariant != null ? imageVariant : "livescoreEntityLogo",
    src: teamLogo != null ? teamLogo : "",
    css: isNational ? setNationalParticipantBorder(true) : setParticipantBorder(team, teamLogo)
  }), /* @__PURE__ */ React.createElement(SMPText, {
    className: classNames2({
      "with-ellipsis": !isMobile || !!winnerBadge,
      "with-winner-badge": !!winnerBadge
    }),
    css: {
      "@bp0": { maxWidth: "100%", whiteSpace: "pre-wrap" },
      "@bp2": { maxWidth: "100%", whiteSpace: isMobile || teamNamePreWrap ? "pre-wrap" : "nowrap" },
      py: "$0"
    },
    style: {
      color: !isWinner && validForCustomSportsStyles.includes(sport || "") ? showAggEventsList ? "var(--colors-gray4)" : "var(--colors-teamLostColor)" : validForCustomSportsStyles.includes(sport || "") && showAggEventsList ? "var(--colors-gray0)" : void 0
    },
    variant: textVariant != null ? textVariant : "contrast",
    size: { "@initial": "3" },
    weight: winnerId && winnerId === (team == null ? void 0 : team.id.toString()) || isWinner ? "700" : "400"
  }, teamName), validForCustomSportsStyles.includes(sport || "") ? showAggEventsList ? void 0 : winnerKnockoutBadge : winnerBadge));
};

// src/molecules/PillTabs/PillTabs.tsx
import { useEffect, useRef } from "react";
import { scrollToHorizontally } from "@sportal365/smp-widget-utils";

// ../constants/entityTypes.ts
var TEAM_ENTITY = "team";
var USER_INTERACTION = "user_interaction";

// src/molecules/PillTabs/PillTabs.tsx
import { defaultHandleUserInteractionClick } from "@sportal365/smp-widget-utils/src/clickHandlers";

// ../constants/subscribeTypes.ts
var DROPDOWN_SELECTION_SUBSCRIBE_TYPE = "dropdownSelection";
var TAB_SELECTION_SUBSCRIBE_TYPE = "tabSelection";
var SHOW_MORE_SUBSCRIBE_TYPE = "showMore";

// src/molecules/PillTabs/PillTabs.tsx
var PillButton = styled.withConfig({ componentId: "PillTabs", displayName: "PillButton" })("button", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: 0,
  variants: {
    mode: {
      tabPill: {
        bc: "$pillBackgroundColor",
        border: "1px solid $pillBorderColor"
      },
      tabPillActive: {
        bc: "$pillActiveBackgroundColor"
      },
      tabPillDisabled: {
        bc: "$pillBackgroundColor",
        opacity: 0.5,
        pointerEvents: "none",
        border: "1px solid $pillBorderColor"
      }
    }
  },
  borderRadius: "$5",
  fontFamily: "$sans",
  lineHeight: "20px",
  "-webkit-appearance": "none",
  "-moz-appearance": "none",
  ":-ms-expand": {
    display: "none"
  },
  cursor: "pointer",
  border: "none",
  outline: "none",
  "&:hover": {
    cursor: "pointer"
  },
  "&:not(:last-child)": {
    mr: "$1"
  }
});
var PillTabs = ({
  tabs,
  selectedTab = "",
  handleTabClick,
  handleSubscriptionClick,
  mobileDropdown,
  parentRef
}) => {
  const activeTabRef = useRef(null);
  const { isMobile } = useSizeContext();
  useEffect(() => {
    scrollToHorizontally(activeTabRef == null ? void 0 : activeTabRef.current);
  }, []);
  const handleTabClickAndSendInteractionEvent = (tab) => {
    handleTabClick && handleTabClick(tab);
    defaultHandleUserInteractionClick(handleSubscriptionClick, USER_INTERACTION, TAB_SELECTION_SUBSCRIBE_TYPE);
  };
  if (mobileDropdown) {
    const activeTab = tabs.find((tab) => tab.value === selectedTab.toString());
    return /* @__PURE__ */ React.createElement("div", {
      style: { width: "100%" }
    }, /* @__PURE__ */ React.createElement(Dropdown, {
      options: tabs.map((tab) => ({ label: tab.name, value: tab.value })),
      value: activeTab ? activeTab.value : void 0,
      onChange: (value) => {
        if (value) {
          handleTabClickAndSendInteractionEvent(value);
        }
      },
      handleSubscriptionClick,
      parentRef
    }));
  }
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "tabsContainer"
  }, /* @__PURE__ */ React.createElement(SMPFlex, null, tabs.map((currentTab, index) => {
    const isActive = currentTab.value === selectedTab.toString();
    if (!(currentTab == null ? void 0 : currentTab.name)) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(PillButton, {
      key: `filter-${index}`,
      ref: isActive ? activeTabRef : void 0,
      mode: isActive ? "tabPillActive" : currentTab.disabled ? "tabPillDisabled" : "tabPill",
      style: { height: isMobile ? "32px" : "42px" }
    }, /* @__PURE__ */ React.createElement(SMPText, {
      variant: isActive ? "activeTabLabel" : "tabLabel",
      onClick: () => handleTabClickAndSendInteractionEvent(currentTab.value),
      style: {
        lineHeight: "20px",
        fontSize: isMobile ? "12px" : "14px",
        paddingInline: isMobile ? "12px" : "24px"
      }
    }, currentTab.name));
  })));
};

// src/molecules/Dropdown/Dropdown.tsx
import { defaultHandleUserInteractionClick as defaultHandleUserInteractionClick2, isMobileUserAgent } from "@sportal365/smp-widget-utils";
import { useState as useState3 } from "react";

// ../hooks/useDetectClickOutside.ts
import { useEffect as useEffect2, useRef as useRef2, useState } from "react";
function useDetectClickOutside(defaultUndefined) {
  const [isComponentVisible, setIsComponentVisible] = useState(defaultUndefined === true ? void 0 : false);
  const ref = useRef2(null);
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.composedPath()[0])) {
      setIsComponentVisible(false);
    }
  };
  useEffect2(() => {
    setIsComponentVisible(false);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  return { ref, isComponentVisible, setIsComponentVisible };
}

// src/atoms/icons/SMPArrowDownIcon.tsx
var SMPArrowDownIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, {
    css: __spreadValues({}, props.css),
    style: __spreadProps(__spreadValues({}, props.style), { width: "24px", height: "16px" }),
    onClick: props.onClick
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(-4.599 -4.969)"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(10.599 10.969) rotate(0)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
};

// src/molecules/MobileModal/MobileModal.tsx
import { useEffect as useEffect3, useState as useState2 } from "react";
var MobileModal = ({ isOpen, onClose, children }) => {
  const [isClosing, setClosing] = useState2(false);
  const [modalStyle, setModalStyle] = useState2({
    position: "fixed",
    inset: 0,
    justifyContent: "center",
    alignItems: "flex-end",
    zIndex: 1e5,
    display: "flex",
    transform: "translateY(100%)",
    transition: "transform 0.5s ease-out"
  });
  const [backdropStyle, setBackdropStyle] = useState2({
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "block",
    zIndex: 99999,
    opacity: 0,
    transition: "opacity 0.5s ease-out"
  });
  useEffect3(() => {
    if (isOpen) {
      requestAnimationFrame(() => {
        setModalStyle((prevStyle) => __spreadProps(__spreadValues({}, prevStyle), { transform: "translateY(0)" }));
        setBackdropStyle((prevStyle) => __spreadProps(__spreadValues({}, prevStyle), { opacity: 1 }));
      });
    }
  }, [isOpen]);
  const handleClose = () => {
    setClosing(true);
    setModalStyle((prevStyle) => __spreadProps(__spreadValues({}, prevStyle), { transform: "translateY(100%)" }));
    setBackdropStyle((prevStyle) => __spreadProps(__spreadValues({}, prevStyle), { opacity: 0 }));
    setTimeout(() => {
      onClose();
      setClosing(false);
    }, 500);
  };
  if (!isOpen && !isClosing)
    return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    style: backdropStyle,
    onClick: handleClose
  }), /* @__PURE__ */ React.createElement("div", {
    style: modalStyle,
    onClick: handleClose
  }, /* @__PURE__ */ React.createElement("div", {
    onClick: (e3) => e3.stopPropagation(),
    style: {
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
      backgroundColor: "white",
      overflowY: "auto",
      maxHeight: "90%",
      width: "100%",
      padding: 0,
      margin: 0
    }
  }, children)));
};

// src/molecules/Dropdown/Dropdown.tsx
var Dropdown = ({
  value = "",
  options = [],
  onChange,
  strictValueCheck = false,
  handleSubscriptionClick,
  parentRef
}) => {
  var _a2, _b, _c, _d2;
  const selectedOption = options.find((option) => {
    var _a3, _b2;
    return strictValueCheck ? ((_a3 = option == null ? void 0 : option.value) == null ? void 0 : _a3.toString()) === value : (_b2 = option == null ? void 0 : option.value) == null ? void 0 : _b2.toString().includes(value);
  });
  const { isComponentVisible, setIsComponentVisible, ref } = useDetectClickOutside();
  const isMobile = isMobileUserAgent();
  const toggleShowDropdown = () => {
    setIsComponentVisible((prevValue) => !prevValue);
  };
  const handleDateClickAndSendInteractionEvent = (optionValue) => {
    onChange && value !== optionValue && onChange(optionValue);
    setIsComponentVisible(false);
    handleSubscriptionClick && defaultHandleUserInteractionClick2(handleSubscriptionClick, USER_INTERACTION, DROPDOWN_SELECTION_SUBSCRIBE_TYPE);
  };
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    className: "dropdown-container",
    ref,
    style: {
      margin: 0,
      padding: 0,
      borderRadius: "6px",
      position: "relative",
      width: !(((_b = (_a2 = ref.current) == null ? void 0 : _a2.parentElement) == null ? void 0 : _b.classList.contains("c-MarketSelectionWrapper-OddsDisplay")) && ref.current.parentElement.classList.contains("with-values-selection")) && (parentRef == null ? void 0 : parentRef.current) && parentRef.current.clientWidth < 640 ? "100%" : void 0
    }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center",
    justify: "spaceBetween",
    onClick: toggleShowDropdown,
    style: {
      position: "relative",
      padding: "9px 12px",
      color: "var(--colors-hiContrast)",
      cursor: "pointer",
      fontWeight: "bold",
      fontFamily: "var(--fonts-primaryFontFamily)",
      lineHeight: "20px",
      border: "1px solid",
      backgroundColor: "var(--colors-pillBackgroundColor)",
      borderRadius: "6px",
      borderColor: isComponentVisible ? "var(--colors-orange500)" : "var(--colors-dropdownBorderColor)",
      gap: "8px"
    }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    style: {
      height: "100%",
      maxWidth: "85%",
      color: "var(--colors-hiContrast)",
      fontWeight: "bold",
      fontFamily: "var(--fonts-primaryFontFamily)",
      fontSize: "14px",
      lineHeight: "20px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis"
    }
  }, selectedOption == null ? void 0 : selectedOption.label), /* @__PURE__ */ React.createElement(SMPArrowDownIcon, {
    style: {
      color: isComponentVisible ? "var(--colors-orange500)" : "var(--colors-selectButtonSecondaryColor)",
      transform: isComponentVisible ? "rotate(180deg)" : "unset"
    }
  })), !isMobile ? /* @__PURE__ */ React.createElement(SMPContainer, {
    style: {
      margin: 0,
      padding: 0,
      display: isComponentVisible !== false ? "block" : "none",
      width: parentRef && ((_c = parentRef.current) == null ? void 0 : _c.clientWidth) ? ((_d2 = parentRef.current) == null ? void 0 : _d2.clientWidth) * 0.5 : 320,
      maxWidth: 320,
      maxHeight: "250px",
      position: "absolute",
      boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.10)",
      borderRadius: "6px",
      overflow: "auto",
      top: "calc(100% + 2px)",
      right: 0,
      zIndex: 1e3
    }
  }, /* @__PURE__ */ React.createElement(DropdownOptions, {
    options,
    selectedOption,
    handleDateClickAndSendInteractionEvent
  })) : /* @__PURE__ */ React.createElement(MobileModal, {
    isOpen: isComponentVisible !== false,
    onClose: () => setIsComponentVisible(false)
  }, /* @__PURE__ */ React.createElement(DropdownOptions, {
    options,
    selectedOption,
    handleDateClickAndSendInteractionEvent
  })));
};
var DropdownOptions = ({ options, selectedOption, handleDateClickAndSendInteractionEvent }) => {
  const [hoveredIndex, setHoveredIndex] = useState3();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, options.map((option, index) => {
    const activeOption = (selectedOption == null ? void 0 : selectedOption.value) == option.value;
    return /* @__PURE__ */ React.createElement(SMPContainer, {
      key: option.value,
      style: {
        margin: 0,
        backgroundColor: activeOption || index === hoveredIndex ? "var(--colors-dropdownActiveBgColor)" : "var(--colors-dropdownBtnColor)",
        color: activeOption || index === hoveredIndex ? "var(--colors-orange500)" : "var(--colors-hiContrast)",
        fontSize: "14px",
        padding: "16px",
        textAlign: "left",
        fontWeight: "bold",
        fontFamily: "var(--fonts-primaryFontFamily)",
        lineHeight: "20px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        WebkitAppearance: "none",
        MozAppearance: "none",
        cursor: "pointer",
        border: "none",
        borderBottom: "1px solid",
        borderColor: "var(--colors-selectOptionBorderColor)",
        outline: "none",
        width: "100%"
      },
      onMouseOver: () => setHoveredIndex(index),
      onMouseLeave: () => setHoveredIndex(void 0),
      onClick: () => handleDateClickAndSendInteractionEvent(option == null ? void 0 : option.value)
    }, option.label);
  }));
};

// src/molecules/FormIcon/FormIcon.tsx
var FormIcon = ({ form }) => {
  const { outcome, startTime, matchSummary } = form;
  return /* @__PURE__ */ React.createElement(Tooltip, {
    text: matchSummary,
    overlineText: startTime
  }, {
    W: /* @__PURE__ */ React.createElement(SMPWinIcon, {
      width: "3",
      height: "3"
    }),
    L: /* @__PURE__ */ React.createElement(SMPLossIcon, {
      width: "3",
      height: "3"
    }),
    D: /* @__PURE__ */ React.createElement(SMPDrawIcon, {
      width: "3",
      height: "3"
    })
  }[outcome]);
};

// src/molecules/Tooltip/Tooltip.tsx
import { useState as useState4 } from "react";
var TooltipContainer = styled.withConfig({ componentId: "CommonWidget", displayName: "TooltipContainer" })("div", {
  position: "relative"
});
var StandingsTooltipBox = styled.withConfig({
  componentId: "CommonWidget",
  displayName: "StandingsTooltipBox"
})("div", {
  position: "absolute",
  bottom: "calc(100% + 8px + 2px)",
  left: "50%",
  display: "none",
  borderRadius: "4px",
  backgroundColor: "$standingsTooltipContainerPrimaryBgColor",
  color: "$standingsTooltipContainerTextColor",
  whiteSpace: "nowrap",
  fontSize: "12px",
  zIndex: "1050",
  cursor: "pointer",
  transform: "translateX(-50%)",
  "&::after": {
    content: '""',
    position: "absolute",
    top: "100%",
    left: "50%",
    border: "8px solid transparent",
    borderTopColor: "$standingsTooltipContainerPrimaryBgColor",
    transform: "translateX(-50%)",
    pointerEvents: "none"
  }
});
var TooltipBox = styled.withConfig({ componentId: "CommonWidget", displayName: "TooltipBox" })("div", {
  zIndex: "101",
  position: "absolute",
  background: "$tooltipBackgroundColor",
  color: "#ffffff",
  padding: "$1",
  borderRadius: "$2",
  top: "-$1",
  transform: "translate(-80%, -100%)",
  transition: "display 0.5s",
  variants: {
    display: {
      none: {
        display: "none"
      },
      block: {
        display: "block"
      }
    }
  },
  defaultVariants: {
    display: "none"
  }
});
var Tooltip = ({ children, text, overlineText, standingsForm }) => {
  const [show, setShow] = useState4(false);
  const handleMouseEnter = () => setShow(true);
  const handleMouseLeave = () => setShow(false);
  return /* @__PURE__ */ React.createElement(TooltipContainer, null, standingsForm ? /* @__PURE__ */ React.createElement(StandingsTooltipBox, {
    style: {
      padding: "10px 10px",
      display: show ? "flex" : "none",
      flexDirection: "column",
      gap: "10px"
    }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "tooltipText",
    size: "2_5",
    css: { textAlign: "center", fontWeight: "700" }
  }, overlineText), /* @__PURE__ */ React.createElement(SMPText, {
    variant: "tooltipText",
    size: "2_5",
    css: { whiteSpace: "nowrap" }
  }, text)) : /* @__PURE__ */ React.createElement(TooltipBox, {
    display: show ? "block" : "none"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "tooltip",
    size: "2",
    css: { textAlign: "center" }
  }, overlineText), /* @__PURE__ */ React.createElement(SMPText, {
    variant: "tooltip",
    size: "3",
    css: { whiteSpace: "nowrap" }
  }, text)), /* @__PURE__ */ React.createElement("div", {
    style: { top: standingsForm ? "5px" : void 0, position: "relative" },
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, children));
};

// src/molecules/ProfileHead/ProfileHead.tsx
import { useMemo as useMemo3 } from "react";
import { setNationalParticipantBorder as setNationalParticipantBorder2, isNationalParticipant } from "@sportal365/smp-widget-utils";
var ProfileHead = ({
  player,
  team,
  widgetType,
  size = GenericSize.DEFAULT,
  align = GenericAlign.LEFT,
  condensed = false,
  showBottomBorder = false,
  primaryLink,
  imageBorderColor,
  isMainImageRound = true,
  displaySecondaryIcon = true
}) => {
  var _a2, _b, _c, _d2, _e, _f, _g, _h, _i, _j;
  const isPlayer = widgetType === "player";
  const isTeam = widgetType === "team";
  const rowDirection = align === GenericAlign.LEFT ? "row" : "row-reverse";
  const onClick = () => {
    if (primaryLink == null ? void 0 : primaryLink.callback) {
      primaryLink.callback();
    }
  };
  const playerName = useMemo3(() => {
    if (!player) {
      return "";
    }
    const fullName = player.name;
    if (!condensed) {
      return fullName;
    }
    const nameParts = fullName.split(" ");
    return nameParts[nameParts.length - 1];
  }, [condensed, player]);
  const getNameFontSize = (defaultSize) => {
    if (size === GenericSize.EXTRA_SMALL) {
      return "$4";
    }
    if (size === GenericSize.SMALL) {
      if (condensed) {
        return "$4";
      }
      return "$6";
    }
    return defaultSize;
  };
  const isTeamNational = isNationalParticipant(team);
  const profileHeadStyles = setNationalParticipantBorder2(isTeam && isTeamNational);
  const subheaderHeadStyles = setNationalParticipantBorder2(isPlayer && isTeamNational || isTeam && !isTeamNational);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, condensed ? /* @__PURE__ */ React.createElement(SMPLinkWrapper, {
    href: primaryLink == null ? void 0 : primaryLink.url,
    target: primaryLink == null ? void 0 : primaryLink.urlTarget
  }, /* @__PURE__ */ React.createElement(SMPContainer, {
    onClick,
    css: {
      jc: "flex-start",
      py: size !== GenericSize.EXTRA_SMALL ? "$3" : "$2",
      display: "flex",
      ai: "center",
      fd: "column",
      borderBottom: showBottomBorder ? "1px solid $dividerBorderColor" : "unset",
      width: "100%"
    }
  }, /* @__PURE__ */ React.createElement(SMPSportEntity, {
    className: "profile-link",
    css: __spreadValues({
      flex: "unset",
      jc: "center",
      br: isMainImageRound ? "$round" : "unset",
      size: "$6_5",
      backgroundImage: `url("${isTeam ? team == null ? void 0 : team.logo : player == null ? void 0 : player.thumb}")`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "100%",
      mb: "$1"
    }, profileHeadStyles)
  }), /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    weight: "700",
    css: {
      ta: "center",
      fontSize: getNameFontSize("unset"),
      "@bp2": { fontSize: getNameFontSize("$8") },
      mb: "$1"
    }
  }, widgetType === "team" ? team == null ? void 0 : team.name : playerName), displaySecondaryIcon && (isPlayer || isTeam && team && !team.national) && /* @__PURE__ */ React.createElement(SMPSportEntity, {
    css: {
      fd: align === GenericAlign.LEFT ? "row" : "row-reverse",
      ai: "end",
      jc: "end",
      gap: "$1"
    }
  }, /* @__PURE__ */ React.createElement(SMPImage, {
    css: __spreadValues({
      borderWidth: "1px",
      bs: "solid",
      bc: imageBorderColor != null ? imageBorderColor : "transparent",
      br: isPlayer ? 0 : "$round",
      size: "$3"
    }, subheaderHeadStyles),
    src: isPlayer ? team == null ? void 0 : team.logo : (_a2 = team == null ? void 0 : team.country) == null ? void 0 : _a2.logo,
    alt: isPlayer ? team == null ? void 0 : team.name : (_c = (_b = team == null ? void 0 : team.country) == null ? void 0 : _b.name) == null ? void 0 : _c.toUpperCase()
  }), /* @__PURE__ */ React.createElement(SMPText, {
    css: {
      fontWeight: "lighter",
      color: "$progressTextColor",
      ta: align === GenericAlign.LEFT ? "unset" : "end",
      wordBreak: "break-word"
    },
    variant: "contrast",
    size: "3"
  }, (_e = isPlayer ? team == null ? void 0 : team.name : (_d2 = team == null ? void 0 : team.country) == null ? void 0 : _d2.name) == null ? void 0 : _e[size !== GenericSize.DEFAULT ? "toString" : "toUpperCase"]())))) : /* @__PURE__ */ React.createElement(SMPLinkWrapper, {
    href: primaryLink == null ? void 0 : primaryLink.url,
    target: primaryLink == null ? void 0 : primaryLink.urlTarget
  }, /* @__PURE__ */ React.createElement(SMPContainer, {
    onClick,
    css: {
      display: "flex",
      py: size !== GenericSize.EXTRA_SMALL ? "$3" : "$2",
      ai: "center",
      fd: rowDirection,
      borderBottom: showBottomBorder ? "1px solid $dividerBorderColor" : "unset",
      width: "100%"
    }
  }, /* @__PURE__ */ React.createElement(SMPSportEntity, {
    className: "profile-link",
    css: __spreadValues({
      flex: "unset",
      justifyContent: align === GenericAlign.LEFT ? "start" : "end",
      borderRadius: isMainImageRound ? "$round" : "unset",
      [align === GenericAlign.LEFT ? "marginRight" : "marginLeft"]: "$2",
      size: "$8",
      backgroundImage: `url("${isTeam ? team == null ? void 0 : team.logo : player == null ? void 0 : player.thumb}")`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "100%",
      mb: "$1"
    }, profileHeadStyles)
  }), /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "column"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    weight: "700",
    css: {
      ta: align === GenericAlign.LEFT ? "start" : "end",
      fontSize: getNameFontSize("unset"),
      "@bp2": { fontSize: getNameFontSize("$8") },
      mb: "$1",
      lh: "40px"
    }
  }, isTeam ? team == null ? void 0 : team.name : playerName), displaySecondaryIcon && (isPlayer || isTeam && team && !team.national) && /* @__PURE__ */ React.createElement(SMPSportEntity, {
    css: {
      fd: align === GenericAlign.LEFT ? "row" : "row-reverse",
      gap: "$1"
    }
  }, /* @__PURE__ */ React.createElement(SMPImage, {
    css: __spreadValues({
      borderWidth: "1px",
      bs: "solid",
      bc: imageBorderColor != null ? imageBorderColor : "transparent",
      br: isPlayer ? 0 : "$round",
      size: "$5"
    }, subheaderHeadStyles),
    src: isPlayer ? team == null ? void 0 : team.logo : (_f = team == null ? void 0 : team.country) == null ? void 0 : _f.logo,
    alt: isPlayer ? team == null ? void 0 : team.name : (_h = (_g = team == null ? void 0 : team.country) == null ? void 0 : _g.name) == null ? void 0 : _h.toUpperCase()
  }), /* @__PURE__ */ React.createElement(SMPText, {
    css: {
      fontWeight: "lighter",
      color: "$progressTextColor",
      ta: align === GenericAlign.LEFT ? "unset" : "end",
      wordBreak: "break-word"
    },
    variant: "contrast",
    size: "3"
  }, (_j = isPlayer ? team == null ? void 0 : team.name : (_i = team == null ? void 0 : team.country) == null ? void 0 : _i.name) == null ? void 0 : _j[size !== GenericSize.DEFAULT ? "toString" : "toUpperCase"]()))))));
};

// ../constants/statistics.ts
var YELLOW_CARDS = "yellow_cards";
var RED_CARDS = "red_cards";

// src/molecules/ProfileSeasonStatistics/ProfileSeasonStatistics.tsx
import { snakeToCamelCase, camelToSnakeCase, toSentenceCase } from "@sportal365/smp-widget-utils";
import { useMemo as useMemo4, useState as useState6 } from "react";

// ../hooks/useResizeObserver.ts
import { useCallback, useEffect as useEffect4, useState as useState5 } from "react";
function useResizeObserver(resizeCallback) {
  const [element, setElement] = useState5();
  const memoizedResizeCallback = useCallback(resizeCallback, [resizeCallback]);
  useEffect4(() => {
    if (element) {
      const resizeObserver = new ResizeObserver(() => requestAnimationFrame(() => memoizedResizeCallback(element)));
      resizeObserver.observe(element);
      return () => resizeObserver.disconnect();
    }
  }, [element, memoizedResizeCallback]);
  return useCallback((node) => {
    if (node) {
      setElement(node);
    }
  }, []);
}

// src/molecules/ProfileSeasonStatistics/ProfileSeasonStatistics.tsx
var ProfileSeasonStatistics = ({ season, statistics, tournamentName, labels }) => {
  var _a2, _b;
  const [isMobile, setIsMobile] = useState6(false);
  const measuredRef = useResizeObserver((fieldElement) => {
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
  });
  const styles = useMemo4(() => {
    return {
      display: "grid",
      gridGap: isMobile ? "40px" : "40px 85px",
      gridRowGap: "40px",
      gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
      paddingTop: "20px",
      paddingBottom: "30px",
      paddingInline: isMobile ? "16px" : "32px"
    };
  }, [isMobile]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SMPFlex, {
    ref: measuredRef,
    css: {
      mt: "$3",
      backgroundColor: "$rowBackgroundColor",
      justifyContent: "flex-start",
      py: "$2",
      "@bp0": { px: "16px" },
      "@bp1": { px: "32px" }
    }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    css: { marginRight: "5px", "@bp0": { fontSize: "12px" }, "@bp2": { fontSize: "14px" } }
  }, tournamentName ? tournamentName : (_b = (_a2 = season == null ? void 0 : season.tournament) == null ? void 0 : _a2.name) == null ? void 0 : _b.toUpperCase()), /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    css: { "@bp0": { fontSize: "12px" }, "@bp2": { fontSize: "14px" } }
  }, season == null ? void 0 : season.name)), /* @__PURE__ */ React.createElement(SMPContainer, {
    style: styles
  }, statistics == null ? void 0 : statistics.map((statistic) => {
    var _a3, _b2;
    const camelStatName = snakeToCamelCase((_a3 = statistic.name) != null ? _a3 : "", true);
    const snakeStatName = camelToSnakeCase(camelStatName);
    const label = (_b2 = labels == null ? void 0 : labels[snakeStatName]) != null ? _b2 : toSentenceCase(snakeStatName);
    return /* @__PURE__ */ React.createElement(SMPFlex, {
      variant: "column",
      key: statistic == null ? void 0 : statistic.name
    }, /* @__PURE__ */ React.createElement(SMPFlex, {
      css: { justifyContent: "left", alignItems: "center" }
    }, statistic.key === YELLOW_CARDS && /* @__PURE__ */ React.createElement(SMPYellowCardsIcon, {
      style: { width: "20px", height: "20px", marginTop: "3px" }
    }), statistic.key === RED_CARDS && /* @__PURE__ */ React.createElement(SMPRedCardsIcon, {
      style: { width: "20px", height: "20px", marginTop: "3px" }
    }), /* @__PURE__ */ React.createElement(SMPText, {
      size: "6",
      variant: "contrast",
      css: { fontWeight: "bolder" }
    }, statistic == null ? void 0 : statistic.value)), /* @__PURE__ */ React.createElement(SMPText, {
      css: { fontWeight: "lighter", mt: "$2" },
      variant: "contrast",
      size: "3"
    }, label));
  })));
};

// ../constants/statusTypes.ts
var LIVE = "LIVE";
var NOT_STARTED = "NOT_STARTED";

// ../constants/statusTextVariants.ts
var LIVE_VARIANT = "live";
var PRIMARY_GRAY_VARIANT = "primaryGray";

// src/molecules/EventInfo/EventInfo.tsx
import { constructEventStatusInfo, getMatchMinutes } from "@sportal365/smp-widget-utils";
var EventInfo = ({
  match: match12,
  matchLink,
  handleEventClick,
  dataShortStatusType,
  displayDate = true
}) => {
  var _a2, _b, _c, _d2, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const [_shouldShowDate, matchDate] = match12.date;
  const statusTextVariant = ((_a2 = match12 == null ? void 0 : match12.matchStatus) == null ? void 0 : _a2.type) === LIVE ? LIVE_VARIANT : PRIMARY_GRAY_VARIANT;
  const showPenaltyScore = Boolean(((_b = match12.score) == null ? void 0 : _b.penaltyShootout) && ((_d2 = (_c = match12.score) == null ? void 0 : _c.penaltyShootout) == null ? void 0 : _d2.home) && ((_f = (_e = match12.score) == null ? void 0 : _e.penaltyShootout) == null ? void 0 : _f.away));
  const isMatchLive = ((_g = match12.matchStatus) == null ? void 0 : _g.type) === "LIVE";
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "score",
    grow: "10",
    shrink: "1",
    basis: "auto",
    css: { minWidth: "75px" }
  }, ((_h = match12 == null ? void 0 : match12.matchStatus) == null ? void 0 : _h.code) === "not_started" || ((_i = match12 == null ? void 0 : match12.matchStatus) == null ? void 0 : _i.code) === "postponed" ? /* @__PURE__ */ React.createElement("a", {
    href: matchLink,
    target: match12.urlTarget,
    onClick: () => handleEventClick && handleEventClick(match12.id),
    style: { display: "inline-flex", textDecoration: "none" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "6",
    weight: "900"
  }, match12.status)) : /* @__PURE__ */ React.createElement(GameScore, {
    eventId: match12.id,
    handleEventClick,
    matchUrlTarget: match12 == null ? void 0 : match12.urlTarget,
    matchLink,
    homeTeamScore: match12.homeTeamScore,
    awayTeamScore: match12.awayTeamScore
  }), (match12 == null ? void 0 : match12.minute) ? /* @__PURE__ */ React.createElement(SMPText, {
    css: { mt: "$2" },
    size: "2",
    weight: "700",
    variant: "green"
  }, getMatchMinutes(match12.minute)) : /* @__PURE__ */ React.createElement(React.Fragment, null, displayDate && /* @__PURE__ */ React.createElement(SMPText, {
    css: { mt: "$2" },
    size: "2",
    variant: "primaryGray"
  }, matchDate), ((_j = match12 == null ? void 0 : match12.matchStatus) == null ? void 0 : _j.code) !== "not_started" && /* @__PURE__ */ React.createElement(SMPText, {
    css: { mt: "$2" },
    variant: statusTextVariant,
    size: "2",
    weight: "700"
  }, constructEventStatusInfo(match12, dataShortStatusType) && showPenaltyScore && isMatchLive ? `${constructEventStatusInfo(match12, dataShortStatusType)}'` : constructEventStatusInfo(match12, dataShortStatusType)), showPenaltyScore && isMatchLive && /* @__PURE__ */ React.createElement(SMPText, {
    css: { mt: "$2" },
    variant: "contrast",
    size: "2",
    weight: "700"
  }, "(", (_l = (_k = match12.score) == null ? void 0 : _k.penaltyShootout) == null ? void 0 : _l.home, " - ", (_n = (_m = match12.score) == null ? void 0 : _m.penaltyShootout) == null ? void 0 : _n.away, ")")));
};

// src/molecules/Filters/Filters.tsx
import { forwardRef, useEffect as useEffect5, useMemo as useMemo5, useRef as useRef3, useState as useState7 } from "react";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";

// ../constants/statusFilters.ts
var POPULAR = "POPULAR";
var ODDS = "ODDS";

// src/molecules/Filters/Filters.tsx
import { defaultHandleUserInteractionClick as defaultHandleUserInteractionClick3 } from "@sportal365/smp-widget-utils/src/clickHandlers";
var Filters = ({
  date,
  filter,
  dataDate,
  dataLabels,
  language,
  dataPopularList,
  handleDateSelect,
  handleFilterClick,
  handleNextArrowClick,
  handlePrevArrowClick,
  statusFilters,
  handleClick,
  theme: theme2,
  showHeader,
  displayOptions
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState7(false);
  const arrowCss3 = {
    borderRadius: "6px",
    border: "1px solid var(--colors-dropdownBorderColor)",
    backgroundColor: "var(--colors-dropdownBtnColor)",
    color: "var(--colors-dropdownArrowIconColor)",
    padding: "12px 16px",
    "transition-timing-function": "ease-out",
    "&:hover": {
      color: "orange",
      cursor: "pointer",
      transition: "color 0.3s"
    },
    "&:active": {
      height: "14px",
      transition: "height 0.3s",
      "transition-timing-function": "ease-out"
    }
  };
  const CalendarBox = forwardRef(({ value, onClick }, ref2) => /* @__PURE__ */ React.createElement("div", {
    ref: ref2,
    onClick,
    style: {
      border: isCalendarOpen ? `1px solid var(--colors-pillActiveBackgroundColor)` : "1px solid var(--colors-dropdownBorderColor)",
      borderRadius: "6px",
      padding: "8px 12px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      height: "24px",
      backgroundColor: "var(--colors-dropdownBtnColor)"
    }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "3",
    weight: "700",
    style: { textAlign: "center", width: "100%" }
  }, dayjs(value).format(dataDate == null ? void 0 : dataDate.dateFormat)), /* @__PURE__ */ React.createElement(SMPCalendarIcon, {
    color: isCalendarOpen ? "var(--colors-pillActiveBackgroundColor)" : "var(--colors-dropdownCalendarIconColor)"
  })));
  CalendarBox.displayName = "CalendarBox";
  const filters = useMemo5(() => {
    return statusFilters.reduce((transformedFilters, statusFilter) => {
      if (!dataPopularList && statusFilter === POPULAR)
        return transformedFilters;
      return [...transformedFilters, { name: (dataLabels == null ? void 0 : dataLabels[statusFilter.toLowerCase()]) || statusFilter, value: statusFilter }];
    }, []);
  }, [statusFilters, dataPopularList, dataLabels]);
  const ref = useRef3(null);
  const [isMobile, setIsMobile] = useState7(false);
  const [width, setWidth] = useState7(0);
  useEffect5(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const newWidth = entry.contentRect.width;
        if (newWidth !== width && ref.current) {
          setWidth(newWidth);
          setIsMobile(newWidth < FILTERS_BREAKPOINT);
          ref.current.style.setProperty("--filters-width", `${newWidth}px`);
        }
      }
    });
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [width]);
  const handleDateClick = (type, date2) => {
    switch (type) {
      case "prev":
        handlePrevArrowClick();
        break;
      case "next":
        handleNextArrowClick();
        break;
      default:
        date2 && handleDateSelect(date2);
        break;
    }
    defaultHandleUserInteractionClick3(handleClick, USER_INTERACTION, DROPDOWN_SELECTION_SUBSCRIBE_TYPE);
  };
  if (!displayOptions && !showHeader) {
    return /* @__PURE__ */ React.createElement("div", null);
  }
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    ref,
    className: isMobile ? "filtersColumn" : "filtersRow",
    css: {
      bc: "$filtersContainerPrimaryBackgroundColor",
      width: "100%",
      padding: "0 16px",
      paddingBottom: displayOptions && !showHeader ? "12px" : "unset"
    }
  }, displayOptions ? /* @__PURE__ */ React.createElement("div", {
    style: { marginBottom: showHeader && isMobile ? "12px" : "unset" }
  }, /* @__PURE__ */ React.createElement(PillTabs, {
    tabs: filters,
    selectedTab: filter,
    handleTabClick: handleFilterClick,
    handleSubscriptionClick: handleClick
  })) : /* @__PURE__ */ React.createElement("div", {
    style: { margin: 0 }
  }), showHeader && /* @__PURE__ */ React.createElement(SMPFlex, {
    style: {
      height: "42px",
      marginBottom: isMobile ? "12px" : "unset"
    },
    grow: "10"
  }, /* @__PURE__ */ React.createElement("div", {
    style: { marginRight: "8px" }
  }, /* @__PURE__ */ React.createElement(SMPArrowLeftIcon, {
    onClick: () => handleDateClick("prev", null),
    css: arrowCss3
  })), /* @__PURE__ */ React.createElement(DatePicker, {
    selected: date,
    popperPlacement: "bottom",
    customInput: /* @__PURE__ */ React.createElement(CalendarBox, null),
    onCalendarOpen: () => setIsCalendarOpen(true),
    onCalendarClose: () => setIsCalendarOpen(false),
    locale: language,
    onChange: (date2) => handleDateClick("select", date2)
  }), /* @__PURE__ */ React.createElement("div", {
    style: { marginLeft: "8px", marginRight: isMobile ? "16px" : "" }
  }, /* @__PURE__ */ React.createElement(SMPArrowRightIcon, {
    onClick: () => handleDateClick("next", null),
    css: arrowCss3
  }))));
};

// src/molecules/PillTabsHeader/PillTabsHeader.tsx
import React13 from "react";

// src/molecules/PillTabsV2/PillTabsV2.tsx
import React8, { useRef as useRef4, useEffect as useEffect6 } from "react";
import { classNames as classNames3 } from "@sportal365/smp-widget-utils";
var PillTabsV2 = ({ selectedPillTab, pillTabOptions, handlePillTabChange }) => {
  const scrollableContainerRef = useRef4(null);
  const pillsContainerRef = useRef4(null);
  const selectedPillRef = useRef4(null);
  const handleTabScroll = (value) => {
    handlePillTabChange(value);
    scrollToSelectedPill();
  };
  const scrollToSelectedPill = () => {
    if (scrollableContainerRef.current && pillsContainerRef.current && selectedPillRef.current) {
      const container = scrollableContainerRef.current;
      const containerRect = container.getBoundingClientRect();
      const pillRect = selectedPillRef.current.getBoundingClientRect();
      if (pillRect.right > containerRect.right || pillRect.left < containerRect.left) {
        if (pillRect.right > containerRect.right) {
          container.scrollLeft += pillRect.right - containerRect.right;
        } else {
          container.scrollLeft -= containerRect.left - pillRect.left;
        }
      }
    }
  };
  useEffect6(() => {
    scrollToSelectedPill();
  }, [selectedPillTab]);
  return /* @__PURE__ */ React8.createElement("div", {
    ref: scrollableContainerRef,
    className: "pill-tabs-scrollable-container flex gap-3 sm:gap-2 relative overflow-x-auto flex-[1_1_auto]",
    style: {
      scrollbarWidth: "none"
    }
  }, /* @__PURE__ */ React8.createElement("div", {
    ref: pillsContainerRef,
    className: "pill-tabs-container flex gap-2 whitespace-nowrap"
  }, pillTabOptions.map(({ label, value, isDisabled }) => {
    const isSelected = value === selectedPillTab;
    if (!value)
      return null;
    return /* @__PURE__ */ React8.createElement("div", {
      key: value,
      ref: isSelected ? selectedPillRef : null,
      onClick: () => handleTabScroll(value),
      className: classNames3({
        "flex items-center justify-center sm:py-[10px] sm:px-6 py-[5px] px-3 h-fit cursor-pointer rounded-5 border-[1px]": true,
        "bg-pillActiveBackgroundColor border-pillActiveBackgroundColor ": isSelected,
        "bg-pillBackgroundColor border-pillBorderColor": !isSelected,
        "pointer-events-none opacity-50": isDisabled && !isSelected
      }, `pill-tab-${label}`)
    }, /* @__PURE__ */ React8.createElement("span", {
      className: classNames3({
        "leading-[20px] text-3 sm:text-4": true,
        "font-bold text-pillActiveTextColor": isSelected,
        "font-normal text-pillTextColor": !isSelected
      }, `pill-tab-${label}-label`)
    }, label));
  })));
};

// src/molecules/CalendarDropdown/Calendar.tsx
import React12 from "react";

// src/molecules/CalendarDropdown/CalendarBtn/CalendarBtn.tsx
import React9 from "react";
import dayjs2 from "dayjs";
import { classNames as classNames4 } from "@sportal365/smp-widget-utils";
var CalendarBtn = ({ value, isCalendarOpen, dataDate, onClick }) => {
  return /* @__PURE__ */ React9.createElement("div", {
    onClick,
    className: classNames4({
      "calendar-btn-container flex items-center h-[42px] bg-dropdownBtnColor cursor-pointer rounded-3 py-2 px-3 border-[1px] border-dropdownBorderColor": true,
      "border-pillActiveBackgroundColor": isCalendarOpen
    })
  }, /* @__PURE__ */ React9.createElement("span", {
    className: "calendar-btn-value text-center w-full text-4 font-bold text-hiContrast"
  }, dayjs2(value).format(dataDate == null ? void 0 : dataDate.dateFormat)), /* @__PURE__ */ React9.createElement(CalendarIcon, null));
};

// src/molecules/CalendarDropdown/CalendarIcon/CalendarIcon.tsx
import React10 from "react";
import { classNames as classNames5 } from "@sportal365/smp-widget-utils";
var CalendarIcon2 = ({ position, handleClick }) => {
  const isLeft = position === "left";
  return /* @__PURE__ */ React10.createElement("div", {
    className: classNames5({
      "flex justify-center items-center h-[42px] min-w-[42px] rounded-3 border-[1px] border-dropdownBorderColor bg-dropdownBtnColor text-dropdownArrowIconColor cursor-pointer": true,
      "my-0 ml-0 mr-3": isLeft,
      "my-0 ml-3 mr-0": !isLeft
    }, `calendar-${position}-icon-container`),
    onClick: handleClick
  }, isLeft ? /* @__PURE__ */ React10.createElement(ArrowLeftIcon, null) : /* @__PURE__ */ React10.createElement(ArrowRightIcon, null));
};

// src/molecules/CalendarDropdown/CalendarMenu/CalendarMenu.tsx
import React11, { useState as useState8, useEffect as useEffect7, useContext as useContext2 } from "react";
import { classNames as classNames6 } from "@sportal365/smp-widget-utils";

// src/contexts/ConfigContext.ts
import { createContext } from "react";
var ConfigContext = createContext({});

// ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}

// ../../node_modules/date-fns/esm/isDate/index.js
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof3(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof3(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

// ../../node_modules/date-fns/esm/toDate/index.js
function _typeof2(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof2 = function _typeof3(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof2 = function _typeof3(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof2(obj);
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof2(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

// ../../node_modules/date-fns/esm/isValid/index.js
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

// ../../node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

// ../../node_modules/date-fns/esm/addMilliseconds/index.js
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

// ../../node_modules/date-fns/esm/subMilliseconds/index.js
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

// ../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

// ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

// ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// ../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

// ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js
var MILLISECONDS_IN_WEEK2 = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK2) + 1;
}

// ../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}

// ../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var formatters = {
  y: function y2(date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  M: function M2(date, token) {
    var month = date.getUTCMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function d2(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  a: function a2(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  h: function h2(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  H: function H2(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  m: function m2(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  s: function s2(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  S: function S2(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var lightFormatters_default = formatters;

// ../../node_modules/date-fns/esm/_lib/format/formatters/index.js
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters2 = {
  G: function G2(date, token, localize12) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize12.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize12.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize12.era(era, {
          width: "wide"
        });
    }
  },
  y: function y3(date, token, localize12) {
    if (token === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize12.ordinalNumber(year, {
        unit: "year"
      });
    }
    return lightFormatters_default.y(date, token);
  },
  Y: function Y2(date, token, localize12, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize12.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function R2(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function u2(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function Q(date, token, localize12) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize12.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize12.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize12.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize12.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function q2(date, token, localize12) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize12.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize12.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize12.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize12.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function M3(date, token, localize12) {
    var month = date.getUTCMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters_default.M(date, token);
      case "Mo":
        return localize12.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize12.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize12.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize12.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function L2(date, token, localize12) {
    var month = date.getUTCMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize12.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize12.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize12.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize12.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function w2(date, token, localize12, options) {
    var week3 = getUTCWeek(date, options);
    if (token === "wo") {
      return localize12.ordinalNumber(week3, {
        unit: "week"
      });
    }
    return addLeadingZeros(week3, token.length);
  },
  I: function I2(date, token, localize12) {
    var isoWeek = getUTCISOWeek(date);
    if (token === "Io") {
      return localize12.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function d3(date, token, localize12) {
    if (token === "do") {
      return localize12.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return lightFormatters_default.d(date, token);
  },
  D: function D2(date, token, localize12) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === "Do") {
      return localize12.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function E2(date, token, localize12) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize12.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize12.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize12.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize12.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function e2(date, token, localize12, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize12.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize12.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize12.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize12.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize12.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function c2(date, token, localize12, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize12.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize12.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize12.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize12.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize12.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function i2(date, token, localize12) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize12.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize12.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize12.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize12.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize12.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function a3(date, token, localize12) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function b2(date, token, localize12) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function B2(date, token, localize12) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function h3(date, token, localize12) {
    if (token === "ho") {
      var hours = date.getUTCHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize12.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return lightFormatters_default.h(date, token);
  },
  H: function H3(date, token, localize12) {
    if (token === "Ho") {
      return localize12.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return lightFormatters_default.H(date, token);
  },
  K: function K(date, token, localize12) {
    var hours = date.getUTCHours() % 12;
    if (token === "Ko") {
      return localize12.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function k2(date, token, localize12) {
    var hours = date.getUTCHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize12.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function m3(date, token, localize12) {
    if (token === "mo") {
      return localize12.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return lightFormatters_default.m(date, token);
  },
  s: function s3(date, token, localize12) {
    if (token === "so") {
      return localize12.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return lightFormatters_default.s(date, token);
  },
  S: function S3(date, token) {
    return lightFormatters_default.S(date, token);
  },
  X: function X2(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  x: function x2(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  O: function O2(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  z: function z2(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  t: function t2(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function T2(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || "";
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters_default = formatters2;

// ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter2(pattern, formatLong12) {
  switch (pattern) {
    case "P":
      return formatLong12.date({
        width: "short"
      });
    case "PP":
      return formatLong12.date({
        width: "medium"
      });
    case "PPP":
      return formatLong12.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong12.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function timeLongFormatter2(pattern, formatLong12) {
  switch (pattern) {
    case "p":
      return formatLong12.time({
        width: "short"
      });
    case "pp":
      return formatLong12.time({
        width: "medium"
      });
    case "ppp":
      return formatLong12.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong12.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong12) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong12);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong12.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong12.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong12.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong12.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong12)).replace("{{time}}", timeLongFormatter(timePattern, formatLong12));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters_default = longFormatters;

// ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

// ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

// ../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function formatDistance2(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
var formatDistance_default = formatDistance;

// ../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}

// ../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatLong_default = formatLong;

// ../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function formatRelative2(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative_default = formatRelative;

// ../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

// ../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function ordinalNumber2(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
var localize_default = localize;

// ../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}

// ../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}

// ../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var match_default = match;

// ../../node_modules/date-fns/esm/locale/en-US/index.js
var locale = {
  code: "en-US",
  formatDistance: formatDistance_default,
  formatLong: formatLong_default,
  formatRelative: formatRelative_default,
  localize: localize_default,
  match: match_default,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var en_US_default = locale;

// ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js
var defaultLocale_default = en_US_default;

// ../../node_modules/date-fns/esm/format/index.js
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale11 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale11.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale11.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale11,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters_default[firstCharacter];
      return longFormatter(substring, locale11.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters_default[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale11.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

// ../../node_modules/date-fns/esm/startOfMonth/index.js
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/endOfMonth/index.js
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

// ../../node_modules/date-fns/esm/startOfWeek/index.js
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/endOfWeek/index.js
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

// ../../node_modules/date-fns/esm/addMonths/index.js
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

// ../../node_modules/date-fns/esm/subMonths/index.js
function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

// ../../node_modules/date-fns/esm/isSameMonth/index.js
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

// ../../node_modules/date-fns/esm/startOfDay/index.js
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/isSameDay/index.js
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

// ../../node_modules/date-fns/esm/addDays/index.js
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

// ../../node_modules/date-fns/esm/subDays/index.js
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

// ../../node_modules/date-fns/esm/_lib/isSameUTCWeek/index.js
function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var dateLeftStartOfWeek = startOfUTCWeek(dirtyDateLeft, options);
  var dateRightStartOfWeek = startOfUTCWeek(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

// ../../node_modules/date-fns/esm/locale/bg/_lib/formatDistance/index.js
var formatDistanceLocale2 = {
  lessThanXSeconds: {
    one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
    other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
  },
  xSeconds: {
    one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
    other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
  },
  halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
  lessThanXMinutes: {
    one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
    other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
  },
  xMinutes: {
    one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
    other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
  },
  aboutXHours: {
    one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
    other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
  },
  xHours: {
    one: "1 \u0447\u0430\u0441",
    other: "{{count}} \u0447\u0430\u0441\u0430"
  },
  xDays: {
    one: "1 \u0434\u0435\u043D",
    other: "{{count}} \u0434\u043D\u0438"
  },
  aboutXWeeks: {
    one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
    other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
  },
  xWeeks: {
    one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
    other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
  },
  aboutXMonths: {
    one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
    other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
  },
  xMonths: {
    one: "1 \u043C\u0435\u0441\u0435\u0446",
    other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
  },
  aboutXYears: {
    one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
    other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
  },
  xYears: {
    one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
    other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
  },
  overXYears: {
    one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
    other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
  },
  almostXYears: {
    one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
    other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
  }
};
var formatDistance3 = function formatDistance4(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale2[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "\u0441\u043B\u0435\u0434 " + result;
    } else {
      return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
  }
  return result;
};
var formatDistance_default2 = formatDistance3;

// ../../node_modules/date-fns/esm/locale/bg/_lib/formatLong/index.js
var dateFormats2 = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
};
var timeFormats2 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
};
var dateTimeFormats2 = {
  any: "{{date}} {{time}}"
};
var formatLong2 = {
  date: buildFormatLongFn({
    formats: dateFormats2,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats2,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats2,
    defaultWidth: "any"
  })
};
var formatLong_default2 = formatLong2;

// ../../node_modules/date-fns/esm/locale/bg/_lib/formatRelative/index.js
var weekdays = ["\u043D\u0435\u0434\u0435\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u044F\u0434\u0430", "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u043F\u0435\u0442\u044A\u043A", "\u0441\u044A\u0431\u043E\u0442\u0430"];
function lastWeek(day) {
  var weekday = weekdays[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
  }
}
function thisWeek(day) {
  var weekday = weekdays[day];
  if (day === 2) {
    return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
  } else {
    return "'\u0432 " + weekday + " \u0432' p";
  }
}
function nextWeek(day) {
  var weekday = weekdays[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
  }
}
var lastWeekFormatToken = function lastWeekFormatToken2(dirtyDate, baseDate, options) {
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  if (isSameUTCWeek(date, baseDate, options)) {
    return thisWeek(day);
  } else {
    return lastWeek(day);
  }
};
var nextWeekFormatToken = function nextWeekFormatToken2(dirtyDate, baseDate, options) {
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  if (isSameUTCWeek(date, baseDate, options)) {
    return thisWeek(day);
  } else {
    return nextWeek(day);
  }
};
var formatRelativeLocale2 = {
  lastWeek: lastWeekFormatToken,
  yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
  today: "'\u0434\u043D\u0435\u0441 \u0432' p",
  tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
  nextWeek: nextWeekFormatToken,
  other: "P"
};
var formatRelative3 = function formatRelative4(token, date, baseDate, options) {
  var format2 = formatRelativeLocale2[token];
  if (typeof format2 === "function") {
    return format2(date, baseDate, options);
  }
  return format2;
};
var formatRelative_default2 = formatRelative3;

// ../../node_modules/date-fns/esm/locale/bg/_lib/localize/index.js
var eraValues2 = {
  narrow: ["\u043F\u0440.\u043D.\u0435.", "\u043D.\u0435."],
  abbreviated: ["\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.", "\u043D. \u0435."],
  wide: ["\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430", "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"]
};
var quarterValues2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."],
  wide: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"]
};
var monthValues2 = {
  abbreviated: ["\u044F\u043D\u0443", "\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433", "\u0441\u0435\u043F", "\u043E\u043A\u0442", "\u043D\u043E\u0435", "\u0434\u0435\u043A"],
  wide: ["\u044F\u043D\u0443\u0430\u0440\u0438", "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438", "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438", "\u043D\u043E\u0435\u043C\u0432\u0440\u0438", "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"]
};
var dayValues2 = {
  narrow: ["\u041D", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
  short: ["\u043D\u0434", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"],
  abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0432\u0442\u043E", "\u0441\u0440\u044F", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u044A\u0431"],
  wide: ["\u043D\u0435\u0434\u0435\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u044F\u0434\u0430", "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u043F\u0435\u0442\u044A\u043A", "\u0441\u044A\u0431\u043E\u0442\u0430"]
};
var dayPeriodValues2 = {
  wide: {
    am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
    pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
    midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
    noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
    morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
    afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
    evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
    night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
  }
};
function isFeminine(unit) {
  return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
}
function isNeuter(unit) {
  return unit === "quarter";
}
function numberWithSuffix(number, unit, masculine, feminine, neuter) {
  var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
  return number + "-" + suffix;
}
var ordinalNumber3 = function ordinalNumber4(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  if (number === 0) {
    return numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
  } else if (number % 1e3 === 0) {
    return numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
  } else if (number % 100 === 0) {
    return numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
  }
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
      case 2:
        return numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
      case 7:
      case 8:
        return numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
  }
  return numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var localize2 = {
  ordinalNumber: ordinalNumber3,
  era: buildLocalizeFn({
    values: eraValues2,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues2,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback2(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues2,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues2,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues2,
    defaultWidth: "wide"
  })
};
var localize_default2 = localize2;

// ../../node_modules/date-fns/esm/locale/bg/_lib/match/index.js
var matchOrdinalNumberPattern2 = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var parseOrdinalNumberPattern2 = /\d+/i;
var matchEraPatterns2 = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(преди новата ера|новата ера|нова ера)/i
};
var parseEraPatterns2 = {
  any: [/^п/i, /^н/i]
};
var matchQuarterPatterns2 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
  wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var parseQuarterPatterns2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchDayPatterns2 = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var parseDayPatterns2 = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
};
var matchMonthPatterns2 = {
  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns2 = {
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
};
var matchDayPeriodPatterns2 = {
  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var parseDayPeriodPatterns2 = {
  any: {
    am: /^преди о/i,
    pm: /^след о/i,
    midnight: /^в пол/i,
    noon: /^на об/i,
    morning: /^сут/i,
    afternoon: /^следо/i,
    evening: /^веч/i,
    night: /^през н/i
  }
};
var match2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern2,
    parsePattern: parseOrdinalNumberPattern2,
    valueCallback: function valueCallback3(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns2,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns2,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns2,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns2,
    defaultParseWidth: "any",
    valueCallback: function valueCallback4(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns2,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns2,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns2,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns2,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns2,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns2,
    defaultParseWidth: "any"
  })
};
var match_default2 = match2;

// ../../node_modules/date-fns/esm/locale/bg/index.js
var locale2 = {
  code: "bg",
  formatDistance: formatDistance_default2,
  formatLong: formatLong_default2,
  formatRelative: formatRelative_default2,
  localize: localize_default2,
  match: match_default2,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var bg_default = locale2;

// ../../node_modules/date-fns/esm/locale/de/_lib/formatDistance/index.js
var formatDistanceLocale3 = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
};
var formatDistance5 = function formatDistance6(token, count, options) {
  var result;
  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale3[token].withPreposition : formatDistanceLocale3[token].standalone;
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return "vor " + result;
    }
  }
  return result;
};
var formatDistance_default3 = formatDistance5;

// ../../node_modules/date-fns/esm/locale/de/_lib/formatLong/index.js
var dateFormats3 = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
};
var timeFormats3 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats3 = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong3 = {
  date: buildFormatLongFn({
    formats: dateFormats3,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats3,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats3,
    defaultWidth: "full"
  })
};
var formatLong_default3 = formatLong3;

// ../../node_modules/date-fns/esm/locale/de/_lib/formatRelative/index.js
var formatRelativeLocale3 = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
};
var formatRelative5 = function formatRelative6(token, _date, _baseDate, _options) {
  return formatRelativeLocale3[token];
};
var formatRelative_default3 = formatRelative5;

// ../../node_modules/date-fns/esm/locale/de/_lib/localize/index.js
var eraValues3 = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
};
var quarterValues3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
};
var monthValues3 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
};
var formattingMonthValues = {
  narrow: monthValues3.narrow,
  abbreviated: ["Jan.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: monthValues3.wide
};
var dayValues3 = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
};
var dayPeriodValues3 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
};
var formattingDayPeriodValues2 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
};
var ordinalNumber5 = function ordinalNumber6(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize3 = {
  ordinalNumber: ordinalNumber5,
  era: buildLocalizeFn({
    values: eraValues3,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues3,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback3(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues3,
    formattingValues: formattingMonthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues3,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues3,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues2,
    defaultFormattingWidth: "wide"
  })
};
var localize_default3 = localize3;

// ../../node_modules/date-fns/esm/locale/de/_lib/match/index.js
var matchOrdinalNumberPattern3 = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern3 = /\d+/i;
var matchEraPatterns3 = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns3 = {
  any: [/^v/i, /^n/i]
};
var matchQuarterPatterns3 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns3 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns3 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns3 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns3 = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns3 = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns3 = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns3 = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    evening: /abends/i,
    night: /nachts/i
  }
};
var match3 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern3,
    parsePattern: parseOrdinalNumberPattern3,
    valueCallback: function valueCallback5(value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns3,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns3,
    defaultParseWidth: "any",
    valueCallback: function valueCallback6(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns3,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns3,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns3,
    defaultParseWidth: "any"
  })
};
var match_default3 = match3;

// ../../node_modules/date-fns/esm/locale/de/index.js
var locale3 = {
  code: "de",
  formatDistance: formatDistance_default3,
  formatLong: formatLong_default3,
  formatRelative: formatRelative_default3,
  localize: localize_default3,
  match: match_default3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var de_default = locale3;

// ../../node_modules/date-fns/esm/locale/el/_lib/formatDistance/index.js
var formatDistanceLocale4 = {
  lessThanXSeconds: {
    one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
    other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
  },
  xSeconds: {
    one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
    other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
  },
  halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
  lessThanXMinutes: {
    one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
    other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
  },
  xMinutes: {
    one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
    other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
  },
  aboutXHours: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
  },
  xHours: {
    one: "1 \u03CE\u03C1\u03B1",
    other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
  },
  xDays: {
    one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
    other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
  },
  aboutXWeeks: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
  },
  xWeeks: {
    one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
    other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
  },
  aboutXMonths: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
  },
  xMonths: {
    one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
    other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
  },
  aboutXYears: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  },
  xYears: {
    one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  },
  overXYears: {
    one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  },
  almostXYears: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  }
};
var formatDistance7 = function formatDistance8(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale4[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "\u03C3\u03B5 " + result;
    } else {
      return result + " \u03C0\u03C1\u03B9\u03BD";
    }
  }
  return result;
};
var formatDistance_default4 = formatDistance7;

// ../../node_modules/date-fns/esm/locale/el/_lib/formatLong/index.js
var dateFormats4 = {
  full: "EEEE, d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "d/M/yy"
};
var timeFormats4 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats4 = {
  full: "{{date}} - {{time}}",
  long: "{{date}} - {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong4 = {
  date: buildFormatLongFn({
    formats: dateFormats4,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats4,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats4,
    defaultWidth: "full"
  })
};
var formatLong_default4 = formatLong4;

// ../../node_modules/date-fns/esm/locale/el/_lib/formatRelative/index.js
var formatRelativeLocale4 = {
  lastWeek: function lastWeek2(date) {
    switch (date.getUTCDay()) {
      case 6:
        return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
      default:
        return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
    }
  },
  yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
  today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
  tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
  nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
  other: "P"
};
var formatRelative7 = function formatRelative8(token, date) {
  var format2 = formatRelativeLocale4[token];
  if (typeof format2 === "function")
    return format2(date);
  return format2;
};
var formatRelative_default4 = formatRelative7;

// ../../node_modules/date-fns/esm/locale/el/_lib/localize/index.js
var eraValues4 = {
  narrow: ["\u03C0\u03A7", "\u03BC\u03A7"],
  abbreviated: ["\u03C0.\u03A7.", "\u03BC.\u03A7."],
  wide: ["\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD", "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"]
};
var quarterValues4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["\u03A41", "\u03A42", "\u03A43", "\u03A44"],
  wide: ["1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"]
};
var monthValues4 = {
  narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
  abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03AC\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03AC\u03B9", "\u0399\u03BF\u03CD\u03BD", "\u0399\u03BF\u03CD\u03BB", "\u0391\u03CD\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03AD", "\u0394\u03B5\u03BA"],
  wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2", "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2", "\u039C\u03AC\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2", "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2", "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"]
};
var formattingMonthValues2 = {
  narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
  abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03B1\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03B1\u0390", "\u0399\u03BF\u03C5\u03BD", "\u0399\u03BF\u03C5\u03BB", "\u0391\u03C5\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03B5", "\u0394\u03B5\u03BA"],
  wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5", "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5", "\u039C\u03B1\u0390\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5", "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5", "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"]
};
var dayValues4 = {
  narrow: ["\u039A", "\u0394", "T", "\u03A4", "\u03A0", "\u03A0", "\u03A3"],
  short: ["\u039A\u03C5", "\u0394\u03B5", "\u03A4\u03C1", "\u03A4\u03B5", "\u03A0\u03AD", "\u03A0\u03B1", "\u03A3\u03AC"],
  abbreviated: ["\u039A\u03C5\u03C1", "\u0394\u03B5\u03C5", "\u03A4\u03C1\u03AF", "\u03A4\u03B5\u03C4", "\u03A0\u03AD\u03BC", "\u03A0\u03B1\u03C1", "\u03A3\u03AC\u03B2"],
  wide: ["\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE", "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1", "\u03A4\u03C1\u03AF\u03C4\u03B7", "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7", "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7", "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE", "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"]
};
var dayPeriodValues4 = {
  narrow: {
    am: "\u03C0\u03BC",
    pm: "\u03BC\u03BC",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  },
  abbreviated: {
    am: "\u03C0.\u03BC.",
    pm: "\u03BC.\u03BC.",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  },
  wide: {
    am: "\u03C0.\u03BC.",
    pm: "\u03BC.\u03BC.",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  }
};
var ordinalNumber7 = function ordinalNumber8(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  var suffix;
  if (unit === "year" || unit === "month") {
    suffix = "\u03BF\u03C2";
  } else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") {
    suffix = "\u03B7";
  } else {
    suffix = "\u03BF";
  }
  return number + suffix;
};
var localize4 = {
  ordinalNumber: ordinalNumber7,
  era: buildLocalizeFn({
    values: eraValues4,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues4,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback4(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues4,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues2,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues4,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues4,
    defaultWidth: "wide"
  })
};
var localize_default4 = localize4;

// ../../node_modules/date-fns/esm/locale/el/_lib/match/index.js
var matchOrdinalNumberPattern4 = /^(\d+)(ος|η|ο)?/i;
var parseOrdinalNumberPattern4 = /\d+/i;
var matchEraPatterns4 = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var parseEraPatterns4 = {
  any: [/^π/i, /^(μ|κ)/i]
};
var matchQuarterPatterns4 = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var parseQuarterPatterns4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns4 = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var parseMonthPatterns4 = {
  narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
  any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
};
var matchDayPatterns4 = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var parseDayPatterns4 = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
};
var matchDayPeriodPatterns4 = {
  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var parseDayPeriodPatterns4 = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i
  }
};
var match4 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern4,
    parsePattern: parseOrdinalNumberPattern4,
    valueCallback: function valueCallback7(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns4,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns4,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns4,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns4,
    defaultParseWidth: "any",
    valueCallback: function valueCallback8(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns4,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns4,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns4,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns4,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns4,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns4,
    defaultParseWidth: "any"
  })
};
var match_default4 = match4;

// ../../node_modules/date-fns/esm/locale/el/index.js
var locale4 = {
  code: "el",
  formatDistance: formatDistance_default4,
  formatLong: formatLong_default4,
  formatRelative: formatRelative_default4,
  localize: localize_default4,
  match: match_default4,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var el_default = locale4;

// ../../node_modules/date-fns/esm/locale/hu/_lib/formatDistance/index.js
var translations = {
  about: "k\xF6r\xFClbel\xFCl",
  over: "t\xF6bb mint",
  almost: "majdnem",
  lessthan: "kevesebb mint"
};
var withoutSuffixes = {
  xseconds: " m\xE1sodperc",
  halfaminute: "f\xE9l perc",
  xminutes: " perc",
  xhours: " \xF3ra",
  xdays: " nap",
  xweeks: " h\xE9t",
  xmonths: " h\xF3nap",
  xyears: " \xE9v"
};
var withSuffixes = {
  xseconds: {
    "-1": " m\xE1sodperccel ezel\u0151tt",
    "1": " m\xE1sodperc m\xFAlva",
    "0": " m\xE1sodperce"
  },
  halfaminute: {
    "-1": "f\xE9l perccel ezel\u0151tt",
    "1": "f\xE9l perc m\xFAlva",
    "0": "f\xE9l perce"
  },
  xminutes: {
    "-1": " perccel ezel\u0151tt",
    "1": " perc m\xFAlva",
    "0": " perce"
  },
  xhours: {
    "-1": " \xF3r\xE1val ezel\u0151tt",
    "1": " \xF3ra m\xFAlva",
    "0": " \xF3r\xE1ja"
  },
  xdays: {
    "-1": " nappal ezel\u0151tt",
    "1": " nap m\xFAlva",
    "0": " napja"
  },
  xweeks: {
    "-1": " h\xE9ttel ezel\u0151tt",
    "1": " h\xE9t m\xFAlva",
    "0": " hete"
  },
  xmonths: {
    "-1": " h\xF3nappal ezel\u0151tt",
    "1": " h\xF3nap m\xFAlva",
    "0": " h\xF3napja"
  },
  xyears: {
    "-1": " \xE9vvel ezel\u0151tt",
    "1": " \xE9v m\xFAlva",
    "0": " \xE9ve"
  }
};
var formatDistance9 = function formatDistance10(token, count, options) {
  var adverb = token.match(/about|over|almost|lessthan/i);
  var unit = adverb ? token.replace(adverb[0], "") : token;
  var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
  var key = unit.toLowerCase();
  var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
  var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
  var result = key === "halfaminute" ? translated : count + translated;
  if (adverb) {
    var adv = adverb[0].toLowerCase();
    result = translations[adv] + " " + result;
  }
  return result;
};
var formatDistance_default5 = formatDistance9;

// ../../node_modules/date-fns/esm/locale/hu/_lib/formatLong/index.js
var dateFormats5 = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd."
};
var timeFormats5 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
};
var dateTimeFormats5 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong5 = {
  date: buildFormatLongFn({
    formats: dateFormats5,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats5,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats5,
    defaultWidth: "full"
  })
};
var formatLong_default5 = formatLong5;

// ../../node_modules/date-fns/esm/locale/hu/_lib/formatRelative/index.js
var accusativeWeekdays = ["vas\xE1rnap", "h\xE9tf\u0151n", "kedden", "szerd\xE1n", "cs\xFCt\xF6rt\xF6k\xF6n", "p\xE9nteken", "szombaton"];
function week(isFuture) {
  return function(date) {
    var weekday = accusativeWeekdays[date.getUTCDay()];
    var prefix = isFuture ? "" : "'m\xFAlt' ";
    return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
  };
}
var formatRelativeLocale5 = {
  lastWeek: week(false),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: week(true),
  other: "P"
};
var formatRelative9 = function formatRelative10(token, date) {
  var format2 = formatRelativeLocale5[token];
  if (typeof format2 === "function") {
    return format2(date);
  }
  return format2;
};
var formatRelative_default5 = formatRelative9;

// ../../node_modules/date-fns/esm/locale/hu/_lib/localize/index.js
var eraValues5 = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus el\u0151tt", "id\u0151sz\xE1m\xEDt\xE1sunk szerint"]
};
var quarterValues5 = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.\xE9v", "2. n.\xE9v", "3. n.\xE9v", "4. n.\xE9v"],
  wide: ["1. negyed\xE9v", "2. negyed\xE9v", "3. negyed\xE9v", "4. negyed\xE9v"]
};
var formattingQuarterValues = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.\xE9v", "II. n.\xE9v", "III. n.\xE9v", "IV. n.\xE9v"],
  wide: ["I. negyed\xE9v", "II. negyed\xE9v", "III. negyed\xE9v", "IV. negyed\xE9v"]
};
var monthValues5 = {
  narrow: ["J", "F", "M", "\xC1", "M", "J", "J", "A", "Sz", "O", "N", "D"],
  abbreviated: ["jan.", "febr.", "m\xE1rc.", "\xE1pr.", "m\xE1j.", "j\xFAn.", "j\xFAl.", "aug.", "szept.", "okt.", "nov.", "dec."],
  wide: ["janu\xE1r", "febru\xE1r", "m\xE1rcius", "\xE1prilis", "m\xE1jus", "j\xFAnius", "j\xFAlius", "augusztus", "szeptember", "okt\xF3ber", "november", "december"]
};
var dayValues5 = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: ["vas\xE1rnap", "h\xE9tf\u0151", "kedd", "szerda", "cs\xFCt\xF6rt\xF6k", "p\xE9ntek", "szombat"]
};
var dayPeriodValues5 = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "\xE9jf\xE9l",
    noon: "d\xE9l",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "\xE9jjel"
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "\xE9jf\xE9l",
    noon: "d\xE9l",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "\xE9jjel"
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "\xE9jf\xE9l",
    noon: "d\xE9l",
    morning: "reggel",
    afternoon: "d\xE9lut\xE1n",
    evening: "este",
    night: "\xE9jjel"
  }
};
var ordinalNumber9 = function ordinalNumber10(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize5 = {
  ordinalNumber: ordinalNumber9,
  era: buildLocalizeFn({
    values: eraValues5,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues5,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback5(quarter) {
      return quarter - 1;
    },
    formattingValues: formattingQuarterValues,
    defaultFormattingWidth: "wide"
  }),
  month: buildLocalizeFn({
    values: monthValues5,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues5,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues5,
    defaultWidth: "wide"
  })
};
var localize_default5 = localize5;

// ../../node_modules/date-fns/esm/locale/hu/_lib/match/index.js
var matchOrdinalNumberPattern5 = /^(\d+)\.?/i;
var parseOrdinalNumberPattern5 = /\d+/i;
var matchEraPatterns5 = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var parseEraPatterns5 = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
};
var matchQuarterPatterns5 = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var parseQuarterPatterns5 = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
};
var matchMonthPatterns5 = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var parseMonthPatterns5 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns5 = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var parseDayPatterns5 = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
};
var matchDayPeriodPatterns5 = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var parseDayPeriodPatterns5 = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
};
var match5 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern5,
    parsePattern: parseOrdinalNumberPattern5,
    valueCallback: function valueCallback9(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns5,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns5,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns5,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns5,
    defaultParseWidth: "any",
    valueCallback: function valueCallback10(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns5,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns5,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns5,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns5,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns5,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns5,
    defaultParseWidth: "any"
  })
};
var match_default5 = match5;

// ../../node_modules/date-fns/esm/locale/hu/index.js
var locale5 = {
  code: "hu",
  formatDistance: formatDistance_default5,
  formatLong: formatLong_default5,
  formatRelative: formatRelative_default5,
  localize: localize_default5,
  match: match_default5,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var hu_default = locale5;

// ../../node_modules/date-fns/esm/locale/it/_lib/formatDistance/index.js
var formatDistanceLocale5 = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "pi\xF9 di un anno",
    other: "pi\xF9 di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
};
var formatDistance11 = function formatDistance12(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale5[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "tra " + result;
    } else {
      return result + " fa";
    }
  }
  return result;
};
var formatDistance_default6 = formatDistance11;

// ../../node_modules/date-fns/esm/locale/it/_lib/formatLong/index.js
var dateFormats6 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
var timeFormats6 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats6 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong6 = {
  date: buildFormatLongFn({
    formats: dateFormats6,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats6,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats6,
    defaultWidth: "full"
  })
};
var formatLong_default6 = formatLong6;

// ../../node_modules/date-fns/esm/locale/it/_lib/formatRelative/index.js
var weekdays2 = ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"];
function _lastWeek(day) {
  switch (day) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + weekdays2[day] + " scorso alle' p";
  }
}
function thisWeek2(day) {
  return "'" + weekdays2[day] + " alle' p";
}
function _nextWeek(day) {
  switch (day) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + weekdays2[day] + " prossimo alle' p";
  }
}
var formatRelativeLocale6 = {
  lastWeek: function lastWeek3(date, baseDate, options) {
    var day = date.getUTCDay();
    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek2(day);
    } else {
      return _lastWeek(day);
    }
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function nextWeek2(date, baseDate, options) {
    var day = date.getUTCDay();
    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek2(day);
    } else {
      return _nextWeek(day);
    }
  },
  other: "P"
};
var formatRelative11 = function formatRelative12(token, date, baseDate, options) {
  var format2 = formatRelativeLocale6[token];
  if (typeof format2 === "function") {
    return format2(date, baseDate, options);
  }
  return format2;
};
var formatRelative_default6 = formatRelative11;

// ../../node_modules/date-fns/esm/locale/it/_lib/localize/index.js
var eraValues6 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
};
var quarterValues6 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues6 = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
};
var dayValues6 = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"]
};
var dayPeriodValues6 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
};
var formattingDayPeriodValues3 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
};
var ordinalNumber11 = function ordinalNumber12(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return String(number);
};
var localize6 = {
  ordinalNumber: ordinalNumber11,
  era: buildLocalizeFn({
    values: eraValues6,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues6,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback6(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues6,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues6,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues6,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues3,
    defaultFormattingWidth: "wide"
  })
};
var localize_default6 = localize6;

// ../../node_modules/date-fns/esm/locale/it/_lib/match/index.js
var matchOrdinalNumberPattern6 = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern6 = /\d+/i;
var matchEraPatterns6 = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns6 = {
  any: [/^a/i, /^(d|e)/i]
};
var matchQuarterPatterns6 = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns6 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns6 = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns6 = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns6 = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns6 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns6 = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns6 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
};
var match6 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern6,
    parsePattern: parseOrdinalNumberPattern6,
    valueCallback: function valueCallback11(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns6,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns6,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns6,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns6,
    defaultParseWidth: "any",
    valueCallback: function valueCallback12(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns6,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns6,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns6,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns6,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns6,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns6,
    defaultParseWidth: "any"
  })
};
var match_default6 = match6;

// ../../node_modules/date-fns/esm/locale/it/index.js
var locale6 = {
  code: "it",
  formatDistance: formatDistance_default6,
  formatLong: formatLong_default6,
  formatRelative: formatRelative_default6,
  localize: localize_default6,
  match: match_default6,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var it_default = locale6;

// ../../node_modules/date-fns/esm/locale/pt/_lib/formatDistance/index.js
var formatDistanceLocale6 = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 m\xEAs",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 m\xEAs",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
};
var formatDistance13 = function formatDistance14(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale6[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "daqui a " + result;
    } else {
      return "h\xE1 " + result;
    }
  }
  return result;
};
var formatDistance_default7 = formatDistance13;

// ../../node_modules/date-fns/esm/locale/pt/_lib/formatLong/index.js
var dateFormats7 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
};
var timeFormats7 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats7 = {
  full: "{{date}} '\xE0s' {{time}}",
  long: "{{date}} '\xE0s' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong7 = {
  date: buildFormatLongFn({
    formats: dateFormats7,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats7,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats7,
    defaultWidth: "full"
  })
};
var formatLong_default7 = formatLong7;

// ../../node_modules/date-fns/esm/locale/pt/_lib/formatRelative/index.js
var formatRelativeLocale7 = {
  lastWeek: function lastWeek4(date) {
    var weekday = date.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? "\xFAltimo" : "\xFAltima";
    return "'" + last + "' eeee '\xE0s' p";
  },
  yesterday: "'ontem \xE0s' p",
  today: "'hoje \xE0s' p",
  tomorrow: "'amanh\xE3 \xE0s' p",
  nextWeek: "eeee '\xE0s' p",
  other: "P"
};
var formatRelative13 = function formatRelative14(token, date, _baseDate, _options) {
  var format2 = formatRelativeLocale7[token];
  if (typeof format2 === "function") {
    return format2(date);
  }
  return format2;
};
var formatRelative_default7 = formatRelative13;

// ../../node_modules/date-fns/esm/locale/pt/_lib/localize/index.js
var eraValues7 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
};
var quarterValues7 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues7 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
};
var dayValues7 = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
};
var dayPeriodValues7 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
};
var formattingDayPeriodValues4 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
};
var ordinalNumber13 = function ordinalNumber14(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + "\xBA";
};
var localize7 = {
  ordinalNumber: ordinalNumber13,
  era: buildLocalizeFn({
    values: eraValues7,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues7,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback7(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues7,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues7,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues7,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues4,
    defaultFormattingWidth: "wide"
  })
};
var localize_default7 = localize7;

// ../../node_modules/date-fns/esm/locale/pt/_lib/match/index.js
var matchOrdinalNumberPattern7 = /^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern7 = /\d+/i;
var matchEraPatterns7 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns7 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
};
var matchQuarterPatterns7 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns7 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns7 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns7 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns7 = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns7 = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
};
var matchDayPeriodPatterns7 = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns7 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
};
var match7 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern7,
    parsePattern: parseOrdinalNumberPattern7,
    valueCallback: function valueCallback13(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns7,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns7,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns7,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns7,
    defaultParseWidth: "any",
    valueCallback: function valueCallback14(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns7,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns7,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns7,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns7,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns7,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns7,
    defaultParseWidth: "any"
  })
};
var match_default7 = match7;

// ../../node_modules/date-fns/esm/locale/pt/index.js
var locale7 = {
  code: "pt",
  formatDistance: formatDistance_default7,
  formatLong: formatLong_default7,
  formatRelative: formatRelative_default7,
  localize: localize_default7,
  match: match_default7,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var pt_default = locale7;

// ../../node_modules/date-fns/esm/locale/ro/_lib/formatDistance/index.js
var formatDistanceLocale7 = {
  lessThanXSeconds: {
    one: "mai pu\u021Bin de o secund\u0103",
    other: "mai pu\u021Bin de {{count}} secunde"
  },
  xSeconds: {
    one: "1 secund\u0103",
    other: "{{count}} secunde"
  },
  halfAMinute: "jum\u0103tate de minut",
  lessThanXMinutes: {
    one: "mai pu\u021Bin de un minut",
    other: "mai pu\u021Bin de {{count}} minute"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "circa 1 or\u0103",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "1 or\u0103",
    other: "{{count}} ore"
  },
  xDays: {
    one: "1 zi",
    other: "{{count}} zile"
  },
  aboutXWeeks: {
    one: "circa o s\u0103pt\u0103m\xE2n\u0103",
    other: "circa {{count}} s\u0103pt\u0103m\xE2ni"
  },
  xWeeks: {
    one: "1 s\u0103pt\u0103m\xE2n\u0103",
    other: "{{count}} s\u0103pt\u0103m\xE2ni"
  },
  aboutXMonths: {
    one: "circa 1 lun\u0103",
    other: "circa {{count}} luni"
  },
  xMonths: {
    one: "1 lun\u0103",
    other: "{{count}} luni"
  },
  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ani"
  },
  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani"
  },
  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani"
  }
};
var formatDistance15 = function formatDistance16(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale7[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "\xEEn " + result;
    } else {
      return result + " \xEEn urm\u0103";
    }
  }
  return result;
};
var formatDistance_default8 = formatDistance15;

// ../../node_modules/date-fns/esm/locale/ro/_lib/formatLong/index.js
var dateFormats8 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
};
var timeFormats8 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats8 = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong8 = {
  date: buildFormatLongFn({
    formats: dateFormats8,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats8,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats8,
    defaultWidth: "full"
  })
};
var formatLong_default8 = formatLong8;

// ../../node_modules/date-fns/esm/locale/ro/_lib/formatRelative/index.js
var formatRelativeLocale8 = {
  lastWeek: "eeee 'trecut\u0103 la' p",
  yesterday: "'ieri la' p",
  today: "'ast\u0103zi la' p",
  tomorrow: "'m\xE2ine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P"
};
var formatRelative15 = function formatRelative16(token, _date, _baseDate, _options) {
  return formatRelativeLocale8[token];
};
var formatRelative_default8 = formatRelative15;

// ../../node_modules/date-fns/esm/locale/ro/_lib/localize/index.js
var eraValues8 = {
  narrow: ["\xCE", "D"],
  abbreviated: ["\xCE.d.C.", "D.C."],
  wide: ["\xCEnainte de Cristos", "Dup\u0103 Cristos"]
};
var quarterValues8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["primul trimestru", "al doilea trimestru", "al treilea trimestru", "al patrulea trimestru"]
};
var monthValues8 = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sep", "oct", "noi", "dec"],
  wide: ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"]
};
var dayValues8 = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "s\xE2"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "s\xE2m"],
  wide: ["duminic\u0103", "luni", "mar\u021Bi", "miercuri", "joi", "vineri", "s\xE2mb\u0103t\u0103"]
};
var dayPeriodValues8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  }
};
var formattingDayPeriodValues5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  }
};
var ordinalNumber15 = function ordinalNumber16(dirtyNumber, _options) {
  return String(dirtyNumber);
};
var localize8 = {
  ordinalNumber: ordinalNumber15,
  era: buildLocalizeFn({
    values: eraValues8,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues8,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback8(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues8,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues8,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues8,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues5,
    defaultFormattingWidth: "wide"
  })
};
var localize_default8 = localize8;

// ../../node_modules/date-fns/esm/locale/ro/_lib/match/index.js
var matchOrdinalNumberPattern8 = /^(\d+)?/i;
var parseOrdinalNumberPattern8 = /\d+/i;
var matchEraPatterns8 = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var parseEraPatterns8 = {
  any: [/^ÎC/i, /^DC/i],
  wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
};
var matchQuarterPatterns8 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
};
var parseQuarterPatterns8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns8 = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var parseMonthPatterns8 = {
  narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns8 = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var parseDayPatterns8 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns8 = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var parseDayPeriodPatterns8 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
};
var match8 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern8,
    parsePattern: parseOrdinalNumberPattern8,
    valueCallback: function valueCallback15(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns8,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns8,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns8,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns8,
    defaultParseWidth: "any",
    valueCallback: function valueCallback16(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns8,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns8,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns8,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns8,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns8,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns8,
    defaultParseWidth: "any"
  })
};
var match_default8 = match8;

// ../../node_modules/date-fns/esm/locale/ro/index.js
var locale8 = {
  code: "ro",
  formatDistance: formatDistance_default8,
  formatLong: formatLong_default8,
  formatRelative: formatRelative_default8,
  localize: localize_default8,
  match: match_default8,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var ro_default = locale8;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatDistance/index.js
var formatDistanceLocale8 = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 nedelju",
      withPrepositionAgo: "oko 1 nedelju",
      withPrepositionIn: "oko 1 nedelju"
    },
    dual: "oko {{count}} nedelje",
    other: "oko {{count}} nedelje"
  },
  xWeeks: {
    one: {
      standalone: "1 nedelju",
      withPrepositionAgo: "1 nedelju",
      withPrepositionIn: "1 nedelju"
    },
    dual: "{{count}} nedelje",
    other: "{{count}} nedelje"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mesec",
      withPrepositionAgo: "oko 1 mesec",
      withPrepositionIn: "oko 1 mesec"
    },
    dual: "oko {{count}} meseca",
    other: "oko {{count}} meseci"
  },
  xMonths: {
    one: {
      standalone: "1 mesec",
      withPrepositionAgo: "1 mesec",
      withPrepositionIn: "1 mesec"
    },
    dual: "{{count}} meseca",
    other: "{{count}} meseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
};
var formatDistance17 = function formatDistance18(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale8[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        result = tokenValue.one.withPrepositionIn;
      } else {
        result = tokenValue.one.withPrepositionAgo;
      }
    } else {
      result = tokenValue.one.standalone;
    }
  } else if (count % 10 > 1 && count % 10 < 5 && String(count).substr(-2, 1) !== "1") {
    result = tokenValue.dual.replace("{{count}}", String(count));
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "za " + result;
    } else {
      return "pre " + result;
    }
  }
  return result;
};
var formatDistance_default9 = formatDistance17;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatLong/index.js
var dateFormats9 = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
};
var timeFormats9 = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats9 = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong9 = {
  date: buildFormatLongFn({
    formats: dateFormats9,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats9,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats9,
    defaultWidth: "full"
  })
};
var formatLong_default9 = formatLong9;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatRelative/index.js
var formatRelativeLocale9 = {
  lastWeek: function lastWeek5(date) {
    switch (date.getUTCDay()) {
      case 0:
        return "'pro\u0161le nedelje u' p";
      case 3:
        return "'pro\u0161le srede u' p";
      case 6:
        return "'pro\u0161le subote u' p";
      default:
        return "'pro\u0161li' EEEE 'u' p";
    }
  },
  yesterday: "'ju\u010De u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function nextWeek3(date) {
    switch (date.getUTCDay()) {
      case 0:
        return "'slede\u0107e nedelje u' p";
      case 3:
        return "'slede\u0107u sredu u' p";
      case 6:
        return "'slede\u0107u subotu u' p";
      default:
        return "'slede\u0107i' EEEE 'u' p";
    }
  },
  other: "P"
};
var formatRelative17 = function formatRelative18(token, date, _baseDate, _options) {
  var format2 = formatRelativeLocale9[token];
  if (typeof format2 === "function") {
    return format2(date);
  }
  return format2;
};
var formatRelative_default9 = formatRelative17;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/localize/index.js
var eraValues9 = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"]
};
var quarterValues9 = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
};
var monthValues9 = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
};
var formattingMonthValues3 = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
};
var dayValues9 = {
  narrow: ["N", "P", "U", "S", "\u010C", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
  wide: ["nedelja", "ponedeljak", "utorak", "sreda", "\u010Detvrtak", "petak", "subota"]
};
var formattingDayPeriodValues6 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uve\u010De",
    night: "no\u0107u"
  }
};
var dayPeriodValues9 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uve\u010De",
    night: "no\u0107u"
  }
};
var ordinalNumber17 = function ordinalNumber18(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize9 = {
  ordinalNumber: ordinalNumber17,
  era: buildLocalizeFn({
    values: eraValues9,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues9,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback9(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues9,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues3,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues9,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues9,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues6,
    defaultFormattingWidth: "wide"
  })
};
var localize_default9 = localize9;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/match/index.js
var matchOrdinalNumberPattern9 = /^(\d+)\./i;
var parseOrdinalNumberPattern9 = /\d+/i;
var matchEraPatterns9 = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var parseEraPatterns9 = {
  any: [/^pr/i, /^(po|nova)/i]
};
var matchQuarterPatterns9 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns9 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns9 = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns9 = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns9 = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns9 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns9 = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var parseDayPeriodPatterns9 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
};
var match9 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern9,
    parsePattern: parseOrdinalNumberPattern9,
    valueCallback: function valueCallback17(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns9,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns9,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns9,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns9,
    defaultParseWidth: "any",
    valueCallback: function valueCallback18(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns9,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns9,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns9,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns9,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns9,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns9,
    defaultParseWidth: "any"
  })
};
var match_default9 = match9;

// ../../node_modules/date-fns/esm/locale/sr-Latn/index.js
var locale9 = {
  code: "sr-Latn",
  formatDistance: formatDistance_default9,
  formatLong: formatLong_default9,
  formatRelative: formatRelative_default9,
  localize: localize_default9,
  match: match_default9,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var sr_Latn_default = locale9;

// ../../node_modules/date-fns/esm/locale/tr/_lib/formatDistance/index.js
var formatDistanceLocale9 = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az"
  },
  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye"
  },
  halfAMinute: "yar\u0131m dakika",
  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az"
  },
  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika"
  },
  aboutXHours: {
    one: "yakla\u015F\u0131k 1 saat",
    other: "yakla\u015F\u0131k {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 g\xFCn",
    other: "{{count}} g\xFCn"
  },
  aboutXWeeks: {
    one: "yakla\u015F\u0131k 1 hafta",
    other: "yakla\u015F\u0131k {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "yakla\u015F\u0131k 1 ay",
    other: "yakla\u015F\u0131k {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "yakla\u015F\u0131k 1 y\u0131l",
    other: "yakla\u015F\u0131k {{count}} y\u0131l"
  },
  xYears: {
    one: "1 y\u0131l",
    other: "{{count}} y\u0131l"
  },
  overXYears: {
    one: "1 y\u0131ldan fazla",
    other: "{{count}} y\u0131ldan fazla"
  },
  almostXYears: {
    one: "neredeyse 1 y\u0131l",
    other: "neredeyse {{count}} y\u0131l"
  }
};
var formatDistance19 = function formatDistance20(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale9[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " sonra";
    } else {
      return result + " \xF6nce";
    }
  }
  return result;
};
var formatDistance_default10 = formatDistance19;

// ../../node_modules/date-fns/esm/locale/tr/_lib/formatLong/index.js
var dateFormats10 = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
};
var timeFormats10 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats10 = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong10 = {
  date: buildFormatLongFn({
    formats: dateFormats10,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats10,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats10,
    defaultWidth: "full"
  })
};
var formatLong_default10 = formatLong10;

// ../../node_modules/date-fns/esm/locale/tr/_lib/formatRelative/index.js
var formatRelativeLocale10 = {
  lastWeek: "'ge\xE7en hafta' eeee 'saat' p",
  yesterday: "'d\xFCn saat' p",
  today: "'bug\xFCn saat' p",
  tomorrow: "'yar\u0131n saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P"
};
var formatRelative19 = function formatRelative20(token, _date, _baseDate, _options) {
  return formatRelativeLocale10[token];
};
var formatRelative_default10 = formatRelative19;

// ../../node_modules/date-fns/esm/locale/tr/_lib/localize/index.js
var eraValues10 = {
  narrow: ["M\xD6", "MS"],
  abbreviated: ["M\xD6", "MS"],
  wide: ["Milattan \xD6nce", "Milattan Sonra"]
};
var quarterValues10 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1\xC7", "2\xC7", "3\xC7", "4\xC7"],
  wide: ["\u0130lk \xE7eyrek", "\u0130kinci \xC7eyrek", "\xDC\xE7\xFCnc\xFC \xE7eyrek", "Son \xE7eyrek"]
};
var monthValues10 = {
  narrow: ["O", "\u015E", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: ["Oca", "\u015Eub", "Mar", "Nis", "May", "Haz", "Tem", "A\u011Fu", "Eyl", "Eki", "Kas", "Ara"],
  wide: ["Ocak", "\u015Eubat", "Mart", "Nisan", "May\u0131s", "Haziran", "Temmuz", "A\u011Fustos", "Eyl\xFCl", "Ekim", "Kas\u0131m", "Aral\u0131k"]
};
var dayValues10 = {
  narrow: ["P", "P", "S", "\xC7", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "\xC7a", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "\xC7ar", "Per", "Cum", "Cts"],
  wide: ["Pazar", "Pazartesi", "Sal\u0131", "\xC7ar\u015Famba", "Per\u015Fembe", "Cuma", "Cumartesi"]
};
var dayPeriodValues10 = {
  narrow: {
    am: "\xF6\xF6",
    pm: "\xF6s",
    midnight: "gy",
    noon: "\xF6",
    morning: "sa",
    afternoon: "\xF6s",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "\xD6\xD6",
    pm: "\xD6S",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Fle",
    morning: "sabah",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Fam",
    night: "gece"
  },
  wide: {
    am: "\xD6.\xD6.",
    pm: "\xD6.S.",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Fle",
    morning: "sabah",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Fam",
    night: "gece"
  }
};
var formattingDayPeriodValues7 = {
  narrow: {
    am: "\xF6\xF6",
    pm: "\xF6s",
    midnight: "gy",
    noon: "\xF6",
    morning: "sa",
    afternoon: "\xF6s",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "\xD6\xD6",
    pm: "\xD6S",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Flen",
    morning: "sabahleyin",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Famleyin",
    night: "geceleyin"
  },
  wide: {
    am: "\xF6.\xF6.",
    pm: "\xF6.s.",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Flen",
    morning: "sabahleyin",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Famleyin",
    night: "geceleyin"
  }
};
var ordinalNumber19 = function ordinalNumber20(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize10 = {
  ordinalNumber: ordinalNumber19,
  era: buildLocalizeFn({
    values: eraValues10,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues10,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback10(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues10,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues10,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues10,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues7,
    defaultFormattingWidth: "wide"
  })
};
var localize_default10 = localize10;

// ../../node_modules/date-fns/esm/locale/tr/_lib/match/index.js
var matchOrdinalNumberPattern10 = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern10 = /\d+/i;
var matchEraPatterns10 = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
};
var parseEraPatterns10 = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
};
var matchQuarterPatterns10 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var parseQuarterPatterns10 = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
};
var matchMonthPatterns10 = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var parseMonthPatterns10 = {
  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
};
var matchDayPatterns10 = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var parseDayPatterns10 = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [/^pazar(?!tesi)/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma(?!rtesi)/i, /^cumartesi/i]
};
var matchDayPeriodPatterns10 = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var parseDayPeriodPatterns10 = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
};
var match10 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern10,
    parsePattern: parseOrdinalNumberPattern10,
    valueCallback: function valueCallback19(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns10,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns10,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns10,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns10,
    defaultParseWidth: "any",
    valueCallback: function valueCallback20(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns10,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns10,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns10,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns10,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns10,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns10,
    defaultParseWidth: "any"
  })
};
var match_default10 = match10;

// ../../node_modules/date-fns/esm/locale/tr/index.js
var locale10 = {
  code: "tr",
  formatDistance: formatDistance_default10,
  formatLong: formatLong_default10,
  formatRelative: formatRelative_default10,
  localize: localize_default10,
  match: match_default10,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var tr_default = locale10;

// src/molecules/CalendarDropdown/CalendarMenu/CalendarMenu.tsx
var getCurrentLocale = (lang) => {
  switch (lang) {
    case "bg":
      return bg_default;
    case "en":
      return en_US_default;
    case "el":
      return el_default;
    case "ro":
      return ro_default;
    case "tr":
      return tr_default;
    case "de":
      return de_default;
    case "pt":
      return pt_default;
    case "it":
      return it_default;
    case "sr":
      return sr_Latn_default;
    case "hu":
      return hu_default;
    default:
      return en_US_default;
  }
};
var CalendarMenu = ({ initialDate, onDateSelect }) => {
  var _a2;
  const { sdkOptions } = useContext2(ConfigContext);
  const [currentMonth, setCurrentMonth] = useState8(new Date(initialDate));
  const [selectedDate, setSelectedDate] = useState8(new Date(initialDate));
  const currentLocale = getCurrentLocale((_a2 = sdkOptions == null ? void 0 : sdkOptions.dataConfigLang) != null ? _a2 : "en");
  useEffect7(() => {
    setSelectedDate(new Date(initialDate));
    setCurrentMonth(new Date(initialDate));
  }, [initialDate]);
  const onDateClick = (day) => {
    setSelectedDate(day);
    onDateSelect(day);
  };
  const nextMonth = () => setCurrentMonth(addMonths(currentMonth, 1));
  const prevMonth = () => setCurrentMonth(subMonths(currentMonth, 1));
  const getDayNames = () => {
    const weekDays = [];
    const firstDayOfWeek = startOfWeek(new Date(), { weekStartsOn: 1 });
    for (let i3 = 0; i3 < 7; i3++) {
      weekDays.push(format(addDays(firstDayOfWeek, i3), "EEEEEE", { locale: currentLocale }));
    }
    return weekDays;
  };
  const renderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart, { weekStartsOn: 1 });
    const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 });
    const rows = [];
    let days = [];
    let day = startDate;
    while (day <= endDate) {
      for (let i3 = 0; i3 < 7; i3++) {
        const cloneDay = day;
        const isCurrentMonth = isSameMonth(day, monthStart);
        days.push(/* @__PURE__ */ React11.createElement("div", {
          key: day.toString(),
          onClick: () => isCurrentMonth ? onDateClick(cloneDay) : null,
          className: classNames6({
            "p-2 text-center text-4 rounded-full cursor-pointer": true,
            "text-hiContrast hover:bg-pillActiveBackgroundColor hover:text-pillActiveTextColor hover:opacity-50": !isSameDay(day, selectedDate) && isCurrentMonth,
            "bg-pillActiveBackgroundColor text-pillActiveTextColor font-bold": isSameDay(day, selectedDate),
            "text-[#bfbfbf] cursor-default": !isCurrentMonth
          })
        }, format(day, "d")));
        day = addDays(day, 1);
      }
      rows.push(/* @__PURE__ */ React11.createElement("div", {
        key: day.toString(),
        className: "grid grid-cols-7 gap-1 mb-1"
      }, days));
      days = [];
    }
    return /* @__PURE__ */ React11.createElement("div", {
      className: "px-4 pb-4"
    }, rows);
  };
  return /* @__PURE__ */ React11.createElement("div", {
    className: "calendar-menu absolute top-full left-1/2 -translate-x-1/2 mt-3 bg-rowBackgroundColor rounded-lg z-50 min-w-[280px] border shadow-lg border-calendarHeaderBgcColor"
  }, /* @__PURE__ */ React11.createElement("div", {
    className: "flex justify-between items-center bg-calendarHeaderBgcColor p-4 h-[60px]"
  }, /* @__PURE__ */ React11.createElement("div", {
    onClick: prevMonth,
    className: "flex items-center justify-center w-7 h-7 border-[1px] border-dropdownBorderColor rounded-2 cursor-pointer"
  }, /* @__PURE__ */ React11.createElement(ArrowLeftIcon, null)), /* @__PURE__ */ React11.createElement("span", {
    className: "text-5 font-bold text-hiContrast capitalize"
  }, format(currentMonth, "MMMM yyyy", { locale: currentLocale })), /* @__PURE__ */ React11.createElement("div", {
    onClick: nextMonth,
    className: "flex items-center justify-center w-7 h-7 border-[1px] border-dropdownBorderColor rounded-2 cursor-pointer"
  }, /* @__PURE__ */ React11.createElement(ArrowRightIcon, null))), /* @__PURE__ */ React11.createElement("div", {
    className: "grid grid-cols-7 gap-1 p-4"
  }, getDayNames().map((day) => /* @__PURE__ */ React11.createElement("div", {
    key: day,
    className: "text-center text-4 font-normal text-hiContrast py-1 capitalize"
  }, day))), renderCells());
};

// src/molecules/CalendarDropdown/Calendar.tsx
import { defaultHandleUserInteractionClick as defaultHandleUserInteractionClick4 } from "@sportal365/smp-widget-utils";
var Calendar = ({ selectedDate, dataDate, handleClick, handleDateChange }) => {
  const { ref, isComponentVisible, setIsComponentVisible } = useDetectClickOutside();
  const handlePreviousMonth = () => {
    handleDateChange(subDays(selectedDate, 1));
    defaultHandleUserInteractionClick4(handleClick, USER_INTERACTION, DROPDOWN_SELECTION_SUBSCRIBE_TYPE);
  };
  const handleNextMonth = () => {
    handleDateChange(addDays(selectedDate, 1));
    defaultHandleUserInteractionClick4(handleClick, USER_INTERACTION, DROPDOWN_SELECTION_SUBSCRIBE_TYPE);
  };
  const handleDate = (date) => {
    date && handleDateChange(date);
    defaultHandleUserInteractionClick4(handleClick, USER_INTERACTION, DROPDOWN_SELECTION_SUBSCRIBE_TYPE);
    setIsComponentVisible(false);
  };
  const handleCalendarToggle = () => setIsComponentVisible((prev) => !prev);
  return /* @__PURE__ */ React12.createElement("div", {
    ref,
    className: "calendar-dropdown-container flex flex-1"
  }, /* @__PURE__ */ React12.createElement(CalendarIcon2, {
    handleClick: handlePreviousMonth,
    position: "left"
  }), /* @__PURE__ */ React12.createElement("div", {
    className: "calendar-dropdown-btn-container relative w-full sm:w-[250px]"
  }, /* @__PURE__ */ React12.createElement(CalendarBtn, {
    dataDate,
    isCalendarOpen: isComponentVisible != null ? isComponentVisible : false,
    value: selectedDate,
    onClick: handleCalendarToggle
  }), isComponentVisible && /* @__PURE__ */ React12.createElement(CalendarMenu, {
    onDateSelect: handleDate,
    initialDate: selectedDate
  })), /* @__PURE__ */ React12.createElement(CalendarIcon2, {
    handleClick: handleNextMonth,
    position: "right"
  }));
};
var Calendar_default = Calendar;

// src/molecules/PillTabsHeader/PillTabsHeader.tsx
var PillTabsHeader = ({
  selectedDate,
  dataDate,
  selectedPillTab,
  pillTabOptions,
  displayPillTabs,
  displayDateDropdown,
  handleClick,
  handlePillTabChange,
  handleDateChange
}) => {
  if (!displayPillTabs && !displayDateDropdown)
    return null;
  return /* @__PURE__ */ React13.createElement("div", {
    className: "pill-tabs-header-container flex justify-between items-center gap-3 py-3 px-4 bg-filtersContainerPrimaryBackgroundColor flex-wrap"
  }, displayPillTabs && /* @__PURE__ */ React13.createElement(PillTabsV2, {
    selectedPillTab,
    pillTabOptions,
    handlePillTabChange
  }), displayDateDropdown && /* @__PURE__ */ React13.createElement(Calendar_default, {
    selectedDate,
    dataDate,
    handleClick,
    handleDateChange
  }));
};

// ../constants/sportRegions.ts
var DOMESTIC = "DOMESTIC";
var NATIONAL = "national";

// ../constants/stageType.ts
var StageTypes;
(function(StageTypes2) {
  StageTypes2["KNOCK_OUT"] = "KNOCK_OUT";
  StageTypes2["FRIENDLY"] = "FRIENDLY";
  StageTypes2["STANDINGS"] = "STANDINGS";
  StageTypes2["GROUPS"] = "GROUPS";
})(StageTypes || (StageTypes = {}));

// src/molecules/Tournament/Tournament.tsx
import { useContext as useContext3 } from "react";
var getTournamentName = ({ tournament, sport }) => {
  var _a2, _b, _c, _d2, _e;
  if (sport === Sports.FOOTBALL && (tournament == null ? void 0 : tournament.hasMultipleStages)) {
    return (_a2 = tournament == null ? void 0 : tournament.stage) == null ? void 0 : _a2.name;
  }
  if (sport === Sports.FOOTBALL && !(tournament == null ? void 0 : tournament.hasMultipleStages) && !(tournament == null ? void 0 : tournament.isDomestic) && (tournament == null ? void 0 : tournament.stage)) {
    return ((_b = tournament == null ? void 0 : tournament.stage) == null ? void 0 : _b.type) === StageTypes.KNOCK_OUT && ((_c = tournament == null ? void 0 : tournament.round) == null ? void 0 : _c.name) ? (_d2 = tournament == null ? void 0 : tournament.round) == null ? void 0 : _d2.name : (_e = tournament == null ? void 0 : tournament.stage) == null ? void 0 : _e.name;
  }
  if (sport === Sports.FOOTBALL && !(tournament == null ? void 0 : tournament.hasMultipleStages) && !(tournament == null ? void 0 : tournament.isDomestic) && !(tournament == null ? void 0 : tournament.stage)) {
    return tournament == null ? void 0 : tournament.name;
  }
  if (sport === Sports.TENNIS && (tournament == null ? void 0 : tournament.season)) {
    return `${tournament.name}-${tournament.season}`;
  }
  return tournament == null ? void 0 : tournament.name;
};
var getTournamentSubName = ({ tournament, sport }) => {
  var _a2, _b, _c, _d2, _e;
  if (sport === Sports.TENNIS)
    return (_a2 = tournament == null ? void 0 : tournament.country) == null ? void 0 : _a2.name;
  if (sport === Sports.FOOTBALL && (tournament == null ? void 0 : tournament.hasMultipleStages))
    return tournament.name;
  if (sport === Sports.FOOTBALL && !(tournament == null ? void 0 : tournament.isDomestic) && ((_b = tournament == null ? void 0 : tournament.stage) == null ? void 0 : _b.type) === StageTypes.FRIENDLY)
    return (_c = tournament == null ? void 0 : tournament.country) == null ? void 0 : _c.name;
  if (sport === Sports.FOOTBALL && !(tournament == null ? void 0 : tournament.hasMultipleStages) && !(tournament == null ? void 0 : tournament.stage)) {
    return (_d2 = tournament == null ? void 0 : tournament.country) == null ? void 0 : _d2.name;
  }
  return (tournament == null ? void 0 : tournament.region) === DOMESTIC ? (_e = tournament == null ? void 0 : tournament.country) == null ? void 0 : _e.name : tournament == null ? void 0 : tournament.name;
};
var Tournament = ({
  tournament,
  handleTournamentClick,
  sport,
  hideLogo,
  hideStandingsIcon,
  hideSubName,
  variant = "livescoreTournamentContainer",
  isMainImageRound
}) => {
  var _a2;
  const { dataLabels } = useContext3(ConfigContext);
  const onTournamentClick = () => tournament && handleTournamentClick && handleTournamentClick(tournament);
  const getLogo = () => {
    var _a3, _b, _c, _d2, _e, _f;
    if ((tournament == null ? void 0 : tournament.logo) && !isMainImageRound) {
      return tournament == null ? void 0 : tournament.logo;
    }
    if ((_c = (_b = (_a3 = tournament == null ? void 0 : tournament.country) == null ? void 0 : _a3.assets) == null ? void 0 : _b.flag) == null ? void 0 : _c.url) {
      return (_f = (_e = (_d2 = tournament == null ? void 0 : tournament.country) == null ? void 0 : _d2.assets) == null ? void 0 : _e.flag) == null ? void 0 : _f.url;
    }
    return "";
  };
  const isFootballSingleEventTournamentContainer = variant === "footballSingleEventTournamentContainer";
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    size: "4",
    variant,
    css: { width: isFootballSingleEventTournamentContainer ? "100%" : void 0, p: "unset" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    grid: true,
    variant: "tournament",
    css: {
      "& > a": { p: variant === "livescoreTournamentContainer" ? "$2 $3" : void 0 },
      "& > a:first-child": { pr: variant === "livescoreTournamentContainer" ? "unset" : void 0 },
      alignItems: "end"
    }
  }, /* @__PURE__ */ React.createElement("a", {
    href: tournament == null ? void 0 : tournament.tournamentLink,
    target: tournament == null ? void 0 : tournament.urlTarget,
    style: { textDecoration: "none" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    onClick: onTournamentClick,
    gap: "md",
    justify: variant === "livescoreTournamentContainer" ? "start" : "center",
    align: "center"
  }, !hideLogo && (tournament == null ? void 0 : tournament.logo) && /* @__PURE__ */ React.createElement(SMPImage, {
    css: { br: isMainImageRound || !(tournament == null ? void 0 : tournament.logo) ? "$round" : "" },
    variant: isMainImageRound || !(tournament == null ? void 0 : tournament.logo) ? "borderedLivescoreEntityLogo" : "tournamentLogo",
    src: getLogo(),
    alt: `${tournament == null ? void 0 : tournament.name} Logo`
  }), /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "column",
    gap: "md",
    style: { width: isFootballSingleEventTournamentContainer ? "100%" : void 0 }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "3",
    weight: "700",
    textAlign: isFootballSingleEventTournamentContainer ? "center" : void 0,
    style: { lineHeight: isFootballSingleEventTournamentContainer ? "20px" : "normal" }
  }, getTournamentName({ tournament, sport })), hideSubName ? null : /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "2",
    style: { lineHeight: isFootballSingleEventTournamentContainer ? "20px" : void 0 }
  }, getTournamentSubName({ tournament, sport }))))), hideStandingsIcon ? null : /* @__PURE__ */ React.createElement("a", {
    href: tournament == null ? void 0 : tournament.standingsLink,
    target: tournament == null ? void 0 : tournament.urlTarget,
    style: { textDecoration: "none" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "2",
    onClick: onTournamentClick,
    css: {
      textDecoration: "underline",
      textDecorationColor: "$standingsLinkColor",
      marginLeft: "$2_5",
      color: "$standingsLinkColor"
    }
  }, (_a2 = dataLabels == null ? void 0 : dataLabels.standings) != null ? _a2 : "Standings"))));
};

// src/molecules/MatchParticipant/MatchParticipant.tsx
import { abbreviateName as abbreviate, setNationalParticipantBorder as setNationalParticipantBorder3 } from "@sportal365/smp-widget-utils";

// ../constants/assetsPlaceholder.ts
var assetsPlaceholder = {
  player: "data:image/png;base64,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",
  lineup: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAe1BMVEUAAABdXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1kzb4jAAAAKHRSTlMA8RC8ca779eLEIATeybamnj40KRzYzpWPFunUmYF5UjmGalsLYEcxGo+DIgAAAWtJREFUSMe11WmPgkAMgGFgBhjuQ1DkkkPX/v9fuNmsMSsdpGXj+/0JCaXFoFWlxu7uAMMOFhhBUHQA0LKYL1svKsNGmfCTx7EZvNYwrGUu8JFMzzKBRTbVDoCTVBxi61pEewNNX0Qc63BCxCWS9Ld9NXVYEUfs6LBz/jwuEGTMynK1uvgHrgMSlqBNMnYRdyFgATjyOTiu4YiAuzXcEXC+hg8GoURvT7QbpJ2zUxikcoc+KFyFKOPmHxhvC2fjw0svw+ePkYc+LkYzetWcjjsfjJe6Z+JpJ8aHv+RZgcfMt3w9KEDVA4leU9CWWpvUF7BaUrylRQJvS/z1dfBgs1i/m5YNpGwLWwnkejxZRiJAS8So+atPwCxFB49Tjk4to/H54JCPy+yBL7AjiX6qjKoHTvfglD8o/Mf1Pb4V9+f+T7biSBXL4PUK5FMVK2eDhaKds7WlPue3/hSLqKmV6Zq/uXUYRl48jnO+YN8ujfTxFYNK5gAAAABJRU5ErkJggg==",
  lineupPlayerType: "data:image/png;base64,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",
  coach: "data:image/png;base64,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",
  referee: "data:image/png;base64,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",
  president: "data:image/png;base64,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",
  team: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzkyMV83MTIzMSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjRDlEOUQ5Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF85MjFfNzEyMzEpIj4KPHBhdGggZD0iTTEyIDIyQzkuNjgzMzMgMjEuNDE2NyA3Ljc3MDgzIDIwLjA4NzUgNi4yNjI1IDE4LjAxMjVDNC43NTQxNyAxNS45Mzc1IDQgMTMuNjMzMyA0IDExLjFWNUwxMiAyTDIwIDVWMTEuMUMyMCAxMy42MzMzIDE5LjI0NTggMTUuOTM3NSAxNy43Mzc1IDE4LjAxMjVDMTYuMjI5MiAyMC4wODc1IDE0LjMxNjcgMjEuNDE2NyAxMiAyMlpNMTIgMTkuOUMxMy43MzMzIDE5LjM1IDE1LjE2NjcgMTguMjUgMTYuMyAxNi42QzE3LjQzMzMgMTQuOTUgMTggMTMuMTE2NyAxOCAxMS4xVjYuMzc1TDEyIDQuMTI1TDYgNi4zNzVWMTEuMUM2IDEzLjExNjcgNi41NjY2NyAxNC45NSA3LjcgMTYuNkM4LjgzMzMzIDE4LjI1IDEwLjI2NjcgMTkuMzUgMTIgMTkuOVoiIGZpbGw9IiM4QzhDOEMiLz4KPC9nPgo8L3N2Zz4K",
  imagePlaceholder: "data:image/png;base64,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",
  blankPlaceholder: "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox ='0 0 16 9' />",
  tournament: "data:image/png;base64,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",
  stage: "data:image/png;base64,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",
  flag: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIUAAACBCAYAAADuS3kqAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAACfRJREFUeJztnXuIXNUdx913shutjfVBqtGFupuZ3Xnd9zz3Ne/dYKEo/isSEGqFSlslSFBi2kStSqkiCEGl1D/ECP4hKLYmTUziZjfRjUl8FzU0pbJLtIlJ1t2N37PZQHBM9t67d845d+b3hS8z9+59nfP73N/5nZnZmcsuI5FIJJJE0pOlpqg+2NwbTbUEQlZLd4/ecnNAbT3vrqDWuqbXbA1GEq0RbaBFSxSbRF8zySOF1b5G1cqtDCl93Xhcq1r530X1gYeMVHlUTxSPYnkqZgydBCDTCP4cfJY9YnkG608pVu44gDiGbXdFtP6N2P4+xcwWw2p/AH/vwHYEi+xC8BoQrOUI1q3wk1jeA39ppIZPm+nhOSuz9uxSjePMmjgeYPlIjeffCGt9vwcoAZyvRXT7SQvCUHAFAjIIGNYjUP/A8gkzPbLk4DsxzjmtJQrjgGNzVBtI4FpaRfdL3QkdvwypPaPFC5uMZGkcmQAgDHMF4cezyMickSxPApLtuL518C8AS6Po/qppYShYjbtwHdL2q3qyfEo0BIsMM3OoXY4iez0AeDvNVLlBdP/VjHC3tQGComLmtgGE06KD7caA42u0YyOK3JVL7hAccAW8DR5d8L6LeAze6kEMpBIq/lvUeGEn7rrvRAd26ZljZE5PFg+j7uhH1nA/pOBgP4E/sXni3R7GQ5gwdbwaIGzAuPwpagVPZgwyGVnjjBYvbsEweLmrDqonKBQru0q18vdjDJ4UHbhqm9UbGBJfQpHc5bijcIArah0KFI8rAMPdyAzHWIoVHTCOnsFM5UHHHVbLUKDwuhLTtQ1Ip/+TIEAiPAsoNjruOIdQ7KlC7DwXIOjQ4vlfYZjYgTQ6I0FwfAnFx7UCRdQY7EIR+SJgmJYgKKJd31AoZu46DTAgSxAMHkBxuZ+hAAjNmHr9AUPFvyUIgmyuLygw1boKReSv8fhxnc0onELxsOPO9RsUmHtfjaxwJ4aJccBwRoKOl9lcoNhbhTjbEoaIFTEzu05Plj63MpQZ6hYKI1VqiZlD3agb/gYYpmiYkBiKrqDeGlIyN1jpYc8/6ME+PBLVB8PICvdgmHgbU8uTEnSuX+0aihVOoQAQIRR5n8HPhrW+jGrl25YCgmJmGwFCGhlhA471MrLCccoKnkGxiQsUCGAMQZv/AAoeZ1D8/Ze9RqBYubvwPN8TSXZim9W406/HRf0cvhLPVyELrAZQnRGtP6InSndgm3uxfif2+8pIDc9K0Im1ZjFQ/MBz7GVlzAxO4vFrKz0yhXWTWP4cy5PY5zj7WBt7a5dtK0Gn1bqXBMVHNk/yDtsHd3z0IlCQ5TJBQfYOig6CombNEQozGwEU30rQaPLiUPyRCxSYQoYJCl+YCxSj56DIERT+MEcorFyIoPCF+UGhnoOCXn6W366haHcORb6XoPCFZ40ULyjiBIVPzBOKAkHhD7N/QP6TWyg+tHmSfWwfLVHoISh8YZ5QFINWeuSEBI0mywKFTlD4xa6hWO4YimQpYGUICh+YoCCLgWLsHBRlQLGWoJDfDIrNvKBYg+f/l6DRZFmgMAgKv5gjFKlyN0HhCwOKYVdQLHMKhZkaJij8YY5QpEe68PwbCRpNXhyKLW6h+MDmScYXMsWNOFnNf5lYDZgfFOynCmJm1m52IdcDFDcHVPZFIXb3IfsQijbnUGiAIntEgkaTZYGiKwgoTILCB2ZQPFJtKPZfAMVhCRpNlgiKJoWg8IN5QqE3IVMckqDRZFmg6O4hKHxi11C0uoECw8f7EjSaLA8UBqDIERTym0HxaLWhOHABFAclaDS5ilDYfc2BoPCXOULROw/FhASNJlcJihanUKzpNQkKf5g7FO9J0Gjy4lA8xguKRoLCF+YCxbvzUISsRsXKvStBo8kEBVlaKAKAQrVyByRoNLlKUDQ7hyIOKPIEhfzmCEV4Hor9EjSavDgUfyYoyJ5BYfcDM++xfYLhBINiXIJGkwkKMi8omhxDEQEU8fyYBI0mywJFTyRJUPjDXKFo0OKFfRI0mrw4FI9XG4qJeSiiBIVfzBuKUdENJksFRapBJSh8YbdQNDqFovccFO+IbjBZJihiKTZ8EBQ+MEco0gyKvaIbLKPN9MhZLVE4ZaTKX+nJ0ljUGHpBtfLPaoni01j+q5Es/0WHsfwUsu0zMTO7VbVyryF4x7DuhNe/3IzjPuEWCrv/7XWQ7RMiKM4DwKZ8JxHcCS1ReiOiDdyvxvO3OQ7Cgsz0MIbl/K1hrf8+gPU6IPoC677zBxRKpgFU7xEdFEEgnEWwvgEIb8aM7DoEsFNPFJrdgnAp4cb7Kc5T1uL5vyPzTFkZ51mENxS7RQeIlwHBDIJzULFyW5ANBsJqX4PnBCwiPVFcFlb7h5BJngcgtr+Z0C0UDQRFpdnQABjYOP9yVB8soc3XeB5pF0L2aAYYA7i25wDHot9QyBGKvpqFYr5QjBcOozjcHDUGA4qZ5Z4V7ArXVgQcE+yaLwHFk44P7BCK98/vByjeFh1Aj2GYBQzjipn7ZUTrlxaEHxMyx1Zc/4wMUOwSHUgvjDttFiBsQ7V/i5EstnsaLU7SE6V2tOMx+LRQKHSfQ4Gp3oyRLO/AMJEVUThWQ6h9CgDjuDgoksWdogPrEoZpdNx+DBVr0YZGT6MigZDBkyhA/4Ppq3somNxBUfIdFADhQxRntxvJUodnUZBQMTO7CnXGAQYGbyj+JTrI9jLD/ItNX6jxwnpkiZWe9bzkwrD4M7T7Jdj5ex9MLNg2O/nQ+X38AAXS6CSKyMdjxuBNyBI1UTc4EWJ0LWo/xdXOLqHYITrol4BhFrOJ15BCcyi+6g4GT1QrUACGM0ibb0b1gSxqh5orIrnKHRTl7aIhuACGGWSFVzBMpCNaP8HghdxAgTn+WyJBWCggj0aNwU3ICgZlBo/lEop/CgCB/XreFIqn7Sgcf6tauWBYyRAM1RA63O7XH7Kp63zhhuBwgWIhI5zA8LBLsXL3KOZQJ7JCk+g+q3m5gQKB+Q3u1DH23r6RWtqngy4EAMeaRhaaBAB7o8bQw3AhrPa1ITMQCDzlBgoA0RhSMq0IXjceFUwB740ZQw/GzOwzAGU3UvwYZgIT+PshAHQE6z9gZs+x/qAaLxxABhiF34poA6wuWI9tb++NpsL4+40hta8Z56DppCi5geJiYu8nIMDLAUp7IBxvX9NrdHQFdVhbsI51ZnswkliODLAMw0Ibr3aSHMhLKEg1IgdQHCYo6kQItN2vVCYo6kUEBalCBAWpQgQFqUIEBalCDqGg9xrqQQi03Z9pICjqRQQFqUIEBalCBAWpQgQFqUIItN1f+TlCUNSJCApShQgKUoUIClKFCApShRxCQR+grQch0HZ/OZCgqBcRFKQKERSkChEUJBKJRCKRHOh7LktbCRuu/n0AAAAASUVORK5CYII=",
  country: "data:image/png;base64,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",
  venue: "data:image/png;base64,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",
  arena: "data:image/png;base64,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",
  city: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACHAgMAAACqvhmaAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAxQTFRFAAAAOT9OLTE7LC447an4ogAAAAR0Uk5TAP+/bsRcrF8AAACVSURBVHic7dOxDYAgFARQLSwcgH0YgQKMhYWjOpomIEgCXigwF/OvoPEFCP8cBkmvOJ+lClQQzoAtrlTAmIQuiymJyjGqRVh00Y5i/EiYuIhgEiz9aBL3/7dD4bDQUJhMPN40CguFw+KAQpMIwyhKkxPxJlaSyYnIxSZdbxQ21Hmmn60IzgbxiUf+KCqffawIEUhw5AS6Ec56SSFrSQAAAABJRU5ErkJggg==",
  matchStatus: "data:image/png;base64,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",
  club: "data:image/png;base64,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",
  competition: "data:image/png;base64,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",
  tennisServer: "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIGZpbGw9IiNmZmY2NDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogICAgPHBhdGggZD0iTTI5LjcyNSAxNmMwLjUxNSAwIDEuMDIyIDAuMDI5IDEuNTIzIDAuMDg0LTAuMDQ0IDguMzg0LTYuODU1IDE1LjE2Ni0xNS4yNDggMTUuMTY2aDAuMDg0Yy0wLjA1NS0wLjUwMi0wLjA4NC0xLjAwOS0wLjA4NC0xLjUyNSAwLTcuNTc5IDYuMTQ2LTEzLjcyNSAxMy43MjUtMTMuNzI1ek0xNy40NTUgMC44MTljNy4yNjEgMC42ODYgMTMuMDM5IDYuNDY2IDEzLjcyNyAxMy43MjUtMC40OC0wLjA0Ni0wLjk2NS0wLjA2OS0xLjQ1Ni0wLjA2OS04LjQyMyAwLTE1LjI1IDYuODI3LTE1LjI1IDE1LjI1IDAgMC40OTEgMC4wMjMgMC45NzYgMC4wNjkgMS40NTYtNy4yNTktMC42ODYtMTMuMDM3LTYuNDY2LTEzLjcyNS0xMy43MjUgMC40OCAwLjA0NiAwLjk2NSAwLjA2OSAxLjQ1NiAwLjA2OSA4LjQyMyAwIDE1LjI1LTYuODI3IDE1LjI1LTE1LjI1IDAtMC40MjctMC4wMTgtMC44NTMtMC4wNTItMS4yNzJ6TTE1LjkxNiAwLjc1YzAuMDU1IDAuNTAzIDAuMDg0IDEuMDEwIDAuMDg0IDEuNTI1IDAgNy41NzktNi4xNDYgMTMuNzI1LTEzLjcyNSAxMy43MjUtMC41MTUgMC0xLjAyMi0wLjAyOS0xLjUyNC0wLjA4NCAwLjA0Ni04LjM4NCA2Ljg1NS0xNS4xNjYgMTUuMjQ4LTE1LjE2NnoiPjwvcGF0aD4NCjwvc3ZnPg==",
  tennisParticipant: "data:image/png;base64,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"
};

// ../constants/tennis.ts
var ParticipantTypes;
(function(ParticipantTypes3) {
  ParticipantTypes3["TEAM_DOUBLE"] = "TEAM_DOUBLE";
  ParticipantTypes3["PLAYER"] = "PLAYER";
})(ParticipantTypes || (ParticipantTypes = {}));
var Winner;
(function(Winner4) {
  Winner4["YES"] = "YES";
  Winner4["NO"] = "NO";
})(Winner || (Winner = {}));
var MatchTypes;
(function(MatchTypes3) {
  MatchTypes3["DOUBLE"] = "DOUBLE";
  MatchTypes3["SINGLE"] = "SINGLE";
})(MatchTypes || (MatchTypes = {}));
var RankingScopeTypes;
(function(RankingScopeTypes3) {
  RankingScopeTypes3["CURRENT"] = "CURRENT";
})(RankingScopeTypes || (RankingScopeTypes = {}));
var RankingColumnTypes;
(function(RankingColumnTypes3) {
  RankingColumnTypes3["NAME"] = "NAME";
  RankingColumnTypes3["POINTS"] = "POINTS";
  RankingColumnTypes3["NATIONALITY"] = "NATIONALITY";
})(RankingColumnTypes || (RankingColumnTypes = {}));
var PlayoffDoubleTypes;
(function(PlayoffDoubleTypes3) {
  PlayoffDoubleTypes3["MALE_DOUBLES"] = "MALE_DOUBLES";
  PlayoffDoubleTypes3["FEMALE_DOUBLES"] = "FEMALE_DOUBLES";
  PlayoffDoubleTypes3["MIXED_DOUBLES"] = "MIXED_DOUBLES";
})(PlayoffDoubleTypes || (PlayoffDoubleTypes = {}));
var CurrentServer;
(function(CurrentServer3) {
  CurrentServer3["YES"] = "YES";
  CurrentServer3["NO"] = "NO";
})(CurrentServer || (CurrentServer = {}));

// src/molecules/MatchParticipant/MatchParticipant.tsx
var Winner2;
(function(Winner4) {
  Winner4["YES"] = "YES";
  Winner4["NO"] = "NO";
})(Winner2 || (Winner2 = {}));
var MatchParticipant = ({
  participantName,
  countryLogo,
  participant,
  handleParticipantClick,
  participantLink,
  urlTarget,
  imageVariant,
  winner,
  sportEntityVariant,
  isMobile,
  showCurrentServer,
  currentServer,
  abbreviateName = false
}) => {
  return /* @__PURE__ */ React.createElement(SMPSportEntity, {
    href: participantLink,
    target: urlTarget,
    onClick: () => handleParticipantClick && participant && handleParticipantClick(participant),
    variant: sportEntityVariant === ParticipantTypes.TEAM_DOUBLE ? "tennisTeamDouble" : { "@bp0": "horizontal" },
    css: {
      "@bp0": { width: "100%" },
      "@bp1": { width: isMobile ? "100%" : "auto" }
    }
  }, countryLogo && countryLogo !== "" ? /* @__PURE__ */ React.createElement(SMPImage, {
    variant: imageVariant ? imageVariant : "livescoreEntityLogo",
    src: countryLogo,
    alt: participantName,
    css: __spreadValues({ br: "$round" }, setNationalParticipantBorder3(true))
  }) : null, /* @__PURE__ */ React.createElement(SMPText, {
    css: {
      overflow: "visible",
      "@bp0": { maxWidth: "100%", whiteSpace: "nowrap", pr: "$1" },
      "@bp1": { maxWidth: "100%", whiteSpace: isMobile ? "nowrap" : "pre-wrap" },
      "@bp2": { pr: isMobile ? "$2" : "0" }
    },
    variant: "tennisSingleEventLabel",
    size: isMobile ? "3" : { "@initial": "2", "@bp1": "3" },
    weight: winner === Winner2.YES ? "700" : "400"
  }, abbreviateName ? abbreviate(participantName) : participantName), showCurrentServer && currentServer && currentServer === CurrentServer.YES && sportEntityVariant !== ParticipantTypes.TEAM_DOUBLE ? /* @__PURE__ */ React.createElement(SMPImage, {
    variant: "tennisParticipantServer",
    src: assetsPlaceholder.tennisServer,
    alt: participantName
  }) : null);
};

// src/molecules/FansUnitedFullTimeOutcome/FansUnitedFullTimeOutcome.tsx
import React16, { useEffect as useEffect11, useMemo as useMemo7, useState as useState13 } from "react";

// ../constants/oddSigns.ts
var ONE = "1";
var X3 = "x";
var TWO = "2";

// ../hooks/usePredictor.ts
import { useCallback as useCallback2, useEffect as useEffect10, useState as useState12 } from "react";

// ../../node_modules/fansunited-sdk-esm/index.js
var Av = Object.create;
var rp = Object.defineProperty;
var xv = Object.getOwnPropertyDescriptor;
var Ov = Object.getOwnPropertyNames;
var Bv = Object.getPrototypeOf;
var Lv = Object.prototype.hasOwnProperty;
var Nv = (s4) => rp(s4, "__esModule", { value: true });
var W2 = (s4, e3) => () => (e3 || s4((e3 = { exports: {} }).exports, e3), e3.exports);
var Dv = (s4, e3, t3, n2) => {
  if (e3 && typeof e3 == "object" || typeof e3 == "function")
    for (let o2 of Ov(e3))
      !Lv.call(s4, o2) && (t3 || o2 !== "default") && rp(s4, o2, { get: () => e3[o2], enumerable: !(n2 = xv(e3, o2)) || n2.enumerable });
  return s4;
};
var mm = (s4, e3) => Dv(Nv(rp(s4 != null ? Av(Bv(s4)) : {}, "default", !e3 && s4 && s4.__esModule ? { get: () => s4.default, enumerable: true } : { value: s4, enumerable: true })), s4);
var dm = W2((Oi, kr) => {
  (function() {
    var s4, e3 = "4.17.21", t3 = 200, n2 = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o2 = "Expected a function", p2 = "Invalid `variable` option passed into `_.template`", d4 = "__lodash_hash_undefined__", h4 = 500, y4 = "__lodash_placeholder__", _2 = 1, w3 = 2, S4 = 4, q3 = 1, Fe = 2, we = 1, ct = 2, Se = 4, ue = 8, Te = 16, Ke = 32, ut = 64, It = 128, yr = 256, Ls = 512, Ld = 30, Nd = "...", Dd = 800, Ud = 16, Bp = 1, Hd = 2, kd = 3, ii = 1 / 0, N2 = 9007199254740991, Gd = 17976931348623157e292, sn = 0 / 0, mt = 4294967295, $d = mt - 1, Vd = mt >>> 1, qd = [["ary", It], ["bind", we], ["bindKey", ct], ["curry", ue], ["curryRight", Te], ["flip", Ls], ["partial", Ke], ["partialRight", ut], ["rearg", yr]], Mi = "[object Arguments]", ln = "[object Array]", Kd = "[object AsyncFunction]", Mr = "[object Boolean]", br = "[object Date]", Wd = "[object DOMException]", pn = "[object Error]", cn = "[object Function]", Lp = "[object GeneratorFunction]", nt = "[object Map]", wr = "[object Number]", Xd = "[object Null]", Pt = "[object Object]", Np = "[object Promise]", Yd = "[object Proxy]", vr = "[object RegExp]", at = "[object Set]", _r = "[object String]", un = "[object Symbol]", Qd = "[object Undefined]", Ir = "[object WeakMap]", zd = "[object WeakSet]", Pr = "[object ArrayBuffer]", bi = "[object DataView]", Ns = "[object Float32Array]", Ds = "[object Float64Array]", Us = "[object Int8Array]", Hs = "[object Int16Array]", ks = "[object Int32Array]", Gs = "[object Uint8Array]", $s = "[object Uint8ClampedArray]", Vs = "[object Uint16Array]", qs = "[object Uint32Array]", Jd = /\b__p \+= '';/g, Zd = /\b(__p \+=) '' \+/g, jd = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Dp = /&(?:amp|lt|gt|quot|#39);/g, Up = /[&<>"']/g, ef = RegExp(Dp.source), tf = RegExp(Up.source), rf = /<%-([\s\S]+?)%>/g, nf = /<%([\s\S]+?)%>/g, Hp = /<%=([\s\S]+?)%>/g, af = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, of = /^\w*$/, sf = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ks = /[\\^$.*+?()[\]{}|]/g, lf = RegExp(Ks.source), Ws = /^\s+/, pf = /\s/, cf = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, uf = /\{\n\/\* \[wrapped with (.+)\] \*/, mf = /,? & /, df = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ff = /[()=,{}\[\]\/\s]/, hf = /\\(\\)?/g, gf = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, kp = /\w*$/, yf = /^[-+]0x[0-9a-f]+$/i, Mf = /^0b[01]+$/i, bf = /^\[object .+?Constructor\]$/, wf = /^0o[0-7]+$/i, vf = /^(?:0|[1-9]\d*)$/, _f = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, mn = /($^)/, If = /['\n\r\u2028\u2029\\]/g, dn = "\\ud800-\\udfff", Pf = "\\u0300-\\u036f", Rf = "\\ufe20-\\ufe2f", Ff = "\\u20d0-\\u20ff", Gp = Pf + Rf + Ff, $p = "\\u2700-\\u27bf", Vp = "a-z\\xdf-\\xf6\\xf8-\\xff", Sf = "\\xac\\xb1\\xd7\\xf7", Tf = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ef = "\\u2000-\\u206f", Cf = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", qp = "A-Z\\xc0-\\xd6\\xd8-\\xde", Kp = "\\ufe0e\\ufe0f", Wp = Sf + Tf + Ef + Cf, Xs = "['\u2019]", Af = "[" + dn + "]", Xp = "[" + Wp + "]", fn = "[" + Gp + "]", Yp = "\\d+", xf = "[" + $p + "]", Qp = "[" + Vp + "]", zp = "[^" + dn + Wp + Yp + $p + Vp + qp + "]", Ys = "\\ud83c[\\udffb-\\udfff]", Of = "(?:" + fn + "|" + Ys + ")", Jp = "[^" + dn + "]", Qs = "(?:\\ud83c[\\udde6-\\uddff]){2}", zs = "[\\ud800-\\udbff][\\udc00-\\udfff]", wi = "[" + qp + "]", Zp = "\\u200d", jp = "(?:" + Qp + "|" + zp + ")", Bf = "(?:" + wi + "|" + zp + ")", ec = "(?:" + Xs + "(?:d|ll|m|re|s|t|ve))?", tc = "(?:" + Xs + "(?:D|LL|M|RE|S|T|VE))?", ic = Of + "?", rc = "[" + Kp + "]?", Lf = "(?:" + Zp + "(?:" + [Jp, Qs, zs].join("|") + ")" + rc + ic + ")*", Nf = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Df = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", nc = rc + ic + Lf, Uf = "(?:" + [xf, Qs, zs].join("|") + ")" + nc, Hf = "(?:" + [Jp + fn + "?", fn, Qs, zs, Af].join("|") + ")", kf = RegExp(Xs, "g"), Gf = RegExp(fn, "g"), Js = RegExp(Ys + "(?=" + Ys + ")|" + Hf + nc, "g"), $f = RegExp([wi + "?" + Qp + "+" + ec + "(?=" + [Xp, wi, "$"].join("|") + ")", Bf + "+" + tc + "(?=" + [Xp, wi + jp, "$"].join("|") + ")", wi + "?" + jp + "+" + ec, wi + "+" + tc, Df, Nf, Yp, Uf].join("|"), "g"), Vf = RegExp("[" + Zp + dn + Gp + Kp + "]"), qf = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Kf = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], Wf = -1, z3 = {};
    z3[Ns] = z3[Ds] = z3[Us] = z3[Hs] = z3[ks] = z3[Gs] = z3[$s] = z3[Vs] = z3[qs] = true, z3[Mi] = z3[ln] = z3[Pr] = z3[Mr] = z3[bi] = z3[br] = z3[pn] = z3[cn] = z3[nt] = z3[wr] = z3[Pt] = z3[vr] = z3[at] = z3[_r] = z3[Ir] = false;
    var Q2 = {};
    Q2[Mi] = Q2[ln] = Q2[Pr] = Q2[bi] = Q2[Mr] = Q2[br] = Q2[Ns] = Q2[Ds] = Q2[Us] = Q2[Hs] = Q2[ks] = Q2[nt] = Q2[wr] = Q2[Pt] = Q2[vr] = Q2[at] = Q2[_r] = Q2[un] = Q2[Gs] = Q2[$s] = Q2[Vs] = Q2[qs] = true, Q2[pn] = Q2[cn] = Q2[Ir] = false;
    var Xf = { \u00C0: "A", \u00C1: "A", \u00C2: "A", \u00C3: "A", \u00C4: "A", \u00C5: "A", \u00E0: "a", \u00E1: "a", \u00E2: "a", \u00E3: "a", \u00E4: "a", \u00E5: "a", \u00C7: "C", \u00E7: "c", \u00D0: "D", \u00F0: "d", \u00C8: "E", \u00C9: "E", \u00CA: "E", \u00CB: "E", \u00E8: "e", \u00E9: "e", \u00EA: "e", \u00EB: "e", \u00CC: "I", \u00CD: "I", \u00CE: "I", \u00CF: "I", \u00EC: "i", \u00ED: "i", \u00EE: "i", \u00EF: "i", \u00D1: "N", \u00F1: "n", \u00D2: "O", \u00D3: "O", \u00D4: "O", \u00D5: "O", \u00D6: "O", \u00D8: "O", \u00F2: "o", \u00F3: "o", \u00F4: "o", \u00F5: "o", \u00F6: "o", \u00F8: "o", \u00D9: "U", \u00DA: "U", \u00DB: "U", \u00DC: "U", \u00F9: "u", \u00FA: "u", \u00FB: "u", \u00FC: "u", \u00DD: "Y", \u00FD: "y", \u00FF: "y", \u00C6: "Ae", \u00E6: "ae", \u00DE: "Th", \u00FE: "th", \u00DF: "ss", \u0100: "A", \u0102: "A", \u0104: "A", \u0101: "a", \u0103: "a", \u0105: "a", \u0106: "C", \u0108: "C", \u010A: "C", \u010C: "C", \u0107: "c", \u0109: "c", \u010B: "c", \u010D: "c", \u010E: "D", \u0110: "D", \u010F: "d", \u0111: "d", \u0112: "E", \u0114: "E", \u0116: "E", \u0118: "E", \u011A: "E", \u0113: "e", \u0115: "e", \u0117: "e", \u0119: "e", \u011B: "e", \u011C: "G", \u011E: "G", \u0120: "G", \u0122: "G", \u011D: "g", \u011F: "g", \u0121: "g", \u0123: "g", \u0124: "H", \u0126: "H", \u0125: "h", \u0127: "h", \u0128: "I", \u012A: "I", \u012C: "I", \u012E: "I", \u0130: "I", \u0129: "i", \u012B: "i", \u012D: "i", \u012F: "i", \u0131: "i", \u0134: "J", \u0135: "j", \u0136: "K", \u0137: "k", \u0138: "k", \u0139: "L", \u013B: "L", \u013D: "L", \u013F: "L", \u0141: "L", \u013A: "l", \u013C: "l", \u013E: "l", \u0140: "l", \u0142: "l", \u0143: "N", \u0145: "N", \u0147: "N", \u014A: "N", \u0144: "n", \u0146: "n", \u0148: "n", \u014B: "n", \u014C: "O", \u014E: "O", \u0150: "O", \u014D: "o", \u014F: "o", \u0151: "o", \u0154: "R", \u0156: "R", \u0158: "R", \u0155: "r", \u0157: "r", \u0159: "r", \u015A: "S", \u015C: "S", \u015E: "S", \u0160: "S", \u015B: "s", \u015D: "s", \u015F: "s", \u0161: "s", \u0162: "T", \u0164: "T", \u0166: "T", \u0163: "t", \u0165: "t", \u0167: "t", \u0168: "U", \u016A: "U", \u016C: "U", \u016E: "U", \u0170: "U", \u0172: "U", \u0169: "u", \u016B: "u", \u016D: "u", \u016F: "u", \u0171: "u", \u0173: "u", \u0174: "W", \u0175: "w", \u0176: "Y", \u0177: "y", \u0178: "Y", \u0179: "Z", \u017B: "Z", \u017D: "Z", \u017A: "z", \u017C: "z", \u017E: "z", \u0132: "IJ", \u0133: "ij", \u0152: "Oe", \u0153: "oe", \u0149: "'n", \u017F: "s" }, Yf = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, Qf = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, zf = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, Jf = parseFloat, Zf = parseInt, ac = typeof global == "object" && global && global.Object === Object && global, jf = typeof self == "object" && self && self.Object === Object && self, pe = ac || jf || Function("return this")(), Zs = typeof Oi == "object" && Oi && !Oi.nodeType && Oi, ri = Zs && typeof kr == "object" && kr && !kr.nodeType && kr, oc = ri && ri.exports === Zs, js = oc && ac.process, We = function() {
      try {
        var M4 = ri && ri.require && ri.require("util").types;
        return M4 || js && js.binding && js.binding("util");
      } catch {
      }
    }(), sc = We && We.isArrayBuffer, lc = We && We.isDate, pc = We && We.isMap, cc = We && We.isRegExp, uc = We && We.isSet, mc = We && We.isTypedArray;
    function De(M4, I3, v2) {
      switch (v2.length) {
        case 0:
          return M4.call(I3);
        case 1:
          return M4.call(I3, v2[0]);
        case 2:
          return M4.call(I3, v2[0], v2[1]);
        case 3:
          return M4.call(I3, v2[0], v2[1], v2[2]);
      }
      return M4.apply(I3, v2);
    }
    function eh(M4, I3, v2, E3) {
      for (var B3 = -1, V2 = M4 == null ? 0 : M4.length; ++B3 < V2; ) {
        var se = M4[B3];
        I3(E3, se, v2(se), M4);
      }
      return E3;
    }
    function Xe(M4, I3) {
      for (var v2 = -1, E3 = M4 == null ? 0 : M4.length; ++v2 < E3 && I3(M4[v2], v2, M4) !== false; )
        ;
      return M4;
    }
    function th(M4, I3) {
      for (var v2 = M4 == null ? 0 : M4.length; v2-- && I3(M4[v2], v2, M4) !== false; )
        ;
      return M4;
    }
    function dc(M4, I3) {
      for (var v2 = -1, E3 = M4 == null ? 0 : M4.length; ++v2 < E3; )
        if (!I3(M4[v2], v2, M4))
          return false;
      return true;
    }
    function Dt(M4, I3) {
      for (var v2 = -1, E3 = M4 == null ? 0 : M4.length, B3 = 0, V2 = []; ++v2 < E3; ) {
        var se = M4[v2];
        I3(se, v2, M4) && (V2[B3++] = se);
      }
      return V2;
    }
    function hn(M4, I3) {
      var v2 = M4 == null ? 0 : M4.length;
      return !!v2 && vi(M4, I3, 0) > -1;
    }
    function el(M4, I3, v2) {
      for (var E3 = -1, B3 = M4 == null ? 0 : M4.length; ++E3 < B3; )
        if (v2(I3, M4[E3]))
          return true;
      return false;
    }
    function J2(M4, I3) {
      for (var v2 = -1, E3 = M4 == null ? 0 : M4.length, B3 = Array(E3); ++v2 < E3; )
        B3[v2] = I3(M4[v2], v2, M4);
      return B3;
    }
    function Ut(M4, I3) {
      for (var v2 = -1, E3 = I3.length, B3 = M4.length; ++v2 < E3; )
        M4[B3 + v2] = I3[v2];
      return M4;
    }
    function tl(M4, I3, v2, E3) {
      var B3 = -1, V2 = M4 == null ? 0 : M4.length;
      for (E3 && V2 && (v2 = M4[++B3]); ++B3 < V2; )
        v2 = I3(v2, M4[B3], B3, M4);
      return v2;
    }
    function ih(M4, I3, v2, E3) {
      var B3 = M4 == null ? 0 : M4.length;
      for (E3 && B3 && (v2 = M4[--B3]); B3--; )
        v2 = I3(v2, M4[B3], B3, M4);
      return v2;
    }
    function il(M4, I3) {
      for (var v2 = -1, E3 = M4 == null ? 0 : M4.length; ++v2 < E3; )
        if (I3(M4[v2], v2, M4))
          return true;
      return false;
    }
    var rh = rl("length");
    function nh(M4) {
      return M4.split("");
    }
    function ah(M4) {
      return M4.match(df) || [];
    }
    function fc(M4, I3, v2) {
      var E3;
      return v2(M4, function(B3, V2, se) {
        if (I3(B3, V2, se))
          return E3 = V2, false;
      }), E3;
    }
    function gn(M4, I3, v2, E3) {
      for (var B3 = M4.length, V2 = v2 + (E3 ? 1 : -1); E3 ? V2-- : ++V2 < B3; )
        if (I3(M4[V2], V2, M4))
          return V2;
      return -1;
    }
    function vi(M4, I3, v2) {
      return I3 === I3 ? yh(M4, I3, v2) : gn(M4, hc, v2);
    }
    function oh(M4, I3, v2, E3) {
      for (var B3 = v2 - 1, V2 = M4.length; ++B3 < V2; )
        if (E3(M4[B3], I3))
          return B3;
      return -1;
    }
    function hc(M4) {
      return M4 !== M4;
    }
    function gc(M4, I3) {
      var v2 = M4 == null ? 0 : M4.length;
      return v2 ? al(M4, I3) / v2 : sn;
    }
    function rl(M4) {
      return function(I3) {
        return I3 == null ? s4 : I3[M4];
      };
    }
    function nl(M4) {
      return function(I3) {
        return M4 == null ? s4 : M4[I3];
      };
    }
    function yc(M4, I3, v2, E3, B3) {
      return B3(M4, function(V2, se, Y3) {
        v2 = E3 ? (E3 = false, V2) : I3(v2, V2, se, Y3);
      }), v2;
    }
    function sh(M4, I3) {
      var v2 = M4.length;
      for (M4.sort(I3); v2--; )
        M4[v2] = M4[v2].value;
      return M4;
    }
    function al(M4, I3) {
      for (var v2, E3 = -1, B3 = M4.length; ++E3 < B3; ) {
        var V2 = I3(M4[E3]);
        V2 !== s4 && (v2 = v2 === s4 ? V2 : v2 + V2);
      }
      return v2;
    }
    function ol(M4, I3) {
      for (var v2 = -1, E3 = Array(M4); ++v2 < M4; )
        E3[v2] = I3(v2);
      return E3;
    }
    function lh(M4, I3) {
      return J2(I3, function(v2) {
        return [v2, M4[v2]];
      });
    }
    function Mc(M4) {
      return M4 && M4.slice(0, _c(M4) + 1).replace(Ws, "");
    }
    function Ue(M4) {
      return function(I3) {
        return M4(I3);
      };
    }
    function sl(M4, I3) {
      return J2(I3, function(v2) {
        return M4[v2];
      });
    }
    function Rr(M4, I3) {
      return M4.has(I3);
    }
    function bc(M4, I3) {
      for (var v2 = -1, E3 = M4.length; ++v2 < E3 && vi(I3, M4[v2], 0) > -1; )
        ;
      return v2;
    }
    function wc(M4, I3) {
      for (var v2 = M4.length; v2-- && vi(I3, M4[v2], 0) > -1; )
        ;
      return v2;
    }
    function ph(M4, I3) {
      for (var v2 = M4.length, E3 = 0; v2--; )
        M4[v2] === I3 && ++E3;
      return E3;
    }
    var ch = nl(Xf), uh = nl(Yf);
    function mh(M4) {
      return "\\" + zf[M4];
    }
    function dh(M4, I3) {
      return M4 == null ? s4 : M4[I3];
    }
    function _i(M4) {
      return Vf.test(M4);
    }
    function fh(M4) {
      return qf.test(M4);
    }
    function hh(M4) {
      for (var I3, v2 = []; !(I3 = M4.next()).done; )
        v2.push(I3.value);
      return v2;
    }
    function ll(M4) {
      var I3 = -1, v2 = Array(M4.size);
      return M4.forEach(function(E3, B3) {
        v2[++I3] = [B3, E3];
      }), v2;
    }
    function vc(M4, I3) {
      return function(v2) {
        return M4(I3(v2));
      };
    }
    function Ht(M4, I3) {
      for (var v2 = -1, E3 = M4.length, B3 = 0, V2 = []; ++v2 < E3; ) {
        var se = M4[v2];
        (se === I3 || se === y4) && (M4[v2] = y4, V2[B3++] = v2);
      }
      return V2;
    }
    function yn(M4) {
      var I3 = -1, v2 = Array(M4.size);
      return M4.forEach(function(E3) {
        v2[++I3] = E3;
      }), v2;
    }
    function gh(M4) {
      var I3 = -1, v2 = Array(M4.size);
      return M4.forEach(function(E3) {
        v2[++I3] = [E3, E3];
      }), v2;
    }
    function yh(M4, I3, v2) {
      for (var E3 = v2 - 1, B3 = M4.length; ++E3 < B3; )
        if (M4[E3] === I3)
          return E3;
      return -1;
    }
    function Mh(M4, I3, v2) {
      for (var E3 = v2 + 1; E3--; )
        if (M4[E3] === I3)
          return E3;
      return E3;
    }
    function Ii(M4) {
      return _i(M4) ? wh(M4) : rh(M4);
    }
    function ot(M4) {
      return _i(M4) ? vh(M4) : nh(M4);
    }
    function _c(M4) {
      for (var I3 = M4.length; I3-- && pf.test(M4.charAt(I3)); )
        ;
      return I3;
    }
    var bh = nl(Qf);
    function wh(M4) {
      for (var I3 = Js.lastIndex = 0; Js.test(M4); )
        ++I3;
      return I3;
    }
    function vh(M4) {
      return M4.match(Js) || [];
    }
    function _h(M4) {
      return M4.match($f) || [];
    }
    var Ih = function M4(I3) {
      I3 = I3 == null ? pe : kt.defaults(pe.Object(), I3, kt.pick(pe, Kf));
      var v2 = I3.Array, E3 = I3.Date, B3 = I3.Error, V2 = I3.Function, se = I3.Math, Y3 = I3.Object, pl = I3.RegExp, Ph = I3.String, Ye = I3.TypeError, Mn = v2.prototype, Rh = V2.prototype, Pi = Y3.prototype, bn = I3["__core-js_shared__"], wn = Rh.toString, X4 = Pi.hasOwnProperty, Fh = 0, Ic = function() {
        var i3 = /[^.]+$/.exec(bn && bn.keys && bn.keys.IE_PROTO || "");
        return i3 ? "Symbol(src)_1." + i3 : "";
      }(), vn = Pi.toString, Sh = wn.call(Y3), Th = pe._, Eh = pl("^" + wn.call(X4).replace(Ks, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), _n = oc ? I3.Buffer : s4, Gt = I3.Symbol, In = I3.Uint8Array, Pc = _n ? _n.allocUnsafe : s4, Pn = vc(Y3.getPrototypeOf, Y3), Rc = Y3.create, Fc = Pi.propertyIsEnumerable, Rn = Mn.splice, Sc = Gt ? Gt.isConcatSpreadable : s4, Fr = Gt ? Gt.iterator : s4, ni = Gt ? Gt.toStringTag : s4, Fn = function() {
        try {
          var i3 = pi(Y3, "defineProperty");
          return i3({}, "", {}), i3;
        } catch {
        }
      }(), Ch = I3.clearTimeout !== pe.clearTimeout && I3.clearTimeout, Ah = E3 && E3.now !== pe.Date.now && E3.now, xh = I3.setTimeout !== pe.setTimeout && I3.setTimeout, Sn = se.ceil, Tn = se.floor, cl = Y3.getOwnPropertySymbols, Oh = _n ? _n.isBuffer : s4, Tc = I3.isFinite, Bh = Mn.join, Lh = vc(Y3.keys, Y3), le = se.max, ge = se.min, Nh = E3.now, Dh = I3.parseInt, Ec = se.random, Uh = Mn.reverse, ul = pi(I3, "DataView"), Sr = pi(I3, "Map"), ml = pi(I3, "Promise"), Ri = pi(I3, "Set"), Tr = pi(I3, "WeakMap"), Er = pi(Y3, "create"), En = Tr && new Tr(), Fi = {}, Hh = ci(ul), kh = ci(Sr), Gh = ci(ml), $h = ci(Ri), Vh = ci(Tr), Cn = Gt ? Gt.prototype : s4, Cr = Cn ? Cn.valueOf : s4, Cc = Cn ? Cn.toString : s4;
      function u3(i3) {
        if (ee(i3) && !L3(i3) && !(i3 instanceof G3)) {
          if (i3 instanceof Qe)
            return i3;
          if (X4.call(i3, "__wrapped__"))
            return Au(i3);
        }
        return new Qe(i3);
      }
      var Si = function() {
        function i3() {
        }
        return function(r2) {
          if (!Z2(r2))
            return {};
          if (Rc)
            return Rc(r2);
          i3.prototype = r2;
          var a4 = new i3();
          return i3.prototype = s4, a4;
        };
      }();
      function An() {
      }
      function Qe(i3, r2) {
        this.__wrapped__ = i3, this.__actions__ = [], this.__chain__ = !!r2, this.__index__ = 0, this.__values__ = s4;
      }
      u3.templateSettings = { escape: rf, evaluate: nf, interpolate: Hp, variable: "", imports: { _: u3 } }, u3.prototype = An.prototype, u3.prototype.constructor = u3, Qe.prototype = Si(An.prototype), Qe.prototype.constructor = Qe;
      function G3(i3) {
        this.__wrapped__ = i3, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = false, this.__iteratees__ = [], this.__takeCount__ = mt, this.__views__ = [];
      }
      function qh() {
        var i3 = new G3(this.__wrapped__);
        return i3.__actions__ = Ee(this.__actions__), i3.__dir__ = this.__dir__, i3.__filtered__ = this.__filtered__, i3.__iteratees__ = Ee(this.__iteratees__), i3.__takeCount__ = this.__takeCount__, i3.__views__ = Ee(this.__views__), i3;
      }
      function Kh() {
        if (this.__filtered__) {
          var i3 = new G3(this);
          i3.__dir__ = -1, i3.__filtered__ = true;
        } else
          i3 = this.clone(), i3.__dir__ *= -1;
        return i3;
      }
      function Wh() {
        var i3 = this.__wrapped__.value(), r2 = this.__dir__, a4 = L3(i3), l2 = r2 < 0, c3 = a4 ? i3.length : 0, m4 = ny(0, c3, this.__views__), f2 = m4.start, g2 = m4.end, b3 = g2 - f2, P2 = l2 ? g2 : f2 - 1, R3 = this.__iteratees__, F2 = R3.length, T3 = 0, C2 = ge(b3, this.__takeCount__);
        if (!a4 || !l2 && c3 == b3 && C2 == b3)
          return eu(i3, this.__actions__);
        var x3 = [];
        e:
          for (; b3-- && T3 < C2; ) {
            P2 += r2;
            for (var U2 = -1, O3 = i3[P2]; ++U2 < F2; ) {
              var k3 = R3[U2], $2 = k3.iteratee, Ge = k3.type, Ie = $2(O3);
              if (Ge == Hd)
                O3 = Ie;
              else if (!Ie) {
                if (Ge == Bp)
                  continue e;
                break e;
              }
            }
            x3[T3++] = O3;
          }
        return x3;
      }
      G3.prototype = Si(An.prototype), G3.prototype.constructor = G3;
      function ai(i3) {
        var r2 = -1, a4 = i3 == null ? 0 : i3.length;
        for (this.clear(); ++r2 < a4; ) {
          var l2 = i3[r2];
          this.set(l2[0], l2[1]);
        }
      }
      function Xh() {
        this.__data__ = Er ? Er(null) : {}, this.size = 0;
      }
      function Yh(i3) {
        var r2 = this.has(i3) && delete this.__data__[i3];
        return this.size -= r2 ? 1 : 0, r2;
      }
      function Qh(i3) {
        var r2 = this.__data__;
        if (Er) {
          var a4 = r2[i3];
          return a4 === d4 ? s4 : a4;
        }
        return X4.call(r2, i3) ? r2[i3] : s4;
      }
      function zh(i3) {
        var r2 = this.__data__;
        return Er ? r2[i3] !== s4 : X4.call(r2, i3);
      }
      function Jh(i3, r2) {
        var a4 = this.__data__;
        return this.size += this.has(i3) ? 0 : 1, a4[i3] = Er && r2 === s4 ? d4 : r2, this;
      }
      ai.prototype.clear = Xh, ai.prototype.delete = Yh, ai.prototype.get = Qh, ai.prototype.has = zh, ai.prototype.set = Jh;
      function Rt(i3) {
        var r2 = -1, a4 = i3 == null ? 0 : i3.length;
        for (this.clear(); ++r2 < a4; ) {
          var l2 = i3[r2];
          this.set(l2[0], l2[1]);
        }
      }
      function Zh() {
        this.__data__ = [], this.size = 0;
      }
      function jh(i3) {
        var r2 = this.__data__, a4 = xn(r2, i3);
        if (a4 < 0)
          return false;
        var l2 = r2.length - 1;
        return a4 == l2 ? r2.pop() : Rn.call(r2, a4, 1), --this.size, true;
      }
      function eg(i3) {
        var r2 = this.__data__, a4 = xn(r2, i3);
        return a4 < 0 ? s4 : r2[a4][1];
      }
      function tg(i3) {
        return xn(this.__data__, i3) > -1;
      }
      function ig(i3, r2) {
        var a4 = this.__data__, l2 = xn(a4, i3);
        return l2 < 0 ? (++this.size, a4.push([i3, r2])) : a4[l2][1] = r2, this;
      }
      Rt.prototype.clear = Zh, Rt.prototype.delete = jh, Rt.prototype.get = eg, Rt.prototype.has = tg, Rt.prototype.set = ig;
      function Ft(i3) {
        var r2 = -1, a4 = i3 == null ? 0 : i3.length;
        for (this.clear(); ++r2 < a4; ) {
          var l2 = i3[r2];
          this.set(l2[0], l2[1]);
        }
      }
      function rg() {
        this.size = 0, this.__data__ = { hash: new ai(), map: new (Sr || Rt)(), string: new ai() };
      }
      function ng(i3) {
        var r2 = qn(this, i3).delete(i3);
        return this.size -= r2 ? 1 : 0, r2;
      }
      function ag(i3) {
        return qn(this, i3).get(i3);
      }
      function og(i3) {
        return qn(this, i3).has(i3);
      }
      function sg(i3, r2) {
        var a4 = qn(this, i3), l2 = a4.size;
        return a4.set(i3, r2), this.size += a4.size == l2 ? 0 : 1, this;
      }
      Ft.prototype.clear = rg, Ft.prototype.delete = ng, Ft.prototype.get = ag, Ft.prototype.has = og, Ft.prototype.set = sg;
      function oi(i3) {
        var r2 = -1, a4 = i3 == null ? 0 : i3.length;
        for (this.__data__ = new Ft(); ++r2 < a4; )
          this.add(i3[r2]);
      }
      function lg(i3) {
        return this.__data__.set(i3, d4), this;
      }
      function pg(i3) {
        return this.__data__.has(i3);
      }
      oi.prototype.add = oi.prototype.push = lg, oi.prototype.has = pg;
      function st(i3) {
        var r2 = this.__data__ = new Rt(i3);
        this.size = r2.size;
      }
      function cg() {
        this.__data__ = new Rt(), this.size = 0;
      }
      function ug(i3) {
        var r2 = this.__data__, a4 = r2.delete(i3);
        return this.size = r2.size, a4;
      }
      function mg(i3) {
        return this.__data__.get(i3);
      }
      function dg(i3) {
        return this.__data__.has(i3);
      }
      function fg(i3, r2) {
        var a4 = this.__data__;
        if (a4 instanceof Rt) {
          var l2 = a4.__data__;
          if (!Sr || l2.length < t3 - 1)
            return l2.push([i3, r2]), this.size = ++a4.size, this;
          a4 = this.__data__ = new Ft(l2);
        }
        return a4.set(i3, r2), this.size = a4.size, this;
      }
      st.prototype.clear = cg, st.prototype.delete = ug, st.prototype.get = mg, st.prototype.has = dg, st.prototype.set = fg;
      function Ac(i3, r2) {
        var a4 = L3(i3), l2 = !a4 && ui(i3), c3 = !a4 && !l2 && Wt(i3), m4 = !a4 && !l2 && !c3 && Ai(i3), f2 = a4 || l2 || c3 || m4, g2 = f2 ? ol(i3.length, Ph) : [], b3 = g2.length;
        for (var P2 in i3)
          (r2 || X4.call(i3, P2)) && !(f2 && (P2 == "length" || c3 && (P2 == "offset" || P2 == "parent") || m4 && (P2 == "buffer" || P2 == "byteLength" || P2 == "byteOffset") || Ct(P2, b3))) && g2.push(P2);
        return g2;
      }
      function xc(i3) {
        var r2 = i3.length;
        return r2 ? i3[Il(0, r2 - 1)] : s4;
      }
      function hg(i3, r2) {
        return Kn(Ee(i3), si(r2, 0, i3.length));
      }
      function gg(i3) {
        return Kn(Ee(i3));
      }
      function dl(i3, r2, a4) {
        (a4 !== s4 && !lt(i3[r2], a4) || a4 === s4 && !(r2 in i3)) && St(i3, r2, a4);
      }
      function Ar(i3, r2, a4) {
        var l2 = i3[r2];
        (!(X4.call(i3, r2) && lt(l2, a4)) || a4 === s4 && !(r2 in i3)) && St(i3, r2, a4);
      }
      function xn(i3, r2) {
        for (var a4 = i3.length; a4--; )
          if (lt(i3[a4][0], r2))
            return a4;
        return -1;
      }
      function yg(i3, r2, a4, l2) {
        return $t(i3, function(c3, m4, f2) {
          r2(l2, c3, a4(c3), f2);
        }), l2;
      }
      function Oc(i3, r2) {
        return i3 && ft(r2, ce(r2), i3);
      }
      function Mg(i3, r2) {
        return i3 && ft(r2, Ae(r2), i3);
      }
      function St(i3, r2, a4) {
        r2 == "__proto__" && Fn ? Fn(i3, r2, { configurable: true, enumerable: true, value: a4, writable: true }) : i3[r2] = a4;
      }
      function fl(i3, r2) {
        for (var a4 = -1, l2 = r2.length, c3 = v2(l2), m4 = i3 == null; ++a4 < l2; )
          c3[a4] = m4 ? s4 : Yl(i3, r2[a4]);
        return c3;
      }
      function si(i3, r2, a4) {
        return i3 === i3 && (a4 !== s4 && (i3 = i3 <= a4 ? i3 : a4), r2 !== s4 && (i3 = i3 >= r2 ? i3 : r2)), i3;
      }
      function ze(i3, r2, a4, l2, c3, m4) {
        var f2, g2 = r2 & _2, b3 = r2 & w3, P2 = r2 & S4;
        if (a4 && (f2 = c3 ? a4(i3, l2, c3, m4) : a4(i3)), f2 !== s4)
          return f2;
        if (!Z2(i3))
          return i3;
        var R3 = L3(i3);
        if (R3) {
          if (f2 = oy(i3), !g2)
            return Ee(i3, f2);
        } else {
          var F2 = ye(i3), T3 = F2 == cn || F2 == Lp;
          if (Wt(i3))
            return ru(i3, g2);
          if (F2 == Pt || F2 == Mi || T3 && !c3) {
            if (f2 = b3 || T3 ? {} : _u(i3), !g2)
              return b3 ? Qg(i3, Mg(f2, i3)) : Yg(i3, Oc(f2, i3));
          } else {
            if (!Q2[F2])
              return c3 ? i3 : {};
            f2 = sy(i3, F2, g2);
          }
        }
        m4 || (m4 = new st());
        var C2 = m4.get(i3);
        if (C2)
          return C2;
        m4.set(i3, f2), Ju(i3) ? i3.forEach(function(O3) {
          f2.add(ze(O3, r2, a4, O3, i3, m4));
        }) : Qu(i3) && i3.forEach(function(O3, k3) {
          f2.set(k3, ze(O3, r2, a4, k3, i3, m4));
        });
        var x3 = P2 ? b3 ? Bl : Ol : b3 ? Ae : ce, U2 = R3 ? s4 : x3(i3);
        return Xe(U2 || i3, function(O3, k3) {
          U2 && (k3 = O3, O3 = i3[k3]), Ar(f2, k3, ze(O3, r2, a4, k3, i3, m4));
        }), f2;
      }
      function bg(i3) {
        var r2 = ce(i3);
        return function(a4) {
          return Bc(a4, i3, r2);
        };
      }
      function Bc(i3, r2, a4) {
        var l2 = a4.length;
        if (i3 == null)
          return !l2;
        for (i3 = Y3(i3); l2--; ) {
          var c3 = a4[l2], m4 = r2[c3], f2 = i3[c3];
          if (f2 === s4 && !(c3 in i3) || !m4(f2))
            return false;
        }
        return true;
      }
      function Lc(i3, r2, a4) {
        if (typeof i3 != "function")
          throw new Ye(o2);
        return Ur(function() {
          i3.apply(s4, a4);
        }, r2);
      }
      function xr(i3, r2, a4, l2) {
        var c3 = -1, m4 = hn, f2 = true, g2 = i3.length, b3 = [], P2 = r2.length;
        if (!g2)
          return b3;
        a4 && (r2 = J2(r2, Ue(a4))), l2 ? (m4 = el, f2 = false) : r2.length >= t3 && (m4 = Rr, f2 = false, r2 = new oi(r2));
        e:
          for (; ++c3 < g2; ) {
            var R3 = i3[c3], F2 = a4 == null ? R3 : a4(R3);
            if (R3 = l2 || R3 !== 0 ? R3 : 0, f2 && F2 === F2) {
              for (var T3 = P2; T3--; )
                if (r2[T3] === F2)
                  continue e;
              b3.push(R3);
            } else
              m4(r2, F2, l2) || b3.push(R3);
          }
        return b3;
      }
      var $t = lu(dt), Nc = lu(gl, true);
      function wg(i3, r2) {
        var a4 = true;
        return $t(i3, function(l2, c3, m4) {
          return a4 = !!r2(l2, c3, m4), a4;
        }), a4;
      }
      function On(i3, r2, a4) {
        for (var l2 = -1, c3 = i3.length; ++l2 < c3; ) {
          var m4 = i3[l2], f2 = r2(m4);
          if (f2 != null && (g2 === s4 ? f2 === f2 && !ke(f2) : a4(f2, g2)))
            var g2 = f2, b3 = m4;
        }
        return b3;
      }
      function vg(i3, r2, a4, l2) {
        var c3 = i3.length;
        for (a4 = D3(a4), a4 < 0 && (a4 = -a4 > c3 ? 0 : c3 + a4), l2 = l2 === s4 || l2 > c3 ? c3 : D3(l2), l2 < 0 && (l2 += c3), l2 = a4 > l2 ? 0 : ju(l2); a4 < l2; )
          i3[a4++] = r2;
        return i3;
      }
      function Dc(i3, r2) {
        var a4 = [];
        return $t(i3, function(l2, c3, m4) {
          r2(l2, c3, m4) && a4.push(l2);
        }), a4;
      }
      function me(i3, r2, a4, l2, c3) {
        var m4 = -1, f2 = i3.length;
        for (a4 || (a4 = py), c3 || (c3 = []); ++m4 < f2; ) {
          var g2 = i3[m4];
          r2 > 0 && a4(g2) ? r2 > 1 ? me(g2, r2 - 1, a4, l2, c3) : Ut(c3, g2) : l2 || (c3[c3.length] = g2);
        }
        return c3;
      }
      var hl = pu(), Uc = pu(true);
      function dt(i3, r2) {
        return i3 && hl(i3, r2, ce);
      }
      function gl(i3, r2) {
        return i3 && Uc(i3, r2, ce);
      }
      function Bn(i3, r2) {
        return Dt(r2, function(a4) {
          return At(i3[a4]);
        });
      }
      function li(i3, r2) {
        r2 = qt(r2, i3);
        for (var a4 = 0, l2 = r2.length; i3 != null && a4 < l2; )
          i3 = i3[ht(r2[a4++])];
        return a4 && a4 == l2 ? i3 : s4;
      }
      function Hc(i3, r2, a4) {
        var l2 = r2(i3);
        return L3(i3) ? l2 : Ut(l2, a4(i3));
      }
      function ve(i3) {
        return i3 == null ? i3 === s4 ? Qd : Xd : ni && ni in Y3(i3) ? ry(i3) : gy(i3);
      }
      function yl(i3, r2) {
        return i3 > r2;
      }
      function _g(i3, r2) {
        return i3 != null && X4.call(i3, r2);
      }
      function Ig(i3, r2) {
        return i3 != null && r2 in Y3(i3);
      }
      function Pg(i3, r2, a4) {
        return i3 >= ge(r2, a4) && i3 < le(r2, a4);
      }
      function Ml(i3, r2, a4) {
        for (var l2 = a4 ? el : hn, c3 = i3[0].length, m4 = i3.length, f2 = m4, g2 = v2(m4), b3 = 1 / 0, P2 = []; f2--; ) {
          var R3 = i3[f2];
          f2 && r2 && (R3 = J2(R3, Ue(r2))), b3 = ge(R3.length, b3), g2[f2] = !a4 && (r2 || c3 >= 120 && R3.length >= 120) ? new oi(f2 && R3) : s4;
        }
        R3 = i3[0];
        var F2 = -1, T3 = g2[0];
        e:
          for (; ++F2 < c3 && P2.length < b3; ) {
            var C2 = R3[F2], x3 = r2 ? r2(C2) : C2;
            if (C2 = a4 || C2 !== 0 ? C2 : 0, !(T3 ? Rr(T3, x3) : l2(P2, x3, a4))) {
              for (f2 = m4; --f2; ) {
                var U2 = g2[f2];
                if (!(U2 ? Rr(U2, x3) : l2(i3[f2], x3, a4)))
                  continue e;
              }
              T3 && T3.push(x3), P2.push(C2);
            }
          }
        return P2;
      }
      function Rg(i3, r2, a4, l2) {
        return dt(i3, function(c3, m4, f2) {
          r2(l2, a4(c3), m4, f2);
        }), l2;
      }
      function Or(i3, r2, a4) {
        r2 = qt(r2, i3), i3 = Fu(i3, r2);
        var l2 = i3 == null ? i3 : i3[ht(Ze(r2))];
        return l2 == null ? s4 : De(l2, i3, a4);
      }
      function kc(i3) {
        return ee(i3) && ve(i3) == Mi;
      }
      function Fg(i3) {
        return ee(i3) && ve(i3) == Pr;
      }
      function Sg(i3) {
        return ee(i3) && ve(i3) == br;
      }
      function Br(i3, r2, a4, l2, c3) {
        return i3 === r2 ? true : i3 == null || r2 == null || !ee(i3) && !ee(r2) ? i3 !== i3 && r2 !== r2 : Tg(i3, r2, a4, l2, Br, c3);
      }
      function Tg(i3, r2, a4, l2, c3, m4) {
        var f2 = L3(i3), g2 = L3(r2), b3 = f2 ? ln : ye(i3), P2 = g2 ? ln : ye(r2);
        b3 = b3 == Mi ? Pt : b3, P2 = P2 == Mi ? Pt : P2;
        var R3 = b3 == Pt, F2 = P2 == Pt, T3 = b3 == P2;
        if (T3 && Wt(i3)) {
          if (!Wt(r2))
            return false;
          f2 = true, R3 = false;
        }
        if (T3 && !R3)
          return m4 || (m4 = new st()), f2 || Ai(i3) ? bu(i3, r2, a4, l2, c3, m4) : ty(i3, r2, b3, a4, l2, c3, m4);
        if (!(a4 & q3)) {
          var C2 = R3 && X4.call(i3, "__wrapped__"), x3 = F2 && X4.call(r2, "__wrapped__");
          if (C2 || x3) {
            var U2 = C2 ? i3.value() : i3, O3 = x3 ? r2.value() : r2;
            return m4 || (m4 = new st()), c3(U2, O3, a4, l2, m4);
          }
        }
        return T3 ? (m4 || (m4 = new st()), iy(i3, r2, a4, l2, c3, m4)) : false;
      }
      function Eg(i3) {
        return ee(i3) && ye(i3) == nt;
      }
      function bl(i3, r2, a4, l2) {
        var c3 = a4.length, m4 = c3, f2 = !l2;
        if (i3 == null)
          return !m4;
        for (i3 = Y3(i3); c3--; ) {
          var g2 = a4[c3];
          if (f2 && g2[2] ? g2[1] !== i3[g2[0]] : !(g2[0] in i3))
            return false;
        }
        for (; ++c3 < m4; ) {
          g2 = a4[c3];
          var b3 = g2[0], P2 = i3[b3], R3 = g2[1];
          if (f2 && g2[2]) {
            if (P2 === s4 && !(b3 in i3))
              return false;
          } else {
            var F2 = new st();
            if (l2)
              var T3 = l2(P2, R3, b3, i3, r2, F2);
            if (!(T3 === s4 ? Br(R3, P2, q3 | Fe, l2, F2) : T3))
              return false;
          }
        }
        return true;
      }
      function Gc(i3) {
        if (!Z2(i3) || uy(i3))
          return false;
        var r2 = At(i3) ? Eh : bf;
        return r2.test(ci(i3));
      }
      function Cg(i3) {
        return ee(i3) && ve(i3) == vr;
      }
      function Ag(i3) {
        return ee(i3) && ye(i3) == at;
      }
      function xg(i3) {
        return ee(i3) && Jn(i3.length) && !!z3[ve(i3)];
      }
      function $c(i3) {
        return typeof i3 == "function" ? i3 : i3 == null ? xe : typeof i3 == "object" ? L3(i3) ? Kc(i3[0], i3[1]) : qc(i3) : cm(i3);
      }
      function wl(i3) {
        if (!Dr(i3))
          return Lh(i3);
        var r2 = [];
        for (var a4 in Y3(i3))
          X4.call(i3, a4) && a4 != "constructor" && r2.push(a4);
        return r2;
      }
      function Og(i3) {
        if (!Z2(i3))
          return hy(i3);
        var r2 = Dr(i3), a4 = [];
        for (var l2 in i3)
          l2 == "constructor" && (r2 || !X4.call(i3, l2)) || a4.push(l2);
        return a4;
      }
      function vl(i3, r2) {
        return i3 < r2;
      }
      function Vc(i3, r2) {
        var a4 = -1, l2 = Ce(i3) ? v2(i3.length) : [];
        return $t(i3, function(c3, m4, f2) {
          l2[++a4] = r2(c3, m4, f2);
        }), l2;
      }
      function qc(i3) {
        var r2 = Nl(i3);
        return r2.length == 1 && r2[0][2] ? Pu(r2[0][0], r2[0][1]) : function(a4) {
          return a4 === i3 || bl(a4, i3, r2);
        };
      }
      function Kc(i3, r2) {
        return Ul(i3) && Iu(r2) ? Pu(ht(i3), r2) : function(a4) {
          var l2 = Yl(a4, i3);
          return l2 === s4 && l2 === r2 ? Ql(a4, i3) : Br(r2, l2, q3 | Fe);
        };
      }
      function Ln(i3, r2, a4, l2, c3) {
        i3 !== r2 && hl(r2, function(m4, f2) {
          if (c3 || (c3 = new st()), Z2(m4))
            Bg(i3, r2, f2, a4, Ln, l2, c3);
          else {
            var g2 = l2 ? l2(kl(i3, f2), m4, f2 + "", i3, r2, c3) : s4;
            g2 === s4 && (g2 = m4), dl(i3, f2, g2);
          }
        }, Ae);
      }
      function Bg(i3, r2, a4, l2, c3, m4, f2) {
        var g2 = kl(i3, a4), b3 = kl(r2, a4), P2 = f2.get(b3);
        if (P2) {
          dl(i3, a4, P2);
          return;
        }
        var R3 = m4 ? m4(g2, b3, a4 + "", i3, r2, f2) : s4, F2 = R3 === s4;
        if (F2) {
          var T3 = L3(b3), C2 = !T3 && Wt(b3), x3 = !T3 && !C2 && Ai(b3);
          R3 = b3, T3 || C2 || x3 ? L3(g2) ? R3 = g2 : te(g2) ? R3 = Ee(g2) : C2 ? (F2 = false, R3 = ru(b3, true)) : x3 ? (F2 = false, R3 = nu(b3, true)) : R3 = [] : Hr(b3) || ui(b3) ? (R3 = g2, ui(g2) ? R3 = em(g2) : (!Z2(g2) || At(g2)) && (R3 = _u(b3))) : F2 = false;
        }
        F2 && (f2.set(b3, R3), c3(R3, b3, l2, m4, f2), f2.delete(b3)), dl(i3, a4, R3);
      }
      function Wc(i3, r2) {
        var a4 = i3.length;
        if (!!a4)
          return r2 += r2 < 0 ? a4 : 0, Ct(r2, a4) ? i3[r2] : s4;
      }
      function Xc(i3, r2, a4) {
        r2.length ? r2 = J2(r2, function(m4) {
          return L3(m4) ? function(f2) {
            return li(f2, m4.length === 1 ? m4[0] : m4);
          } : m4;
        }) : r2 = [xe];
        var l2 = -1;
        r2 = J2(r2, Ue(A2()));
        var c3 = Vc(i3, function(m4, f2, g2) {
          var b3 = J2(r2, function(P2) {
            return P2(m4);
          });
          return { criteria: b3, index: ++l2, value: m4 };
        });
        return sh(c3, function(m4, f2) {
          return Xg(m4, f2, a4);
        });
      }
      function Lg(i3, r2) {
        return Yc(i3, r2, function(a4, l2) {
          return Ql(i3, l2);
        });
      }
      function Yc(i3, r2, a4) {
        for (var l2 = -1, c3 = r2.length, m4 = {}; ++l2 < c3; ) {
          var f2 = r2[l2], g2 = li(i3, f2);
          a4(g2, f2) && Lr(m4, qt(f2, i3), g2);
        }
        return m4;
      }
      function Ng(i3) {
        return function(r2) {
          return li(r2, i3);
        };
      }
      function _l(i3, r2, a4, l2) {
        var c3 = l2 ? oh : vi, m4 = -1, f2 = r2.length, g2 = i3;
        for (i3 === r2 && (r2 = Ee(r2)), a4 && (g2 = J2(i3, Ue(a4))); ++m4 < f2; )
          for (var b3 = 0, P2 = r2[m4], R3 = a4 ? a4(P2) : P2; (b3 = c3(g2, R3, b3, l2)) > -1; )
            g2 !== i3 && Rn.call(g2, b3, 1), Rn.call(i3, b3, 1);
        return i3;
      }
      function Qc(i3, r2) {
        for (var a4 = i3 ? r2.length : 0, l2 = a4 - 1; a4--; ) {
          var c3 = r2[a4];
          if (a4 == l2 || c3 !== m4) {
            var m4 = c3;
            Ct(c3) ? Rn.call(i3, c3, 1) : Fl(i3, c3);
          }
        }
        return i3;
      }
      function Il(i3, r2) {
        return i3 + Tn(Ec() * (r2 - i3 + 1));
      }
      function Dg(i3, r2, a4, l2) {
        for (var c3 = -1, m4 = le(Sn((r2 - i3) / (a4 || 1)), 0), f2 = v2(m4); m4--; )
          f2[l2 ? m4 : ++c3] = i3, i3 += a4;
        return f2;
      }
      function Pl(i3, r2) {
        var a4 = "";
        if (!i3 || r2 < 1 || r2 > N2)
          return a4;
        do
          r2 % 2 && (a4 += i3), r2 = Tn(r2 / 2), r2 && (i3 += i3);
        while (r2);
        return a4;
      }
      function H4(i3, r2) {
        return Gl(Ru(i3, r2, xe), i3 + "");
      }
      function Ug(i3) {
        return xc(xi(i3));
      }
      function Hg(i3, r2) {
        var a4 = xi(i3);
        return Kn(a4, si(r2, 0, a4.length));
      }
      function Lr(i3, r2, a4, l2) {
        if (!Z2(i3))
          return i3;
        r2 = qt(r2, i3);
        for (var c3 = -1, m4 = r2.length, f2 = m4 - 1, g2 = i3; g2 != null && ++c3 < m4; ) {
          var b3 = ht(r2[c3]), P2 = a4;
          if (b3 === "__proto__" || b3 === "constructor" || b3 === "prototype")
            return i3;
          if (c3 != f2) {
            var R3 = g2[b3];
            P2 = l2 ? l2(R3, b3, g2) : s4, P2 === s4 && (P2 = Z2(R3) ? R3 : Ct(r2[c3 + 1]) ? [] : {});
          }
          Ar(g2, b3, P2), g2 = g2[b3];
        }
        return i3;
      }
      var zc = En ? function(i3, r2) {
        return En.set(i3, r2), i3;
      } : xe, kg = Fn ? function(i3, r2) {
        return Fn(i3, "toString", { configurable: true, enumerable: false, value: Jl(r2), writable: true });
      } : xe;
      function Gg(i3) {
        return Kn(xi(i3));
      }
      function Je(i3, r2, a4) {
        var l2 = -1, c3 = i3.length;
        r2 < 0 && (r2 = -r2 > c3 ? 0 : c3 + r2), a4 = a4 > c3 ? c3 : a4, a4 < 0 && (a4 += c3), c3 = r2 > a4 ? 0 : a4 - r2 >>> 0, r2 >>>= 0;
        for (var m4 = v2(c3); ++l2 < c3; )
          m4[l2] = i3[l2 + r2];
        return m4;
      }
      function $g(i3, r2) {
        var a4;
        return $t(i3, function(l2, c3, m4) {
          return a4 = r2(l2, c3, m4), !a4;
        }), !!a4;
      }
      function Nn(i3, r2, a4) {
        var l2 = 0, c3 = i3 == null ? l2 : i3.length;
        if (typeof r2 == "number" && r2 === r2 && c3 <= Vd) {
          for (; l2 < c3; ) {
            var m4 = l2 + c3 >>> 1, f2 = i3[m4];
            f2 !== null && !ke(f2) && (a4 ? f2 <= r2 : f2 < r2) ? l2 = m4 + 1 : c3 = m4;
          }
          return c3;
        }
        return Rl(i3, r2, xe, a4);
      }
      function Rl(i3, r2, a4, l2) {
        var c3 = 0, m4 = i3 == null ? 0 : i3.length;
        if (m4 === 0)
          return 0;
        r2 = a4(r2);
        for (var f2 = r2 !== r2, g2 = r2 === null, b3 = ke(r2), P2 = r2 === s4; c3 < m4; ) {
          var R3 = Tn((c3 + m4) / 2), F2 = a4(i3[R3]), T3 = F2 !== s4, C2 = F2 === null, x3 = F2 === F2, U2 = ke(F2);
          if (f2)
            var O3 = l2 || x3;
          else
            P2 ? O3 = x3 && (l2 || T3) : g2 ? O3 = x3 && T3 && (l2 || !C2) : b3 ? O3 = x3 && T3 && !C2 && (l2 || !U2) : C2 || U2 ? O3 = false : O3 = l2 ? F2 <= r2 : F2 < r2;
          O3 ? c3 = R3 + 1 : m4 = R3;
        }
        return ge(m4, $d);
      }
      function Jc(i3, r2) {
        for (var a4 = -1, l2 = i3.length, c3 = 0, m4 = []; ++a4 < l2; ) {
          var f2 = i3[a4], g2 = r2 ? r2(f2) : f2;
          if (!a4 || !lt(g2, b3)) {
            var b3 = g2;
            m4[c3++] = f2 === 0 ? 0 : f2;
          }
        }
        return m4;
      }
      function Zc(i3) {
        return typeof i3 == "number" ? i3 : ke(i3) ? sn : +i3;
      }
      function He(i3) {
        if (typeof i3 == "string")
          return i3;
        if (L3(i3))
          return J2(i3, He) + "";
        if (ke(i3))
          return Cc ? Cc.call(i3) : "";
        var r2 = i3 + "";
        return r2 == "0" && 1 / i3 == -ii ? "-0" : r2;
      }
      function Vt(i3, r2, a4) {
        var l2 = -1, c3 = hn, m4 = i3.length, f2 = true, g2 = [], b3 = g2;
        if (a4)
          f2 = false, c3 = el;
        else if (m4 >= t3) {
          var P2 = r2 ? null : jg(i3);
          if (P2)
            return yn(P2);
          f2 = false, c3 = Rr, b3 = new oi();
        } else
          b3 = r2 ? [] : g2;
        e:
          for (; ++l2 < m4; ) {
            var R3 = i3[l2], F2 = r2 ? r2(R3) : R3;
            if (R3 = a4 || R3 !== 0 ? R3 : 0, f2 && F2 === F2) {
              for (var T3 = b3.length; T3--; )
                if (b3[T3] === F2)
                  continue e;
              r2 && b3.push(F2), g2.push(R3);
            } else
              c3(b3, F2, a4) || (b3 !== g2 && b3.push(F2), g2.push(R3));
          }
        return g2;
      }
      function Fl(i3, r2) {
        return r2 = qt(r2, i3), i3 = Fu(i3, r2), i3 == null || delete i3[ht(Ze(r2))];
      }
      function jc(i3, r2, a4, l2) {
        return Lr(i3, r2, a4(li(i3, r2)), l2);
      }
      function Dn(i3, r2, a4, l2) {
        for (var c3 = i3.length, m4 = l2 ? c3 : -1; (l2 ? m4-- : ++m4 < c3) && r2(i3[m4], m4, i3); )
          ;
        return a4 ? Je(i3, l2 ? 0 : m4, l2 ? m4 + 1 : c3) : Je(i3, l2 ? m4 + 1 : 0, l2 ? c3 : m4);
      }
      function eu(i3, r2) {
        var a4 = i3;
        return a4 instanceof G3 && (a4 = a4.value()), tl(r2, function(l2, c3) {
          return c3.func.apply(c3.thisArg, Ut([l2], c3.args));
        }, a4);
      }
      function Sl(i3, r2, a4) {
        var l2 = i3.length;
        if (l2 < 2)
          return l2 ? Vt(i3[0]) : [];
        for (var c3 = -1, m4 = v2(l2); ++c3 < l2; )
          for (var f2 = i3[c3], g2 = -1; ++g2 < l2; )
            g2 != c3 && (m4[c3] = xr(m4[c3] || f2, i3[g2], r2, a4));
        return Vt(me(m4, 1), r2, a4);
      }
      function tu(i3, r2, a4) {
        for (var l2 = -1, c3 = i3.length, m4 = r2.length, f2 = {}; ++l2 < c3; ) {
          var g2 = l2 < m4 ? r2[l2] : s4;
          a4(f2, i3[l2], g2);
        }
        return f2;
      }
      function Tl(i3) {
        return te(i3) ? i3 : [];
      }
      function El(i3) {
        return typeof i3 == "function" ? i3 : xe;
      }
      function qt(i3, r2) {
        return L3(i3) ? i3 : Ul(i3, r2) ? [i3] : Cu(K2(i3));
      }
      var Vg = H4;
      function Kt(i3, r2, a4) {
        var l2 = i3.length;
        return a4 = a4 === s4 ? l2 : a4, !r2 && a4 >= l2 ? i3 : Je(i3, r2, a4);
      }
      var iu = Ch || function(i3) {
        return pe.clearTimeout(i3);
      };
      function ru(i3, r2) {
        if (r2)
          return i3.slice();
        var a4 = i3.length, l2 = Pc ? Pc(a4) : new i3.constructor(a4);
        return i3.copy(l2), l2;
      }
      function Cl(i3) {
        var r2 = new i3.constructor(i3.byteLength);
        return new In(r2).set(new In(i3)), r2;
      }
      function qg(i3, r2) {
        var a4 = r2 ? Cl(i3.buffer) : i3.buffer;
        return new i3.constructor(a4, i3.byteOffset, i3.byteLength);
      }
      function Kg(i3) {
        var r2 = new i3.constructor(i3.source, kp.exec(i3));
        return r2.lastIndex = i3.lastIndex, r2;
      }
      function Wg(i3) {
        return Cr ? Y3(Cr.call(i3)) : {};
      }
      function nu(i3, r2) {
        var a4 = r2 ? Cl(i3.buffer) : i3.buffer;
        return new i3.constructor(a4, i3.byteOffset, i3.length);
      }
      function au(i3, r2) {
        if (i3 !== r2) {
          var a4 = i3 !== s4, l2 = i3 === null, c3 = i3 === i3, m4 = ke(i3), f2 = r2 !== s4, g2 = r2 === null, b3 = r2 === r2, P2 = ke(r2);
          if (!g2 && !P2 && !m4 && i3 > r2 || m4 && f2 && b3 && !g2 && !P2 || l2 && f2 && b3 || !a4 && b3 || !c3)
            return 1;
          if (!l2 && !m4 && !P2 && i3 < r2 || P2 && a4 && c3 && !l2 && !m4 || g2 && a4 && c3 || !f2 && c3 || !b3)
            return -1;
        }
        return 0;
      }
      function Xg(i3, r2, a4) {
        for (var l2 = -1, c3 = i3.criteria, m4 = r2.criteria, f2 = c3.length, g2 = a4.length; ++l2 < f2; ) {
          var b3 = au(c3[l2], m4[l2]);
          if (b3) {
            if (l2 >= g2)
              return b3;
            var P2 = a4[l2];
            return b3 * (P2 == "desc" ? -1 : 1);
          }
        }
        return i3.index - r2.index;
      }
      function ou(i3, r2, a4, l2) {
        for (var c3 = -1, m4 = i3.length, f2 = a4.length, g2 = -1, b3 = r2.length, P2 = le(m4 - f2, 0), R3 = v2(b3 + P2), F2 = !l2; ++g2 < b3; )
          R3[g2] = r2[g2];
        for (; ++c3 < f2; )
          (F2 || c3 < m4) && (R3[a4[c3]] = i3[c3]);
        for (; P2--; )
          R3[g2++] = i3[c3++];
        return R3;
      }
      function su(i3, r2, a4, l2) {
        for (var c3 = -1, m4 = i3.length, f2 = -1, g2 = a4.length, b3 = -1, P2 = r2.length, R3 = le(m4 - g2, 0), F2 = v2(R3 + P2), T3 = !l2; ++c3 < R3; )
          F2[c3] = i3[c3];
        for (var C2 = c3; ++b3 < P2; )
          F2[C2 + b3] = r2[b3];
        for (; ++f2 < g2; )
          (T3 || c3 < m4) && (F2[C2 + a4[f2]] = i3[c3++]);
        return F2;
      }
      function Ee(i3, r2) {
        var a4 = -1, l2 = i3.length;
        for (r2 || (r2 = v2(l2)); ++a4 < l2; )
          r2[a4] = i3[a4];
        return r2;
      }
      function ft(i3, r2, a4, l2) {
        var c3 = !a4;
        a4 || (a4 = {});
        for (var m4 = -1, f2 = r2.length; ++m4 < f2; ) {
          var g2 = r2[m4], b3 = l2 ? l2(a4[g2], i3[g2], g2, a4, i3) : s4;
          b3 === s4 && (b3 = i3[g2]), c3 ? St(a4, g2, b3) : Ar(a4, g2, b3);
        }
        return a4;
      }
      function Yg(i3, r2) {
        return ft(i3, Dl(i3), r2);
      }
      function Qg(i3, r2) {
        return ft(i3, wu(i3), r2);
      }
      function Un(i3, r2) {
        return function(a4, l2) {
          var c3 = L3(a4) ? eh : yg, m4 = r2 ? r2() : {};
          return c3(a4, i3, A2(l2, 2), m4);
        };
      }
      function Ti(i3) {
        return H4(function(r2, a4) {
          var l2 = -1, c3 = a4.length, m4 = c3 > 1 ? a4[c3 - 1] : s4, f2 = c3 > 2 ? a4[2] : s4;
          for (m4 = i3.length > 3 && typeof m4 == "function" ? (c3--, m4) : s4, f2 && _e(a4[0], a4[1], f2) && (m4 = c3 < 3 ? s4 : m4, c3 = 1), r2 = Y3(r2); ++l2 < c3; ) {
            var g2 = a4[l2];
            g2 && i3(r2, g2, l2, m4);
          }
          return r2;
        });
      }
      function lu(i3, r2) {
        return function(a4, l2) {
          if (a4 == null)
            return a4;
          if (!Ce(a4))
            return i3(a4, l2);
          for (var c3 = a4.length, m4 = r2 ? c3 : -1, f2 = Y3(a4); (r2 ? m4-- : ++m4 < c3) && l2(f2[m4], m4, f2) !== false; )
            ;
          return a4;
        };
      }
      function pu(i3) {
        return function(r2, a4, l2) {
          for (var c3 = -1, m4 = Y3(r2), f2 = l2(r2), g2 = f2.length; g2--; ) {
            var b3 = f2[i3 ? g2 : ++c3];
            if (a4(m4[b3], b3, m4) === false)
              break;
          }
          return r2;
        };
      }
      function zg(i3, r2, a4) {
        var l2 = r2 & we, c3 = Nr(i3);
        function m4() {
          var f2 = this && this !== pe && this instanceof m4 ? c3 : i3;
          return f2.apply(l2 ? a4 : this, arguments);
        }
        return m4;
      }
      function cu(i3) {
        return function(r2) {
          r2 = K2(r2);
          var a4 = _i(r2) ? ot(r2) : s4, l2 = a4 ? a4[0] : r2.charAt(0), c3 = a4 ? Kt(a4, 1).join("") : r2.slice(1);
          return l2[i3]() + c3;
        };
      }
      function Ei(i3) {
        return function(r2) {
          return tl(lm(sm(r2).replace(kf, "")), i3, "");
        };
      }
      function Nr(i3) {
        return function() {
          var r2 = arguments;
          switch (r2.length) {
            case 0:
              return new i3();
            case 1:
              return new i3(r2[0]);
            case 2:
              return new i3(r2[0], r2[1]);
            case 3:
              return new i3(r2[0], r2[1], r2[2]);
            case 4:
              return new i3(r2[0], r2[1], r2[2], r2[3]);
            case 5:
              return new i3(r2[0], r2[1], r2[2], r2[3], r2[4]);
            case 6:
              return new i3(r2[0], r2[1], r2[2], r2[3], r2[4], r2[5]);
            case 7:
              return new i3(r2[0], r2[1], r2[2], r2[3], r2[4], r2[5], r2[6]);
          }
          var a4 = Si(i3.prototype), l2 = i3.apply(a4, r2);
          return Z2(l2) ? l2 : a4;
        };
      }
      function Jg(i3, r2, a4) {
        var l2 = Nr(i3);
        function c3() {
          for (var m4 = arguments.length, f2 = v2(m4), g2 = m4, b3 = Ci(c3); g2--; )
            f2[g2] = arguments[g2];
          var P2 = m4 < 3 && f2[0] !== b3 && f2[m4 - 1] !== b3 ? [] : Ht(f2, b3);
          if (m4 -= P2.length, m4 < a4)
            return hu(i3, r2, Hn, c3.placeholder, s4, f2, P2, s4, s4, a4 - m4);
          var R3 = this && this !== pe && this instanceof c3 ? l2 : i3;
          return De(R3, this, f2);
        }
        return c3;
      }
      function uu(i3) {
        return function(r2, a4, l2) {
          var c3 = Y3(r2);
          if (!Ce(r2)) {
            var m4 = A2(a4, 3);
            r2 = ce(r2), a4 = function(g2) {
              return m4(c3[g2], g2, c3);
            };
          }
          var f2 = i3(r2, a4, l2);
          return f2 > -1 ? c3[m4 ? r2[f2] : f2] : s4;
        };
      }
      function mu(i3) {
        return Et(function(r2) {
          var a4 = r2.length, l2 = a4, c3 = Qe.prototype.thru;
          for (i3 && r2.reverse(); l2--; ) {
            var m4 = r2[l2];
            if (typeof m4 != "function")
              throw new Ye(o2);
            if (c3 && !f2 && Vn(m4) == "wrapper")
              var f2 = new Qe([], true);
          }
          for (l2 = f2 ? l2 : a4; ++l2 < a4; ) {
            m4 = r2[l2];
            var g2 = Vn(m4), b3 = g2 == "wrapper" ? Ll(m4) : s4;
            b3 && Hl(b3[0]) && b3[1] == (It | ue | Ke | yr) && !b3[4].length && b3[9] == 1 ? f2 = f2[Vn(b3[0])].apply(f2, b3[3]) : f2 = m4.length == 1 && Hl(m4) ? f2[g2]() : f2.thru(m4);
          }
          return function() {
            var P2 = arguments, R3 = P2[0];
            if (f2 && P2.length == 1 && L3(R3))
              return f2.plant(R3).value();
            for (var F2 = 0, T3 = a4 ? r2[F2].apply(this, P2) : R3; ++F2 < a4; )
              T3 = r2[F2].call(this, T3);
            return T3;
          };
        });
      }
      function Hn(i3, r2, a4, l2, c3, m4, f2, g2, b3, P2) {
        var R3 = r2 & It, F2 = r2 & we, T3 = r2 & ct, C2 = r2 & (ue | Te), x3 = r2 & Ls, U2 = T3 ? s4 : Nr(i3);
        function O3() {
          for (var k3 = arguments.length, $2 = v2(k3), Ge = k3; Ge--; )
            $2[Ge] = arguments[Ge];
          if (C2)
            var Ie = Ci(O3), $e = ph($2, Ie);
          if (l2 && ($2 = ou($2, l2, c3, C2)), m4 && ($2 = su($2, m4, f2, C2)), k3 -= $e, C2 && k3 < P2) {
            var ie = Ht($2, Ie);
            return hu(i3, r2, Hn, O3.placeholder, a4, $2, ie, g2, b3, P2 - k3);
          }
          var pt = F2 ? a4 : this, Ot = T3 ? pt[i3] : i3;
          return k3 = $2.length, g2 ? $2 = yy($2, g2) : x3 && k3 > 1 && $2.reverse(), R3 && b3 < k3 && ($2.length = b3), this && this !== pe && this instanceof O3 && (Ot = U2 || Nr(Ot)), Ot.apply(pt, $2);
        }
        return O3;
      }
      function du(i3, r2) {
        return function(a4, l2) {
          return Rg(a4, i3, r2(l2), {});
        };
      }
      function kn(i3, r2) {
        return function(a4, l2) {
          var c3;
          if (a4 === s4 && l2 === s4)
            return r2;
          if (a4 !== s4 && (c3 = a4), l2 !== s4) {
            if (c3 === s4)
              return l2;
            typeof a4 == "string" || typeof l2 == "string" ? (a4 = He(a4), l2 = He(l2)) : (a4 = Zc(a4), l2 = Zc(l2)), c3 = i3(a4, l2);
          }
          return c3;
        };
      }
      function Al(i3) {
        return Et(function(r2) {
          return r2 = J2(r2, Ue(A2())), H4(function(a4) {
            var l2 = this;
            return i3(r2, function(c3) {
              return De(c3, l2, a4);
            });
          });
        });
      }
      function Gn(i3, r2) {
        r2 = r2 === s4 ? " " : He(r2);
        var a4 = r2.length;
        if (a4 < 2)
          return a4 ? Pl(r2, i3) : r2;
        var l2 = Pl(r2, Sn(i3 / Ii(r2)));
        return _i(r2) ? Kt(ot(l2), 0, i3).join("") : l2.slice(0, i3);
      }
      function Zg(i3, r2, a4, l2) {
        var c3 = r2 & we, m4 = Nr(i3);
        function f2() {
          for (var g2 = -1, b3 = arguments.length, P2 = -1, R3 = l2.length, F2 = v2(R3 + b3), T3 = this && this !== pe && this instanceof f2 ? m4 : i3; ++P2 < R3; )
            F2[P2] = l2[P2];
          for (; b3--; )
            F2[P2++] = arguments[++g2];
          return De(T3, c3 ? a4 : this, F2);
        }
        return f2;
      }
      function fu(i3) {
        return function(r2, a4, l2) {
          return l2 && typeof l2 != "number" && _e(r2, a4, l2) && (a4 = l2 = s4), r2 = xt(r2), a4 === s4 ? (a4 = r2, r2 = 0) : a4 = xt(a4), l2 = l2 === s4 ? r2 < a4 ? 1 : -1 : xt(l2), Dg(r2, a4, l2, i3);
        };
      }
      function $n(i3) {
        return function(r2, a4) {
          return typeof r2 == "string" && typeof a4 == "string" || (r2 = je(r2), a4 = je(a4)), i3(r2, a4);
        };
      }
      function hu(i3, r2, a4, l2, c3, m4, f2, g2, b3, P2) {
        var R3 = r2 & ue, F2 = R3 ? f2 : s4, T3 = R3 ? s4 : f2, C2 = R3 ? m4 : s4, x3 = R3 ? s4 : m4;
        r2 |= R3 ? Ke : ut, r2 &= ~(R3 ? ut : Ke), r2 & Se || (r2 &= ~(we | ct));
        var U2 = [i3, r2, c3, C2, F2, x3, T3, g2, b3, P2], O3 = a4.apply(s4, U2);
        return Hl(i3) && Su(O3, U2), O3.placeholder = l2, Tu(O3, i3, r2);
      }
      function xl(i3) {
        var r2 = se[i3];
        return function(a4, l2) {
          if (a4 = je(a4), l2 = l2 == null ? 0 : ge(D3(l2), 292), l2 && Tc(a4)) {
            var c3 = (K2(a4) + "e").split("e"), m4 = r2(c3[0] + "e" + (+c3[1] + l2));
            return c3 = (K2(m4) + "e").split("e"), +(c3[0] + "e" + (+c3[1] - l2));
          }
          return r2(a4);
        };
      }
      var jg = Ri && 1 / yn(new Ri([, -0]))[1] == ii ? function(i3) {
        return new Ri(i3);
      } : ep;
      function gu(i3) {
        return function(r2) {
          var a4 = ye(r2);
          return a4 == nt ? ll(r2) : a4 == at ? gh(r2) : lh(r2, i3(r2));
        };
      }
      function Tt(i3, r2, a4, l2, c3, m4, f2, g2) {
        var b3 = r2 & ct;
        if (!b3 && typeof i3 != "function")
          throw new Ye(o2);
        var P2 = l2 ? l2.length : 0;
        if (P2 || (r2 &= ~(Ke | ut), l2 = c3 = s4), f2 = f2 === s4 ? f2 : le(D3(f2), 0), g2 = g2 === s4 ? g2 : D3(g2), P2 -= c3 ? c3.length : 0, r2 & ut) {
          var R3 = l2, F2 = c3;
          l2 = c3 = s4;
        }
        var T3 = b3 ? s4 : Ll(i3), C2 = [i3, r2, a4, l2, c3, R3, F2, m4, f2, g2];
        if (T3 && fy(C2, T3), i3 = C2[0], r2 = C2[1], a4 = C2[2], l2 = C2[3], c3 = C2[4], g2 = C2[9] = C2[9] === s4 ? b3 ? 0 : i3.length : le(C2[9] - P2, 0), !g2 && r2 & (ue | Te) && (r2 &= ~(ue | Te)), !r2 || r2 == we)
          var x3 = zg(i3, r2, a4);
        else
          r2 == ue || r2 == Te ? x3 = Jg(i3, r2, g2) : (r2 == Ke || r2 == (we | Ke)) && !c3.length ? x3 = Zg(i3, r2, a4, l2) : x3 = Hn.apply(s4, C2);
        var U2 = T3 ? zc : Su;
        return Tu(U2(x3, C2), i3, r2);
      }
      function yu(i3, r2, a4, l2) {
        return i3 === s4 || lt(i3, Pi[a4]) && !X4.call(l2, a4) ? r2 : i3;
      }
      function Mu(i3, r2, a4, l2, c3, m4) {
        return Z2(i3) && Z2(r2) && (m4.set(r2, i3), Ln(i3, r2, s4, Mu, m4), m4.delete(r2)), i3;
      }
      function ey(i3) {
        return Hr(i3) ? s4 : i3;
      }
      function bu(i3, r2, a4, l2, c3, m4) {
        var f2 = a4 & q3, g2 = i3.length, b3 = r2.length;
        if (g2 != b3 && !(f2 && b3 > g2))
          return false;
        var P2 = m4.get(i3), R3 = m4.get(r2);
        if (P2 && R3)
          return P2 == r2 && R3 == i3;
        var F2 = -1, T3 = true, C2 = a4 & Fe ? new oi() : s4;
        for (m4.set(i3, r2), m4.set(r2, i3); ++F2 < g2; ) {
          var x3 = i3[F2], U2 = r2[F2];
          if (l2)
            var O3 = f2 ? l2(U2, x3, F2, r2, i3, m4) : l2(x3, U2, F2, i3, r2, m4);
          if (O3 !== s4) {
            if (O3)
              continue;
            T3 = false;
            break;
          }
          if (C2) {
            if (!il(r2, function(k3, $2) {
              if (!Rr(C2, $2) && (x3 === k3 || c3(x3, k3, a4, l2, m4)))
                return C2.push($2);
            })) {
              T3 = false;
              break;
            }
          } else if (!(x3 === U2 || c3(x3, U2, a4, l2, m4))) {
            T3 = false;
            break;
          }
        }
        return m4.delete(i3), m4.delete(r2), T3;
      }
      function ty(i3, r2, a4, l2, c3, m4, f2) {
        switch (a4) {
          case bi:
            if (i3.byteLength != r2.byteLength || i3.byteOffset != r2.byteOffset)
              return false;
            i3 = i3.buffer, r2 = r2.buffer;
          case Pr:
            return !(i3.byteLength != r2.byteLength || !m4(new In(i3), new In(r2)));
          case Mr:
          case br:
          case wr:
            return lt(+i3, +r2);
          case pn:
            return i3.name == r2.name && i3.message == r2.message;
          case vr:
          case _r:
            return i3 == r2 + "";
          case nt:
            var g2 = ll;
          case at:
            var b3 = l2 & q3;
            if (g2 || (g2 = yn), i3.size != r2.size && !b3)
              return false;
            var P2 = f2.get(i3);
            if (P2)
              return P2 == r2;
            l2 |= Fe, f2.set(i3, r2);
            var R3 = bu(g2(i3), g2(r2), l2, c3, m4, f2);
            return f2.delete(i3), R3;
          case un:
            if (Cr)
              return Cr.call(i3) == Cr.call(r2);
        }
        return false;
      }
      function iy(i3, r2, a4, l2, c3, m4) {
        var f2 = a4 & q3, g2 = Ol(i3), b3 = g2.length, P2 = Ol(r2), R3 = P2.length;
        if (b3 != R3 && !f2)
          return false;
        for (var F2 = b3; F2--; ) {
          var T3 = g2[F2];
          if (!(f2 ? T3 in r2 : X4.call(r2, T3)))
            return false;
        }
        var C2 = m4.get(i3), x3 = m4.get(r2);
        if (C2 && x3)
          return C2 == r2 && x3 == i3;
        var U2 = true;
        m4.set(i3, r2), m4.set(r2, i3);
        for (var O3 = f2; ++F2 < b3; ) {
          T3 = g2[F2];
          var k3 = i3[T3], $2 = r2[T3];
          if (l2)
            var Ge = f2 ? l2($2, k3, T3, r2, i3, m4) : l2(k3, $2, T3, i3, r2, m4);
          if (!(Ge === s4 ? k3 === $2 || c3(k3, $2, a4, l2, m4) : Ge)) {
            U2 = false;
            break;
          }
          O3 || (O3 = T3 == "constructor");
        }
        if (U2 && !O3) {
          var Ie = i3.constructor, $e = r2.constructor;
          Ie != $e && "constructor" in i3 && "constructor" in r2 && !(typeof Ie == "function" && Ie instanceof Ie && typeof $e == "function" && $e instanceof $e) && (U2 = false);
        }
        return m4.delete(i3), m4.delete(r2), U2;
      }
      function Et(i3) {
        return Gl(Ru(i3, s4, Bu), i3 + "");
      }
      function Ol(i3) {
        return Hc(i3, ce, Dl);
      }
      function Bl(i3) {
        return Hc(i3, Ae, wu);
      }
      var Ll = En ? function(i3) {
        return En.get(i3);
      } : ep;
      function Vn(i3) {
        for (var r2 = i3.name + "", a4 = Fi[r2], l2 = X4.call(Fi, r2) ? a4.length : 0; l2--; ) {
          var c3 = a4[l2], m4 = c3.func;
          if (m4 == null || m4 == i3)
            return c3.name;
        }
        return r2;
      }
      function Ci(i3) {
        var r2 = X4.call(u3, "placeholder") ? u3 : i3;
        return r2.placeholder;
      }
      function A2() {
        var i3 = u3.iteratee || Zl;
        return i3 = i3 === Zl ? $c : i3, arguments.length ? i3(arguments[0], arguments[1]) : i3;
      }
      function qn(i3, r2) {
        var a4 = i3.__data__;
        return cy(r2) ? a4[typeof r2 == "string" ? "string" : "hash"] : a4.map;
      }
      function Nl(i3) {
        for (var r2 = ce(i3), a4 = r2.length; a4--; ) {
          var l2 = r2[a4], c3 = i3[l2];
          r2[a4] = [l2, c3, Iu(c3)];
        }
        return r2;
      }
      function pi(i3, r2) {
        var a4 = dh(i3, r2);
        return Gc(a4) ? a4 : s4;
      }
      function ry(i3) {
        var r2 = X4.call(i3, ni), a4 = i3[ni];
        try {
          i3[ni] = s4;
          var l2 = true;
        } catch {
        }
        var c3 = vn.call(i3);
        return l2 && (r2 ? i3[ni] = a4 : delete i3[ni]), c3;
      }
      var Dl = cl ? function(i3) {
        return i3 == null ? [] : (i3 = Y3(i3), Dt(cl(i3), function(r2) {
          return Fc.call(i3, r2);
        }));
      } : tp, wu = cl ? function(i3) {
        for (var r2 = []; i3; )
          Ut(r2, Dl(i3)), i3 = Pn(i3);
        return r2;
      } : tp, ye = ve;
      (ul && ye(new ul(new ArrayBuffer(1))) != bi || Sr && ye(new Sr()) != nt || ml && ye(ml.resolve()) != Np || Ri && ye(new Ri()) != at || Tr && ye(new Tr()) != Ir) && (ye = function(i3) {
        var r2 = ve(i3), a4 = r2 == Pt ? i3.constructor : s4, l2 = a4 ? ci(a4) : "";
        if (l2)
          switch (l2) {
            case Hh:
              return bi;
            case kh:
              return nt;
            case Gh:
              return Np;
            case $h:
              return at;
            case Vh:
              return Ir;
          }
        return r2;
      });
      function ny(i3, r2, a4) {
        for (var l2 = -1, c3 = a4.length; ++l2 < c3; ) {
          var m4 = a4[l2], f2 = m4.size;
          switch (m4.type) {
            case "drop":
              i3 += f2;
              break;
            case "dropRight":
              r2 -= f2;
              break;
            case "take":
              r2 = ge(r2, i3 + f2);
              break;
            case "takeRight":
              i3 = le(i3, r2 - f2);
              break;
          }
        }
        return { start: i3, end: r2 };
      }
      function ay(i3) {
        var r2 = i3.match(uf);
        return r2 ? r2[1].split(mf) : [];
      }
      function vu(i3, r2, a4) {
        r2 = qt(r2, i3);
        for (var l2 = -1, c3 = r2.length, m4 = false; ++l2 < c3; ) {
          var f2 = ht(r2[l2]);
          if (!(m4 = i3 != null && a4(i3, f2)))
            break;
          i3 = i3[f2];
        }
        return m4 || ++l2 != c3 ? m4 : (c3 = i3 == null ? 0 : i3.length, !!c3 && Jn(c3) && Ct(f2, c3) && (L3(i3) || ui(i3)));
      }
      function oy(i3) {
        var r2 = i3.length, a4 = new i3.constructor(r2);
        return r2 && typeof i3[0] == "string" && X4.call(i3, "index") && (a4.index = i3.index, a4.input = i3.input), a4;
      }
      function _u(i3) {
        return typeof i3.constructor == "function" && !Dr(i3) ? Si(Pn(i3)) : {};
      }
      function sy(i3, r2, a4) {
        var l2 = i3.constructor;
        switch (r2) {
          case Pr:
            return Cl(i3);
          case Mr:
          case br:
            return new l2(+i3);
          case bi:
            return qg(i3, a4);
          case Ns:
          case Ds:
          case Us:
          case Hs:
          case ks:
          case Gs:
          case $s:
          case Vs:
          case qs:
            return nu(i3, a4);
          case nt:
            return new l2();
          case wr:
          case _r:
            return new l2(i3);
          case vr:
            return Kg(i3);
          case at:
            return new l2();
          case un:
            return Wg(i3);
        }
      }
      function ly(i3, r2) {
        var a4 = r2.length;
        if (!a4)
          return i3;
        var l2 = a4 - 1;
        return r2[l2] = (a4 > 1 ? "& " : "") + r2[l2], r2 = r2.join(a4 > 2 ? ", " : " "), i3.replace(cf, `{
/* [wrapped with ` + r2 + `] */
`);
      }
      function py(i3) {
        return L3(i3) || ui(i3) || !!(Sc && i3 && i3[Sc]);
      }
      function Ct(i3, r2) {
        var a4 = typeof i3;
        return r2 = r2 != null ? r2 : N2, !!r2 && (a4 == "number" || a4 != "symbol" && vf.test(i3)) && i3 > -1 && i3 % 1 == 0 && i3 < r2;
      }
      function _e(i3, r2, a4) {
        if (!Z2(a4))
          return false;
        var l2 = typeof r2;
        return (l2 == "number" ? Ce(a4) && Ct(r2, a4.length) : l2 == "string" && r2 in a4) ? lt(a4[r2], i3) : false;
      }
      function Ul(i3, r2) {
        if (L3(i3))
          return false;
        var a4 = typeof i3;
        return a4 == "number" || a4 == "symbol" || a4 == "boolean" || i3 == null || ke(i3) ? true : of.test(i3) || !af.test(i3) || r2 != null && i3 in Y3(r2);
      }
      function cy(i3) {
        var r2 = typeof i3;
        return r2 == "string" || r2 == "number" || r2 == "symbol" || r2 == "boolean" ? i3 !== "__proto__" : i3 === null;
      }
      function Hl(i3) {
        var r2 = Vn(i3), a4 = u3[r2];
        if (typeof a4 != "function" || !(r2 in G3.prototype))
          return false;
        if (i3 === a4)
          return true;
        var l2 = Ll(a4);
        return !!l2 && i3 === l2[0];
      }
      function uy(i3) {
        return !!Ic && Ic in i3;
      }
      var my = bn ? At : ip;
      function Dr(i3) {
        var r2 = i3 && i3.constructor, a4 = typeof r2 == "function" && r2.prototype || Pi;
        return i3 === a4;
      }
      function Iu(i3) {
        return i3 === i3 && !Z2(i3);
      }
      function Pu(i3, r2) {
        return function(a4) {
          return a4 == null ? false : a4[i3] === r2 && (r2 !== s4 || i3 in Y3(a4));
        };
      }
      function dy(i3) {
        var r2 = Qn(i3, function(l2) {
          return a4.size === h4 && a4.clear(), l2;
        }), a4 = r2.cache;
        return r2;
      }
      function fy(i3, r2) {
        var a4 = i3[1], l2 = r2[1], c3 = a4 | l2, m4 = c3 < (we | ct | It), f2 = l2 == It && a4 == ue || l2 == It && a4 == yr && i3[7].length <= r2[8] || l2 == (It | yr) && r2[7].length <= r2[8] && a4 == ue;
        if (!(m4 || f2))
          return i3;
        l2 & we && (i3[2] = r2[2], c3 |= a4 & we ? 0 : Se);
        var g2 = r2[3];
        if (g2) {
          var b3 = i3[3];
          i3[3] = b3 ? ou(b3, g2, r2[4]) : g2, i3[4] = b3 ? Ht(i3[3], y4) : r2[4];
        }
        return g2 = r2[5], g2 && (b3 = i3[5], i3[5] = b3 ? su(b3, g2, r2[6]) : g2, i3[6] = b3 ? Ht(i3[5], y4) : r2[6]), g2 = r2[7], g2 && (i3[7] = g2), l2 & It && (i3[8] = i3[8] == null ? r2[8] : ge(i3[8], r2[8])), i3[9] == null && (i3[9] = r2[9]), i3[0] = r2[0], i3[1] = c3, i3;
      }
      function hy(i3) {
        var r2 = [];
        if (i3 != null)
          for (var a4 in Y3(i3))
            r2.push(a4);
        return r2;
      }
      function gy(i3) {
        return vn.call(i3);
      }
      function Ru(i3, r2, a4) {
        return r2 = le(r2 === s4 ? i3.length - 1 : r2, 0), function() {
          for (var l2 = arguments, c3 = -1, m4 = le(l2.length - r2, 0), f2 = v2(m4); ++c3 < m4; )
            f2[c3] = l2[r2 + c3];
          c3 = -1;
          for (var g2 = v2(r2 + 1); ++c3 < r2; )
            g2[c3] = l2[c3];
          return g2[r2] = a4(f2), De(i3, this, g2);
        };
      }
      function Fu(i3, r2) {
        return r2.length < 2 ? i3 : li(i3, Je(r2, 0, -1));
      }
      function yy(i3, r2) {
        for (var a4 = i3.length, l2 = ge(r2.length, a4), c3 = Ee(i3); l2--; ) {
          var m4 = r2[l2];
          i3[l2] = Ct(m4, a4) ? c3[m4] : s4;
        }
        return i3;
      }
      function kl(i3, r2) {
        if (!(r2 === "constructor" && typeof i3[r2] == "function") && r2 != "__proto__")
          return i3[r2];
      }
      var Su = Eu(zc), Ur = xh || function(i3, r2) {
        return pe.setTimeout(i3, r2);
      }, Gl = Eu(kg);
      function Tu(i3, r2, a4) {
        var l2 = r2 + "";
        return Gl(i3, ly(l2, My(ay(l2), a4)));
      }
      function Eu(i3) {
        var r2 = 0, a4 = 0;
        return function() {
          var l2 = Nh(), c3 = Ud - (l2 - a4);
          if (a4 = l2, c3 > 0) {
            if (++r2 >= Dd)
              return arguments[0];
          } else
            r2 = 0;
          return i3.apply(s4, arguments);
        };
      }
      function Kn(i3, r2) {
        var a4 = -1, l2 = i3.length, c3 = l2 - 1;
        for (r2 = r2 === s4 ? l2 : r2; ++a4 < r2; ) {
          var m4 = Il(a4, c3), f2 = i3[m4];
          i3[m4] = i3[a4], i3[a4] = f2;
        }
        return i3.length = r2, i3;
      }
      var Cu = dy(function(i3) {
        var r2 = [];
        return i3.charCodeAt(0) === 46 && r2.push(""), i3.replace(sf, function(a4, l2, c3, m4) {
          r2.push(c3 ? m4.replace(hf, "$1") : l2 || a4);
        }), r2;
      });
      function ht(i3) {
        if (typeof i3 == "string" || ke(i3))
          return i3;
        var r2 = i3 + "";
        return r2 == "0" && 1 / i3 == -ii ? "-0" : r2;
      }
      function ci(i3) {
        if (i3 != null) {
          try {
            return wn.call(i3);
          } catch {
          }
          try {
            return i3 + "";
          } catch {
          }
        }
        return "";
      }
      function My(i3, r2) {
        return Xe(qd, function(a4) {
          var l2 = "_." + a4[0];
          r2 & a4[1] && !hn(i3, l2) && i3.push(l2);
        }), i3.sort();
      }
      function Au(i3) {
        if (i3 instanceof G3)
          return i3.clone();
        var r2 = new Qe(i3.__wrapped__, i3.__chain__);
        return r2.__actions__ = Ee(i3.__actions__), r2.__index__ = i3.__index__, r2.__values__ = i3.__values__, r2;
      }
      function by(i3, r2, a4) {
        (a4 ? _e(i3, r2, a4) : r2 === s4) ? r2 = 1 : r2 = le(D3(r2), 0);
        var l2 = i3 == null ? 0 : i3.length;
        if (!l2 || r2 < 1)
          return [];
        for (var c3 = 0, m4 = 0, f2 = v2(Sn(l2 / r2)); c3 < l2; )
          f2[m4++] = Je(i3, c3, c3 += r2);
        return f2;
      }
      function wy(i3) {
        for (var r2 = -1, a4 = i3 == null ? 0 : i3.length, l2 = 0, c3 = []; ++r2 < a4; ) {
          var m4 = i3[r2];
          m4 && (c3[l2++] = m4);
        }
        return c3;
      }
      function vy() {
        var i3 = arguments.length;
        if (!i3)
          return [];
        for (var r2 = v2(i3 - 1), a4 = arguments[0], l2 = i3; l2--; )
          r2[l2 - 1] = arguments[l2];
        return Ut(L3(a4) ? Ee(a4) : [a4], me(r2, 1));
      }
      var _y = H4(function(i3, r2) {
        return te(i3) ? xr(i3, me(r2, 1, te, true)) : [];
      }), Iy = H4(function(i3, r2) {
        var a4 = Ze(r2);
        return te(a4) && (a4 = s4), te(i3) ? xr(i3, me(r2, 1, te, true), A2(a4, 2)) : [];
      }), Py = H4(function(i3, r2) {
        var a4 = Ze(r2);
        return te(a4) && (a4 = s4), te(i3) ? xr(i3, me(r2, 1, te, true), s4, a4) : [];
      });
      function Ry(i3, r2, a4) {
        var l2 = i3 == null ? 0 : i3.length;
        return l2 ? (r2 = a4 || r2 === s4 ? 1 : D3(r2), Je(i3, r2 < 0 ? 0 : r2, l2)) : [];
      }
      function Fy(i3, r2, a4) {
        var l2 = i3 == null ? 0 : i3.length;
        return l2 ? (r2 = a4 || r2 === s4 ? 1 : D3(r2), r2 = l2 - r2, Je(i3, 0, r2 < 0 ? 0 : r2)) : [];
      }
      function Sy(i3, r2) {
        return i3 && i3.length ? Dn(i3, A2(r2, 3), true, true) : [];
      }
      function Ty(i3, r2) {
        return i3 && i3.length ? Dn(i3, A2(r2, 3), true) : [];
      }
      function Ey(i3, r2, a4, l2) {
        var c3 = i3 == null ? 0 : i3.length;
        return c3 ? (a4 && typeof a4 != "number" && _e(i3, r2, a4) && (a4 = 0, l2 = c3), vg(i3, r2, a4, l2)) : [];
      }
      function xu(i3, r2, a4) {
        var l2 = i3 == null ? 0 : i3.length;
        if (!l2)
          return -1;
        var c3 = a4 == null ? 0 : D3(a4);
        return c3 < 0 && (c3 = le(l2 + c3, 0)), gn(i3, A2(r2, 3), c3);
      }
      function Ou(i3, r2, a4) {
        var l2 = i3 == null ? 0 : i3.length;
        if (!l2)
          return -1;
        var c3 = l2 - 1;
        return a4 !== s4 && (c3 = D3(a4), c3 = a4 < 0 ? le(l2 + c3, 0) : ge(c3, l2 - 1)), gn(i3, A2(r2, 3), c3, true);
      }
      function Bu(i3) {
        var r2 = i3 == null ? 0 : i3.length;
        return r2 ? me(i3, 1) : [];
      }
      function Cy(i3) {
        var r2 = i3 == null ? 0 : i3.length;
        return r2 ? me(i3, ii) : [];
      }
      function Ay(i3, r2) {
        var a4 = i3 == null ? 0 : i3.length;
        return a4 ? (r2 = r2 === s4 ? 1 : D3(r2), me(i3, r2)) : [];
      }
      function xy(i3) {
        for (var r2 = -1, a4 = i3 == null ? 0 : i3.length, l2 = {}; ++r2 < a4; ) {
          var c3 = i3[r2];
          l2[c3[0]] = c3[1];
        }
        return l2;
      }
      function Lu(i3) {
        return i3 && i3.length ? i3[0] : s4;
      }
      function Oy(i3, r2, a4) {
        var l2 = i3 == null ? 0 : i3.length;
        if (!l2)
          return -1;
        var c3 = a4 == null ? 0 : D3(a4);
        return c3 < 0 && (c3 = le(l2 + c3, 0)), vi(i3, r2, c3);
      }
      function By(i3) {
        var r2 = i3 == null ? 0 : i3.length;
        return r2 ? Je(i3, 0, -1) : [];
      }
      var Ly = H4(function(i3) {
        var r2 = J2(i3, Tl);
        return r2.length && r2[0] === i3[0] ? Ml(r2) : [];
      }), Ny = H4(function(i3) {
        var r2 = Ze(i3), a4 = J2(i3, Tl);
        return r2 === Ze(a4) ? r2 = s4 : a4.pop(), a4.length && a4[0] === i3[0] ? Ml(a4, A2(r2, 2)) : [];
      }), Dy = H4(function(i3) {
        var r2 = Ze(i3), a4 = J2(i3, Tl);
        return r2 = typeof r2 == "function" ? r2 : s4, r2 && a4.pop(), a4.length && a4[0] === i3[0] ? Ml(a4, s4, r2) : [];
      });
      function Uy(i3, r2) {
        return i3 == null ? "" : Bh.call(i3, r2);
      }
      function Ze(i3) {
        var r2 = i3 == null ? 0 : i3.length;
        return r2 ? i3[r2 - 1] : s4;
      }
      function Hy(i3, r2, a4) {
        var l2 = i3 == null ? 0 : i3.length;
        if (!l2)
          return -1;
        var c3 = l2;
        return a4 !== s4 && (c3 = D3(a4), c3 = c3 < 0 ? le(l2 + c3, 0) : ge(c3, l2 - 1)), r2 === r2 ? Mh(i3, r2, c3) : gn(i3, hc, c3, true);
      }
      function ky(i3, r2) {
        return i3 && i3.length ? Wc(i3, D3(r2)) : s4;
      }
      var Gy = H4(Nu);
      function Nu(i3, r2) {
        return i3 && i3.length && r2 && r2.length ? _l(i3, r2) : i3;
      }
      function $y(i3, r2, a4) {
        return i3 && i3.length && r2 && r2.length ? _l(i3, r2, A2(a4, 2)) : i3;
      }
      function Vy(i3, r2, a4) {
        return i3 && i3.length && r2 && r2.length ? _l(i3, r2, s4, a4) : i3;
      }
      var qy = Et(function(i3, r2) {
        var a4 = i3 == null ? 0 : i3.length, l2 = fl(i3, r2);
        return Qc(i3, J2(r2, function(c3) {
          return Ct(c3, a4) ? +c3 : c3;
        }).sort(au)), l2;
      });
      function Ky(i3, r2) {
        var a4 = [];
        if (!(i3 && i3.length))
          return a4;
        var l2 = -1, c3 = [], m4 = i3.length;
        for (r2 = A2(r2, 3); ++l2 < m4; ) {
          var f2 = i3[l2];
          r2(f2, l2, i3) && (a4.push(f2), c3.push(l2));
        }
        return Qc(i3, c3), a4;
      }
      function $l(i3) {
        return i3 == null ? i3 : Uh.call(i3);
      }
      function Wy(i3, r2, a4) {
        var l2 = i3 == null ? 0 : i3.length;
        return l2 ? (a4 && typeof a4 != "number" && _e(i3, r2, a4) ? (r2 = 0, a4 = l2) : (r2 = r2 == null ? 0 : D3(r2), a4 = a4 === s4 ? l2 : D3(a4)), Je(i3, r2, a4)) : [];
      }
      function Xy(i3, r2) {
        return Nn(i3, r2);
      }
      function Yy(i3, r2, a4) {
        return Rl(i3, r2, A2(a4, 2));
      }
      function Qy(i3, r2) {
        var a4 = i3 == null ? 0 : i3.length;
        if (a4) {
          var l2 = Nn(i3, r2);
          if (l2 < a4 && lt(i3[l2], r2))
            return l2;
        }
        return -1;
      }
      function zy(i3, r2) {
        return Nn(i3, r2, true);
      }
      function Jy(i3, r2, a4) {
        return Rl(i3, r2, A2(a4, 2), true);
      }
      function Zy(i3, r2) {
        var a4 = i3 == null ? 0 : i3.length;
        if (a4) {
          var l2 = Nn(i3, r2, true) - 1;
          if (lt(i3[l2], r2))
            return l2;
        }
        return -1;
      }
      function jy(i3) {
        return i3 && i3.length ? Jc(i3) : [];
      }
      function eM(i3, r2) {
        return i3 && i3.length ? Jc(i3, A2(r2, 2)) : [];
      }
      function tM(i3) {
        var r2 = i3 == null ? 0 : i3.length;
        return r2 ? Je(i3, 1, r2) : [];
      }
      function iM(i3, r2, a4) {
        return i3 && i3.length ? (r2 = a4 || r2 === s4 ? 1 : D3(r2), Je(i3, 0, r2 < 0 ? 0 : r2)) : [];
      }
      function rM(i3, r2, a4) {
        var l2 = i3 == null ? 0 : i3.length;
        return l2 ? (r2 = a4 || r2 === s4 ? 1 : D3(r2), r2 = l2 - r2, Je(i3, r2 < 0 ? 0 : r2, l2)) : [];
      }
      function nM(i3, r2) {
        return i3 && i3.length ? Dn(i3, A2(r2, 3), false, true) : [];
      }
      function aM(i3, r2) {
        return i3 && i3.length ? Dn(i3, A2(r2, 3)) : [];
      }
      var oM = H4(function(i3) {
        return Vt(me(i3, 1, te, true));
      }), sM = H4(function(i3) {
        var r2 = Ze(i3);
        return te(r2) && (r2 = s4), Vt(me(i3, 1, te, true), A2(r2, 2));
      }), lM = H4(function(i3) {
        var r2 = Ze(i3);
        return r2 = typeof r2 == "function" ? r2 : s4, Vt(me(i3, 1, te, true), s4, r2);
      });
      function pM(i3) {
        return i3 && i3.length ? Vt(i3) : [];
      }
      function cM(i3, r2) {
        return i3 && i3.length ? Vt(i3, A2(r2, 2)) : [];
      }
      function uM(i3, r2) {
        return r2 = typeof r2 == "function" ? r2 : s4, i3 && i3.length ? Vt(i3, s4, r2) : [];
      }
      function Vl(i3) {
        if (!(i3 && i3.length))
          return [];
        var r2 = 0;
        return i3 = Dt(i3, function(a4) {
          if (te(a4))
            return r2 = le(a4.length, r2), true;
        }), ol(r2, function(a4) {
          return J2(i3, rl(a4));
        });
      }
      function Du(i3, r2) {
        if (!(i3 && i3.length))
          return [];
        var a4 = Vl(i3);
        return r2 == null ? a4 : J2(a4, function(l2) {
          return De(r2, s4, l2);
        });
      }
      var mM = H4(function(i3, r2) {
        return te(i3) ? xr(i3, r2) : [];
      }), dM = H4(function(i3) {
        return Sl(Dt(i3, te));
      }), fM = H4(function(i3) {
        var r2 = Ze(i3);
        return te(r2) && (r2 = s4), Sl(Dt(i3, te), A2(r2, 2));
      }), hM = H4(function(i3) {
        var r2 = Ze(i3);
        return r2 = typeof r2 == "function" ? r2 : s4, Sl(Dt(i3, te), s4, r2);
      }), gM = H4(Vl);
      function yM(i3, r2) {
        return tu(i3 || [], r2 || [], Ar);
      }
      function MM(i3, r2) {
        return tu(i3 || [], r2 || [], Lr);
      }
      var bM = H4(function(i3) {
        var r2 = i3.length, a4 = r2 > 1 ? i3[r2 - 1] : s4;
        return a4 = typeof a4 == "function" ? (i3.pop(), a4) : s4, Du(i3, a4);
      });
      function Uu(i3) {
        var r2 = u3(i3);
        return r2.__chain__ = true, r2;
      }
      function wM(i3, r2) {
        return r2(i3), i3;
      }
      function Wn(i3, r2) {
        return r2(i3);
      }
      var vM = Et(function(i3) {
        var r2 = i3.length, a4 = r2 ? i3[0] : 0, l2 = this.__wrapped__, c3 = function(m4) {
          return fl(m4, i3);
        };
        return r2 > 1 || this.__actions__.length || !(l2 instanceof G3) || !Ct(a4) ? this.thru(c3) : (l2 = l2.slice(a4, +a4 + (r2 ? 1 : 0)), l2.__actions__.push({ func: Wn, args: [c3], thisArg: s4 }), new Qe(l2, this.__chain__).thru(function(m4) {
          return r2 && !m4.length && m4.push(s4), m4;
        }));
      });
      function _M() {
        return Uu(this);
      }
      function IM() {
        return new Qe(this.value(), this.__chain__);
      }
      function PM() {
        this.__values__ === s4 && (this.__values__ = Zu(this.value()));
        var i3 = this.__index__ >= this.__values__.length, r2 = i3 ? s4 : this.__values__[this.__index__++];
        return { done: i3, value: r2 };
      }
      function RM() {
        return this;
      }
      function FM(i3) {
        for (var r2, a4 = this; a4 instanceof An; ) {
          var l2 = Au(a4);
          l2.__index__ = 0, l2.__values__ = s4, r2 ? c3.__wrapped__ = l2 : r2 = l2;
          var c3 = l2;
          a4 = a4.__wrapped__;
        }
        return c3.__wrapped__ = i3, r2;
      }
      function SM() {
        var i3 = this.__wrapped__;
        if (i3 instanceof G3) {
          var r2 = i3;
          return this.__actions__.length && (r2 = new G3(this)), r2 = r2.reverse(), r2.__actions__.push({ func: Wn, args: [$l], thisArg: s4 }), new Qe(r2, this.__chain__);
        }
        return this.thru($l);
      }
      function TM() {
        return eu(this.__wrapped__, this.__actions__);
      }
      var EM = Un(function(i3, r2, a4) {
        X4.call(i3, a4) ? ++i3[a4] : St(i3, a4, 1);
      });
      function CM(i3, r2, a4) {
        var l2 = L3(i3) ? dc : wg;
        return a4 && _e(i3, r2, a4) && (r2 = s4), l2(i3, A2(r2, 3));
      }
      function AM(i3, r2) {
        var a4 = L3(i3) ? Dt : Dc;
        return a4(i3, A2(r2, 3));
      }
      var xM = uu(xu), OM = uu(Ou);
      function BM(i3, r2) {
        return me(Xn(i3, r2), 1);
      }
      function LM(i3, r2) {
        return me(Xn(i3, r2), ii);
      }
      function NM(i3, r2, a4) {
        return a4 = a4 === s4 ? 1 : D3(a4), me(Xn(i3, r2), a4);
      }
      function Hu(i3, r2) {
        var a4 = L3(i3) ? Xe : $t;
        return a4(i3, A2(r2, 3));
      }
      function ku(i3, r2) {
        var a4 = L3(i3) ? th : Nc;
        return a4(i3, A2(r2, 3));
      }
      var DM = Un(function(i3, r2, a4) {
        X4.call(i3, a4) ? i3[a4].push(r2) : St(i3, a4, [r2]);
      });
      function UM(i3, r2, a4, l2) {
        i3 = Ce(i3) ? i3 : xi(i3), a4 = a4 && !l2 ? D3(a4) : 0;
        var c3 = i3.length;
        return a4 < 0 && (a4 = le(c3 + a4, 0)), Zn(i3) ? a4 <= c3 && i3.indexOf(r2, a4) > -1 : !!c3 && vi(i3, r2, a4) > -1;
      }
      var HM = H4(function(i3, r2, a4) {
        var l2 = -1, c3 = typeof r2 == "function", m4 = Ce(i3) ? v2(i3.length) : [];
        return $t(i3, function(f2) {
          m4[++l2] = c3 ? De(r2, f2, a4) : Or(f2, r2, a4);
        }), m4;
      }), kM = Un(function(i3, r2, a4) {
        St(i3, a4, r2);
      });
      function Xn(i3, r2) {
        var a4 = L3(i3) ? J2 : Vc;
        return a4(i3, A2(r2, 3));
      }
      function GM(i3, r2, a4, l2) {
        return i3 == null ? [] : (L3(r2) || (r2 = r2 == null ? [] : [r2]), a4 = l2 ? s4 : a4, L3(a4) || (a4 = a4 == null ? [] : [a4]), Xc(i3, r2, a4));
      }
      var $M = Un(function(i3, r2, a4) {
        i3[a4 ? 0 : 1].push(r2);
      }, function() {
        return [[], []];
      });
      function VM(i3, r2, a4) {
        var l2 = L3(i3) ? tl : yc, c3 = arguments.length < 3;
        return l2(i3, A2(r2, 4), a4, c3, $t);
      }
      function qM(i3, r2, a4) {
        var l2 = L3(i3) ? ih : yc, c3 = arguments.length < 3;
        return l2(i3, A2(r2, 4), a4, c3, Nc);
      }
      function KM(i3, r2) {
        var a4 = L3(i3) ? Dt : Dc;
        return a4(i3, zn(A2(r2, 3)));
      }
      function WM(i3) {
        var r2 = L3(i3) ? xc : Ug;
        return r2(i3);
      }
      function XM(i3, r2, a4) {
        (a4 ? _e(i3, r2, a4) : r2 === s4) ? r2 = 1 : r2 = D3(r2);
        var l2 = L3(i3) ? hg : Hg;
        return l2(i3, r2);
      }
      function YM(i3) {
        var r2 = L3(i3) ? gg : Gg;
        return r2(i3);
      }
      function QM(i3) {
        if (i3 == null)
          return 0;
        if (Ce(i3))
          return Zn(i3) ? Ii(i3) : i3.length;
        var r2 = ye(i3);
        return r2 == nt || r2 == at ? i3.size : wl(i3).length;
      }
      function zM(i3, r2, a4) {
        var l2 = L3(i3) ? il : $g;
        return a4 && _e(i3, r2, a4) && (r2 = s4), l2(i3, A2(r2, 3));
      }
      var JM = H4(function(i3, r2) {
        if (i3 == null)
          return [];
        var a4 = r2.length;
        return a4 > 1 && _e(i3, r2[0], r2[1]) ? r2 = [] : a4 > 2 && _e(r2[0], r2[1], r2[2]) && (r2 = [r2[0]]), Xc(i3, me(r2, 1), []);
      }), Yn = Ah || function() {
        return pe.Date.now();
      };
      function ZM(i3, r2) {
        if (typeof r2 != "function")
          throw new Ye(o2);
        return i3 = D3(i3), function() {
          if (--i3 < 1)
            return r2.apply(this, arguments);
        };
      }
      function Gu(i3, r2, a4) {
        return r2 = a4 ? s4 : r2, r2 = i3 && r2 == null ? i3.length : r2, Tt(i3, It, s4, s4, s4, s4, r2);
      }
      function $u(i3, r2) {
        var a4;
        if (typeof r2 != "function")
          throw new Ye(o2);
        return i3 = D3(i3), function() {
          return --i3 > 0 && (a4 = r2.apply(this, arguments)), i3 <= 1 && (r2 = s4), a4;
        };
      }
      var ql = H4(function(i3, r2, a4) {
        var l2 = we;
        if (a4.length) {
          var c3 = Ht(a4, Ci(ql));
          l2 |= Ke;
        }
        return Tt(i3, l2, r2, a4, c3);
      }), Vu = H4(function(i3, r2, a4) {
        var l2 = we | ct;
        if (a4.length) {
          var c3 = Ht(a4, Ci(Vu));
          l2 |= Ke;
        }
        return Tt(r2, l2, i3, a4, c3);
      });
      function qu(i3, r2, a4) {
        r2 = a4 ? s4 : r2;
        var l2 = Tt(i3, ue, s4, s4, s4, s4, s4, r2);
        return l2.placeholder = qu.placeholder, l2;
      }
      function Ku(i3, r2, a4) {
        r2 = a4 ? s4 : r2;
        var l2 = Tt(i3, Te, s4, s4, s4, s4, s4, r2);
        return l2.placeholder = Ku.placeholder, l2;
      }
      function Wu(i3, r2, a4) {
        var l2, c3, m4, f2, g2, b3, P2 = 0, R3 = false, F2 = false, T3 = true;
        if (typeof i3 != "function")
          throw new Ye(o2);
        r2 = je(r2) || 0, Z2(a4) && (R3 = !!a4.leading, F2 = "maxWait" in a4, m4 = F2 ? le(je(a4.maxWait) || 0, r2) : m4, T3 = "trailing" in a4 ? !!a4.trailing : T3);
        function C2(ie) {
          var pt = l2, Ot = c3;
          return l2 = c3 = s4, P2 = ie, f2 = i3.apply(Ot, pt), f2;
        }
        function x3(ie) {
          return P2 = ie, g2 = Ur(k3, r2), R3 ? C2(ie) : f2;
        }
        function U2(ie) {
          var pt = ie - b3, Ot = ie - P2, um = r2 - pt;
          return F2 ? ge(um, m4 - Ot) : um;
        }
        function O3(ie) {
          var pt = ie - b3, Ot = ie - P2;
          return b3 === s4 || pt >= r2 || pt < 0 || F2 && Ot >= m4;
        }
        function k3() {
          var ie = Yn();
          if (O3(ie))
            return $2(ie);
          g2 = Ur(k3, U2(ie));
        }
        function $2(ie) {
          return g2 = s4, T3 && l2 ? C2(ie) : (l2 = c3 = s4, f2);
        }
        function Ge() {
          g2 !== s4 && iu(g2), P2 = 0, l2 = b3 = c3 = g2 = s4;
        }
        function Ie() {
          return g2 === s4 ? f2 : $2(Yn());
        }
        function $e() {
          var ie = Yn(), pt = O3(ie);
          if (l2 = arguments, c3 = this, b3 = ie, pt) {
            if (g2 === s4)
              return x3(b3);
            if (F2)
              return iu(g2), g2 = Ur(k3, r2), C2(b3);
          }
          return g2 === s4 && (g2 = Ur(k3, r2)), f2;
        }
        return $e.cancel = Ge, $e.flush = Ie, $e;
      }
      var jM = H4(function(i3, r2) {
        return Lc(i3, 1, r2);
      }), eb = H4(function(i3, r2, a4) {
        return Lc(i3, je(r2) || 0, a4);
      });
      function tb(i3) {
        return Tt(i3, Ls);
      }
      function Qn(i3, r2) {
        if (typeof i3 != "function" || r2 != null && typeof r2 != "function")
          throw new Ye(o2);
        var a4 = function() {
          var l2 = arguments, c3 = r2 ? r2.apply(this, l2) : l2[0], m4 = a4.cache;
          if (m4.has(c3))
            return m4.get(c3);
          var f2 = i3.apply(this, l2);
          return a4.cache = m4.set(c3, f2) || m4, f2;
        };
        return a4.cache = new (Qn.Cache || Ft)(), a4;
      }
      Qn.Cache = Ft;
      function zn(i3) {
        if (typeof i3 != "function")
          throw new Ye(o2);
        return function() {
          var r2 = arguments;
          switch (r2.length) {
            case 0:
              return !i3.call(this);
            case 1:
              return !i3.call(this, r2[0]);
            case 2:
              return !i3.call(this, r2[0], r2[1]);
            case 3:
              return !i3.call(this, r2[0], r2[1], r2[2]);
          }
          return !i3.apply(this, r2);
        };
      }
      function ib(i3) {
        return $u(2, i3);
      }
      var rb = Vg(function(i3, r2) {
        r2 = r2.length == 1 && L3(r2[0]) ? J2(r2[0], Ue(A2())) : J2(me(r2, 1), Ue(A2()));
        var a4 = r2.length;
        return H4(function(l2) {
          for (var c3 = -1, m4 = ge(l2.length, a4); ++c3 < m4; )
            l2[c3] = r2[c3].call(this, l2[c3]);
          return De(i3, this, l2);
        });
      }), Kl = H4(function(i3, r2) {
        var a4 = Ht(r2, Ci(Kl));
        return Tt(i3, Ke, s4, r2, a4);
      }), Xu = H4(function(i3, r2) {
        var a4 = Ht(r2, Ci(Xu));
        return Tt(i3, ut, s4, r2, a4);
      }), nb = Et(function(i3, r2) {
        return Tt(i3, yr, s4, s4, s4, r2);
      });
      function ab(i3, r2) {
        if (typeof i3 != "function")
          throw new Ye(o2);
        return r2 = r2 === s4 ? r2 : D3(r2), H4(i3, r2);
      }
      function ob(i3, r2) {
        if (typeof i3 != "function")
          throw new Ye(o2);
        return r2 = r2 == null ? 0 : le(D3(r2), 0), H4(function(a4) {
          var l2 = a4[r2], c3 = Kt(a4, 0, r2);
          return l2 && Ut(c3, l2), De(i3, this, c3);
        });
      }
      function sb(i3, r2, a4) {
        var l2 = true, c3 = true;
        if (typeof i3 != "function")
          throw new Ye(o2);
        return Z2(a4) && (l2 = "leading" in a4 ? !!a4.leading : l2, c3 = "trailing" in a4 ? !!a4.trailing : c3), Wu(i3, r2, { leading: l2, maxWait: r2, trailing: c3 });
      }
      function lb(i3) {
        return Gu(i3, 1);
      }
      function pb(i3, r2) {
        return Kl(El(r2), i3);
      }
      function cb() {
        if (!arguments.length)
          return [];
        var i3 = arguments[0];
        return L3(i3) ? i3 : [i3];
      }
      function ub(i3) {
        return ze(i3, S4);
      }
      function mb(i3, r2) {
        return r2 = typeof r2 == "function" ? r2 : s4, ze(i3, S4, r2);
      }
      function db(i3) {
        return ze(i3, _2 | S4);
      }
      function fb(i3, r2) {
        return r2 = typeof r2 == "function" ? r2 : s4, ze(i3, _2 | S4, r2);
      }
      function hb(i3, r2) {
        return r2 == null || Bc(i3, r2, ce(r2));
      }
      function lt(i3, r2) {
        return i3 === r2 || i3 !== i3 && r2 !== r2;
      }
      var gb = $n(yl), yb = $n(function(i3, r2) {
        return i3 >= r2;
      }), ui = kc(function() {
        return arguments;
      }()) ? kc : function(i3) {
        return ee(i3) && X4.call(i3, "callee") && !Fc.call(i3, "callee");
      }, L3 = v2.isArray, Mb = sc ? Ue(sc) : Fg;
      function Ce(i3) {
        return i3 != null && Jn(i3.length) && !At(i3);
      }
      function te(i3) {
        return ee(i3) && Ce(i3);
      }
      function bb(i3) {
        return i3 === true || i3 === false || ee(i3) && ve(i3) == Mr;
      }
      var Wt = Oh || ip, wb = lc ? Ue(lc) : Sg;
      function vb(i3) {
        return ee(i3) && i3.nodeType === 1 && !Hr(i3);
      }
      function _b(i3) {
        if (i3 == null)
          return true;
        if (Ce(i3) && (L3(i3) || typeof i3 == "string" || typeof i3.splice == "function" || Wt(i3) || Ai(i3) || ui(i3)))
          return !i3.length;
        var r2 = ye(i3);
        if (r2 == nt || r2 == at)
          return !i3.size;
        if (Dr(i3))
          return !wl(i3).length;
        for (var a4 in i3)
          if (X4.call(i3, a4))
            return false;
        return true;
      }
      function Ib(i3, r2) {
        return Br(i3, r2);
      }
      function Pb(i3, r2, a4) {
        a4 = typeof a4 == "function" ? a4 : s4;
        var l2 = a4 ? a4(i3, r2) : s4;
        return l2 === s4 ? Br(i3, r2, s4, a4) : !!l2;
      }
      function Wl(i3) {
        if (!ee(i3))
          return false;
        var r2 = ve(i3);
        return r2 == pn || r2 == Wd || typeof i3.message == "string" && typeof i3.name == "string" && !Hr(i3);
      }
      function Rb(i3) {
        return typeof i3 == "number" && Tc(i3);
      }
      function At(i3) {
        if (!Z2(i3))
          return false;
        var r2 = ve(i3);
        return r2 == cn || r2 == Lp || r2 == Kd || r2 == Yd;
      }
      function Yu(i3) {
        return typeof i3 == "number" && i3 == D3(i3);
      }
      function Jn(i3) {
        return typeof i3 == "number" && i3 > -1 && i3 % 1 == 0 && i3 <= N2;
      }
      function Z2(i3) {
        var r2 = typeof i3;
        return i3 != null && (r2 == "object" || r2 == "function");
      }
      function ee(i3) {
        return i3 != null && typeof i3 == "object";
      }
      var Qu = pc ? Ue(pc) : Eg;
      function Fb(i3, r2) {
        return i3 === r2 || bl(i3, r2, Nl(r2));
      }
      function Sb(i3, r2, a4) {
        return a4 = typeof a4 == "function" ? a4 : s4, bl(i3, r2, Nl(r2), a4);
      }
      function Tb(i3) {
        return zu(i3) && i3 != +i3;
      }
      function Eb(i3) {
        if (my(i3))
          throw new B3(n2);
        return Gc(i3);
      }
      function Cb(i3) {
        return i3 === null;
      }
      function Ab(i3) {
        return i3 == null;
      }
      function zu(i3) {
        return typeof i3 == "number" || ee(i3) && ve(i3) == wr;
      }
      function Hr(i3) {
        if (!ee(i3) || ve(i3) != Pt)
          return false;
        var r2 = Pn(i3);
        if (r2 === null)
          return true;
        var a4 = X4.call(r2, "constructor") && r2.constructor;
        return typeof a4 == "function" && a4 instanceof a4 && wn.call(a4) == Sh;
      }
      var Xl = cc ? Ue(cc) : Cg;
      function xb(i3) {
        return Yu(i3) && i3 >= -N2 && i3 <= N2;
      }
      var Ju = uc ? Ue(uc) : Ag;
      function Zn(i3) {
        return typeof i3 == "string" || !L3(i3) && ee(i3) && ve(i3) == _r;
      }
      function ke(i3) {
        return typeof i3 == "symbol" || ee(i3) && ve(i3) == un;
      }
      var Ai = mc ? Ue(mc) : xg;
      function Ob(i3) {
        return i3 === s4;
      }
      function Bb(i3) {
        return ee(i3) && ye(i3) == Ir;
      }
      function Lb(i3) {
        return ee(i3) && ve(i3) == zd;
      }
      var Nb = $n(vl), Db = $n(function(i3, r2) {
        return i3 <= r2;
      });
      function Zu(i3) {
        if (!i3)
          return [];
        if (Ce(i3))
          return Zn(i3) ? ot(i3) : Ee(i3);
        if (Fr && i3[Fr])
          return hh(i3[Fr]());
        var r2 = ye(i3), a4 = r2 == nt ? ll : r2 == at ? yn : xi;
        return a4(i3);
      }
      function xt(i3) {
        if (!i3)
          return i3 === 0 ? i3 : 0;
        if (i3 = je(i3), i3 === ii || i3 === -ii) {
          var r2 = i3 < 0 ? -1 : 1;
          return r2 * Gd;
        }
        return i3 === i3 ? i3 : 0;
      }
      function D3(i3) {
        var r2 = xt(i3), a4 = r2 % 1;
        return r2 === r2 ? a4 ? r2 - a4 : r2 : 0;
      }
      function ju(i3) {
        return i3 ? si(D3(i3), 0, mt) : 0;
      }
      function je(i3) {
        if (typeof i3 == "number")
          return i3;
        if (ke(i3))
          return sn;
        if (Z2(i3)) {
          var r2 = typeof i3.valueOf == "function" ? i3.valueOf() : i3;
          i3 = Z2(r2) ? r2 + "" : r2;
        }
        if (typeof i3 != "string")
          return i3 === 0 ? i3 : +i3;
        i3 = Mc(i3);
        var a4 = Mf.test(i3);
        return a4 || wf.test(i3) ? Zf(i3.slice(2), a4 ? 2 : 8) : yf.test(i3) ? sn : +i3;
      }
      function em(i3) {
        return ft(i3, Ae(i3));
      }
      function Ub(i3) {
        return i3 ? si(D3(i3), -N2, N2) : i3 === 0 ? i3 : 0;
      }
      function K2(i3) {
        return i3 == null ? "" : He(i3);
      }
      var Hb = Ti(function(i3, r2) {
        if (Dr(r2) || Ce(r2)) {
          ft(r2, ce(r2), i3);
          return;
        }
        for (var a4 in r2)
          X4.call(r2, a4) && Ar(i3, a4, r2[a4]);
      }), tm = Ti(function(i3, r2) {
        ft(r2, Ae(r2), i3);
      }), jn = Ti(function(i3, r2, a4, l2) {
        ft(r2, Ae(r2), i3, l2);
      }), kb = Ti(function(i3, r2, a4, l2) {
        ft(r2, ce(r2), i3, l2);
      }), Gb = Et(fl);
      function $b(i3, r2) {
        var a4 = Si(i3);
        return r2 == null ? a4 : Oc(a4, r2);
      }
      var Vb = H4(function(i3, r2) {
        i3 = Y3(i3);
        var a4 = -1, l2 = r2.length, c3 = l2 > 2 ? r2[2] : s4;
        for (c3 && _e(r2[0], r2[1], c3) && (l2 = 1); ++a4 < l2; )
          for (var m4 = r2[a4], f2 = Ae(m4), g2 = -1, b3 = f2.length; ++g2 < b3; ) {
            var P2 = f2[g2], R3 = i3[P2];
            (R3 === s4 || lt(R3, Pi[P2]) && !X4.call(i3, P2)) && (i3[P2] = m4[P2]);
          }
        return i3;
      }), qb = H4(function(i3) {
        return i3.push(s4, Mu), De(im, s4, i3);
      });
      function Kb(i3, r2) {
        return fc(i3, A2(r2, 3), dt);
      }
      function Wb(i3, r2) {
        return fc(i3, A2(r2, 3), gl);
      }
      function Xb(i3, r2) {
        return i3 == null ? i3 : hl(i3, A2(r2, 3), Ae);
      }
      function Yb(i3, r2) {
        return i3 == null ? i3 : Uc(i3, A2(r2, 3), Ae);
      }
      function Qb(i3, r2) {
        return i3 && dt(i3, A2(r2, 3));
      }
      function zb(i3, r2) {
        return i3 && gl(i3, A2(r2, 3));
      }
      function Jb(i3) {
        return i3 == null ? [] : Bn(i3, ce(i3));
      }
      function Zb(i3) {
        return i3 == null ? [] : Bn(i3, Ae(i3));
      }
      function Yl(i3, r2, a4) {
        var l2 = i3 == null ? s4 : li(i3, r2);
        return l2 === s4 ? a4 : l2;
      }
      function jb(i3, r2) {
        return i3 != null && vu(i3, r2, _g);
      }
      function Ql(i3, r2) {
        return i3 != null && vu(i3, r2, Ig);
      }
      var ew = du(function(i3, r2, a4) {
        r2 != null && typeof r2.toString != "function" && (r2 = vn.call(r2)), i3[r2] = a4;
      }, Jl(xe)), tw = du(function(i3, r2, a4) {
        r2 != null && typeof r2.toString != "function" && (r2 = vn.call(r2)), X4.call(i3, r2) ? i3[r2].push(a4) : i3[r2] = [a4];
      }, A2), iw = H4(Or);
      function ce(i3) {
        return Ce(i3) ? Ac(i3) : wl(i3);
      }
      function Ae(i3) {
        return Ce(i3) ? Ac(i3, true) : Og(i3);
      }
      function rw(i3, r2) {
        var a4 = {};
        return r2 = A2(r2, 3), dt(i3, function(l2, c3, m4) {
          St(a4, r2(l2, c3, m4), l2);
        }), a4;
      }
      function nw(i3, r2) {
        var a4 = {};
        return r2 = A2(r2, 3), dt(i3, function(l2, c3, m4) {
          St(a4, c3, r2(l2, c3, m4));
        }), a4;
      }
      var aw = Ti(function(i3, r2, a4) {
        Ln(i3, r2, a4);
      }), im = Ti(function(i3, r2, a4, l2) {
        Ln(i3, r2, a4, l2);
      }), ow = Et(function(i3, r2) {
        var a4 = {};
        if (i3 == null)
          return a4;
        var l2 = false;
        r2 = J2(r2, function(m4) {
          return m4 = qt(m4, i3), l2 || (l2 = m4.length > 1), m4;
        }), ft(i3, Bl(i3), a4), l2 && (a4 = ze(a4, _2 | w3 | S4, ey));
        for (var c3 = r2.length; c3--; )
          Fl(a4, r2[c3]);
        return a4;
      });
      function sw(i3, r2) {
        return rm(i3, zn(A2(r2)));
      }
      var lw = Et(function(i3, r2) {
        return i3 == null ? {} : Lg(i3, r2);
      });
      function rm(i3, r2) {
        if (i3 == null)
          return {};
        var a4 = J2(Bl(i3), function(l2) {
          return [l2];
        });
        return r2 = A2(r2), Yc(i3, a4, function(l2, c3) {
          return r2(l2, c3[0]);
        });
      }
      function pw(i3, r2, a4) {
        r2 = qt(r2, i3);
        var l2 = -1, c3 = r2.length;
        for (c3 || (c3 = 1, i3 = s4); ++l2 < c3; ) {
          var m4 = i3 == null ? s4 : i3[ht(r2[l2])];
          m4 === s4 && (l2 = c3, m4 = a4), i3 = At(m4) ? m4.call(i3) : m4;
        }
        return i3;
      }
      function cw(i3, r2, a4) {
        return i3 == null ? i3 : Lr(i3, r2, a4);
      }
      function uw(i3, r2, a4, l2) {
        return l2 = typeof l2 == "function" ? l2 : s4, i3 == null ? i3 : Lr(i3, r2, a4, l2);
      }
      var nm = gu(ce), am = gu(Ae);
      function mw(i3, r2, a4) {
        var l2 = L3(i3), c3 = l2 || Wt(i3) || Ai(i3);
        if (r2 = A2(r2, 4), a4 == null) {
          var m4 = i3 && i3.constructor;
          c3 ? a4 = l2 ? new m4() : [] : Z2(i3) ? a4 = At(m4) ? Si(Pn(i3)) : {} : a4 = {};
        }
        return (c3 ? Xe : dt)(i3, function(f2, g2, b3) {
          return r2(a4, f2, g2, b3);
        }), a4;
      }
      function dw(i3, r2) {
        return i3 == null ? true : Fl(i3, r2);
      }
      function fw(i3, r2, a4) {
        return i3 == null ? i3 : jc(i3, r2, El(a4));
      }
      function hw(i3, r2, a4, l2) {
        return l2 = typeof l2 == "function" ? l2 : s4, i3 == null ? i3 : jc(i3, r2, El(a4), l2);
      }
      function xi(i3) {
        return i3 == null ? [] : sl(i3, ce(i3));
      }
      function gw(i3) {
        return i3 == null ? [] : sl(i3, Ae(i3));
      }
      function yw(i3, r2, a4) {
        return a4 === s4 && (a4 = r2, r2 = s4), a4 !== s4 && (a4 = je(a4), a4 = a4 === a4 ? a4 : 0), r2 !== s4 && (r2 = je(r2), r2 = r2 === r2 ? r2 : 0), si(je(i3), r2, a4);
      }
      function Mw(i3, r2, a4) {
        return r2 = xt(r2), a4 === s4 ? (a4 = r2, r2 = 0) : a4 = xt(a4), i3 = je(i3), Pg(i3, r2, a4);
      }
      function bw(i3, r2, a4) {
        if (a4 && typeof a4 != "boolean" && _e(i3, r2, a4) && (r2 = a4 = s4), a4 === s4 && (typeof r2 == "boolean" ? (a4 = r2, r2 = s4) : typeof i3 == "boolean" && (a4 = i3, i3 = s4)), i3 === s4 && r2 === s4 ? (i3 = 0, r2 = 1) : (i3 = xt(i3), r2 === s4 ? (r2 = i3, i3 = 0) : r2 = xt(r2)), i3 > r2) {
          var l2 = i3;
          i3 = r2, r2 = l2;
        }
        if (a4 || i3 % 1 || r2 % 1) {
          var c3 = Ec();
          return ge(i3 + c3 * (r2 - i3 + Jf("1e-" + ((c3 + "").length - 1))), r2);
        }
        return Il(i3, r2);
      }
      var ww = Ei(function(i3, r2, a4) {
        return r2 = r2.toLowerCase(), i3 + (a4 ? om(r2) : r2);
      });
      function om(i3) {
        return zl(K2(i3).toLowerCase());
      }
      function sm(i3) {
        return i3 = K2(i3), i3 && i3.replace(_f, ch).replace(Gf, "");
      }
      function vw(i3, r2, a4) {
        i3 = K2(i3), r2 = He(r2);
        var l2 = i3.length;
        a4 = a4 === s4 ? l2 : si(D3(a4), 0, l2);
        var c3 = a4;
        return a4 -= r2.length, a4 >= 0 && i3.slice(a4, c3) == r2;
      }
      function _w(i3) {
        return i3 = K2(i3), i3 && tf.test(i3) ? i3.replace(Up, uh) : i3;
      }
      function Iw(i3) {
        return i3 = K2(i3), i3 && lf.test(i3) ? i3.replace(Ks, "\\$&") : i3;
      }
      var Pw = Ei(function(i3, r2, a4) {
        return i3 + (a4 ? "-" : "") + r2.toLowerCase();
      }), Rw = Ei(function(i3, r2, a4) {
        return i3 + (a4 ? " " : "") + r2.toLowerCase();
      }), Fw = cu("toLowerCase");
      function Sw(i3, r2, a4) {
        i3 = K2(i3), r2 = D3(r2);
        var l2 = r2 ? Ii(i3) : 0;
        if (!r2 || l2 >= r2)
          return i3;
        var c3 = (r2 - l2) / 2;
        return Gn(Tn(c3), a4) + i3 + Gn(Sn(c3), a4);
      }
      function Tw(i3, r2, a4) {
        i3 = K2(i3), r2 = D3(r2);
        var l2 = r2 ? Ii(i3) : 0;
        return r2 && l2 < r2 ? i3 + Gn(r2 - l2, a4) : i3;
      }
      function Ew(i3, r2, a4) {
        i3 = K2(i3), r2 = D3(r2);
        var l2 = r2 ? Ii(i3) : 0;
        return r2 && l2 < r2 ? Gn(r2 - l2, a4) + i3 : i3;
      }
      function Cw(i3, r2, a4) {
        return a4 || r2 == null ? r2 = 0 : r2 && (r2 = +r2), Dh(K2(i3).replace(Ws, ""), r2 || 0);
      }
      function Aw(i3, r2, a4) {
        return (a4 ? _e(i3, r2, a4) : r2 === s4) ? r2 = 1 : r2 = D3(r2), Pl(K2(i3), r2);
      }
      function xw() {
        var i3 = arguments, r2 = K2(i3[0]);
        return i3.length < 3 ? r2 : r2.replace(i3[1], i3[2]);
      }
      var Ow = Ei(function(i3, r2, a4) {
        return i3 + (a4 ? "_" : "") + r2.toLowerCase();
      });
      function Bw(i3, r2, a4) {
        return a4 && typeof a4 != "number" && _e(i3, r2, a4) && (r2 = a4 = s4), a4 = a4 === s4 ? mt : a4 >>> 0, a4 ? (i3 = K2(i3), i3 && (typeof r2 == "string" || r2 != null && !Xl(r2)) && (r2 = He(r2), !r2 && _i(i3)) ? Kt(ot(i3), 0, a4) : i3.split(r2, a4)) : [];
      }
      var Lw = Ei(function(i3, r2, a4) {
        return i3 + (a4 ? " " : "") + zl(r2);
      });
      function Nw(i3, r2, a4) {
        return i3 = K2(i3), a4 = a4 == null ? 0 : si(D3(a4), 0, i3.length), r2 = He(r2), i3.slice(a4, a4 + r2.length) == r2;
      }
      function Dw(i3, r2, a4) {
        var l2 = u3.templateSettings;
        a4 && _e(i3, r2, a4) && (r2 = s4), i3 = K2(i3), r2 = jn({}, r2, l2, yu);
        var c3 = jn({}, r2.imports, l2.imports, yu), m4 = ce(c3), f2 = sl(c3, m4), g2, b3, P2 = 0, R3 = r2.interpolate || mn, F2 = "__p += '", T3 = pl((r2.escape || mn).source + "|" + R3.source + "|" + (R3 === Hp ? gf : mn).source + "|" + (r2.evaluate || mn).source + "|$", "g"), C2 = "//# sourceURL=" + (X4.call(r2, "sourceURL") ? (r2.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Wf + "]") + `
`;
        i3.replace(T3, function(O3, k3, $2, Ge, Ie, $e) {
          return $2 || ($2 = Ge), F2 += i3.slice(P2, $e).replace(If, mh), k3 && (g2 = true, F2 += `' +
__e(` + k3 + `) +
'`), Ie && (b3 = true, F2 += `';
` + Ie + `;
__p += '`), $2 && (F2 += `' +
((__t = (` + $2 + `)) == null ? '' : __t) +
'`), P2 = $e + O3.length, O3;
        }), F2 += `';
`;
        var x3 = X4.call(r2, "variable") && r2.variable;
        if (!x3)
          F2 = `with (obj) {
` + F2 + `
}
`;
        else if (ff.test(x3))
          throw new B3(p2);
        F2 = (b3 ? F2.replace(Jd, "") : F2).replace(Zd, "$1").replace(jd, "$1;"), F2 = "function(" + (x3 || "obj") + `) {
` + (x3 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (g2 ? ", __e = _.escape" : "") + (b3 ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + F2 + `return __p
}`;
        var U2 = pm(function() {
          return V2(m4, C2 + "return " + F2).apply(s4, f2);
        });
        if (U2.source = F2, Wl(U2))
          throw U2;
        return U2;
      }
      function Uw(i3) {
        return K2(i3).toLowerCase();
      }
      function Hw(i3) {
        return K2(i3).toUpperCase();
      }
      function kw(i3, r2, a4) {
        if (i3 = K2(i3), i3 && (a4 || r2 === s4))
          return Mc(i3);
        if (!i3 || !(r2 = He(r2)))
          return i3;
        var l2 = ot(i3), c3 = ot(r2), m4 = bc(l2, c3), f2 = wc(l2, c3) + 1;
        return Kt(l2, m4, f2).join("");
      }
      function Gw(i3, r2, a4) {
        if (i3 = K2(i3), i3 && (a4 || r2 === s4))
          return i3.slice(0, _c(i3) + 1);
        if (!i3 || !(r2 = He(r2)))
          return i3;
        var l2 = ot(i3), c3 = wc(l2, ot(r2)) + 1;
        return Kt(l2, 0, c3).join("");
      }
      function $w(i3, r2, a4) {
        if (i3 = K2(i3), i3 && (a4 || r2 === s4))
          return i3.replace(Ws, "");
        if (!i3 || !(r2 = He(r2)))
          return i3;
        var l2 = ot(i3), c3 = bc(l2, ot(r2));
        return Kt(l2, c3).join("");
      }
      function Vw(i3, r2) {
        var a4 = Ld, l2 = Nd;
        if (Z2(r2)) {
          var c3 = "separator" in r2 ? r2.separator : c3;
          a4 = "length" in r2 ? D3(r2.length) : a4, l2 = "omission" in r2 ? He(r2.omission) : l2;
        }
        i3 = K2(i3);
        var m4 = i3.length;
        if (_i(i3)) {
          var f2 = ot(i3);
          m4 = f2.length;
        }
        if (a4 >= m4)
          return i3;
        var g2 = a4 - Ii(l2);
        if (g2 < 1)
          return l2;
        var b3 = f2 ? Kt(f2, 0, g2).join("") : i3.slice(0, g2);
        if (c3 === s4)
          return b3 + l2;
        if (f2 && (g2 += b3.length - g2), Xl(c3)) {
          if (i3.slice(g2).search(c3)) {
            var P2, R3 = b3;
            for (c3.global || (c3 = pl(c3.source, K2(kp.exec(c3)) + "g")), c3.lastIndex = 0; P2 = c3.exec(R3); )
              var F2 = P2.index;
            b3 = b3.slice(0, F2 === s4 ? g2 : F2);
          }
        } else if (i3.indexOf(He(c3), g2) != g2) {
          var T3 = b3.lastIndexOf(c3);
          T3 > -1 && (b3 = b3.slice(0, T3));
        }
        return b3 + l2;
      }
      function qw(i3) {
        return i3 = K2(i3), i3 && ef.test(i3) ? i3.replace(Dp, bh) : i3;
      }
      var Kw = Ei(function(i3, r2, a4) {
        return i3 + (a4 ? " " : "") + r2.toUpperCase();
      }), zl = cu("toUpperCase");
      function lm(i3, r2, a4) {
        return i3 = K2(i3), r2 = a4 ? s4 : r2, r2 === s4 ? fh(i3) ? _h(i3) : ah(i3) : i3.match(r2) || [];
      }
      var pm = H4(function(i3, r2) {
        try {
          return De(i3, s4, r2);
        } catch (a4) {
          return Wl(a4) ? a4 : new B3(a4);
        }
      }), Ww = Et(function(i3, r2) {
        return Xe(r2, function(a4) {
          a4 = ht(a4), St(i3, a4, ql(i3[a4], i3));
        }), i3;
      });
      function Xw(i3) {
        var r2 = i3 == null ? 0 : i3.length, a4 = A2();
        return i3 = r2 ? J2(i3, function(l2) {
          if (typeof l2[1] != "function")
            throw new Ye(o2);
          return [a4(l2[0]), l2[1]];
        }) : [], H4(function(l2) {
          for (var c3 = -1; ++c3 < r2; ) {
            var m4 = i3[c3];
            if (De(m4[0], this, l2))
              return De(m4[1], this, l2);
          }
        });
      }
      function Yw(i3) {
        return bg(ze(i3, _2));
      }
      function Jl(i3) {
        return function() {
          return i3;
        };
      }
      function Qw(i3, r2) {
        return i3 == null || i3 !== i3 ? r2 : i3;
      }
      var zw = mu(), Jw = mu(true);
      function xe(i3) {
        return i3;
      }
      function Zl(i3) {
        return $c(typeof i3 == "function" ? i3 : ze(i3, _2));
      }
      function Zw(i3) {
        return qc(ze(i3, _2));
      }
      function jw(i3, r2) {
        return Kc(i3, ze(r2, _2));
      }
      var ev = H4(function(i3, r2) {
        return function(a4) {
          return Or(a4, i3, r2);
        };
      }), tv = H4(function(i3, r2) {
        return function(a4) {
          return Or(i3, a4, r2);
        };
      });
      function jl(i3, r2, a4) {
        var l2 = ce(r2), c3 = Bn(r2, l2);
        a4 == null && !(Z2(r2) && (c3.length || !l2.length)) && (a4 = r2, r2 = i3, i3 = this, c3 = Bn(r2, ce(r2)));
        var m4 = !(Z2(a4) && "chain" in a4) || !!a4.chain, f2 = At(i3);
        return Xe(c3, function(g2) {
          var b3 = r2[g2];
          i3[g2] = b3, f2 && (i3.prototype[g2] = function() {
            var P2 = this.__chain__;
            if (m4 || P2) {
              var R3 = i3(this.__wrapped__), F2 = R3.__actions__ = Ee(this.__actions__);
              return F2.push({ func: b3, args: arguments, thisArg: i3 }), R3.__chain__ = P2, R3;
            }
            return b3.apply(i3, Ut([this.value()], arguments));
          });
        }), i3;
      }
      function iv() {
        return pe._ === this && (pe._ = Th), this;
      }
      function ep() {
      }
      function rv(i3) {
        return i3 = D3(i3), H4(function(r2) {
          return Wc(r2, i3);
        });
      }
      var nv = Al(J2), av = Al(dc), ov = Al(il);
      function cm(i3) {
        return Ul(i3) ? rl(ht(i3)) : Ng(i3);
      }
      function sv(i3) {
        return function(r2) {
          return i3 == null ? s4 : li(i3, r2);
        };
      }
      var lv = fu(), pv = fu(true);
      function tp() {
        return [];
      }
      function ip() {
        return false;
      }
      function cv() {
        return {};
      }
      function uv() {
        return "";
      }
      function mv() {
        return true;
      }
      function dv(i3, r2) {
        if (i3 = D3(i3), i3 < 1 || i3 > N2)
          return [];
        var a4 = mt, l2 = ge(i3, mt);
        r2 = A2(r2), i3 -= mt;
        for (var c3 = ol(l2, r2); ++a4 < i3; )
          r2(a4);
        return c3;
      }
      function fv(i3) {
        return L3(i3) ? J2(i3, ht) : ke(i3) ? [i3] : Ee(Cu(K2(i3)));
      }
      function hv(i3) {
        var r2 = ++Fh;
        return K2(i3) + r2;
      }
      var gv = kn(function(i3, r2) {
        return i3 + r2;
      }, 0), yv = xl("ceil"), Mv = kn(function(i3, r2) {
        return i3 / r2;
      }, 1), bv = xl("floor");
      function wv(i3) {
        return i3 && i3.length ? On(i3, xe, yl) : s4;
      }
      function vv(i3, r2) {
        return i3 && i3.length ? On(i3, A2(r2, 2), yl) : s4;
      }
      function _v(i3) {
        return gc(i3, xe);
      }
      function Iv(i3, r2) {
        return gc(i3, A2(r2, 2));
      }
      function Pv(i3) {
        return i3 && i3.length ? On(i3, xe, vl) : s4;
      }
      function Rv(i3, r2) {
        return i3 && i3.length ? On(i3, A2(r2, 2), vl) : s4;
      }
      var Fv = kn(function(i3, r2) {
        return i3 * r2;
      }, 1), Sv = xl("round"), Tv = kn(function(i3, r2) {
        return i3 - r2;
      }, 0);
      function Ev(i3) {
        return i3 && i3.length ? al(i3, xe) : 0;
      }
      function Cv(i3, r2) {
        return i3 && i3.length ? al(i3, A2(r2, 2)) : 0;
      }
      return u3.after = ZM, u3.ary = Gu, u3.assign = Hb, u3.assignIn = tm, u3.assignInWith = jn, u3.assignWith = kb, u3.at = Gb, u3.before = $u, u3.bind = ql, u3.bindAll = Ww, u3.bindKey = Vu, u3.castArray = cb, u3.chain = Uu, u3.chunk = by, u3.compact = wy, u3.concat = vy, u3.cond = Xw, u3.conforms = Yw, u3.constant = Jl, u3.countBy = EM, u3.create = $b, u3.curry = qu, u3.curryRight = Ku, u3.debounce = Wu, u3.defaults = Vb, u3.defaultsDeep = qb, u3.defer = jM, u3.delay = eb, u3.difference = _y, u3.differenceBy = Iy, u3.differenceWith = Py, u3.drop = Ry, u3.dropRight = Fy, u3.dropRightWhile = Sy, u3.dropWhile = Ty, u3.fill = Ey, u3.filter = AM, u3.flatMap = BM, u3.flatMapDeep = LM, u3.flatMapDepth = NM, u3.flatten = Bu, u3.flattenDeep = Cy, u3.flattenDepth = Ay, u3.flip = tb, u3.flow = zw, u3.flowRight = Jw, u3.fromPairs = xy, u3.functions = Jb, u3.functionsIn = Zb, u3.groupBy = DM, u3.initial = By, u3.intersection = Ly, u3.intersectionBy = Ny, u3.intersectionWith = Dy, u3.invert = ew, u3.invertBy = tw, u3.invokeMap = HM, u3.iteratee = Zl, u3.keyBy = kM, u3.keys = ce, u3.keysIn = Ae, u3.map = Xn, u3.mapKeys = rw, u3.mapValues = nw, u3.matches = Zw, u3.matchesProperty = jw, u3.memoize = Qn, u3.merge = aw, u3.mergeWith = im, u3.method = ev, u3.methodOf = tv, u3.mixin = jl, u3.negate = zn, u3.nthArg = rv, u3.omit = ow, u3.omitBy = sw, u3.once = ib, u3.orderBy = GM, u3.over = nv, u3.overArgs = rb, u3.overEvery = av, u3.overSome = ov, u3.partial = Kl, u3.partialRight = Xu, u3.partition = $M, u3.pick = lw, u3.pickBy = rm, u3.property = cm, u3.propertyOf = sv, u3.pull = Gy, u3.pullAll = Nu, u3.pullAllBy = $y, u3.pullAllWith = Vy, u3.pullAt = qy, u3.range = lv, u3.rangeRight = pv, u3.rearg = nb, u3.reject = KM, u3.remove = Ky, u3.rest = ab, u3.reverse = $l, u3.sampleSize = XM, u3.set = cw, u3.setWith = uw, u3.shuffle = YM, u3.slice = Wy, u3.sortBy = JM, u3.sortedUniq = jy, u3.sortedUniqBy = eM, u3.split = Bw, u3.spread = ob, u3.tail = tM, u3.take = iM, u3.takeRight = rM, u3.takeRightWhile = nM, u3.takeWhile = aM, u3.tap = wM, u3.throttle = sb, u3.thru = Wn, u3.toArray = Zu, u3.toPairs = nm, u3.toPairsIn = am, u3.toPath = fv, u3.toPlainObject = em, u3.transform = mw, u3.unary = lb, u3.union = oM, u3.unionBy = sM, u3.unionWith = lM, u3.uniq = pM, u3.uniqBy = cM, u3.uniqWith = uM, u3.unset = dw, u3.unzip = Vl, u3.unzipWith = Du, u3.update = fw, u3.updateWith = hw, u3.values = xi, u3.valuesIn = gw, u3.without = mM, u3.words = lm, u3.wrap = pb, u3.xor = dM, u3.xorBy = fM, u3.xorWith = hM, u3.zip = gM, u3.zipObject = yM, u3.zipObjectDeep = MM, u3.zipWith = bM, u3.entries = nm, u3.entriesIn = am, u3.extend = tm, u3.extendWith = jn, jl(u3, u3), u3.add = gv, u3.attempt = pm, u3.camelCase = ww, u3.capitalize = om, u3.ceil = yv, u3.clamp = yw, u3.clone = ub, u3.cloneDeep = db, u3.cloneDeepWith = fb, u3.cloneWith = mb, u3.conformsTo = hb, u3.deburr = sm, u3.defaultTo = Qw, u3.divide = Mv, u3.endsWith = vw, u3.eq = lt, u3.escape = _w, u3.escapeRegExp = Iw, u3.every = CM, u3.find = xM, u3.findIndex = xu, u3.findKey = Kb, u3.findLast = OM, u3.findLastIndex = Ou, u3.findLastKey = Wb, u3.floor = bv, u3.forEach = Hu, u3.forEachRight = ku, u3.forIn = Xb, u3.forInRight = Yb, u3.forOwn = Qb, u3.forOwnRight = zb, u3.get = Yl, u3.gt = gb, u3.gte = yb, u3.has = jb, u3.hasIn = Ql, u3.head = Lu, u3.identity = xe, u3.includes = UM, u3.indexOf = Oy, u3.inRange = Mw, u3.invoke = iw, u3.isArguments = ui, u3.isArray = L3, u3.isArrayBuffer = Mb, u3.isArrayLike = Ce, u3.isArrayLikeObject = te, u3.isBoolean = bb, u3.isBuffer = Wt, u3.isDate = wb, u3.isElement = vb, u3.isEmpty = _b, u3.isEqual = Ib, u3.isEqualWith = Pb, u3.isError = Wl, u3.isFinite = Rb, u3.isFunction = At, u3.isInteger = Yu, u3.isLength = Jn, u3.isMap = Qu, u3.isMatch = Fb, u3.isMatchWith = Sb, u3.isNaN = Tb, u3.isNative = Eb, u3.isNil = Ab, u3.isNull = Cb, u3.isNumber = zu, u3.isObject = Z2, u3.isObjectLike = ee, u3.isPlainObject = Hr, u3.isRegExp = Xl, u3.isSafeInteger = xb, u3.isSet = Ju, u3.isString = Zn, u3.isSymbol = ke, u3.isTypedArray = Ai, u3.isUndefined = Ob, u3.isWeakMap = Bb, u3.isWeakSet = Lb, u3.join = Uy, u3.kebabCase = Pw, u3.last = Ze, u3.lastIndexOf = Hy, u3.lowerCase = Rw, u3.lowerFirst = Fw, u3.lt = Nb, u3.lte = Db, u3.max = wv, u3.maxBy = vv, u3.mean = _v, u3.meanBy = Iv, u3.min = Pv, u3.minBy = Rv, u3.stubArray = tp, u3.stubFalse = ip, u3.stubObject = cv, u3.stubString = uv, u3.stubTrue = mv, u3.multiply = Fv, u3.nth = ky, u3.noConflict = iv, u3.noop = ep, u3.now = Yn, u3.pad = Sw, u3.padEnd = Tw, u3.padStart = Ew, u3.parseInt = Cw, u3.random = bw, u3.reduce = VM, u3.reduceRight = qM, u3.repeat = Aw, u3.replace = xw, u3.result = pw, u3.round = Sv, u3.runInContext = M4, u3.sample = WM, u3.size = QM, u3.snakeCase = Ow, u3.some = zM, u3.sortedIndex = Xy, u3.sortedIndexBy = Yy, u3.sortedIndexOf = Qy, u3.sortedLastIndex = zy, u3.sortedLastIndexBy = Jy, u3.sortedLastIndexOf = Zy, u3.startCase = Lw, u3.startsWith = Nw, u3.subtract = Tv, u3.sum = Ev, u3.sumBy = Cv, u3.template = Dw, u3.times = dv, u3.toFinite = xt, u3.toInteger = D3, u3.toLength = ju, u3.toLower = Uw, u3.toNumber = je, u3.toSafeInteger = Ub, u3.toString = K2, u3.toUpper = Hw, u3.trim = kw, u3.trimEnd = Gw, u3.trimStart = $w, u3.truncate = Vw, u3.unescape = qw, u3.uniqueId = hv, u3.upperCase = Kw, u3.upperFirst = zl, u3.each = Hu, u3.eachRight = ku, u3.first = Lu, jl(u3, function() {
        var i3 = {};
        return dt(u3, function(r2, a4) {
          X4.call(u3.prototype, a4) || (i3[a4] = r2);
        }), i3;
      }(), { chain: false }), u3.VERSION = e3, Xe(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(i3) {
        u3[i3].placeholder = u3;
      }), Xe(["drop", "take"], function(i3, r2) {
        G3.prototype[i3] = function(a4) {
          a4 = a4 === s4 ? 1 : le(D3(a4), 0);
          var l2 = this.__filtered__ && !r2 ? new G3(this) : this.clone();
          return l2.__filtered__ ? l2.__takeCount__ = ge(a4, l2.__takeCount__) : l2.__views__.push({ size: ge(a4, mt), type: i3 + (l2.__dir__ < 0 ? "Right" : "") }), l2;
        }, G3.prototype[i3 + "Right"] = function(a4) {
          return this.reverse()[i3](a4).reverse();
        };
      }), Xe(["filter", "map", "takeWhile"], function(i3, r2) {
        var a4 = r2 + 1, l2 = a4 == Bp || a4 == kd;
        G3.prototype[i3] = function(c3) {
          var m4 = this.clone();
          return m4.__iteratees__.push({ iteratee: A2(c3, 3), type: a4 }), m4.__filtered__ = m4.__filtered__ || l2, m4;
        };
      }), Xe(["head", "last"], function(i3, r2) {
        var a4 = "take" + (r2 ? "Right" : "");
        G3.prototype[i3] = function() {
          return this[a4](1).value()[0];
        };
      }), Xe(["initial", "tail"], function(i3, r2) {
        var a4 = "drop" + (r2 ? "" : "Right");
        G3.prototype[i3] = function() {
          return this.__filtered__ ? new G3(this) : this[a4](1);
        };
      }), G3.prototype.compact = function() {
        return this.filter(xe);
      }, G3.prototype.find = function(i3) {
        return this.filter(i3).head();
      }, G3.prototype.findLast = function(i3) {
        return this.reverse().find(i3);
      }, G3.prototype.invokeMap = H4(function(i3, r2) {
        return typeof i3 == "function" ? new G3(this) : this.map(function(a4) {
          return Or(a4, i3, r2);
        });
      }), G3.prototype.reject = function(i3) {
        return this.filter(zn(A2(i3)));
      }, G3.prototype.slice = function(i3, r2) {
        i3 = D3(i3);
        var a4 = this;
        return a4.__filtered__ && (i3 > 0 || r2 < 0) ? new G3(a4) : (i3 < 0 ? a4 = a4.takeRight(-i3) : i3 && (a4 = a4.drop(i3)), r2 !== s4 && (r2 = D3(r2), a4 = r2 < 0 ? a4.dropRight(-r2) : a4.take(r2 - i3)), a4);
      }, G3.prototype.takeRightWhile = function(i3) {
        return this.reverse().takeWhile(i3).reverse();
      }, G3.prototype.toArray = function() {
        return this.take(mt);
      }, dt(G3.prototype, function(i3, r2) {
        var a4 = /^(?:filter|find|map|reject)|While$/.test(r2), l2 = /^(?:head|last)$/.test(r2), c3 = u3[l2 ? "take" + (r2 == "last" ? "Right" : "") : r2], m4 = l2 || /^find/.test(r2);
        !c3 || (u3.prototype[r2] = function() {
          var f2 = this.__wrapped__, g2 = l2 ? [1] : arguments, b3 = f2 instanceof G3, P2 = g2[0], R3 = b3 || L3(f2), F2 = function(k3) {
            var $2 = c3.apply(u3, Ut([k3], g2));
            return l2 && T3 ? $2[0] : $2;
          };
          R3 && a4 && typeof P2 == "function" && P2.length != 1 && (b3 = R3 = false);
          var T3 = this.__chain__, C2 = !!this.__actions__.length, x3 = m4 && !T3, U2 = b3 && !C2;
          if (!m4 && R3) {
            f2 = U2 ? f2 : new G3(this);
            var O3 = i3.apply(f2, g2);
            return O3.__actions__.push({ func: Wn, args: [F2], thisArg: s4 }), new Qe(O3, T3);
          }
          return x3 && U2 ? i3.apply(this, g2) : (O3 = this.thru(F2), x3 ? l2 ? O3.value()[0] : O3.value() : O3);
        });
      }), Xe(["pop", "push", "shift", "sort", "splice", "unshift"], function(i3) {
        var r2 = Mn[i3], a4 = /^(?:push|sort|unshift)$/.test(i3) ? "tap" : "thru", l2 = /^(?:pop|shift)$/.test(i3);
        u3.prototype[i3] = function() {
          var c3 = arguments;
          if (l2 && !this.__chain__) {
            var m4 = this.value();
            return r2.apply(L3(m4) ? m4 : [], c3);
          }
          return this[a4](function(f2) {
            return r2.apply(L3(f2) ? f2 : [], c3);
          });
        };
      }), dt(G3.prototype, function(i3, r2) {
        var a4 = u3[r2];
        if (a4) {
          var l2 = a4.name + "";
          X4.call(Fi, l2) || (Fi[l2] = []), Fi[l2].push({ name: r2, func: a4 });
        }
      }), Fi[Hn(s4, ct).name] = [{ name: "wrapper", func: s4 }], G3.prototype.clone = qh, G3.prototype.reverse = Kh, G3.prototype.value = Wh, u3.prototype.at = vM, u3.prototype.chain = _M, u3.prototype.commit = IM, u3.prototype.next = PM, u3.prototype.plant = FM, u3.prototype.reverse = SM, u3.prototype.toJSON = u3.prototype.valueOf = u3.prototype.value = TM, u3.prototype.first = u3.prototype.head, Fr && (u3.prototype[Fr] = RM), u3;
    }, kt = Ih();
    typeof define == "function" && typeof define.amd == "object" && define.amd ? (pe._ = kt, define(function() {
      return kt;
    })) : ri ? ((ri.exports = kt)._ = kt, Zs._ = kt) : pe._ = kt;
  }).call(Oi);
});
var ap = W2((rI, gm) => {
  "use strict";
  gm.exports = function(e3, t3) {
    return function() {
      for (var o2 = new Array(arguments.length), p2 = 0; p2 < o2.length; p2++)
        o2[p2] = arguments[p2];
      return e3.apply(t3, o2);
    };
  };
});
var Be = W2((nI, bm) => {
  "use strict";
  var Uv = ap(), mi = Object.prototype.toString;
  function op(s4) {
    return mi.call(s4) === "[object Array]";
  }
  function sp(s4) {
    return typeof s4 == "undefined";
  }
  function Hv(s4) {
    return s4 !== null && !sp(s4) && s4.constructor !== null && !sp(s4.constructor) && typeof s4.constructor.isBuffer == "function" && s4.constructor.isBuffer(s4);
  }
  function kv(s4) {
    return mi.call(s4) === "[object ArrayBuffer]";
  }
  function Gv(s4) {
    return typeof FormData != "undefined" && s4 instanceof FormData;
  }
  function $v(s4) {
    var e3;
    return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? e3 = ArrayBuffer.isView(s4) : e3 = s4 && s4.buffer && s4.buffer instanceof ArrayBuffer, e3;
  }
  function Vv(s4) {
    return typeof s4 == "string";
  }
  function qv(s4) {
    return typeof s4 == "number";
  }
  function ym(s4) {
    return s4 !== null && typeof s4 == "object";
  }
  function pa(s4) {
    if (mi.call(s4) !== "[object Object]")
      return false;
    var e3 = Object.getPrototypeOf(s4);
    return e3 === null || e3 === Object.prototype;
  }
  function Kv(s4) {
    return mi.call(s4) === "[object Date]";
  }
  function Wv(s4) {
    return mi.call(s4) === "[object File]";
  }
  function Xv(s4) {
    return mi.call(s4) === "[object Blob]";
  }
  function Mm(s4) {
    return mi.call(s4) === "[object Function]";
  }
  function Yv(s4) {
    return ym(s4) && Mm(s4.pipe);
  }
  function Qv(s4) {
    return typeof URLSearchParams != "undefined" && s4 instanceof URLSearchParams;
  }
  function zv(s4) {
    return s4.trim ? s4.trim() : s4.replace(/^\s+|\s+$/g, "");
  }
  function Jv() {
    return typeof navigator != "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? false : typeof window != "undefined" && typeof document != "undefined";
  }
  function lp(s4, e3) {
    if (!(s4 === null || typeof s4 == "undefined"))
      if (typeof s4 != "object" && (s4 = [s4]), op(s4))
        for (var t3 = 0, n2 = s4.length; t3 < n2; t3++)
          e3.call(null, s4[t3], t3, s4);
      else
        for (var o2 in s4)
          Object.prototype.hasOwnProperty.call(s4, o2) && e3.call(null, s4[o2], o2, s4);
  }
  function pp() {
    var s4 = {};
    function e3(o2, p2) {
      pa(s4[p2]) && pa(o2) ? s4[p2] = pp(s4[p2], o2) : pa(o2) ? s4[p2] = pp({}, o2) : op(o2) ? s4[p2] = o2.slice() : s4[p2] = o2;
    }
    for (var t3 = 0, n2 = arguments.length; t3 < n2; t3++)
      lp(arguments[t3], e3);
    return s4;
  }
  function Zv(s4, e3, t3) {
    return lp(e3, function(o2, p2) {
      t3 && typeof o2 == "function" ? s4[p2] = Uv(o2, t3) : s4[p2] = o2;
    }), s4;
  }
  function jv(s4) {
    return s4.charCodeAt(0) === 65279 && (s4 = s4.slice(1)), s4;
  }
  bm.exports = { isArray: op, isArrayBuffer: kv, isBuffer: Hv, isFormData: Gv, isArrayBufferView: $v, isString: Vv, isNumber: qv, isObject: ym, isPlainObject: pa, isUndefined: sp, isDate: Kv, isFile: Wv, isBlob: Xv, isFunction: Mm, isStream: Yv, isURLSearchParams: Qv, isStandardBrowserEnv: Jv, forEach: lp, merge: pp, extend: Zv, trim: zv, stripBOM: jv };
});
var cp = W2((aI, vm) => {
  "use strict";
  var Li = Be();
  function wm(s4) {
    return encodeURIComponent(s4).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  vm.exports = function(e3, t3, n2) {
    if (!t3)
      return e3;
    var o2;
    if (n2)
      o2 = n2(t3);
    else if (Li.isURLSearchParams(t3))
      o2 = t3.toString();
    else {
      var p2 = [];
      Li.forEach(t3, function(y4, _2) {
        y4 === null || typeof y4 == "undefined" || (Li.isArray(y4) ? _2 = _2 + "[]" : y4 = [y4], Li.forEach(y4, function(S4) {
          Li.isDate(S4) ? S4 = S4.toISOString() : Li.isObject(S4) && (S4 = JSON.stringify(S4)), p2.push(wm(_2) + "=" + wm(S4));
        }));
      }), o2 = p2.join("&");
    }
    if (o2) {
      var d4 = e3.indexOf("#");
      d4 !== -1 && (e3 = e3.slice(0, d4)), e3 += (e3.indexOf("?") === -1 ? "?" : "&") + o2;
    }
    return e3;
  };
});
var Im = W2((oI, _m) => {
  "use strict";
  var e_ = Be();
  function ca() {
    this.handlers = [];
  }
  ca.prototype.use = function(e3, t3, n2) {
    return this.handlers.push({ fulfilled: e3, rejected: t3, synchronous: n2 ? n2.synchronous : false, runWhen: n2 ? n2.runWhen : null }), this.handlers.length - 1;
  };
  ca.prototype.eject = function(e3) {
    this.handlers[e3] && (this.handlers[e3] = null);
  };
  ca.prototype.forEach = function(e3) {
    e_.forEach(this.handlers, function(n2) {
      n2 !== null && e3(n2);
    });
  };
  _m.exports = ca;
});
var Rm = W2((sI, Pm) => {
  "use strict";
  var t_ = Be();
  Pm.exports = function(e3, t3) {
    t_.forEach(e3, function(o2, p2) {
      p2 !== t3 && p2.toUpperCase() === t3.toUpperCase() && (e3[t3] = o2, delete e3[p2]);
    });
  };
});
var up = W2((lI, Fm) => {
  "use strict";
  Fm.exports = function(e3, t3, n2, o2, p2) {
    return e3.config = t3, n2 && (e3.code = n2), e3.request = o2, e3.response = p2, e3.isAxiosError = true, e3.toJSON = function() {
      return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: this.config, code: this.code, status: this.response && this.response.status ? this.response.status : null };
    }, e3;
  };
});
var mp = W2((pI, Sm) => {
  "use strict";
  var i_ = up();
  Sm.exports = function(e3, t3, n2, o2, p2) {
    var d4 = new Error(e3);
    return i_(d4, t3, n2, o2, p2);
  };
});
var Em = W2((cI, Tm) => {
  "use strict";
  var r_ = mp();
  Tm.exports = function(e3, t3, n2) {
    var o2 = n2.config.validateStatus;
    !n2.status || !o2 || o2(n2.status) ? e3(n2) : t3(r_("Request failed with status code " + n2.status, n2.config, null, n2.request, n2));
  };
});
var Am = W2((uI, Cm) => {
  "use strict";
  var ua = Be();
  Cm.exports = ua.isStandardBrowserEnv() ? function() {
    return { write: function(t3, n2, o2, p2, d4, h4) {
      var y4 = [];
      y4.push(t3 + "=" + encodeURIComponent(n2)), ua.isNumber(o2) && y4.push("expires=" + new Date(o2).toGMTString()), ua.isString(p2) && y4.push("path=" + p2), ua.isString(d4) && y4.push("domain=" + d4), h4 === true && y4.push("secure"), document.cookie = y4.join("; ");
    }, read: function(t3) {
      var n2 = document.cookie.match(new RegExp("(^|;\\s*)(" + t3 + ")=([^;]*)"));
      return n2 ? decodeURIComponent(n2[3]) : null;
    }, remove: function(t3) {
      this.write(t3, "", Date.now() - 864e5);
    } };
  }() : function() {
    return { write: function() {
    }, read: function() {
      return null;
    }, remove: function() {
    } };
  }();
});
var Om = W2((mI, xm) => {
  "use strict";
  xm.exports = function(e3) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e3);
  };
});
var Lm = W2((dI, Bm) => {
  "use strict";
  Bm.exports = function(e3, t3) {
    return t3 ? e3.replace(/\/+$/, "") + "/" + t3.replace(/^\/+/, "") : e3;
  };
});
var Dm = W2((fI, Nm) => {
  "use strict";
  var n_ = Om(), a_ = Lm();
  Nm.exports = function(e3, t3) {
    return e3 && !n_(t3) ? a_(e3, t3) : t3;
  };
});
var Hm = W2((hI, Um) => {
  "use strict";
  var dp = Be(), o_ = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
  Um.exports = function(e3) {
    var t3 = {}, n2, o2, p2;
    return e3 && dp.forEach(e3.split(`
`), function(h4) {
      if (p2 = h4.indexOf(":"), n2 = dp.trim(h4.substr(0, p2)).toLowerCase(), o2 = dp.trim(h4.substr(p2 + 1)), n2) {
        if (t3[n2] && o_.indexOf(n2) >= 0)
          return;
        n2 === "set-cookie" ? t3[n2] = (t3[n2] ? t3[n2] : []).concat([o2]) : t3[n2] = t3[n2] ? t3[n2] + ", " + o2 : o2;
      }
    }), t3;
  };
});
var $m = W2((gI, Gm) => {
  "use strict";
  var km = Be();
  Gm.exports = km.isStandardBrowserEnv() ? function() {
    var e3 = /(msie|trident)/i.test(navigator.userAgent), t3 = document.createElement("a"), n2;
    function o2(p2) {
      var d4 = p2;
      return e3 && (t3.setAttribute("href", d4), d4 = t3.href), t3.setAttribute("href", d4), { href: t3.href, protocol: t3.protocol ? t3.protocol.replace(/:$/, "") : "", host: t3.host, search: t3.search ? t3.search.replace(/^\?/, "") : "", hash: t3.hash ? t3.hash.replace(/^#/, "") : "", hostname: t3.hostname, port: t3.port, pathname: t3.pathname.charAt(0) === "/" ? t3.pathname : "/" + t3.pathname };
    }
    return n2 = o2(window.location.href), function(d4) {
      var h4 = km.isString(d4) ? o2(d4) : d4;
      return h4.protocol === n2.protocol && h4.host === n2.host;
    };
  }() : function() {
    return function() {
      return true;
    };
  }();
});
var Vr = W2((yI, Vm) => {
  "use strict";
  function fp(s4) {
    this.message = s4;
  }
  fp.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  };
  fp.prototype.__CANCEL__ = true;
  Vm.exports = fp;
});
var gp = W2((MI, qm) => {
  "use strict";
  var ma = Be(), s_ = Em(), l_ = Am(), p_ = cp(), c_ = Dm(), u_ = Hm(), m_ = $m(), hp = mp(), d_ = qr(), f_ = Vr();
  qm.exports = function(e3) {
    return new Promise(function(n2, o2) {
      var p2 = e3.data, d4 = e3.headers, h4 = e3.responseType, y4;
      function _2() {
        e3.cancelToken && e3.cancelToken.unsubscribe(y4), e3.signal && e3.signal.removeEventListener("abort", y4);
      }
      ma.isFormData(p2) && delete d4["Content-Type"];
      var w3 = new XMLHttpRequest();
      if (e3.auth) {
        var S4 = e3.auth.username || "", q3 = e3.auth.password ? unescape(encodeURIComponent(e3.auth.password)) : "";
        d4.Authorization = "Basic " + btoa(S4 + ":" + q3);
      }
      var Fe = c_(e3.baseURL, e3.url);
      w3.open(e3.method.toUpperCase(), p_(Fe, e3.params, e3.paramsSerializer), true), w3.timeout = e3.timeout;
      function we() {
        if (!!w3) {
          var Se = "getAllResponseHeaders" in w3 ? u_(w3.getAllResponseHeaders()) : null, ue = !h4 || h4 === "text" || h4 === "json" ? w3.responseText : w3.response, Te = { data: ue, status: w3.status, statusText: w3.statusText, headers: Se, config: e3, request: w3 };
          s_(function(ut) {
            n2(ut), _2();
          }, function(ut) {
            o2(ut), _2();
          }, Te), w3 = null;
        }
      }
      if ("onloadend" in w3 ? w3.onloadend = we : w3.onreadystatechange = function() {
        !w3 || w3.readyState !== 4 || w3.status === 0 && !(w3.responseURL && w3.responseURL.indexOf("file:") === 0) || setTimeout(we);
      }, w3.onabort = function() {
        !w3 || (o2(hp("Request aborted", e3, "ECONNABORTED", w3)), w3 = null);
      }, w3.onerror = function() {
        o2(hp("Network Error", e3, null, w3)), w3 = null;
      }, w3.ontimeout = function() {
        var ue = e3.timeout ? "timeout of " + e3.timeout + "ms exceeded" : "timeout exceeded", Te = e3.transitional || d_.transitional;
        e3.timeoutErrorMessage && (ue = e3.timeoutErrorMessage), o2(hp(ue, e3, Te.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", w3)), w3 = null;
      }, ma.isStandardBrowserEnv()) {
        var ct = (e3.withCredentials || m_(Fe)) && e3.xsrfCookieName ? l_.read(e3.xsrfCookieName) : void 0;
        ct && (d4[e3.xsrfHeaderName] = ct);
      }
      "setRequestHeader" in w3 && ma.forEach(d4, function(ue, Te) {
        typeof p2 == "undefined" && Te.toLowerCase() === "content-type" ? delete d4[Te] : w3.setRequestHeader(Te, ue);
      }), ma.isUndefined(e3.withCredentials) || (w3.withCredentials = !!e3.withCredentials), h4 && h4 !== "json" && (w3.responseType = e3.responseType), typeof e3.onDownloadProgress == "function" && w3.addEventListener("progress", e3.onDownloadProgress), typeof e3.onUploadProgress == "function" && w3.upload && w3.upload.addEventListener("progress", e3.onUploadProgress), (e3.cancelToken || e3.signal) && (y4 = function(Se) {
        !w3 || (o2(!Se || Se && Se.type ? new f_("canceled") : Se), w3.abort(), w3 = null);
      }, e3.cancelToken && e3.cancelToken.subscribe(y4), e3.signal && (e3.signal.aborted ? y4() : e3.signal.addEventListener("abort", y4))), p2 || (p2 = null), w3.send(p2);
    });
  };
});
var qr = W2((bI, Xm) => {
  "use strict";
  var he = Be(), Km = Rm(), h_ = up(), g_ = { "Content-Type": "application/x-www-form-urlencoded" };
  function Wm(s4, e3) {
    !he.isUndefined(s4) && he.isUndefined(s4["Content-Type"]) && (s4["Content-Type"] = e3);
  }
  function y_() {
    var s4;
    return typeof XMLHttpRequest != "undefined" ? s4 = gp() : typeof process != "undefined" && Object.prototype.toString.call(process) === "[object process]" && (s4 = gp()), s4;
  }
  function M_(s4, e3, t3) {
    if (he.isString(s4))
      try {
        return (e3 || JSON.parse)(s4), he.trim(s4);
      } catch (n2) {
        if (n2.name !== "SyntaxError")
          throw n2;
      }
    return (t3 || JSON.stringify)(s4);
  }
  var da = { transitional: { silentJSONParsing: true, forcedJSONParsing: true, clarifyTimeoutError: false }, adapter: y_(), transformRequest: [function(e3, t3) {
    return Km(t3, "Accept"), Km(t3, "Content-Type"), he.isFormData(e3) || he.isArrayBuffer(e3) || he.isBuffer(e3) || he.isStream(e3) || he.isFile(e3) || he.isBlob(e3) ? e3 : he.isArrayBufferView(e3) ? e3.buffer : he.isURLSearchParams(e3) ? (Wm(t3, "application/x-www-form-urlencoded;charset=utf-8"), e3.toString()) : he.isObject(e3) || t3 && t3["Content-Type"] === "application/json" ? (Wm(t3, "application/json"), M_(e3)) : e3;
  }], transformResponse: [function(e3) {
    var t3 = this.transitional || da.transitional, n2 = t3 && t3.silentJSONParsing, o2 = t3 && t3.forcedJSONParsing, p2 = !n2 && this.responseType === "json";
    if (p2 || o2 && he.isString(e3) && e3.length)
      try {
        return JSON.parse(e3);
      } catch (d4) {
        if (p2)
          throw d4.name === "SyntaxError" ? h_(d4, this, "E_JSON_PARSE") : d4;
      }
    return e3;
  }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, validateStatus: function(e3) {
    return e3 >= 200 && e3 < 300;
  }, headers: { common: { Accept: "application/json, text/plain, */*" } } };
  he.forEach(["delete", "get", "head"], function(e3) {
    da.headers[e3] = {};
  });
  he.forEach(["post", "put", "patch"], function(e3) {
    da.headers[e3] = he.merge(g_);
  });
  Xm.exports = da;
});
var Qm = W2((wI, Ym) => {
  "use strict";
  var b_ = Be(), w_ = qr();
  Ym.exports = function(e3, t3, n2) {
    var o2 = this || w_;
    return b_.forEach(n2, function(d4) {
      e3 = d4.call(o2, e3, t3);
    }), e3;
  };
});
var yp = W2((vI, zm) => {
  "use strict";
  zm.exports = function(e3) {
    return !!(e3 && e3.__CANCEL__);
  };
});
var jm = W2((_I, Zm) => {
  "use strict";
  var Jm = Be(), Mp = Qm(), v_ = yp(), __ = qr(), I_ = Vr();
  function bp(s4) {
    if (s4.cancelToken && s4.cancelToken.throwIfRequested(), s4.signal && s4.signal.aborted)
      throw new I_("canceled");
  }
  Zm.exports = function(e3) {
    bp(e3), e3.headers = e3.headers || {}, e3.data = Mp.call(e3, e3.data, e3.headers, e3.transformRequest), e3.headers = Jm.merge(e3.headers.common || {}, e3.headers[e3.method] || {}, e3.headers), Jm.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function(o2) {
      delete e3.headers[o2];
    });
    var t3 = e3.adapter || __.adapter;
    return t3(e3).then(function(o2) {
      return bp(e3), o2.data = Mp.call(e3, o2.data, o2.headers, e3.transformResponse), o2;
    }, function(o2) {
      return v_(o2) || (bp(e3), o2 && o2.response && (o2.response.data = Mp.call(e3, o2.response.data, o2.response.headers, e3.transformResponse))), Promise.reject(o2);
    });
  };
});
var wp = W2((II, ed) => {
  "use strict";
  var Ve = Be();
  ed.exports = function(e3, t3) {
    t3 = t3 || {};
    var n2 = {};
    function o2(w3, S4) {
      return Ve.isPlainObject(w3) && Ve.isPlainObject(S4) ? Ve.merge(w3, S4) : Ve.isPlainObject(S4) ? Ve.merge({}, S4) : Ve.isArray(S4) ? S4.slice() : S4;
    }
    function p2(w3) {
      if (Ve.isUndefined(t3[w3])) {
        if (!Ve.isUndefined(e3[w3]))
          return o2(void 0, e3[w3]);
      } else
        return o2(e3[w3], t3[w3]);
    }
    function d4(w3) {
      if (!Ve.isUndefined(t3[w3]))
        return o2(void 0, t3[w3]);
    }
    function h4(w3) {
      if (Ve.isUndefined(t3[w3])) {
        if (!Ve.isUndefined(e3[w3]))
          return o2(void 0, e3[w3]);
      } else
        return o2(void 0, t3[w3]);
    }
    function y4(w3) {
      if (w3 in t3)
        return o2(e3[w3], t3[w3]);
      if (w3 in e3)
        return o2(void 0, e3[w3]);
    }
    var _2 = { url: d4, method: d4, data: d4, baseURL: h4, transformRequest: h4, transformResponse: h4, paramsSerializer: h4, timeout: h4, timeoutMessage: h4, withCredentials: h4, adapter: h4, responseType: h4, xsrfCookieName: h4, xsrfHeaderName: h4, onUploadProgress: h4, onDownloadProgress: h4, decompress: h4, maxContentLength: h4, maxBodyLength: h4, transport: h4, httpAgent: h4, httpsAgent: h4, cancelToken: h4, socketPath: h4, responseEncoding: h4, validateStatus: y4 };
    return Ve.forEach(Object.keys(e3).concat(Object.keys(t3)), function(S4) {
      var q3 = _2[S4] || p2, Fe = q3(S4);
      Ve.isUndefined(Fe) && q3 !== y4 || (n2[S4] = Fe);
    }), n2;
  };
});
var vp = W2((PI, td) => {
  td.exports = { version: "0.24.0" };
});
var nd = W2((RI, rd) => {
  "use strict";
  var P_ = vp().version, _p = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(s4, e3) {
    _p[s4] = function(n2) {
      return typeof n2 === s4 || "a" + (e3 < 1 ? "n " : " ") + s4;
    };
  });
  var id = {};
  _p.transitional = function(e3, t3, n2) {
    function o2(p2, d4) {
      return "[Axios v" + P_ + "] Transitional option '" + p2 + "'" + d4 + (n2 ? ". " + n2 : "");
    }
    return function(p2, d4, h4) {
      if (e3 === false)
        throw new Error(o2(d4, " has been removed" + (t3 ? " in " + t3 : "")));
      return t3 && !id[d4] && (id[d4] = true, console.warn(o2(d4, " has been deprecated since v" + t3 + " and will be removed in the near future"))), e3 ? e3(p2, d4, h4) : true;
    };
  };
  function R_(s4, e3, t3) {
    if (typeof s4 != "object")
      throw new TypeError("options must be an object");
    for (var n2 = Object.keys(s4), o2 = n2.length; o2-- > 0; ) {
      var p2 = n2[o2], d4 = e3[p2];
      if (d4) {
        var h4 = s4[p2], y4 = h4 === void 0 || d4(h4, p2, s4);
        if (y4 !== true)
          throw new TypeError("option " + p2 + " must be " + y4);
        continue;
      }
      if (t3 !== true)
        throw Error("Unknown option " + p2);
    }
  }
  rd.exports = { assertOptions: R_, validators: _p };
});
var cd = W2((FI, pd) => {
  "use strict";
  var ad = Be(), F_ = cp(), od = Im(), sd = jm(), fa = wp(), ld = nd(), Ni = ld.validators;
  function Kr(s4) {
    this.defaults = s4, this.interceptors = { request: new od(), response: new od() };
  }
  Kr.prototype.request = function(e3) {
    typeof e3 == "string" ? (e3 = arguments[1] || {}, e3.url = arguments[0]) : e3 = e3 || {}, e3 = fa(this.defaults, e3), e3.method ? e3.method = e3.method.toLowerCase() : this.defaults.method ? e3.method = this.defaults.method.toLowerCase() : e3.method = "get";
    var t3 = e3.transitional;
    t3 !== void 0 && ld.assertOptions(t3, { silentJSONParsing: Ni.transitional(Ni.boolean), forcedJSONParsing: Ni.transitional(Ni.boolean), clarifyTimeoutError: Ni.transitional(Ni.boolean) }, false);
    var n2 = [], o2 = true;
    this.interceptors.request.forEach(function(q3) {
      typeof q3.runWhen == "function" && q3.runWhen(e3) === false || (o2 = o2 && q3.synchronous, n2.unshift(q3.fulfilled, q3.rejected));
    });
    var p2 = [];
    this.interceptors.response.forEach(function(q3) {
      p2.push(q3.fulfilled, q3.rejected);
    });
    var d4;
    if (!o2) {
      var h4 = [sd, void 0];
      for (Array.prototype.unshift.apply(h4, n2), h4 = h4.concat(p2), d4 = Promise.resolve(e3); h4.length; )
        d4 = d4.then(h4.shift(), h4.shift());
      return d4;
    }
    for (var y4 = e3; n2.length; ) {
      var _2 = n2.shift(), w3 = n2.shift();
      try {
        y4 = _2(y4);
      } catch (S4) {
        w3(S4);
        break;
      }
    }
    try {
      d4 = sd(y4);
    } catch (S4) {
      return Promise.reject(S4);
    }
    for (; p2.length; )
      d4 = d4.then(p2.shift(), p2.shift());
    return d4;
  };
  Kr.prototype.getUri = function(e3) {
    return e3 = fa(this.defaults, e3), F_(e3.url, e3.params, e3.paramsSerializer).replace(/^\?/, "");
  };
  ad.forEach(["delete", "get", "head", "options"], function(e3) {
    Kr.prototype[e3] = function(t3, n2) {
      return this.request(fa(n2 || {}, { method: e3, url: t3, data: (n2 || {}).data }));
    };
  });
  ad.forEach(["post", "put", "patch"], function(e3) {
    Kr.prototype[e3] = function(t3, n2, o2) {
      return this.request(fa(o2 || {}, { method: e3, url: t3, data: n2 }));
    };
  });
  pd.exports = Kr;
});
var md = W2((SI, ud) => {
  "use strict";
  var S_ = Vr();
  function Di(s4) {
    if (typeof s4 != "function")
      throw new TypeError("executor must be a function.");
    var e3;
    this.promise = new Promise(function(o2) {
      e3 = o2;
    });
    var t3 = this;
    this.promise.then(function(n2) {
      if (!!t3._listeners) {
        var o2, p2 = t3._listeners.length;
        for (o2 = 0; o2 < p2; o2++)
          t3._listeners[o2](n2);
        t3._listeners = null;
      }
    }), this.promise.then = function(n2) {
      var o2, p2 = new Promise(function(d4) {
        t3.subscribe(d4), o2 = d4;
      }).then(n2);
      return p2.cancel = function() {
        t3.unsubscribe(o2);
      }, p2;
    }, s4(function(o2) {
      t3.reason || (t3.reason = new S_(o2), e3(t3.reason));
    });
  }
  Di.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  };
  Di.prototype.subscribe = function(e3) {
    if (this.reason) {
      e3(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e3) : this._listeners = [e3];
  };
  Di.prototype.unsubscribe = function(e3) {
    if (!!this._listeners) {
      var t3 = this._listeners.indexOf(e3);
      t3 !== -1 && this._listeners.splice(t3, 1);
    }
  };
  Di.source = function() {
    var e3, t3 = new Di(function(o2) {
      e3 = o2;
    });
    return { token: t3, cancel: e3 };
  };
  ud.exports = Di;
});
var fd = W2((TI, dd) => {
  "use strict";
  dd.exports = function(e3) {
    return function(n2) {
      return e3.apply(null, n2);
    };
  };
});
var gd = W2((EI, hd) => {
  "use strict";
  hd.exports = function(e3) {
    return typeof e3 == "object" && e3.isAxiosError === true;
  };
});
var bd = W2((CI, Ip) => {
  "use strict";
  var yd = Be(), T_ = ap(), ha = cd(), E_ = wp(), C_ = qr();
  function Md(s4) {
    var e3 = new ha(s4), t3 = T_(ha.prototype.request, e3);
    return yd.extend(t3, ha.prototype, e3), yd.extend(t3, e3), t3.create = function(o2) {
      return Md(E_(s4, o2));
    }, t3;
  }
  var gt = Md(C_);
  gt.Axios = ha;
  gt.Cancel = Vr();
  gt.CancelToken = md();
  gt.isCancel = yp();
  gt.VERSION = vp().version;
  gt.all = function(e3) {
    return Promise.all(e3);
  };
  gt.spread = fd();
  gt.isAxiosError = gd();
  Ip.exports = gt;
  Ip.exports.default = gt;
});
var vd = W2((AI, wd) => {
  wd.exports = bd();
});
var hm = mm(dm());
var np = (s4) => {
  let e3 = 200, t3 = [], n2 = 0;
  return t3[n2] = [], s4.forEach((o2) => {
    t3[n2].length <= e3 - 1 ? t3[n2].push(o2) : (n2++, t3[n2] = [o2]);
  }), t3;
};
var ea = (s4) => {
  let e3 = [], t3 = 200;
  for (; s4.length > t3; ) {
    let n2 = s4.splice(0, t3);
    e3.push(n2);
  }
  return e3.push(s4), e3;
};
var Oe = (s4, e3) => {
  let t3 = "", n2 = { profile: "https://profile.fansunitedapi.com/v1", football: "https://football.fansunitedapi.com/v1", idMapping: "https://id-mapping.fansunitedapi.com/v1", predictor: "https://prediction.fansunitedapi.com/v1", client: "https://client.fansunitedapi.com/v1", loyalty: "https://loyalty.fansunitedapi.com/v1" }, o2 = { profile: "http://localhost:8010/v1", football: "http://localhost:8080/v1", idMapping: "http://localhost:8030/v1", predictor: "http://localhost:8040/v1", client: "http://localhost:8070/v1", loyalty: "http://localhost:8060/v1" }, p2 = { profile: "https://profile.fansunitedstagingapi.com/v1", football: "https://football.fansunitedstagingapi.com/v1", idMapping: "https://id-mapping.fansunitedstagingapi.com/v1", predictor: "https://prediction.fansunitedstagingapi.com/v1", client: "https://client.fansunitedstagingapi.com/v1", loyalty: "https://loyalty.fansunitedstagingapi.com/v1" };
  return s4 === "prod" ? t3 = n2[e3] : s4 === "dev" ? t3 = o2[e3] : t3 = p2[e3], t3;
};
var Xt = (s4) => s4.filter((t3, n2, o2) => n2 === o2.indexOf(t3));
var ta = (s4) => Array.isArray(s4) ? s4.map((e3) => ta(e3)) : s4 != null && s4.constructor === Object ? Object.keys(s4).reduce((e3, t3) => __spreadProps(__spreadValues({}, e3), { [(0, hm.camelCase)(t3)]: ta(s4[t3]) }), {}) : s4;
var de = (s4) => s4 || false;
var fe = () => `&disable_cache=${Date.now()}`;
var Gr = (s4) => s4.sort((e3, t3) => e3.localeCompare(t3));
var ia = class {
  id = null;
  name = null;
  nickname = null;
  avatar = null;
  gender = null;
  country = null;
  birthDate = null;
  interests = [];
  followingCount = 0;
  followersCount = 0;
};
var ra = class {
  profilesFromResponse = (e3) => e3 ? e3.map((t3) => this.fullProfileFromResponse(t3)) : null;
  fullProfileFromResponse = (e3) => {
    let t3 = new ia();
    return t3.id = e3.id, t3.name = e3.name, t3.nickname = e3.nickname, t3.avatar = e3.avatar, t3.gender = e3.gender, t3.country = e3.country, t3.birthDate = e3.birth_date, t3.interests = e3.interests ? e3.interests : [], t3.followingCount = e3.following_count, t3.followersCount = e3.followers_count, t3;
  };
};
var na = class {
  nextPageStartsAfter = null;
  itemsPerPage = null;
};
var Bi = class {
  pagination = new na();
};
var re2 = class {
  meta = new Bi();
  data = [];
};
var aa = class {
  avatar = null;
  followingId = null;
  name = null;
  nickname = null;
  profileId = null;
};
var oa = class {
  followResponse = (e3) => e3.map((t3) => this.remapResponse(t3));
  followingFromResponse = (e3) => {
    let t3 = new re2();
    return t3.meta.pagination.nextPageStartsAfter = e3.meta.pagination.next_page_starts_after, t3.meta.pagination.itemsPerPage = e3.meta.pagination.items_per_page, t3.data = e3.data.map((n2) => this.remapResponse(n2)), t3;
  };
  remapResponse = (e3) => {
    let t3 = new aa();
    return t3.avatar = e3.avatar, t3.followingId = e3.following_id, t3.name = e3.name, t3.profileId = e3.profile_id, t3.nickname = e3.nickname, t3;
  };
};
var sa = class {
  avatar = null;
  followerId = null;
  name = null;
  nickname = null;
  profileId = null;
};
var la = class {
  followersFromResponse = (e3) => {
    let t3 = new re2();
    return t3.meta.pagination.nextPageStartsAfter = e3.meta.pagination.next_page_starts_after, t3.meta.pagination.itemsPerPage = e3.meta.pagination.items_per_page, t3.data = e3.data.map((n2) => this.remapResponse(n2)), t3;
  };
  remapResponse = (e3) => {
    let t3 = new sa();
    return t3.avatar = e3.avatar, t3.followerId = e3.follower_id, t3.name = e3.name, t3.profileId = e3.profile_id, t3;
  };
};
var $r = class {
  profile_ids = [];
};
var ya = mm(vd());
function Pp(s4) {
  this.message = s4;
}
Pp.prototype = new Error(), Pp.prototype.name = "InvalidCharacterError";
var _d = typeof window != "undefined" && window.atob && window.atob.bind(window) || function(s4) {
  var e3 = String(s4).replace(/=+$/, "");
  if (e3.length % 4 == 1)
    throw new Pp("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var t3, n2, o2 = 0, p2 = 0, d4 = ""; n2 = e3.charAt(p2++); ~n2 && (t3 = o2 % 4 ? 64 * t3 + n2 : n2, o2++ % 4) ? d4 += String.fromCharCode(255 & t3 >> (-2 * o2 & 6)) : 0)
    n2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n2);
  return d4;
};
function A_(s4) {
  var e3 = s4.replace(/-/g, "+").replace(/_/g, "/");
  switch (e3.length % 4) {
    case 0:
      break;
    case 2:
      e3 += "==";
      break;
    case 3:
      e3 += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(t3) {
      return decodeURIComponent(_d(t3).replace(/(.)/g, function(n2, o2) {
        var p2 = o2.charCodeAt(0).toString(16).toUpperCase();
        return p2.length < 2 && (p2 = "0" + p2), "%" + p2;
      }));
    }(e3);
  } catch {
    return _d(e3);
  }
}
function ga(s4) {
  this.message = s4;
}
function x_(s4, e3) {
  if (typeof s4 != "string")
    throw new ga("Invalid token specified");
  var t3 = (e3 = e3 || {}).header === true ? 0 : 1;
  try {
    return JSON.parse(A_(s4.split(".")[t3]));
  } catch (n2) {
    throw new ga("Invalid token specified: " + n2.message);
  }
}
ga.prototype = new Error(), ga.prototype.name = "InvalidTokenError";
var Id = x_;
var Pd = (s4, e3, t3) => {
  let n2 = { data: s4.data, status: e3, statusText: t3, headers: s4.headers, config: s4 };
  return { code: String(e3), config: s4, isAxiosError: true, toJSON: () => ({}), name: "Unauthorized", message: t3, response: n2 };
};
var Me = class {
  instanceAuth = null;
  instance = null;
  constructor(e3, t3) {
    this.instanceAuth = ya.default.create({ baseURL: t3, headers: { Authorization: `Bearer ${e3.authProvider.getIdToken()}`, "Content-Type": "application/json" } }), this.instanceAuth.interceptors.request.use((n2) => {
      let o2 = null;
      try {
        o2 = Id(e3.authProvider.getIdToken());
      } catch (d4) {
        throw Pd(n2, 401, d4.message);
      }
      return Date.now() > o2.exp && (ya.default.defaults.headers.common.Authorization = `Bearer ${e3.authProvider.getIdToken()}`, n2.headers.Authorization = `Bearer ${e3.authProvider.getIdToken()}`), n2;
    }, (n2) => {
      Promise.reject(n2);
    }), this.instanceAuth.interceptors.response.use((n2) => n2, (n2) => {
      var _a2, _b;
      let o2 = n2.config;
      if ((((_a2 = n2.response) == null ? void 0 : _a2.status) === 403 || ((_b = n2.response) == null ? void 0 : _b.status) === 401) && !o2._retry) {
        o2._retry = true;
        let p2 = e3.authProvider.getIdToken();
        return o2.headers.Authorization = `Bearer ${p2}`, this.instanceAuth(o2);
      }
      return Promise.reject(n2);
    }), this.instance = ya.default.create({ baseURL: t3, headers: { "Content-Type": "application/json" } });
  }
};
var O_ = "/countries";
var Le = "/profile";
var Rd = "/profiles";
var Ui = class extends Me {
  apiSignInUrl = null;
  profileRemapper = null;
  followingRemapper = null;
  followersRemapper = null;
  lang = null;
  constructor(e3) {
    super(e3, Oe(e3.environment, "profile"));
    this.lang = e3.lang, this.apiSignInUrl = `?key=${e3.apiKey}&client_id=${e3.clientId}`, this.profileRemapper = new ra(), this.followingRemapper = new oa(), this.followersRemapper = new la();
  }
  getCountries = async (e3) => {
    try {
      let t3 = `&lang=${this.lang}`, n2 = `${O_}${this.apiSignInUrl}${t3}`, o2 = Date.now();
      return e3 && (n2 += `&disable_cache=${o2}`), (await this.instance.get(n2)).data.data;
    } catch (t3) {
      throw console.warn("There was a problem fetching the countries:", t3), t3.response;
    }
  };
  getProfile = async (e3) => {
    let t3 = `${Le}${this.apiSignInUrl}`;
    if (e3) {
      t3 = `${Rd}/${e3}${this.apiSignInUrl}`;
      try {
        let n2 = await this.instance.get(t3);
        return this.profileRemapper.fullProfileFromResponse(n2.data.data);
      } catch (n2) {
        throw console.warn(`There was a problem fetching the following profile: ${e3}`, n2), n2.response;
      }
    } else
      try {
        let n2 = await this.instanceAuth.get(t3);
        return this.profileRemapper.fullProfileFromResponse(n2.data.data);
      } catch (n2) {
        throw console.warn("There was a problem fetching your profile from API:", n2), n2.response;
      }
  };
  getProfiles = async (e3, t3) => {
    try {
      let n2 = `${Rd}${this.apiSignInUrl}&profile_ids=${e3.join(",")}`, o2 = Date.now();
      t3 && (n2 += `&disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.profileRemapper.profilesFromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn(`There was a problem fetching the following profiles: ${e3.join(",")}`, n2), n2.response;
    }
  };
  getFollowers = async (e3, t3) => {
    let n2 = `${Le}/followers${this.apiSignInUrl}`;
    if (e3 && !t3) {
      n2 = `${Le}/followers${this.apiSignInUrl}${e3.constructFilterUrl()}`;
      try {
        let o2 = await this.instanceAuth.get(n2);
        return this.followersRemapper.followersFromResponse(o2.data);
      } catch (o2) {
        throw console.warn("There was a problem fetching the followers for own profile", o2), o2.response;
      }
    } else if (!e3 && !t3)
      try {
        let o2 = await this.instanceAuth.get(n2);
        return this.followersRemapper.followersFromResponse(o2.data);
      } catch (o2) {
        throw console.warn("There was a problem fetching the followers for own profile", o2), o2.response;
      }
    e3 && t3 ? n2 = `${Le}/${t3}/followers${this.apiSignInUrl}${e3.constructFilterUrl()}` : !e3 && t3 && (n2 = `${Le}/${t3}/followers${this.apiSignInUrl}`);
    try {
      let o2 = await this.instance.get(n2);
      return this.followersRemapper.followersFromResponse(o2.data);
    } catch (o2) {
      throw console.warn(`There was a problem fetching the followers for profile: ${t3}`, o2), o2.response;
    }
  };
  getFollowing = async (e3, t3) => {
    let n2 = `${Le}/following${this.apiSignInUrl}`;
    if (e3 && !t3) {
      n2 = `${Le}/following${this.apiSignInUrl}${e3.constructFilterUrl()}`;
      try {
        let o2 = await this.instanceAuth.get(n2);
        return this.followingRemapper.followingFromResponse(o2.data);
      } catch (o2) {
        throw console.warn("There was a problem fetching the followers of own profile", o2), o2.response;
      }
    } else if (!e3 && !t3)
      try {
        let o2 = await this.instanceAuth.get(n2);
        return this.followingRemapper.followingFromResponse(o2.data);
      } catch (o2) {
        throw console.warn("There was a problem fetching the followers of own profile", o2), o2.response;
      }
    e3 && t3 ? n2 = `${Le}/${t3}/following${this.apiSignInUrl}${e3.constructFilterUrl()}` : !e3 && t3 && (n2 = `${Le}/${t3}/following${this.apiSignInUrl}`);
    try {
      let o2 = await this.instance.get(n2);
      return this.followingRemapper.followingFromResponse(o2.data);
    } catch (o2) {
      throw console.warn(`There was a problem fetching the followers of the following profile: ${t3}`, o2), o2.response;
    }
  };
  follow = async (e3) => {
    let t3 = new $r();
    t3.profile_ids = e3;
    try {
      let n2 = await this.instanceAuth.post(`${Le}/follow${this.apiSignInUrl}`, JSON.stringify(t3));
      return this.followingRemapper.followResponse(n2.data.data);
    } catch (n2) {
      throw console.warn(`There was a problem with POST request for profiles: ${e3.join(",")} `, n2), n2.response;
    }
  };
  unfollow = async (e3) => {
    let t3 = new $r();
    t3.profile_ids = e3;
    try {
      return await this.instanceAuth.delete(`${Le}/follow${this.apiSignInUrl}`, { data: JSON.stringify(t3) }), true;
    } catch (n2) {
      throw console.warn(`There was a problem with DELETE request for profiles: ${e3.join(",")} `, n2), n2.response;
    }
  };
  getBadges = async (e3) => {
    let t3 = `${Le}/badges${this.apiSignInUrl}`;
    try {
      return e3 ? (t3 = `${Le}/${e3}/badges${this.apiSignInUrl}`, (await this.instance.get(t3)).data.data) : (await this.instanceAuth.get(t3)).data.data;
    } catch (n2) {
      throw console.warn("There was a problem with fetching the badges", n2), n2.response;
    }
  };
  updateProfile = async (e3) => {
    try {
      let t3 = await this.instanceAuth.patch(`${Le}${this.apiSignInUrl}`, e3);
      return this.profileRemapper.fullProfileFromResponse(t3.data.data);
    } catch (t3) {
      throw console.warn("There was a problem updating the own profile:", t3), t3.response;
    }
  };
};
var Bt = { native: "id", sportradar: "sportradar_id", sportal365: "sportal365_id", enetpulse: "enetpulse_id" };
var Rp = { PREDICTOR_USER_RELATED_OPERATION: "https://docs.fansunitedmedia.com/docs/predictor-operations#user-related-operations" };
var Fp = ["matchId", "matchType", "market", "prediction"];
var Fd = "FansUnited";
var Sp = { football: { ids: [], countries: [], competitions: [] }, profile: { info: {}, statistics: {}, badges: null, countries: [], exparations: { profile: 0, statistics: 0, badges: 0 } } };
var yt = class {
  idSchema = "";
  expirationTimeout = 600;
  expirationBadgesTimeout = 3600;
  constructor(e3) {
    this.idSchema = e3.idSchema, (this.getData() === void 0 || this.getData() === null) && this.setData(Sp);
  }
  clearData = () => {
    this.setData(Sp);
  };
  getEntityById = (e3 = "", t3 = "") => this.getData().football.ids.find((n2) => {
    let o2 = Bt[this.idSchema];
    return n2 && `${n2[o2]}` === t3 && n2.resource === e3;
  });
  getEntity = (e3, t3, n2) => Array.isArray(e3) ? this.getData().football.ids.filter((o2) => {
    let p2 = Bt[n2];
    return o2 && e3.includes(`${o2[p2]}`) && o2.resource === t3;
  }) : this.getData().football.ids.find((o2) => {
    let p2 = Bt[n2];
    return o2 && `${o2[p2]}` === e3 && o2.resource === t3;
  });
  getEntityByNativeId = (e3 = "", t3 = "") => this.getData().football.ids.find((n2) => n2 && `${n2.id}` === t3 && n2.resource === e3);
  checkForExistingIdObjs = (e3, t3) => {
    let n2 = Bt[t3], o2 = {};
    return Object.keys(e3).forEach((p2) => {
      let d4 = e3[p2], y4 = this.getEntity(d4, p2, t3).map((w3) => w3[n2]), _2 = e3[p2].filter((w3) => !y4.includes(w3));
      o2[p2] = d4.map((w3) => _2.includes(w3) ? { id: w3, exists: false } : { id: w3, exists: true });
    }), o2;
  };
  getIdsByType = (e3, t3, n2) => {
    let o2 = Bt[n2], p2 = Bt[t3], d4 = {};
    return Object.keys(e3).forEach((h4) => {
      let y4 = e3[h4], _2 = [];
      this.getData().football.ids.forEach((w3) => {
        y4.forEach((S4, q3) => {
          S4 === w3[p2] && h4 === w3.resource && (_2[q3] = w3[o2]);
        });
      }), d4[h4] = _2;
    }), d4;
  };
  addIdMapping = (e3) => {
    let t3 = this.getData();
    t3.football.ids.push(e3), this.setData(t3);
  };
  addIdMappings = (e3) => {
    let t3 = this.getData(), n2 = t3.football.ids;
    n2 = [...n2, ...e3], t3.football.ids = n2, this.setData(t3);
  };
  setOwnProfile = (e3) => {
    let t3 = this.getData();
    t3.profile.info = e3, t3.profile.exparations.profile = Math.floor(Date.now() / 1e3) + this.expirationTimeout, this.setData(t3);
  };
  getOwnProfile = () => this.getData().profile.info;
  getProfileCountries = () => this.getData().profile.countries;
  setProfileCountries = (e3) => {
    let t3 = this.getData();
    t3.profile.countries = e3, this.setData(t3);
  };
  getProfileStats = () => this.getData().profile.statistics;
  setProfileStats = (e3) => {
    let t3 = this.getData();
    t3.profile.statistics = e3, t3.profile.exparations.statistics = Math.floor(Date.now() / 1e3) + this.expirationTimeout, this.setData(t3);
  };
  getProfileBadges = () => this.getData().profile.badges;
  setProfileBadges = (e3) => {
    let t3 = this.getData();
    t3.profile.badges = e3, t3.profile.exparations.badges = Math.floor(Date.now() / 1e3) + this.expirationBadgesTimeout, this.setData(t3);
  };
  getFootballCountries = () => this.getData().football.countries;
  setFootballCountries = (e3) => {
    let t3 = this.getData();
    t3.football.countries = e3, this.setData(t3);
  };
  getCompetitions = (e3) => {
    let t3 = this.getData();
    return e3 ? e3.competitionSearchFilter(t3.football.competitions) : t3.football.competitions;
  };
  setCompetitions = (e3) => {
    let t3 = this.getData(), n2 = [...t3.football.competitions];
    n2.push(...e3), t3.football.competitions = this.makeCompetitionsUnique(n2), this.setData(t3);
  };
  getCompetitionsLength = () => {
    let { football: e3 } = this.getData();
    return e3.competitions.length;
  };
  getExpiration = (e3) => {
    let t3 = this.getData();
    switch (this.initialNewSchema("exparations"), e3) {
      case "profile":
        return t3.profile.exparations.profile;
      case "statistics":
        return t3.profile.exparations.statistics;
      case "badges":
        return t3.profile.exparations.badges;
    }
  };
  makeCompetitionsUnique = (e3) => {
    let t3 = new Set();
    return e3.filter((n2) => {
      let o2 = !t3.has(n2.id);
      return t3.add(n2.id), o2;
    });
  };
  getData = () => JSON.parse(localStorage.getItem(Fd));
  setData = (e3) => {
    localStorage.setItem(Fd, JSON.stringify(e3));
  };
  initialNewSchema = (e3) => {
    this.getData().profile[e3] || this.setData(Sp);
  };
};
var Wr = { player: "players", team: "teams", homeTeam: "teams", awayTeam: "teams", country: "countries", competition: "competitions", match: "matches" };
var Ma = class extends Me {
  apiSignInUrl = "";
  constructor(e3) {
    super(e3, Oe(e3.environment, "idMapping"));
    this.apiSignInUrl = `?key=${e3.apiKey}&client_id=${e3.clientId}`;
  }
  getEntityById = (e3, t3) => {
    try {
      return this.instance.get(`/football${this.apiSignInUrl}&input_provider=${config.idSchema}&${Wr[e3]}=${t3}`);
    } catch (n2) {
      throw console.warn(`There was a problem with id mapping request for the following id:${t3}`, n2), n2.response;
    }
  };
  getEntityByIdAndSchema = (e3, t3, n2) => {
    try {
      return this.instance.get(`/football${this.apiSignInUrl}&input_provider=${n2}&${Wr[e3]}=${t3}`);
    } catch (o2) {
      throw console.warn(`There was a problem with id mapping request for the following id:${t3}`, o2), o2.response;
    }
  };
  getEntityIdsByIdsAndSchema = (e3, t3, n2) => {
    try {
      return this.instance.get(`/football${this.apiSignInUrl}&input_provider=${n2}&${Wr[e3]}=${t3.join(",")}`);
    } catch (o2) {
      throw console.warn(`There was a problem with id mapping request for the following ids:${t3.join(",")}`, o2), o2.response;
    }
  };
  getEntitiesByIds = (e3, t3, n2) => {
    t3.sort((d4, h4) => d4.localeCompare(h4));
    let p2 = np(t3).map((d4) => {
      try {
        return this.instance.get(`/football${this.apiSignInUrl}&input_provider=${n2}&${Wr[e3]}=${d4.join(",")}`);
      } catch (h4) {
        throw console.warn(`There was a problem with id mapping request for the following ids:${d4.join(",")}`, h4), h4.response;
      }
    });
    return Promise.all(p2).then((d4) => {
      let h4 = [];
      return d4.forEach((y4) => {
        h4.push(...y4.data.data);
      }), h4;
    });
  };
  getEntitiesByIdObjs = async (e3, t3) => {
    let n2 = [], o2 = {}, p2 = [];
    Object.keys(e3).forEach((_2) => {
      n2.push.apply(n2, e3[_2]);
    });
    let d4 = Xt(n2), h4 = np(d4);
    for (let _2 of h4) {
      let w3 = "";
      if (Object.keys(e3).forEach((S4) => {
        o2[S4] = [];
        let q3 = _2.filter((Fe) => e3[S4].includes(Fe));
        q3 && q3.length > 0 && (o2[S4] = q3);
      }), Object.keys(o2).forEach((S4) => {
        o2[S4].length > 0 && (o2[S4].sort((q3, Fe) => q3.localeCompare(Fe)), w3 += "&", w3 += `${Wr[S4]}=${o2[S4].join(",")}`);
      }), w3 && w3.length > 0)
        try {
          let S4 = await this.instance.get(`/football${this.apiSignInUrl}&input_provider=${t3 || "native"}${w3}`);
          p2.push(S4.data.data);
        } catch (S4) {
          throw console.warn("There was a problem with id mapping request", S4), S4.response;
        }
      else
        p2.push([]);
    }
    return Array.prototype.concat.apply([], p2);
  };
};
var ba = class {
  isBrowser = false;
  localStorage = null;
  https = null;
  constructor(e3) {
    this.isBrowser = typeof window != "undefined", this.localStorage = new yt(e3), this.https = new Ma(e3);
  }
  getEntitiesByIds = async (e3, t3, n2) => {
    if (this.isBrowser)
      try {
        let o2 = this.localStorage.checkForExistingIdObjs(e3, t3), p2 = this.splitForRequestAndExisting(o2), d4 = await this.https.getEntitiesByIdObjs(p2.request, t3);
        return this.localStorage.addIdMappings(d4), this.localStorage.getIdsByType(e3, t3, n2);
      } catch (o2) {
        return console.warn("There was a problem retrieving the entity ids ", o2), Promise.resolve([]);
      }
    else
      try {
        let o2 = await this.https.getEntitiesByIdObjs(e3, t3);
        return Object.keys(e3).forEach((p2) => {
          e3[p2] = o2.filter((d4) => d4.resource === p2).map((d4) => d4[Bt[n2]]);
        }), e3;
      } catch (o2) {
        return console.warn("There was a problem retrieving the entity ids ", o2), Promise.resolve([]);
      }
  };
  getEntityById = async (e3, t3, n2) => {
    if (this.isBrowser) {
      let o2 = this.localStorage.getEntity(e3, t3, n2);
      if (o2)
        return o2;
      {
        let p2 = await this.requestEntity(e3, t3, n2);
        return this.localStorage.addIdMappings(p2), p2;
      }
    } else
      return await this.requestEntity(e3, t3, n2);
  };
  splitForRequestAndExisting = (e3) => {
    let t3 = {}, n2 = {};
    return Object.keys(e3).forEach((o2) => {
      t3[o2] = e3[o2].filter((p2) => !p2.exists).map((p2) => p2.id), n2[o2] = e3[o2].filter((p2) => p2.exists).map((p2) => p2.id);
    }), { existing: n2, request: t3 };
  };
  requestEntity = async (e3, t3, n2) => {
    try {
      return e3 = Array.isArray(e3) ? e3 : [e3], await this.https.getEntitiesByIds(t3, e3, n2);
    } catch (o2) {
      return console.warn(`There was a problem retrieving the requested entity: ${o2}`), null;
    }
  };
};
var wa = (s4) => {
  switch (s4) {
    case "competitions":
      return "competition";
    case "players":
    case "relatedPlayer":
    case "squad":
      return "player";
    case "teams":
    case "participants":
    case "homeTeam":
    case "awayTeam":
    case "timeline":
    case "teamId":
      return "team";
    default:
      return s4;
  }
};
var va = class {
  extractedObjIds = {};
  traverse = (e3, t3) => (t3 = wa(t3), Array.isArray(e3) ? this.traverseArrExtract(e3, t3) : e3 && typeof e3 == "object" && this.traverseObjExtract(e3, t3), this.extractedObjIds);
  traverseArrExtract = (e3, t3) => {
    e3 && e3.length > 0 && e3.forEach((n2) => {
      this.traverseObjExtract(n2, t3);
    });
  };
  traverseObjExtract = (e3, t3) => {
    e3 && Object.keys(e3).length > 0 && Object.keys(e3).forEach((n2) => {
      let o2 = e3[n2];
      n2 === "id" || n2 === "teamId" ? (this.extractedObjIds.hasOwnProperty(t3) || (this.extractedObjIds[t3] = []), o2 && this.extractedObjIds[t3].push(o2)) : e3[n2] && this.traverse(e3[n2], n2);
    });
  };
};
var _a = class {
  replaceObjIdsIndex = null;
  remappedIdsObj = {};
  traverse = (e3, t3, n2) => (t3 = wa(t3), this.replaceObjIdsIndex === null && (this.initReplaceObjIdsIndex(n2), this.remappedIdsObj = n2), Array.isArray(e3) ? this.traverseArrReplace(e3, t3) : e3 && typeof e3 == "object" && this.traverseObjReplace(e3, t3), e3);
  initReplaceObjIdsIndex = (e3) => {
    this.replaceObjIdsIndex = {}, Object.keys(e3).forEach((t3) => {
      this.replaceObjIdsIndex[t3] = 0;
    });
  };
  traverseArrReplace = (e3, t3) => {
    e3 && e3.length > 0 && e3.forEach((n2) => {
      this.traverseObjReplace(n2, t3);
    });
  };
  traverseObjReplace = (e3, t3) => {
    e3 && Object.keys(e3).length > 0 && Object.keys(e3).forEach((n2) => {
      n2 === "id" || n2 === "teamId" ? e3[n2] && (e3[n2] = this.remappedIdsObj[t3][this.replaceObjIdsIndex[t3]], this.replaceObjIdsIndex[t3] = this.replaceObjIdsIndex[t3] + 1) : e3[n2] && this.traverse(e3[n2], n2, this.remappedIdsObj);
    });
  };
};
var ae = class {
  idSchema = "";
  idMappingFacade = null;
  constructor(e3) {
    this.idSchema = e3.idSchema, this.idMappingFacade = new ba(e3);
  }
  getEntityIdBySchemaId = (e3, t3) => this.idMappingFacade.getEntityById(e3, t3, this.idSchema);
  remapEntities = async (e3, t3) => {
    let n2 = JSON.parse(JSON.stringify(e3));
    try {
      if (this.idSchema !== "native") {
        let p2 = new va().traverse(n2, t3);
        return this.idMappingFacade.getEntitiesByIds(p2, "native", this.idSchema).then((d4) => new _a().traverse(n2, t3, d4));
      } else
        return e3;
    } catch (o2) {
      return console.warn(`There was a problem remapping entity: ${t3} with inner entity `, o2), [];
    }
  };
  getEntityIdsBySchemaId = async (e3, t3, n2) => {
    let o2 = {};
    return o2[t3] = e3, this.idSchema !== "native" ? await this.idMappingFacade.getEntitiesByIds(o2, this.idSchema, n2) : o2;
  };
};
var qe = class {
  completed = false;
  percentage;
  constructor(e3) {
    this.percentage = e3;
  }
};
var Ia = class {
  teamFollowed = new qe(10);
  teamFavourite = new qe(15);
  playerFollowed = new qe(10);
  playerFavourite = new qe(10);
  competitionFollowed = new qe(10);
  competitionFavourite = new qe(5);
  addedBirthdate = new qe(10);
  addedGender = new qe(10);
  addedCountry = new qe(10);
  addedAvatar = new qe(10);
};
var Pa = class {
  totalPercentage;
  breakdown = new Ia();
};
var Xr = class {
  limit = 0;
  startAfter = null;
  constructor(e3) {
    this.limit = e3.limit ? e3.limit : 20, this.startAfter = e3.startAfter ? e3.startAfter : null;
  }
  constructFilterUrl = () => {
    let e3 = "";
    return this.limit && (e3 = e3 + "&", e3 = e3 + `limit=${this.limit}`), this.startAfter && (e3 = e3 + "&", e3 = e3 + `start_after=${this.startAfter}`), e3;
  };
};
var Mt = class {
  isBrowser = false;
  localStorage = {};
  profileHttps = null;
  activityHttps = null;
  constructor(e3, t3, n2) {
    this.isBrowser = typeof window != "undefined", this.localStorage = e3, this.profileHttps = t3, this.activityHttps = n2;
  }
  getOwn = async () => {
    if (this.isBrowser) {
      let e3 = this.getLocalStorageData("profile");
      if (e3)
        return JSON.parse(JSON.stringify(e3));
      try {
        let t3 = await this.profileHttps.getProfile();
        return this.localStorage.setOwnProfile(t3), t3;
      } catch (t3) {
        throw console.warn("There was a problem retrieving your profile: ", t3), t3;
      }
    } else
      try {
        return await this.profileHttps.getProfile();
      } catch (e3) {
        throw console.warn("There was a problem retrieving your profile: ", e3), e3;
      }
  };
  updateOwnProfile = async () => {
    try {
      let e3 = await this.profileHttps.getProfile();
      return this.localStorage.setOwnProfile(e3), e3;
    } catch (e3) {
      throw console.warn("There was a problem retrieving your profile: ", e3), e3;
    }
  };
  getByIds = async (e3, t3) => {
    try {
      return t3 = t3 || false, await this.profileHttps.getProfiles(e3, t3);
    } catch (n2) {
      throw console.warn(`There was a problem retrieving the selected profiles: ${e3.join(",")} `, n2), n2;
    }
  };
  getById = async (e3) => {
    try {
      return await this.profileHttps.getProfile(e3);
    } catch (t3) {
      throw console.warn(`There was a problem retrieving the selected profile: ${e3} `, t3), t3;
    }
  };
  getCountries = async (e3) => {
    if (e3 = e3 || false, this.isBrowser) {
      let t3 = this.localStorage.getProfileCountries();
      if (t3 && t3.length > 0)
        return t3;
      try {
        let n2 = await this.profileHttps.getCountries(e3);
        return this.localStorage.setProfileCountries(n2), n2;
      } catch (n2) {
        throw console.warn("There was a problem retrieving profile countries: ", n2), n2;
      }
    } else
      try {
        return await this.profileHttps.getCountries(e3);
      } catch (t3) {
        throw console.warn("There was a problem retrieving profile countries: ", t3), t3;
      }
  };
  getFollowers = async (e3, t3) => {
    try {
      e3 && (e3 = new Xr(e3));
      let n2 = await this.profileHttps.getFollowers(e3, t3), o2 = n2.data.map((p2) => p2.followerId);
      if (o2.length) {
        let p2 = await this.getByIds(o2), d4 = n2.data.map((h4) => (p2.forEach((y4) => {
          h4.followerId === y4.id && (h4.name = y4.name, h4.nickname = y4.nickname, h4.avatar = y4.avatar);
        }), h4));
        return n2.data = d4, n2;
      }
      return n2;
    } catch (n2) {
      throw console.warn("There was a problem retrieving your followers: ", n2), n2;
    }
  };
  getFollowing = async (e3, t3) => {
    try {
      e3 && (e3 = new Xr(e3));
      let n2 = await this.profileHttps.getFollowing(e3, t3), o2 = n2.data.map((p2) => p2.followingId);
      if (o2.length) {
        let p2 = await this.getByIds(o2), d4 = n2.data.map((h4) => (p2.forEach((y4) => {
          h4.followingId === y4.id && (h4.name = y4.name, h4.nickname = y4.nickname, h4.avatar = y4.avatar);
        }), h4));
        return n2.data = d4, n2;
      }
      return n2;
    } catch (n2) {
      throw console.warn("There was a problem retrieving your following profiles: ", n2), n2;
    }
  };
  follow = async (e3) => {
    try {
      return await this.profileHttps.follow(e3);
    } catch (t3) {
      throw console.warn(`There was a problem following profiles: ${e3.join(",")} `, t3), t3;
    }
  };
  unfollow = async (e3) => {
    try {
      return await this.profileHttps.unfollow(e3);
    } catch (t3) {
      throw console.warn(`There was a problem unfollowing profiles: ${e3.join(",")} `, t3), t3;
    }
  };
  showFullnessProfile = (e3) => {
    let t3 = new Pa(), n2 = 0;
    return e3.avatar && (t3.breakdown.addedAvatar.completed = true, n2 += t3.breakdown.addedAvatar.percentage), e3.birthDate && (t3.breakdown.addedBirthdate.completed = true, n2 += t3.breakdown.addedBirthdate.percentage), e3.country && (t3.breakdown.addedCountry.completed = true, n2 += t3.breakdown.addedCountry.percentage), e3.gender && (t3.breakdown.addedGender.completed = true, n2 += t3.breakdown.addedGender.percentage), e3.interests && e3.interests.length > 0 && (e3.interests.find((w3) => w3.type === "team" && w3.favourite) && (t3.breakdown.teamFavourite.completed = true, n2 += t3.breakdown.teamFavourite.percentage), e3.interests.find((w3) => w3.type === "team") && (t3.breakdown.teamFollowed.completed = true, n2 += t3.breakdown.teamFollowed.percentage), e3.interests.find((w3) => w3.type === "player" && w3.favourite) && (t3.breakdown.playerFavourite.completed = true, n2 += t3.breakdown.playerFavourite.percentage), e3.interests.find((w3) => w3.type === "player") && (t3.breakdown.playerFollowed.completed = true, n2 += t3.breakdown.playerFollowed.percentage), e3.interests.find((w3) => w3.type === "competition" && w3.favourite) && (t3.breakdown.competitionFavourite.completed = true, n2 += t3.breakdown.competitionFavourite.percentage), e3.interests.find((w3) => w3.type === "competition") && (t3.breakdown.competitionFollowed.completed = true, n2 += t3.breakdown.competitionFollowed.percentage)), t3.totalPercentage = n2, t3;
  };
  getStats = async () => {
    if (this.isBrowser) {
      let e3 = this.getLocalStorageData("statistics");
      if (e3 && Object.keys(e3).length)
        return JSON.parse(JSON.stringify(e3));
      try {
        let t3 = await this.activityHttps.getStats();
        return this.localStorage.setProfileStats(t3), t3;
      } catch (t3) {
        throw console.warn("There was a problem retrieving own profile statistics: ", t3), t3;
      }
    } else
      try {
        return await this.activityHttps.getStats();
      } catch (e3) {
        throw console.warn("There was a problem retrieving own profile statistics: ", e3), e3;
      }
  };
  getBadges = async () => {
    if (this.isBrowser) {
      let e3 = this.getLocalStorageData("badges");
      if (e3)
        return e3;
      try {
        let t3 = await this.profileHttps.getBadges();
        return this.localStorage.setProfileBadges(t3), t3;
      } catch (t3) {
        throw console.warn("There was a problem retrieving own profile badges: ", t3), t3;
      }
    } else
      try {
        return await this.profileHttps.getBadges();
      } catch (e3) {
        throw console.warn("There was a problem retrieving own profile badges: ", e3), e3;
      }
  };
  getLocalStorageData = (e3) => {
    let t3 = Math.floor(Date.now() / 1e3), n2 = this.localStorage.getExpiration(e3);
    switch (e3) {
      case "profile":
        if (n2 > t3)
          return this.localStorage.getOwnProfile();
      case "statistics":
        if (n2 > t3)
          return this.localStorage.getProfileStats();
      case "badges":
        if (n2 > t3)
          return this.localStorage.getProfileBadges();
      default:
        return null;
    }
  };
};
var Ra = class {
  id = null;
  name = null;
  assets = null;
};
var Fa = class {
  extractUpdatedProps = (e3, t3) => {
    let n2 = ["name", "nickname", "gender"], o2 = {};
    return Object.keys(e3).forEach((p2) => {
      if (n2.includes(p2) && e3[p2] !== t3[p2])
        o2[p2] = t3[p2];
      else if (p2 === "birthDate")
        (t3[p2] === null || e3[p2] === null && t3[p2] || e3[p2] !== t3[p2]) && (o2.birth_date = t3[p2]);
      else if (p2 === "country")
        t3[p2] === null ? o2.country_id = t3[p2] : (e3[p2] === null && t3[p2] || e3[p2].id !== t3[p2].id) && (o2.country_id = t3[p2].id);
      else if (p2 === "interests") {
        let d4 = e3[p2], h4 = t3[p2];
        h4.length && this.isNewInterest(d4, h4) ? o2[p2] = this.updateInterests(d4, h4) : (!h4.length && d4.length || d4.length !== h4.length && !this.isNewInterest(d4, h4)) && (o2[p2] = h4);
      }
    }), o2;
  };
  updateInterests = (e3, t3) => {
    if (e3.length === t3.length) {
      let [n2, o2] = this.extractSameAndNewInterests(e3, t3);
      return [...o2, ...n2];
    } else
      return t3;
  };
  isNewInterest = (e3, t3) => {
    let n2 = false, [o2] = this.extractSameAndNewInterests(e3, t3);
    return o2.length && (n2 = true), n2;
  };
  extractSameAndNewInterests = (e3, t3) => {
    let n2 = t3.filter((p2) => e3.some((d4) => p2.id === d4.id && p2.type === d4.type && p2.source === d4.source && p2.favourite === d4.favourite));
    return [t3.filter((p2) => !e3.some((d4) => p2.id === d4.id && p2.type === d4.type && p2.source === d4.source && p2.favourite === d4.favourite)), n2];
  };
};
var Sa = class {
  idsRemapper = null;
  profileHttps = null;
  profileService = null;
  localStorage = null;
  profileFacade = null;
  ownProfile = null;
  modified = false;
  expireAt = 0;
  promises = [];
  isFetching = false;
  constructor(e3, t3, n2, o2, p2, d4) {
    this.idsRemapper = e3, this.localStorage = t3, this.profileHttps = n2, this.profileService = new Fa(), this.profileFacade = new Mt(t3, n2, o2);
  }
  getOwnProfile = async () => {
    for (; this.isFetching; )
      console.log("Another thread is fetching profile..."), await this.delay(100);
    if (this.modified && this.ownProfile)
      return console.log("Timestamp is less than 10 minutes OR profile is modifying "), this.ownProfile;
    let e3 = Math.floor(Date.now() / 1e3);
    if (!this.ownProfile || this.expireAt < e3) {
      this.isFetching = true, this.expireAt = Math.floor(Date.now() / 1e3) + 600;
      try {
        let t3 = await this.profileFacade.getOwn();
        this.setOwnProfile(t3);
      } catch (t3) {
        throw this.isFetching = false, t3;
      }
      return this.modified = false, this.isFetching = false, this.ownProfile;
    }
    return this.ownProfile;
  };
  delay = (e3) => new Promise((t3) => {
    setTimeout(t3, e3);
  });
  setOwnProfile = (e3) => {
    this.ownProfile = e3;
  };
  getInfo = async () => {
    let e3 = await this.getOwnProfile(), t3 = JSON.parse(JSON.stringify(e3));
    return delete t3.interests, t3;
  };
  showInterests = async () => {
    let e3 = await this.getOwnProfile(), t3 = JSON.parse(JSON.stringify(e3));
    return await this.idsRemapper.remapInterests(t3.interests);
  };
  showFullInterests = async () => {
    let e3 = await this.getOwnProfile(), t3 = JSON.parse(JSON.stringify(e3));
    return await this.idsRemapper.showFullInterests(t3.interests);
  };
  getFollowers = async (e3) => await this.profileFacade.getFollowers(e3);
  getFollowing = async (e3) => await this.profileFacade.getFollowing(e3);
  follow = async (e3) => {
    let t3 = await this.profileFacade.follow(e3), n2 = await this.profileFacade.updateOwnProfile();
    return this.setOwnProfile(n2), t3;
  };
  unfollow = async (e3) => {
    let t3 = await this.profileFacade.unfollow(e3), n2 = await this.profileFacade.updateOwnProfile();
    return this.setOwnProfile(n2), t3;
  };
  getStats = async () => {
    let e3 = await this.profileFacade.getStats();
    return await this.idsRemapper.remapSuccessRatesEntities(e3);
  };
  getBadges = async () => await this.profileFacade.getBadges();
  addInterestPromise = async (e3) => {
    this.modified = true, await this.getOwnProfile();
    let t3 = null;
    e3.source !== "custom" ? t3 = await this.idsRemapper.remapInterestToNative(e3) : t3 = e3;
    let n2 = this.ownProfile.interests.filter((o2) => o2.id !== t3.id || o2.type !== t3.type || o2.source !== t3.source);
    return this.ownProfile.interests = [...n2], this.ownProfile.interests.push(t3), this;
  };
  addInterest = (e3) => (this.promises.push(this.addInterestPromise(e3)), this);
  removeInterestPromise = async (e3) => {
    this.modified = true, await this.getOwnProfile();
    let t3 = null;
    return e3.source !== "custom" ? t3 = await this.idsRemapper.remapInterestToNative(e3) : t3 = e3, this.ownProfile.interests = this.ownProfile.interests.filter((n2) => n2.id !== t3.id || n2.type !== t3.type || n2.source !== t3.source), this;
  };
  removeInterest = (e3) => (this.promises.push(this.removeInterestPromise(e3)), this);
  setBirthdatePromise = async (e3) => (this.modified = true, await this.getOwnProfile(), e3 ? this.ownProfile.birthDate = e3 : this.ownProfile.birthDate = null, this);
  setBirthdate = (e3) => (this.promises.push(this.setBirthdatePromise(e3)), this);
  setGenderPromise = async (e3) => (this.modified = true, await this.getOwnProfile(), e3 === "male" || e3 === "female" ? this.ownProfile.gender = e3 : this.ownProfile.gender = "unspecified", this);
  setGender = (e3) => (this.promises.push(this.setGenderPromise(e3)), this);
  setNicknamePromise = async (e3) => (this.modified = true, await this.getOwnProfile(), this.ownProfile.nickname = e3, this);
  setNickname = (e3) => (this.promises.push(this.setNicknamePromise(e3)), this);
  setNamePromise = async (e3) => (this.modified = true, await this.getOwnProfile(), this.ownProfile.name = e3, this);
  setName = (e3) => (this.promises.push(this.setNamePromise(e3)), this);
  setCountryPromise = async (e3) => (this.modified = true, await this.getOwnProfile(), e3 && !this.ownProfile.country ? (this.ownProfile.country = new Ra(), this.ownProfile.country.id = e3) : e3 && this.ownProfile.country ? this.ownProfile.country.id = e3 : this.ownProfile.country = null, this);
  setCountry = (e3) => (this.promises.push(this.setCountryPromise(e3)), this);
  showFullnessProfile = async () => {
    let e3 = await this.getOwnProfile(), t3 = JSON.parse(JSON.stringify(e3));
    return this.profileFacade.showFullnessProfile(t3);
  };
  update = async () => {
    if (this.promises.length === 0)
      return this.ownProfile;
    await Promise.all(this.promises);
    let e3 = await this.profileFacade.getOwn(), t3 = await this.getOwnProfile(), n2 = this.profileService.extractUpdatedProps(e3, t3);
    if (this.modified = false, this.expireAt = 0, Object.keys(n2).length) {
      let p2 = await this.profileHttps.updateProfile(n2), d4 = JSON.parse(JSON.stringify(p2));
      return this.setOwnProfile(d4), this.localStorage.setOwnProfile(d4), delete p2.interests, p2;
    }
    let o2 = JSON.parse(JSON.stringify(this.ownProfile));
    return delete o2.interests, o2;
  };
};
var Ta = class {
  idsRemapper = null;
  profileHttps = null;
  activityHttps = null;
  profileFacade = null;
  profileId = "";
  constructor(e3, t3, n2, o2) {
    this.idsRemapper = e3, this.profileHttps = n2, this.activityHttps = o2, this.profileFacade = new Mt(t3, n2, o2);
  }
  setId = (e3) => (this.profileId = e3, this);
  getProfile = async () => await this.profileFacade.getById(this.profileId);
  getInfo = async () => {
    let e3 = await this.getProfile();
    return delete e3.interests, e3;
  };
  showInterests = async () => {
    let e3 = await this.getProfile(), t3 = JSON.parse(JSON.stringify(e3));
    return await this.idsRemapper.remapInterests(t3.interests);
  };
  showFullInterests = async () => {
    let e3 = await this.getProfile(), t3 = JSON.parse(JSON.stringify(e3));
    return await this.idsRemapper.showFullInterests(t3.interests);
  };
  getFollowers = async (e3) => await this.profileFacade.getFollowers(e3, this.profileId);
  getFollowing = async (e3) => await this.profileFacade.getFollowing(e3, this.profileId);
  showFullnessProfile = async () => {
    let e3 = await this.getProfile();
    return this.profileFacade.showFullnessProfile(e3);
  };
  getStats = async (e3) => {
    let t3 = await this.activityHttps.getStats(this.profileId, e3);
    return await this.idsRemapper.remapSuccessRatesEntities(t3);
  };
  getBadges = async () => await this.profileHttps.getBadges(this.profileId);
};
var Ea = class {
  isBrowser = false;
  localStorage = {};
  https = null;
  idMapping = null;
  constructor(e3, t3, n2) {
    this.isBrowser = typeof window != "undefined", this.localStorage = e3, this.idMapping = n2, this.https = t3;
  }
  getCountriesWithIdMapping = async (e3) => {
    try {
      let t3 = await this.getCountries(e3);
      return this.idMapping.remapEntities(t3, "country");
    } catch (t3) {
      throw console.warn("There was a problem browsing countries as football entities", t3), t3;
    }
  };
  getCountries = async (e3) => {
    if (e3 = e3 || false, this.isBrowser) {
      let t3 = this.localStorage.getFootballCountries();
      if (t3 && t3.length > 0)
        return t3;
      try {
        let n2 = await this.https.getCountries(e3);
        return this.localStorage.setFootballCountries(n2), n2;
      } catch (n2) {
        throw console.warn("There was a problem retrieving countries as football entities", n2), n2;
      }
    } else
      return this.https.getCountries(e3);
  };
};
var Yr = class {
  countryId = null;
  name = null;
  gender = null;
  type = null;
  sortField = null;
  sortOrder = null;
  competitionIds = null;
  constructor(e3) {
    this.countryId = e3.countryId ? `${e3.countryId}` : null, this.name = e3.name ? e3.name : null, this.gender = e3.gender ? e3.gender : null, this.type = e3.type ? e3.type : null, this.sortField = e3.sortField ? `${e3.sortField}` : null, this.sortOrder = e3.sortOrder ? `${e3.sortOrder}` : null, this.competitionIds = e3.competitionIds ? e3.competitionIds : null;
  }
  constructFilterUrl = () => {
    let e3 = "";
    return this.countryId && (e3 = e3 + "&", e3 = e3 + `country_id=${this.countryId}`), this.gender && (e3 = e3 + "&", e3 = e3 + `gender=${this.gender}`), this.type && (e3 = e3 + "&", e3 = e3 + `type=${this.type}`), this.sortField && (e3 = e3 + "&", e3 = e3 + `sort_field=${this.sortField}`), this.sortOrder && (e3 = e3 + "&", e3 = e3 + `sort_order=${this.sortOrder}`), this.name && (e3 = e3 + "&", e3 = e3 + `name=${this.name}`), this.competitionIds && (e3 = e3 + "&", e3 = e3 + `competition_ids=${this.competitionIds.join(",")}`), e3;
  };
  competitionSearchFilter = (e3) => {
    try {
      let t3 = this.filter(e3);
      return this.sortField || this.sortOrder ? this.sort(t3) : t3;
    } catch (t3) {
      return console.warn("There was a problem filtering the local competitions", t3), [];
    }
  };
  filter = (e3) => {
    let t3 = this.entitiesToSearchWith();
    return e3.filter((n2) => {
      let o2 = true;
      return t3.forEach((p2) => {
        p2 !== "sortOrder" && p2 !== "sortField" && (p2 === "countryId" ? o2 && (o2 = n2.country.id === this[p2]) : p2 === "name" ? o2 && (o2 = n2.name.toLocaleLowerCase().includes(this[p2].toLocaleLowerCase())) : p2 === "competitionIds" ? o2 && (o2 = this[p2].some((d4) => n2.id === d4)) : o2 && (o2 = n2[p2].toLocaleLowerCase() === this[p2].toLocaleLowerCase()));
      }), o2;
    });
  };
  entitiesToSearchWith = () => {
    let e3 = [];
    return this.countryId && e3.push("countryId"), this.name && e3.push("name"), this.gender && e3.push("gender"), this.type && e3.push("type"), this.sortField && e3.push("sortField"), this.sortOrder && e3.push("sortOrder"), this.competitionIds && e3.push("competitionIds"), e3;
  };
  sort = (e3) => {
    let t3 = [];
    return this.sortField === "name" ? t3 = e3.sort((n2, o2) => this.sortOrder && this.sortOrder === "desc" ? o2.name.localeCompare(n2.name) : n2.name.localeCompare(o2.name)) : this.sortField === "country" ? t3 = e3.sort((n2, o2) => this.sortOrder && this.sortOrder === "desc" ? o2.country.name.localeCompare(n2.country.name) : n2.country.name.localeCompare(o2.country.name)) : this.sortField === "scope" ? e3.forEach((n2) => t3[this.competitionIds.indexOf(n2.id)] = n2) : !this.sortField && this.sortOrder === "desc" && (t3 = e3.sort((n2, o2) => o2.id.localeCompare(n2.id))), t3;
  };
};
var Ca = class {
  isBrowser = false;
  localStorage = {};
  https = null;
  idMapping = null;
  constructor(e3, t3, n2) {
    this.isBrowser = typeof window != "undefined", this.localStorage = e3, this.idMapping = n2, this.https = t3;
  }
  getCompetitionsIdMapping = async (e3, t3) => {
    try {
      let n2 = false;
      if (e3) {
        if (e3 = new Yr(e3), e3.countryId) {
          let p2 = await this.idMapping.getEntityIdsBySchemaId([`${e3.countryId}`], "country", "native");
          p2.country.length === 0 && (n2 = true), e3.countryId = p2.country[0];
        }
        if (e3.competitionIds) {
          let p2 = await this.idMapping.getEntityIdsBySchemaId(e3.competitionIds, "competition", "native");
          p2.competition.length === 0 && (n2 = true), e3.competitionIds = p2.competition;
        }
        if (n2)
          return [];
      }
      let o2 = await this.getCompetitions(e3, t3);
      return await this.idMapping.remapEntities(o2, "competition");
    } catch (n2) {
      throw console.warn("There was a problem browsing all of the competitions", n2), n2;
    }
  };
  getCompetitionsMapWithNativeIds = async (e3) => {
    let t3 = new Map(), n2 = e3.length, o2 = new Yr({ competitionIds: e3, limit: n2 }), p2 = await this.getCompetitions(o2);
    p2.sort((h4, y4) => h4.id.localeCompare(y4.id));
    let d4 = await this.idMapping.remapEntities(p2, "competition");
    return e3.forEach((h4, y4) => t3.set(h4, d4[y4])), t3;
  };
  getCompetitions = async (e3, t3) => {
    let n2 = null;
    if (t3 = t3 || false, this.isBrowser) {
      if (!this.localStorage.getCompetitionsLength()) {
        try {
          n2 = await this.https.getCompetitions();
        } catch (o2) {
          throw console.warn("There was a problem retrieving all competitions", o2), o2;
        }
        this.localStorage.setCompetitions(n2);
      }
      return this.localStorage.getCompetitions(e3);
    } else
      return this.https.getCompetitions(e3, t3);
  };
  getCompetitionByIdIdMapping = async (e3, t3) => {
    try {
      let o2 = (await this.idMapping.getEntityIdsBySchemaId([e3], "competition", "native")).competition[0], p2 = await this.getCompetitionById(o2, t3);
      return await this.idMapping.remapEntities(p2, "competition");
    } catch (n2) {
      throw console.warn(`There was a problem browsing the following competition:${e3}`, n2), n2;
    }
  };
  getCompetitionById = async (e3, t3) => {
    try {
      return t3 = t3 || false, await this.https.getCompetitionById(e3, t3);
    } catch (n2) {
      throw console.warn(`There was a problem retrieving the competition with the following id: ${e3}`, n2), n2;
    }
  };
  getTopCompetitionsIdMapping = async (e3) => {
    try {
      let t3 = await this.getTopCompetitions(e3);
      return await this.idMapping.remapEntities(t3, "competition");
    } catch (t3) {
      throw console.warn("There was a problem browsing the top competitions", t3), t3;
    }
  };
  getTopCompetitions = async (e3) => {
    try {
      return e3 = e3 || false, await this.https.getTopCompetitions(e3);
    } catch (t3) {
      throw console.warn("There was a problem retrieving the top competitions", t3), t3;
    }
  };
};
var Qr = class {
  name = null;
  countryId = null;
  national = false;
  gender = null;
  limit = null;
  page = null;
  scope = null;
  sortField = null;
  sortOrder = null;
  teamIds = null;
  constructor(e3) {
    this.name = e3.name ? e3.name : null, this.countryId = e3.countryId ? `${e3.countryId}` : null, this.national = e3.national ? e3.national : false, this.gender = e3.gender ? e3.gender : null, this.limit = e3.limit ? e3.limit : null, this.page = e3.page ? e3.page : null, this.scope = e3.scope ? e3.scope : null, this.sortField = e3.sortField ? `${e3.sortField}` : null, this.sortOrder = e3.sortOrder ? `${e3.sortOrder}` : null, this.teamIds = e3.teamIds ? e3.teamIds : null;
  }
  constructFilterUrl = () => {
    let e3 = "";
    return this.name && (e3 = e3 + "&", e3 = e3 + `name=${this.name}`), this.countryId && (e3 = e3 + "&", e3 = e3 + `country_id=${this.countryId}`), this.national && (e3 = e3 + "&", e3 = e3 + `national=${this.national}`), this.gender && (e3 = e3 + "&", e3 = e3 + `gender=${this.gender}`), this.limit && (e3 = e3 + "&", e3 = e3 + `limit=${this.limit}`), this.scope && (e3 = e3 + "&", e3 = e3 + `scope=${this.scope.join(",")}`), this.page && (e3 = e3 + "&", e3 = e3 + `page=${this.page}`), this.sortField && (e3 = e3 + "&", e3 = e3 + `sort_field=${this.sortField}`), this.sortOrder && (e3 = e3 + "&", e3 = e3 + `sort_order=${this.sortOrder}`), this.teamIds && (e3 = e3 + "&", e3 = e3 + `team_ids=${this.teamIds.join(",")}`), e3;
  };
};
var Aa = class {
  general = [];
  predictor = [];
  topX = [];
  matchQuiz = [];
};
var Hi = class {
  points = null;
  gameParticipationCount = null;
  entityId = null;
  entityType = null;
  predictionsMade = null;
  correctPredictions = null;
};
var xa = class {
  id;
  enabled;
  requirements = new Hi();
};
var Oa = class {
  id;
  weight;
  multiplier;
  conditions;
};
var Ba = class {
  value = [new Oa()];
};
var ki = class {
  points = null;
  tiers = null;
  badges = null;
};
var La = class {
  enabled = false;
  conditions = { list: null };
  actions = new Ba();
  rewards = new ki();
};
var Na = class {
  general = null;
  comments = null;
  predictor = null;
  activity = null;
  topX = null;
  matchQuiz = null;
};
var Gi = class {
  enabled = false;
  defaultMarkets = null;
  competitionsWhitelist = null;
};
var $i = class {
  enabled = false;
  minFixtures = null;
  maxFixtures = null;
  competitionsWhitelist = null;
};
var Da = class {
  competitions = [];
  teams = [];
  markets = [];
};
var Vi = class {
  enabled = false;
  fullCoverageCompetitions = null;
  markets = null;
  successRateScopes = new Da();
};
var Ua = class {
  remapPredictorConfig = (e3) => {
    let t3 = new Vi();
    return t3.enabled = e3.enabled, t3.fullCoverageCompetitions = e3.full_coverage_competitions, t3.markets = e3.markets, t3.successRateScopes = e3.success_rate_scopes, t3;
  };
  remapTopXConfig = (e3) => {
    let t3 = new $i();
    return t3.enabled = e3.enabled, t3.minFixtures = e3.min_fixtures, t3.maxFixtures = e3.max_fixtures, t3.competitionsWhitelist = e3.competitions_whitelist, t3;
  };
  remapMatchQuizConfig = (e3) => {
    let t3 = new Gi();
    return t3.enabled = e3.enabled, t3.defaultMarkets = e3.default_markets, t3.competitionsWhitelist = e3.competitions_whitelist, t3;
  };
  remapLoyaltyConfig = (e3) => {
    let t3 = new La();
    return t3.enabled = e3.enabled, t3.conditions.list = e3.conditions.list, t3.actions.value = e3.actions.value, t3.rewards = this.remapRewards(e3.rewards), t3;
  };
  remapRewards = (e3) => {
    let t3 = new ki();
    return t3.points = this.remapPoints(e3.points), t3.tiers = e3.tiers, t3.badges = this.remapBadges(e3.badges), t3;
  };
  remapPoints = (e3) => {
    let t3 = new Na();
    return t3.general = e3.general, t3.comments = e3.comments, t3.predictor = e3.predictor, t3.activity = e3.activity, t3.topX = e3.top_x, t3.matchQuiz = e3.match_quiz, t3;
  };
  remapBadges = (e3) => {
    let t3 = new Aa();
    return t3.general = e3.general, t3.predictor = this.remapBadgeValues(e3.predictor), t3.topX = this.remapBadgeValues(e3.top_x), t3.matchQuiz = this.remapBadgeValues(e3.match_quiz), t3;
  };
  remapBadgeValues = (e3) => e3.map((t3) => {
    let n2 = new xa();
    return n2.id = t3.id, n2.enabled = t3.enabled, n2.requirements = this.remapRequirements(t3.requirements), n2;
  });
  remapRequirements = (e3) => {
    let t3 = new Hi();
    return t3.points = e3.points, t3.gameParticipationCount = e3.game_participation_count, t3.entityId = e3.entity_id, t3.entityType = e3.entity_type, t3.predictionsMade = e3.predictions_made, t3.correctPredictions = e3.correct_predictions, t3;
  };
};
var et = class extends Me {
  apiSignInUrl = "";
  featureConfigRemapper = null;
  constructor(e3) {
    super(e3, Oe(e3.environment, "client"));
    this.apiSignInUrl = `/clients/${e3.clientId}/features?key=${e3.apiKey}`, this.featureConfigRemapper = new Ua();
  }
  getConfig = async (e3) => {
    try {
      let t3 = await this.instance.get(`${this.apiSignInUrl}`);
      switch (e3) {
        case "predictor":
          return this.featureConfigRemapper.remapPredictorConfig(t3.data.data.predictor);
        case "topX":
          return this.featureConfigRemapper.remapTopXConfig(t3.data.data.top_x);
        case "matchQuiz":
          return this.featureConfigRemapper.remapMatchQuizConfig(t3.data.data.match_quiz);
        case "loyalty":
          return this.featureConfigRemapper.remapLoyaltyConfig(t3.data.data.loyalty);
      }
    } catch (t3) {
      throw console.warn("There was a problem fetching configuration from Client API", t3), t3.response;
    }
  };
};
var Yt = class {
  clientHttps = null;
  constructor(e3) {
    this.clientHttps = new et(e3);
  }
  setAvailableMarketsForMatch = async (e3) => {
    let { fullCoverageCompetitions: t3, markets: n2 } = await this.clientHttps.getConfig("predictor");
    if (Array.isArray(e3))
      return e3.map((o2) => this.setAvailableMarkets(o2, t3, n2));
    if (typeof e3 == "object" && Object.keys(e3).length)
      return this.setAvailableMarkets(e3, t3, n2);
  };
  setAvailableMarkets = (e3, t3, n2) => {
    var _a2;
    let o2 = (_a2 = e3.context.competition) == null ? void 0 : _a2.id;
    return o2 && this.isMatchInCoverageCompetition(o2, t3) ? (e3.availableMarkets = n2.all, e3) : (e3.availableMarkets = n2.main, e3);
  };
  isMatchInCoverageCompetition = (e3, t3) => {
    let n2 = false;
    return t3.includes(e3) && (n2 = true), n2;
  };
};
var ka = class {
  footballService = null;
  https = null;
  idMapping = null;
  constructor(e3, t3, n2) {
    this.idMapping = n2, this.https = t3, this.footballService = new Yt(e3);
  }
  getTeamsIdMapping = async (e3, t3) => {
    try {
      let n2 = false;
      if (e3) {
        if (e3 = new Qr(e3), e3.countryId) {
          let p2 = await this.idMapping.getEntityIdsBySchemaId([`${e3.countryId}`], "country", "native");
          p2.country.length === 0 && (n2 = true), e3.countryId = p2.country[0];
        }
        if (e3.scope) {
          let p2 = await this.idMapping.getEntityIdsBySchemaId(e3.scope, "competition", "native");
          p2.competition.length === 0 && (n2 = true), e3.scope = p2.competition;
        }
        if (e3.teamIds) {
          let p2 = await this.idMapping.getEntityIdsBySchemaId(e3.teamIds, "team", "native");
          p2.team.length === 0 && (n2 = true), e3.teamIds = p2.team;
        }
      }
      if (n2)
        return [];
      let o2 = await this.getTeams(e3, t3);
      return o2.data = await this.idMapping.remapEntities(o2.data, "team"), o2;
    } catch (n2) {
      throw console.warn("There was a problem browsing all teams", n2), n2;
    }
  };
  getTeamsMapWithNativeIds = async (e3) => {
    let t3 = new Map(), n2 = e3.length, o2 = new Qr({ teamIds: e3, limit: n2 }), { data: p2 } = await this.getTeams(o2);
    p2.sort((h4, y4) => h4.id.localeCompare(y4.id));
    let d4 = await this.idMapping.remapEntities(p2, "team");
    return e3.forEach((h4, y4) => t3.set(h4, d4[y4])), t3;
  };
  getTeams = async (e3, t3) => {
    try {
      return t3 = t3 || false, await this.https.getTeams(e3, t3);
    } catch (n2) {
      throw console.warn("There was a problem retrieving all teams", n2), n2;
    }
  };
  getTeamByIdIdMapping = async (e3, t3) => {
    try {
      e3 = (await this.idMapping.getEntityIdsBySchemaId([e3], "team", "native")).team[0];
      let o2 = await this.getTeamById(e3, t3);
      return await this.idMapping.remapEntities(o2, "team");
    } catch (n2) {
      throw console.warn(`There was a problem browsing the following team:${e3}`, n2), n2;
    }
  };
  getTeamById = async (e3, t3) => {
    try {
      return t3 = t3 || false, await this.https.getTeamById(e3, t3);
    } catch (n2) {
      throw console.warn(`There was a problem retrieving the following team: ${e3}`, n2), n2;
    }
  };
  getTopTeamsIdMapping = async (e3) => {
    try {
      let t3 = await this.getTopTeams(e3);
      return await this.idMapping.remapEntities(t3, "team");
    } catch (t3) {
      throw console.warn("There was a problem browsing the top teams", t3), t3;
    }
  };
  getTopTeams = async (e3) => {
    try {
      return e3 = e3 || false, await this.https.getTopTeams(e3);
    } catch (t3) {
      throw console.warn("There was a problem retrieving the top teams", t3), t3;
    }
  };
  getNextMatchForTeamIdMapping = async (e3, t3) => {
    try {
      e3 = (await this.idMapping.getEntityIdsBySchemaId([e3], "team", "native")).team[0];
      let o2 = await this.getNextMatchForTeam(e3, t3);
      return await this.idMapping.remapEntities(o2, "match");
    } catch (n2) {
      throw console.warn(`There was a problem browsing the next match for the following team:${e3}`, n2), n2;
    }
  };
  getNextMatchForTeam = async (e3, t3) => {
    try {
      t3 = t3 || false;
      let n2 = await this.https.getNextMatchForTeam(e3, t3);
      return await this.footballService.setAvailableMarketsForMatch(n2);
    } catch (n2) {
      throw console.warn(`There was a problem retrieving the next match for the following team: ${e3}`, n2), n2;
    }
  };
  getPrevMatchForTeamIdMapping = async (e3, t3) => {
    try {
      e3 = (await this.idMapping.getEntityIdsBySchemaId([e3], "team", "native")).team[0];
      let o2 = await this.getPrevMatchForTeam(e3, t3);
      return await this.idMapping.remapEntities(o2, "match");
    } catch (n2) {
      throw console.warn(`There was a problem browsing the previous match for the following team:${e3}`, n2), n2;
    }
  };
  getPrevMatchForTeam = async (e3, t3) => {
    try {
      t3 = t3 || false;
      let n2 = await this.https.getPrevMatchForTeam(e3, t3);
      return await this.footballService.setAvailableMarketsForMatch(n2);
    } catch (n2) {
      throw console.warn(`There was a problem retrieving the previous match for the following team: ${e3}`, n2), n2;
    }
  };
};
var zr = class {
  countryId = null;
  scope = null;
  name = null;
  playerIds = null;
  limit = null;
  page = null;
  sortField = null;
  sortOrder = null;
  constructor(e3) {
    this.countryId = e3.countryId ? e3.countryId : null, this.scope = e3.scope ? e3.scope : null, this.name = e3.name ? e3.name : null, this.playerIds = e3.playerIds ? e3.playerIds : null, this.limit = e3.limit ? e3.limit : null, this.page = e3.page ? e3.page : null, this.sortField = e3.sortField ? e3.sortField : null, this.sortOrder = e3.sortOrder ? e3.sortOrder : null;
  }
  constructFilterUrl = () => {
    let e3 = "";
    return this.countryId && (e3 = e3 + "&", e3 = e3 + `country_id=${this.countryId}`), this.scope && (e3 = e3 + "&", e3 = e3 + `scope=${this.scope.join(",")}`), this.name && (e3 = e3 + "&", e3 = e3 + `name=${this.name}`), this.playerIds && (e3 = e3 + "&", e3 = e3 + `player_ids=${this.playerIds.join(",")}`), this.limit && (e3 = e3 + "&", e3 = e3 + `limit=${this.limit}`), this.page && (e3 = e3 + "&", e3 = e3 + `page=${this.page}`), this.sortField && (e3 = e3 + "&", e3 = e3 + `sort_field=${this.sortField}`), this.sortOrder && (e3 = e3 + "&", e3 = e3 + `sort_order=${this.sortOrder}`), e3;
  };
};
var Qt = class {
  https = null;
  footballService = null;
  idMapping = null;
  constructor(e3, t3, n2) {
    this.idMapping = n2, this.https = t3, this.footballService = new Yt(e3);
  }
  getPlayersIdMapping = async (e3, t3) => {
    try {
      let n2 = false;
      if (e3) {
        if (e3 = new zr(e3), e3.countryId) {
          let p2 = await this.idMapping.getEntityIdsBySchemaId([e3.countryId], "country", "native");
          p2.country.length === 0 && (n2 = true), e3.countryId = p2.country[0];
        }
        if (e3.playerIds) {
          let p2 = await this.idMapping.getEntityIdsBySchemaId(e3.playerIds, "player", "native");
          p2.player.length === 0 && (n2 = true), e3.playerIds = p2.player;
        }
        if (e3.scope) {
          let p2 = await this.idMapping.getEntityIdsBySchemaId(e3.scope, "competition", "native");
          p2.competition.length === 0 && (n2 = true), e3.scope = p2.competition;
        }
        if (n2)
          return [];
      }
      let o2 = await this.getPlayers(e3, t3);
      return o2.data = await this.idMapping.remapEntities(o2.data, "player"), o2;
    } catch (n2) {
      throw console.warn("There was a problem browsing the players", n2), n2;
    }
  };
  getPlayersWithNativeIds = async (e3) => {
    let t3 = e3.length, n2 = new zr({ playerIds: e3, limit: t3 }), o2 = await this.getPlayers(n2);
    return o2.data.sort((p2, d4) => p2.id.localeCompare(d4.id)), await this.idMapping.remapEntities(o2.data, "player");
  };
  getPlayersMapWithNativeIds = async (e3) => {
    let t3 = {}, n2 = Xt(e3);
    n2.sort((p2, d4) => p2.localeCompare(d4));
    let o2 = await this.getPlayersWithNativeIds(n2);
    return n2.forEach((p2, d4) => t3[p2] = o2[d4]), t3;
  };
  getPlayers = async (e3, t3) => {
    try {
      return t3 = t3 || false, await this.https.getPlayers(e3, t3);
    } catch (n2) {
      throw console.warn("There was a problem retrieving the players", n2), n2;
    }
  };
  getPlayerIdMapping = async (e3, t3) => {
    try {
      let n2 = await this.idMapping.getEntityIdsBySchemaId([e3], "player", "native"), o2 = await this.getPlayerById(n2.player[0], t3);
      return await this.idMapping.remapEntities(o2, "player");
    } catch (n2) {
      throw console.warn(`There was a problem browsing the following player:${e3}`, n2), n2;
    }
  };
  getPlayerById = async (e3, t3) => {
    try {
      return t3 = t3 || false, await this.https.getPlayerById(e3, t3);
    } catch (n2) {
      throw console.warn(`There was a problem retrieving the following player: ${e3}`, n2), n2;
    }
  };
  getTopPlayersIdMapping = async (e3) => {
    try {
      let t3 = await this.getTopPlayers(e3);
      return await this.idMapping.remapEntities(t3, "player");
    } catch (t3) {
      throw console.warn("There was a problem browsing the top players", t3), t3;
    }
  };
  getTopPlayers = async (e3) => {
    try {
      return e3 = e3 || false, await this.https.getTopPlayers(e3);
    } catch (t3) {
      throw console.warn("There was a problem retrieving the top players", t3), t3;
    }
  };
  getNextMatchForPlayerIdMapping = async (e3, t3) => {
    try {
      e3 = (await this.idMapping.getEntityIdsBySchemaId([e3], "player", "native")).player[0];
      let o2 = await this.getNextMatchForPlayer(e3, t3);
      return await this.idMapping.remapEntities(o2, "match");
    } catch (n2) {
      throw console.warn(`There was a problem browsing the next match for player:${e3}`, n2), n2;
    }
  };
  getNextMatchForPlayer = async (e3, t3) => {
    try {
      t3 = t3 || false;
      let n2 = await this.https.getNextMatchForPlayer(e3, t3);
      return await this.footballService.setAvailableMarketsForMatch(n2);
    } catch (n2) {
      throw console.warn(`There was a problem retrieving the next match for player: ${e3}`, n2), n2;
    }
  };
  getPrevMatchForPlayerIdMapping = async (e3, t3) => {
    try {
      e3 = (await this.idMapping.getEntityIdsBySchemaId([e3], "player", "native")).player[0];
      let o2 = await this.getPrevMatchForPlayer(e3, t3);
      return await this.idMapping.remapEntities(o2, "match");
    } catch (n2) {
      throw console.warn(`There was a problem browsing the previous match for player:${e3}`, n2), n2;
    }
  };
  getPrevMatchForPlayer = async (e3, t3) => {
    try {
      t3 = t3 || false;
      let n2 = await this.https.getPrevMatchForPlayer(e3, t3);
      return await this.footballService.setAvailableMarketsForMatch(n2);
    } catch (n2) {
      throw console.warn(`There was a problem retrieving the previous match for player: ${e3}`, n2), n2;
    }
  };
};
var Jr = class {
  countryIds = null;
  competitionIds = null;
  matchIds = null;
  status = null;
  teamIds = null;
  fromDate = null;
  toDate = null;
  limit = null;
  page = null;
  sortField = null;
  sortOrder = null;
  constructor(e3) {
    this.countryIds = e3.countryIds ? e3.countryIds : null, this.competitionIds = e3.competitionIds ? e3.competitionIds : null, this.matchIds = e3.matchIds ? e3.matchIds : null, this.status = e3.status ? e3.status : null, this.teamIds = e3.teamIds ? e3.teamIds : null, this.fromDate = e3.fromDate ? e3.fromDate : null, this.toDate = e3.toDate ? e3.toDate : null, this.limit = e3.limit ? e3.limit : null, this.page = e3.page ? e3.page : null, this.sortField = e3.sortField ? e3.sortField : null, this.sortOrder = e3.sortOrder ? e3.sortOrder : null;
  }
  constructFilterUrl = () => {
    let e3 = "";
    return this.countryIds && (e3 = e3 + "&", e3 = e3 + `countries=${this.countryIds.join(",")}`), this.competitionIds && (e3 = e3 + "&", e3 = e3 + `competitions=${this.competitionIds.join(",")}`), this.matchIds && (e3 = e3 + "&", e3 = e3 + `matches=${this.matchIds.join(",")}`), this.status && (e3 = e3 + "&", e3 = e3 + `status=${this.status}`), this.teamIds && (e3 = e3 + "&", e3 = e3 + `teams=${this.teamIds.join(",")}`), this.fromDate && (e3 = e3 + "&", e3 = e3 + `from_date=${this.fromDate}`), this.toDate && (e3 = e3 + "&", e3 = e3 + `to_date=${this.toDate}`), this.limit && (e3 = e3 + "&", e3 = e3 + `limit=${this.limit}`), this.page && (e3 = e3 + "&", e3 = e3 + `page=${this.page}`), this.sortField && (e3 = e3 + "&", e3 = e3 + `sort_field=${this.sortField}`), this.sortOrder && (e3 = e3 + "&", e3 = e3 + `sort_order=${this.sortOrder}`), e3;
  };
};
var zt = class {
  https = null;
  idMapping = null;
  footballService = null;
  constructor(e3, t3, n2) {
    this.https = t3, this.idMapping = n2, this.footballService = new Yt(e3);
  }
  getMatchesIdMapping = async (e3, t3) => {
    try {
      if (e3) {
        if (e3 = new Jr(e3), e3.countryIds) {
          let o2 = await this.idMapping.getEntityIdsBySchemaId(e3.countryIds, "country", "native");
          e3.countryIds = o2.country;
        }
        if (e3.competitionIds) {
          let o2 = await this.idMapping.getEntityIdsBySchemaId(e3.competitionIds, "competition", "native");
          e3.competitionIds = o2.competition;
        }
        if (e3.matchIds) {
          let o2 = await this.idMapping.getEntityIdsBySchemaId(e3.matchIds, "match", "native");
          e3.matchIds = o2.match;
        }
        if (e3.teamIds) {
          let o2 = await this.idMapping.getEntityIdsBySchemaId(e3.teamIds, "team", "native");
          e3.teamIds = o2.team;
        }
      }
      let n2 = await this.getMatches(e3, t3);
      return n2.data = await this.footballService.setAvailableMarketsForMatch([...n2.data]), n2.data = await this.idMapping.remapEntities(n2.data, "match"), n2;
    } catch (n2) {
      throw console.warn("There was a problem browsing the matches", n2), n2;
    }
  };
  getMatchesWithNativeIds = async (e3) => {
    let t3 = e3.length, n2 = new Jr({ matchIds: e3, limit: t3 }), o2 = await this.getMatches(n2);
    return o2.data.sort((p2, d4) => p2.id.localeCompare(d4.id)), await this.idMapping.remapEntities(o2.data, "match");
  };
  getMatchesMapWithNativeIds = async (e3) => {
    let t3 = {}, n2 = Xt(e3);
    n2.sort((p2, d4) => p2.localeCompare(d4));
    let o2 = await this.getMatchesWithNativeIds(n2);
    return n2.forEach((p2, d4) => t3[p2] = o2[d4]), t3;
  };
  getMatches = async (e3, t3) => {
    try {
      return t3 = t3 || false, await this.https.getMatches(e3, t3);
    } catch (n2) {
      throw console.warn("There was a problem retrieving the matches", n2), n2;
    }
  };
  getMatchIdMapping = async (e3, t3) => {
    try {
      let n2 = await this.idMapping.getEntityIdsBySchemaId([e3], "match", "native"), o2 = await this.getMatchById(n2.match[0], t3), p2 = await this.footballService.setAvailableMarketsForMatch(o2);
      return await this.idMapping.remapEntities(p2, "match");
    } catch (n2) {
      throw console.warn(`There was a problem browsing the following match: ${e3}`, n2), n2;
    }
  };
  getMatchById = async (e3, t3) => {
    try {
      return t3 = t3 || false, await this.https.getMatchById(e3, t3);
    } catch (n2) {
      throw console.warn(`There was a problem retrieving the following match: ${e3}`, n2), n2;
    }
  };
};
var Ga = class {
  entities = null;
  query = null;
  scope = null;
  constructor(e3) {
    this.entities = e3.entities ? e3.entities : null, this.query = e3.query ? e3.query : null, this.scope = e3.scope ? e3.scope : null;
  }
  constructFilterUrl = () => {
    let e3 = "";
    return this.entities && (e3 = e3 + "&", e3 = e3 + `entities=${this.entities.join(",")}`), this.query && (e3 = e3 + "&", e3 = e3 + `q=${this.query}`), this.scope && (e3 = e3 + "&", e3 = e3 + `scope=${this.scope.join(",")}`), e3;
  };
};
var $a = class {
  https = null;
  idMapping = null;
  constructor(e3, t3) {
    this.https = e3, this.idMapping = t3;
  }
  searchIdMapping = async (e3, t3) => {
    try {
      if (e3 = new Ga(e3), e3.scope) {
        let o2 = await this.idMapping.getEntityIdsBySchemaId(e3.scope, "competition", "native");
        e3.scope = o2.competition;
      }
      let n2 = await this.search(e3, t3);
      if (n2.teams && n2.teams.length > 0) {
        let o2 = await this.idMapping.remapEntities(n2.teams, "team");
        n2.teams = o2;
      }
      if (n2.players && n2.players.length > 0) {
        let o2 = await this.idMapping.remapEntities(n2.players, "player");
        n2.players = o2;
      }
      if (n2.competitions && n2.competitions.length > 0) {
        let o2 = await this.idMapping.remapEntities(n2.competitions, "competition");
        n2.competitions = o2;
      }
      return n2;
    } catch (n2) {
      throw console.warn("There was a problem with browsing the search result", n2), n2;
    }
  };
  search = async (e3, t3) => {
    try {
      return await this.https.search(e3, t3);
    } catch (n2) {
      throw console.warn("There was a problem retrieving the search response", n2), n2;
    }
  };
};
var qi = class {
  countriesFacade = null;
  competitionsFacade = null;
  teamsFacade = null;
  playerFacade = null;
  matchFacade = null;
  searchFacade = null;
  constructor(e3, t3, n2, o2) {
    this.countriesFacade = new Ea(t3, n2, o2), this.competitionsFacade = new Ca(t3, n2, o2), this.teamsFacade = new ka(e3, n2, o2), this.playerFacade = new Qt(e3, n2, o2), this.matchFacade = new zt(e3, n2, o2), this.searchFacade = new $a(n2, o2);
  }
  getCountries = async (e3) => this.countriesFacade.getCountriesWithIdMapping(e3);
  getCompetitions = async (e3, t3) => this.competitionsFacade.getCompetitionsIdMapping(e3, t3);
  getCompetitionById = async (e3, t3) => this.competitionsFacade.getCompetitionByIdIdMapping(e3, t3);
  getTopCompetitions = async (e3) => this.competitionsFacade.getTopCompetitionsIdMapping(e3);
  getCompetitionsMapWithNativeIds = async (e3) => await this.competitionsFacade.getCompetitionsMapWithNativeIds(e3);
  getTeams = async (e3, t3) => this.teamsFacade.getTeamsIdMapping(e3, t3);
  getTeamById = async (e3, t3) => this.teamsFacade.getTeamByIdIdMapping(e3, t3);
  getTopTeams = async (e3) => this.teamsFacade.getTopTeamsIdMapping(e3);
  getNextMatchForTeam = async (e3, t3) => this.teamsFacade.getNextMatchForTeamIdMapping(e3, t3);
  getPrevMatchForTeam = async (e3, t3) => this.teamsFacade.getPrevMatchForTeamIdMapping(e3, t3);
  getTeamsMapWithNativeIds = async (e3) => await this.teamsFacade.getTeamsMapWithNativeIds(e3);
  getPlayers = async (e3, t3) => this.playerFacade.getPlayersIdMapping(e3, t3);
  getPlayerById = async (e3, t3) => this.playerFacade.getPlayerIdMapping(e3, t3);
  getTopPlayers = async (e3) => this.playerFacade.getTopPlayersIdMapping(e3);
  getNextMatchForPlayer = async (e3, t3) => this.playerFacade.getNextMatchForPlayerIdMapping(e3, t3);
  getPrevMatchForPlayer = async (e3, t3) => this.playerFacade.getPrevMatchForPlayerIdMapping(e3, t3);
  getPlayersMapWithNativeIds = async (e3) => this.playerFacade.getPlayersMapWithNativeIds(e3);
  getMatches = async (e3, t3) => this.matchFacade.getMatchesIdMapping(e3, t3);
  getMatchById = async (e3, t3) => this.matchFacade.getMatchIdMapping(e3, t3);
  search = async (e3, t3) => this.searchFacade.searchIdMapping(e3, t3);
};
var Va = class {
  id = "";
  alias = "";
  countryCode = "";
  assets = null;
  name = "";
};
var oe = class {
  countriesFromResponse = (e3) => {
    if (e3)
      return e3.map((t3) => this.countryFromResponse(t3));
  };
  countryFromResponse = (e3) => {
    try {
      if (e3) {
        let t3 = new Va();
        return t3.id = e3.id, t3.alias = e3.alias, t3.assets = e3.assets, t3.countryCode = e3.country_code, t3.name = e3.name, t3;
      }
    } catch (t3) {
      throw t3;
    }
    return null;
  };
};
var qa = class {
  id = "";
  country = null;
  gender = "";
  assets = null;
  type = "";
  name = "";
};
var Ne = class {
  countryRemapper = null;
  constructor() {
    this.countryRemapper = new oe();
  }
  fromResponse(e3) {
    try {
      let t3 = new qa();
      return t3.id = e3.id, t3.country = this.countryRemapper.countryFromResponse(e3.country), t3.gender = e3.gender, t3.assets = e3.assets, t3.type = e3.type, t3.name = e3.name, t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping the competition response", t3), t3;
    }
  }
};
var Ka = class {
  id = "";
  country = null;
  gender = "";
  assets = null;
  type = "";
  name = "";
  participants = [];
};
var Wa = class {
  id = "";
  country = null;
  gender = "";
  assets = null;
  name = "";
  code = "";
  national = false;
  fullName = "";
  shortName = "";
};
var be = class {
  countryRemapper = null;
  constructor() {
    this.countryRemapper = new oe();
  }
  fromResponse(e3) {
    try {
      let t3 = new Wa();
      return t3.id = e3.id, t3.country = this.countryRemapper.countryFromResponse(e3.country), t3.gender = e3.gender, t3.assets = e3.assets, t3.code = e3.code, t3.national = e3.national, t3.fullName = e3.full_name, t3.shortName = e3.short_name, t3.name = e3.name, t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping teams response", t3), t3;
    }
  }
};
var Xa = class {
  countryRemapper = null;
  teamBasicRemapper = null;
  constructor() {
    this.countryRemapper = new oe(), this.teamBasicRemapper = new be();
  }
  fromResponse(e3) {
    try {
      let t3 = new Ka();
      return t3.id = e3.id, t3.country = this.countryRemapper.countryFromResponse(e3.country), t3.gender = e3.gender, t3.assets = e3.assets, t3.type = e3.type, t3.name = e3.name, t3.participants = e3.participants.map((n2) => this.teamBasicRemapper.fromResponse(n2)), t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping the competition response", t3), t3;
    }
  }
};
var Ya = class {
  id = "";
  country = null;
  gender = "";
  assets = null;
  name = "";
  competitions = [];
  code = "";
  national = false;
  fullName = "";
  shortName = "";
  squad = [];
};
var Qa = class {
  id = "";
  startDate = "";
  endDate = "";
  shirtNumber;
  loan = false;
  position = "";
  country = null;
  name = "";
  assets = null;
  birthDate = "";
};
var za = class {
  countryRemapper = null;
  constructor() {
    this.countryRemapper = new oe();
  }
  fromResponse(e3) {
    try {
      let t3 = new Qa();
      return t3.id = e3.id, t3.startDate = e3.start_date, t3.endDate = e3.end_date, t3.shirtNumber = e3.shirt_number, t3.loan = e3.loan, t3.position = e3.position, t3.country = this.countryRemapper.countryFromResponse(e3.country), t3.name = e3.name, t3.assets = e3.assets, t3.birthDate = e3.birth_date, t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping the player from squad", t3), t3;
    }
  }
};
var Ja = class {
  countryRemapper = null;
  competitionRemapper = null;
  playerRemapper = null;
  constructor() {
    this.countryRemapper = new oe(), this.competitionRemapper = new Ne(), this.playerRemapper = new za();
  }
  fromResponse(e3) {
    try {
      let t3 = new Ya();
      return t3.id = e3.id, t3.country = this.countryRemapper.countryFromResponse(e3.country), t3.gender = e3.gender, t3.assets = e3.assets, t3.code = e3.code, t3.national = e3.national, t3.fullName = e3.full_name, t3.shortName = e3.short_name, t3.name = e3.name, t3.competitions = e3.competitions ? e3.competitions.map((n2) => this.competitionRemapper.fromResponse(n2)) : [], t3.squad = e3.squad ? e3.squad.map((n2) => this.playerRemapper.fromResponse(n2)) : [], t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping team response", t3), t3;
    }
  }
};
var Za = class {
  id = "";
  kickoffAt = "";
  finishedAt = "";
  updatedAt = "";
  availableMarkets = null;
  homeTeam = null;
  awayTeam = null;
  lineupsConfirmed = false;
  startedAt = "";
  minute = "";
  scores = null;
  context = { competition: null };
  status = { type: null, subType: null };
};
var ja = class {
  ftScore = null;
  htScore = null;
  aetScore = null;
  aggScore = null;
  penScore = null;
};
var Ki = class {
  fromResponse(e3) {
    try {
      let t3 = new ja();
      return t3.ftScore = this.statEntityFromResponse(e3.ft_score), t3.htScore = this.statEntityFromResponse(e3.ht_score), t3.aetScore = this.statEntityFromResponse(e3.aet_score), t3.aggScore = this.statEntityFromResponse(e3.agg_score), t3.penScore = this.statEntityFromResponse(e3.pen_score), t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping the scores", t3), t3;
    }
  }
  statEntityFromResponse = (e3) => ({ homeGoals: e3.home_goals, awayGoals: e3.away_goals });
};
var eo = class {
  teamRemapper = null;
  competitionRemapper = null;
  scoresRemapper = null;
  constructor() {
    this.teamRemapper = new be(), this.competitionRemapper = new Ne(), this.scoresRemapper = new Ki();
  }
  fromResponse(e3) {
    try {
      let t3 = new Za();
      return t3.id = e3.id, t3.kickoffAt = e3.kickoff_at, t3.finishedAt = e3.finished_at, t3.updatedAt = e3.updated_at, t3.homeTeam = this.teamRemapper.fromResponse(e3.home_team), t3.awayTeam = this.teamRemapper.fromResponse(e3.away_team), t3.lineupsConfirmed = e3.lineups_confirmed, t3.startedAt = e3.started_at, t3.minute = e3.minute, t3.scores = this.scoresRemapper.fromResponse(e3.scores), t3.context = { competition: e3.context.competition ? this.competitionRemapper.fromResponse(e3.context.competition) : null }, t3.status = { type: e3.status.type, subType: e3.status.sub_type }, t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping the match response", t3), t3;
    }
  }
};
var to = class {
  id = "";
  kickoffAt = "";
  finishedAt = "";
  updatedAt = "";
  availableMarkets = null;
  homeTeam = null;
  awayTeam = null;
  lineupsConfirmed = false;
  startedAt = "";
  minute = "";
  scores = null;
  stats = null;
  context = { competition: null };
  timeline = [];
  status = { type: null, subType: null };
  lineups = null;
};
var io = class {
  corners = null;
  cornersFirstHalf = null;
  cornersSecondHalf = null;
  cornersExtraTime = null;
  crosses = null;
  crossesFirstHalf = null;
  crossesSecondHalf = null;
  crossesExtraTime = null;
  offside = null;
  offsideFirstHalf = null;
  offsideSecondHalf = null;
  offsideExtraTime = null;
  shotsOn = null;
  shotsOnFirstHalf = null;
  shotsOnSecondHalf = null;
  shotsOnExtraTime = null;
  throwIn = null;
  throwInFirstHalf = null;
  throwInSecondHalf = null;
  throwInExtraTime = null;
  redCards = null;
  redCardsFirstHalf = null;
  redCardsSecondHalf = null;
  redCardsExtraTime = null;
  shotsOff = null;
  shotsOffFirstHalf = null;
  shotsOffSecondHalf = null;
  shotsOffExtraTime = null;
  goalKicks = null;
  goalKicksFirstHalf = null;
  goalKicksSecondHalf = null;
  goalKicksExtraTime = null;
  possession = null;
  possessionFirstHalf = null;
  possessionSecondHalf = null;
  possessionExtraTime = null;
  treatments = null;
  treatmentsFirstHalf = null;
  treatmentsSecondHalf = null;
  treatmentsExtraTime = null;
  yellowCards = null;
  yellowCardsFirstHalf = null;
  yellowCardsSecondHalf = null;
  yellowCardsExtraTime = null;
  shotsBlocked = null;
  shotsBlockedFirstHalf = null;
  shotsBlockedSecondHalf = null;
  shotsBlockedExtraTime = null;
  substitutions = null;
  substitutionsFirstHalf = null;
  substitutionsSecondHalf = null;
  substitutionsExtraTime = null;
  counterAttacks = null;
  counterAttacksFirstHalf = null;
  counterAttacksSecondHalf = null;
  counterAttacksExtraTime = null;
  foulsCommitted = null;
  foulsCommittedFirstHalf = null;
  foulsCommittedSecondHalf = null;
  foulsCommittedExtraTime = null;
};
var ro = class {
  fromResponse(e3) {
    try {
      let t3 = new io();
      return t3.corners = this.statEntityFromResponse(e3.corners), t3.cornersFirstHalf = this.statEntityFromResponse(e3.corners_1h), t3.cornersSecondHalf = this.statEntityFromResponse(e3.corners_2h), t3.cornersExtraTime = this.statEntityFromResponse(e3.corners_et), t3.crosses = this.statEntityFromResponse(e3.crosses), t3.crossesFirstHalf = this.statEntityFromResponse(e3.crosses_1h), t3.crossesSecondHalf = this.statEntityFromResponse(e3.crosses_2h), t3.crossesExtraTime = this.statEntityFromResponse(e3.crosses_et), t3.offside = this.statEntityFromResponse(e3.offside), t3.offsideFirstHalf = this.statEntityFromResponse(e3.offside_1h), t3.offsideSecondHalf = this.statEntityFromResponse(e3.offside_2h), t3.offsideExtraTime = this.statEntityFromResponse(e3.offside_et), t3.shotsOn = this.statEntityFromResponse(e3.shots_on), t3.shotsOnFirstHalf = this.statEntityFromResponse(e3.shots_on_1h), t3.shotsOnSecondHalf = this.statEntityFromResponse(e3.shots_on_2h), t3.shotsOnExtraTime = this.statEntityFromResponse(e3.shots_on_et), t3.throwIn = this.statEntityFromResponse(e3.throw_in), t3.throwInFirstHalf = this.statEntityFromResponse(e3.throw_in_1h), t3.throwInSecondHalf = this.statEntityFromResponse(e3.throw_in_2h), t3.throwInExtraTime = this.statEntityFromResponse(e3.throw_in_et), t3.redCards = this.statEntityFromResponse(e3.red_cards), t3.redCardsFirstHalf = this.statEntityFromResponse(e3.red_cards_1h), t3.redCardsSecondHalf = this.statEntityFromResponse(e3.red_cards_2h), t3.redCardsExtraTime = this.statEntityFromResponse(e3.red_cards_et), t3.shotsOff = this.statEntityFromResponse(e3.shots_off), t3.shotsOffFirstHalf = this.statEntityFromResponse(e3.shots_off_1h), t3.shotsOffSecondHalf = this.statEntityFromResponse(e3.shots_off_2h), t3.shotsOffExtraTime = this.statEntityFromResponse(e3.shots_off_et), t3.goalKicks = this.statEntityFromResponse(e3.goal_kicks), t3.goalKicksFirstHalf = this.statEntityFromResponse(e3.goal_kicks_1h), t3.goalKicksSecondHalf = this.statEntityFromResponse(e3.goal_kicks_2h), t3.goalKicksExtraTime = this.statEntityFromResponse(e3.goal_kicks_et), t3.possession = this.statEntityFromResponse(e3.possession), t3.possessionFirstHalf = this.statEntityFromResponse(e3.possession_1h), t3.possessionSecondHalf = this.statEntityFromResponse(e3.possession_2h), t3.possessionExtraTime = this.statEntityFromResponse(e3.possession_et), t3.treatments = this.statEntityFromResponse(e3.treatments), t3.treatmentsFirstHalf = this.statEntityFromResponse(e3.treatments_1h), t3.treatmentsSecondHalf = this.statEntityFromResponse(e3.treatments_2h), t3.treatmentsExtraTime = this.statEntityFromResponse(e3.treatments_et), t3.yellowCards = this.statEntityFromResponse(e3.yellow_cards), t3.yellowCardsFirstHalf = this.statEntityFromResponse(e3.yellow_cards_1h), t3.yellowCardsSecondHalf = this.statEntityFromResponse(e3.yellow_cards_2h), t3.yellowCardsExtraTime = this.statEntityFromResponse(e3.yellow_cards_et), t3.shotsBlocked = this.statEntityFromResponse(e3.shots_blocked), t3.shotsBlockedFirstHalf = this.statEntityFromResponse(e3.shots_blocked_1h), t3.shotsBlockedSecondHalf = this.statEntityFromResponse(e3.shots_blocked_2h), t3.shotsBlockedExtraTime = this.statEntityFromResponse(e3.shots_blocked_et), t3.substitutions = this.statEntityFromResponse(e3.substitutions), t3.substitutionsFirstHalf = this.statEntityFromResponse(e3.substitutions_1h), t3.substitutionsSecondHalf = this.statEntityFromResponse(e3.substitutions_2h), t3.substitutionsExtraTime = this.statEntityFromResponse(e3.substitutions_et), t3.counterAttacks = this.statEntityFromResponse(e3.counter_attacks), t3.counterAttacksFirstHalf = this.statEntityFromResponse(e3.counter_attacks_1h), t3.counterAttacksSecondHalf = this.statEntityFromResponse(e3.counter_attacks_2h), t3.counterAttacksExtraTime = this.statEntityFromResponse(e3.counter_attacks_et), t3.foulsCommitted = this.statEntityFromResponse(e3.fouls_committed), t3.foulsCommittedFirstHalf = this.statEntityFromResponse(e3.fouls_committed_1h), t3.foulsCommittedSecondHalf = this.statEntityFromResponse(e3.fouls_committed_2h), t3.foulsCommittedExtraTime = this.statEntityFromResponse(e3.fouls_committed_et), t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping the stats", t3), t3;
    }
  }
  statEntityFromResponse = (e3) => ({ homeTeam: e3 ? e3.home_team : null, awayTeam: e3 ? e3.away_team : null });
};
var Wi = class {
  homeTeam = { players: [] };
  awayTeam = { players: [] };
};
var no = class {
  id = "";
  name = "";
  position = "";
  shirtNumber;
  assets = null;
  type = "";
};
var Xi = class {
  fromResponse(e3) {
    try {
      let t3 = new no();
      return t3.id = e3.id, t3.name = e3.name, t3.position = e3.position, t3.shirtNumber = e3.shirt_number, t3.assets = e3.assets, t3.type = e3.type, t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping the player from timeline", t3), t3;
    }
  }
};
var ao = class {
  playerRemapper = null;
  constructor() {
    this.playerRemapper = new Xi();
  }
  fromResponse(e3) {
    try {
      let t3 = new Wi();
      return t3.homeTeam.players = e3.home_team && e3.home_team.players ? e3.home_team.players.map((n2) => this.playerRemapper.fromResponse(n2)) : [], t3.awayTeam.players = e3.away_team && e3.away_team.players ? e3.away_team.players.map((n2) => this.playerRemapper.fromResponse(n2)) : [], t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping the lineups", t3), t3;
    }
  }
};
var oo = class {
  minute = "";
  type = "";
  teamId = "";
  player = null;
  relatedPlayer = null;
  updatedAt = "";
};
var so = class {
  playerRemapper = null;
  constructor() {
    this.playerRemapper = new Xi();
  }
  fromResponse(e3) {
    try {
      let t3 = new oo();
      return t3.minute = e3.minute, t3.type = e3.type, t3.teamId = e3.team_id, t3.player = this.playerRemapper.fromResponse(e3.player), t3.relatedPlayer = e3.related_player ? this.playerRemapper.fromResponse(e3.related_player) : null, t3.updatedAt = e3.updated_at, t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping timeline", t3), t3;
    }
  }
};
var lo = class {
  teamMapper = null;
  competitionsMapper = null;
  lineupsMapper = null;
  scoresMapper = null;
  statsMapper = null;
  timelineMapper = null;
  constructor() {
    this.teamMapper = new be(), this.competitionsMapper = new Ne(), this.lineupsMapper = new ao(), this.scoresMapper = new Ki(), this.statsMapper = new ro(), this.timelineMapper = new so();
  }
  fromResponse(e3) {
    try {
      let t3 = new to();
      return t3.id = e3.id, t3.kickoffAt = e3.kickoff_at, t3.finishedAt = e3.finished_at, t3.updatedAt = e3.updated_at, t3.homeTeam = e3.home_team ? this.teamMapper.fromResponse(e3.home_team) : null, t3.awayTeam = e3.away_team ? this.teamMapper.fromResponse(e3.away_team) : null, t3.lineupsConfirmed = e3.lineups_confirmed, t3.startedAt = e3.started_at, t3.minute = e3.minute, t3.scores = this.scoresMapper.fromResponse(e3.scores), t3.stats = this.statsMapper.fromResponse(e3.stats), t3.context = { competition: this.competitionsMapper.fromResponse(e3.context.competition) }, t3.timeline = e3.timeline ? e3.timeline.map((n2) => this.timelineMapper.fromResponse(n2)) : [], t3.status = { type: e3.status.type, subType: e3.status.sub_type }, t3.lineups = e3.lineups ? this.lineupsMapper.fromResponse(e3.lineups) : new Wi(), t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping the match response", t3), t3;
    }
  }
};
var po = class {
  id = "";
  country = null;
  birthDate = "";
  firstName = "";
  lastName = "";
  name = "";
  position = "";
  assets = null;
};
var co = class {
  countryRemapper = null;
  constructor() {
    this.countryRemapper = new oe();
  }
  fromResponse(e3) {
    try {
      let t3 = new po();
      return t3.id = e3.id, t3.firstName = e3.first_name ? e3.first_name : null, t3.lastName = e3.last_name ? e3.last_name : null, t3.name = e3.name ? e3.name : null, t3.birthDate = e3.birth_date, t3.country = this.countryRemapper.countryFromResponse(e3.country), t3.assets = e3.assets, t3.position = e3.position, t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping top player response", t3), t3;
    }
  }
};
var uo = class {
  id = "";
  country = null;
  birthDate = "";
  firstName = "";
  lastName = "";
  name = "";
  position = "";
  assets = null;
  teams = [];
};
var Yi = class {
  countryRemapper = null;
  teamRemapper = null;
  constructor() {
    this.countryRemapper = new oe(), this.teamRemapper = new be();
  }
  fromResponse(e3) {
    try {
      let t3 = new uo();
      return t3.id = e3.id, t3.firstName = e3.first_name ? e3.first_name : null, t3.lastName = e3.last_name ? e3.last_name : null, t3.name = e3.name ? e3.name : null, t3.birthDate = e3.birth_date, t3.country = this.countryRemapper.countryFromResponse(e3.country), t3.assets = e3.assets, t3.teams = e3.teams ? e3.teams.map((n2) => this.teamRemapper.fromResponse(n2)) : [], t3.position = e3.position, t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping players response", t3), t3;
    }
  }
};
var mo = class {
  id = "";
  country = null;
  birthDate = "";
  firstName = "";
  lastName = "";
  name = "";
  position = "";
  assets = null;
  competitions = [];
  teams = [];
};
var fo = class {
  countryRemapper = null;
  teamRemapper = null;
  competitionRemapper = null;
  constructor() {
    this.countryRemapper = new oe(), this.teamRemapper = new be(), this.competitionRemapper = new Ne();
  }
  fromResponse(e3) {
    try {
      let t3 = new mo();
      return t3.id = e3.id, t3.firstName = e3.first_name ? e3.first_name : null, t3.lastName = e3.last_name ? e3.last_name : null, t3.name = e3.name ? e3.name : null, t3.birthDate = e3.birth_date, t3.country = this.countryRemapper.countryFromResponse(e3.country), t3.assets = e3.assets, t3.teams = e3.teams ? e3.teams.map((n2) => this.teamRemapper.fromResponse(n2)) : [], t3.position = e3.position, t3.competitions = e3.competitions ? e3.competitions.map((n2) => this.competitionRemapper.fromResponse(n2)) : [], t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping player response", t3), t3;
    }
  }
};
var ho = class {
  teams = null;
  players = null;
  competitions = null;
};
var go = class {
  teamRemapper = null;
  playerRemapper = null;
  competitionremapper = null;
  constructor() {
    this.teamRemapper = new be(), this.playerRemapper = new Yi(), this.competitionremapper = new Ne();
  }
  fromResponse(e3) {
    try {
      let t3 = new ho();
      return t3.teams = e3.teams ? e3.teams.map((n2) => this.teamRemapper.fromResponse(n2)) : [], t3.players = e3.players ? e3.players.map((n2) => this.playerRemapper.fromResponse(n2)) : [], t3.competitions = e3.competitions ? e3.competitions.map((n2) => this.competitionremapper.fromResponse(n2)) : [], t3;
    } catch (t3) {
      throw console.warn("There was a problem remapping search response", t3), t3;
    }
  }
};
var Qi = class {
  currentPage = null;
  itemsPerPage = null;
  totalItems = null;
  numberOfPages = null;
};
var Jt = class {
  pagination = new Qi();
};
var zi = class {
  meta = new Jt();
  data = [];
};
var yo = class {
  remapMetaProp = (e3) => {
    let t3 = new Jt();
    return t3.pagination.currentPage = e3.pagination.current_page, t3.pagination.itemsPerPage = e3.pagination.items_per_page, t3.pagination.totalItems = e3.pagination.total_items, t3.pagination.numberOfPages = e3.pagination.number_of_pages, t3;
  };
};
var bt = class extends Me {
  apiSignInUrl = "";
  clientId = "";
  limitIds = 200;
  countryRemapper = null;
  competitionBasicRemapper = null;
  competitionFullRemapper = null;
  teamBasicRemapper = null;
  teamFullRemapper = null;
  matchBasicRemapper = null;
  matchFullRemapper = null;
  playerBasicRemapper = null;
  playerFullRemapper = null;
  topPlayerRemapper = null;
  searchRemapper = null;
  footballMetaRemapper = null;
  constructor(e3) {
    super(e3, Oe(e3.environment, "football"));
    this.clientId = e3.clientId, this.apiSignInUrl = `?key=${e3.apiKey}&lang=${e3.lang}`, this.countryRemapper = new oe(), this.competitionBasicRemapper = new Ne(), this.competitionFullRemapper = new Xa(), this.teamBasicRemapper = new be(), this.teamFullRemapper = new Ja(), this.matchBasicRemapper = new eo(), this.matchFullRemapper = new lo(), this.playerBasicRemapper = new Yi(), this.playerFullRemapper = new fo(), this.topPlayerRemapper = new co(), this.searchRemapper = new go(), this.footballMetaRemapper = new yo();
  }
  getCountries = async (e3) => {
    try {
      let t3 = `/countries${this.apiSignInUrl}`, n2 = Date.now();
      e3 && (t3 += `&disable_cache=${n2}`);
      let o2 = await this.instance.get(t3);
      return this.countryRemapper.countriesFromResponse(o2.data.data);
    } catch (t3) {
      throw console.warn("There was a problem with the football countries request", t3), t3;
    }
  };
  getCompetitions = async (e3, t3) => {
    try {
      let n2 = {}, o2 = Date.now();
      if (t3 = t3 || false, e3 && e3.competitionIds && e3.competitionIds.length > this.limitIds - 1) {
        let p2 = [], d4 = ea(e3.competitionIds);
        for (let y4 of d4) {
          e3.competitionIds = y4;
          let _2 = `/competitions${this.apiSignInUrl}${e3.constructFilterUrl()}`;
          t3 && (_2 += `&disable_cache=${o2}`), n2 = await this.instance.get(_2), p2.push(n2.data.data.map((w3) => this.competitionBasicRemapper.fromResponse(w3)));
        }
        return Array.prototype.concat.apply([], p2);
      } else {
        let p2 = `/competitions${this.apiSignInUrl}`;
        return e3 && (p2 += `${e3.constructFilterUrl()}`), t3 && (p2 += `&disable_cache=${o2}`), n2 = await this.instance.get(p2), n2.data.data.map((d4) => this.competitionBasicRemapper.fromResponse(d4));
      }
    } catch (n2) {
      throw console.warn("There was a problem with getCompetitions request", n2), n2.response;
    }
  };
  getCompetitionById = async (e3, t3) => {
    try {
      let n2 = `/competitions/${e3}${this.apiSignInUrl}`, o2 = Date.now();
      t3 && (n2 += `&disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.competitionFullRemapper.fromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem with getCompetitionById request", n2), n2.response;
    }
  };
  getTopCompetitions = async (e3) => {
    try {
      let t3 = `/competitions/top${this.apiSignInUrl}&client_id=${this.clientId}`, n2 = Date.now();
      return e3 && (t3 += `&disable_cache=${n2}`), (await this.instance.get(t3)).data.data.map((p2) => this.competitionBasicRemapper.fromResponse(p2));
    } catch (t3) {
      throw console.warn("There was a problem with getTopCompetitions request", t3), t3.response;
    }
  };
  getTeams = async (e3, t3) => {
    try {
      let n2 = {}, o2 = Date.now();
      if (e3 && e3.teamIds && e3.teamIds.length > this.limitIds) {
        let p2 = [], d4 = ea(e3.teamIds);
        for (let y4 of d4) {
          e3.teamIds = y4;
          let _2 = `/teams${this.apiSignInUrl}${e3.constructFilterUrl()}`;
          t3 && (_2 += `disable_cache=${o2}`), n2 = await this.instance.get(_2), p2.push(n2.data.data.map((w3) => this.teamBasicRemapper.fromResponse(w3)));
        }
        return Array.prototype.concat.apply([], p2);
      } else {
        let p2 = new zi(), d4 = `/teams${this.apiSignInUrl}`;
        return e3 && (d4 += `${e3.constructFilterUrl()}`), t3 && (d4 += `&disable_cache=${o2}`), n2 = await this.instance.get(d4), p2.meta = this.footballMetaRemapper.remapMetaProp(n2.data.meta), p2.data = n2.data.data.map((h4) => this.teamBasicRemapper.fromResponse(h4)), p2;
      }
    } catch (n2) {
      throw console.warn("There was a problem with getTeams request", n2), n2.response;
    }
  };
  getTeamById = async (e3, t3) => {
    try {
      let n2 = `/teams/${e3}${this.apiSignInUrl}`, o2 = Date.now();
      t3 && (n2 += `disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.teamFullRemapper.fromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem with getTeamById request", n2), n2.response;
    }
  };
  getTopTeams = async (e3) => {
    try {
      let t3 = `/teams/top${this.apiSignInUrl}&client_id=${this.clientId}`, n2 = Date.now();
      e3 && (t3 += `$disable_cache=${n2}`);
      let o2 = await this.instance.get(t3);
      return o2.data.data ? o2.data.data.map((p2) => this.teamBasicRemapper.fromResponse(p2)) : [];
    } catch (t3) {
      throw console.warn("There was a problem with getTopTeams request", t3), t3.response;
    }
  };
  getNextMatchForTeam = async (e3, t3) => {
    try {
      let n2 = `/teams/${e3}/next-match${this.apiSignInUrl}`, o2 = Date.now();
      t3 && (n2 += `&disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.matchFullRemapper.fromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem with getNextMatchForTeam request", n2), n2.response;
    }
  };
  getPrevMatchForTeam = async (e3, t3) => {
    try {
      let n2 = `/teams/${e3}/previous-match${this.apiSignInUrl}`, o2 = Date.now();
      t3 && (n2 += `disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.matchFullRemapper.fromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem with getPrevMatchForTeam request", n2), n2.response;
    }
  };
  getPlayers = async (e3, t3) => {
    try {
      let n2 = {}, o2 = Date.now();
      if (e3 && e3.playerIds && e3.playerIds.length > this.limitIds - 1) {
        let p2 = [], d4 = ea(e3.playerIds);
        for (let y4 of d4) {
          e3.playerIds = y4;
          let _2 = `/players${this.apiSignInUrl}${e3.constructFilterUrl()}`;
          t3 && (_2 += `&disable_cache=${o2}`), n2 = await this.instance.get(_2), p2.push(n2.data.data.map((w3) => this.teamBasicRemapper.fromResponse(w3)));
        }
        return Array.prototype.concat.apply([], p2);
      } else {
        let p2 = new zi(), d4 = `/players${this.apiSignInUrl}`;
        return e3 && (d4 += `${e3.constructFilterUrl()}`), t3 && (d4 += `&disable_cache=${o2}`), n2 = await this.instance.get(d4), p2.meta = this.footballMetaRemapper.remapMetaProp(n2.data.meta), p2.data = n2.data.data.map((h4) => this.playerBasicRemapper.fromResponse(h4)), p2;
      }
    } catch (n2) {
      throw console.warn("There was a problem with getPlayers request", n2), n2.response;
    }
  };
  getPlayerById = async (e3, t3) => {
    try {
      let n2 = `/players/${e3}${this.apiSignInUrl}`, o2 = Date.now();
      t3 && (n2 += `&disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.playerFullRemapper.fromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem with getPlayerById request", n2), n2.response;
    }
  };
  getTopPlayers = async (e3) => {
    try {
      let t3 = `/players/top${this.apiSignInUrl}&client_id=${this.clientId}`, n2 = Date.now();
      return e3 && (t3 += `&disable_cache=${n2}`), (await this.instance.get(t3)).data.data.map((p2) => this.topPlayerRemapper.fromResponse(p2));
    } catch (t3) {
      throw console.warn("There was a problem with getTopPlayers request", t3), t3.response;
    }
  };
  getNextMatchForPlayer = async (e3, t3) => {
    try {
      let n2 = `/players/${e3}/next-match${this.apiSignInUrl}`, o2 = Date.now();
      t3 && (n2 += `&disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.matchFullRemapper.fromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem with getNextMatchForPlayer request", n2), n2.response;
    }
  };
  getPrevMatchForPlayer = async (e3, t3) => {
    try {
      let n2 = `/players/${e3}/previous-match${this.apiSignInUrl}`, o2 = Date.now();
      t3 && (n2 += `&disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.matchFullRemapper.fromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem with getPrevMatchForPlayer request", n2), n2.response;
    }
  };
  getMatchById = async (e3, t3) => {
    try {
      let n2 = `/matches/${e3}${this.apiSignInUrl}`, o2 = Date.now();
      t3 && (n2 += `&disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.matchFullRemapper.fromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem with getMatchById request", n2), n2.response;
    }
  };
  getMatches = async (e3, t3) => {
    try {
      let n2 = new zi(), o2 = `/matches${this.apiSignInUrl}`, p2 = Date.now();
      e3 && (o2 += `${e3.constructFilterUrl()}`), t3 && (o2 += `&disable_cache=${p2}`);
      let d4 = await this.instance.get(o2);
      return n2.meta = this.footballMetaRemapper.remapMetaProp(d4.data.meta), n2.data = d4.data.data.map((h4) => this.matchBasicRemapper.fromResponse(h4)), n2;
    } catch (n2) {
      throw console.warn("There was a problem with getMatches request", n2), n2.response;
    }
  };
  search = async (e3, t3) => {
    try {
      let n2 = `/search${this.apiSignInUrl}${e3.constructFilterUrl()}`, o2 = Date.now();
      t3 && (n2 += `&disable_cache=${o2}`);
      let p2 = await this.instance.get(n2);
      return this.searchRemapper.fromResponse(p2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem with search request", n2), n2.response;
    }
  };
};
var Pe = ((N2) => (N2.FT_1X2 = "FT_1X2", N2.HT_1X2 = "HT_1X2", N2.BOTH_TEAMS_SCORE = "BOTH_TEAMS_SCORE", N2.DOUBLE_CHANCE = "DOUBLE_CHANCE", N2.HT_FT = "HT_FT", N2.PLAYER_SCORE = "PLAYER_SCORE", N2.PLAYER_YELLOW_CARD = "PLAYER_YELLOW_CARD", N2.PLAYER_RED_CARD = "PLAYER_RED_CARD", N2.RED_CARD_MATCH = "RED_CARD_MATCH", N2.PENALTY_MATCH = "PENALTY_MATCH", N2.PLAYER_SCORE_FIRST_GOAL = "PLAYER_SCORE_FIRST_GOAL", N2.CORNERS_MATCH = "CORNERS_MATCH", N2.CORRECT_SCORE = "CORRECT_SCORE", N2.CORRECT_SCORE_ADVANCED = "CORRECT_SCORE_ADVANCED", N2.CORRECT_SCORE_HT = "CORRECT_SCORE_HT", N2.PLAYER_SCORE_HATTRICK = "PLAYER_SCORE_HATTRICK", N2.PLAYER_SCORE_TWICE = "PLAYER_SCORE_TWICE", N2.OVER_GOALS_0_5 = "OVER_GOALS_0_5", N2.OVER_GOALS_1_5 = "OVER_GOALS_1_5", N2.OVER_GOALS_2_5 = "OVER_GOALS_2_5", N2.OVER_GOALS_3_5 = "OVER_GOALS_3_5", N2.OVER_GOALS_4_5 = "OVER_GOALS_4_5", N2.OVER_GOALS_5_5 = "OVER_GOALS_5_5", N2.OVER_GOALS_6_5 = "OVER_GOALS_6_5", N2.OVER_CORNERS_6_5 = "OVER_CORNERS_6_5", N2.OVER_CORNERS_7_5 = "OVER_CORNERS_7_5", N2.OVER_CORNERS_8_5 = "OVER_CORNERS_8_5", N2.OVER_CORNERS_9_5 = "OVER_CORNERS_9_5", N2.OVER_CORNERS_10_5 = "OVER_CORNERS_10_5", N2.OVER_CORNERS_11_5 = "OVER_CORNERS_11_5", N2.OVER_CORNERS_12_5 = "OVER_CORNERS_12_5", N2.OVER_CORNERS_13_5 = "OVER_CORNERS_13_5", N2))(Pe || {});
var Sd = ["OVER_GOALS_0_5", "OVER_GOALS_1_5", "OVER_GOALS_2_5", "OVER_GOALS_3_5", "OVER_GOALS_4_5", "OVER_GOALS_5_5", "OVER_GOALS_6_5"];
var Td = ["OVER_CORNERS_6_5", "OVER_CORNERS_7_5", "OVER_CORNERS_8_5", "OVER_CORNERS_9_5", "OVER_CORNERS_10_5", "OVER_CORNERS_11_5", "OVER_CORNERS_12_5", "OVER_CORNERS_13_5"];
var wt = ["PLAYER_RED_CARD", "PLAYER_SCORE", "PLAYER_SCORE_FIRST_GOAL", "PLAYER_SCORE_HATTRICK", "PLAYER_SCORE_TWICE", "PLAYER_YELLOW_CARD"];
var Ed = ["FT_1X2", "HT_1X2", "HT_FT", "DOUBLE_CHANCE", "CORNERS_MATCH", "CORRECT_SCORE", "CORRECT_SCORE_HT", "CORRECT_SCORE_ADVANCED"];
var Zr = "PLAYER_SCORE_FIRST_GOAL";
var Mo = class {
  overallPercent;
  byFootballCompetition;
  byFootballTeam;
  byFootballMarket;
};
var bo = class {
  profileId;
  tier;
  points;
  successRates = new Mo();
};
var wo = class {
  successRatePercent;
  model = null;
};
var vo = class {
  id = null;
  label = null;
};
var _o = class {
  type = null;
  id = null;
  label = null;
};
var Ji = class {
  content = new _o();
  tags = [];
  campaign = new vo();
};
var Zi = class {
  id = null;
  profileId = null;
  action = null;
  context = new Ji();
  points = 0;
};
var Io = class {
  totalItems = 0;
};
var Po = class {
  meta = new Io();
  data = [new Zi()];
};
var Ro = class {
  remapSingleResponse = (e3) => {
    var _a2, _b;
    let t3 = new Zi();
    return t3.id = e3.id, t3.profileId = e3.profile_id, t3.action = e3.action, t3.context.content = (_a2 = e3.context.content) != null ? _a2 : t3.context.content, t3.context.tags = e3.context.tags, t3.context.campaign = (_b = e3.context.campaign) != null ? _b : t3.context.campaign, t3.points = e3.points, t3;
  };
  remapActivitiesResponse = (e3) => {
    let t3 = new Po();
    return t3.meta.totalItems = e3.meta.total_items, t3.data = e3.data.map((n2) => this.remapSingleResponse(n2)), t3;
  };
  remapStatsReponse = (e3) => {
    let t3 = new bo();
    return t3.profileId = e3.profile_id, t3.tier = e3.tier, t3.points = e3.points, t3.successRates.overallPercent = e3.success_rates.overall_percent, t3.successRates.byFootballCompetition = this.constructNewRecord(e3.success_rates.by_competition), t3.successRates.byFootballTeam = this.constructNewRecord(e3.success_rates.by_team), t3.successRates.byFootballMarket = this.constructNewRecord(e3.success_rates.by_market), t3;
  };
  constructNewRecord = (e3) => {
    let t3;
    if (Object.entries(e3).length)
      Object.entries(e3).forEach(([n2, o2]) => {
        t3 = __spreadProps(__spreadValues({}, t3), { [n2]: this.remapSuccessRatePercent(o2) }), Pe[n2] && delete t3[n2].model;
      });
    else
      return e3;
    return t3;
  };
  remapSuccessRatePercent = (e3) => {
    let t3 = new wo();
    return t3.successRatePercent = e3.success_rate_percent, t3;
  };
};
var ji = class extends Me {
  activityRemapper = null;
  apiSignInUrl = null;
  constructor(e3) {
    super(e3, Oe(e3.environment, "loyalty"));
    this.apiSignInUrl = `?key=${e3.apiKey}&client_id=${e3.clientId}`, this.activityRemapper = new Ro();
  }
  createActivity = async (e3) => {
    try {
      let t3 = `/activities${this.apiSignInUrl}`, n2 = await this.instanceAuth.post(t3, JSON.stringify(e3));
      return this.activityRemapper.remapSingleResponse(n2.data);
    } catch (t3) {
      throw console.warn("There was a problem with creating activity for user", t3), t3;
    }
  };
  deleteActivity = async (e3) => {
    try {
      let t3 = `/activities/${e3}${this.apiSignInUrl}`;
      return await this.instanceAuth.delete(t3), true;
    } catch (t3) {
      throw console.warn(`There was a problem deleting the following activity: ${e3}`, t3), t3.response;
    }
  };
  getOwnActivities = async (e3, t3) => {
    try {
      let n2 = `/activities${this.apiSignInUrl}`, o2 = Date.now();
      e3 && (n2 += `${e3.constructFilterUrl()}`), t3 && (n2 += `disable_cache=${o2}`);
      let p2 = await this.instanceAuth.get(n2);
      return this.activityRemapper.remapActivitiesResponse(p2.data);
    } catch (n2) {
      throw console.warn("There was a problem with fetching own activities", n2), n2;
    }
  };
  getActivitiesForUser = async (e3, t3, n2) => {
    try {
      let o2 = `/users/${e3}/activities${this.apiSignInUrl}`, p2 = Date.now();
      t3 && (o2 += `${t3.constructFilterUrl()}`), n2 && (o2 += `disable_cache=${p2}`);
      let d4 = await this.instance.get(o2);
      return this.activityRemapper.remapActivitiesResponse(d4.data);
    } catch (o2) {
      throw console.warn(`There was a problem with fetching activities for user ${e3}`, o2), o2;
    }
  };
  getStats = async (e3, t3) => {
    try {
      let n2 = "", o2 = null;
      return e3 ? (n2 += de(t3) ? `/users/${e3}/statistics${this.apiSignInUrl}${fe()}` : `/users/${e3}/statistics${this.apiSignInUrl}`, o2 = await this.instance.get(n2)) : (n2 += `/statistics${this.apiSignInUrl}`, o2 = await this.instanceAuth.get(n2)), this.activityRemapper.remapStatsReponse(o2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem fetching profile`s statistics:", n2), n2.response;
    }
  };
};
var Fo = class {
  idMapping = null;
  idSchema = null;
  native = "native";
  footballFacade = null;
  constructor(e3, t3, n2) {
    this.idMapping = n2, this.idSchema = e3.idSchema, this.footballFacade = t3;
  }
  remapSuccessRatesEntities = async (e3) => {
    let { successRates: t3 } = e3, n2 = { competition: this.getIdsKeys(t3.byFootballCompetition), team: this.getIdsKeys(t3.byFootballTeam) };
    if (Object.values(n2.competition).length) {
      let o2 = e3.successRates.byFootballCompetition;
      e3.successRates.byFootballCompetition = await this.setModels(o2, n2.competition, "competition");
    }
    if (Object.values(n2.team).length) {
      let o2 = e3.successRates.byFootballTeam;
      e3.successRates.byFootballTeam = await this.setModels(o2, n2.team, "team");
    }
    return e3;
  };
  setModels = async (e3, t3, n2) => {
    let o2 = null, p2;
    switch (t3 = Gr(t3), n2) {
      case "competition":
        o2 = await this.footballFacade.getCompetitionsMapWithNativeIds(t3);
        break;
      case "team":
        o2 = await this.footballFacade.getTeamsMapWithNativeIds(t3);
        break;
    }
    return Object.keys(e3).forEach((d4) => {
      let h4 = o2.get(d4);
      p2 = __spreadProps(__spreadValues({}, p2), { [h4.id]: e3[d4] }), p2[h4.id].model = h4;
    }), p2;
  };
  getIdsKeys = (e3) => {
    let t3 = JSON.parse(JSON.stringify(e3));
    return Object.keys(t3);
  };
  remapInterestsToIdSchema = async (e3) => {
    if (this.idSchema !== this.native)
      if (e3 && e3.length > 0) {
        let t3 = {}, n2 = {};
        e3.forEach((d4) => {
          t3.hasOwnProperty(d4.type) || (t3[d4.type] = [], n2[d4.type] = []), t3[d4.type].push(d4.id), n2[d4.type].push(d4);
        });
        let o2 = await this.remapIdsObj(t3, this.native, this.idSchema), p2 = [];
        for (let [d4, h4] of Object.entries(n2))
          h4.forEach((y4, _2) => {
            y4.id = o2[d4][_2], p2.push(y4);
          });
        return p2;
      } else
        return e3;
    return e3;
  };
  remapInterestToNative = async (e3) => {
    if (this.idSchema !== this.native) {
      let t3 = {}, { id: n2, type: o2 } = e3;
      t3[o2] = [n2];
      let p2 = await this.remapIdsObj(t3, this.idSchema, this.native);
      return e3.id = p2[o2][0], e3;
    }
    return e3;
  };
  inquiryCustomInterests = (e3) => {
    let t3 = [];
    return e3 && e3.length > 0 && (t3 = e3.filter((n2) => n2.source.toLocaleUpperCase() === "CUSTOM")), t3;
  };
  remapInterests = async (e3) => {
    let t3 = this.inquiryCustomInterests(e3);
    if (t3 && t3.length > 0) {
      let n2 = e3.filter((p2) => p2.source.toLocaleUpperCase() !== "CUSTOM"), o2 = await this.remapInterestsToIdSchema(n2);
      return t3.forEach((p2) => o2.push(p2)), o2;
    }
    return await this.remapInterestsToIdSchema(e3);
  };
  showFullInterests = async (e3) => {
    let t3 = [];
    if (e3 && e3.length > 0) {
      let n2 = this.inquiryCustomInterests(e3);
      t3.push(n2);
      let o2 = e3.filter((_2) => _2.source.toLocaleUpperCase() !== "CUSTOM"), { competitionsMap: p2, teamsMap: d4, playersMap: h4 } = await this.getInterestsEntitiesMap(o2), y4 = o2.map((_2) => {
        let w3 = null;
        if (_2.type === "competition")
          return w3 = p2.get(_2.id), w3 && (_2.id = w3.id), _2.model = w3, _2;
        if (_2.type === "team")
          return w3 = d4.get(_2.id), w3 && (_2.id = w3.id), _2.model = w3, _2;
        if (_2.type === "player")
          return h4 ? (_2.model = h4[_2.id], _2.id = h4[_2.id].id) : _2.model = w3, _2;
      });
      return t3.push(y4), t3.flat();
    }
    return t3;
  };
  getInterestsEntitiesMap = async (e3) => {
    let t3 = [], n2 = [], o2 = [], p2 = new Map(), d4 = new Map(), h4 = null;
    if (e3.forEach((y4) => {
      y4.type === "competition" ? t3.push(y4.id) : y4.type === "team" ? n2.push(y4.id) : y4.type === "player" && o2.push(y4.id);
    }), t3.length) {
      let y4 = Gr(t3);
      p2 = await this.footballFacade.getCompetitionsMapWithNativeIds(y4);
    }
    if (n2.length) {
      let y4 = Gr(n2);
      d4 = await this.footballFacade.getTeamsMapWithNativeIds(y4);
    }
    if (o2.length) {
      let y4 = Gr(o2);
      h4 = await this.footballFacade.getPlayersMapWithNativeIds(y4);
    }
    return { competitionsMap: p2, teamsMap: d4, playersMap: h4 };
  };
  remapIdsObj = async (e3, t3, n2) => await this.idMapping.idMappingFacade.getEntitiesByIds(e3, t3, n2);
};
var So = class {
  idMapping = null;
  profileOperations = null;
  constructor(e3, t3) {
    this.idMapping = new ae(e3), this.profileOperations = new Fo(e3, t3, this.idMapping);
  }
  remapSuccessRatesEntities = async (e3) => await this.profileOperations.remapSuccessRatesEntities(e3);
  remapInterestToNative = async (e3) => await this.profileOperations.remapInterestToNative(e3);
  remapInterests = async (e3) => await this.profileOperations.remapInterests(e3);
  showFullInterests = async (e3) => await this.profileOperations.showFullInterests(e3);
};
var er = class {
  idsRemapper = null;
  profileHttps = null;
  activityHttps = null;
  footballHttps = null;
  footballFacade = null;
  idMapping = null;
  localStorage = null;
  profileFacade = null;
  ownProfileBuilder = null;
  profileBuilder = null;
  constructor(e3) {
    this.profileHttps = new Ui(e3), this.activityHttps = new ji(e3), this.footballHttps = new bt(e3), this.idMapping = new ae(e3), this.localStorage = new yt(e3), this.footballFacade = new qi(e3, this.localStorage, this.footballHttps, this.idMapping), this.profileFacade = new Mt(this.localStorage, this.profileHttps, this.activityHttps), this.idsRemapper = new So(e3, this.footballFacade), this.ownProfileBuilder = new Sa(this.idsRemapper, this.localStorage, this.profileHttps, this.activityHttps, this.idMapping, this.footballFacade), this.profileBuilder = new Ta(this.idsRemapper, this.localStorage, this.profileHttps, this.activityHttps);
  }
  getOwn = () => this.ownProfileBuilder;
  getById = (e3) => this.profileBuilder.setId(e3);
  getCountries = async (e3) => await this.profileFacade.getCountries(e3);
  getByIds = async (e3, t3) => await this.profileFacade.getByIds(e3, t3);
};
var To = class {
  validate = (e3) => {
    let t3 = this.validateField(e3.lang), n2 = this.generateMessage(t3);
    return { validation: t3, message: n2 };
  };
  validateField = (e3) => {
    let t3 = ["bg", "ro", "en"], n2 = null;
    return e3 != null && e3.length > 0 ? t3.includes(e3) ? n2 = "valid" : n2 = "invalid" : n2 = "missing", n2;
  };
  generateMessage = (e3) => {
    let t3 = null, n2 = "warning";
    return e3 === "missing" && (t3 = "If no lang is passed the default one will be set which is: en"), e3 === "invalid" && (t3 = "This lang value is not supported, the default one will be set which is: en"), e3 === "valid" && (t3 = null, n2 = null), { text: t3, type: n2 };
  };
};
var Eo = class {
  validate(e3) {
    let t3 = this.validateField(e3.environment), n2 = this.generateMessage(t3);
    return { validation: t3, message: n2 };
  }
  validateField = (e3) => {
    let t3 = ["dev", "staging", "prod"], n2 = null;
    return e3 != null && e3.length > 0 ? t3.includes(e3) ? n2 = "valid" : n2 = "invalid" : n2 = "missing", n2;
  };
  generateMessage = (e3) => {
    let t3 = null, n2 = "warning";
    return e3 === "missing" && (t3 = "If no environment is passed the default one will be set which is: prod"), e3 === "invalid" && (t3 = "This environment value is not supported, the default one will be set which is: prod"), e3 === "valid" && (t3 = null, n2 = null), { text: t3, type: n2 };
  };
};
var Co = class {
  validate(e3) {
    let t3 = this.validateField(e3.apiKey), n2 = this.generateMessage(t3);
    return { validation: t3, message: n2 };
  }
  validateField = (e3) => {
    let t3 = null;
    return e3 != null && e3.length > 0 ? t3 = "valid" : t3 = "missing", t3;
  };
  generateMessage = (e3) => {
    let t3 = null, n2 = "error";
    return e3 === "missing" && (t3 = "The field apiKey with valid value must be provided to use Fans United JS SDK"), e3 === "valid" && (n2 = null), { text: t3, type: n2 };
  };
};
var Ao = class {
  validate(e3) {
    let t3 = this.validateField(e3.idSchema), n2 = this.generateMessage(t3);
    return { validation: t3, message: n2 };
  }
  validateField = (e3) => {
    let t3 = ["native", "sportal365", "enetpulse", "sportradar"], n2 = null;
    return e3 != null && e3.length > 0 ? t3.includes(e3) ? n2 = "valid" : n2 = "invalid" : n2 = "missing", n2;
  };
  generateMessage = (e3) => {
    let t3 = null, n2 = "warning";
    return e3 === "missing" && (t3 = "If no idSchema is passed the default one will be set which is: native"), e3 === "invalid" && (t3 = "This idSchema value is not supported, the default one will be set which is: native"), e3 === "valid" && (t3 = null, n2 = null), { text: t3, type: n2 };
  };
};
var fi = class {
  getIdToken = null;
  logout = null;
};
var ir = class {
  text = null;
  type = null;
};
var xo = class {
  validation = null;
  message = new ir();
  getIdToken = { validation: null, message: new ir() };
  logout = { validation: null, message: new ir() };
};
var Oo = class {
  validate(e3) {
    let t3 = this.validateAuthProvider(e3.authProvider);
    return t3.validation !== "missing" && (t3 = this.validateAuthProviderConfigFields(e3.authProvider, t3), t3 = this.generateAuthProviderConfigMessages(t3), t3 = this.checkAuthProviderConfigMessagesForErrors(t3)), t3;
  }
  validateAuthProvider = (e3) => {
    let t3 = Object.keys(new fi()), n2 = new xo();
    if (e3) {
      let p2 = Object.keys(e3).filter((d4) => !t3.includes(d4));
      p2.length > 0 ? (n2.validation = "invalid", n2.message.type = "warning", n2.message.text = `${"You have passed a property which is not supported for the authentication provider:"} ${p2.join(",")}`) : n2.validation = "valid";
    } else
      n2.validation = "missing", n2.message.type = "error", n2.message.text = "The field authProvider must be provided to use this SDK";
    return n2;
  };
  validateAuthProviderConfigFields = (e3, t3) => (Object.keys(new fi()).forEach((o2) => {
    e3[o2] ? t3[o2].validation = "valid" : t3[o2].validation = "missing";
  }), t3);
  generateAuthProviderConfigMessages = (e3) => (Object.keys(e3).filter((t3) => t3 !== "validation" && t3 !== "message").forEach((t3) => {
    let n2 = e3[t3];
    n2.validation === "missing" && (n2.message.text = `${"The following property is missing from the authProvider object:"} ${t3}`, n2.message.type = "error");
  }), e3);
  checkAuthProviderConfigMessagesForErrors = (e3) => (Object.keys(e3).filter((t3) => t3 !== "validation" && t3 !== "message").forEach((t3) => {
    e3[t3].validation === "missing" && e3.validation === "valid" && (e3.validation = "invalid", e3.message.type = "error", e3.message.text = "The field authProvider has missing properties");
  }), e3);
};
var en = class {
  validation;
  message;
};
var Bo = class {
  apiKey = null;
  environment = null;
  idSchema = null;
  clientId = null;
  lang = null;
  authProvider = { getIdToken: new en(), logout: new en() };
  isValid = false;
};
var Lo = class {
  validate(e3) {
    let t3 = this.validateField(e3.clientId), n2 = this.generateMessage(t3);
    return { validation: t3, message: n2 };
  }
  validateField = (e3) => {
    let t3 = null;
    return e3 != null && e3.length > 0 ? t3 = "valid" : t3 = "missing", t3;
  };
  generateMessage = (e3) => {
    let t3 = null, n2 = "error";
    return e3 === "missing" && (t3 = "The field clientId must be provided to use Fans United JS SDK"), e3 === "valid" && (t3 = null, n2 = null), { text: t3, type: n2 };
  };
};
var No = class {
  validate = (e3) => {
    let t3 = this.checkFieldsForValues(e3);
    return t3.isValid = this.containsErrorMessage(t3), t3;
  };
  checkFieldsForValues = (e3) => {
    let t3 = new Bo(), n2 = { apiKey: new Co(), environment: new Eo(), idSchema: new Ao(), clientId: new Lo(), lang: new To(), authProvider: new Oo() };
    for (let [o2, p2] of Object.entries(t3))
      o2 !== "isValid" && (p2 = n2[o2].validate(e3));
    return Object.keys(n2).forEach((o2) => {
      t3[o2] = n2[o2].validate(e3);
    }), t3;
  };
  containsErrorMessage = (e3) => {
    let t3 = true;
    for (let [n2, o2] of Object.entries(e3))
      if (n2 !== "authProvider") {
        if (n2 !== "isValid" && o2.message.type === "error")
          return t3 = false, t3;
        if (n2 !== "isValid" && o2.message.type === "warning")
          return t3 = true, t3;
      } else if (o2.message.type === "error")
        return t3 = false, t3;
    return t3;
  };
};
var Do = class {
  https = null;
  idMapping = null;
  localStorage = null;
  footballFacade = null;
  constructor(e3) {
    this.https = new bt(e3), this.idMapping = new ae(e3), this.localStorage = new yt(e3), this.footballFacade = new qi(e3, this.localStorage, this.https, this.idMapping);
  }
  getCountries = async (e3) => await this.footballFacade.getCountries(e3);
  getCompetitions = async (e3, t3) => await this.footballFacade.getCompetitions(e3, t3);
  getCompetitionById = async (e3, t3) => await this.footballFacade.getCompetitionById(e3, t3);
  getTopCompetitions = async (e3) => await this.footballFacade.getTopCompetitions(e3);
  getTeams = async (e3, t3) => await this.footballFacade.getTeams(e3, t3);
  getTeamById = async (e3, t3) => await this.footballFacade.getTeamById(e3, t3);
  getTopTeams = async (e3) => await this.footballFacade.getTopTeams(e3);
  getNextMatchForTeam = async (e3, t3) => await this.footballFacade.getNextMatchForTeam(e3, t3);
  getPrevMatchForTeam = async (e3, t3) => await this.footballFacade.getPrevMatchForTeam(e3, t3);
  getPlayers = async (e3, t3) => await this.footballFacade.getPlayers(e3, t3);
  getPlayerById = async (e3, t3) => await this.footballFacade.getPlayerById(e3, t3);
  getTopPlayers = async (e3) => await this.footballFacade.getTopPlayers(e3);
  getNextMatchForPlayer = async (e3, t3) => await this.footballFacade.getNextMatchForPlayer(e3, t3);
  getPrevMatchForPlayer = async (e3, t3) => await this.footballFacade.getPrevMatchForPlayer(e3, t3);
  getMatches = async (e3, t3) => await this.footballFacade.getMatches(e3, t3);
  getMatchById = async (e3, t3) => await this.footballFacade.getMatchById(e3, t3);
  search = async (e3, t3) => await this.footballFacade.search(e3, t3);
};
var Uo = class {
  value = null;
  playerId = null;
  playerModel = null;
};
var rr = class {
  market = null;
  matchId = null;
  matchType = null;
  matchModel = null;
  prediction = new Uo();
  result = null;
};
var Ho = class {
  value = false;
  playerId = null;
};
var tt = class {
  matchId = null;
  market = null;
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3, n2, o2) {
    this.matchId = e3, this.market = t3, this.prediction = new Ho(), this.prediction.value = n2, this.prediction.playerId = o2;
  }
};
var nr = class {
  settledAt = null;
  resettledAt = null;
  status = null;
  outcome = null;
  points = 0;
};
var ko = class {
  value = null;
};
var Zt = class {
  matchId = null;
  market = null;
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3, n2) {
    this.matchId = e3, this.market = t3, this.prediction = new ko(), this.prediction.value = n2;
  }
};
var it = class {
  value = false;
};
var ar = class {
  matchId = null;
  market = null;
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3, n2) {
    this.matchId = e3, this.market = t3, this.prediction = new it(), this.prediction.value = n2;
  }
};
var or = class {
  matchId = null;
  market = null;
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3, n2) {
    this.matchId = e3, this.market = t3, this.prediction = new it(), this.prediction.value = n2;
  }
};
var Go = class {
  matchFacade = null;
  playerFacade = null;
  predictorService = null;
  constructor(e3, t3, n2) {
    this.matchFacade = e3, this.playerFacade = t3, this.predictorService = n2;
  }
  remapFixturesRequest = (e3) => {
    let t3 = {};
    if (t3.match_id = e3.matchId, t3.match_type = "FOOTBALL", e3 instanceof tt)
      t3.market = e3.market, t3.prediction = e3.prediction.value, t3.player_id = e3.prediction.playerId;
    else if (e3 instanceof ar || e3 instanceof or)
      t3.market = e3.market, t3.prediction = e3.prediction.value;
    else if (e3 instanceof Zt) {
      t3.market = e3.market;
      let n2 = e3.prediction.value.split(":");
      t3.goals_home = Number(n2[0]), t3.goals_away = Number(n2[1]);
    } else
      t3.market = e3.market, t3.prediction = e3.prediction.value;
    return t3;
  };
  remapFixturesResponse = async (e3) => {
    e3.length > 1 && e3.sort((h4, y4) => h4.match_id.localeCompare(y4.match_id));
    let t3 = [], n2 = [];
    for (let h4 of e3)
      t3.push(h4.match_id), h4.player_id && !n2.includes(h4.player_id) && n2.push(h4.player_id);
    let o2 = await this.matchFacade.getMatchesMapWithNativeIds(t3), p2 = [];
    n2.sort((h4, y4) => h4.localeCompare(y4)), n2 && n2.length > 0 && (p2 = await this.playerFacade.getPlayersMapWithNativeIds(n2));
    let d4 = [];
    for (let h4 of e3) {
      let y4 = new rr();
      h4.target ? y4.market = this.predictorService.convertMarketForResponseModel(h4.market, h4.target) : y4.market = h4.market, y4.matchId = o2[h4.match_id].id, y4.matchType = h4.match_type, y4.matchModel = o2 ? o2[h4.match_id] : null, delete y4.matchModel.availableMarkets, h4.goals_home !== void 0 && h4.goals_away !== void 0 ? y4.prediction.value = h4.goals_home.toString() + ":" + h4.goals_away.toString() : y4.prediction.value = h4.prediction, y4.prediction.playerId = h4.player_id ? h4.player_id : null, y4.prediction.playerId && (y4.prediction.playerModel = p2[h4.player_id], y4.prediction.playerId = p2[h4.player_id].id), y4.result = this.remapResult(h4.result), d4.push(y4);
    }
    return d4;
  };
  remapResult = (e3) => {
    let t3 = new nr();
    return t3.settledAt = e3.settled_at, t3.resettledAt = e3.resettled_at, t3.status = e3.status, t3.outcome = e3.outcome, t3.points = e3.points, t3;
  };
};
var jt = class {
  goldenGoal = null;
};
var tn = class {
  id = null;
  gameInstanceId = null;
  gameType = null;
  wager = null;
  totalFixtures = null;
  settledFixtures = null;
  userId = null;
  fixtures = [];
  status = null;
  tiebreaker = new jt();
  points = null;
  createdAt = null;
  updatedAt = null;
};
var j2 = class {
  no = 0;
  yes = 0;
};
var sr = class {
  fullTimeOneXTwo = {};
  halfTimeOneXTwo = {};
  bothTeamsScore = new j2();
  doubleChance = {};
  halfTimeFullTime = {};
  playerScore = {};
  playerYellowCard = {};
  playerRedCard = {};
  redCardMatch = new j2();
  penaltyMatch = new j2();
  playerScoreFirstGoal = {};
  cornersMatch = {};
  correctScore = {};
  correctScoreHalfTime = {};
  correctScoreAdvanced = {};
  playerScoreHattrick = {};
  playerScoreTwice = {};
  overZeroPointFiveGoals = new j2();
  overOnePointFiveGoals = new j2();
  overTwoPointFiveGoals = new j2();
  overThreePointFiveGoals = new j2();
  overFourPointFiveGoals = new j2();
  overFivePointFiveGoals = new j2();
  overSixPointFiveGoals = new j2();
  overSixPointFiveCorners = new j2();
  overSevenPointFiveCorners = new j2();
  overEightPointFiveCorners = new j2();
  overNinePointFiveCorners = new j2();
  overTenPointFiveCorners = new j2();
  overElevenPointFiveCorners = new j2();
  overTwelvePointFiveCorners = new j2();
  overThirteenPointFiveCorners = new j2();
};
var vt = class {
  timeTiebreaker = false;
};
var hi = class {
  id = null;
  title = null;
  description = null;
  type = null;
  status = null;
  outcome = null;
  predictionsCutoff = null;
  fixtures = [];
  tiebreaker = new vt();
  predictionId = null;
  participantsCount = 0;
  rules = null;
  flags = null;
  points = null;
  createdAt = null;
  updatedAt = null;
  predictionsMadeAt = null;
  scheduleOpenAt = null;
  images = null;
};
var gi = class {
  userId = null;
  points = null;
  results = [];
  tiebreaker = null;
};
var $o = ((p2) => (p2.ACTIVE = "ACTIVE", p2.WON = "WON", p2.LOST = "LOST", p2.PARTIALLY_WON = "PARTIALLY_WON", p2.CANCELED = "CANCELED", p2))($o || {});
var Tp = ["WON", "LOST", "PARTIALLY_WON", "CANCELED"];
var Re = class {
  limit = null;
  startAfter = null;
  status = null;
  type = null;
  matchIds = null;
  constructor(e3) {
    this.limit = e3.limit ? e3.limit : null, this.startAfter = e3.startAfter ? e3.startAfter : null, this.status = e3.status ? e3.status : null, this.type = e3.type ? e3.type : null, this.matchIds = e3.matchIds ? e3.matchIds : null;
  }
  constructFiltersUrl = () => {
    let e3 = "", t3 = false;
    return this.status && (t3 = Object.values($o).some((n2) => this.status.includes(n2))), this.limit && (e3 += "&", e3 += `limit=${this.limit}`), this.startAfter && (e3 += "&", e3 += `start_after=${this.startAfter}`), this.status && t3 && (e3 += "&", e3 += `status=${this.status.join(",")}`), this.type && (e3 += "&", e3 += `game_types=${this.type}`), this.matchIds && (e3 += "&", e3 += `match_ids=${this.matchIds.join(",")}`), e3;
  };
};
var lr = class {
  limit;
  startAfter;
  constructor(e3) {
    this.limit = e3.limit ? e3.limit : null, this.startAfter = e3.startAfter ? e3.startAfter : null;
  }
  constructMainFiltersUrl() {
    let e3 = "";
    return this.limit && (e3 += "&", e3 += `limit=${this.limit}`), this.startAfter && (e3 += "&", e3 += `start_after=${this.startAfter}`), e3;
  }
};
var rn = ((d4) => (d4.OPEN = "OPEN", d4.LIVE = "LIVE", d4.PENDING = "PENDING", d4.CANCELED = "CANCELED", d4.CLOSED = "CLOSED", d4.SETTLED = "SETTLED", d4))(rn || {});
var rt = class extends lr {
  status = null;
  type = null;
  gameIds = null;
  sortOrder = null;
  constructor(e3) {
    super(e3);
    this.status = e3.status ? e3.status : null, this.type = e3.type ? e3.type : null, this.gameIds = e3.gameIds ? e3.gameIds : null, this.sortOrder = e3.sortOrder ? e3.sortOrder : null;
  }
  constructFiltersUrl = () => {
    let e3 = super.constructMainFiltersUrl();
    return this.status && Object.values(rn).includes(this.status) && (e3 += "&", e3 += `status=${this.status}`), this.type && (e3 += "&", e3 += `type=${this.type}`), this.gameIds && this.gameIds.length > 0 && (e3 += "&", e3 += `game_ids=${this.gameIds.join(",")}`), this.sortOrder && (e3 += "&", e3 += `sort_order=${this.sortOrder}`), e3;
  };
};
var pr = class {
  main = null;
  cover = null;
  mobile = null;
};
var yi = class {
  id = null;
  title = null;
  description = null;
  type = null;
  status = null;
  scheduleOpenAt = null;
  predictionsCutoff = null;
  fixtures = [];
  tiebreaker = new vt();
  participantsCount = 0;
  rules = null;
  flags = null;
  images = new pr();
  createdAt = null;
  updatedAt = null;
};
var Nt = class {
  id = null;
  title = null;
  description = null;
  type = null;
  status = null;
  outcome = null;
  predictionsCutoff = null;
  fixtures = [];
  tiebreaker = new vt();
  predictionId = null;
  participantsCount = 0;
  rules = null;
  flags = null;
  points = null;
  createdAt = null;
  updatedAt = null;
  predictionsMadeAt = null;
  images = null;
  scheduleOpenAt = null;
};
var Ep = { UNEXPECTED_STATUS_PROP: `Unexpected provided property 'status'. You can NOT use this property for this method. For more information visit our documentation: 
 ${Rp.PREDICTOR_USER_RELATED_OPERATION}`, UNEXPECTED_TYPE_PROP: `Unexpected provided property 'type'. You can NOT use this property for this method. For more information visit our documentation: 
 ${Rp.PREDICTOR_USER_RELATED_OPERATION}` };
var Cd = (s4, e3) => `The prediction '${s4}' is invalid for market '${e3}'. Please check again have you passed appropriate prediction model. For more information please visit our documentation: https://docs.fansunitedmedia.com/sdks/js/match.quiz#gamerelatedoperations`;
var Vo = (s4) => `The market '${s4}' is not supported from Fans United. For more information please visit our documentation: https://docs.fansunitedmedia.com/docs/predictor-operations#make-football-prediction`;
var Ad = (s4) => `The market '${s4}' is not valid for Top X game. The only available market is CORRECT_SCORE.`;
var xd = (s4) => `The field/s '${s4.length > 1 ? s4.join(", ") : s4[0]}' is/are invalid. For more information please visit our documentation: https://docs.fansunitedmedia.com/docs/javascript-sdk`;
var Od = (s4, e3) => `The following field/s is/are missing from ${s4}: '${e3.length > 1 ? e3.join(", ") : e3[0]}'. For more information please visit our documentation: https://docs.fansunitedmedia.com/docs/predictor-operations#make-football-prediction`;
var Bd = (s4, e3) => `The field ${s4} has incorrect type. The correct type is ${e3}`;
var _t = class {
  footballHttps = null;
  idMapping = null;
  matchFacade = null;
  playerFacade = null;
  constructor(e3, t3) {
    this.footballHttps = new bt(e3), this.idMapping = t3, this.matchFacade = new zt(e3, this.footballHttps, t3), this.playerFacade = new Qt(e3, this.footballHttps, t3);
  }
  remapMatchIdToNative = async (e3) => (await this.idMapping.getEntityIdsBySchemaId(e3, "match", "native")).match;
  remapPlayerIdToNative = async (e3) => (await this.idMapping.getEntityIdsBySchemaId(e3, "player", "native")).player[0];
  remapPlayerIdMapToNative = async (e3) => {
    let t3 = {}, n2 = Xt(e3), p2 = (await this.idMapping.getEntityIdsBySchemaId(n2, "player", "native")).player;
    return n2.forEach((d4, h4) => t3[d4] = p2[h4]), t3;
  };
  remapPlayerIdToIdSchema = async (e3) => {
    let t3 = ["playerScore", "playerYellowCard", "playerRedCard", "playerScoreFirstGoal", "playerScoreHattrick", "playerScoreTwice"];
    for (let [n2, o2] of Object.entries(e3))
      if (t3.includes(n2))
        for (let p2 of Object.keys(o2)) {
          let d4 = { player: [p2] }, y4 = (await this.idMapping.idMappingFacade.getEntitiesByIds(d4, "native", this.idMapping.idSchema)).player[0];
          o2[y4] = o2[p2], delete o2[p2];
        }
    return e3;
  };
  convertMarket = (e3) => {
    let t3 = Object.keys(new sr()), n2 = Object.values(Pe);
    for (let o2 = 0; o2 < n2.length; o2++)
      e3 === n2[o2] && (e3 = t3[o2]);
    return e3;
  };
  convertMarketForResponseModel = (e3, t3) => {
    let n2 = t3.toString();
    return e3 + "_" + n2;
  };
  getMarketSummary = (e3, t3, n2) => {
    let o2 = this.convertMarket(t3), p2 = {};
    if (p2.matchId = e3.matchId, p2.matchType = e3.matchType, Object.keys(e3.predictions).includes(o2))
      p2[o2] = e3.predictions[o2];
    else
      throw new Error("You have passed invalid market");
    return wt.includes(t3) && n2 ? (p2[o2][n2] || (p2[o2][n2] = new j2()), p2[o2][n2]) : p2;
  };
  remapCompetitionsFromConfig = async (e3) => {
    if (e3 instanceof Vi) {
      let t3 = { competition: e3.fullCoverageCompetitions }, n2 = { competition: e3.successRateScopes.competitions }, o2 = { team: e3.successRateScopes.teams }, p2 = await this.idMapping.idMappingFacade.getEntitiesByIds(t3, "native", this.idMapping.idSchema), d4 = await this.idMapping.idMappingFacade.getEntitiesByIds(n2, "native", this.idMapping.idSchema), h4 = await this.idMapping.idMappingFacade.getEntitiesByIds(o2, "native", this.idMapping.idSchema);
      return e3.fullCoverageCompetitions = p2.competition, e3.successRateScopes.competitions = d4.competition, e3.successRateScopes.teams = h4.team, e3;
    }
    if (e3 instanceof $i || e3 instanceof Gi) {
      let t3 = { competition: e3.competitionsWhitelist }, n2 = await this.idMapping.idMappingFacade.getEntitiesByIds(t3, "native", this.idMapping.idSchema);
      return e3.competitionsWhitelist = n2.competition, e3;
    }
  };
  remapMatchIdsFixtures = async (e3) => {
    if (Array.isArray(e3.data))
      if (e3.data.length > 0) {
        let t3 = [], n2 = [];
        return e3.data.forEach((o2) => {
          o2 instanceof yi || o2 instanceof hi || o2 instanceof Nt ? (o2.fixtures.forEach((p2) => t3.push(p2.matchId)), o2 instanceof Nt && o2.fixtures.forEach((p2) => {
            p2.prediction.playerId && n2.push(p2.prediction.playerId);
          })) : o2 instanceof gi && o2.results.forEach((p2) => t3.push(p2.matchId));
        }), await this.refactorResponseArrModel(e3, t3, n2);
      } else
        return e3;
    else
      return await this.refactorResponseObjModel(e3);
  };
  refactorResponseArrModel = async (e3, t3, n2) => {
    let o2 = [], p2 = await this.matchFacade.getMatchesMapWithNativeIds(t3), d4 = {};
    return n2.length > 0 && (d4 = await this.playerFacade.getPlayersMapWithNativeIds(n2)), e3.data.forEach((h4) => {
      h4 instanceof yi || h4 instanceof hi || h4 instanceof Nt ? (h4.fixtures.forEach((y4) => {
        y4.matchModel = p2[y4.matchId], delete y4.matchModel.availableMarkets, y4.matchId = y4.matchModel.id, h4 instanceof Nt && y4.prediction.playerId && (y4.prediction.playerModel = d4[y4.prediction.playerId], y4.prediction.playerId = d4[y4.prediction.playerId].id);
      }), o2.push(h4)) : h4 instanceof gi && (h4.results.forEach((y4) => {
        y4.matchModel = p2[y4.matchId], delete y4.matchModel.availableMarkets, y4.matchId = y4.matchModel.id;
      }), o2.push(h4));
    }), e3.data = o2, e3;
  };
  refactorResponseObjModel = async (e3) => {
    let t3 = [];
    e3.fixtures.forEach((o2) => t3.push(o2.matchId));
    let n2 = await this.matchFacade.getMatchesMapWithNativeIds(t3);
    return e3.fixtures.forEach((o2) => {
      o2.matchModel = n2[o2.matchId], delete o2.matchModel.availableMarkets, o2.matchId = n2[o2.matchId].id;
    }), e3;
  };
  getCurrentGameId = (e3) => {
    let t3 = new Date();
    if (e3.data.length > 1) {
      let n2 = [];
      return e3.data.forEach((p2) => n2.push(p2.predictionsCutoff)), e3.data.sort((p2, d4) => {
        let [h4, y4] = [p2.predictionsCutoff, d4.predictionsCutoff].map((_2) => Math.abs(new Date(_2) - t3));
        return h4 - y4;
      })[0].id;
    } else
      return e3.data[0].id;
  };
  initGameTypePredictions = (e3, t3) => {
    let n2 = { type: e3, limit: null, startAfter: null };
    return t3 && (n2 = __spreadProps(__spreadValues({}, n2), { limit: t3.limit, startAfter: t3.startAfter })), n2 = new Re(n2), n2;
  };
  initGameFilters = (e3, t3, n2) => {
    if (t3 && n2)
      return t3.type = e3, t3.gameIds = n2, t3 = new rt(t3), t3;
    if (t3 && !n2)
      return t3.type = e3, t3 = new rt(t3), t3;
    if (!t3 && n2) {
      let o2 = { type: e3, gameIds: n2 };
      return o2 = new rt(o2), o2;
    } else {
      let o2 = { type: e3 };
      return o2 = new rt(o2), o2;
    }
  };
  addPredictionProp = async (e3, t3) => (t3.data.forEach((n2) => {
    e3.data.forEach((o2) => {
      n2.id === o2.game_instance_id && (n2.predictionId = o2.id, n2.outcome = o2.status, n2.fixtures.forEach((p2, d4) => {
        o2.fixtures[d4].goals_home !== void 0 && o2.fixtures[d4].goals_away !== void 0 ? p2.prediction.value = o2.fixtures[d4].goals_home + ":" + o2.fixtures[d4].goals_away : p2.prediction.value = o2.fixtures[d4].prediction, o2.fixtures[d4].player_id ? p2.prediction.playerId = o2.fixtures[d4].player_id : o2.fixtures[d4].target && (p2.prediction.target = o2.fixtures[d4].target), p2.prediction.result = this.remapResult(o2.fixtures[d4].result);
      }), n2.predictionsMadeAt = o2.created_at, n2.points = o2.points);
    });
  }), t3.meta.pagination.nextPageStartsAfter = e3.meta.pagination.next_page_starts_after, await this.remapMatchIdsFixtures(t3));
  remapResult = (e3) => {
    let t3 = new nr();
    return t3.settledAt = e3.settled_at, t3.resettledAt = e3.resettled_at, t3.status = e3.status, t3.outcome = e3.outcome, t3.points = e3.points, t3;
  };
  areIdsExceeded = (e3) => {
    let t3 = 10;
    return e3.length > t3;
  };
  initPredictionsFilters = (e3, t3, n2) => {
    switch (t3) {
      case "user":
        e3 && (e3 = new Re(e3));
        break;
      case "current":
        if (e3)
          this.deleteUnexpectedProperties(e3), e3.status = ["ACTIVE"], e3 = new Re(e3);
        else {
          let o2 = { status: ["ACTIVE"] };
          e3 = new Re(o2);
        }
        break;
      case "past":
        if (e3)
          this.deleteUnexpectedProperties(e3), e3.status = Tp, e3 = new Re(e3);
        else {
          let o2 = { status: Tp };
          e3 = new Re(o2);
        }
        break;
      case "matches":
        if (e3)
          this.deleteUnexpectedProperties(e3), e3.matchIds = n2, e3 = new Re(e3);
        else {
          let o2 = { matchIds: n2 };
          e3 = new Re(o2);
        }
        break;
    }
    return e3;
  };
  completeGameMarketResults = async (e3, t3) => {
    switch (t3) {
      case "MATCH_QUIZ":
        let n2 = {}, o2 = e3.results[0].matchId, p2 = e3.results.map((_2) => wt.includes(_2.market) ? [..._2.result] : []).flat(), d4 = await this.matchFacade.getMatchesMapWithNativeIds([o2]);
        return p2.length && (n2 = await this.playerFacade.getPlayersMapWithNativeIds(p2)), e3.results = e3.results.map((_2) => {
          if (_2.matchModel = d4[_2.matchId], _2.playerModels && _2.result.forEach((S4) => {
            let q3 = n2[S4];
            _2.playerModels.push(q3);
          }), this.idMapping.idSchema !== "native" && (_2.matchId = d4[_2.matchId].id, _2.playerModels)) {
            let w3 = _2.result;
            _2.result = w3.map((S4) => n2[S4].id);
          }
          return _2;
        }), e3;
      case "TOP_X":
        let h4 = e3.results.map((_2) => _2.matchId), y4 = await this.matchFacade.getMatchesMapWithNativeIds(h4);
        if (e3.results = e3.results.map((_2) => (_2.matchModel = y4[_2.matchId], this.idMapping.idSchema !== "native" && (_2.matchId = y4[_2.matchId].id), _2)), e3.tieBreakers.goldenGoals.length) {
          let _2 = e3.tieBreakers.goldenGoals.map((S4) => S4.playerId), w3 = await this.playerFacade.getPlayersMapWithNativeIds(_2);
          e3.tieBreakers.goldenGoals = e3.tieBreakers.goldenGoals.map((S4) => (S4.matchModel = y4[S4.matchId], S4.playerModel = w3[S4.playerId], this.idMapping.idSchema !== "native" && (S4.matchId = y4[S4.matchId].id, S4.playerId = w3[S4.playerId].id), S4));
        }
        return e3;
    }
  };
  deleteUnexpectedProperties = (e3) => (e3.status && (console.warn(Ep.UNEXPECTED_STATUS_PROP), delete e3.status), e3.type && (console.warn(Ep.UNEXPECTED_TYPE_PROP), delete e3.type), e3);
};
var cr = class {
  gameInstanceId = null;
  fixtures = [];
  tiebreaker = null;
  constructor(e3) {
    this.gameInstanceId = e3.gameInstanceId, e3.fixtures.forEach((t3) => this.fixtures.push(new Zt(t3.matchId, t3.market, t3.prediction.value))), this.tiebreaker = e3.tiebreaker ? e3.tiebreaker : null;
  }
};
var ur = class {
  fixturesRemapper = null;
  footballHttps = null;
  matchFacade = null;
  playerFacade = null;
  predictorService = null;
  constructor(e3, t3) {
    this.footballHttps = new bt(e3), this.matchFacade = new zt(e3, this.footballHttps, t3), this.playerFacade = new Qt(e3, this.footballHttps, t3), this.predictorService = new _t(e3, t3), this.fixturesRemapper = new Go(this.matchFacade, this.playerFacade, this.predictorService);
  }
  remapRequestBody = (e3) => {
    let t3 = {};
    return t3.game_instance_id = e3.gameInstanceId, t3.fixtures = e3.fixtures.map((n2) => this.fixturesRemapper.remapFixturesRequest(n2)), e3 instanceof cr && e3.tiebreaker && (t3.tiebreaker = {}, t3.tiebreaker.golden_goal = e3.tiebreaker.goldenGoal ? e3.tiebreaker.goldenGoal : null), t3;
  };
  remapResponseArrayBody = async (e3) => {
    if (e3.length) {
      let t3 = [], n2 = [], o2 = {}, p2 = [];
      e3.forEach((h4) => {
        h4.fixtures.forEach((y4) => {
          t3.push(y4.match_id), y4.player_id && n2.push(y4.player_id);
        });
      });
      let d4 = await this.matchFacade.getMatchesMapWithNativeIds(t3);
      return n2.length > 0 && (o2 = await this.playerFacade.getPlayersMapWithNativeIds(n2)), e3.forEach((h4) => {
        let y4 = new tn(), _2 = [];
        y4.id = h4.id, y4.gameInstanceId = h4.game_instance_id, y4.gameType = h4.game_type, y4.wager = h4.wager, y4.totalFixtures = h4.total_fixtures, y4.settledFixtures = h4.settled_fixtures, y4.userId = h4.user_id, h4.fixtures.forEach((w3) => {
          let S4 = new rr();
          w3.target ? S4.market = this.predictorService.convertMarketForResponseModel(w3.market, w3.target) : S4.market = w3.market, S4.matchId = d4[w3.match_id].id, S4.matchType = w3.match_type, S4.matchModel = d4[w3.match_id], delete S4.matchModel.availableMarkets, w3.goals_home !== void 0 && w3.goals_away !== void 0 ? S4.prediction.value = w3.goals_home.toString() + ":" + w3.goals_away.toString() : S4.prediction.value = w3.prediction, S4.prediction.playerId = w3.player_id ? w3.player_id : null, S4.prediction.playerId && (S4.prediction.playerModel = o2[S4.prediction.playerId], S4.prediction.playerId = o2[S4.prediction.playerId].id), S4.result = this.fixturesRemapper.remapResult(w3.result), _2.push(S4);
        }), y4.fixtures = _2, y4.status = h4.status, h4.tiebreaker ? y4.tiebreaker.goldenGoal = h4.tiebreaker.golden_goal : y4.tiebreaker = null, y4.points = h4.points, y4.createdAt = h4.created_at, y4.updatedAt = h4.updated_at, p2.push(y4);
      }), p2;
    }
    return e3;
  };
  remapResponseObjBody = async (e3) => {
    let t3 = new tn();
    return t3.id = e3.id, t3.gameInstanceId = e3.game_instance_id, t3.gameType = e3.game_type, t3.wager = e3.wager, t3.totalFixtures = e3.total_fixtures, t3.settledFixtures = e3.settled_fixtures, t3.userId = e3.user_id, t3.fixtures = await this.fixturesRemapper.remapFixturesResponse(e3.fixtures), t3.status = e3.status, e3.tiebreaker ? t3.tiebreaker.goldenGoal = e3.tiebreaker.golden_goal : t3.tiebreaker = null, t3.points = e3.points, t3.createdAt = e3.created_at, t3.updatedAt = e3.updated_at, t3;
  };
  remapPredictionModel = (e3) => {
    let t3 = new sr();
    return t3.fullTimeOneXTwo = e3.FT_1X2, t3.halfTimeOneXTwo = e3.HT_1X2, t3.bothTeamsScore = e3.BOTH_TEAMS_SCORE, t3.overZeroPointFiveGoals = e3.OVER_GOALS_0_5, t3.overOnePointFiveGoals = e3.OVER_GOALS_1_5, t3.overTwoPointFiveGoals = e3.OVER_GOALS_2_5, t3.overThreePointFiveGoals = e3.OVER_GOALS_3_5, t3.overFourPointFiveGoals = e3.OVER_GOALS_4_5, t3.overFivePointFiveGoals = e3.OVER_GOALS_5_5, t3.overSixPointFiveGoals = e3.OVER_GOALS_6_5, t3.overSixPointFiveCorners = e3.OVER_CORNERS_6_5, t3.overSevenPointFiveCorners = e3.OVER_CORNERS_7_5, t3.overEightPointFiveCorners = e3.OVER_CORNERS_8_5, t3.overNinePointFiveCorners = e3.OVER_CORNERS_9_5, t3.overTenPointFiveCorners = e3.OVER_CORNERS_10_5, t3.overElevenPointFiveCorners = e3.OVER_CORNERS_11_5, t3.overTwelvePointFiveCorners = e3.OVER_CORNERS_12_5, t3.overThirteenPointFiveCorners = e3.OVER_CORNERS_13_5, t3.doubleChance = e3.DOUBLE_CHANCE, t3.halfTimeFullTime = e3.HT_FT, t3.playerScore = e3.PLAYER_SCORE, t3.playerYellowCard = e3.PLAYER_YELLOW_CARD, t3.playerRedCard = e3.PLAYER_RED_CARD, t3.redCardMatch = e3.RED_CARD_MATCH, t3.penaltyMatch = e3.PENALTY_MATCH, t3.playerScoreFirstGoal = e3.PLAYER_SCORE_FIRST_GOAL, t3.cornersMatch = e3.CORNERS_MATCH, t3.correctScore = e3.CORRECT_SCORE, t3.correctScoreHalfTime = e3.CORRECT_SCORE_HT, t3.correctScoreAdvanced = e3.CORRECT_SCORE_ADVANCED, t3.playerScoreHattrick = e3.PLAYER_SCORE_HATTRICK, t3.playerScoreTwice = e3.PLAYER_SCORE_TWICE, t3;
  };
};
var qo = class {
  matchId = null;
  matchType = null;
  predictions = null;
};
var Ko = class {
  remapPredictions = null;
  constructor(e3, t3) {
    this.remapPredictions = new ur(e3, t3);
  }
  remapResponse = (e3) => {
    let t3 = new qo();
    return t3.matchId = e3.match_id, t3.matchType = e3.match_type, t3.predictions = this.remapPredictions.remapPredictionModel(e3.predictions), t3;
  };
};
var Wo = class {
  matchId = null;
  matchType = null;
  market = null;
  matchModel = null;
};
var Xo = class {
  value = null;
  target = null;
  playerId = null;
  playerModel = null;
  result = null;
};
var Yo = class {
  matchId = null;
  matchType = null;
  market = null;
  matchModel = null;
  prediction = new Xo();
};
var Qo = class {
  value = null;
  result = null;
};
var zo = class {
  matchId = null;
  matchType = null;
  market = null;
  matchModel = null;
  prediction = new Qo();
};
var Jo = class {
  matchId = null;
  matchModel = null;
  outcome = null;
};
var Zo = class {
  gameId = null;
  results = null;
  tieBreakers = null;
};
var jo = class {
  remapPaginatedGames = (e3) => {
    let t3 = new re2();
    return t3.meta.pagination.nextPageStartsAfter = e3.meta.pagination.next_page_starts_after, t3.meta.pagination.itemsPerPage = e3.meta.pagination.items_per_page, t3.data = e3.data.map((n2) => this.remapGamesListResponse(n2)), t3;
  };
  remapGamesListResponse = (e3) => {
    let t3 = new yi();
    return t3.id = e3.id, t3.title = e3.title, t3.description = e3.description, t3.type = e3.type, t3.status = e3.status, t3.scheduleOpenAt = e3.schedule_open_at, t3.predictionsCutoff = e3.predictions_cutoff, t3.fixtures = e3.fixtures.map((n2) => this.remapFixturesResponse(n2)), t3.tiebreaker = e3.tiebreaker ? this.remapTimeTiebreaker(e3.tiebreaker.time_tiebreaker) : null, t3.participantsCount = e3.participants_count, t3.rules = e3.rules, t3.flags = e3.flags, t3.images = e3.images, t3.createdAt = e3.created_at, t3.updatedAt = e3.updated_at, t3;
  };
  remapFixturesResponse = (e3) => {
    let t3 = new Wo();
    return t3.matchId = e3.match_id, t3.matchType = e3.match_type, t3.market = e3.market, t3;
  };
  remapPaginatedUserTopXEditions = (e3) => {
    let t3 = new re2();
    return t3.meta.pagination.nextPageStartsAfter = e3.meta.pagination.next_page_starts_after, t3.meta.pagination.itemsPerPage = e3.meta.pagination.items_per_page, t3.data = e3.data.map((n2) => this.remapUserTopXEditionsResponse(n2)), t3;
  };
  remapUserTopXEditionsResponse = (e3) => {
    let t3 = new hi();
    return t3.id = e3.id, t3.title = e3.title, t3.description = e3.description, t3.type = e3.type, t3.status = e3.status, t3.predictionsCutoff = e3.predictions_cutoff, t3.scheduleOpenAt = e3.schedule_open_at, t3.fixtures = e3.fixtures.map((n2) => this.remapTopXFixturesResponse(n2)), t3.tiebreaker = e3.tiebreaker ? this.remapTimeTiebreaker(e3.tiebreaker.time_tiebreaker) : null, t3.participantsCount = e3.participants_count, t3.rules = e3.rules, t3.flags = e3.flags, t3.images = e3.images, t3.createdAt = e3.created_at, t3.updatedAt = e3.updated_at, t3;
  };
  remapTopXFixturesResponse = (e3) => {
    let t3 = new zo();
    return t3.matchId = e3.match_id, t3.matchType = e3.match_type, t3.market = e3.market, t3;
  };
  remapPaginatedUserMathQuizEditions = (e3) => {
    let t3 = new re2();
    return t3.meta.pagination.nextPageStartsAfter = e3.meta.pagination.next_page_starts_after, t3.meta.pagination.itemsPerPage = e3.meta.pagination.items_per_page, t3.data = e3.data.map((n2) => this.remapUserMatchQuizEditionsResponse(n2)), t3;
  };
  remapUserMatchQuizEditionsResponse = (e3) => {
    let t3 = new Nt();
    return t3.id = e3.id, t3.title = e3.title, t3.description = e3.description, t3.type = e3.type, t3.status = e3.status, t3.predictionsCutoff = e3.predictions_cutoff, t3.scheduleOpenAt = e3.schedule_open_at, t3.fixtures = e3.fixtures.map((n2) => this.remapMatchQuizFixturesResponse(n2)), t3.tiebreaker = e3.tiebreaker ? this.remapTimeTiebreaker(e3.tiebreaker.time_tiebreaker) : null, t3.participantsCount = e3.participants_count, t3.rules = e3.rules, t3.flags = e3.flags, t3.images = e3.images, t3.createdAt = e3.created_at, t3.updatedAt = e3.updated_at, t3;
  };
  remapMatchQuizFixturesResponse = (e3) => {
    let t3 = new Yo();
    return t3.matchId = e3.match_id, t3.matchType = e3.match_type, t3.market = e3.market, t3;
  };
  remapPaginatedGameResults = (e3) => {
    let t3 = new re2();
    return t3.meta.pagination.nextPageStartsAfter = e3.meta.pagination.next_page_starts_after, t3.meta.pagination.itemsPerPage = e3.meta.pagination.items_per_page, t3.data = e3.data.map((n2) => this.remapGameResults(n2)), t3;
  };
  remapGameResults = (e3) => {
    let t3 = new gi();
    return t3.userId = e3.user_id, t3.points = e3.points ? e3.points : 0, t3.results = e3.results.map((n2) => this.remapResults(n2)), t3.tiebreaker = e3.tiebreaker ? this.remapTiebreaker(e3.tiebreaker) : null, t3;
  };
  remapGameMarketsResults = (e3) => {
    let t3 = new Zo();
    return t3.gameId = e3.game_id, t3.results = this.remapMarketsResults(e3.results), t3.tieBreakers = e3.tie_breakers ? this.remapTieBreakers(e3.tie_breakers) : null, t3;
  };
  remapTieBreakers = (e3) => {
    let t3 = { goldenGoals: [] };
    return t3.goldenGoals = e3.golden_goals.map((n2) => ({ minute: n2.minute, matchId: n2.match_id, matchModel: null, playerId: n2.player_id, playerModel: null, goalType: n2.goal_type })), t3;
  };
  remapMarketsResults = (e3) => {
    let t3 = [];
    return e3.forEach((n2) => {
      let o2 = { matchId: n2.match_id, market: n2.market, result: this.remapMarketResult(n2.market, n2.result), matchModel: null, playerModels: [] };
      t3.push(this.deleteUnusefulField(o2));
    }), t3;
  };
  remapMarketResult = (e3, t3) => {
    if (Ed.includes(e3))
      return t3[0];
    if (wt.includes(e3))
      return t3;
    if (t3[0] === "true")
      return true;
    if (t3[0] === "false")
      return false;
  };
  deleteUnusefulField = (e3) => ((!wt.includes(e3.market) || this.isPlayerMarketWithNoResult(e3.market, e3.result)) && delete e3.playerModels, e3);
  isPlayerMarketWithNoResult = (e3, t3) => wt.includes(e3) && t3.length === 0;
  remapResults = (e3) => {
    let t3 = new Jo();
    return t3.matchId = e3.match_id, t3.outcome = e3.outcome, t3;
  };
  remapTiebreaker = (e3) => {
    let t3 = new jt();
    return t3.goldenGoal = e3.golden_goal, t3;
  };
  remapTimeTiebreaker = (e3) => {
    let t3 = new vt();
    return t3.timeTiebreaker = e3, t3;
  };
};
var es = class {
  remapMetaData = (e3) => {
    let t3 = new Bi();
    return t3.pagination.nextPageStartsAfter = e3.pagination.next_page_starts_after, t3.pagination.itemsPerPage = e3.pagination.items_per_page, t3;
  };
};
var ei = class extends Me {
  apiSignInUrl = null;
  predictionRemapper = null;
  matchSummaryRemapper = null;
  gamesRemapper = null;
  metaRemapper = null;
  constructor(e3, t3) {
    super(e3, Oe(e3.environment, "predictor"));
    this.apiSignInUrl = `?key=${e3.apiKey}&client_id=${e3.clientId}`, this.predictionRemapper = new ur(e3, t3), this.matchSummaryRemapper = new Ko(e3, t3), this.gamesRemapper = new jo(), this.metaRemapper = new es();
  }
  makeFootballPrediction = async (e3) => {
    try {
      let t3 = this.predictionRemapper.remapRequestBody(e3), n2 = await this.instanceAuth.post(`/predictions${this.apiSignInUrl}`, JSON.stringify(t3));
      return await this.predictionRemapper.remapResponseObjBody(n2.data);
    } catch (t3) {
      throw console.warn("There was a problem making POST request: ", t3), t3.response;
    }
  };
  getMatchSummary = async (e3, t3) => {
    let n2 = de(t3) ? `/predictions/summary/${e3}${this.apiSignInUrl}${fe()}` : `/predictions/summary/${e3}${this.apiSignInUrl}`;
    try {
      let o2 = await this.instance.get(n2);
      return this.matchSummaryRemapper.remapResponse(o2.data);
    } catch (o2) {
      throw console.warn(`There was a problem fetching predictions for match: ${e3} `, o2), o2.response;
    }
  };
  deleteFootballPrediction = async (e3) => {
    try {
      return await this.instanceAuth.delete(`/predictions/${e3}${this.apiSignInUrl}`), true;
    } catch (t3) {
      throw console.warn(`There was a problem deleting your prediction: ${e3}`, t3), t3.response;
    }
  };
  getMyPredictions = async (e3) => {
    try {
      let t3 = new re2(), n2 = `/predictions${this.apiSignInUrl}`;
      e3 && (n2 += `${e3.constructFiltersUrl()}`);
      let o2 = await this.instanceAuth.get(n2);
      return t3.meta = this.metaRemapper.remapMetaData(o2.data.meta), t3.data = await this.predictionRemapper.remapResponseArrayBody(o2.data.data), t3;
    } catch (t3) {
      throw console.warn("There was a problem fetching own predictions", t3), t3.response;
    }
  };
  getMyPredictionsNoRemap = async (e3) => {
    try {
      return (await this.instanceAuth.get(`/predictions${this.apiSignInUrl}${e3.constructFiltersUrl()}`)).data;
    } catch (t3) {
      throw console.warn("There was a problem fetching own predictions", t3), t3.response;
    }
  };
  getUserPredictions = async (e3, t3, n2) => {
    try {
      let o2 = new re2(), p2 = de(t3) ? `/predictions/users/${e3}${this.apiSignInUrl}${fe()}` : `/predictions/users/${e3}${this.apiSignInUrl}`;
      n2 && (p2 += `${n2.constructFiltersUrl()}`);
      let d4 = await this.instance.get(p2);
      return o2.meta = this.metaRemapper.remapMetaData(d4.data.meta), o2.data = await this.predictionRemapper.remapResponseArrayBody(d4.data.data), o2;
    } catch (o2) {
      throw console.warn(`There was a problem fetching predictions for user: ${e3}`, o2), o2.response;
    }
  };
  getUserPredictionsNoRemap = async (e3, t3) => {
    try {
      return (await this.instance.get(`/predictions/users/${e3}${this.apiSignInUrl}${t3.constructFiltersUrl()}`)).data;
    } catch (n2) {
      throw console.warn(`There was a problem fetching predictions for user: ${e3}`, n2), n2.response;
    }
  };
  getGames = async (e3, t3) => {
    try {
      let n2 = de(t3) ? `/games/${this.apiSignInUrl}${e3.constructFiltersUrl()}${fe()}` : `/games/${this.apiSignInUrl}${e3.constructFiltersUrl()}`, o2 = await this.instance.get(n2);
      return this.gamesRemapper.remapPaginatedGames(o2.data);
    } catch (n2) {
      throw console.warn("There was a problem fetching the games list", n2), n2.response;
    }
  };
  getGameById = async (e3, t3) => {
    try {
      let n2 = de(t3) ? `/games/${e3}${this.apiSignInUrl}${fe()}` : `/games/${e3}${this.apiSignInUrl}`, o2 = await this.instance.get(n2);
      return this.gamesRemapper.remapGamesListResponse(o2.data);
    } catch (n2) {
      throw console.warn(`There was a problem fetching the following game: ${e3}`, n2), n2.response;
    }
  };
  getGamePredictions = async (e3, t3, n2) => {
    try {
      let o2 = new re2(), p2 = de(t3) ? `/games/${e3}/predictions${this.apiSignInUrl}${fe()}` : `/games/${e3}/predictions${this.apiSignInUrl}`;
      n2 && (p2 += `${n2.constructFiltersUrl()}`);
      let d4 = await this.instance.get(p2);
      return o2.meta = this.metaRemapper.remapMetaData(d4.data.meta), o2.data = await this.predictionRemapper.remapResponseArrayBody(d4.data.data), o2;
    } catch (o2) {
      throw console.warn(`There was a problem fetching the predictions for game: ${e3}`, o2), o2.response;
    }
  };
  getUserGameEditions = async (e3, t3) => {
    try {
      let n2 = null, o2 = de(t3) ? `/games/${this.apiSignInUrl}${e3.constructFiltersUrl()}${fe()}` : `/games/${this.apiSignInUrl}${e3.constructFiltersUrl()}`, p2 = await this.instance.get(o2);
      return p2.data.data.forEach((d4) => {
        d4.type === "TOP_X" ? n2 = this.gamesRemapper.remapPaginatedUserTopXEditions(p2.data) : d4.type === "MATCH_QUIZ" && (n2 = this.gamesRemapper.remapPaginatedUserMathQuizEditions(p2.data));
      }), n2;
    } catch (n2) {
      throw console.warn("There was a problem fetching the games list", n2), n2.response;
    }
  };
  getGameResults = async (e3, t3, n2) => {
    try {
      let o2 = de(t3) ? `/games/${e3}/results/${this.apiSignInUrl}${fe()}` : `/games/${e3}/results/${this.apiSignInUrl}`;
      n2 && (o2 += `${n2.constructMainFiltersUrl()}`);
      let p2 = await this.instance.get(o2);
      return this.gamesRemapper.remapPaginatedGameResults(p2.data);
    } catch (o2) {
      throw console.warn(`There was a problem fetching the results for the following game: ${e3}`, o2), o2.response;
    }
  };
  getMarketResultsForGame = async (e3, t3) => {
    let n2 = `/games/${e3}/correct-results/${this.apiSignInUrl}`;
    de(t3) && (n2 += `${fe()}`);
    try {
      let o2 = await this.instance.get(n2);
      return this.gamesRemapper.remapGameMarketsResults(o2.data.data);
    } catch (o2) {
      throw console.warn(`There was a problem fetching the markets correct results for the following game: ${e3}`, o2), o2.response;
    }
  };
};
var mr = class {
  gameInstanceId = null;
  fixtures = null;
};
var ne = class extends Error {
  code = 0;
  status = null;
  message = null;
  constructor(e3, t3, n2) {
    super();
    this.code = e3, this.status = t3, this.message = n2;
  }
  errorMessage = () => this.message;
};
var Cp = ((n2) => (n2.ONE = "1", n2.X = "x", n2.TWO = "2", n2))(Cp || {});
var Ap = ((n2) => (n2.ONE_X = "1x", n2.X_TWO = "x2", n2.ONE_TWO = "12", n2))(Ap || {});
var xp = ((_2) => (_2.ONE_ONE = "1/1", _2.ONE_X = "1/x", _2.ONE_TWO = "1/2", _2.X_ONE = "x/1", _2.X_X = "x/x", _2.X_TWO = "x/2", _2.TWO_ONE = "2/1", _2.TWO_X = "2/x", _2.TWO_TWO = "2/2", _2))(xp || {});
var ts = class {
  matchId = null;
  market = "BOTH_TEAMS_SCORE";
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3) {
    this.matchId = e3, this.prediction = new it(), this.prediction.value = t3;
  }
};
var is = class {
  value;
};
var rs = class {
  matchId = null;
  market = "CORNERS_MATCH";
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3) {
    this.matchId = e3, this.prediction = new is(), this.prediction.value = t3;
  }
};
var ns = class {
  value = null;
};
var as = class {
  matchId = null;
  market = "DOUBLE_CHANCE";
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3) {
    this.matchId = e3, this.prediction = new ns(), this.prediction.value = t3;
  }
};
var os = class {
  value = null;
};
var ss = class {
  matchId = null;
  market = null;
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3, n2) {
    this.matchId = e3, this.market = t3, this.prediction = new os(), this.prediction.value = n2;
  }
};
var ls = class {
  value = null;
};
var ps = class {
  matchId = null;
  market = "HT_FT";
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3) {
    this.matchId = e3, this.prediction = new ls(), this.prediction.value = t3;
  }
};
var cs = class {
  matchId = null;
  market = "PENALTY_MATCH";
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3) {
    this.matchId = e3, this.prediction = new it(), this.prediction.value = t3;
  }
};
var us = class {
  matchId = null;
  market = "RED_CARD_MATCH";
  matchType = "FOOTBALL";
  prediction = null;
  constructor(e3, t3) {
    this.matchId = e3, this.prediction = new it(), this.prediction.value = t3;
  }
};
var ti = class {
  validateBodyFields = (e3, t3) => {
    let n2 = Object.keys(t3), o2 = Object.keys(new mr());
    switch (e3) {
      case "MATCH_QUIZ":
        n2.forEach((y4) => {
          o2.includes(y4) || this.throwInvalidParamException([y4]);
        });
        break;
      case "TOP_X":
        let d4 = t3;
        d4.fixtures.forEach((y4) => this.validateMarketTopX(y4.market));
        let h4 = "tiebreaker";
        n2.includes(h4) && d4.tiebreaker && this.validateTiebreaker(d4.tiebreaker), n2.forEach((y4) => {
          y4 !== "tiebreaker" && !o2.includes(y4) && this.throwInvalidParamException([y4]);
        });
        break;
    }
    let p2 = o2.filter((d4) => !n2.includes(d4));
    return p2.length && this.throwMissingFieldsException("game prediction body", p2), t3.fixtures.forEach((d4) => {
      this.validateFixtureFields(d4);
    }), t3;
  };
  validateFixture = (e3, t3, n2, o2) => {
    this.validateMarket(t3);
    let p2 = Object.values(Cp), d4 = Object.values(xp), h4 = Object.values(Ap);
    if (t3 === "FT_1X2" || t3 === "HT_1X2") {
      if (p2.includes(n2))
        return new ss(e3, t3, n2);
    } else if (t3 === "HT_FT") {
      if (d4.includes(n2))
        return new ps(e3, n2);
    } else if (t3 === "DOUBLE_CHANCE") {
      if (h4.includes(n2))
        return new as(e3, n2);
    } else if (t3 === "CORRECT_SCORE" || t3 === "CORRECT_SCORE_ADVANCED" || t3 === "CORRECT_SCORE_HT") {
      if (typeof n2 == "string" && /\d+:\d+/.test(n2))
        return new Zt(e3, t3, n2);
    } else if (t3 === "CORNERS_MATCH") {
      if (typeof n2 == "number")
        return new rs(e3, n2);
    } else if (t3 === "BOTH_TEAMS_SCORE") {
      if (this.isPredictionBoolean(n2))
        return new ts(e3, n2);
    } else if (t3 === "RED_CARD_MATCH") {
      if (this.isPredictionBoolean(n2))
        return new us(e3, n2);
    } else if (t3 === "PENALTY_MATCH") {
      if (this.isPredictionBoolean(n2))
        return new cs(e3, n2);
    } else if (wt.includes(t3)) {
      if (this.validatePlayerId(t3, o2), t3 === Zr && this.isPredictionBoolean(n2))
        return new tt(e3, t3, n2, o2);
      if (o2 && this.isPredictionBoolean(n2))
        return new tt(e3, t3, n2, o2);
    } else if (Sd.includes(t3)) {
      if (this.isPredictionBoolean(n2))
        return new or(e3, t3, n2);
    } else if (Td.includes(t3) && this.isPredictionBoolean(n2))
      return new ar(e3, t3, n2);
    this.throwInvalidPredictionException(n2, t3);
  };
  validateFixtureFields = (e3) => {
    let t3 = Object.keys(e3);
    t3.forEach((o2) => {
      Fp.includes(o2) || this.throwInvalidParamException([o2]);
    });
    let n2 = Fp.filter((o2) => {
      if (o2 !== "matchType" && !t3.includes(o2))
        return o2;
    });
    n2.length && this.throwMissingFieldsException("fixtures", n2), this.validatePredictionKey(e3.market, e3.prediction);
  };
  validateTiebreaker = (e3) => {
    let t3 = Object.keys(e3);
    (!t3.length || typeof e3 != "object") && this.throwInvalidType("tiebreaker", "object");
    let n2 = Object.keys(new jt())[0];
    t3.forEach((o2) => {
      n2 !== o2 && this.throwInvalidParamException([o2]);
    }), t3.includes(n2) || this.throwMissingFieldsException("tiebreaker", [n2]), typeof e3.goldenGoal != "number" && this.throwInvalidType("goldenGoal", "number");
  };
  validatePredictionKey = (e3, t3) => {
    if (typeof t3 == "object") {
      let n2 = Object.keys(t3), o2 = ["value"];
      if (n2.length || this.throwMissingFieldsException("prediction", o2), n2.length === 1 && !n2.includes(o2[0]) && this.throwInvalidParamException(n2), n2.length > 1) {
        wt.includes(e3) && o2.push("playerId");
        let p2 = n2.filter((d4) => !o2.includes(d4));
        p2.length && this.throwInvalidParamException(p2);
      }
    } else
      this.throwInvalidType("prediction", "object");
  };
  validatePlayerId = (e3, t3) => {
    let n2 = "playerId";
    e3 !== Zr && (t3 || this.throwInvalidParamException([n2]), typeof t3 != "string" && this.throwInvalidType(n2, "string"));
  };
  validateMarket = (e3) => {
    Object.values(Pe).includes(e3) || this.throwInvalidMarketException(e3);
  };
  validateMarketTopX = (e3) => {
    e3 !== "CORRECT_SCORE" && e3 !== "CORRECT_SCORE_ADVANCED" && this.throwInvalidMarketException(e3, "TOP_X");
  };
  isPredictionBoolean = (e3) => typeof e3 == "boolean";
  throwInvalidPredictionException = (e3, t3) => {
    let n2 = Cd(e3, t3);
    throw new ne(400, "INVALID_PREDICTION", n2);
  };
  throwInvalidMarketException = (e3, t3) => {
    let n2 = null;
    throw t3 && t3 === "TOP_X" ? n2 = Ad(e3) : n2 = Vo(e3), new ne(400, "INVALID_MARKET", n2);
  };
  throwInvalidParamException = (e3) => {
    let t3 = xd(e3);
    throw new ne(400, "INVALID_FIELD", t3);
  };
  throwMissingFieldsException = (e3, t3) => {
    let n2 = Od(e3, t3);
    throw new ne(400, "INVALID_FIELD", n2);
  };
  throwInvalidType = (e3, t3) => {
    let n2 = Bd(e3, t3);
    throw new ne(400, "INVALID_TYPE", n2);
  };
};
var ds = class {
  predictorHttps = null;
  clientHttps = null;
  idMapping = null;
  predictorService = null;
  predictorValidator = null;
  constructor(e3, t3, n2, o2) {
    this.predictorHttps = t3, this.idMapping = o2, this.clientHttps = n2, this.predictorValidator = new ti(), this.predictorService = new _t(e3, o2);
  }
  makeFootballPrediction = async (e3, t3, n2, o2) => {
    let p2 = this.predictorValidator.validateFixture(e3, t3, n2, o2), d4 = new mr();
    if (this.idMapping.idSchema !== "native") {
      let h4 = p2.matchId, y4 = "", _2 = await this.predictorService.remapMatchIdToNative([h4]);
      if (p2.matchId = _2[0], !p2.matchId)
        throw new ne(400, "INVALID_FIELD", "Match id is invalid!").errorMessage();
      if (p2 instanceof tt && (y4 = p2.prediction.playerId, p2.prediction.playerId = y4 && await this.predictorService.remapPlayerIdToNative([y4]), p2.market !== Zr && !p2.prediction.playerId))
        throw new ne(400, "INVALID_FIELD", "Player id is invalid!").errorMessage();
      d4.fixtures = [p2];
      let w3 = await this.predictorHttps.makeFootballPrediction(d4);
      return w3.fixtures.map((S4) => {
        S4.prediction.playerId && (S4.prediction.playerId = y4), S4.matchId = h4;
      }), w3;
    } else
      return d4.fixtures = [p2], await this.predictorHttps.makeFootballPrediction(d4);
  };
  getMatchSummary = async (e3, t3) => {
    if (this.idMapping.idSchema !== "native") {
      let o2 = (await this.predictorService.remapMatchIdToNative([e3]))[0], p2 = await this.predictorHttps.getMatchSummary(o2, t3);
      p2.matchId = e3;
      let d4 = p2.predictions, h4 = await this.predictorService.remapPlayerIdToIdSchema(d4);
      return p2.predictions = h4, p2;
    } else
      return await this.predictorHttps.getMatchSummary(e3, t3);
  };
  getMarketSummary = async (e3, t3, n2, o2) => {
    try {
      let p2 = await this.getMatchSummary(e3, o2);
      return this.predictorService.getMarketSummary(p2, t3, n2);
    } catch (p2) {
      return p2.message;
    }
  };
  getConfig = async () => {
    let e3 = await this.clientHttps.getConfig("predictor");
    return this.idMapping.idSchema !== "native" ? await this.predictorService.remapCompetitionsFromConfig(e3) : e3;
  };
  deleteFootballPrediction = async (e3) => await this.predictorHttps.deleteFootballPrediction(e3);
  getMyPredictions = async (e3) => {
    let t3 = this.predictorService.initPredictionsFilters(e3, "user");
    return await this.predictorHttps.getMyPredictions(t3);
  };
  getMyPredictionsForMatches = async (e3, t3) => {
    if (this.predictorService.areIdsExceeded(e3))
      throw new ne(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.").errorMessage();
    this.idMapping.idSchema !== "native" && (e3 = await this.predictorService.remapMatchIdToNative([...e3]));
    let n2 = this.predictorService.initPredictionsFilters(t3, "matches", e3);
    return await this.predictorHttps.getMyPredictions(n2);
  };
  getMyCurrentPredictions = async (e3) => {
    let t3 = this.predictorService.initPredictionsFilters(e3, "current");
    return await this.predictorHttps.getMyPredictions(t3);
  };
  getMyPastPredictions = async (e3) => {
    let t3 = this.predictorService.initPredictionsFilters(e3, "past");
    return await this.predictorHttps.getMyPredictions(t3);
  };
  getUserPredictions = async (e3, t3, n2) => {
    let o2 = this.predictorService.initPredictionsFilters(t3, "user");
    return await this.predictorHttps.getUserPredictions(e3, n2, o2);
  };
  getUserCurrentPredictions = async (e3, t3, n2) => {
    let o2 = this.predictorService.initPredictionsFilters(t3, "current");
    return await this.predictorHttps.getUserPredictions(e3, n2, o2);
  };
  getUserPastPredictions = async (e3, t3, n2) => {
    let o2 = this.predictorService.initPredictionsFilters(t3, "past");
    return await this.predictorHttps.getUserPredictions(e3, n2, o2);
  };
  getUserPredictionsForMatches = async (e3, t3, n2, o2) => {
    if (this.predictorService.areIdsExceeded(t3))
      throw new ne(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.").errorMessage();
    this.idMapping.idSchema !== "native" && (t3 = await this.predictorService.remapMatchIdToNative([...t3]));
    let p2 = this.predictorService.initPredictionsFilters(n2, "matches", t3);
    return await this.predictorHttps.getUserPredictions(e3, o2, p2);
  };
};
var fs = class {
  predictorHttps = null;
  clientHttps = null;
  predictorFacade = null;
  idMapping = null;
  constructor(e3) {
    this.idMapping = new ae(e3), this.predictorHttps = new ei(e3, this.idMapping), this.clientHttps = new et(e3), this.predictorFacade = new ds(e3, this.predictorHttps, this.clientHttps, this.idMapping);
  }
  makeFootballPrediction = async (e3, t3, n2, o2) => await this.predictorFacade.makeFootballPrediction(e3, t3, n2, o2);
  getMatchSummary = async (e3, t3) => await this.predictorFacade.getMatchSummary(e3, t3);
  getMarketSummary = async (e3, t3, n2, o2) => await this.predictorFacade.getMarketSummary(e3, t3, n2, o2);
  getConfig = async () => await this.predictorFacade.getConfig();
  deleteFootballPrediction = async (e3) => await this.predictorFacade.deleteFootballPrediction(e3);
  getMyPredictions = async (e3) => await this.predictorFacade.getMyPredictions(e3);
  getMyCurrentPredictions = async (e3) => await this.predictorFacade.getMyCurrentPredictions(e3);
  getMyPastPredictions = async (e3) => await this.predictorFacade.getMyPastPredictions(e3);
  getMyPredictionsForMatches = async (e3, t3) => await this.predictorFacade.getMyPredictionsForMatches(e3, t3);
  getUserPredictions = async (e3, t3, n2) => await this.predictorFacade.getUserPredictions(e3, t3, n2);
  getUserCurrentPredictions = async (e3, t3, n2) => await this.predictorFacade.getUserCurrentPredictions(e3, t3, n2);
  getUserPastPredictions = async (e3, t3, n2) => await this.predictorFacade.getUserPastPredictions(e3, t3, n2);
  getUserPredictionsForMatches = async (e3, t3, n2, o2) => await this.predictorFacade.getUserPredictionsForMatches(e3, t3, n2, o2);
};
var hs = class {
  rankType = null;
  fromDate = null;
  toDate = null;
  pagination = new Qi();
};
var dr = class {
  position = null;
  profileId = null;
  profileModel = null;
  points = null;
  predictionsMade = null;
};
var gs = class {
  remapResponse = (e3) => (e3.meta = this.remapMeta(e3.meta), e3.data = this.remapData(e3.data), e3);
  remapMeta = (e3) => {
    let t3 = new hs();
    return t3.rankType = e3.rank_type, t3.fromDate = e3.from_date, t3.toDate = e3.to_date, t3.pagination.currentPage = e3.pagination.current_page, t3.pagination.itemsPerPage = e3.pagination.items_per_page, t3.pagination.totalItems = e3.pagination.total_items, t3.pagination.numberOfPages = e3.pagination.number_of_pages, t3;
  };
  remapData = (e3) => {
    let t3 = [];
    return e3.forEach((n2) => {
      let o2 = new dr();
      o2.position = n2.position, o2.profileId = n2.profile_id, o2.points = n2.points, o2.predictionsMade = n2.predictions_made, t3.push(o2);
    }), t3;
  };
};
var ys = class extends dr {
  id = null;
  rankType = null;
  model = null;
  gameType = null;
};
var Ms = class {
  remapRankings = (e3) => (e3.meta = this.remapMeta(e3.meta), e3.data = this.remapData(e3.data), e3);
  remapMeta = (e3) => {
    let t3 = new Jt();
    return t3.pagination.currentPage = e3.pagination.current_page, t3.pagination.itemsPerPage = e3.pagination.items_per_page, t3.pagination.numberOfPages = e3.pagination.number_of_pages, t3.pagination.totalItems = e3.pagination.total_items, t3;
  };
  remapData(e3) {
    let t3 = [];
    return e3.forEach((n2) => {
      let o2 = new ys();
      o2.id = n2.id, o2.rankType = n2.rank_type, o2.position = n2.position, o2.points = n2.points, o2.gameType = n2.game_type, delete o2.profileId, delete o2.profileModel, delete o2.predictionsMade, t3.push(o2);
    }), t3;
  }
};
var bs = class {
  id = null;
  name = null;
  description = null;
  type = null;
  fromDate = null;
  toDate = null;
  markets = [];
  teamIds = [];
  matchIds = [];
  gameIds = [];
  gameTypes = [];
  competitionIds = [];
  rules = null;
  flags = null;
  images = new pr();
  status = null;
  automaticallyChangeStatus = true;
};
var ws = class {
  remapResponse = (e3) => {
    let t3 = [];
    return e3.forEach((n2) => {
      let o2 = new bs();
      o2.id = n2.id, o2.name = n2.name, o2.description = n2.description, o2.type = n2.type, o2.fromDate = n2.from_date, o2.toDate = n2.to_date, o2.markets = n2.markets ? n2.markets : null, o2.teamIds = n2.team_ids ? n2.team_ids : null, o2.matchIds = n2.match_ids ? n2.match_ids : null, o2.gameIds = n2.game_ids ? n2.game_ids : null, o2.gameTypes = n2.game_types ? n2.game_types : null, o2.competitionIds = n2.competition_ids ? n2.competition_ids : null, o2.rules = n2.rules ? n2.rules : null, o2.flags = n2.flags ? n2.flags : null, o2.images = n2.images ? n2.images : null, o2.status = n2.status ? n2.status : null, o2.automaticallyChangeStatus = n2.automatically_change_status, t3.push(o2);
    }), t3;
  };
  remapMeta = (e3) => {
    let t3 = {};
    return t3.totalItems = e3.pagination.total_items, t3;
  };
};
var vs = class {
  position = null;
  points = null;
  predictionsMade = null;
  profileId = null;
  profileModel = null;
  successRatePercent = null;
};
var _s = class {
  remapHighestSuccessRate = (e3) => e3.map((t3) => {
    let n2 = new vs();
    return n2.position = t3.position, n2.points = t3.points, n2.predictionsMade = t3.predictions_made, n2.profileId = t3.profile_id, n2.successRatePercent = t3.success_rate_percent, n2;
  });
};
var Is = class extends Me {
  apiSignInUrl = null;
  templateRemapper = null;
  leaderboardRemapper = null;
  rankingsRemapper = null;
  highestSuccessRateRemapper = null;
  constructor(e3) {
    super(e3, Oe(e3.environment, "loyalty"));
    this.apiSignInUrl = `?key=${e3.apiKey}&client_id=${e3.clientId}`, this.templateRemapper = new ws(), this.leaderboardRemapper = new gs(), this.rankingsRemapper = new Ms(), this.highestSuccessRateRemapper = new _s();
  }
  getTemplates = async (e3, t3) => {
    try {
      let n2 = de(e3) ? `/leaderboard/templates/${this.apiSignInUrl}${fe()}` : `/leaderboard/templates/${this.apiSignInUrl}`, o2 = await this.instance.get(n2);
      if (t3) {
        let p2 = JSON.parse(JSON.stringify(o2.data));
        return p2.meta = this.templateRemapper.remapMeta(o2.data.meta), p2.data = this.templateRemapper.remapResponse(o2.data.data), p2;
      }
      return this.templateRemapper.remapResponse(o2.data.data);
    } catch (n2) {
      throw console.warn("There was a problem fetching the list of templates", n2), n2.response;
    }
  };
  getLeaderboard = async (e3, t3, n2) => {
    try {
      let o2 = de(t3) ? `/leaderboard/${e3}/${this.apiSignInUrl}${fe()}` : `/leaderboard/${e3}/${this.apiSignInUrl}`;
      n2 && (o2 += `${n2.constructFiltersUrl()}`);
      let p2 = await this.instance.get(o2), d4 = JSON.parse(JSON.stringify(p2.data));
      return this.leaderboardRemapper.remapResponse(d4);
    } catch (o2) {
      throw console.warn(`There was a problem fetching the leaderboard for the following template: ${e3}`, o2), o2.response;
    }
  };
  getLeaderboardForGame = async (e3, t3, n2) => {
    try {
      let o2 = de(t3) ? `/leaderboard/games/${e3}/${this.apiSignInUrl}${fe()}` : `/leaderboard/games/${e3}/${this.apiSignInUrl}`;
      n2 && (o2 += `${n2.constructFiltersUrl()}`);
      let p2 = await this.instance.get(o2), d4 = JSON.parse(JSON.stringify(p2.data));
      return ta(d4);
    } catch (o2) {
      throw console.warn(`There was a problem fetching the leaderboard for the following game: ${e3}`, o2), o2.response;
    }
  };
  getUserRankings = async (e3, t3, n2) => {
    let o2 = `/leaderboard/users/${e3}/rankings/${this.apiSignInUrl}`;
    t3 && (o2 += `${t3.constructFiltersUrl()}`), de(n2) && (o2 += `${fe()}`);
    try {
      let p2 = await this.instance.get(o2);
      return this.rankingsRemapper.remapRankings(p2.data);
    } catch (p2) {
      throw console.warn(`There was a problem fetching the rankings for the following user: ${e3}`, p2), p2.response;
    }
  };
  getHighestSuccessRate = async (e3, t3) => {
    let n2 = de(t3) ? `/statistics/top${this.apiSignInUrl}${fe()}` : `/statistics/top${this.apiSignInUrl}`;
    e3 && (n2 += `&market=${e3}`);
    try {
      let o2 = await this.instance.get(n2);
      return this.highestSuccessRateRemapper.remapHighestSuccessRate(o2.data.data);
    } catch (o2) {
      throw console.warn("There was a problem fetching highest success rate", o2), o2.response;
    }
  };
};
var Ps = class {
  general;
  predictor;
  topX;
  matchQuiz;
};
var fr = class {
  limit = null;
  page = null;
  constructor(e3) {
    this.limit = e3.limit ? e3.limit : null, this.page = e3.page ? e3.page : null;
  }
  constructFiltersUrl() {
    let e3 = "";
    return this.limit && (e3 += "&", e3 += `limit=${this.limit}`), this.page && (e3 += "&", e3 += `page=${this.page}`), e3;
  }
};
var Rs = class extends fr {
  sortOrder = null;
  rankType = null;
  leaderboardIds = null;
  gameType = null;
  constructor(e3) {
    super(e3);
    this.sortOrder = e3.sortOrder, this.rankType = e3.rankType, this.leaderboardIds = e3.leaderboardIds, this.gameType = e3.type && e3.type.toLowerCase() === "game" ? e3.gameType : null;
  }
  constructFiltersUrl = () => {
    let e3 = super.constructFiltersUrl();
    return this.sortOrder && (e3 += "&", e3 += `sort_order=${this.sortOrder}`), this.rankType && (e3 += "&", e3 += `rank_type=${this.rankType}`), this.leaderboardIds && (e3 += "&", e3 += `type_ids=${this.leaderboardIds.join(",")}`), this.gameType && (e3 += "&", e3 += `game_type=${this.gameType}`), e3;
  };
};
var Fs = class {
  idMappingService = null;
  profileNamespace = null;
  constructor(e3) {
    this.idMappingService = new ae(e3), this.profileNamespace = new er(e3);
  }
  remapTemplatesIds = async (e3) => {
    if (e3.length > 0) {
      let t3 = [], n2 = [], o2 = [], p2 = [], d4 = [], h4 = [];
      e3.forEach((w3) => {
        w3.teamIds && w3.teamIds.length > 0 ? t3 = [...t3, ...w3.teamIds] : w3.matchIds && w3.matchIds.length > 0 ? o2 = [...o2, ...w3.matchIds] : w3.competitionIds && w3.competitionIds.length > 0 && (d4 = [...d4, ...w3.competitionIds]);
      });
      let y4 = { team: t3, match: o2, competition: d4 }, _2 = await this.idMappingService.idMappingFacade.getEntitiesByIds(y4, "native", this.idMappingService.idSchema);
      return n2 = [..._2.team], p2 = [..._2.match], h4 = [..._2.competition], e3.forEach((w3) => {
        w3.teamIds && w3.teamIds.length > 0 ? w3.teamIds = w3.teamIds.map((S4) => S4 = _2.team.shift()) : w3.matchIds && w3.matchIds.length > 0 ? w3.matchIds = w3.matchIds.map((S4) => S4 = _2.match.shift()) : w3.competitionIds && w3.competitionIds.length > 0 && (w3.competitionIds = w3.competitionIds.map((S4) => S4 = _2.competition.shift()));
      }), e3;
    }
    return e3;
  };
  addProfileModelToLeaderboad = async (e3) => {
    if (e3.length > 0) {
      let t3 = [], n2 = [];
      e3.forEach((p2) => {
        t3.push(p2.profileId);
      });
      let o2 = await this.profileNamespace.getByIds(t3);
      return e3.forEach((p2) => {
        o2.forEach((d4) => {
          d4.id === p2.profileId && (delete d4.interests, p2.profileModel = d4);
        }), p2.profileModel || (p2.profileModel = null), n2.push(p2);
      }), n2;
    }
    return e3;
  };
  buildClientBadges = (e3) => {
    let t3 = new Ps();
    return t3.general = this.extractEnabledBadgesId(e3.general), t3.predictor = this.extractEnabledBadgesId(e3.predictor), t3.topX = this.extractEnabledBadgesId(e3.topX), t3.matchQuiz = this.extractEnabledBadgesId(e3.matchQuiz), t3;
  };
  initFilters = (e3, t3) => {
    switch (t3) {
      case "loyalty":
        e3 && (e3 = new fr(e3));
        break;
      case "rankings":
        e3 && (e3 = new Rs(e3));
        break;
    }
    return e3;
  };
  addProfileModelToHighestSuccessRate = async (e3) => {
    let t3 = e3.map((o2) => o2.profileId), n2 = await this.profileNamespace.getByIds(t3);
    return e3.map((o2) => (n2.forEach((p2) => {
      p2.id === o2.profileId && (delete p2.interests, o2.profileModel = p2);
    }), o2));
  };
  extractRankingsIdsMap = (e3) => {
    let t3 = [], n2 = [], o2 = [];
    return e3.forEach((p2) => {
      p2.rankType === "GAME" && p2.gameType === "TOP_X" ? t3.push(p2.id) : p2.rankType === "GAME" && p2.gameType === "MATCH_QUIZ" ? n2.push(p2.id) : p2.rankType === "TEMPLATE" && o2.push(p2.id);
    }), [t3, n2, o2];
  };
  setModelsForUserRankings = (e3, t3, n2, o2) => (o2.data.forEach((p2) => {
    p2.gameType === "MATCH_QUIZ" && t3 ? p2.model = t3.filter((d4) => d4.id === p2.id)[0] : p2.gameType === "TOP_X" && e3 ? p2.model = e3.filter((d4) => d4.id === p2.id)[0] : p2.rankType === "TEMPLATE" && n2 && (p2.model = n2.filter((d4) => d4.id === p2.id)[0]);
  }), o2);
  extractEnabledBadgesId = (e3) => {
    let t3 = [];
    return e3.forEach((n2) => {
      n2.enabled && t3.push(n2.id);
    }), t3;
  };
};
var Ss = class {
  validateMarket = (e3) => {
    if (!Object.keys(Pe).includes(e3)) {
      let n2 = Vo(e3);
      throw new ne(400, "INVALID_MARKET", n2);
    }
  };
};
var hr = class {
  idMapping = null;
  predictorHttps = null;
  predictorService = null;
  predictorValidator = null;
  clientHttps = null;
  constructor(e3, t3) {
    this.idMapping = t3, this.predictorValidator = new ti(), this.predictorHttps = new ei(e3, t3), this.predictorService = new _t(e3, t3), this.clientHttps = new et(e3);
  }
  getConfig = async () => {
    let e3 = await this.clientHttps.getConfig("topX");
    return this.idMapping.idSchema !== "native" ? await this.predictorService.remapCompetitionsFromConfig(e3) : e3;
  };
  getGames = async (e3, t3) => {
    t3 = t3 || false;
    let n2 = this.predictorService.initGameFilters("TOP_X", e3), o2 = await this.predictorHttps.getGames(n2, t3);
    return await this.predictorService.remapMatchIdsFixtures(o2);
  };
  getGameById = async (e3, t3) => {
    t3 = t3 || false;
    let n2 = await this.predictorHttps.getGameById(e3, t3);
    return await this.predictorService.remapMatchIdsFixtures(n2);
  };
  getGamePredictions = async (e3, t3, n2) => (n2 = n2 || false, t3 && (t3.type && delete t3.type, t3.status && delete t3.status, t3 = new Re(t3)), await this.predictorHttps.getGamePredictions(e3, n2, t3));
  getGameResults = async (e3, t3, n2) => {
    n2 = n2 || false, t3 && (t3 = new rt(t3));
    let o2 = await this.predictorHttps.getGameResults(e3, n2, t3);
    return await this.predictorService.remapMatchIdsFixtures(o2);
  };
  getCurrentGameResults = async (e3) => {
    e3 = e3 || false;
    let t3 = { status: "OPEN", type: "TOP_X" };
    t3 = new rt(t3);
    let n2 = await this.predictorHttps.getGames(t3, e3), o2 = this.predictorService.getCurrentGameId(n2);
    return (await this.getGameResults(o2, null, e3)).data[0];
  };
  play = async (e3) => {
    let t3 = new cr(e3);
    if (t3 = this.predictorValidator.validateBodyFields("TOP_X", t3), t3.fixtures = t3.fixtures.map((o2) => this.predictorValidator.validateFixture(o2.matchId, o2.market, o2.prediction.value)), this.idMapping.idSchema !== "native") {
      let o2 = [];
      t3.fixtures.forEach((d4) => o2.push(d4.matchId));
      let p2 = await this.predictorService.remapMatchIdToNative(o2);
      t3.fixtures.forEach((d4) => d4.matchId = p2.shift());
    }
    let n2 = await this.predictorHttps.makeFootballPrediction(t3);
    return n2.fixtures.forEach((o2) => {
      o2.matchId = o2.matchModel.id;
    }), n2;
  };
  delete = async (e3) => await this.predictorHttps.deleteFootballPrediction(e3);
  getMyGameEditions = async (e3, t3) => {
    e3 && e3.limit && this.validateLimitFilterOnGames(e3.limit), t3 = t3 || false;
    let n2 = this.predictorService.initGameTypePredictions("TOP_X", e3), o2 = [], p2 = await this.predictorHttps.getMyPredictionsNoRemap(n2);
    if (p2.data.length > 0) {
      p2.data.forEach((y4) => {
        y4.game_instance_id && o2.push(y4.game_instance_id);
      });
      let d4 = this.predictorService.initGameFilters("TOP_X", null, o2), h4 = await this.predictorHttps.getUserGameEditions(d4, t3);
      return await this.predictorService.addPredictionProp(p2, h4);
    } else
      return new re2();
  };
  getMyGamePrediction = async (e3) => {
    let t3 = this.predictorService.initGameTypePredictions("TOP_X"), n2 = await this.predictorHttps.getMyPredictions(t3);
    if (n2.data.length > 0) {
      let o2 = n2.data.filter((p2) => p2.gameInstanceId === e3);
      return o2.length ? o2[0] : null;
    }
    return null;
  };
  getUserGameEditions = async (e3, t3, n2) => {
    t3 && t3.limit && this.validateLimitFilterOnGames(t3.limit), n2 = n2 || false;
    let o2 = this.predictorService.initGameTypePredictions("TOP_X", t3), p2 = [], d4 = await this.predictorHttps.getUserPredictionsNoRemap(e3, o2);
    if (d4.data.length > 0) {
      d4.data.forEach((_2) => {
        _2.game_instance_id && p2.push(_2.game_instance_id);
      });
      let h4 = this.predictorService.initGameFilters("TOP_X", null, p2), y4 = await this.predictorHttps.getUserGameEditions(h4, n2);
      return await this.predictorService.addPredictionProp(d4, y4);
    } else
      return new re2();
  };
  getUserGamePrediction = async (e3, t3, n2) => {
    n2 = n2 || false;
    let o2 = this.predictorService.initGameTypePredictions("TOP_X"), p2 = await this.predictorHttps.getUserPredictions(e3, n2, o2);
    if (p2.data.length > 0) {
      let d4 = p2.data.filter((h4) => h4.gameInstanceId === t3);
      return d4.length ? d4[0] : null;
    } else
      return null;
  };
  getMarketsResultsForGame = async (e3, t3) => {
    let n2 = await this.predictorHttps.getMarketResultsForGame(e3, t3);
    return await this.predictorService.completeGameMarketResults(n2, "TOP_X");
  };
  validateLimitFilterOnGames = (e3) => {
    if (e3 > 50)
      throw new ne(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
  };
};
var gr = class {
  predictorHttps = null;
  predictorService = null;
  idMapping = null;
  clientHttps = null;
  predictorValidator = null;
  constructor(e3) {
    this.predictorValidator = new ti(), this.idMapping = new ae(e3), this.predictorHttps = new ei(e3, this.idMapping), this.predictorService = new _t(e3, this.idMapping), this.clientHttps = new et(e3);
  }
  getConfig = async () => {
    let e3 = await this.clientHttps.getConfig("matchQuiz");
    return this.idMapping.idSchema !== "native" ? await this.predictorService.remapCompetitionsFromConfig(e3) : e3;
  };
  play = async (e3) => {
    e3 = this.predictorValidator.validateBodyFields("MATCH_QUIZ", e3);
    let t3 = e3.fixtures.map((n2) => this.predictorValidator.validateFixture(n2.matchId, n2.market, n2.prediction.value, n2.prediction.playerId));
    if (t3 && t3.length && this.idMapping.idSchema !== "native") {
      let n2 = [], o2 = [];
      t3.forEach((h4) => {
        n2.push(h4.matchId), h4 instanceof tt && h4.prediction.playerId && o2.push(h4.prediction.playerId);
      });
      let p2 = await this.predictorService.remapMatchIdToNative(n2), d4 = {};
      o2 && o2.length > 0 && (d4 = await this.predictorService.remapPlayerIdMapToNative(o2)), t3.forEach((h4, y4) => {
        h4.matchId = p2[y4], h4 instanceof tt && (h4.prediction.playerId = d4[h4.prediction.playerId]);
      });
    }
    return e3.fixtures = t3, await this.predictorHttps.makeFootballPrediction(e3);
  };
  delete = async (e3) => await this.predictorHttps.deleteFootballPrediction(e3);
  getGames = async (e3, t3) => {
    t3 = t3 || false;
    let n2 = this.predictorService.initGameFilters("MATCH_QUIZ", e3), o2 = await this.predictorHttps.getGames(n2, t3);
    return await this.predictorService.remapMatchIdsFixtures(o2);
  };
  getGameById = async (e3, t3) => {
    t3 = t3 || false;
    let n2 = await this.predictorHttps.getGameById(e3, t3);
    return await this.predictorService.remapMatchIdsFixtures(n2);
  };
  getGamePredictions = async (e3, t3, n2) => (n2 = n2 || false, t3 && (t3.type && delete t3.type, t3.status && delete t3.status, t3 = new Re(t3)), await this.predictorHttps.getGamePredictions(e3, n2, t3));
  getGameResults = async (e3, t3, n2) => {
    n2 = n2 || false, t3 && (t3 = new lr(t3));
    let o2 = await this.predictorHttps.getGameResults(e3, n2, t3);
    return await this.predictorService.remapMatchIdsFixtures(o2);
  };
  getCurrentGameResults = async (e3) => {
    e3 = e3 || false;
    let t3 = { status: "OPEN", type: "MATCH_QUIZ" };
    t3 = new rt(t3);
    let n2 = await this.predictorHttps.getGames(t3, e3), o2 = this.predictorService.getCurrentGameId(n2);
    return (await this.getGameResults(o2, null, e3)).data[0];
  };
  getMyGameEditions = async (e3, t3) => {
    e3 && e3.limit && this.validateLimitFilterOnGames(e3.limit), t3 = t3 || false;
    let n2 = this.predictorService.initGameTypePredictions("MATCH_QUIZ", e3), o2 = [], p2 = await this.predictorHttps.getMyPredictionsNoRemap(n2);
    if (p2.data.length > 0) {
      p2.data.forEach((y4) => {
        y4.game_instance_id && o2.push(y4.game_instance_id);
      });
      let d4 = this.predictorService.initGameFilters("MATCH_QUIZ", null, o2), h4 = await this.predictorHttps.getUserGameEditions(d4, t3);
      return await this.predictorService.addPredictionProp(p2, h4);
    } else
      return new re2();
  };
  getMyGamePrediction = async (e3) => {
    let t3 = this.predictorService.initGameTypePredictions("MATCH_QUIZ"), n2 = await this.predictorHttps.getMyPredictions(t3);
    if (n2.data.length > 0) {
      let o2 = n2.data.filter((p2) => p2.gameInstanceId === e3);
      return o2.length ? o2[0] : null;
    }
    return null;
  };
  getUserGameEditions = async (e3, t3, n2) => {
    t3 && t3.limit && this.validateLimitFilterOnGames(t3.limit), n2 = n2 || false;
    let o2 = this.predictorService.initGameTypePredictions("MATCH_QUIZ", t3), p2 = [], d4 = await this.predictorHttps.getUserPredictionsNoRemap(e3, o2);
    if (d4.data.length > 0) {
      d4.data.forEach((_2) => {
        _2.game_instance_id && p2.push(_2.game_instance_id);
      });
      let h4 = this.predictorService.initGameFilters("MATCH_QUIZ", null, p2), y4 = await this.predictorHttps.getUserGameEditions(h4, n2);
      return await this.predictorService.addPredictionProp(d4, y4);
    } else
      return new re2();
  };
  getUserGamePrediction = async (e3, t3, n2) => {
    n2 = n2 || false;
    let o2 = this.predictorService.initGameTypePredictions("MATCH_QUIZ"), p2 = await this.predictorHttps.getUserPredictions(e3, n2, o2);
    if (p2.data.length > 0) {
      let d4 = p2.data.filter((h4) => h4.gameInstanceId === t3);
      return d4.length ? d4[0] : null;
    } else
      return null;
  };
  getMarketsResultsForGame = async (e3, t3) => {
    let n2 = await this.predictorHttps.getMarketResultsForGame(e3, t3);
    return await this.predictorService.completeGameMarketResults(n2, "MATCH_QUIZ");
  };
  validateLimitFilterOnGames = (e3) => {
    if (e3 > 50)
      throw new ne(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
  };
};
var Ts = class {
  config = null;
  clientHttps = null;
  loyaltyHttps = null;
  loyaltyService = null;
  profileFacade = null;
  loyaltyValidator = null;
  idMapping = null;
  topXFacade = null;
  matchQuizFacade = null;
  constructor(e3, t3, n2, o2, p2) {
    this.config = e3, this.clientHttps = t3, this.loyaltyHttps = n2, this.profileFacade = new Mt(p2, o2), this.loyaltyService = new Fs(this.config), this.loyaltyValidator = new Ss(), this.idMapping = new ae(e3), this.topXFacade = new hr(e3, this.idMapping), this.matchQuizFacade = new gr(e3);
  }
  getConfig = async () => await this.clientHttps.getConfig("loyalty");
  getClientBadges = async () => {
    let e3 = await this.getConfig();
    return this.loyaltyService.buildClientBadges(e3.rewards.badges);
  };
  getTemplates = async (e3) => {
    let t3 = true;
    if (this.config.idSchema === "native")
      return await this.loyaltyHttps.getTemplates(e3, t3);
    let n2 = await this.loyaltyHttps.getTemplates(e3, t3);
    return n2.data = await this.loyaltyService.remapTemplatesIds([...n2.data]), n2;
  };
  getTemplateById = async (e3, t3) => {
    try {
      let n2 = false, p2 = (await this.loyaltyHttps.getTemplates(t3, n2)).filter((h4) => h4.id === e3);
      if (!p2.length)
        throw new ne(400, "INVALID_TEMPLATE", "Provided template ID does NOT exist! Try again with existing template ID.").errorMessage();
      return this.config.idSchema === "native" ? p2[0] : (await this.loyaltyService.remapTemplatesIds(p2))[0];
    } catch (n2) {
      throw console.warn("There was a problem retrieving specified template: ", n2), n2;
    }
  };
  getLeaderboard = async (e3, t3, n2) => {
    t3 = this.loyaltyService.initFilters(t3, "loyalty");
    let o2 = await this.loyaltyHttps.getLeaderboard(e3, n2, t3);
    return o2.data = await this.loyaltyService.addProfileModelToLeaderboad(o2.data), o2;
  };
  getLeaderboardForGame = async (e3, t3, n2) => {
    t3 = this.loyaltyService.initFilters(t3, "loyalty");
    let o2 = await this.loyaltyHttps.getLeaderboardForGame(e3, n2, t3);
    return o2.data = await this.loyaltyService.addProfileModelToLeaderboad(o2.data), o2;
  };
  getOwnRankings = async (e3, t3) => {
    let { id: n2 } = await this.profileFacade.getOwn();
    return this.getUserRankings(n2, e3, t3);
  };
  getUserRankings = async (e3, t3, n2) => {
    t3 = this.loyaltyService.initFilters(t3, "rankings");
    let o2 = await this.loyaltyHttps.getUserRankings(e3, t3, n2);
    return await this.getModelsForUserRankings(o2);
  };
  getHighestSuccessRate = async (e3, t3) => {
    e3 && this.loyaltyValidator.validateMarket(e3);
    let n2 = await this.loyaltyHttps.getHighestSuccessRate(e3, t3);
    return this.loyaltyService.addProfileModelToHighestSuccessRate(n2);
  };
  getModelsForUserRankings = async (e3) => {
    let t3 = null, n2 = null, o2 = null, [p2, d4, h4] = this.loyaltyService.extractRankingsIdsMap(e3.data);
    if (h4.length && (t3 = (await this.getTemplates()).data.filter((_2) => h4.includes(_2.id))), p2.length) {
      let y4 = { gameIds: p2 };
      n2 = (await this.topXFacade.getGames(y4)).data;
    }
    if (d4.length) {
      let y4 = { gameIds: d4 };
      o2 = (await this.matchQuizFacade.getGames(y4)).data;
    }
    return this.loyaltyService.setModelsForUserRankings(n2, o2, t3, e3);
  };
};
var Es = class {
  clientHttps = null;
  profileHttps = null;
  loyaltyHttps = null;
  loyaltyFacade = null;
  localStorage = null;
  constructor(e3) {
    this.clientHttps = new et(e3), this.profileHttps = new Ui(e3), this.loyaltyHttps = new Is(e3), this.localStorage = new yt(e3), this.loyaltyFacade = new Ts(e3, this.clientHttps, this.loyaltyHttps, this.profileHttps, this.localStorage);
  }
  getConfig = async () => await this.loyaltyFacade.getConfig();
  getClientBadges = async () => await this.loyaltyFacade.getClientBadges();
  getTemplates = async (e3) => await this.loyaltyFacade.getTemplates(e3);
  getTemplateById = async (e3, t3) => await this.loyaltyFacade.getTemplateById(e3, t3);
  getLeaderboard = async (e3, t3, n2) => await this.loyaltyFacade.getLeaderboard(e3, t3, n2);
  getLeaderboardForGame = async (e3, t3, n2) => await this.loyaltyFacade.getLeaderboardForGame(e3, t3, n2);
  getOwnRankings = async (e3, t3) => await this.loyaltyFacade.getOwnRankings(e3, t3);
  getUserRankings = async (e3, t3, n2) => await this.loyaltyFacade.getUserRankings(e3, t3, n2);
  getHighestSuccessRate = async (e3, t3) => await this.loyaltyFacade.getHighestSuccessRate(e3, t3);
};
var Cs = class {
  topXFacade = null;
  idMapping = null;
  constructor(e3) {
    this.idMapping = new ae(e3), this.topXFacade = new hr(e3, this.idMapping);
  }
  getConfig = async () => await this.topXFacade.getConfig();
  getGames = async (e3, t3) => await this.topXFacade.getGames(e3, t3);
  getGameById = async (e3, t3) => await this.topXFacade.getGameById(e3, t3);
  getGamePredictions = async (e3, t3, n2) => await this.topXFacade.getGamePredictions(e3, t3, n2);
  getGameResults = async (e3, t3, n2) => await this.topXFacade.getGameResults(e3, t3, n2);
  getCurrentGameResults = async (e3) => await this.topXFacade.getCurrentGameResults(e3);
  play = async (e3) => await this.topXFacade.play(e3);
  delete = async (e3) => await this.topXFacade.delete(e3);
  getMyGameEditions = async (e3, t3) => await this.topXFacade.getMyGameEditions(e3, t3);
  getMyGamePrediction = async (e3) => await this.topXFacade.getMyGamePrediction(e3);
  getUserGameEditions = async (e3, t3, n2) => await this.topXFacade.getUserGameEditions(e3, t3, n2);
  getUserGamePrediction = async (e3, t3, n2) => await this.topXFacade.getUserGamePrediction(e3, t3, n2);
  getMarketsResultsForGame = async (e3, t3) => await this.topXFacade.getMarketsResultsForGame(e3, t3);
};
var As = class {
  matchQuizFacade = null;
  constructor(e3) {
    this.matchQuizFacade = new gr(e3);
  }
  getConfig = async () => await this.matchQuizFacade.getConfig();
  play = async (e3) => await this.matchQuizFacade.play(e3);
  delete = async (e3) => await this.matchQuizFacade.delete(e3);
  getGames = async (e3, t3) => await this.matchQuizFacade.getGames(e3, t3);
  getGameById = async (e3, t3) => await this.matchQuizFacade.getGameById(e3, t3);
  getGamePredictions = async (e3, t3, n2) => await this.matchQuizFacade.getGamePredictions(e3, t3, n2);
  getGameResults = async (e3, t3, n2) => await this.matchQuizFacade.getGameResults(e3, t3, n2);
  getCurrentGameResults = async (e3) => await this.matchQuizFacade.getCurrentGameResults(e3);
  getMyGameEditions = async (e3, t3) => await this.matchQuizFacade.getMyGameEditions(e3, t3);
  getMyGamePrediction = async (e3) => await this.matchQuizFacade.getMyGamePrediction(e3);
  getUserGameEditions = async (e3, t3, n2) => await this.matchQuizFacade.getUserGameEditions(e3, t3, n2);
  getUserGamePrediction = async (e3, t3, n2) => await this.matchQuizFacade.getUserGamePrediction(e3, t3, n2);
  getMarketsResultsForGame = async (e3, t3) => await this.matchQuizFacade.getMarketsResultsForGame(e3, t3);
};
var an = class {
  action = null;
  page = null;
  limit = null;
  constructor(e3) {
    this.action = e3.action ? e3.action : null, this.page = e3.page ? e3.page : null, this.limit = e3.limit ? e3.limit : null;
  }
  constructFilterUrl = () => {
    let e3 = "";
    return this.action && (e3 += "&", e3 += `action=${this.action}`), this.page && (e3 += "&", e3 += `page=${this.page}`), this.limit && (e3 += "&", e3 += `limit=${this.limit}`), e3;
  };
};
var on = class {
  action = null;
  context = new Ji();
  constructor(e3, t3, n2, o2) {
    this.action = e3, this.context.tags = t3, n2 && (this.context.content = n2), o2 && (this.context.campaign = o2);
  }
};
var xs = class {
  idSchema;
  idMapping;
  constructor(e3) {
    this.idSchema = e3.idSchema, this.idMapping = new ae(e3);
  }
  remapTagsIds = async (e3, t3, n2) => {
    let o2 = {}, p2 = {}, d4 = [];
    e3.forEach((y4) => {
      o2.hasOwnProperty(y4.type) || (o2[y4.type] = [], p2[y4.type] = []), o2[y4.type].push(y4.id), p2[y4.type].push(y4);
    });
    let h4 = await this.idMapping.idMappingFacade.getEntitiesByIds(o2, t3, n2);
    for (let [y4, _2] of Object.entries(p2))
      _2.forEach((w3, S4) => {
        w3.id = h4[y4][S4], d4.push(w3);
      });
    return d4;
  };
};
var Os = class {
  idSchema;
  activityHttps;
  activityService;
  constructor(e3) {
    this.idSchema = e3.idSchema, this.activityHttps = new ji(e3), this.activityService = new xs(e3);
  }
  add = async (e3, t3, n2, o2) => {
    if (this.idSchema != "native") {
      let d4 = JSON.parse(JSON.stringify(t3)), h4 = await this.activityService.remapTagsIds(t3, this.idSchema, "native"), y4 = new on(e3, h4, n2, o2), _2 = await this.activityHttps.createActivity(y4);
      return _2.context.tags = d4, _2;
    }
    let p2 = new on(e3, t3, n2, o2);
    return this.activityHttps.createActivity(p2);
  };
  delete = async (e3) => await this.activityHttps.deleteActivity(e3);
  like = async (e3, t3, n2) => {
    let o2 = "like";
    return await this.add(o2, e3, t3, n2);
  };
  dislike = async (e3, t3, n2) => {
    let o2 = "dislike";
    return await this.add(o2, e3, t3, n2);
  };
  addPageview = async (e3, t3, n2) => {
    let o2 = "page_view";
    return await this.add(o2, e3, t3, n2);
  };
  addContentConsumed = async (e3, t3, n2) => {
    let o2 = "content_consumed";
    return await this.add(o2, e3, t3, n2);
  };
  addShare = async (e3, t3, n2) => {
    let o2 = "share";
    return await this.add(o2, e3, t3, n2);
  };
  addComment = async (e3, t3, n2) => {
    let o2 = "comment";
    return await this.add(o2, e3, t3, n2);
  };
  addClickAd = async (e3, t3, n2) => {
    let o2 = "click_ad";
    return await this.add(o2, e3, t3, n2);
  };
  addConversion = async (e3, t3, n2) => {
    let o2 = "conversion";
    return await this.add(o2, e3, t3, n2);
  };
  getOwn = async (e3, t3) => {
    if (t3 = t3 || false, e3 && (e3 = new an(e3)), this.idSchema != "native") {
      let n2 = await this.activityHttps.getOwnActivities(e3, t3);
      for (let o2 of n2.data)
        await this.activityService.remapTagsIds(o2.context.tags, "native", this.idSchema);
      return n2;
    }
    return await this.activityHttps.getOwnActivities(e3, t3);
  };
  getForUser = async (e3, t3, n2) => {
    if (n2 = n2 || false, t3 && (t3 = new an(t3)), this.idSchema != "native") {
      let o2 = await this.activityHttps.getActivitiesForUser(e3, t3, n2);
      for (let p2 of o2.data)
        await this.activityService.remapTagsIds(p2.context.tags, "native", this.idSchema);
      return o2;
    }
    return await this.activityHttps.getActivitiesForUser(e3, t3, n2);
  };
};
var Bs = class {
  activityFacade;
  constructor(e3) {
    this.activityFacade = new Os(e3);
  }
  add = async (e3, t3, n2, o2) => await this.activityFacade.add(e3, t3, n2, o2);
  delete = async (e3) => await this.activityFacade.delete(e3);
  like = async (e3, t3, n2) => await this.activityFacade.like(e3, t3, n2);
  dislike = async (e3, t3, n2) => await this.activityFacade.dislike(e3, t3, n2);
  addPageview = async (e3, t3, n2) => await this.activityFacade.addPageview(e3, t3, n2);
  addContentConsumed = async (e3, t3, n2) => await this.activityFacade.addContentConsumed(e3, t3, n2);
  addShare = async (e3, t3, n2) => await this.activityFacade.addShare(e3, t3, n2);
  addComment = async (e3, t3, n2) => await this.activityFacade.addComment(e3, t3, n2);
  addClickAd = async (e3, t3, n2) => await this.activityFacade.addClickAd(e3, t3, n2);
  addConversion = async (e3, t3, n2) => await this.activityFacade.addConversion(e3, t3, n2);
  getOwn = async (e3, t3) => await this.activityFacade.getOwn(e3, t3);
  getForUser = async (e3, t3, n2) => await this.activityFacade.getForUser(e3, t3, n2);
};
function yB(s4) {
  let t3 = new No().validate(s4);
  if ((t3.idSchema.validation === "missing" || t3.idSchema.validation === "invalid") && (console.warn(t3.idSchema.message.text), s4.idSchema = "native"), (t3.environment.validation === "missing" || t3.environment.validation === "invalid") && (console.warn(t3.environment.message.text), s4.environment = "prod"), (t3.lang.validation === "missing" || t3.lang.validation === "invalid") && (console.warn(t3.lang.message.text), s4.lang = "en"), t3.authProvider.validation === "invalid" && console.warn(t3.authProvider.message.text), t3.isValid)
    return { profile: new er(s4), football: new Do(s4), predictor: new fs(s4), loyalty: new Es(s4), topX: new Cs(s4), matchQuiz: new As(s4), activity: new Bs(s4) };
  L_(t3);
}
var L_ = (s4) => {
  let e3 = "authProvider", t3 = "isValid";
  Object.keys(s4).forEach((n2) => {
    let o2 = s4[n2];
    if (n2 !== t3 && n2 !== e3) {
      if (o2.message.type === "error")
        throw new Error(o2.message.text);
    } else
      n2 !== t3 && n2 === e3 && Object.keys(new fi()).forEach((p2) => {
        if (o2[p2].message.type === "error")
          throw new Error(o2[p2].message.text);
      });
  });
};

// ../lib/SMPFansUnitedSDK.ts
var SMPFansUnitedSDK_default = ({ apiKey, environment = "prod", clientId, lang = "en", idSchema = "sportal365", authProvider }) => {
  return yB({
    apiKey,
    environment,
    clientId,
    lang,
    idSchema,
    authProvider
  });
};

// ../constants/windowTarget.ts
var TARGET_BLANK = "_blank";

// ../hooks/useRootNodeRef.ts
import { useRef as useRef5, useEffect as useEffect8, useState as useState9 } from "react";

// ../constants/widgetAttributes.ts
var WidgetAttributes;
(function(WidgetAttributes3) {
  WidgetAttributes3["WIDGET_SPORT"] = "data-widget-sport";
  WidgetAttributes3["WIDGET_TYPE"] = "data-widget-type";
  WidgetAttributes3["WIDGET_ID"] = "data-widget-id";
  WidgetAttributes3["DATE"] = "data-date";
  WidgetAttributes3["NAME_TYPE"] = "data-team-name-type";
  WidgetAttributes3["REFRESH_TIME"] = "data-refresh-time";
  WidgetAttributes3["ENTITY_LINKS"] = "data-entity-links";
  WidgetAttributes3["THEME"] = "data-theme";
  WidgetAttributes3["POPULAR_LIST"] = "data-popular-list";
  WidgetAttributes3["LABELS"] = "data-labels";
  WidgetAttributes3["DROPDOWN_DISPLAY"] = "data-dropdown-display";
  WidgetAttributes3["HEADER_DEFAULT_OPTION"] = "data-header-default-option";
  WidgetAttributes3["HEADER_DISPLAY"] = "data-header-display";
  WidgetAttributes3["ODDS_BETTING_ID"] = "data-odds-betting-id";
  WidgetAttributes3["ODDS_DISPLAY"] = "data-odds-display";
  WidgetAttributes3["ODDS_MARKET"] = "data-odds-market";
  WidgetAttributes3["ODDS_PRE_EVENT_ONLY"] = "data-odds-pre-event-only";
  WidgetAttributes3["ODDS_MARKET_VALUE_TYPE"] = "data-odds-market-value-type";
  WidgetAttributes3["OPTIONS_DISPLAY"] = "data-options-display";
  WidgetAttributes3["ODDS_TAB_BETTING_ID"] = "data-odds-tab-betting-id";
  WidgetAttributes3["AGE_RESTRICTION_DISPLAY"] = "data-age-restriction-display";
  WidgetAttributes3["MATCH"] = "data-match-id";
  WidgetAttributes3["SHORT_STATUS_TYPE"] = "data-short-status-type";
  WidgetAttributes3["COMPETITION"] = "data-competition";
  WidgetAttributes3["STAGE"] = "data-stage";
  WidgetAttributes3["SEASON"] = "data-season";
  WidgetAttributes3["PLAYER"] = "data-player";
  WidgetAttributes3["TEAM"] = "data-team";
  WidgetAttributes3["TABS"] = "data-tabs";
  WidgetAttributes3["DISPLAY_TABS"] = "data-display-tabs";
  WidgetAttributes3["DEFAULT_TAB"] = "data-default-tab";
  WidgetAttributes3["ROUND"] = "data-round";
  WidgetAttributes3["ROUNDS"] = "data-rounds";
  WidgetAttributes3["ROUNDS_FILTER"] = "data-rounds-filter";
  WidgetAttributes3["MATCH_TYPE"] = "data-match-type";
  WidgetAttributes3["SORT_DIRECTION"] = "data-sort-direction";
  WidgetAttributes3["SORT_DIRECTION_RESULTS"] = "data-sort-direction-results";
  WidgetAttributes3["SORT_DIRECTION_FIXTURES"] = "data-sort-direction-fixtures";
  WidgetAttributes3["FANS_UNITED_API_KEY"] = "fans-united-api-key";
  WidgetAttributes3["FANS_UNITED_CLIENT_ID"] = "fans-united-client-id";
  WidgetAttributes3["FANS_UNITED_EXPANDED"] = "fans-united-expanded";
  WidgetAttributes3["FANS_UNITED_TOKEN"] = "fans-united-token";
  WidgetAttributes3["FANS_UNITED_ID_SCHEMA"] = "fans-united-id-schema";
  WidgetAttributes3["FANS_UNITED_ENABLED"] = "fans-united-enabled";
  WidgetAttributes3["FANS_UNITED_ENVIRONMENT"] = "fans-united-environment";
  WidgetAttributes3["FANS_UNITED_HIDE_BEFORE_GAME_START"] = "fans-united-hide-before-game-start";
  WidgetAttributes3["FANS_UNITED_SHOW_FROM"] = "fans-united-show-from";
  WidgetAttributes3["GROUPS"] = "data-groups";
  WidgetAttributes3["DISPLAY_STATISTICS"] = "data-display-statistics";
  WidgetAttributes3["LIMIT"] = "data-limit";
  WidgetAttributes3["DATA_TEAM_IDS"] = "data-team-ids";
  WidgetAttributes3["DATA_LIMIT"] = "data-limit";
  WidgetAttributes3["DATA_START_POSITION"] = "data-start-position";
  WidgetAttributes3["DATA_HIGHLIGHT_ENTITIES"] = "data-highlight-entities";
  WidgetAttributes3["SPORT_ENTITY_ONE"] = "data-sport-entity-one";
  WidgetAttributes3["SPORT_ENTITY_TWO"] = "data-sport-entity-two";
  WidgetAttributes3["ELEMENTS"] = "data-elements";
  WidgetAttributes3["ELEMENTS_MOBILE"] = "data-elements-mobile";
  WidgetAttributes3["ELEMENTS_DESKTOP"] = "data-elements-desktop";
  WidgetAttributes3["TEAM_TYPE"] = "data-team-type";
  WidgetAttributes3["DATA_OFFSET"] = "data-offset";
  WidgetAttributes3["DATA_STANDING_TYPE_SUBCATEGORY"] = "data-standing-type-subcategory";
  WidgetAttributes3["TOURNAMENT"] = "data-tournament";
  WidgetAttributes3["HOME_TEAM_COLOR"] = "data-home-team-color";
  WidgetAttributes3["AWAY_TEAM_COLOR"] = "data-away-team-color";
  WidgetAttributes3["ALLOW_INLINE_ODDS"] = "data-allow-inline-odds";
  WidgetAttributes3["ADDITIONAL_INFO"] = "data-additional-info";
  WidgetAttributes3["IMAGE_DISPLAY"] = "data-image-display";
  WidgetAttributes3["AMOUNT"] = "data-amount";
  WidgetAttributes3["WRAPPER_LINK"] = "data-wrapper-link";
  WidgetAttributes3["GAME_TYPE"] = "data-game-type";
  WidgetAttributes3["GENDER"] = "data-gender";
  WidgetAttributes3["FIXED"] = "data-fixed";
  WidgetAttributes3["DATA_DATE_FROM"] = "data-date-from";
  WidgetAttributes3["DATA_DATE_TO"] = "data-date-to";
  WidgetAttributes3["BETTING_BRAND_COLORS"] = "data-betting-brand-colors";
  WidgetAttributes3["BETTING_LOGO_CLICK_ACTION"] = "data-betting-logo-click-action";
  WidgetAttributes3["BETTING_LOGO_OVERLAP"] = "data-betting-logo-overlap";
  WidgetAttributes3["BETTING_LOGO_DISPLAY"] = "data-betting-logo-display";
  WidgetAttributes3["DATA_ODDS_CLICKABLE"] = "data-odds-clickable";
  WidgetAttributes3["DATA_SHOW_COMPETITION_NAMES"] = "data-show-competition-names";
  WidgetAttributes3["NAME_FORMAT"] = "data-name-format";
  WidgetAttributes3["COMPETITIONS"] = "data-competitions";
  WidgetAttributes3["SPORT"] = "data-sport";
  WidgetAttributes3["DATA_MATCH_DISPLAY"] = "data-match-display";
  WidgetAttributes3["DATA_STATISTICS_DISPLAY"] = "data-statistics-display";
  WidgetAttributes3["CURRENCY_POSITION"] = "data-currency-symbol-position";
  WidgetAttributes3["SINGLE_EVENT_MAIN_EVENTS_DISPLAY"] = "data-single-event-main-events-display";
  WidgetAttributes3["MATCH_CENTER_EVENT_MAIN_EVENTS_DISPLAY"] = "data-match-center-main-events-display";
  WidgetAttributes3["DATE_FORMAT"] = "data-date-format";
  WidgetAttributes3["DATA_DISPLAY_SOCIAL_ICONS"] = "data-display-social-icons";
  WidgetAttributes3["DATA_DISPLAY_TEAM_IMAGE"] = "data-display-team-image";
  WidgetAttributes3["DATA_COUNTRY_ID"] = "data-country-id";
})(WidgetAttributes || (WidgetAttributes = {}));
var widgetAttributes_default = WidgetAttributes;

// ../utils/dist/index.mjs
import { Buffer as Buffer2 } from "buffer";
import React14 from "react";
var ENTITY_TYPES = {
  team: "team",
  player: "player",
  venue: "venue",
  coach: "coach",
  referee: "referee",
  standingsTournament: "standings_tournament",
  match: "match",
  tournament: "tournament",
  standingsStage: "standings_stage",
  competition: "competition",
  standings: "standings",
  arena: "arena",
  season: "season",
  stage: "stage",
  game: "game"
};
var listOfAvailableEntities = [
  ENTITY_TYPES.team,
  ENTITY_TYPES.player,
  ENTITY_TYPES.venue,
  ENTITY_TYPES.coach,
  ENTITY_TYPES.referee,
  ENTITY_TYPES.standingsTournament,
  ENTITY_TYPES.match,
  ENTITY_TYPES.tournament,
  ENTITY_TYPES.standingsStage,
  ENTITY_TYPES.arena,
  ENTITY_TYPES.standings,
  ENTITY_TYPES.competition,
  ENTITY_TYPES.season,
  ENTITY_TYPES.stage,
  ENTITY_TYPES.game
];
var SLUG_ENTITY;
(function(SLUG_ENTITY2) {
  SLUG_ENTITY2["SLUG"] = "slug";
})(SLUG_ENTITY || (SLUG_ENTITY = {}));
var Sports2;
(function(Sports22) {
  Sports22["FOOTBALL"] = "football";
  Sports22["BASKETBALL"] = "basketball";
  Sports22["TENNIS"] = "tennis";
  Sports22["MULTISPORT"] = "multisport";
  Sports22["ICE_HOCKEY"] = "ice-hockey";
})(Sports2 || (Sports2 = {}));
var FootballStandingsElements2;
(function(FootballStandingsElements22) {
  FootballStandingsElements22["MATCHES_PLAYED"] = "matches_played";
  FootballStandingsElements22["MATCHES_WON"] = "matches_won";
  FootballStandingsElements22["MATCH_LOSSES"] = "match_losses";
  FootballStandingsElements22["MATCH_DRAW"] = "match_draw";
  FootballStandingsElements22["GOAL_DIFFERENCE"] = "goal_difference";
  FootballStandingsElements22["POINTS"] = "points";
  FootballStandingsElements22["TEAM_FORM"] = "team_form";
})(FootballStandingsElements2 || (FootballStandingsElements2 = {}));
var TableVariants2;
(function(TableVariants22) {
  TableVariants22["STATS"] = "stats_table";
  TableVariants22["STANDINGS"] = "standings";
  TableVariants22["DEFAULT"] = "default";
})(TableVariants2 || (TableVariants2 = {}));
var WidgetAttributes2;
(function(WidgetAttributes22) {
  WidgetAttributes22["WIDGET_SPORT"] = "data-widget-sport";
  WidgetAttributes22["WIDGET_TYPE"] = "data-widget-type";
  WidgetAttributes22["WIDGET_ID"] = "data-widget-id";
  WidgetAttributes22["DATE"] = "data-date";
  WidgetAttributes22["NAME_TYPE"] = "data-team-name-type";
  WidgetAttributes22["REFRESH_TIME"] = "data-refresh-time";
  WidgetAttributes22["ENTITY_LINKS"] = "data-entity-links";
  WidgetAttributes22["THEME"] = "data-theme";
  WidgetAttributes22["POPULAR_LIST"] = "data-popular-list";
  WidgetAttributes22["LABELS"] = "data-labels";
  WidgetAttributes22["DROPDOWN_DISPLAY"] = "data-dropdown-display";
  WidgetAttributes22["HEADER_DEFAULT_OPTION"] = "data-header-default-option";
  WidgetAttributes22["HEADER_DISPLAY"] = "data-header-display";
  WidgetAttributes22["ODDS_BETTING_ID"] = "data-odds-betting-id";
  WidgetAttributes22["ODDS_DISPLAY"] = "data-odds-display";
  WidgetAttributes22["ODDS_MARKET"] = "data-odds-market";
  WidgetAttributes22["ODDS_PRE_EVENT_ONLY"] = "data-odds-pre-event-only";
  WidgetAttributes22["ODDS_MARKET_VALUE_TYPE"] = "data-odds-market-value-type";
  WidgetAttributes22["OPTIONS_DISPLAY"] = "data-options-display";
  WidgetAttributes22["ODDS_TAB_BETTING_ID"] = "data-odds-tab-betting-id";
  WidgetAttributes22["AGE_RESTRICTION_DISPLAY"] = "data-age-restriction-display";
  WidgetAttributes22["MATCH"] = "data-match-id";
  WidgetAttributes22["SHORT_STATUS_TYPE"] = "data-short-status-type";
  WidgetAttributes22["COMPETITION"] = "data-competition";
  WidgetAttributes22["STAGE"] = "data-stage";
  WidgetAttributes22["SEASON"] = "data-season";
  WidgetAttributes22["PLAYER"] = "data-player";
  WidgetAttributes22["TEAM"] = "data-team";
  WidgetAttributes22["TABS"] = "data-tabs";
  WidgetAttributes22["DISPLAY_TABS"] = "data-display-tabs";
  WidgetAttributes22["DEFAULT_TAB"] = "data-default-tab";
  WidgetAttributes22["ROUND"] = "data-round";
  WidgetAttributes22["ROUNDS"] = "data-rounds";
  WidgetAttributes22["ROUNDS_FILTER"] = "data-rounds-filter";
  WidgetAttributes22["MATCH_TYPE"] = "data-match-type";
  WidgetAttributes22["SORT_DIRECTION"] = "data-sort-direction";
  WidgetAttributes22["SORT_DIRECTION_RESULTS"] = "data-sort-direction-results";
  WidgetAttributes22["SORT_DIRECTION_FIXTURES"] = "data-sort-direction-fixtures";
  WidgetAttributes22["FANS_UNITED_API_KEY"] = "fans-united-api-key";
  WidgetAttributes22["FANS_UNITED_CLIENT_ID"] = "fans-united-client-id";
  WidgetAttributes22["FANS_UNITED_EXPANDED"] = "fans-united-expanded";
  WidgetAttributes22["FANS_UNITED_TOKEN"] = "fans-united-token";
  WidgetAttributes22["FANS_UNITED_ID_SCHEMA"] = "fans-united-id-schema";
  WidgetAttributes22["FANS_UNITED_ENABLED"] = "fans-united-enabled";
  WidgetAttributes22["FANS_UNITED_ENVIRONMENT"] = "fans-united-environment";
  WidgetAttributes22["FANS_UNITED_HIDE_BEFORE_GAME_START"] = "fans-united-hide-before-game-start";
  WidgetAttributes22["FANS_UNITED_SHOW_FROM"] = "fans-united-show-from";
  WidgetAttributes22["GROUPS"] = "data-groups";
  WidgetAttributes22["DISPLAY_STATISTICS"] = "data-display-statistics";
  WidgetAttributes22["LIMIT"] = "data-limit";
  WidgetAttributes22["DATA_TEAM_IDS"] = "data-team-ids";
  WidgetAttributes22["DATA_LIMIT"] = "data-limit";
  WidgetAttributes22["DATA_START_POSITION"] = "data-start-position";
  WidgetAttributes22["DATA_HIGHLIGHT_ENTITIES"] = "data-highlight-entities";
  WidgetAttributes22["SPORT_ENTITY_ONE"] = "data-sport-entity-one";
  WidgetAttributes22["SPORT_ENTITY_TWO"] = "data-sport-entity-two";
  WidgetAttributes22["ELEMENTS"] = "data-elements";
  WidgetAttributes22["ELEMENTS_MOBILE"] = "data-elements-mobile";
  WidgetAttributes22["ELEMENTS_DESKTOP"] = "data-elements-desktop";
  WidgetAttributes22["TEAM_TYPE"] = "data-team-type";
  WidgetAttributes22["DATA_OFFSET"] = "data-offset";
  WidgetAttributes22["DATA_STANDING_TYPE_SUBCATEGORY"] = "data-standing-type-subcategory";
  WidgetAttributes22["TOURNAMENT"] = "data-tournament";
  WidgetAttributes22["HOME_TEAM_COLOR"] = "data-home-team-color";
  WidgetAttributes22["AWAY_TEAM_COLOR"] = "data-away-team-color";
  WidgetAttributes22["ALLOW_INLINE_ODDS"] = "data-allow-inline-odds";
  WidgetAttributes22["ADDITIONAL_INFO"] = "data-additional-info";
  WidgetAttributes22["IMAGE_DISPLAY"] = "data-image-display";
  WidgetAttributes22["AMOUNT"] = "data-amount";
  WidgetAttributes22["WRAPPER_LINK"] = "data-wrapper-link";
  WidgetAttributes22["GAME_TYPE"] = "data-game-type";
  WidgetAttributes22["GENDER"] = "data-gender";
  WidgetAttributes22["FIXED"] = "data-fixed";
  WidgetAttributes22["DATA_DATE_FROM"] = "data-date-from";
  WidgetAttributes22["DATA_DATE_TO"] = "data-date-to";
  WidgetAttributes22["BETTING_BRAND_COLORS"] = "data-betting-brand-colors";
  WidgetAttributes22["BETTING_LOGO_CLICK_ACTION"] = "data-betting-logo-click-action";
  WidgetAttributes22["BETTING_LOGO_OVERLAP"] = "data-betting-logo-overlap";
  WidgetAttributes22["BETTING_LOGO_DISPLAY"] = "data-betting-logo-display";
  WidgetAttributes22["DATA_ODDS_CLICKABLE"] = "data-odds-clickable";
  WidgetAttributes22["DATA_SHOW_COMPETITION_NAMES"] = "data-show-competition-names";
  WidgetAttributes22["NAME_FORMAT"] = "data-name-format";
  WidgetAttributes22["COMPETITIONS"] = "data-competitions";
  WidgetAttributes22["SPORT"] = "data-sport";
  WidgetAttributes22["DATA_MATCH_DISPLAY"] = "data-match-display";
  WidgetAttributes22["DATA_STATISTICS_DISPLAY"] = "data-statistics-display";
  WidgetAttributes22["CURRENCY_POSITION"] = "data-currency-symbol-position";
  WidgetAttributes22["SINGLE_EVENT_MAIN_EVENTS_DISPLAY"] = "data-single-event-main-events-display";
  WidgetAttributes22["MATCH_CENTER_EVENT_MAIN_EVENTS_DISPLAY"] = "data-match-center-main-events-display";
  WidgetAttributes22["DATE_FORMAT"] = "data-date-format";
  WidgetAttributes22["DATA_DISPLAY_SOCIAL_ICONS"] = "data-display-social-icons";
  WidgetAttributes22["DATA_DISPLAY_TEAM_IMAGE"] = "data-display-team-image";
  WidgetAttributes22["DATA_COUNTRY_ID"] = "data-country-id";
})(WidgetAttributes2 || (WidgetAttributes2 = {}));
var WidgetTypes2;
(function(WidgetTypes22) {
  WidgetTypes22["TOURNAMENT"] = "tournament";
  WidgetTypes22["TEAM"] = "team";
  WidgetTypes22["PLAYER"] = "player";
  WidgetTypes22["EVENT"] = "event";
  WidgetTypes22["H2H"] = "h2h";
  WidgetTypes22["MULTISPORT"] = "multisport";
})(WidgetTypes2 || (WidgetTypes2 = {}));
var THEME_VARIANTS2;
(function(THEME_VARIANTS22) {
  THEME_VARIANTS22["LIGHT"] = "light";
  THEME_VARIANTS22["DARK"] = "dark";
  THEME_VARIANTS22["CLIENT"] = "client";
})(THEME_VARIANTS2 || (THEME_VARIANTS2 = {}));
var LineupStatuses2;
(function(LineupStatuses22) {
  LineupStatuses22["NOT_AVAILABLE"] = "NOT_AVAILABLE";
  LineupStatuses22["UNCONFIRMED"] = "UNCONFIRMED";
  LineupStatuses22["CONFIRMED"] = "CONFIRMED";
})(LineupStatuses2 || (LineupStatuses2 = {}));
var IMostDecoratedDataLabelsKeys2;
(function(IMostDecoratedDataLabelsKeys22) {
  IMostDecoratedDataLabelsKeys22["FIRST_YELLOW_CARDS"] = "first_yellow_cards";
  IMostDecoratedDataLabelsKeys22["RED_CARDS"] = "red_cards";
  IMostDecoratedDataLabelsKeys22["TOTAL_CARDS"] = "total_cards";
  IMostDecoratedDataLabelsKeys22["YELLOW_CARDS"] = "yellow_cards";
})(IMostDecoratedDataLabelsKeys2 || (IMostDecoratedDataLabelsKeys2 = {}));
var ITopScorersDataLabelsKeys2;
(function(ITopScorersDataLabelsKeys22) {
  ITopScorersDataLabelsKeys22["ASSISTS"] = "assists";
  ITopScorersDataLabelsKeys22["GOALS"] = "goals";
  ITopScorersDataLabelsKeys22["MINUTES"] = "minutes";
  ITopScorersDataLabelsKeys22["PENALTIES"] = "penalties";
  ITopScorersDataLabelsKeys22["PLAYED"] = "played";
  ITopScorersDataLabelsKeys22["RED_CARDS"] = "red_cards";
  ITopScorersDataLabelsKeys22["SCORED_FIRST"] = "scored_first";
  ITopScorersDataLabelsKeys22["YELLOW_CARDS"] = "yellow_cards";
  ITopScorersDataLabelsKeys22["MISSED_PENALTIES"] = "missed_penalties";
})(ITopScorersDataLabelsKeys2 || (ITopScorersDataLabelsKeys2 = {}));
var Movement2;
(function(Movement22) {
  Movement22["UP"] = "UP";
  Movement22["DOWN"] = "DOWN";
  Movement22["NONE"] = "NONE";
})(Movement2 || (Movement2 = {}));
var OddsMarketTypes2;
(function(OddsMarketTypes22) {
  OddsMarketTypes22["ONETWO"] = "12";
  OddsMarketTypes22["ONEXTWO"] = "1x2";
  OddsMarketTypes22["OVER_UNDER"] = "OVER_UNDER";
  OddsMarketTypes22["DOUBLE_CHANCE"] = "DOUBLE_CHANCE";
  OddsMarketTypes22["BOTH_TO_SCORE"] = "BOTH_TO_SCORE";
  OddsMarketTypes22["DRAW_NO_BET"] = "DRAW_NO_BET";
  OddsMarketTypes22["FIRST_TEAM_TO_SCORE"] = "FIRST_TEAM_TO_SCORE";
  OddsMarketTypes22["GAME_HANDICAP"] = "GAME_HANDICAP";
  OddsMarketTypes22["FIRST_HALF"] = "FIRST_HALF";
  OddsMarketTypes22["SECOND_HALF"] = "SECOND_HALF";
  OddsMarketTypes22["FULL_TIME"] = "FULL_TIME";
  OddsMarketTypes22["FIRST_HALF_GOALS"] = "FIRST_HALF_GOALS";
  OddsMarketTypes22["CORRECT_SCORE"] = "CORRECT_SCORE";
  OddsMarketTypes22["FIRST_PLAYER_TO_SCORE"] = "FIRST_PLAYER_TO_SCORE";
  OddsMarketTypes22["PLAYER_TO_SCORE_DURING_GAME"] = "PLAYER_TO_SCORE_DURING_GAME";
  OddsMarketTypes22["PLAYER_TO_RECEIVE_CARD"] = "PLAYER_TO_RECEIVE_CARD";
  OddsMarketTypes22["FIRST_HALF_AND_FINAL_RESULT"] = "FIRST_HALF_AND_FINAL_RESULT";
})(OddsMarketTypes2 || (OddsMarketTypes2 = {}));
var OddFormat2;
(function(OddFormat22) {
  OddFormat22["FRACTIONAL"] = "FRACTIONAL";
  OddFormat22["DECIMAL"] = "DECIMAL";
  OddFormat22["MONEYLINE"] = "MONEYLINE";
})(OddFormat2 || (OddFormat2 = {}));
var OddsTypes2;
(function(OddsTypes22) {
  OddsTypes22["PRE_EVENT"] = "PRE_EVENT";
  OddsTypes22["ALL"] = "ALL";
})(OddsTypes2 || (OddsTypes2 = {}));
var HeaderLabels2;
(function(HeaderLabels22) {
  HeaderLabels22["OVERTIME"] = "overtime_short";
  HeaderLabels22["POINTS"] = "points_short";
  HeaderLabels22["SCORE"] = "score_short";
})(HeaderLabels2 || (HeaderLabels2 = {}));
var SocialLabels2;
(function(SocialLabels22) {
  SocialLabels22["FACEBOOK"] = "facebook";
  SocialLabels22["TWITTER"] = "twitter";
  SocialLabels22["YOUTUBE"] = "youtube";
  SocialLabels22["WIKIPEDIA"] = "wikipedia";
  SocialLabels22["WEB"] = "web";
  SocialLabels22["INSTAGRAM"] = "instagram";
})(SocialLabels2 || (SocialLabels2 = {}));
var ParticipantType2;
(function(ParticipantType22) {
  ParticipantType22["HOME"] = "HOME";
  ParticipantType22["AWAY"] = "AWAY";
})(ParticipantType2 || (ParticipantType2 = {}));
var TeamFormOutcomeTypes2;
(function(TeamFormOutcomeTypes22) {
  TeamFormOutcomeTypes22["WIN"] = "win";
  TeamFormOutcomeTypes22["LOSS"] = "loss";
  TeamFormOutcomeTypes22["WIN_OVERTIME"] = "win_overtime";
  TeamFormOutcomeTypes22["LOSS_OVERTIME"] = "loss_overtime";
  TeamFormOutcomeTypes22["DRAW"] = "draw";
  TeamFormOutcomeTypes22["WIN_AFTER_PENALTY"] = "win_after_penalty";
  TeamFormOutcomeTypes22["LOSS_AFTER_PENALTY"] = "loss_after_penalty";
})(TeamFormOutcomeTypes2 || (TeamFormOutcomeTypes2 = {}));
var NameFormat2;
(function(NameFormat22) {
  NameFormat22["LAST_NAME"] = "last_name";
  NameFormat22["INITIALS"] = "initials";
})(NameFormat2 || (NameFormat2 = {}));
var ScopeTypes2;
(function(ScopeTypes22) {
  ScopeTypes22["FIRST_HALF"] = "FIRST_HALF";
  ScopeTypes22["SECOND_HALF"] = "SECOND_HALF";
  ScopeTypes22["ORDINARY_TIME"] = "ORDINARY_TIME";
  ScopeTypes22["FULL_TIME"] = "FULL_TIME";
  ScopeTypes22["ALL"] = "ALL";
})(ScopeTypes2 || (ScopeTypes2 = {}));
var LineupsStatus2;
(function(LineupsStatus22) {
  LineupsStatus22["CONFIRMED"] = "CONFIRMED";
  LineupsStatus22["UNCONFIRMED"] = "UNCONFIRMED";
  LineupsStatus22["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(LineupsStatus2 || (LineupsStatus2 = {}));
var EventTypeCode2;
(function(EventTypeCode22) {
  EventTypeCode22["YELLOW_CARD_RED"] = "YELLOW_RED_CARD";
  EventTypeCode22["PENALTY_SHOOTOUT_MISSED"] = "PENALTY_SHOOTOUT_MISSED";
  EventTypeCode22["PENALTY_SHOOTOUT_SCORED"] = "PENALTY_SHOOTOUT_SCORED";
  EventTypeCode22["SUBSTITUTION"] = "SUBSTITUTION";
  EventTypeCode22["GOAL"] = "GOAL";
  EventTypeCode22["RED_CARD"] = "RED_CARD";
  EventTypeCode22["PENALTY_MISS"] = "PENALTY_MISS";
  EventTypeCode22["YELLOW_CARD"] = "YELLOW_CARD";
  EventTypeCode22["ASSIST"] = "ASSIST";
  EventTypeCode22["PENALTY_GOAL"] = "PENALTY_GOAL";
  EventTypeCode22["OWN_GOAL"] = "OWN_GOAL";
  EventTypeCode22["DISALLOWED_GOAL"] = "DISALLOWED_GOAL";
  EventTypeCode22["DISALLOWED_MISSED_PENALTY"] = "DISALLOWED_MISSED_PENALTY";
  EventTypeCode22["DISALLOWED_PENALTY"] = "DISALLOWED_PENALTY";
  EventTypeCode22["DISALLOWED_OWN_GOAL"] = "DISALLOWED_OWN_GOAL";
  EventTypeCode22["KICKOFF"] = "KICKOFF";
  EventTypeCode22["HALFTIME"] = "HALFTIME";
  EventTypeCode22["START_SECOND_HALF"] = "START_SECOND_HALF";
  EventTypeCode22["FINISHED_FIRST_HALF"] = "FINISHED_FIRST_HALF";
  EventTypeCode22["FINISHED_AFTER_EXTRA_TIME"] = "FINISHED_AFTER_EXTRA_TIME";
  EventTypeCode22["FINISHED_AFTER_PENALTIES"] = "FINISHED_AFTER_PENALTIES";
  EventTypeCode22["OVERTIME_FIRST_HALF"] = "OVERTIME_FIRST_HALF";
  EventTypeCode22["OVERTIME_FIRST_HALF_END"] = "OVERTIME_FIRST_HALF_END";
  EventTypeCode22["OVERTIME_SECOND_HALF"] = "OVERTIME_SECOND_HALF";
  EventTypeCode22["INJURY_TIME"] = "INJURY_TIME";
  EventTypeCode22["FINISHED"] = "FINISHED";
})(EventTypeCode2 || (EventTypeCode2 = {}));
var AllTeamNameTypes2;
(function(AllTeamNameTypes22) {
  AllTeamNameTypes22["threeLetterCode"] = "threeLetterCode";
  AllTeamNameTypes22["shortName"] = "shortName";
})(AllTeamNameTypes2 || (AllTeamNameTypes2 = {}));
var SportTypes2;
(function(SportTypes22) {
  SportTypes22["ALL"] = "all";
  SportTypes22["FOOTBALL"] = "football";
  SportTypes22["BASKETBALL"] = "basketball";
  SportTypes22["TENNIS"] = "tennis";
  SportTypes22["CYCLING"] = "cycling";
  SportTypes22["HANDBALL"] = "handball";
  SportTypes22["ICE_HOCKEY"] = "ice_hockey";
  SportTypes22["MOTORSPORTS"] = "motorsports";
  SportTypes22["RUGBY_LEAGUE"] = "rugby_league";
  SportTypes22["CRICKET"] = "cricket";
  SportTypes22["ROLLER_HOCKEY"] = "roller_hockey";
})(SportTypes2 || (SportTypes2 = {}));
var StatusType2;
(function(StatusType22) {
  StatusType22["FINISHED"] = "FINISHED";
  StatusType22["NOT_STARTED"] = "NOT_STARTED";
  StatusType22["LIVE"] = "LIVE";
  StatusType22["INTERRUPTED"] = "INTERRUPTED";
  StatusType22["CANCELED"] = "CANCELED";
  StatusType22["UNKNOWN"] = "UNKNOWN";
})(StatusType2 || (StatusType2 = {}));
var TennisCode2;
(function(TennisCode22) {
  TennisCode22["GAME_SCORE"] = "gamescore";
  TennisCode22["SET_1"] = "set1";
  TennisCode22["SET_2"] = "set2";
  TennisCode22["SET_3"] = "set3";
  TennisCode22["SET_4"] = "set4";
  TennisCode22["SET_5"] = "set5";
  TennisCode22["SET_6"] = "set6";
})(TennisCode2 || (TennisCode2 = {}));
var WinnerType2;
(function(WinnerType22) {
  WinnerType22["YES"] = "YES";
  WinnerType22["NO"] = "NO";
  WinnerType22["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(WinnerType2 || (WinnerType2 = {}));
function buildFormatLongFn2(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats11 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats11 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats11 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong11 = {
  date: buildFormatLongFn2({
    formats: dateFormats11,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats11,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats11,
    defaultWidth: "full"
  })
};
function buildLocalizeFn2(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}
var eraValues11 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues11 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues11 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues11 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues11 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber21 = function ordinalNumber22(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize11 = {
  ordinalNumber: ordinalNumber21,
  era: buildLocalizeFn2({
    values: eraValues11,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues11,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback11(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn2({
    values: monthValues11,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues11,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues11,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues8,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn2(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex2(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey2(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey2(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex2(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn2(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var matchOrdinalNumberPattern11 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern11 = /\d+/i;
var matchEraPatterns11 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns11 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns11 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns11 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns11 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns11 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns11 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns11 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns11 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns11 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match11 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern11,
    parsePattern: parseOrdinalNumberPattern11,
    valueCallback: function valueCallback21(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns11,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns11,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns11,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns11,
    defaultParseWidth: "any",
    valueCallback: function valueCallback22(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns11,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns11,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns11,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns11,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns11,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns11,
    defaultParseWidth: "any"
  })
};
var dateFormats22 = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
};
var timeFormats22 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
};
var dateTimeFormats22 = {
  any: "{{date}} {{time}}"
};
var formatLong22 = {
  date: buildFormatLongFn2({
    formats: dateFormats22,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats22,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats22,
    defaultWidth: "any"
  })
};
var eraValues22 = {
  narrow: ["\u043F\u0440.\u043D.\u0435.", "\u043D.\u0435."],
  abbreviated: ["\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.", "\u043D. \u0435."],
  wide: ["\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430", "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"]
};
var quarterValues22 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."],
  wide: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"]
};
var monthValues22 = {
  abbreviated: ["\u044F\u043D\u0443", "\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433", "\u0441\u0435\u043F", "\u043E\u043A\u0442", "\u043D\u043E\u0435", "\u0434\u0435\u043A"],
  wide: ["\u044F\u043D\u0443\u0430\u0440\u0438", "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438", "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438", "\u043D\u043E\u0435\u043C\u0432\u0440\u0438", "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"]
};
var dayValues22 = {
  narrow: ["\u041D", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
  short: ["\u043D\u0434", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"],
  abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0432\u0442\u043E", "\u0441\u0440\u044F", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u044A\u0431"],
  wide: ["\u043D\u0435\u0434\u0435\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u044F\u0434\u0430", "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u043F\u0435\u0442\u044A\u043A", "\u0441\u044A\u0431\u043E\u0442\u0430"]
};
var dayPeriodValues22 = {
  wide: {
    am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
    pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
    midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
    noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
    morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
    afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
    evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
    night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
  }
};
function isFeminine2(unit) {
  return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
}
function isNeuter2(unit) {
  return unit === "quarter";
}
function numberWithSuffix2(number, unit, masculine, feminine, neuter) {
  var suffix = isNeuter2(unit) ? neuter : isFeminine2(unit) ? feminine : masculine;
  return number + "-" + suffix;
}
var ordinalNumber32 = function ordinalNumber42(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  if (number === 0) {
    return numberWithSuffix2(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
  } else if (number % 1e3 === 0) {
    return numberWithSuffix2(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
  } else if (number % 100 === 0) {
    return numberWithSuffix2(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
  }
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return numberWithSuffix2(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
      case 2:
        return numberWithSuffix2(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
      case 7:
      case 8:
        return numberWithSuffix2(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
  }
  return numberWithSuffix2(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var localize22 = {
  ordinalNumber: ordinalNumber32,
  era: buildLocalizeFn2({
    values: eraValues22,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues22,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback22(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn2({
    values: monthValues22,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues22,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues22,
    defaultWidth: "wide"
  })
};
var matchOrdinalNumberPattern22 = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var parseOrdinalNumberPattern22 = /\d+/i;
var matchEraPatterns22 = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(преди новата ера|новата ера|нова ера)/i
};
var parseEraPatterns22 = {
  any: [/^п/i, /^н/i]
};
var matchQuarterPatterns22 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
  wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var parseQuarterPatterns22 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchDayPatterns22 = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var parseDayPatterns22 = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
};
var matchMonthPatterns22 = {
  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns22 = {
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
};
var matchDayPeriodPatterns22 = {
  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var parseDayPeriodPatterns22 = {
  any: {
    am: /^преди о/i,
    pm: /^след о/i,
    midnight: /^в пол/i,
    noon: /^на об/i,
    morning: /^сут/i,
    afternoon: /^следо/i,
    evening: /^веч/i,
    night: /^през н/i
  }
};
var match22 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern22,
    parsePattern: parseOrdinalNumberPattern22,
    valueCallback: function valueCallback32(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns22,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns22,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns22,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns22,
    defaultParseWidth: "any",
    valueCallback: function valueCallback42(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns22,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns22,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns22,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns22,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns22,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns22,
    defaultParseWidth: "any"
  })
};
var dateFormats32 = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
};
var timeFormats32 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats32 = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong32 = {
  date: buildFormatLongFn2({
    formats: dateFormats32,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats32,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats32,
    defaultWidth: "full"
  })
};
var eraValues32 = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
};
var quarterValues32 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
};
var monthValues32 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
};
var formattingMonthValues4 = {
  narrow: monthValues32.narrow,
  abbreviated: ["Jan.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: monthValues32.wide
};
var dayValues32 = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
};
var dayPeriodValues32 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
};
var formattingDayPeriodValues22 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
};
var ordinalNumber52 = function ordinalNumber62(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize32 = {
  ordinalNumber: ordinalNumber52,
  era: buildLocalizeFn2({
    values: eraValues32,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues32,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback32(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn2({
    values: monthValues32,
    formattingValues: formattingMonthValues4,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues32,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues32,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues22,
    defaultFormattingWidth: "wide"
  })
};
var matchOrdinalNumberPattern32 = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern32 = /\d+/i;
var matchEraPatterns32 = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns32 = {
  any: [/^v/i, /^n/i]
};
var matchQuarterPatterns32 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns32 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns32 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns32 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns32 = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns32 = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns32 = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns32 = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    evening: /abends/i,
    night: /nachts/i
  }
};
var match32 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern32,
    parsePattern: parseOrdinalNumberPattern32,
    valueCallback: function valueCallback52(value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns32,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns32,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns32,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns32,
    defaultParseWidth: "any",
    valueCallback: function valueCallback62(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns32,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns32,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns32,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns32,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns32,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns32,
    defaultParseWidth: "any"
  })
};
var dateFormats42 = {
  full: "EEEE, d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "d/M/yy"
};
var timeFormats42 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats42 = {
  full: "{{date}} - {{time}}",
  long: "{{date}} - {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong42 = {
  date: buildFormatLongFn2({
    formats: dateFormats42,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats42,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats42,
    defaultWidth: "full"
  })
};
var eraValues42 = {
  narrow: ["\u03C0\u03A7", "\u03BC\u03A7"],
  abbreviated: ["\u03C0.\u03A7.", "\u03BC.\u03A7."],
  wide: ["\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD", "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"]
};
var quarterValues42 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["\u03A41", "\u03A42", "\u03A43", "\u03A44"],
  wide: ["1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"]
};
var monthValues42 = {
  narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
  abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03AC\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03AC\u03B9", "\u0399\u03BF\u03CD\u03BD", "\u0399\u03BF\u03CD\u03BB", "\u0391\u03CD\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03AD", "\u0394\u03B5\u03BA"],
  wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2", "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2", "\u039C\u03AC\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2", "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2", "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"]
};
var formattingMonthValues22 = {
  narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
  abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03B1\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03B1\u0390", "\u0399\u03BF\u03C5\u03BD", "\u0399\u03BF\u03C5\u03BB", "\u0391\u03C5\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03B5", "\u0394\u03B5\u03BA"],
  wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5", "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5", "\u039C\u03B1\u0390\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5", "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5", "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"]
};
var dayValues42 = {
  narrow: ["\u039A", "\u0394", "T", "\u03A4", "\u03A0", "\u03A0", "\u03A3"],
  short: ["\u039A\u03C5", "\u0394\u03B5", "\u03A4\u03C1", "\u03A4\u03B5", "\u03A0\u03AD", "\u03A0\u03B1", "\u03A3\u03AC"],
  abbreviated: ["\u039A\u03C5\u03C1", "\u0394\u03B5\u03C5", "\u03A4\u03C1\u03AF", "\u03A4\u03B5\u03C4", "\u03A0\u03AD\u03BC", "\u03A0\u03B1\u03C1", "\u03A3\u03AC\u03B2"],
  wide: ["\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE", "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1", "\u03A4\u03C1\u03AF\u03C4\u03B7", "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7", "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7", "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE", "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"]
};
var dayPeriodValues42 = {
  narrow: {
    am: "\u03C0\u03BC",
    pm: "\u03BC\u03BC",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  },
  abbreviated: {
    am: "\u03C0.\u03BC.",
    pm: "\u03BC.\u03BC.",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  },
  wide: {
    am: "\u03C0.\u03BC.",
    pm: "\u03BC.\u03BC.",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  }
};
var ordinalNumber72 = function ordinalNumber82(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  var suffix;
  if (unit === "year" || unit === "month") {
    suffix = "\u03BF\u03C2";
  } else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") {
    suffix = "\u03B7";
  } else {
    suffix = "\u03BF";
  }
  return number + suffix;
};
var localize42 = {
  ordinalNumber: ordinalNumber72,
  era: buildLocalizeFn2({
    values: eraValues42,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues42,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback42(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn2({
    values: monthValues42,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues22,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues42,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues42,
    defaultWidth: "wide"
  })
};
var matchOrdinalNumberPattern42 = /^(\d+)(ος|η|ο)?/i;
var parseOrdinalNumberPattern42 = /\d+/i;
var matchEraPatterns42 = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var parseEraPatterns42 = {
  any: [/^π/i, /^(μ|κ)/i]
};
var matchQuarterPatterns42 = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var parseQuarterPatterns42 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns42 = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var parseMonthPatterns42 = {
  narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
  any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
};
var matchDayPatterns42 = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var parseDayPatterns42 = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
};
var matchDayPeriodPatterns42 = {
  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var parseDayPeriodPatterns42 = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i
  }
};
var match42 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern42,
    parsePattern: parseOrdinalNumberPattern42,
    valueCallback: function valueCallback72(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns42,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns42,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns42,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns42,
    defaultParseWidth: "any",
    valueCallback: function valueCallback82(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns42,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns42,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns42,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns42,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns42,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns42,
    defaultParseWidth: "any"
  })
};
var dateFormats52 = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd."
};
var timeFormats52 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
};
var dateTimeFormats52 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong52 = {
  date: buildFormatLongFn2({
    formats: dateFormats52,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats52,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats52,
    defaultWidth: "full"
  })
};
var accusativeWeekdays2 = ["vas\xE1rnap", "h\xE9tf\u0151n", "kedden", "szerd\xE1n", "cs\xFCt\xF6rt\xF6k\xF6n", "p\xE9nteken", "szombaton"];
function week2(isFuture2) {
  return function(date) {
    var weekday = accusativeWeekdays2[date.getUTCDay()];
    var prefix = isFuture2 ? "" : "'m\xFAlt' ";
    return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
  };
}
var formatRelativeLocale52 = {
  lastWeek: week2(false),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: week2(true),
  other: "P"
};
var eraValues52 = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus el\u0151tt", "id\u0151sz\xE1m\xEDt\xE1sunk szerint"]
};
var quarterValues52 = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.\xE9v", "2. n.\xE9v", "3. n.\xE9v", "4. n.\xE9v"],
  wide: ["1. negyed\xE9v", "2. negyed\xE9v", "3. negyed\xE9v", "4. negyed\xE9v"]
};
var formattingQuarterValues2 = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.\xE9v", "II. n.\xE9v", "III. n.\xE9v", "IV. n.\xE9v"],
  wide: ["I. negyed\xE9v", "II. negyed\xE9v", "III. negyed\xE9v", "IV. negyed\xE9v"]
};
var monthValues52 = {
  narrow: ["J", "F", "M", "\xC1", "M", "J", "J", "A", "Sz", "O", "N", "D"],
  abbreviated: ["jan.", "febr.", "m\xE1rc.", "\xE1pr.", "m\xE1j.", "j\xFAn.", "j\xFAl.", "aug.", "szept.", "okt.", "nov.", "dec."],
  wide: ["janu\xE1r", "febru\xE1r", "m\xE1rcius", "\xE1prilis", "m\xE1jus", "j\xFAnius", "j\xFAlius", "augusztus", "szeptember", "okt\xF3ber", "november", "december"]
};
var dayValues52 = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: ["vas\xE1rnap", "h\xE9tf\u0151", "kedd", "szerda", "cs\xFCt\xF6rt\xF6k", "p\xE9ntek", "szombat"]
};
var dayPeriodValues52 = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "\xE9jf\xE9l",
    noon: "d\xE9l",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "\xE9jjel"
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "\xE9jf\xE9l",
    noon: "d\xE9l",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "\xE9jjel"
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "\xE9jf\xE9l",
    noon: "d\xE9l",
    morning: "reggel",
    afternoon: "d\xE9lut\xE1n",
    evening: "este",
    night: "\xE9jjel"
  }
};
var ordinalNumber92 = function ordinalNumber102(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize52 = {
  ordinalNumber: ordinalNumber92,
  era: buildLocalizeFn2({
    values: eraValues52,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues52,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback52(quarter) {
      return quarter - 1;
    },
    formattingValues: formattingQuarterValues2,
    defaultFormattingWidth: "wide"
  }),
  month: buildLocalizeFn2({
    values: monthValues52,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues52,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues52,
    defaultWidth: "wide"
  })
};
var matchOrdinalNumberPattern52 = /^(\d+)\.?/i;
var parseOrdinalNumberPattern52 = /\d+/i;
var matchEraPatterns52 = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var parseEraPatterns52 = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
};
var matchQuarterPatterns52 = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var parseQuarterPatterns52 = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
};
var matchMonthPatterns52 = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var parseMonthPatterns52 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns52 = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var parseDayPatterns52 = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
};
var matchDayPeriodPatterns52 = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var parseDayPeriodPatterns52 = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
};
var match52 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern52,
    parsePattern: parseOrdinalNumberPattern52,
    valueCallback: function valueCallback92(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns52,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns52,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns52,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns52,
    defaultParseWidth: "any",
    valueCallback: function valueCallback102(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns52,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns52,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns52,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns52,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns52,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns52,
    defaultParseWidth: "any"
  })
};
var dateFormats62 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
var timeFormats62 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats62 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong62 = {
  date: buildFormatLongFn2({
    formats: dateFormats62,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats62,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats62,
    defaultWidth: "full"
  })
};
var eraValues62 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
};
var quarterValues62 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues62 = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
};
var dayValues62 = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"]
};
var dayPeriodValues62 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
};
var formattingDayPeriodValues32 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
};
var ordinalNumber112 = function ordinalNumber122(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return String(number);
};
var localize62 = {
  ordinalNumber: ordinalNumber112,
  era: buildLocalizeFn2({
    values: eraValues62,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues62,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback62(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn2({
    values: monthValues62,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues62,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues62,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues32,
    defaultFormattingWidth: "wide"
  })
};
var matchOrdinalNumberPattern62 = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern62 = /\d+/i;
var matchEraPatterns62 = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns62 = {
  any: [/^a/i, /^(d|e)/i]
};
var matchQuarterPatterns62 = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns62 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns62 = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns62 = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns62 = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns62 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns62 = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns62 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
};
var match62 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern62,
    parsePattern: parseOrdinalNumberPattern62,
    valueCallback: function valueCallback112(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns62,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns62,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns62,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns62,
    defaultParseWidth: "any",
    valueCallback: function valueCallback122(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns62,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns62,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns62,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns62,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns62,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns62,
    defaultParseWidth: "any"
  })
};
var dateFormats72 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
};
var timeFormats72 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats72 = {
  full: "{{date}} '\xE0s' {{time}}",
  long: "{{date}} '\xE0s' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong72 = {
  date: buildFormatLongFn2({
    formats: dateFormats72,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats72,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats72,
    defaultWidth: "full"
  })
};
var eraValues72 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
};
var quarterValues72 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues72 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
};
var dayValues72 = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
};
var dayPeriodValues72 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
};
var formattingDayPeriodValues42 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
};
var ordinalNumber132 = function ordinalNumber142(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + "\xBA";
};
var localize72 = {
  ordinalNumber: ordinalNumber132,
  era: buildLocalizeFn2({
    values: eraValues72,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues72,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback72(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn2({
    values: monthValues72,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues72,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues72,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues42,
    defaultFormattingWidth: "wide"
  })
};
var matchOrdinalNumberPattern72 = /^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern72 = /\d+/i;
var matchEraPatterns72 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns72 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
};
var matchQuarterPatterns72 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns72 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns72 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns72 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns72 = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns72 = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
};
var matchDayPeriodPatterns72 = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns72 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
};
var match72 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern72,
    parsePattern: parseOrdinalNumberPattern72,
    valueCallback: function valueCallback132(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns72,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns72,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns72,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns72,
    defaultParseWidth: "any",
    valueCallback: function valueCallback142(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns72,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns72,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns72,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns72,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns72,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns72,
    defaultParseWidth: "any"
  })
};
var dateFormats82 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
};
var timeFormats82 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats82 = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong82 = {
  date: buildFormatLongFn2({
    formats: dateFormats82,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats82,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats82,
    defaultWidth: "full"
  })
};
var eraValues82 = {
  narrow: ["\xCE", "D"],
  abbreviated: ["\xCE.d.C.", "D.C."],
  wide: ["\xCEnainte de Cristos", "Dup\u0103 Cristos"]
};
var quarterValues82 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["primul trimestru", "al doilea trimestru", "al treilea trimestru", "al patrulea trimestru"]
};
var monthValues82 = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sep", "oct", "noi", "dec"],
  wide: ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"]
};
var dayValues82 = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "s\xE2"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "s\xE2m"],
  wide: ["duminic\u0103", "luni", "mar\u021Bi", "miercuri", "joi", "vineri", "s\xE2mb\u0103t\u0103"]
};
var dayPeriodValues82 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  }
};
var formattingDayPeriodValues52 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  }
};
var ordinalNumber152 = function ordinalNumber162(dirtyNumber, _options) {
  return String(dirtyNumber);
};
var localize82 = {
  ordinalNumber: ordinalNumber152,
  era: buildLocalizeFn2({
    values: eraValues82,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues82,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback82(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn2({
    values: monthValues82,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues82,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues82,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues52,
    defaultFormattingWidth: "wide"
  })
};
var matchOrdinalNumberPattern82 = /^(\d+)?/i;
var parseOrdinalNumberPattern82 = /\d+/i;
var matchEraPatterns82 = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var parseEraPatterns82 = {
  any: [/^ÎC/i, /^DC/i],
  wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
};
var matchQuarterPatterns82 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
};
var parseQuarterPatterns82 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns82 = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var parseMonthPatterns82 = {
  narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns82 = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var parseDayPatterns82 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns82 = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var parseDayPeriodPatterns82 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
};
var match82 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern82,
    parsePattern: parseOrdinalNumberPattern82,
    valueCallback: function valueCallback152(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns82,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns82,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns82,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns82,
    defaultParseWidth: "any",
    valueCallback: function valueCallback162(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns82,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns82,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns82,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns82,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns82,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns82,
    defaultParseWidth: "any"
  })
};
var dateFormats92 = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
};
var timeFormats92 = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats92 = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong92 = {
  date: buildFormatLongFn2({
    formats: dateFormats92,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats92,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats92,
    defaultWidth: "full"
  })
};
var eraValues92 = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"]
};
var quarterValues92 = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
};
var monthValues92 = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
};
var formattingMonthValues32 = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
};
var dayValues92 = {
  narrow: ["N", "P", "U", "S", "\u010C", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
  wide: ["nedelja", "ponedeljak", "utorak", "sreda", "\u010Detvrtak", "petak", "subota"]
};
var formattingDayPeriodValues62 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uve\u010De",
    night: "no\u0107u"
  }
};
var dayPeriodValues92 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uve\u010De",
    night: "no\u0107u"
  }
};
var ordinalNumber172 = function ordinalNumber182(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize92 = {
  ordinalNumber: ordinalNumber172,
  era: buildLocalizeFn2({
    values: eraValues92,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues92,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback92(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn2({
    values: monthValues92,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues32,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues92,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues92,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues62,
    defaultFormattingWidth: "wide"
  })
};
var matchOrdinalNumberPattern92 = /^(\d+)\./i;
var parseOrdinalNumberPattern92 = /\d+/i;
var matchEraPatterns92 = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var parseEraPatterns92 = {
  any: [/^pr/i, /^(po|nova)/i]
};
var matchQuarterPatterns92 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns92 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns92 = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns92 = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns92 = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns92 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns92 = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var parseDayPeriodPatterns92 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
};
var match92 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern92,
    parsePattern: parseOrdinalNumberPattern92,
    valueCallback: function valueCallback172(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns92,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns92,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns92,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns92,
    defaultParseWidth: "any",
    valueCallback: function valueCallback182(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns92,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns92,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns92,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns92,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns92,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns92,
    defaultParseWidth: "any"
  })
};
var dateFormats102 = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
};
var timeFormats102 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats102 = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong102 = {
  date: buildFormatLongFn2({
    formats: dateFormats102,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn2({
    formats: timeFormats102,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn2({
    formats: dateTimeFormats102,
    defaultWidth: "full"
  })
};
var eraValues102 = {
  narrow: ["M\xD6", "MS"],
  abbreviated: ["M\xD6", "MS"],
  wide: ["Milattan \xD6nce", "Milattan Sonra"]
};
var quarterValues102 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1\xC7", "2\xC7", "3\xC7", "4\xC7"],
  wide: ["\u0130lk \xE7eyrek", "\u0130kinci \xC7eyrek", "\xDC\xE7\xFCnc\xFC \xE7eyrek", "Son \xE7eyrek"]
};
var monthValues102 = {
  narrow: ["O", "\u015E", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: ["Oca", "\u015Eub", "Mar", "Nis", "May", "Haz", "Tem", "A\u011Fu", "Eyl", "Eki", "Kas", "Ara"],
  wide: ["Ocak", "\u015Eubat", "Mart", "Nisan", "May\u0131s", "Haziran", "Temmuz", "A\u011Fustos", "Eyl\xFCl", "Ekim", "Kas\u0131m", "Aral\u0131k"]
};
var dayValues102 = {
  narrow: ["P", "P", "S", "\xC7", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "\xC7a", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "\xC7ar", "Per", "Cum", "Cts"],
  wide: ["Pazar", "Pazartesi", "Sal\u0131", "\xC7ar\u015Famba", "Per\u015Fembe", "Cuma", "Cumartesi"]
};
var dayPeriodValues102 = {
  narrow: {
    am: "\xF6\xF6",
    pm: "\xF6s",
    midnight: "gy",
    noon: "\xF6",
    morning: "sa",
    afternoon: "\xF6s",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "\xD6\xD6",
    pm: "\xD6S",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Fle",
    morning: "sabah",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Fam",
    night: "gece"
  },
  wide: {
    am: "\xD6.\xD6.",
    pm: "\xD6.S.",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Fle",
    morning: "sabah",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Fam",
    night: "gece"
  }
};
var formattingDayPeriodValues72 = {
  narrow: {
    am: "\xF6\xF6",
    pm: "\xF6s",
    midnight: "gy",
    noon: "\xF6",
    morning: "sa",
    afternoon: "\xF6s",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "\xD6\xD6",
    pm: "\xD6S",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Flen",
    morning: "sabahleyin",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Famleyin",
    night: "geceleyin"
  },
  wide: {
    am: "\xF6.\xF6.",
    pm: "\xF6.s.",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Flen",
    morning: "sabahleyin",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Famleyin",
    night: "geceleyin"
  }
};
var ordinalNumber192 = function ordinalNumber202(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize102 = {
  ordinalNumber: ordinalNumber192,
  era: buildLocalizeFn2({
    values: eraValues102,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn2({
    values: quarterValues102,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback102(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn2({
    values: monthValues102,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn2({
    values: dayValues102,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn2({
    values: dayPeriodValues102,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues72,
    defaultFormattingWidth: "wide"
  })
};
var matchOrdinalNumberPattern102 = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern102 = /\d+/i;
var matchEraPatterns102 = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
};
var parseEraPatterns102 = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
};
var matchQuarterPatterns102 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var parseQuarterPatterns102 = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
};
var matchMonthPatterns102 = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var parseMonthPatterns102 = {
  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
};
var matchDayPatterns102 = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var parseDayPatterns102 = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [/^pazar(?!tesi)/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma(?!rtesi)/i, /^cumartesi/i]
};
var matchDayPeriodPatterns102 = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var parseDayPeriodPatterns102 = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
};
var match102 = {
  ordinalNumber: buildMatchPatternFn2({
    matchPattern: matchOrdinalNumberPattern102,
    parsePattern: parseOrdinalNumberPattern102,
    valueCallback: function valueCallback192(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn2({
    matchPatterns: matchEraPatterns102,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns102,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn2({
    matchPatterns: matchQuarterPatterns102,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns102,
    defaultParseWidth: "any",
    valueCallback: function valueCallback202(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn2({
    matchPatterns: matchMonthPatterns102,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns102,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn2({
    matchPatterns: matchDayPatterns102,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns102,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn2({
    matchPatterns: matchDayPeriodPatterns102,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns102,
    defaultParseWidth: "any"
  })
};
var Result;
(function(Result2) {
  Result2["RESULT_ONLY"] = "RO";
})(Result || (Result = {}));
var ParticipantTypes2;
(function(ParticipantTypes22) {
  ParticipantTypes22["TEAM_DOUBLE"] = "TEAM_DOUBLE";
  ParticipantTypes22["PLAYER"] = "PLAYER";
})(ParticipantTypes2 || (ParticipantTypes2 = {}));
var Winner3;
(function(Winner22) {
  Winner22["YES"] = "YES";
  Winner22["NO"] = "NO";
})(Winner3 || (Winner3 = {}));
var MatchTypes2;
(function(MatchTypes22) {
  MatchTypes22["DOUBLE"] = "DOUBLE";
  MatchTypes22["SINGLE"] = "SINGLE";
})(MatchTypes2 || (MatchTypes2 = {}));
var RankingScopeTypes2;
(function(RankingScopeTypes22) {
  RankingScopeTypes22["CURRENT"] = "CURRENT";
})(RankingScopeTypes2 || (RankingScopeTypes2 = {}));
var RankingColumnTypes2;
(function(RankingColumnTypes22) {
  RankingColumnTypes22["NAME"] = "NAME";
  RankingColumnTypes22["POINTS"] = "POINTS";
  RankingColumnTypes22["NATIONALITY"] = "NATIONALITY";
})(RankingColumnTypes2 || (RankingColumnTypes2 = {}));
var PlayoffDoubleTypes2;
(function(PlayoffDoubleTypes22) {
  PlayoffDoubleTypes22["MALE_DOUBLES"] = "MALE_DOUBLES";
  PlayoffDoubleTypes22["FEMALE_DOUBLES"] = "FEMALE_DOUBLES";
  PlayoffDoubleTypes22["MIXED_DOUBLES"] = "MIXED_DOUBLES";
})(PlayoffDoubleTypes2 || (PlayoffDoubleTypes2 = {}));
var CurrentServer2;
(function(CurrentServer22) {
  CurrentServer22["YES"] = "YES";
  CurrentServer22["NO"] = "NO";
})(CurrentServer2 || (CurrentServer2 = {}));
var TeamWinnerForm;
(function(TeamWinnerForm2) {
  TeamWinnerForm2["W"] = "W";
  TeamWinnerForm2["D"] = "D";
  TeamWinnerForm2["L"] = "L";
})(TeamWinnerForm || (TeamWinnerForm = {}));
var isInStorybook = () => {
  return window.location.pathname.includes("/iframe.html");
};
var DEFAULT_HEADER_LABELS = {
  [HeaderLabels2.OVERTIME]: "OT",
  [HeaderLabels2.POINTS]: "PTS",
  [HeaderLabels2.SCORE]: "S"
};
var hasOwn = {}.hasOwnProperty;
var TAB_OPTIONS;
(function(TAB_OPTIONS2) {
  TAB_OPTIONS2["ALL"] = "ALL";
  TAB_OPTIONS2["POPULAR"] = "POPULAR";
  TAB_OPTIONS2["UPCOMING"] = "UPCOMING";
  TAB_OPTIONS2["LIVE"] = "LIVE";
  TAB_OPTIONS2["FINISHED"] = "FINISHED";
  TAB_OPTIONS2["ODDS"] = "ODDS";
})(TAB_OPTIONS || (TAB_OPTIONS = {}));
var sortLabelsByType = (data, element, isLive) => {
  if (!data) {
    return [];
  }
  const sortedData = [...data];
  const index = data.indexOf(element);
  if (index > -1) {
    sortedData.splice(index, 1);
    sortedData.unshift(element);
  }
  return isLive ? sortedData : data;
};
var ResultTypes;
(function(ResultTypes2) {
  ResultTypes2["QUARTER1"] = "quarter1";
  ResultTypes2["QUARTER2"] = "quarter2";
  ResultTypes2["QUARTER3"] = "quarter3";
  ResultTypes2["QUARTER4"] = "quarter4";
  ResultTypes2["PERIOD1"] = "period1";
  ResultTypes2["PERIOD2"] = "period2";
  ResultTypes2["PERIOD3"] = "period3";
  ResultTypes2["PERIOD4"] = "period4";
  ResultTypes2["EXTRA_TIME"] = "extratime";
  ResultTypes2["FINAL_RESULT"] = "display";
  ResultTypes2["PENALTY_SHOOTOUT"] = "penaltyshootout";
})(ResultTypes || (ResultTypes = {}));
var ALL_TABLE_TYPES;
(function(ALL_TABLE_TYPES2) {
  ALL_TABLE_TYPES2["PLAYED"] = "PLAYED";
  ALL_TABLE_TYPES2["WINS"] = "WINS";
  ALL_TABLE_TYPES2["WINS_OVER_TIME"] = "WINS_OVER_TIME";
  ALL_TABLE_TYPES2["LOSSES"] = "LOSSES";
  ALL_TABLE_TYPES2["LOSSES_OVER_TIME"] = "LOSSES_OVER_TIME";
  ALL_TABLE_TYPES2["WINS_PENALTY"] = "WINS_PENALTY";
  ALL_TABLE_TYPES2["LOSSES_PENALTY"] = "LOSSES_PENALTY";
  ALL_TABLE_TYPES2["GOAL_DIFFERENCES"] = "GOAL_DIFFERENCES";
  ALL_TABLE_TYPES2["POINTS"] = "POINTS";
  ALL_TABLE_TYPES2["TOTAL_POINTS"] = "TOTAL_POINTS";
  ALL_TABLE_TYPES2["PERCENTAGE"] = "PERCENTAGE";
  ALL_TABLE_TYPES2["GOALS_FOR"] = "GOALS_FOR";
  ALL_TABLE_TYPES2["GOALS_AGAINST"] = "GOALS_AGAINST";
  ALL_TABLE_TYPES2["FORM"] = "FORM";
})(ALL_TABLE_TYPES || (ALL_TABLE_TYPES = {}));

// ../hooks/useRootNodeRef.ts
function useRootNodeRef() {
  const ref = useRef5(null);
  const [widgetContext, setWidgetContext] = useState9(null);
  useEffect8(() => {
    var _a2, _b, _c, _d2;
    if (ref.current && !isInStorybook()) {
      const el = ref.current;
      const widgetNode = (_a2 = el.getRootNode()) == null ? void 0 : _a2.host;
      if (!widgetNode) {
        return;
      }
      setWidgetContext({
        widgetId: (_b = widgetNode.getAttribute(widgetAttributes_default.WIDGET_ID)) != null ? _b : "",
        widgetSport: (_c = widgetNode.getAttribute(widgetAttributes_default.WIDGET_SPORT)) != null ? _c : "",
        widgetCuid: (_d2 = widgetNode.getAttribute("data-id")) != null ? _d2 : ""
      });
    }
  }, []);
  return { ref, widgetContext };
}

// ../hooks/useOverlapOdds.ts
import { useEffect as useEffect9, useState as useState10 } from "react";
var windowPropNameValue = "smpCustomBettingOverlapValue";
function useOverlapOdds({ dataBettingLogoOverlap }) {
  const [areBettingOddsOverlapVisible, setAreBettingOddsOverlapVisible] = useState10(true);
  useEffect9(() => {
    if (dataBettingLogoOverlap) {
      const checkCustomValue = () => {
        const customValue = window[windowPropNameValue];
        if (customValue !== void 0 && customValue !== "") {
          setAreBettingOddsOverlapVisible(Boolean(customValue));
        } else {
          setAreBettingOddsOverlapVisible(true);
        }
      };
      checkCustomValue();
      const handleCustomValueChange = () => {
        checkCustomValue();
      };
      window.addEventListener(`${windowPropNameValue}Change`, handleCustomValueChange);
      return () => {
        window.removeEventListener(`${windowPropNameValue}Change`, handleCustomValueChange);
      };
    }
  }, [dataBettingLogoOverlap]);
  return { areBettingOddsOverlapVisible };
}

// ../constants/h2hStatistics.ts
var STATISTICS_WITH_MINUTES_SIGN = ["minutes", "minutes_substitute"];
var STATISTICS_WITH_PERCENTAGE_SIGN = ["possession"];
var MINUTES_SIGN = "'";
var PERCENTAGE_SIGN = "%";

// ../HOC/LinkWrapper.tsx
import React15 from "react";
var LinkWrapper = ({
  url = "#",
  target = TARGET_BLANK,
  children,
  shouldWrap = true,
  onClick,
  isTeamSquad
}) => {
  const childrenResult = shouldWrap ? /* @__PURE__ */ React15.createElement("div", {
    style: { pointerEvents: isTeamSquad ? "auto" : "none" }
  }, children) : /* @__PURE__ */ React15.createElement(React15.Fragment, null, children);
  if (shouldWrap) {
    return /* @__PURE__ */ React15.createElement("a", {
      href: url,
      target,
      style: { display: "block", textDecoration: "none", color: "inherit" },
      onClick
    }, childrenResult);
  }
  return childrenResult;
};

// ../odds/hooks/useProcessedOdds.ts
import { useMemo as useMemo6 } from "react";

// ../odds/types/markets.ts
var ScopeTypes3;
(function(ScopeTypes4) {
  ScopeTypes4["FIRST_HALF"] = "FIRST_HALF";
  ScopeTypes4["SECOND_HALF"] = "SECOND_HALF";
  ScopeTypes4["ORDINARY_TIME"] = "ORDINARY_TIME";
  ScopeTypes4["FULL_TIME"] = "FULL_TIME";
  ScopeTypes4["ALL"] = "ALL";
})(ScopeTypes3 || (ScopeTypes3 = {}));

// ../odds/helpers/mapOddsMarketsWithDifferentKeys.ts
var mapOddsMarketsWithDifferentKeys = (odds) => {
  if (!odds || odds.length === 0)
    return [];
  const transformedOdds = odds.map((odd) => {
    var _a2;
    const mappedMarketsWithNewKeys = {};
    if (!((_a2 = odd == null ? void 0 : odd.markets) == null ? void 0 : _a2.length))
      return __spreadProps(__spreadValues({}, odd), { markets: {} });
    for (const market of odd.markets) {
      if (!market.type.code)
        continue;
      if (market.type.code === OddsMarketTypes.ONEXTWO) {
        switch (market.scope.type.toUpperCase()) {
          case ScopeTypes3.FULL_TIME:
            mappedMarketsWithNewKeys[ScopeTypes3.FULL_TIME] = market;
            break;
          case ScopeTypes3.FIRST_HALF:
            mappedMarketsWithNewKeys[ScopeTypes3.FIRST_HALF] = market;
            break;
          case ScopeTypes3.SECOND_HALF:
            mappedMarketsWithNewKeys[ScopeTypes3.SECOND_HALF] = market;
            break;
          default:
            mappedMarketsWithNewKeys[OddsMarketTypes.ONEXTWO] = market;
        }
      } else {
        mappedMarketsWithNewKeys[market.type.code] = market;
      }
    }
    return __spreadProps(__spreadValues({}, odd), {
      markets: mappedMarketsWithNewKeys
    });
  });
  return transformedOdds;
};

// ../odds/hooks/useProcessedOdds.ts
var filterOddsByBettingIds = (odds, bettingIds) => {
  if (!bettingIds)
    return odds.length > 0 ? [odds[0]] : [];
  return odds.filter(({ bookmaker }) => bettingIds.includes(`${bookmaker == null ? void 0 : bookmaker.id}`)) || odds;
};
var useProcessedOdds = ({ odds, dataOddsBettingId, showOdds }) => {
  const processedOdds = useMemo6(() => {
    var _a2;
    if (!showOdds || odds.length === 0)
      return [];
    try {
      const processedOdds2 = (_a2 = mapOddsMarketsWithDifferentKeys(odds)) != null ? _a2 : [];
      const bookmakerIds = odds.map(({ bookmaker }) => {
        var _a3;
        return (_a3 = bookmaker == null ? void 0 : bookmaker.id) != null ? _a3 : "";
      }).filter((id) => id !== "");
      const bettingIds = dataOddsBettingId ? dataOddsBettingId.split(",").map((id) => id.trim()) : bookmakerIds;
      return bettingIds ? filterOddsByBettingIds(processedOdds2, bettingIds) : processedOdds2;
    } catch (error) {
      return [];
    }
  }, [odds, dataOddsBettingId, showOdds]);
  return processedOdds;
};

// ../constants/programmeStatus.ts
var ProgrammeFilterEnums;
(function(ProgrammeFilterEnums2) {
  ProgrammeFilterEnums2["FIXTURES"] = "Fixtures";
  ProgrammeFilterEnums2["RESULTS"] = "Results";
})(ProgrammeFilterEnums || (ProgrammeFilterEnums = {}));

// ../hooks/useIsSmartphoneDevice.ts
import { useLayoutEffect, useState as useState11 } from "react";
var useIsSmartphoneDevice = (ref) => {
  const checkForDevice = () => {
    var _a2;
    return (ref == null ? void 0 : ref.current) && ((_a2 = ref == null ? void 0 : ref.current) == null ? void 0 : _a2.clientWidth) < 768 || window.innerWidth < 768;
  };
  const [isMobile, setIsMobile] = useState11(checkForDevice());
  useLayoutEffect(() => {
    if (ref) {
      setIsMobile(checkForDevice());
    }
    const handlePageResized = () => {
      setIsMobile(checkForDevice());
    };
    if (typeof window !== "undefined") {
      window.addEventListener("resize", handlePageResized);
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handlePageResized);
      }
    };
  }, [isMobile]);
  return {
    isMobile
  };
};

// ../constants/actitivityStatus.ts
var ACTIVE = "ACTIVE";

// ../api/football.ts
import { getOddsSettings } from "@sportal365/smp-widget-utils";

// ../api/player.ts
import { getOddsSettings as getOddsSettings2 } from "@sportal365/smp-widget-utils";

// ../api/team.ts
import { getOddsSettings as getOddsSettings3 } from "@sportal365/smp-widget-utils";

// ../api/predictor.ts
var predictor_default = (sdk) => {
  function makeFootballPrediction({ matchId, market, value }) {
    return sdk.predictor.makeFootballPrediction(matchId, market, value);
  }
  function getMyPredictionsForMatches({ matchId, predictionId }) {
    const filters = {
      limit: 1,
      startAfter: predictionId
    };
    return sdk.predictor.getMyPredictionsForMatches([matchId], filters);
  }
  function getMarketSummary({ matchId, market }) {
    return sdk.predictor.getMarketSummary(matchId, market);
  }
  return { getMarketSummary, makeFootballPrediction, getMyPredictionsForMatches };
};

// ../hooks/useFansUnitedApi.ts
function useFansUnitedApi(sdkOptions) {
  const sdkFansUnited = SMPFansUnitedSDK_default(sdkOptions);
  return {
    $predictor: predictor_default(sdkFansUnited)
  };
}

// ../hooks/usePredictor.ts
import { FansUnitedTokenProvider } from "@sportal365/smp-widget-utils";
function usePredictor({
  matchId,
  subscribers,
  predictionSign,
  fansUnitedApiKey,
  fansUnitedMarket,
  fansUnitedEnvironment,
  fansUnitedClientId,
  fansUnitedGetAuthToken,
  fansUnitedSignOut,
  fansUnitedIdSchema
}) {
  const authProvider = new FansUnitedTokenProvider({ getAuthToken: fansUnitedGetAuthToken, signOut: fansUnitedSignOut });
  const { $predictor } = useFansUnitedApi({
    apiKey: fansUnitedApiKey || "",
    clientId: fansUnitedClientId || "",
    idSchema: fansUnitedIdSchema,
    environment: fansUnitedEnvironment,
    authProvider
  });
  const [prediction, setPrediction] = useState12();
  const [summary, setSummary] = useState12();
  const makePrediction = ({
    matchId: matchId2,
    fansUnitedMarket: fansUnitedMarket2,
    predictionSign: predictionSign2
  }) => {
    if (predictionSign2) {
      $predictor.makeFootballPrediction({ matchId: matchId2, market: fansUnitedMarket2, value: predictionSign2 }).then((res) => {
        setPrediction(res);
        subscribers["onPredictionSuccess"].forEach((fn) => fn(res));
      }).catch((error) => {
        subscribers["onPredictionError"].forEach((fn) => fn(error));
      });
    }
  };
  const getMarketSummary = useCallback2(() => {
    if (matchId) {
      $predictor.getMarketSummary({ matchId, market: fansUnitedMarket }).then((res) => {
        const homeWinVotes = res.fullTimeOneXTwo["1"];
        const awayWinVotes = res.fullTimeOneXTwo["2"];
        const drawVotes = res.fullTimeOneXTwo.x;
        const totalVotes = homeWinVotes + awayWinVotes + drawVotes;
        if (totalVotes > 0) {
          const summary2 = {
            1: homeWinVotes / totalVotes * 100,
            2: awayWinVotes / totalVotes * 100,
            x: drawVotes / totalVotes * 100
          };
          setSummary(summary2);
        }
      }).catch((error) => {
        console.error(error);
      });
    }
  }, [matchId, fansUnitedMarket, prediction, predictionSign]);
  useEffect10(() => {
    const token = fansUnitedGetAuthToken();
    if (matchId && Boolean(token == null ? void 0 : token.trim())) {
      $predictor.getMyPredictionsForMatches({ matchId }).then(({ data }) => {
        setPrediction(data == null ? void 0 : data[0]);
      }).catch((error) => {
        console.error(error);
      });
    }
  }, [matchId, fansUnitedGetAuthToken]);
  return {
    summary,
    prediction,
    makePrediction,
    getMarketSummary
  };
}

// src/molecules/FansUnitedFullTimeOutcome/FansUnitedToggleTitle.tsx
var FansUnitedToggleTitle = ({ title }) => {
  if (!title) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, "Play ", /* @__PURE__ */ React.createElement("span", {
      style: { color: "#FF901A", fontWeight: "bold" }
    }, "FREE"), " with Sportal");
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, title);
};

// src/molecules/FansUnitedFullTimeOutcome/FansUnitedFullTimeOutcome.tsx
var FansUnitedFullTimeOutcome = ({
  matchId,
  homeTeam,
  awayTeam,
  subscribers,
  fansUnitedApiKey,
  fansUnitedSignOut,
  fansUnitedIdSchema,
  fansUnitedClientId,
  fansUnitedEnvironment,
  fansUnitedGetAuthToken,
  fansUnitedMarket = "FT_1X2",
  fansUnitedExpanded = false,
  labels
}) => {
  var _a2, _b;
  const [isExpanded, setIsExpanded] = useState13(fansUnitedExpanded);
  const [predictionSign, setPredictionSign] = useState13(null);
  const handleCollapseToggle = () => {
    setIsExpanded((prev) => !prev);
  };
  const { summary, prediction, getMarketSummary, makePrediction } = usePredictor({
    matchId,
    subscribers,
    predictionSign,
    fansUnitedMarket,
    fansUnitedApiKey,
    fansUnitedSignOut,
    fansUnitedIdSchema,
    fansUnitedClientId,
    fansUnitedEnvironment,
    fansUnitedGetAuthToken
  });
  useEffect11(() => {
    if (prediction) {
      getMarketSummary();
      if ((prediction == null ? void 0 : prediction.fixtures[0].prediction.value) !== predictionSign) {
        setPredictionSign(prediction == null ? void 0 : prediction.fixtures[0].prediction.value);
      }
    }
  }, [prediction]);
  const handlePredictionClick = (value) => {
    if (!prediction) {
      setPredictionSign(value);
      makePrediction({ matchId, fansUnitedMarket, predictionSign: value });
    }
  };
  const Wrapper3 = useMemo7(() => styled.withConfig({ componentId: "FansUnitedWidget", displayName: "FansUnitedFullTimeWrapper" })("div", {
    backgroundColor: "$fansUnitedContainerPrimaryBgColor"
  }), []);
  return /* @__PURE__ */ React16.createElement(Wrapper3, null, /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "fansUnitedHeaderWrapper",
    onClick: handleCollapseToggle
  }, /* @__PURE__ */ React16.createElement(SMPText, {
    size: "2",
    variant: "contrast"
  }, /* @__PURE__ */ React16.createElement(FansUnitedToggleTitle, {
    title: labels == null ? void 0 : labels.fu_play_free
  })), /* @__PURE__ */ React16.createElement(SMPArrowUpIcon, {
    style: {
      width: "12px",
      height: "8px",
      transition: "all 0.4s ease-out",
      transform: `rotate(${isExpanded ? "0deg" : "180deg"})`
    },
    css: {
      "&:hover": {
        color: "#FF901A",
        cursor: "pointer"
      }
    }
  })), /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "fansUnitedContentWrapper",
    display: isExpanded ? "flex" : "none"
  }, /* @__PURE__ */ React16.createElement(SMPText, {
    size: "2",
    weight: "700",
    variant: "contrast"
  }, (_a2 = labels == null ? void 0 : labels.fu_win_question) != null ? _a2 : "Who will win?"), /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "fansUnitedOutcome1X2"
  }, /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "column",
    align: "center",
    css: { width: "60%", "@bp1": { width: "auto" } }
  }, /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "fansUnited1X2Pill",
    gap: "sm",
    style: { border: `${predictionSign === ONE ? "1px solid #FF901A" : "none"}` },
    onClick: () => handlePredictionClick(ONE)
  }, /* @__PURE__ */ React16.createElement(SMPText, {
    variant: "fansUnited1X2Label"
  }, homeTeam)), /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "column",
    align: "center",
    css: { mt: "11px", width: "100%" },
    display: summary ? "flex" : "none"
  }, /* @__PURE__ */ React16.createElement(SMPProgressBar, {
    value: summary == null ? void 0 : summary["1"],
    css: { width: "100%", "@bp1": { width: "115px" }, mb: "$2" }
  }), /* @__PURE__ */ React16.createElement(SMPText, {
    size: "2",
    variant: "contrast"
  }, summary == null ? void 0 : summary["1"], "%"))), /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "column",
    align: "center",
    css: { width: "60%", "@bp1": { width: "auto" } }
  }, /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "fansUnited1X2Pill",
    style: { border: `${predictionSign === X3 ? "1px solid #FF901A" : "none"}` },
    onClick: () => handlePredictionClick(X3)
  }, /* @__PURE__ */ React16.createElement(SMPText, {
    variant: "fansUnited1X2Label"
  }, (_b = labels == null ? void 0 : labels.fu_draw) != null ? _b : "Draw")), /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "column",
    align: "center",
    css: { mt: "11px", width: "100%" },
    display: summary ? "flex" : "none"
  }, /* @__PURE__ */ React16.createElement(SMPProgressBar, {
    value: summary == null ? void 0 : summary.x,
    css: { width: "100%", "@bp1": { width: "115px" }, mb: "$2" }
  }), /* @__PURE__ */ React16.createElement(SMPText, {
    size: "2",
    variant: "contrast"
  }, summary == null ? void 0 : summary.x, "%"))), /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "column",
    align: "center",
    css: { width: "60%", "@bp1": { width: "auto" } }
  }, /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "fansUnited1X2Pill",
    style: { border: `${predictionSign === TWO ? "1px solid #FF901A" : "none"}` },
    onClick: () => handlePredictionClick(TWO)
  }, /* @__PURE__ */ React16.createElement(SMPText, {
    variant: "fansUnited1X2Label"
  }, awayTeam)), /* @__PURE__ */ React16.createElement(SMPFlex, {
    variant: "column",
    align: "center",
    css: { mt: "11px", width: "100%" },
    display: summary ? "flex" : "none"
  }, /* @__PURE__ */ React16.createElement(SMPProgressBar, {
    value: summary == null ? void 0 : summary["2"],
    css: { width: "100%", "@bp1": { width: "115px" }, mb: "$2" }
  }), /* @__PURE__ */ React16.createElement(SMPText, {
    size: "2",
    variant: "contrast"
  }, summary == null ? void 0 : summary["2"], "%"))))));
};

// src/molecules/Header/Header.tsx
import { useEffect as useEffect12, useRef as useRef6, useState as useState14 } from "react";
import { setNationalParticipantBorder as setNationalParticipantBorder4 } from "@sportal365/smp-widget-utils";
var Header = ({
  logo,
  link,
  title,
  urlTarget,
  options,
  tabOptions,
  selectedOption,
  secondaryTitle,
  selectedTab,
  handleClick,
  handleChange,
  secondaryHeader,
  handleTabOptionClick,
  handleSubscriptionClick,
  isMainImageRound,
  displayMainHeader,
  dataOptionsDisplay,
  mobileDropdown
}) => {
  const headerRef = useRef6(null);
  const displayTabOptions = !!(dataOptionsDisplay && tabOptions && tabOptions.length > 1);
  const [isMobile, setIsMobile] = useState14(false);
  const [width, setWidth] = useState14(0);
  useEffect12(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const newWidth = entry.contentRect.width;
        if (newWidth !== width && headerRef.current) {
          setWidth(newWidth);
          setIsMobile(newWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT);
          headerRef.current.style.setProperty("--filters-width", `${newWidth}px`);
        }
      }
    });
    if (headerRef.current) {
      resizeObserver.observe(headerRef.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [width, displayTabOptions]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, displayMainHeader && /* @__PURE__ */ React.createElement(SMPFlex, {
    ref: headerRef,
    variant: "header",
    wrap: "wrap",
    gap: "lg",
    css: {
      pb: displayTabOptions || secondaryHeader !== void 0 ? void 0 : "$2_5",
      bc: "$rowBackgroundColor",
      flexDirection: "column",
      "@media (min-width: 640px)": {
        flexDirection: "row",
        alignItems: "center"
      }
    }
  }, /* @__PURE__ */ React.createElement(SMPLinkWrapper, {
    href: link,
    target: urlTarget,
    onClick: handleClick
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    grow: 1,
    align: "center",
    css: { justifyContent: "start" }
  }, logo && /* @__PURE__ */ React.createElement(SMPImage, {
    variant: "livescoreEntityLogo",
    src: logo,
    alt: `${title} Logo`,
    css: __spreadValues({ mr: "$1", br: isMainImageRound ? "$round" : "" }, setNationalParticipantBorder4(!!isMainImageRound))
  }), /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "column"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "3",
    weight: "700"
  }, title), /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "2"
  }, secondaryTitle)))), options && /* @__PURE__ */ React.createElement(Dropdown, {
    options,
    value: selectedOption,
    onChange: handleChange,
    handleSubscriptionClick,
    parentRef: headerRef
  })), displayTabOptions && /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "standingsFilters",
    ref: headerRef
  }, /* @__PURE__ */ React.createElement(PillTabs, {
    tabs: tabOptions,
    selectedTab,
    handleTabClick: handleTabOptionClick,
    handleSubscriptionClick,
    mobileDropdown: mobileDropdown && isMobile,
    parentRef: headerRef
  })), secondaryHeader && /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "standingsFilters"
  }, secondaryHeader));
};

// src/molecules/Table/Table.tsx
import React20, { useEffect as useEffect15, useState as useState17 } from "react";

// src/molecules/TableRows/TableRows.tsx
import React17 from "react";
import { setNationalParticipantBorder as setNationalParticipantBorder5 } from "@sportal365/smp-widget-utils";
var TableRow = styled.withConfig({ componentId: "CommonWidget", displayName: "TableRow" })("tr", {
  height: "45px",
  position: "relative",
  "&::after": {
    content: "",
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    borderBottom: "1px solid $primaryBackgroundColor",
    zIndex: 100
  }
});
var StickyColD = styled.withConfig({ componentId: "CommonWidget", displayName: "StickyColD" })("td", {
  position: "sticky",
  width: "100%",
  left: "0",
  bc: "$rowBackgroundColor",
  boxSizing: "border-box",
  "&::before": {
    content: "",
    width: "$1",
    top: "4%",
    height: "90%",
    position: "absolute",
    borderRadius: "0 $3 $3 0"
  },
  variants: {
    rule: {
      top: {
        "&::before": {
          background: "$top"
        }
      },
      topplayoff: {
        "&::before": {
          background: "$topPlayoff"
        }
      },
      relegation: {
        "&::before": {
          background: "$relegationColor"
        }
      },
      relegationplayoff: {
        "&::before": {
          background: "$relegationPlayoff"
        }
      },
      promotion: {
        "&::before": {
          background: "$promotion"
        }
      },
      promotionplayoff: {
        "&::before": {
          background: "$promotionPlayoff"
        }
      },
      championshipplayoff: {
        "&::before": {
          background: "$championshipPlayoff"
        }
      },
      tiertwo: {
        "&::before": {
          background: "$tierTwo"
        }
      },
      tiertwoplayoff: {
        "&::before": {
          background: "$tierTwoPlayoff"
        }
      },
      none: {
        "&::before": {
          background: "inherit"
        }
      }
    },
    highlighted: {
      true: {
        backgroundColor: "$highLighted"
      }
    }
  }
});
var TableD = styled.withConfig({ componentId: "CommonWidget", displayName: "TableD" })("td", {
  bc: "$rowBackgroundColor",
  py: "12px",
  ml: "$3"
});
var TableRows = ({ rows, isSmallSize, noDataMessage, handleClick, handleTeamClick, columnsLength }) => {
  const getDataEntity = ({ type, value, css: css2 = {}, eventValues, urlTarget, countryName, countryFlag, teamName, teamId }) => {
    switch (type) {
      case "text": {
        const data = value;
        return /* @__PURE__ */ React17.createElement(SMPText, {
          variant: "contrast",
          size: "3",
          css: css2
        }, data != null ? data : "-");
      }
      case "link": {
        const data = value;
        return /* @__PURE__ */ React17.createElement(React17.Fragment, null, countryName || teamName ? /* @__PURE__ */ React17.createElement(SMPFlex, {
          css: css2,
          style: {
            flexDirection: "column",
            marginTop: "8px",
            marginBottom: "8px",
            marginLeft: isSmallSize ? "0" : "$2"
          }
        }, /* @__PURE__ */ React17.createElement(SMPText, {
          variant: "contrast",
          size: "3",
          style: isSmallSize ? {
            marginLeft: "$2",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            maxWidth: "135px"
          } : {},
          css: css2,
          onClick: () => handleClick && handleClick(eventValues.id, eventValues.name)
        }, data), countryName && /* @__PURE__ */ React17.createElement(SMPFlex, {
          style: { marginLeft: isSmallSize ? "0" : "8px", marginTop: "8px" },
          css: { alignItems: "center" }
        }, /* @__PURE__ */ React17.createElement(SMPImage, {
          variant: "livescoreEntityLogo",
          src: countryFlag,
          alt: `${countryName} Logo`,
          css: __spreadValues({
            width: "12px",
            height: "12px",
            br: "$round"
          }, setNationalParticipantBorder5(true))
        }), /* @__PURE__ */ React17.createElement(SMPText, {
          variant: "contrast",
          size: "2",
          css: css2,
          style: { marginLeft: "4px" }
        }, countryName)), teamName && /* @__PURE__ */ React17.createElement(SMPFlex, {
          style: { marginTop: "8px" },
          css: { alignItems: "center" }
        }, /* @__PURE__ */ React17.createElement(SMPText, {
          variant: "contrast",
          size: "2",
          css: css2,
          onClick: () => teamId && handleTeamClick && handleTeamClick(teamId, teamName)
        }, teamName))) : /* @__PURE__ */ React17.createElement(SMPText, {
          variant: "contrast",
          size: "3",
          css: css2,
          style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            height: "16px"
          },
          onClick: () => handleClick && handleClick(eventValues == null ? void 0 : eventValues.id, eventValues == null ? void 0 : eventValues.name)
        }, data));
      }
      case "image": {
        const data = value;
        return /* @__PURE__ */ React17.createElement(SMPImage, {
          variant: "livescoreEntityLogo",
          src: data,
          style: { display: "block" },
          alt: `${data} Logo`,
          css: __spreadValues({
            width: isSmallSize ? "24px" : "32px",
            height: isSmallSize ? "24px" : "32px",
            "@bp0": { display: "none" }
          }, css2)
        });
      }
      case "form": {
        const data = value;
        return /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(SMPFlex, {
          justify: "start",
          variant: "formWrapper",
          css: { paddingRight: "$2" }
        }, data == null ? void 0 : data.map((form, index) => {
          return /* @__PURE__ */ React17.createElement("a", {
            key: index,
            href: form.matchLink,
            target: urlTarget
          }, /* @__PURE__ */ React17.createElement(FormIcon, {
            form
          }));
        })));
      }
    }
  };
  if (rows && rows.length > 0) {
    return /* @__PURE__ */ React17.createElement(React17.Fragment, null, rows == null ? void 0 : rows.map((item, index) => {
      const deviceColumns = isSmallSize ? item == null ? void 0 : item.mobileColumns : item == null ? void 0 : item.desktopColumns;
      const itemLink = deviceColumns == null ? void 0 : deviceColumns.find((column) => column.type === "link");
      const eventLinkProps = {
        href: itemLink == null ? void 0 : itemLink.link,
        target: itemLink == null ? void 0 : itemLink.urlTarget,
        onClick: () => {
          var _a2, _b, _c, _d2;
          return handleClick && ((_a2 = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _a2.id) && ((_b = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _b.name) && handleClick((_c = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _c.id, (_d2 = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _d2.name);
        }
      };
      return /* @__PURE__ */ React17.createElement(SMPLinkWrapper, __spreadValues({
        key: `standings-rank-${index}`
      }, eventLinkProps), /* @__PURE__ */ React17.createElement(TableRow, null, /* @__PURE__ */ React17.createElement(StickyColD, {
        css: {
          "@bp0": { zIndex: "20" },
          "@bp2": { zIndex: isSmallSize ? "20" : "0" }
        },
        rule: item.ruleType,
        highlighted: item.isHighlighted,
        className: item.isHighlighted ? "highlighted-entity" : ""
      }, /* @__PURE__ */ React17.createElement(SMPFlex, {
        variant: "centeredRow",
        style: { maxWidth: isSmallSize ? "190px" : "" }
      }, deviceColumns ? deviceColumns.slice(0, 3).map((column, index2) => {
        return /* @__PURE__ */ React17.createElement(React17.Fragment, {
          key: index2
        }, getDataEntity({
          type: column.type,
          value: column.value,
          css: column.css,
          eventValues: column.eventValues,
          link: column.link,
          urlTarget: column.urlTarget,
          countryName: column.countryName,
          countryFlag: column.countryFlag,
          teamName: column.teamName,
          teamLink: column.teamLink
        }));
      }) : null)), deviceColumns ? deviceColumns.slice(3, deviceColumns.length).map((column, index2) => {
        return /* @__PURE__ */ React17.createElement(TableD, {
          key: index2,
          css: {
            backgroundColor: item.isHighlighted ? "$highLighted" : ""
          },
          className: item.isHighlighted ? "highlighted-entity" : ""
        }, getDataEntity({
          type: column.type,
          value: column.value,
          css: column.css,
          eventValues: column.eventValues,
          link: column.link,
          urlTarget: column.urlTarget,
          countryName: column.countryName,
          countryFlag: column.countryFlag,
          teamName: column.teamName
        }));
      }) : null));
    }));
  }
  return /* @__PURE__ */ React17.createElement(TableRow, {
    key: "standings-rank-no-data"
  }, /* @__PURE__ */ React17.createElement(TableD, {
    key: "no-data-table-data",
    align: "center",
    colSpan: columnsLength
  }, /* @__PURE__ */ React17.createElement(SMPText, {
    variant: "contrast",
    size: "3"
  }, noDataMessage != null ? noDataMessage : "No data")));
};

// src/molecules/StandingsTableRows/StandingsTableRows.tsx
import React18, { useEffect as useEffect13, useState as useState15 } from "react";

// src/atoms/icons/SMPStandingsWinIcon.tsx
var SMPStandingsWinIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("image", {
    width: "20",
    height: "20",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iIzAwODIyRiIvPgo8cGF0aCBkPSJNMTMuMDk5NiAxNUgxMi4xMTUyTDEwLjM4NjcgOS4yNjM2N0MxMC4zMDQ3IDkuMDA5NzcgMTAuMjEyOSA4LjY4OTQ1IDEwLjExMTMgOC4zMDI3M0MxMC4wMDk4IDcuOTE2MDIgOS45NTcwMyA3LjY4MzU5IDkuOTUzMTIgNy42MDU0N0M5Ljg2NzE5IDguMTIxMDkgOS43MzA0NyA4LjY4NTU1IDkuNTQyOTcgOS4yOTg4M0w3Ljg2NzE5IDE1SDYuODgyODFMNC42MDM1MiA2LjQzMzU5SDUuNjU4Mkw3LjAxMTcyIDExLjcyNDZDNy4xOTkyMiAxMi40NjY4IDcuMzM1OTQgMTMuMTM4NyA3LjQyMTg4IDEzLjc0MDJDNy41MjczNCAxMy4wMjU0IDcuNjgzNTkgMTIuMzI2MiA3Ljg5MDYyIDExLjY0MjZMOS40MjU3OCA2LjQzMzU5SDEwLjQ4MDVMMTIuMDkxOCAxMS42ODk1QzEyLjI3OTMgMTIuMjk0OSAxMi40Mzc1IDEyLjk3ODUgMTIuNTY2NCAxMy43NDAyQzEyLjY0MDYgMTMuMTg1NSAxMi43ODEyIDEyLjUwOTggMTIuOTg4MyAxMS43MTI5TDE0LjMzNTkgNi40MzM1OUgxNS4zOTA2TDEzLjA5OTYgMTVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
  }));
};

// src/atoms/icons/SMPStandingsLossIcon.tsx
var SMPStandingsLossIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("image", {
    width: "20",
    height: "20",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iI0RDMDEwMCIvPgo8cGF0aCBkPSJNOC4wNjA1NSAxNVY2LjQzMzU5SDkuMDU2NjRWMTQuMDk3N0gxMi44MzU5VjE1SDguMDYwNTVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
  }));
};

// src/atoms/icons/SMPStandingsWinOverTimeIcon.tsx
var SMPStandingsWinOverTimeIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("image", {
    width: "20",
    height: "20",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iIzAwODIyRiIvPgo8cGF0aCBkPSJNMTMuMDk5NiAxNUgxMi4xMTUyTDEwLjM4NjcgOS4yNjM2N0MxMC4zMDQ3IDkuMDA5NzcgMTAuMjEyOSA4LjY4OTQ1IDEwLjExMTMgOC4zMDI3M0MxMC4wMDk4IDcuOTE2MDIgOS45NTcwMyA3LjY4MzU5IDkuOTUzMTIgNy42MDU0N0M5Ljg2NzE5IDguMTIxMDkgOS43MzA0NyA4LjY4NTU1IDkuNTQyOTcgOS4yOTg4M0w3Ljg2NzE5IDE1SDYuODgyODFMNC42MDM1MiA2LjQzMzU5SDUuNjU4Mkw3LjAxMTcyIDExLjcyNDZDNy4xOTkyMiAxMi40NjY4IDcuMzM1OTQgMTMuMTM4NyA3LjQyMTg4IDEzLjc0MDJDNy41MjczNCAxMy4wMjU0IDcuNjgzNTkgMTIuMzI2MiA3Ljg5MDYyIDExLjY0MjZMOS40MjU3OCA2LjQzMzU5SDEwLjQ4MDVMMTIuMDkxOCAxMS42ODk1QzEyLjI3OTMgMTIuMjk0OSAxMi40Mzc1IDEyLjk3ODUgMTIuNTY2NCAxMy43NDAyQzEyLjY0MDYgMTMuMTg1NSAxMi43ODEyIDEyLjUwOTggMTIuOTg4MyAxMS43MTI5TDE0LjMzNTkgNi40MzM1OUgxNS4zOTA2TDEzLjA5OTYgMTVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTUgMTVMMjAgMTBWMTZDMjAgMTguMjA5MSAxOC4yMDkxIDIwIDE2IDIwSDEwTDE1IDE1WiIgZmlsbD0iI0ZGRDgwMCIvPgo8L3N2Zz4K"
  }));
};

// src/atoms/icons/SMPStandingsLossOvertimeIcon.tsx
var SMPStandingsLossOverTimeIcon = (props) => {
  return /* @__PURE__ */ React.createElement(SMPIcon, __spreadValues({}, props), /* @__PURE__ */ React.createElement("image", {
    width: "20",
    height: "20",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iI0RDMDEwMCIvPgo8cGF0aCBkPSJNOC4wNjA1NSAxNVY2LjQzMzU5SDkuMDU2NjRWMTQuMDk3N0gxMi44MzU5VjE1SDguMDYwNTVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTUgMTVMMjAgMTBWMTZDMjAgMTguMjA5MSAxOC4yMDkxIDIwIDE2IDIwSDEwTDE1IDE1WiIgZmlsbD0iI0ZGRDgwMCIvPgo8L3N2Zz4K"
  }));
};

// src/molecules/SMPStandingsFormIcon/StandingsFormIcon.tsx
var StandingsFormIcon = ({ form }) => {
  const { outcome, startTime, matchSummary } = form;
  return /* @__PURE__ */ React.createElement(Tooltip, {
    text: startTime,
    overlineText: matchSummary,
    standingsForm: true
  }, {
    win: /* @__PURE__ */ React.createElement(SMPStandingsWinIcon, {
      width: "4",
      height: "4"
    }),
    loss: /* @__PURE__ */ React.createElement(SMPStandingsLossIcon, {
      width: "4",
      height: "4"
    }),
    win_overtime: /* @__PURE__ */ React.createElement(SMPStandingsWinOverTimeIcon, {
      width: "4",
      height: "4"
    }),
    loss_overtime: /* @__PURE__ */ React.createElement(SMPStandingsLossOverTimeIcon, {
      width: "4",
      height: "4"
    }),
    win_after_penalty: /* @__PURE__ */ React.createElement(SMPStandingsWinOverTimeIcon, {
      width: "4",
      height: "4"
    }),
    loss_after_penalty: /* @__PURE__ */ React.createElement(SMPStandingsLossOverTimeIcon, {
      width: "4",
      height: "4"
    })
  }[outcome]);
};

// src/molecules/StandingsTableRows/StandingsTableRows.tsx
var TableRow2 = styled.withConfig({ componentId: "CommonWidget", displayName: "TableRow" })("tr", {
  height: "44px",
  position: "relative",
  "&::after": {
    content: "",
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    borderBottom: "1px solid $primaryBackgroundColor",
    zIndex: 100
  }
});
var StickyColD2 = styled.withConfig({ componentId: "CommonWidget", displayName: "StickyColD" })("td", {
  height: "44px",
  position: "sticky",
  width: "100%",
  left: "0",
  bc: "$rowBackgroundColor",
  boxSizing: "border-box",
  "&::before": {
    content: "",
    width: "$1",
    top: "4%",
    height: "90%",
    position: "absolute",
    borderRadius: "0 $3 $3 0"
  },
  variants: {
    rule: {
      top: {
        "&::before": {
          background: "$top"
        }
      },
      topplayoff: {
        "&::before": {
          background: "$topPlayoff"
        }
      },
      relegation: {
        "&::before": {
          background: "$relegationColor"
        }
      },
      relegationplayoff: {
        "&::before": {
          background: "$relegationPlayoff"
        }
      },
      promotion: {
        "&::before": {
          background: "$promotion"
        }
      },
      promotionplayoff: {
        "&::before": {
          background: "$promotionPlayoff"
        }
      },
      championshipplayoff: {
        "&::before": {
          background: "$championshipPlayoff"
        }
      },
      tiertwo: {
        "&::before": {
          background: "$tierTwo"
        }
      },
      tiertwoplayoff: {
        "&::before": {
          background: "$tierTwoPlayoff"
        }
      },
      none: {
        "&::before": {
          background: "inherit"
        }
      }
    },
    highlighted: {
      true: {
        backgroundColor: "$highLighted"
      }
    }
  }
});
var TableD2 = styled.withConfig({ componentId: "CommonWidget", displayName: "TableD" })("td", {
  bc: "$rowBackgroundColor",
  py: "12px",
  ml: "$3"
});
var standingsDefaultColumnsMaxWidth = (containerWidth) => {
  if (containerWidth) {
    if (containerWidth < 300) {
      return "185px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT - 80) {
      return "225px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT - 55) {
      return "225px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT - 35) {
      return "250px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT - 20) {
      return "285px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT) {
      return "300px";
    }
  }
  return "";
};
var StandingsTableRows = ({
  rows,
  isSmallSize,
  containerSize,
  noDataMessage,
  handleClick,
  handleTeamClick,
  columnsLength,
  displayImage
}) => {
  const getDataEntity = ({ type, value, css: css2 = {}, eventValues, countryName, countryFlag, teamName, teamId }) => {
    switch (type) {
      case "text": {
        const data = value;
        return /* @__PURE__ */ React18.createElement(SMPText, {
          variant: "contrast",
          size: "3",
          css: css2
        }, data != null ? data : "-");
      }
      case "link": {
        const data = value;
        return /* @__PURE__ */ React18.createElement(React18.Fragment, null, countryName || teamName ? /* @__PURE__ */ React18.createElement(SMPFlex, {
          css: css2,
          style: {
            flexDirection: "column",
            marginTop: "8px",
            marginBottom: "8px",
            marginLeft: isSmallSize ? "0" : "$2"
          }
        }, /* @__PURE__ */ React18.createElement(SMPText, {
          variant: "contrast",
          size: "3",
          style: isSmallSize ? {
            marginLeft: "$2",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            maxWidth: "135px"
          } : {},
          css: css2
        }, data), countryName && /* @__PURE__ */ React18.createElement(SMPFlex, {
          style: { marginLeft: isSmallSize ? "0" : "8px", marginTop: "8px" },
          css: { alignItems: "center" }
        }, /* @__PURE__ */ React18.createElement(SMPImage, {
          variant: "livescoreEntityLogo",
          src: countryFlag,
          alt: `${countryName} Logo`,
          css: { width: "12px", height: "12px" }
        }), /* @__PURE__ */ React18.createElement(SMPText, {
          variant: "contrast",
          size: "2",
          css: css2,
          style: { marginLeft: "4px" }
        }, countryName)), teamName && /* @__PURE__ */ React18.createElement(SMPFlex, {
          style: { marginTop: "8px" },
          css: { alignItems: "center" }
        }, /* @__PURE__ */ React18.createElement(SMPText, {
          variant: "contrast",
          size: "2",
          css: css2,
          onClick: () => teamId && handleTeamClick && handleTeamClick(teamId, teamName)
        }, teamName))) : /* @__PURE__ */ React18.createElement(SMPText, {
          variant: "contrast",
          size: "3",
          css: css2,
          style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            height: "16px"
          },
          onClick: () => handleClick && handleClick(eventValues == null ? void 0 : eventValues.id, eventValues == null ? void 0 : eventValues.name)
        }, data));
      }
      case "image": {
        const data = value;
        return /* @__PURE__ */ React18.createElement(SMPImage, {
          variant: "livescoreEntityLogo",
          src: data,
          alt: `${data} Logo`,
          style: {
            display: displayImage ? "block" : "none"
          },
          css: __spreadValues({
            width: isBelow400 ? "24px" : "32px",
            height: isBelow400 ? "24px" : "32px",
            "@bp0": { display: "none" }
          }, css2)
        });
      }
      case "form": {
        const data = value;
        return /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement(SMPFlex, {
          justify: "start",
          variant: "formWrapper",
          css: { paddingRight: "$2" }
        }, data == null ? void 0 : data.map((form) => /* @__PURE__ */ React18.createElement(FormIcon, {
          key: form.matchLink,
          form
        }))));
      }
      case "standings_form": {
        const data = value;
        return /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement(SMPFlex, {
          justify: "start",
          variant: "formWrapper",
          css: { paddingRight: "$3" }
        }, data == null ? void 0 : data.map((form) => /* @__PURE__ */ React18.createElement(StandingsFormIcon, {
          key: form.matchLink,
          form
        }))));
      }
    }
  };
  const [isBelow400, setIsBelow400] = useState15(false);
  const [defColumnsMaxWidth, setDefColumnsMaxWidth] = useState15(standingsDefaultColumnsMaxWidth(containerSize));
  useEffect13(() => {
    if (containerSize) {
      setDefColumnsMaxWidth(standingsDefaultColumnsMaxWidth(containerSize));
      setIsBelow400(containerSize < STANDINGS_DATA_ELEMENTS_BREAKPOINT);
    }
  }, [containerSize]);
  if (rows && rows.length > 0) {
    return /* @__PURE__ */ React18.createElement(React18.Fragment, null, rows == null ? void 0 : rows.map((item, index) => {
      const isSmallSize2 = containerSize && containerSize + 16 < TABULAR_WIDGET_BREAKPOINT_1;
      const deviceColumns = isSmallSize2 ? item == null ? void 0 : item.mobileColumns : item == null ? void 0 : item.desktopColumns;
      const itemLink = deviceColumns == null ? void 0 : deviceColumns.find((column) => column.type === "link");
      const eventLinkProps = {
        href: itemLink == null ? void 0 : itemLink.link,
        target: itemLink == null ? void 0 : itemLink.urlTarget,
        onClick: () => {
          var _a2, _b, _c, _d2;
          return handleTeamClick && ((_a2 = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _a2.id) && ((_b = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _b.name) && handleTeamClick((_c = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _c.id, (_d2 = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _d2.name);
        }
      };
      return /* @__PURE__ */ React18.createElement(SMPLinkWrapper, __spreadValues({
        key: `standings-rank-${index}`
      }, eventLinkProps), /* @__PURE__ */ React18.createElement(TableRow2, null, /* @__PURE__ */ React18.createElement(StickyColD2, {
        css: {
          "@bp0": { zIndex: "20" },
          "@bp2": { zIndex: isSmallSize2 ? "20" : "0" }
        },
        rule: item.ruleType,
        highlighted: item.isHighlighted,
        className: item.isHighlighted ? "highlighted-entity" : ""
      }, /* @__PURE__ */ React18.createElement(SMPFlex, {
        variant: "centeredRow",
        style: {
          maxWidth: defColumnsMaxWidth,
          height: 45
        }
      }, deviceColumns ? deviceColumns.slice(0, 3).map((column, index2) => {
        return /* @__PURE__ */ React18.createElement(React18.Fragment, {
          key: index2
        }, getDataEntity({
          type: column.type,
          value: column.value,
          css: column.css,
          eventValues: column.eventValues,
          link: column.link,
          urlTarget: column.urlTarget,
          countryName: column.countryName,
          countryFlag: column.countryFlag,
          teamName: column.teamName,
          teamLink: column.teamLink
        }));
      }) : null)), deviceColumns ? deviceColumns.slice(3, deviceColumns.length).map((column, index2) => {
        return /* @__PURE__ */ React18.createElement(TableD2, {
          key: index2,
          css: {
            backgroundColor: item.isHighlighted ? "$highLighted" : ""
          },
          className: item.isHighlighted ? "highlighted-entity" : ""
        }, getDataEntity({
          type: column.type,
          value: column.value,
          css: column.css,
          eventValues: column.eventValues,
          link: column.link,
          urlTarget: column.urlTarget,
          countryName: column.countryName,
          countryFlag: column.countryFlag,
          teamName: column.teamName
        }));
      }) : null));
    }));
  }
  return /* @__PURE__ */ React18.createElement(TableRow2, {
    key: "standings-rank-no-data"
  }, /* @__PURE__ */ React18.createElement(TableD2, {
    key: "no-data-table-data",
    align: "center",
    colSpan: columnsLength
  }, /* @__PURE__ */ React18.createElement(SMPText, {
    variant: "contrast",
    size: "3"
  }, noDataMessage != null ? noDataMessage : "No data")));
};

// src/molecules/StatsTableRows/StatsTableRows.tsx
import React19, { useEffect as useEffect14, useState as useState16 } from "react";
var TableRow3 = styled.withConfig({ componentId: "CommonWidget", displayName: "TableRow" })("tr", {
  height: "45px",
  position: "relative",
  "&::after": {
    content: "",
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    borderBottom: "1px solid $primaryBackgroundColor",
    zIndex: 100
  }
});
var StickyColD3 = styled.withConfig({ componentId: "CommonWidget", displayName: "StickyColD" })("td", {
  position: "sticky",
  width: "100%",
  left: "0",
  bc: "$rowBackgroundColor",
  boxSizing: "border-box",
  "&::before": {
    content: "",
    width: "$1",
    top: "4%",
    height: "90%",
    position: "absolute",
    borderRadius: "0 $3 $3 0"
  },
  variants: {
    rule: {
      top: {
        "&::before": {
          background: "$top"
        }
      },
      topplayoff: {
        "&::before": {
          background: "$topPlayoff"
        }
      },
      relegation: {
        "&::before": {
          background: "$relegationColor"
        }
      },
      relegationplayoff: {
        "&::before": {
          background: "$relegationPlayoff"
        }
      },
      promotion: {
        "&::before": {
          background: "$promotion"
        }
      },
      promotionplayoff: {
        "&::before": {
          background: "$promotionPlayoff"
        }
      },
      championshipplayoff: {
        "&::before": {
          background: "$championshipPlayoff"
        }
      },
      tiertwo: {
        "&::before": {
          background: "$tierTwo"
        }
      },
      tiertwoplayoff: {
        "&::before": {
          background: "$tierTwoPlayoff"
        }
      },
      none: {
        "&::before": {
          background: "inherit"
        }
      }
    },
    highlighted: {
      true: {
        backgroundColor: "$highLighted"
      }
    }
  }
});
var TableD3 = styled.withConfig({ componentId: "CommonWidget", displayName: "TableD" })("td", {
  bc: "$rowBackgroundColor",
  py: "12px",
  ml: "$3"
});
var statDefaultColumnsMaxWidth = (containerWidth) => {
  if (containerWidth) {
    if (containerWidth < 300) {
      return "185px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT - 80) {
      return "225px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT - 55) {
      return "225px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT - 35) {
      return "250px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT - 20) {
      return "285px";
    } else if (containerWidth < STANDINGS_DATA_ELEMENTS_BREAKPOINT) {
      return "300px";
    }
  }
  return "";
};
var StatsTableRows = ({
  rows,
  isSmallSize,
  noDataMessage,
  handleClick,
  handleTeamClick,
  columnsLength,
  containerSize,
  displayImage
}) => {
  const getDataEntity = ({ type, value, css: css2 = {}, eventValues, countryName, countryFlag, teamName, teamId, teamLogo }) => {
    switch (type) {
      case "text": {
        const data = value;
        return /* @__PURE__ */ React19.createElement(SMPText, {
          variant: "contrast",
          size: "3",
          css: css2
        }, data != null ? data : "-");
      }
      case "link": {
        const data = value;
        return /* @__PURE__ */ React19.createElement(React19.Fragment, null, countryName || teamName ? /* @__PURE__ */ React19.createElement(SMPFlex, {
          css: css2,
          style: {
            flexDirection: "column",
            marginTop: "8px",
            marginBottom: "8px",
            marginLeft: isSmallSize ? "0" : "$2",
            gap: "2px"
          }
        }, /* @__PURE__ */ React19.createElement(SMPText, {
          variant: "contrast",
          size: "3",
          css: __spreadProps(__spreadValues({}, css2), {
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            width: "100%",
            maxWidth: "135px",
            lineHeight: "normal"
          }),
          onClick: () => handleClick && handleClick(eventValues.id, eventValues.name)
        }, data), countryName && /* @__PURE__ */ React19.createElement(SMPFlex, {
          css: { alignItems: "center", gap: "2px", display: "flex" }
        }, /* @__PURE__ */ React19.createElement(SMPImage, {
          variant: "livescoreEntityLogo",
          src: countryFlag,
          alt: `${countryName} Logo`,
          css: { width: "16px", height: "16px", br: "$round" }
        }), /* @__PURE__ */ React19.createElement(SMPText, {
          variant: "contrast",
          size: "2",
          css: __spreadProps(__spreadValues({}, css2), {
            color: "$playerTeamColor",
            marginLeft: "4px"
          })
        }, countryName)), teamName && /* @__PURE__ */ React19.createElement(SMPFlex, {
          css: { alignItems: "center", gap: "2px", display: "flex" }
        }, /* @__PURE__ */ React19.createElement(SMPImage, {
          variant: "livescoreEntityLogo",
          src: teamLogo,
          alt: `${teamName} Logo`,
          css: { width: "16px", height: "16px", br: "$round" }
        }), /* @__PURE__ */ React19.createElement(SMPText, {
          variant: "contrast",
          size: "2",
          css: __spreadProps(__spreadValues({}, css2), {
            color: "$playerTeamColor",
            marginLeft: "4px"
          }),
          onClick: () => teamId && handleTeamClick && handleTeamClick(teamId, teamName)
        }, teamName))) : /* @__PURE__ */ React19.createElement(SMPText, {
          variant: "contrast",
          size: "3",
          css: __spreadProps(__spreadValues({}, css2), {
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            width: "100%",
            maxWidth: "135px",
            lineHeight: "normal"
          }),
          onClick: () => handleClick && handleClick(eventValues == null ? void 0 : eventValues.id, eventValues == null ? void 0 : eventValues.name)
        }, data));
      }
      case "image": {
        const data = value;
        return /* @__PURE__ */ React19.createElement(SMPImage, {
          variant: "livescoreEntityLogo",
          src: data,
          alt: `${data} Logo`,
          style: {
            display: displayImage ? "block" : "none"
          },
          css: __spreadValues({
            width: "42px",
            height: "42px",
            "@bp0": { display: "none" },
            borderRadius: "$round"
          }, css2)
        });
      }
      case "form": {
        const data = value;
        return /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement(SMPFlex, {
          justify: "start",
          variant: "formWrapper"
        }, data == null ? void 0 : data.map((form) => /* @__PURE__ */ React19.createElement(FormIcon, {
          key: form.matchLink,
          form
        }))));
      }
    }
  };
  const [defColumnsMaxWidth, setDefColumnsMaxWidth] = useState16(statDefaultColumnsMaxWidth(containerSize));
  useEffect14(() => {
    if (containerSize) {
      setDefColumnsMaxWidth(statDefaultColumnsMaxWidth(containerSize));
    }
  }, [containerSize]);
  if (rows && rows.length > 0) {
    return /* @__PURE__ */ React19.createElement(React19.Fragment, null, rows == null ? void 0 : rows.map((item, index) => {
      const deviceColumns = isSmallSize ? item == null ? void 0 : item.mobileColumns : item == null ? void 0 : item.desktopColumns;
      const itemLink = deviceColumns == null ? void 0 : deviceColumns.find((column) => column.type === "link");
      const eventLinkProps = {
        href: itemLink == null ? void 0 : itemLink.link,
        target: itemLink == null ? void 0 : itemLink.urlTarget,
        onClick: () => {
          var _a2, _b, _c, _d2;
          return handleClick && ((_a2 = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _a2.id) && ((_b = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _b.name) && handleClick((_c = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _c.id, (_d2 = itemLink == null ? void 0 : itemLink.eventValues) == null ? void 0 : _d2.name);
        }
      };
      return /* @__PURE__ */ React19.createElement(SMPLinkWrapper, __spreadValues({
        key: `standings-rank-${index}`
      }, eventLinkProps), /* @__PURE__ */ React19.createElement(TableRow3, null, /* @__PURE__ */ React19.createElement(StickyColD3, {
        css: {
          "@bp0": { zIndex: "20" },
          "@bp2": { zIndex: isSmallSize ? "20" : "0" }
        },
        rule: item.ruleType,
        highlighted: item.isHighlighted,
        className: item.isHighlighted ? "highlighted-entity" : ""
      }, /* @__PURE__ */ React19.createElement(SMPFlex, {
        variant: "centeredRow",
        style: { maxWidth: defColumnsMaxWidth, gap: "2px" }
      }, deviceColumns ? deviceColumns.slice(0, 3).map((column, index2) => {
        return /* @__PURE__ */ React19.createElement(React19.Fragment, {
          key: index2
        }, getDataEntity({
          type: column.type,
          value: column.value,
          css: column.css,
          eventValues: column.eventValues,
          link: column.link,
          urlTarget: column.urlTarget,
          countryName: column.countryName,
          countryFlag: column.countryFlag,
          teamName: column.teamName,
          teamLink: column.teamLink,
          teamLogo: column.teamLogo
        }));
      }) : null)), deviceColumns ? deviceColumns.slice(3, deviceColumns.length).map((column, index2) => {
        return /* @__PURE__ */ React19.createElement(TableD3, {
          key: index2,
          css: {
            backgroundColor: item.isHighlighted ? "$highLighted" : ""
          },
          className: item.isHighlighted ? "highlighted-entity" : ""
        }, getDataEntity({
          type: column.type,
          value: column.value,
          css: column.css,
          eventValues: column.eventValues,
          link: column.link,
          urlTarget: column.urlTarget,
          countryName: column.countryName,
          countryFlag: column.countryFlag,
          teamName: column.teamName,
          teamLogo: column.teamLogo
        }));
      }) : null));
    }));
  }
  return /* @__PURE__ */ React19.createElement(TableRow3, {
    key: "standings-rank-no-data"
  }, /* @__PURE__ */ React19.createElement(TableD3, {
    key: "no-data-table-data",
    align: "center",
    colSpan: columnsLength
  }, /* @__PURE__ */ React19.createElement(SMPText, {
    variant: "contrast",
    size: "3"
  }, noDataMessage != null ? noDataMessage : "No data")));
};

// src/molecules/Table/Table.tsx
var View = styled.withConfig({ componentId: "CommonWidget", displayName: "TableView" })("div", {
  position: "relative",
  margin: "auto",
  width: "100%"
});
var Wrapper = styled.withConfig({ componentId: "CommonWidget", displayName: "TableWrapper" })("div", {
  position: "relative",
  whiteSpace: "nowrap",
  "@bp0": {
    overflow: "auto",
    zIndex: "20"
  },
  "@bp1": {
    overflow: "visible"
  },
  "&::-webkit-scrollbar": {
    display: "none"
  },
  scrollbarWidth: "none",
  msOverflowStyle: "none"
});
var StickyColH = styled.withConfig({ componentId: "CommonWidget", displayName: "StickyColH" })("th", {
  position: "sticky",
  bc: "$primaryBackgroundColor",
  left: "0"
});
var StandardColH = styled.withConfig({ componentId: "CommonWidget", displayName: "StandardColH" })("th", {
  minWidth: "$2_5"
});
var Table = ({
  groupName,
  handleClick,
  rows,
  columns,
  addCustomStyles,
  handleTeamClick,
  noDataMessage,
  sport,
  isMobile,
  isTeamSquad,
  position,
  displayImage,
  tableVariant
}) => {
  const [containerSize, setContainerSize] = useState17(void 0);
  const [isSmallSize, setIsSmallSize] = useState17(true);
  const [forceTooltipRender, setForceTooltipRender] = useState17(true);
  useEffect15(() => {
    setForceTooltipRender(false);
  }, [isSmallSize]);
  const measuredContainerRef = useResizeObserver((container) => {
    setIsSmallSize(container.offsetWidth < 768);
    setContainerSize(container.offsetWidth);
  });
  const isGoalkeeperGroup = position === "keeper";
  const shouldRenderColumn = (column) => {
    if (isGoalkeeperGroup) {
      return true;
    }
    return column.statValue !== "conceded";
  };
  const toggleTooltip2 = (e3, show) => {
    if (!(e3.target instanceof Element)) {
      return;
    }
    const statContainer = e3.target.closest(".stat-column");
    const tooltip = statContainer == null ? void 0 : statContainer.querySelector(".stat-column-tooltip");
    if (tooltip) {
      try {
        tooltip.style.display = show ? "block" : "none";
      } catch (e4) {
        console.error(e4);
      }
    }
  };
  const applyCustomCssForStandings = validForCustomSportsStyles.includes(sport || "");
  const applyCustomCss = tableVariant === TableVariants.STATS || applyCustomCssForStandings;
  const tableHeaderColCss = applyCustomCss ? {
    paddingTop: "10px",
    paddingBottom: "10px",
    height: "20px"
  } : {};
  const tableStickyHeaderColCss = applyCustomCss ? {
    paddingLeft: "16px"
  } : {};
  return /* @__PURE__ */ React20.createElement(SMPContainer, {
    ref: measuredContainerRef,
    variant: "paddinglessContainer",
    css: {
      mb: isTeamSquad ? void 0 : "$1"
    }
  }, groupName && /* @__PURE__ */ React20.createElement(SMPFlex, {
    variant: "standingsMarginals",
    style: { backgroundColor: isTeamSquad ? void 0 : "var(--colors-subHeaderBgColor)" }
  }, /* @__PURE__ */ React20.createElement(SMPText, {
    variant: "contrast",
    size: `${applyCustomCss ? 3 : 2}`,
    weight: "700"
  }, groupName)), /* @__PURE__ */ React20.createElement(View, null, /* @__PURE__ */ React20.createElement(Wrapper, {
    style: { overflow: isMobile && applyCustomCssForStandings ? "hidden" : isSmallSize ? "auto" : "" },
    css: {
      "& th:not(:first-child) > :first-child, & td:not(:first-child) > :first-child": {
        mr: isMobile && !applyCustomCssForStandings ? "$2" : void 0
      }
    }
  }, /* @__PURE__ */ React20.createElement("table", {
    style: { borderCollapse: "collapse", width: "100%" }
  }, /* @__PURE__ */ React20.createElement("thead", null, /* @__PURE__ */ React20.createElement("tr", null, /* @__PURE__ */ React20.createElement(StickyColH, {
    style: __spreadProps(__spreadValues(__spreadValues({}, tableStickyHeaderColCss), tableHeaderColCss), {
      backgroundColor: "var(--colors-subHeaderBgColor)"
    }),
    css: {
      "@bp0": { zIndex: "20" },
      minWidth: isSmallSize ? "" : "200px",
      "@bp2": { zIndex: isSmallSize ? "20" : "0" }
    }
  }, /* @__PURE__ */ React20.createElement(SMPFlex, {
    css: applyCustomCss ? { justifyContent: "left" } : {
      py: "$2",
      justifyContent: "left",
      ml: "$2"
    }
  }, /* @__PURE__ */ React20.createElement(SMPText, {
    variant: "contrast",
    style: {
      width: `${addCustomStyles ? "24px" : "16px"}`,
      marginRight: `${applyCustomCssForStandings ? isMobile ? "10px" : "16px" : "16px"}`,
      fontWeight: applyCustomCssForStandings ? "600" : void 0
    },
    size: `${applyCustomCss ? 3 : 2}`
  }, "#"), columns ? columns.slice(0, 1).map((label, index) => {
    const css2 = sport === Sports.FOOTBALL ? {
      minWidth: "120px",
      maxWidth: "175px"
    } : { minWidth: "160px" };
    return /* @__PURE__ */ React20.createElement(React20.Fragment, {
      key: `sticky - col - ${index}`
    }, label.tooltip && (forceTooltipRender || !isSmallSize) ? /* @__PURE__ */ React20.createElement(Tooltip, {
      text: label.tooltip
    }, /* @__PURE__ */ React20.createElement(SMPText, {
      variant: "contrast",
      size: "2",
      css: __spreadValues({
        textAlign: "left",
        flexGrow: "1"
      }, css2)
    }, label == null ? void 0 : label.value)) : /* @__PURE__ */ React20.createElement(SMPText, {
      variant: "contrast",
      size: `${applyCustomCss ? 3 : 2}`,
      style: { fontWeight: applyCustomCssForStandings ? "600" : void 0 },
      css: __spreadValues({
        textAlign: "left",
        flexGrow: "1",
        userSelect: "none"
      }, css2)
    }, label == null ? void 0 : label.value));
  }) : null)), columns ? columns.slice(1, columns.length).map((label, index) => {
    if (!shouldRenderColumn(label))
      return null;
    return /* @__PURE__ */ React20.createElement(StandardColH, {
      style: tableHeaderColCss,
      key: `col - ${index}`,
      className: "stat-column",
      css: {
        bc: "$subHeaderBgColor",
        paddingRight: applyCustomCss && index === columns.length - 2 ? "16px" : void 0,
        gap: applyCustomCss ? "4px" : void 0
      },
      onClick: (e3) => e3.preventDefault(),
      onPointerEnter: (e3) => !isSmallSize && toggleTooltip2(e3, true),
      onPointerLeave: (e3) => !isSmallSize && toggleTooltip2(e3, false)
    }, /* @__PURE__ */ React20.createElement("div", {
      style: { position: "relative" }
    }, /* @__PURE__ */ React20.createElement(SMPTooltip, {
      css: {
        bottom: "100%",
        marginBottom: "10px",
        transition: "display 0.5s"
      },
      className: "stat-column-tooltip"
    }, /* @__PURE__ */ React20.createElement("span", null, label == null ? void 0 : label.tooltip))), /* @__PURE__ */ React20.createElement(SMPText, {
      variant: "contrast",
      size: `${applyCustomCss ? 3 : 2}`,
      css: label.css ? label.css : {
        width: "$6",
        textAlign: "center",
        userSelect: "none"
      }
    }, label == null ? void 0 : label.value));
  }) : null)), /* @__PURE__ */ React20.createElement("tbody", null, (() => {
    var _a2, _b, _c;
    const components = {
      STANDINGS_TABLE: /* @__PURE__ */ React20.createElement(StandingsTableRows, {
        rows,
        columnsLength: (_a2 = columns == null ? void 0 : columns.length) != null ? _a2 : 0,
        isSmallSize,
        containerSize,
        handleClick,
        handleTeamClick,
        noDataMessage,
        displayImage
      }),
      DEFAULT: /* @__PURE__ */ React20.createElement(TableRows, {
        rows,
        columnsLength: (_b = columns == null ? void 0 : columns.length) != null ? _b : 0,
        isSmallSize,
        handleClick,
        handleTeamClick,
        noDataMessage
      }),
      STATS_TABLE: /* @__PURE__ */ React20.createElement(StatsTableRows, {
        rows,
        columnsLength: (_c = columns == null ? void 0 : columns.length) != null ? _c : 0,
        isSmallSize,
        handleClick,
        handleTeamClick,
        noDataMessage,
        containerSize,
        displayImage
      })
    };
    switch (tableVariant) {
      case TableVariants.STANDINGS:
        return components.STANDINGS_TABLE;
      case TableVariants.STATS:
        return components.STATS_TABLE;
      default:
        return components.DEFAULT;
    }
  })())))));
};

// src/molecules/Tab/Tab.tsx
var Tab = ({ tab, selectTab, isSelected }) => {
  return /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    weight: "700",
    variant: isSelected ? "accentSecondary" : "contrast",
    css: {
      borderBottom: isSelected ? "4px solid" : "",
      lineHeight: "32px",
      cursor: "pointer",
      paddingTop: "8px",
      paddingRight: "16px",
      paddingBottom: "8px",
      paddingLeft: "16px"
    },
    onClick: () => selectTab && selectTab(tab.key)
  }, tab.value);
};

// src/molecules/TabBody/TabBody.tsx
var TabBody = ({ data }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, data);
};

// src/molecules/ProfileInfo/ProfileInfo.tsx
import { camelToSnakeCase as camelToSnakeCase2, getLabelValue } from "@sportal365/smp-widget-utils";
import { returnBuiltSocialData } from "@sportal365/smp-widget-utils/src/buildSocialUrls";

// src/atoms/SMPSocialsIcon.tsx
import { getSocialIconAsBgImage } from "@sportal365/smp-widget-utils/src/icons";
var SocialsIconContainer = styled.withConfig({ componentId: "SocialsIcon", displayName: "SocialsIconContainer" })("div", {
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  minWidth: "100%",
  display: "flex",
  overflow: "hidden",
  variants: {
    size: {
      mobile: {
        width: "26px",
        height: "26px"
      },
      desktop: {
        width: "32px",
        height: "32px"
      }
    }
  }
});
var SMPSocialsIcon = ({ key, href, social, dataTheme, isMobile }) => {
  const variant = dataTheme === "client" ? "light" : dataTheme;
  const icon = getSocialIconAsBgImage(social, variant != null ? variant : "light");
  return /* @__PURE__ */ React.createElement("a", {
    key,
    href,
    target: "_blank",
    rel: "noreferrer"
  }, /* @__PURE__ */ React.createElement(SocialsIconContainer, {
    id: `social`,
    size: isMobile ? "mobile" : "desktop",
    style: { backgroundImage: `url("${icon}")` }
  }));
};

// src/molecules/ProfileInfo/ProfileInfo.tsx
var ProfileInfo = ({ labels, data, elements, socials, dataTheme, isMobile }) => {
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    style: { paddingTop: "10px" }
  }, elements == null ? void 0 : elements.map((element) => {
    var _a2, _b;
    const dataElementValue = data == null ? void 0 : data[element];
    if (dataElementValue === void 0) {
      return null;
    }
    const elementAsSnakeCase = camelToSnakeCase2(element);
    const value = element === "position" ? getLabelValue(labels == null ? void 0 : labels[dataElementValue], dataElementValue) : dataElementValue;
    if (element === "socials") {
      return /* @__PURE__ */ React.createElement(SMPFlex, {
        variant: "even",
        justify: "spaceBetween",
        style: {
          paddingTop: "16px",
          paddingRight: "0px",
          paddingBottom: "16px",
          paddingLeft: "0px",
          flexDirection: "row"
        },
        key: element
      }, /* @__PURE__ */ React.createElement(SMPText, {
        variant: "contrast",
        size: "4"
      }, (_a2 = labels == null ? void 0 : labels[elementAsSnakeCase]) != null ? _a2 : element, ":"), /* @__PURE__ */ React.createElement(SMPText, {
        display: "flex",
        variant: "contrast",
        size: "4",
        weight: "700",
        gap: isMobile ? "mobile" : "desktop"
      }, socials && Object.keys(socials).map((social, index) => {
        if (socials[social]) {
          const socialUrl = returnBuiltSocialData(socials, social);
          return /* @__PURE__ */ React.createElement(SMPSocialsIcon, {
            isMobile,
            dataTheme,
            key: index,
            href: (socialUrl == null ? void 0 : socialUrl.length) > 0 ? socialUrl : "",
            social
          });
        }
      })));
    } else {
      return /* @__PURE__ */ React.createElement(SMPFlex, {
        justify: "spaceBetween",
        style: {
          paddingTop: "16px",
          paddingRight: "0px",
          paddingBottom: "16px",
          paddingLeft: "0px"
        },
        key: element
      }, /* @__PURE__ */ React.createElement(SMPText, {
        variant: "contrast",
        size: "4"
      }, (_b = labels == null ? void 0 : labels[elementAsSnakeCase]) != null ? _b : element, ":"), /* @__PURE__ */ React.createElement(SMPText, {
        variant: "contrast",
        size: "4",
        weight: "700"
      }, value));
    }
  }));
};

// src/molecules/TextBlock/TextBlock.tsx
var TextBlock = ({ text = "No games to show" }) => {
  const { setIsMobile } = useSizeContext();
  const measuredRef = useResizeObserver((fieldElement) => {
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
  });
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    variant: "sportEntityContainer",
    ref: measuredRef
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    justify: "center",
    align: "center"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "4",
    variant: "contrast"
  }, text)));
};

// src/molecules/text-block/text-block.tsx
var TextBlockTailwind = ({ text = "No games to show" }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "box-border p-4 bg-sportEntityContainerPrimaryBgColor"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-center items-center"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "text-5 text-hiContrast"
  }, text)));
};

// src/molecules/RankingFilters/RankingFilters.tsx
import { useMemo as useMemo8, useRef as useRef7 } from "react";
var RankingFilters = ({
  filter,
  handleFilterClick,
  availableRankings,
  handleSubscriptionClick
}) => {
  const filters = useMemo8(() => {
    if (availableRankings) {
      return availableRankings.map((ranking) => {
        return { name: ranking.standingType.name, value: ranking.id };
      });
    }
    return [];
  }, [availableRankings]);
  const ref = useRef7(null);
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    ref,
    variant: "standingsFilters",
    css: { bc: "$filtersContainerPrimaryBackgroundColor" }
  }, /* @__PURE__ */ React.createElement(PillTabs, {
    tabs: filters,
    selectedTab: filter,
    handleTabClick: handleFilterClick,
    handleSubscriptionClick
  }));
};

// src/molecules/ShowMore/ShowMore.tsx
import { defaultHandleUserInteractionClick as defaultHandleUserInteractionClick5 } from "@sportal365/smp-widget-utils/src/clickHandlers";
var ShowMore = ({
  handleShowMoreClick,
  showMoreLabel,
  totalItems,
  showedItems,
  handleSubscriptionClick
}) => {
  const showMore = showMoreLabel != null ? showMoreLabel : "Show more";
  const handleShowMoreClickAndSendSubscriptionEvent = () => {
    if (!handleShowMoreClick) {
      return;
    }
    handleShowMoreClick();
    handleSubscriptionClick && defaultHandleUserInteractionClick5(handleSubscriptionClick, USER_INTERACTION, SHOW_MORE_SUBSCRIBE_TYPE);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, totalItems && showedItems && totalItems > showedItems ? /* @__PURE__ */ React.createElement(SMPFlex, {
    justify: "center",
    align: "center",
    css: {
      backgroundColor: "$rowBackgroundColor"
    }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    onClick: handleShowMoreClickAndSendSubscriptionEvent,
    variant: "showMore"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "showMore"
  }, showMore), /* @__PURE__ */ React.createElement(SMPArrowDownIcon, null))) : null);
};

// src/molecules/ComparisonRow/ComparisonRow.tsx
var ComparisonRow = ({ valueOne, valueTwo, label, name, takeLowerValue }) => {
  const highlightFirstValue = takeLowerValue ? valueOne < valueTwo : valueOne > valueTwo;
  const highlightSecondValue = takeLowerValue ? valueTwo < valueOne : valueTwo > valueOne;
  const calculatedFullValue = valueOne + valueTwo;
  const percentageA = calculatedFullValue > 0 ? valueOne / calculatedFullValue * 100 : 0;
  const percentageB = calculatedFullValue > 0 ? valueTwo / calculatedFullValue * 100 : 0;
  const sign = name ? STATISTICS_WITH_PERCENTAGE_SIGN.includes(name) ? PERCENTAGE_SIGN : STATISTICS_WITH_MINUTES_SIGN.includes(name) ? MINUTES_SIGN : "" : "";
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    direction: "column",
    css: { bc: "$sportEntityContainerPrimaryBgColor", pb: "$3" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    justify: "spaceBetween",
    css: { mb: "$2", width: "100%" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    weight: highlightFirstValue ? "700" : "400",
    css: { color: highlightFirstValue ? "$progressHighlightedColor" : "$progressTextColor" }
  }, valueOne + sign), /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    variant: "contrast"
  }, label), /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    weight: highlightSecondValue ? "700" : "400",
    css: { color: highlightSecondValue ? "$progressHighlightedColor" : "$progressTextColor" }
  }, valueTwo + sign)), /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { bc: "$progressContainerBgColor", height: "$2", br: 25 }
  }, /* @__PURE__ */ React.createElement(Progressbar, null, /* @__PURE__ */ React.createElement(ProgressbarValue, {
    css: {
      bc: "$progressOneBgColor",
      right: 0,
      width: percentageA + "%"
    }
  })), /* @__PURE__ */ React.createElement(Delimiter, null), /* @__PURE__ */ React.createElement(Progressbar, null, /* @__PURE__ */ React.createElement(ProgressbarValue, {
    css: {
      bc: "$progressTwoBgColor",
      width: percentageB + "%"
    }
  }))));
};
var Progressbar = styled("div", {
  position: "relative",
  width: "calc(50% - 1px)",
  height: "100%"
});
var ProgressbarValue = styled("div", {
  position: "absolute",
  height: "100%",
  br: 25
});
var Delimiter = styled("div", {
  width: 4
});

// src/molecules/SubHeader/SubHeader.tsx
import { defaultHandleTournamentClick } from "@sportal365/smp-widget-utils";
var SubHeader = ({ tournamentOne, seasonOne, tournamentTwo, seasonTwo, handleClick }) => {
  var _a2, _b;
  if (!tournamentOne || !tournamentTwo) {
    return null;
  }
  const handleTournamentClick = () => defaultHandleTournamentClick(handleClick, Number(tournamentOne.id), tournamentOne.name);
  return /* @__PURE__ */ React.createElement(Wrapper2, null, /* @__PURE__ */ React.createElement(SMPLinkWrapper, {
    href: tournamentOne.tournamentLink,
    target: tournamentOne.urlTarget,
    onClick: handleTournamentClick
  }, /* @__PURE__ */ React.createElement(TournamentWrapper, {
    align: "left"
  }, /* @__PURE__ */ React.createElement(TournamentLogo, {
    style: { backgroundImage: `url("${(_a2 = tournamentOne.logo) != null ? _a2 : tournamentOne.tournamentImage}")` }
  }), /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    weight: "700",
    variant: "contrast",
    css: { lh: "$4" }
  }, tournamentOne.name), /* @__PURE__ */ React.createElement(SMPText, {
    size: "2",
    weight: "400",
    variant: "contrast",
    css: { lh: "18px" }
  }, seasonOne.name))), /* @__PURE__ */ React.createElement(SMPLinkWrapper, {
    href: tournamentTwo.tournamentLink,
    target: tournamentTwo.urlTarget
  }, /* @__PURE__ */ React.createElement(TournamentWrapper, {
    align: "right"
  }, /* @__PURE__ */ React.createElement(TournamentLogo, {
    style: { backgroundImage: `url("${(_b = tournamentTwo.logo) != null ? _b : tournamentOne.tournamentImage}")` }
  }), /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    weight: "700",
    variant: "contrast",
    css: { lh: "$4" }
  }, tournamentTwo.name), /* @__PURE__ */ React.createElement(SMPText, {
    size: "2",
    weight: "400",
    variant: "contrast",
    css: { lh: "18px" }
  }, seasonTwo.name))));
};
var Wrapper2 = styled.withConfig({ componentId: "SubHeader", displayName: "Wrapper" })("div", {
  display: "flex",
  justifyContent: "space-between",
  background: "$subHeaderBgColor",
  mb: "$5",
  "@bp1": {
    mx: 10
  }
});
var TournamentWrapper = styled.withConfig({ componentId: "SubHeader", displayName: "TournamentWrapper" })("div", {
  display: "grid",
  columnGap: "$2",
  alignItems: "center",
  width: "50%",
  p: "$2",
  variants: {
    align: {
      left: {
        gridTemplateColumns: "auto 1fr",
        gridTemplateAreas: '"logo name" "logo season"'
      },
      right: {
        gridTemplateColumns: "1fr auto",
        gridTemplateAreas: '"name logo" "season logo"',
        "& span": {
          textAlign: "right"
        }
      }
    }
  },
  [`& ${SMPSportEntity}`]: {
    color: "unset"
  }
});
var TournamentLogo = styled.withConfig({ componentId: "SubHeader", displayName: "TournamentLogo" })("div", {
  gridArea: "logo",
  alignSelf: "start",
  width: "$6",
  height: "$6",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  "@bp1": { width: "$6" }
});

// src/molecules/H2hHeaderDelimiter/H2hHeaderDelimiter.tsx
var H2hHeaderDelimiter = ({ text, additionalText }) => {
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    direction: "column",
    align: "center",
    justify: "center"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "7",
    weight: "700",
    variant: "contrast"
  }, text), additionalText && /* @__PURE__ */ React.createElement(SMPText, {
    size: "2",
    variant: "contrast"
  }, additionalText));
};

// src/molecules/Round/Round.tsx
import { getLabelValue as getLabelValue2, getMatchDate } from "@sportal365/smp-widget-utils";
var DATA_LABELS;
(function(DATA_LABELS2) {
  DATA_LABELS2["ROUND"] = "Round";
})(DATA_LABELS || (DATA_LABELS = {}));
var getRoundName = ({ round }) => {
  return round == null ? void 0 : round.name;
};
var Round = ({ round, sport, dataRoundLabel, matchDate, sdkOptions }) => {
  const roundDataLabel = getLabelValue2(dataRoundLabel, DATA_LABELS.ROUND);
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    variant: "singleEventRoundContainer"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "2_5",
    weight: "400",
    css: { color: "$roundColor" }
  }, roundDataLabel, " ", getRoundName({ round, sport }), matchDate ? `, ${getMatchDate(matchDate, sdkOptions)}` : ""));
};

// src/molecules/GroupSectionTitle/GroupSectionTitle.tsx
import { useContext as useContext4 } from "react";
var GroupSectionTitle = ({ url, urlTarget, title, handleClick, urlTitle, image }) => {
  var _a2;
  const { dataLabels } = useContext4(ConfigContext);
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    size: "4",
    variant: "groupSectionTitleContainer",
    css: { borderBottom: "2px solid $loContrast", p: "unset" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    grid: true,
    variant: "tournament",
    css: { py: "$2", px: "$3", alignItems: "end" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center",
    justify: "start",
    gap: "sm"
  }, image && /* @__PURE__ */ React.createElement(SMPImage, {
    src: image,
    height: "16px",
    width: "22px",
    css: { borderRadius: "$0" }
  }), /* @__PURE__ */ React.createElement("a", {
    href: urlTitle,
    target: urlTarget,
    style: { textDecoration: "none" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    direction: "row",
    justify: "start",
    align: "center"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "2",
    weight: "700"
  }, title)))), url && /* @__PURE__ */ React.createElement("a", {
    href: url,
    target: urlTarget
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "2",
    onClick: handleClick,
    css: {
      textDecoration: "underline",
      textDecorationColor: "$standingsLinkColor",
      marginLeft: "$2_5",
      color: "$standingsLinkColor"
    }
  }, (_a2 = dataLabels == null ? void 0 : dataLabels.standings) != null ? _a2 : "Standings"))));
};

// src/molecules/OddsDisplay/OddsDisplay.tsx
import {
  classNames as classNames7,
  defaultHandleBettingMarketValueClick,
  defaultHandleOddProviderClick,
  defaultHandleUserInteractionClick as defaultHandleUserInteractionClick6,
  isMobileUserAgent as isMobileUserAgent2
} from "@sportal365/smp-widget-utils";
import { useContext as useContext5, useEffect as useEffect16, useMemo as useMemo9, useState as useState18 } from "react";

// ../constants/deviceTypes.ts
var MOBILE = "mobile";
var DESKTOP = "desktop";

// ../constants/supportedMarkets.ts
var MARKETS_WITH_ARBITRARY_SELECTIONS = [
  "CORRECT_SCORE",
  "FIRST_HALF_AND_FINAL_RESULT",
  "FIRST_PLAYER_TO_SCORE",
  "PLAYER_TO_SCORE_DURING_GAME",
  "FIRST_HALF_GOALS",
  "PLAYER_TO_RECEIVE_CARD"
];
var SUPPORTED_MARKETS = [
  "12",
  "1X2",
  "OVER_UNDER",
  "DOUBLE_CHANCE",
  "BOTH_TO_SCORE",
  "DRAW_NO_BET",
  "FIRST_TEAM_TO_SCORE",
  "FIRST_HALF",
  "SECOND_HALF",
  "FULL_TIME",
  ...MARKETS_WITH_ARBITRARY_SELECTIONS
];
var MARKETS_WITH_VALUES = [OddsMarketTypes.OVER_UNDER, OddsMarketTypes.GAME_HANDICAP, OddsMarketTypes.FIRST_HALF_GOALS];

// src/molecules/OddsDisplay/OddsDisplay.tsx
var extractAvailableMarkets = (odds, labels) => {
  const availableMarkets = [];
  odds.forEach((currentOdds) => {
    Object.entries(currentOdds.markets).forEach(([, value]) => {
      var _a2;
      if (!((_a2 = value == null ? void 0 : value.type) == null ? void 0 : _a2.code)) {
        return;
      }
      const scopeType = value.scope.type.toUpperCase();
      if (value.type.code === OddsMarketTypes.ONEXTWO && scopeType !== ScopeTypes.ORDINARY_TIME && !availableMarkets.some((market) => market.value === scopeType)) {
        availableMarkets.push({
          label: labels && labels[value.scope.name] ? labels[value.scope.name] : value.scope.name,
          value: scopeType
        });
        return;
      }
      if (!availableMarkets.some((market) => market.value === value.type.code) && SUPPORTED_MARKETS.includes(value.type.code.toUpperCase())) {
        availableMarkets.push({
          label: labels && labels[value.type.name] ? labels[value.type.name] : value.type.name,
          value: value.type.code
        });
      }
    });
  });
  return availableMarkets;
};
var extractAvailableValues = (odds, market) => {
  const availableValues = [];
  odds.forEach((currentOdds) => {
    var _a2, _b;
    (_b = (_a2 = currentOdds.markets[market]) == null ? void 0 : _a2.selections) == null ? void 0 : _b.forEach((selection) => {
      const value = selection.value;
      if (!availableValues.some((option) => option.value === value)) {
        availableValues.push({ label: value, value });
      }
    });
  });
  return availableValues.sort((a4, b3) => Number(a4.value) - Number(b3.value));
};
var MARKETS_WITH_VALUES2 = [OddsMarketTypes.OVER_UNDER, OddsMarketTypes.GAME_HANDICAP, OddsMarketTypes.FIRST_HALF_GOALS];
var OddsDisplay = ({
  odds: fullOdds,
  handleClick,
  marketSelectionDisplay = true,
  isStandalone = false,
  alignment = GenericLayout.HORIZONTAL,
  isHeader = false,
  oddsMarketScope,
  areBettingOddsOverlapVisible,
  isTransparent = false
}) => {
  var _a2, _b;
  const { dataBettingLogoClickAction, dataBettingLogoOverlap, dataLabels } = useContext5(ConfigContext);
  const odds = useMemo9(() => {
    if (isStandalone || fullOdds.length <= 1) {
      return fullOdds;
    }
    return [fullOdds[0]];
  }, [fullOdds, isStandalone]);
  const availableMarkets = useMemo9(() => extractAvailableMarkets(odds, dataLabels), [odds, dataLabels]);
  const [bettingLogoOverlap, setBettingLogoOverlap] = useState18(dataBettingLogoOverlap);
  const [selectedMarket, setSelectedMarket] = useState18((_a2 = availableMarkets[0]) == null ? void 0 : _a2.value);
  const availableValues = useMemo9(() => {
    if (MARKETS_WITH_VALUES2.includes(selectedMarket)) {
      return extractAvailableValues(odds, selectedMarket);
    }
    return [];
  }, [selectedMarket, odds]);
  const [selectedValue, setSelectedValue] = useState18((_b = availableValues[0]) == null ? void 0 : _b.value);
  const [condensedMarketSelectionWrapper, setCondensedMarketSelectionWrapper] = useState18(false);
  const [isMobile, setIsMobile] = useState18(false);
  const [scopeNotFound, setScopeNotFound] = useState18(false);
  const measuredRef = useResizeObserver((innerContainerElement) => {
    if (!innerContainerElement.parentElement) {
      return;
    }
    const parentElementOffsetWidth = innerContainerElement.parentElement.offsetWidth;
    setCondensedMarketSelectionWrapper(parentElementOffsetWidth < 640);
    setIsMobile(parentElementOffsetWidth < MAX_MOBILE_WIDTH);
  });
  const { ref } = useRootNodeRef();
  useEffect16(() => {
    var _a3;
    if (oddsMarketScope) {
      const relevantMarket = availableMarkets.find((market) => market.value === oddsMarketScope);
      if (relevantMarket) {
        setSelectedMarket(relevantMarket.value);
        setScopeNotFound(false);
      } else {
        setScopeNotFound(true);
      }
      return;
    }
    setSelectedMarket((_a3 = availableMarkets[0]) == null ? void 0 : _a3.value);
    setScopeNotFound(false);
  }, [availableMarkets, oddsMarketScope]);
  useEffect16(() => {
    var _a3;
    setSelectedValue((_a3 = availableValues[0]) == null ? void 0 : _a3.value);
  }, [availableValues]);
  const arbitrarySelections = useMemo9(() => MARKETS_WITH_ARBITRARY_SELECTIONS.includes(selectedMarket), [selectedMarket]);
  const arbitrarySelectionsPerRow = useMemo9(() => {
    if (!arbitrarySelections) {
      return void 0;
    }
    if (isMobile) {
      if ([OddsMarketTypes.CORRECT_SCORE, OddsMarketTypes.FIRST_HALF_AND_FINAL_RESULT, OddsMarketTypes.FIRST_HALF_GOALS].includes(selectedMarket)) {
        return 2;
      }
      if ([
        OddsMarketTypes.FIRST_PLAYER_TO_SCORE,
        OddsMarketTypes.PLAYER_TO_SCORE_DURING_GAME,
        OddsMarketTypes.PLAYER_TO_RECEIVE_CARD
      ].includes(selectedMarket)) {
        return 1;
      }
    }
    return 3;
  }, [arbitrarySelections, isMobile, selectedMarket]);
  useEffect16(() => {
    if (arbitrarySelections) {
      setBettingLogoOverlap(false);
    } else {
      setBettingLogoOverlap(dataBettingLogoOverlap);
    }
  }, [arbitrarySelections, dataBettingLogoOverlap, selectedMarket]);
  if (odds.length === 0) {
    return null;
  }
  if (scopeNotFound) {
    if (dataLabels == null ? void 0 : dataLabels.no_odds) {
      return /* @__PURE__ */ React.createElement(SMPText, {
        textAlign: "center",
        variant: "contrast"
      }, dataLabels.no_odds);
    }
    return null;
  }
  const sendInteractionEvent = () => defaultHandleUserInteractionClick6(handleClick, USER_INTERACTION, DROPDOWN_SELECTION_SUBSCRIBE_TYPE);
  const withValuesSelection = MARKETS_WITH_VALUES2.includes(selectedMarket);
  const isVerticalAlignment = !arbitrarySelections && alignment === GenericLayout.VERTICAL;
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    variant: isHeader ? "sportEntityContainer" : isTransparent ? "transparentOddsContainer" : "oddsContainer",
    ref
  }, /* @__PURE__ */ React.createElement(SMPContainer, {
    ref: measuredRef,
    css: {
      margin: "auto",
      px: 0,
      maxWidth: bettingLogoOverlap ? "360px" : "616px",
      height: isVerticalAlignment ? "100%" : void 0
    }
  }, (marketSelectionDisplay || !marketSelectionDisplay && withValuesSelection) && /* @__PURE__ */ React.createElement(MarketSelectionWrapper, {
    className: classNames7({
      condensed: condensedMarketSelectionWrapper,
      "with-values-selection": withValuesSelection
    })
  }, marketSelectionDisplay && /* @__PURE__ */ React.createElement(Dropdown, {
    parentRef: ref,
    value: selectedMarket,
    options: availableMarkets,
    onChange: (value) => {
      setSelectedMarket(value);
      sendInteractionEvent();
    }
  }), withValuesSelection && /* @__PURE__ */ React.createElement(Dropdown, {
    parentRef: ref,
    value: selectedValue,
    options: availableValues,
    onChange: (value) => {
      setSelectedValue(value);
      sendInteractionEvent();
    },
    strictValueCheck: true
  })), /* @__PURE__ */ React.createElement(SMPContainer, {
    css: {
      px: 0,
      height: isVerticalAlignment ? "100%" : void 0,
      "& *": {
        boxSizing: "border-box"
      }
    }
  }, odds.map(({ bookmaker, markets }) => {
    var _a3, _b2, _c, _d2, _e;
    const marketData = markets[selectedMarket];
    if (!bookmaker || !marketData || withValuesSelection && !((_a3 = marketData.selections) == null ? void 0 : _a3.some((selection) => selection.value === selectedValue))) {
      return null;
    }
    const handleOddCoefficientClick = (link) => defaultHandleBettingMarketValueClick(handleClick, bookmaker, selectedMarket, link);
    return /* @__PURE__ */ React.createElement(OddsContainer, {
      key: bookmaker.id,
      className: classNames7({
        "arbitrary-selections": arbitrarySelections,
        "betting-logo-overlap": bettingLogoOverlap,
        "horizontal-alignment": !arbitrarySelections && alignment === GenericLayout.HORIZONTAL,
        "vertical-alignment": isVerticalAlignment,
        "odds-visible": areBettingOddsOverlapVisible
      })
    }, /* @__PURE__ */ React.createElement(SMPProviderLogo, {
      className: classNames7({
        "disable-interaction": dataBettingLogoClickAction === false
      }),
      href: dataBettingLogoClickAction !== false ? bookmaker.url : void 0,
      target: "_blank",
      style: {
        backgroundColor: (_b2 = bookmaker.assets[0].backgroundColor) != null ? _b2 : "transparent",
        backgroundImage: `url("${(_c = bookmaker.assets[0].transparentBackgroundUrl) != null ? _c : bookmaker.assets[0].logo}")`,
        borderRadius: "2px"
      },
      onClick: (e3) => {
        if (dataBettingLogoClickAction === false) {
          e3.preventDefault();
          return;
        }
        defaultHandleOddProviderClick(handleClick, { id: bookmaker.id, name: bookmaker.name, url: bookmaker.url });
      }
    }), /* @__PURE__ */ React.createElement(SelectionsWrapper, {
      arbitrarySelections,
      arbitrarySelectionsPerRow,
      bettingLogoOverlap
    }, withValuesSelection ? (_d2 = marketData.selections) == null ? void 0 : _d2.filter((selection) => selection.value === selectedValue).map((selection) => /* @__PURE__ */ React.createElement(Selection, {
      key: selection.name,
      bookmaker,
      handleOddCoefficientClick,
      selection
    })) : (_e = marketData.selections) == null ? void 0 : _e.map((selection) => /* @__PURE__ */ React.createElement(Selection, {
      key: selection.name,
      bookmaker,
      handleOddCoefficientClick,
      selection
    }))));
  }))));
};
var SelectionsWrapper = ({ arbitrarySelections, arbitrarySelectionsPerRow, bettingLogoOverlap, children }) => {
  if (arbitrarySelections && arbitrarySelectionsPerRow) {
    return /* @__PURE__ */ React.createElement(SelectionContainerArbitraryNumber, {
      style: {
        gridTemplateColumns: `repeat(auto-fit, minmax(calc(${100 / arbitrarySelectionsPerRow}% - calc(var(--sizes-2) * ${arbitrarySelectionsPerRow} - var(--sizes-2))), 1fr))`
      }
    }, children);
  }
  if (bettingLogoOverlap) {
    return /* @__PURE__ */ React.createElement(SelectionContainer, null, children);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
var Selection = ({ bookmaker, handleOddCoefficientClick, selection }) => {
  var _a2, _b, _c, _d2;
  const { dataBettingBrandColors, dataLabels } = useContext5(ConfigContext);
  const url = useMemo9(() => {
    var _a3, _b2, _c2, _d3, _e;
    if (selection.odds === null) {
      return void 0;
    }
    return (_e = (_d3 = (_c2 = (_a3 = selection.urls) == null ? void 0 : _a3.find(({ appType }) => appType === (isMobileUserAgent2() ? MOBILE : DESKTOP))) != null ? _c2 : (_b2 = selection.urls) == null ? void 0 : _b2[0]) == null ? void 0 : _d3.url) != null ? _e : bookmaker.url;
  }, [bookmaker.url, selection.odds, selection.urls]);
  const branding = {
    backgroundColor: dataBettingBrandColors && ((_a2 = bookmaker.branding) == null ? void 0 : _a2.backgroundColor) || void 0,
    textColor: dataBettingBrandColors && ((_b = bookmaker.branding) == null ? void 0 : _b.textColor) || void 0
  };
  const selectionName = useMemo9(() => {
    var _a3, _b2;
    const additionalInfoName = (_a3 = selection.additionalInfo) == null ? void 0 : _a3.name;
    if (additionalInfoName) {
      return (_b2 = dataLabels == null ? void 0 : dataLabels[additionalInfoName]) != null ? _b2 : additionalInfoName;
    }
    return dataLabels && selection.name && dataLabels[selection.name] ? dataLabels[selection.name] : selection.name;
  }, [dataLabels, (_c = selection.additionalInfo) == null ? void 0 : _c.name, selection.name]);
  return /* @__PURE__ */ React.createElement(SelectionCell, {
    className: classNames7({
      "with-betting-brand-colors": dataBettingBrandColors
    }),
    style: { backgroundColor: branding.backgroundColor },
    withOdds: selection.odds !== null,
    href: url,
    target: "_blank",
    onClick: () => url && handleOddCoefficientClick(url)
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "2_5",
    variant: "contrast",
    style: { color: branding.textColor, opacity: 0.5 }
  }, selectionName), /* @__PURE__ */ React.createElement(SMPText, {
    size: "2_5",
    variant: "contrast",
    weight: "700",
    style: { color: branding.textColor }
  }, (_d2 = selection.odds) != null ? _d2 : "-"));
};
var MarketSelectionWrapper = styled.withConfig({ componentId: "OddsDisplay", displayName: "MarketSelectionWrapper" })("div", {
  display: "flex",
  justifyContent: "center",
  gap: "$2",
  marginBottom: "$3",
  "&.condensed.with-values-selection": {
    ".dropdown-container": {
      width: "50%"
    }
  }
});
var SelectionCell = styled.withConfig({ componentId: "OddsDisplay", displayName: "SelectionCell" })("a", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "none",
  borderRadius: "$1",
  height: "100%",
  padding: "$1 $2_5",
  backgroundColor: "$oddsSelectionBackgroundColor",
  color: "inherit",
  textDecoration: "none",
  outline: "none",
  "&.with-betting-brand-colors": {
    border: "1px solid $oddsSelectionBorderColor"
  },
  variants: {
    withOdds: {
      true: {
        "&:hover": {
          backgroundColor: "$oddItemHoverColor",
          cursor: "pointer"
        }
      },
      false: {}
    }
  }
});
var SelectionContainerArbitraryNumber = styled.withConfig({
  componentId: "OddsDisplay",
  displayName: "SelectionContainerArbitraryNumber"
})("div");
var SelectionContainer = styled.withConfig({ componentId: "OddsDisplay", displayName: "SelectionContainer" })("div", {
  height: "100%"
});
var OddsContainer = styled.withConfig({ componentId: "OddsDisplay", displayName: "OddsContainer" })("div", {
  display: "grid",
  width: "100%",
  "&:not(:last-child)": {
    marginBottom: "$2"
  },
  "&.horizontal-alignment": {
    height: "32px"
  },
  "&.vertical-alignment": {
    height: "auto"
  },
  "&.arbitrary-selections": {
    gridTemplateColumns: "1fr 3fr",
    gap: "$2",
    height: "auto",
    [`${SMPProviderLogo}`]: {
      height: "32px"
    }
  },
  "&:not(.betting-logo-overlap)": {
    "&.horizontal-alignment": {
      gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))",
      gridTemplateRows: "100%",
      columnGap: "$2"
    },
    "&.vertical-alignment": {
      gridTemplateColumns: "100px",
      gridTemplateRows: "repeat(auto-fit, 26px)",
      rowGap: "$1"
    }
  },
  "&.betting-logo-overlap": {
    position: "relative",
    "& > *": {
      position: "absolute",
      width: "100%",
      left: 0,
      top: 0,
      transition: "opacity 0.2s"
    },
    [`${SMPProviderLogo}`]: {
      borderRadius: "$0",
      opacity: 1,
      pointerEvents: "auto"
    },
    [`${SelectionContainer}`]: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))",
      gridTemplateRows: "100%",
      columnGap: "$2",
      opacity: 0,
      pointerEvents: "none"
    },
    "&.vertical-alignment": {
      width: "100px",
      height: "100%",
      alignItems: "center",
      [`${SMPProviderLogo}`]: {
        position: "static",
        height: "56px"
      },
      [`${SelectionContainer}`]: {
        gridTemplateColumns: "100%",
        gridTemplateRows: "repeat(2, 26px)",
        alignContent: "center",
        rowGap: "$1",
        [`${SelectionCell}`]: {
          height: "26px"
        }
      }
    },
    "&.odds-visible": {
      [`${SMPProviderLogo}`]: {
        opacity: 0,
        pointerEvents: "none"
      },
      [`${SelectionContainer}`]: {
        opacity: 1,
        pointerEvents: "auto"
      }
    }
  },
  [`${SelectionContainerArbitraryNumber}`]: {
    display: "grid",
    gap: "$2",
    [`${SelectionCell}`]: {
      height: "32px"
    }
  }
});

// src/molecules/OddsDisplayV2/OddsDisplayV2.tsx
import { useContext as useContext7, useEffect as useEffect19, useRef as useRef8, useState as useState21 } from "react";

// ../odds/components/MarketDropdown.tsx
import React21 from "react";
import { classNames as classNames8, defaultHandleUserInteractionClick as defaultHandleUserInteractionClick7 } from "@sportal365/smp-widget-utils";
var MarketDropdown = ({
  availableMarkets,
  availableValues,
  selectedMarket,
  setSelectedMarket,
  selectedValue,
  setSelectedValue,
  marketSelectionDisplay,
  withValuesSelection,
  fullWidth,
  handleClick
}) => {
  const sendInteractionEvent = () => defaultHandleUserInteractionClick7(handleClick, USER_INTERACTION, DROPDOWN_SELECTION_SUBSCRIBE_TYPE);
  return /* @__PURE__ */ React21.createElement("div", {
    className: classNames8({
      "odds-market-dropdown-container flex justify-center gap-2 mb-4 w-full": true,
      "mx-auto": !fullWidth
    })
  }, marketSelectionDisplay && /* @__PURE__ */ React21.createElement(DropdownV2, {
    value: selectedMarket,
    options: availableMarkets,
    onChange: (value) => {
      setSelectedMarket(value);
      sendInteractionEvent();
    }
  }), withValuesSelection && /* @__PURE__ */ React21.createElement(DropdownV2, {
    value: selectedValue,
    options: availableValues,
    onChange: (value) => {
      value && setSelectedValue(value);
      sendInteractionEvent();
    }
  }));
};

// ../odds/components/BookmakerCellsRow.tsx
import React22 from "react";
import { classNames as classNames9 } from "@sportal365/smp-widget-utils";
var BookmakerCellsRow = ({
  isMultipleRow,
  isVertical,
  isStandalone,
  areBettingOddsOverlapVisible,
  dataBettingLogoOverlap,
  children
}) => {
  if (isMultipleRow) {
    return /* @__PURE__ */ React22.createElement("div", {
      className: "bookmaker-cells-row-container grid w-full gap-2 mb-2 grid-cols-[1fr_3fr]"
    }, children);
  }
  const overlappingGridStyles = isVertical ? { gridTemplateRows: areBettingOddsOverlapVisible ? "repeat(auto-fit, 26px)" : "56px", gridTemplateColumns: "100px" } : { gridTemplateColumns: "repeat(auto-fit, minmax(0px, 1fr))", gridTemplateRows: "32px" };
  const standartGridStyles = isVertical ? { gridTemplateRows: "repeat(auto-fit, 26px)", gridTemplateColumns: "100px" } : { gridTemplateColumns: "repeat(auto-fit, minmax(0px, 1fr))", gridTemplateRows: "32px" };
  const gridStyles = dataBettingLogoOverlap ? overlappingGridStyles : standartGridStyles;
  return /* @__PURE__ */ React22.createElement("div", {
    style: __spreadValues({}, gridStyles),
    className: classNames9({
      "bookmaker-cells-row-container grid w-full": true,
      "gap-1": isVertical,
      "gap-2": !isVertical,
      "mb-2": isStandalone
    })
  }, children);
};

// ../odds/components/SelectionCellsRow.tsx
import React24 from "react";

// ../odds/components/SelectionCell.tsx
import React23, { useContext as useContext6, useState as useState19, useMemo as useMemo10 } from "react";
import { classNames as classNames10, defaultHandleBettingMarketValueClickNew, isMobileUserAgent as isMobileUserAgent3 } from "@sportal365/smp-widget-utils";
var SelectionCell2 = ({
  isMultipleRow,
  bookmaker,
  selection,
  selectedMarket,
  areBettingOddsOverlapVisible,
  bettingLogoOverlap,
  handleClick
}) => {
  var _a2, _b, _c, _d2, _e, _f, _g;
  const [isHovered, setIsHovered] = useState19(false);
  const { dataBettingBrandColors, dataLabels } = useContext6(ConfigContext);
  const url = useMemo10(() => {
    var _a3, _b2, _c2, _d3, _e2;
    if (!selection || selection.odds === null) {
      return void 0;
    }
    return (_e2 = (_d3 = (_c2 = (_a3 = selection.urls) == null ? void 0 : _a3.find(({ app_type }) => app_type === (isMobileUserAgent3() ? MOBILE : DESKTOP))) != null ? _c2 : (_b2 = selection.urls) == null ? void 0 : _b2[0]) == null ? void 0 : _d3.url) != null ? _e2 : bookmaker.url;
  }, [bookmaker.url, selection.odds, selection.urls]);
  const branding = {
    backgroundColor: dataBettingBrandColors && ((_a2 = bookmaker.branding) == null ? void 0 : _a2.background_color) || void 0,
    textColor: dataBettingBrandColors && ((_b = bookmaker.branding) == null ? void 0 : _b.text_color) || void 0
  };
  const selectionName = useMemo10(() => {
    var _a3, _b2, _c2, _d3;
    const additionalInfoName = (_a3 = selection.additional_info) == null ? void 0 : _a3.name;
    if ((_b2 = selection.additional_info) == null ? void 0 : _b2.name) {
      return (_d3 = dataLabels == null ? void 0 : dataLabels[(_c2 = selection.additional_info) == null ? void 0 : _c2.name]) != null ? _d3 : additionalInfoName;
    }
    return dataLabels && selection.name && dataLabels[selection.name] ? dataLabels[selection.name] : selection.name;
  }, [dataLabels, (_c = selection.additional_info) == null ? void 0 : _c.name, selection.name]);
  const handleOddCoefficientClick = () => url && defaultHandleBettingMarketValueClickNew(handleClick, bookmaker, selectedMarket, url);
  const showHoveredStyles = isHovered && selection.odds !== null;
  if (bettingLogoOverlap && !areBettingOddsOverlapVisible)
    return null;
  return /* @__PURE__ */ React23.createElement("a", {
    href: url,
    target: "_blank",
    style: {
      backgroundColor: showHoveredStyles ? "var(--colors-oddItemHoverColor)" : (_d2 = branding.backgroundColor) != null ? _d2 : "var(--colors-oddsSelectionBackgroundColor)"
    },
    className: classNames10({
      "bookmaker-selection-cell flex items-center justify-between rounded-2 py-1 px-3 text-inherit no-underline box-border min-h-[26px] h-full border-none hover:cursor-pointer": true,
      "h-7": isMultipleRow,
      "border-[1px] border-solid border-oddsSelectionBorderColor": dataBettingBrandColors
    }),
    onMouseOver: () => setIsHovered(true),
    onMouseOut: () => setIsHovered(false),
    onClick: handleOddCoefficientClick
  }, /* @__PURE__ */ React23.createElement("span", {
    style: { color: (_e = branding.textColor) != null ? _e : "var(--colors-hiContrast)" },
    className: "selection-cell-name text-3 font-normal opacity-50"
  }, selectionName), /* @__PURE__ */ React23.createElement("span", {
    style: { color: (_f = branding.textColor) != null ? _f : "var(--colors-hiContrast)" },
    className: "selection-cell-value text-3 font-bold"
  }, (_g = selection.odds) != null ? _g : "-"));
};

// ../odds/components/SelectionCellsRow.tsx
var SelectionCellsRow = ({
  isMultipleRow,
  itemsPerRow,
  withValuesSelection,
  marketData,
  bookmaker,
  selectedValue,
  selectedMarket,
  areBettingOddsOverlapVisible,
  bettingLogoOverlap,
  handleClick
}) => {
  var _a2;
  const selections = withValuesSelection ? (_a2 = marketData.selections) == null ? void 0 : _a2.filter(({ value }) => value === selectedValue) : marketData.selections;
  if (isMultipleRow)
    return /* @__PURE__ */ React24.createElement("div", {
      style: { gridTemplateColumns: `repeat(${itemsPerRow}, 1fr)` },
      className: "selection-cells-container grid gap-2"
    }, selections.map((selection) => /* @__PURE__ */ React24.createElement(SelectionCell2, {
      key: selection.name,
      bookmaker,
      selection,
      selectedMarket,
      areBettingOddsOverlapVisible,
      bettingLogoOverlap,
      handleClick
    })));
  return /* @__PURE__ */ React24.createElement(React24.Fragment, null, selections.map((selection) => /* @__PURE__ */ React24.createElement(SelectionCell2, {
    key: selection.name,
    bookmaker,
    selection,
    selectedMarket,
    areBettingOddsOverlapVisible,
    bettingLogoOverlap,
    handleClick
  })));
};

// ../odds/components/ProviderLogoCell.tsx
import React25 from "react";
import { classNames as classNames11, defaultHandleOddProviderClick as defaultHandleOddProviderClick2 } from "@sportal365/smp-widget-utils";
var ProviderLogoCell = ({
  isMultipleRow,
  bookmaker,
  dataBettingLogoClickAction,
  areBettingOddsOverlapVisible,
  bettingLogoOverlap,
  handleClick
}) => {
  var _a2, _b, _c, _d2, _e;
  const backgroundColor = (_b = (_a2 = bookmaker == null ? void 0 : bookmaker.assets[0]) == null ? void 0 : _a2.background_color) != null ? _b : "transparent";
  const backgroundImage = (_e = (_c = bookmaker == null ? void 0 : bookmaker.assets[0]) == null ? void 0 : _c.transparent_background_url) != null ? _e : (_d2 = bookmaker == null ? void 0 : bookmaker.assets[0]) == null ? void 0 : _d2.logo;
  const handleOddProviderClick = (event) => {
    if (!dataBettingLogoClickAction) {
      event.preventDefault();
      return;
    }
    defaultHandleOddProviderClick2(handleClick, { id: bookmaker.id, name: bookmaker.name, url: bookmaker.url });
  };
  if (bettingLogoOverlap && areBettingOddsOverlapVisible)
    return null;
  return /* @__PURE__ */ React25.createElement("a", {
    href: dataBettingLogoClickAction ? bookmaker.url : void 0,
    target: "_blank",
    style: {
      backgroundColor,
      backgroundImage: `url("${backgroundImage}")`
    },
    className: classNames11({
      "bookmaker-provider-cell block rounded-1 bg-center bg-no-repeat bg-contain no-underline": true,
      "cursor-pointer": dataBettingLogoClickAction,
      "h-7": isMultipleRow
    }),
    onClick: handleOddProviderClick
  });
};

// ../odds/hooks/useAvailableOdds.ts
import { useMemo as useMemo11, useEffect as useEffect17, useState as useState20 } from "react";

// ../odds/helpers/extractAvailableOdds.ts
var extractAvailableMarkets2 = (odds, labels) => {
  const availableMarkets = [];
  odds.forEach((currentOdds) => {
    Object.entries(currentOdds.markets).forEach(([, value]) => {
      var _a2;
      if (!((_a2 = value == null ? void 0 : value.type) == null ? void 0 : _a2.code)) {
        return;
      }
      const scopeType = value && value.scope && value.scope.type ? value.scope.type.toUpperCase() : "";
      if (value.type.code === OddsMarketTypes.ONEXTWO && scopeType !== ScopeTypes.ORDINARY_TIME && !availableMarkets.some((market) => market.value === scopeType)) {
        availableMarkets.push({
          label: labels && labels[value.scope.name] ? labels[value.scope.name] : value.scope.name,
          value: scopeType
        });
        return;
      }
      if (!availableMarkets.some((market) => market.value === value.type.code) && SUPPORTED_MARKETS.includes(value.type.code.toUpperCase())) {
        availableMarkets.push({
          label: labels && labels[value.type.name] ? labels[value.type.name] : value.type.name,
          value: value.type.code
        });
      }
    });
  });
  return availableMarkets;
};
var extractAvailableValues2 = (odds, market) => {
  const availableValues = [];
  odds.forEach((currentOdds) => {
    var _a2, _b;
    (_b = (_a2 = currentOdds.markets[market]) == null ? void 0 : _a2.selections) == null ? void 0 : _b.forEach((selection) => {
      const value = selection.value;
      if (!availableValues.some((option) => option.value === value)) {
        availableValues.push({ label: value, value });
      }
    });
  });
  return availableValues.sort((a4, b3) => Number(a4.value) - Number(b3.value));
};

// ../odds/hooks/useAvailableOdds.ts
var useAvailableOdds = ({ fullOdds, isStandalone, dataLabels }) => {
  var _a2, _b;
  const odds = useMemo11(() => {
    if (isStandalone || fullOdds.length <= 1) {
      return fullOdds;
    }
    return [fullOdds[0]];
  }, [fullOdds, isStandalone]);
  const availableMarkets = useMemo11(() => extractAvailableMarkets2(odds, dataLabels), [odds, dataLabels]);
  const [selectedMarket, setSelectedMarket] = useState20((_a2 = availableMarkets[0]) == null ? void 0 : _a2.value);
  const availableValues = useMemo11(() => {
    if (MARKETS_WITH_VALUES.includes(selectedMarket)) {
      return extractAvailableValues2(odds, selectedMarket);
    }
    return [];
  }, [selectedMarket, odds]);
  const [selectedValue, setSelectedValue] = useState20((_b = availableValues[0]) == null ? void 0 : _b.value);
  useEffect17(() => {
    var _a3;
    setSelectedValue((_a3 = availableValues[0]) == null ? void 0 : _a3.value);
  }, [availableValues]);
  return {
    odds,
    availableMarkets,
    availableValues,
    selectedMarket,
    setSelectedMarket,
    selectedValue,
    setSelectedValue
  };
};

// ../odds/hooks/useMultipleRowsOdds.ts
import { useEffect as useEffect18, useMemo as useMemo12 } from "react";
var useMultipleRowsOdds = ({ selectedMarket, isMobile, dataBettingLogoOverlap, setBettingLogoOverlap }) => {
  const isMultipleRow = MARKETS_WITH_ARBITRARY_SELECTIONS.includes(selectedMarket);
  const withSingleRow = [
    OddsMarketTypes.FIRST_PLAYER_TO_SCORE,
    OddsMarketTypes.PLAYER_TO_SCORE_DURING_GAME,
    OddsMarketTypes.PLAYER_TO_RECEIVE_CARD
  ].includes(selectedMarket);
  const itemsPerRow = useMemo12(() => {
    if (isMobile)
      return withSingleRow ? 1 : 2;
    return 3;
  }, [isMultipleRow, isMobile, selectedMarket]);
  useEffect18(() => {
    if (isMultipleRow) {
      setBettingLogoOverlap(false);
      return;
    }
    setBettingLogoOverlap(dataBettingLogoOverlap);
  }, [isMultipleRow, dataBettingLogoOverlap, selectedMarket]);
  return { isMultipleRow, itemsPerRow };
};

// src/molecules/OddsDisplayV2/OddsDisplayV2.tsx
import { classNames as classNames12 } from "@sportal365/smp-widget-utils";
var OddsDisplayV2 = ({
  fullOdds,
  handleClick,
  marketSelectionDisplay = true,
  isStandalone = false,
  alignment = GenericLayout.HORIZONTAL,
  isHeader = false,
  isTransparent = false,
  oddsMarketScope,
  areBettingOddsOverlapVisible
}) => {
  const [isMobile, setIsMobile] = useState21(false);
  const parentContainerRef = useRef8(null);
  const measuredRef = useResizeObserver((fieldElement) => {
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
  });
  const { dataBettingLogoClickAction, dataBettingLogoOverlap, dataLabels } = useContext7(ConfigContext);
  const [bettingLogoOverlap, setBettingLogoOverlap] = useState21(dataBettingLogoOverlap);
  const [scopeNotFound, setScopeNotFound] = useState21(false);
  const { odds, availableMarkets, availableValues, selectedMarket, setSelectedMarket, selectedValue, setSelectedValue } = useAvailableOdds({
    fullOdds,
    isStandalone,
    dataLabels
  });
  const { isMultipleRow, itemsPerRow } = useMultipleRowsOdds({
    selectedMarket,
    isMobile,
    dataBettingLogoOverlap,
    setBettingLogoOverlap
  });
  useEffect19(() => {
    var _a2;
    if (oddsMarketScope) {
      const relevantMarket = availableMarkets.find((market) => market.value === oddsMarketScope);
      if (relevantMarket) {
        setSelectedMarket(relevantMarket.value);
        setScopeNotFound(false);
      } else {
        setScopeNotFound(true);
      }
    } else {
      setSelectedMarket((_a2 = availableMarkets[0]) == null ? void 0 : _a2.value);
      setScopeNotFound(false);
    }
  }, [availableMarkets, oddsMarketScope]);
  if (odds.length === 0 || scopeNotFound)
    return null;
  const withValuesSelection = MARKETS_WITH_VALUES.includes(selectedMarket);
  const isVerticalAlignment = !isMultipleRow && alignment === GenericLayout.VERTICAL;
  const showMarketDropdown = marketSelectionDisplay || !marketSelectionDisplay && withValuesSelection;
  return /* @__PURE__ */ React.createElement("div", {
    ref: parentContainerRef,
    className: classNames12({
      "odds-container px-4 m-auto box-border max-w-[616px] py-2 bg-oddsContainerPrimaryBgColor": true,
      "py-4 bg-sportEntityContainerPrimaryBgColor": isHeader,
      "max-w-[360px]": bettingLogoOverlap,
      "h-full": isVerticalAlignment,
      "bg-transparent": isTransparent
    })
  }, showMarketDropdown && /* @__PURE__ */ React.createElement(MarketDropdown, {
    availableMarkets,
    availableValues,
    selectedMarket,
    setSelectedMarket,
    selectedValue,
    setSelectedValue,
    marketSelectionDisplay,
    withValuesSelection,
    fullWidth: isVerticalAlignment,
    handleClick
  }), /* @__PURE__ */ React.createElement("div", {
    ref: measuredRef,
    className: classNames12({
      "odds-cells-container mx-auto box-border": true,
      "items-center": !showMarketDropdown,
      "h-full": isVerticalAlignment
    })
  }, odds.map(({ bookmaker, markets }) => {
    var _a2;
    const marketData = markets[selectedMarket];
    const hasNotValidMarket = withValuesSelection && !((_a2 = marketData == null ? void 0 : marketData.selections) == null ? void 0 : _a2.some(({ value }) => value === selectedValue));
    if (!bookmaker || !marketData || hasNotValidMarket)
      return null;
    return /* @__PURE__ */ React.createElement(BookmakerCellsRow, {
      key: bookmaker.id,
      isMultipleRow,
      isVertical: isVerticalAlignment,
      isStandalone,
      areBettingOddsOverlapVisible,
      dataBettingLogoOverlap: bettingLogoOverlap
    }, /* @__PURE__ */ React.createElement(ProviderLogoCell, {
      isMultipleRow,
      dataBettingLogoClickAction,
      bookmaker,
      areBettingOddsOverlapVisible,
      bettingLogoOverlap,
      handleClick
    }), /* @__PURE__ */ React.createElement(SelectionCellsRow, {
      isMultipleRow,
      itemsPerRow,
      withValuesSelection,
      marketData,
      bookmaker,
      selectedValue,
      selectedMarket,
      areBettingOddsOverlapVisible,
      bettingLogoOverlap,
      handleClick
    }));
  })));
};

// src/molecules/Collapsible/Collapsible.tsx
import { useState as useState22 } from "react";
var Collapsible = ({
  children,
  text,
  initialState = "open",
  verticalMode = false
}) => {
  const [isExpanded, setIsExpanded] = useState22(initialState !== "closed");
  return /* @__PURE__ */ React.createElement(CollapsibleWrapper, null, /* @__PURE__ */ React.createElement(CollapsibleHeader, {
    onClick: () => setIsExpanded((prev) => !prev),
    verticalMode,
    isExpanded
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: verticalMode ? "4" : "5",
    variant: "contrast",
    weight: "600"
  }, text), /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center",
    justify: "center",
    css: { width: "$5", height: "$5" },
    style: { transform: isExpanded ? "unset" : "rotate(180deg)" }
  }, /* @__PURE__ */ React.createElement(SMPArrowUpIcon, {
    css: { width: "$2_5", height: "$2" }
  }))), isExpanded && children);
};
var CollapsibleWrapper = styled.withConfig({ componentId: "Collapsible", displayName: "CollapsibleWrapper" })("div", {
  marginTop: "0px"
});
var CollapsibleHeader = styled.withConfig({ componentId: "Collapsible", displayName: "CollapsibleHeader" })("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "$2_5 $3",
  width: "100%",
  backgroundColor: "$collapsibleBgColor",
  cursor: "pointer",
  variants: {
    verticalMode: {
      true: {
        borderRadius: "0"
      },
      false: {
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px"
      }
    },
    isExpanded: {
      true: {},
      false: {}
    }
  },
  compoundVariants: [
    {
      verticalMode: false,
      isExpanded: false,
      css: {
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px"
      }
    }
  ]
});

// src/molecules/Field/Field.tsx
var Field = ({ mode, lineColor = "white" }) => {
  if (mode === GenericLayout.HORIZONTAL) {
    return /* @__PURE__ */ React.createElement("svg", {
      width: "756",
      height: "402",
      viewBox: "0 0 756 402",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ React.createElement("g", {
      opacity: "0.5"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M755 101L675 101L675 301L755 301",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M755 161L715 161L715 241L755 241",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M674.999 168.523C655.999 174.73 634.499 211.19 674.999 232.523",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M1 301L81 301L81 101L0.999991 101",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M1 241L41 241L41 161L0.999997 161",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M81 232.977C100 226.771 121.5 190.31 81 168.977",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M378 142C410.585 142 437 168.415 437 201C437 233.585 410.585 260 378 260C345.415 260 319 233.585 319 201C319 168.415 345.415 142 378 142Z",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("rect", {
      x: "377",
      y: "401",
      width: "400",
      height: "2.00002",
      rx: "1.00001",
      transform: "rotate(-90 377 401)",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("circle", {
      cx: "378",
      cy: "201",
      r: "4",
      transform: "rotate(-90 378 201)",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("rect", {
      x: "1",
      y: "1",
      width: "754",
      height: "400",
      rx: "8",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M14 400C14 393.373 8.62742 388 2 388",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M2 14C8.62742 14 14 8.62742 14 2",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M742 2C742 8.62742 747.373 14 754 14",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M754 388C747.373 388 742 393.373 742 400",
      stroke: lineColor,
      strokeWidth: "2"
    })));
  }
  if (mode === GenericLayout.VERTICAL) {
    return /* @__PURE__ */ React.createElement("svg", {
      width: "332",
      height: "601",
      viewBox: "0 0 332 601",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ React.createElement("g", {
      opacity: "0.5"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M255.5 600.231L255.5 520.231L75.5 520.231L75.5 600.231",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M205 600L205 570L125 570L125 600",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M196 520C190.182 503.477 156 484.781 136 520",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M75.5 1.9996L75.5 81.9996L255.5 81.9996L255.5 1.99957",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M126 2.23129L126 32.2313L206 32.2313L206 2.23128",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M135 82.2313C140.818 98.7536 175 117.45 195 82.2313",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M215 302.231C215 329.293 193.062 351.231 166 351.231C138.938 351.231 117 329.293 117 302.231C117 275.169 138.938 253.231 166 253.231C193.062 253.231 215 275.169 215 302.231Z",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("rect", {
      x: "2",
      y: "300",
      width: "328",
      height: "2.00002",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("circle", {
      cx: "166",
      cy: "301.151",
      r: "4",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("rect", {
      x: "331",
      y: "1",
      width: "598.769",
      height: "330",
      rx: "4",
      transform: "rotate(90 331 1)",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M13 598.769C13 592.144 7.62742 586.774 0.999999 586.774",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M330 586.774C323.373 586.774 318 592.144 318 598.769",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M318 1.99963C318 8.62449 323.373 13.995 330 13.995",
      stroke: lineColor,
      strokeWidth: "2"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M1 13.995C7.62742 13.995 13 8.62449 13 1.99963",
      stroke: lineColor,
      strokeWidth: "2"
    })));
  }
  if (mode === GenericLayout.VERTICAL_CONDENSED) {
    return /* @__PURE__ */ React.createElement("svg", {
      width: "294",
      height: "601",
      viewBox: "0 0 294 601",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ React.createElement("g", {
      opacity: "0.5"
    }, /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M237.5 600.228L235.5 600.228L235.5 521.228L57.5 521.228L57.5 600.228L55.5 600.228L55.5 519.228L237.5 519.228L237.5 600.228Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M187 599.996L185 599.996L185 570.996L107 570.996L107 599.996L105 599.996L105 568.996L187 568.996L187 599.996Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M168.614 507.298C173.053 510.908 176.413 515.318 177.943 519.664L176.057 520.329C174.678 516.414 171.583 512.291 167.352 508.849C163.129 505.414 157.833 502.708 152.124 501.574C146.424 500.443 140.318 500.879 134.428 503.716C128.537 506.553 122.789 511.827 117.87 520.49L116.131 519.503C121.211 510.557 127.236 504.96 133.561 501.914C139.887 498.867 146.44 498.407 152.513 499.613C158.577 500.816 164.167 503.681 168.614 507.298Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M147 349.228C173.51 349.228 195 327.738 195 301.228C195 274.718 173.51 253.228 147 253.228C120.49 253.228 99 274.718 99 301.228C99 327.738 120.49 349.228 147 349.228ZM147 351.228C174.614 351.228 197 328.842 197 301.228C197 273.614 174.614 251.228 147 251.228C119.386 251.228 97 273.614 97 301.228C97 328.842 119.386 351.228 147 351.228Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M1 299.068L293 299.068L293 301.015L1 301.015L1 299.068Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M151 300.148C151 302.357 149.209 304.148 147 304.148C144.791 304.148 143 302.357 143 300.148C143 297.939 144.791 296.148 147 296.148C149.209 296.148 151 297.939 151 300.148Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M55.5 -0.00366211L57.5 -0.00366246L57.5 78.9963L235.5 78.9963L235.5 -0.00369358L237.5 -0.00369393L237.5 80.9963L55.5 80.9963L55.5 -0.00366211Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M106 0.228012L108 0.228012L108 29.228L186 29.228L186 0.227998L188 0.227998L188 31.228L106 31.228L106 0.228012Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M124.386 92.9268C119.947 89.3163 116.587 84.9066 115.057 80.5602L116.943 79.8959C118.322 83.8106 121.417 87.9338 125.648 91.3752C129.871 94.81 135.167 97.5167 140.876 98.65C146.576 99.7815 152.682 99.345 158.572 96.5084C164.463 93.6712 170.211 88.3975 175.13 79.7342L176.869 80.7218C171.789 89.6678 165.764 95.2641 159.439 98.3103C153.113 101.357 146.56 101.817 140.487 100.612C134.423 99.408 128.833 96.5438 124.386 92.9268Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M289 5.96244e-08C291.761 2.66948e-08 294 2.23485 294 4.99168L294 595.008C294 597.765 291.761 600 289 600L5.00001 600C2.23859 600 7.12828e-06 597.765 7.0954e-06 595.008L5.95252e-08 4.99169C2.66505e-08 2.23486 2.23859 3.47922e-06 5 3.44629e-06L289 5.96244e-08ZM292 4.99168C292 3.33758 290.657 1.99667 289 1.99667L5 1.99667C3.34314 1.99667 2 3.33759 2 4.99169L2.00001 595.008C2.00001 596.662 3.34315 598.003 5.00001 598.003L289 598.003C290.657 598.003 292 596.662 292 595.008L292 4.99168Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 586.795C8.0755 586.795 13 591.71 13 597.772L15 597.772C15 590.607 9.17934 584.799 2 584.799L2 586.795Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M281 597.772C281 591.71 285.925 586.795 292 586.795L292 584.799C284.821 584.799 279 590.607 279 597.772L281 597.772Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M292 12.9734C285.925 12.9734 281 8.0584 281 1.9963L279 1.9963C279 9.16186 284.821 14.97 292 14.97L292 12.9734Z",
      fill: lineColor
    }), /* @__PURE__ */ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 1.99629C13 8.0584 8.0755 12.9734 2 12.9734L2 14.97C9.17934 14.97 15 9.16186 15 1.99629L13 1.99629Z",
      fill: lineColor
    })));
  }
  return null;
};
var Svg = styled.withConfig({ componentId: "Field", displayName: "Svg" })("svg", {
  width: "100%"
});
var Rect = styled.withConfig({ componentId: "Field", displayName: "Rect" })("rect", {
  variants: {
    withFill: {
      true: {
        fill: "$footballFieldTone"
      },
      false: {}
    },
    withStroke: {
      true: {
        stroke: "$footballFieldTone"
      },
      false: {}
    }
  }
});

// src/molecules/DropdownBtn/DropdownBtn.tsx
var DropdownButton = styled("button", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "$1 $2",
  borderRadius: "$2",
  border: "1px solid $borderMultiSportColor",
  cursor: "pointer",
  gap: "$1",
  backgroundColor: "$dropdownBtnColor",
  width: "100%"
});
var DropdownBtn = ({ selectedOption, toggleDropdown }) => {
  return /* @__PURE__ */ React.createElement(DropdownButton, {
    onClick: toggleDropdown
  }, /* @__PURE__ */ React.createElement(SMPText, {
    css: {
      fontSize: "14px",
      lineHeight: "22px",
      color: "$multiSportTextColor",
      textAlign: "center",
      width: "100%"
    }
  }, selectedOption), /* @__PURE__ */ React.createElement(SMPChevronDownIcon, {
    css: { width: "$3", height: "$3" }
  }));
};

// src/molecules/DropdownListWrapper/DropdownListWrapper.tsx
var DropdownListWrapper = ({ isOpen, children, css: css2 = {} }) => {
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    css: __spreadValues({ position: "relative", margin: 0, padding: 0 }, css2)
  }, isOpen && /* @__PURE__ */ React.createElement(SMPContainer, {
    style: {
      margin: 0,
      padding: 0,
      position: "absolute",
      backgroundColor: "var(--colors-multiSportBgColor)",
      borderRadius: "6px",
      border: "1px solid var(--colors-borderMultiSportColor)",
      zIndex: 1e3
    }
  }, children));
};

// src/molecules/StakesDisplayFixed/StakesDisplayFixed.tsx
import { defaultHandleBettingMarketValueClick as defaultHandleBettingMarketValueClick2, getLabelValue as getLabelValue4, invertColor as invertColor2, rgba2hex } from "@sportal365/smp-widget-utils";
import { useCallback as useCallback3, useContext as useContext9, useEffect as useEffect20, useState as useState23 } from "react";

// src/molecules/StakesFooter/StakesFooter.tsx
import { defaultHandleOddProviderClick as defaultHandleOddProviderClick3, getLabelValue as getLabelValue3 } from "@sportal365/smp-widget-utils";
import { useContext as useContext8, useMemo as useMemo13 } from "react";
var StakesFooter = ({ amount, currency, handleClick, oddsBookmaker, theme: theme2, currencyPosition }) => {
  const { dataLabels } = useContext8(ConfigContext);
  const isPrefix = currencyPosition === "prefix";
  const stakesAmountDescription = useMemo13(() => getLabelValue3(dataLabels == null ? void 0 : dataLabels.stakes_amount_description, "With a {amount} bet").replace(/{amount}/g, isPrefix ? `${currency}${amount}` : `${amount}${currency}`), [amount, currency, dataLabels == null ? void 0 : dataLabels.stakes_amount_description, isPrefix]);
  const bookmakerLogo = useMemo13(() => oddsBookmaker.assets[0].transparentBackgroundUrl, [oddsBookmaker.assets]);
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "2_5",
    variant: "contrast",
    style: { width: "fit-content" }
  }, /* @__PURE__ */ React.createElement("strong", null, stakesAmountDescription, "\xA0"), oddsBookmaker.stakesDisclaimer ? `| ${oddsBookmaker.stakesDisclaimer} ` : null, oddsBookmaker.domainName ? `| ${oddsBookmaker.domainName}` : null), /* @__PURE__ */ React.createElement(BookmakerLogo, {
    href: oddsBookmaker.url,
    target: "_blank",
    onClick: () => defaultHandleOddProviderClick3(handleClick, {
      id: oddsBookmaker.id,
      name: oddsBookmaker.name,
      url: oddsBookmaker.url
    }),
    style: {
      backgroundImage: bookmakerLogo ? `url("${bookmakerLogo}")` : void 0,
      filter: `brightness(0)${theme2 === "dark" ? " saturate(100%) invert(1)" : ""}`
    }
  }));
};
var BookmakerLogo = styled.withConfig({ componentId: "StakesWidget", displayName: "BookmakerLogo" })("a", {
  ml: "$0",
  width: "90px",
  height: "26px",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  flexShrink: 0
});

// src/molecules/TeamStake/TeamStake.tsx
import { invertColor, isMobileUserAgent as isMobileUserAgent4 } from "@sportal365/smp-widget-utils";
import { useMemo as useMemo14 } from "react";
var TeamStake = ({
  contrastFallbackColor,
  currency,
  handleOddCoefficientClick,
  selection,
  size,
  team,
  wins,
  currencyPosition
}) => {
  var _a2;
  const url = useMemo14(() => {
    var _a3, _b, _c, _d2, _e;
    if (selection.odds === null) {
      return void 0;
    }
    return (_e = (_d2 = (_c = (_a3 = selection.urls) == null ? void 0 : _a3.find(({ appType }) => appType === (isMobileUserAgent4() ? MOBILE : DESKTOP))) != null ? _c : (_b = selection.urls) == null ? void 0 : _b[0]) == null ? void 0 : _d2.url) != null ? _e : void 0;
  }, [selection.odds, selection.urls]);
  const value = currencyPosition === "prefix" ? `${currency} ${wins}` : `${wins} ${currency}`;
  return /* @__PURE__ */ React.createElement(TeamButton, {
    href: url,
    target: "_blank",
    onClick: () => url && handleOddCoefficientClick(url),
    css: { backgroundColor: (_a2 = team.shirtColor) != null ? _a2 : "$oddsSelectionBackgroundColor" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    display: "flex",
    size: size !== GenericSize.DEFAULT ? "4" : "2_5",
    variant: "contrast",
    css: {
      alignItems: "center",
      gap: "$1",
      height: "100%",
      color: team.shirtColor ? invertColor(team.shirtColor, true) : contrastFallbackColor
    }
  }, team.threeLetterCode, /* @__PURE__ */ React.createElement("strong", {
    style: { textAlign: "end" }
  }, value)));
};
var TeamButton = styled.withConfig({ componentId: "StakesDisplayFixed", displayName: "TeamButton" })("a", {
  border: "1px solid $teamStakesBorderColor",
  borderRadius: "$1",
  width: "177px",
  py: "$2",
  px: "$2_5",
  textDecoration: "none",
  cursor: "pointer",
  [`${SMPText}`]: {
    justifyContent: "space-between",
    width: "100%"
  }
});

// src/molecules/StakesDisplayFixed/StakesDisplayFixed.tsx
var StakesDisplayFixed = ({
  amount = 10,
  handleClick,
  htmlElement,
  odds,
  size,
  teams,
  theme: theme2,
  currencyPosition = "prefix"
}) => {
  const { dataLabels } = useContext9(ConfigContext);
  const [contrastFallbackColor, setContrastFallbackColor] = useState23("$gray12");
  const calculateWins = useCallback3((teamOdds) => {
    return (amount * +teamOdds).toFixed(2);
  }, [amount]);
  useEffect20(() => {
    if (!htmlElement) {
      return;
    }
    const computedStyle = getComputedStyle(htmlElement);
    const oddsSelectionBackgroundColor = computedStyle.getPropertyValue("--colors-oddsSelectionBackgroundColor");
    setContrastFallbackColor(invertColor2(oddsSelectionBackgroundColor.startsWith("rgb") ? rgba2hex(oddsSelectionBackgroundColor) : oddsSelectionBackgroundColor, true));
  }, [htmlElement, theme2]);
  if (odds.length === 0) {
    return null;
  }
  const oddsBookmaker = odds[0].bookmaker;
  const oddsMarket = odds[0].markets["1x2"];
  if (!oddsBookmaker || !oddsMarket || !oddsMarket.selections) {
    return null;
  }
  const firstTeamSelection = oddsMarket.selections[0];
  const secondTeamSelection = oddsMarket.selections[oddsMarket.selections.length - 1];
  if (firstTeamSelection.odds === null || secondTeamSelection.odds === null) {
    return null;
  }
  const currency = getLabelValue4(dataLabels == null ? void 0 : dataLabels.stakes_currency, "\u20AC");
  const handleOddCoefficientClick = (link) => defaultHandleBettingMarketValueClick2(handleClick, oddsBookmaker, OddsMarketTypes["ONEXTWO"], link);
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    css: {
      margin: "auto",
      pb: "$3",
      "& *": {
        boxSizing: "border-box"
      }
    }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { mb: "$2_5" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "5",
    variant: "contrast",
    weight: "700"
  }, getLabelValue4(dataLabels == null ? void 0 : dataLabels.stakes_bet_on_team, "Bet on your team to win!"))), /* @__PURE__ */ React.createElement(SMPFlex, {
    gap: "md",
    css: { mb: "$2" }
  }, /* @__PURE__ */ React.createElement(TeamStake, {
    contrastFallbackColor,
    currency,
    handleOddCoefficientClick,
    selection: firstTeamSelection,
    size,
    team: teams[0],
    wins: calculateWins(firstTeamSelection.odds),
    currencyPosition
  }), /* @__PURE__ */ React.createElement(TeamStake, {
    contrastFallbackColor,
    currency,
    handleOddCoefficientClick,
    selection: secondTeamSelection,
    size,
    team: teams[1],
    wins: calculateWins(secondTeamSelection.odds),
    currencyPosition
  })), /* @__PURE__ */ React.createElement(StakesFooter, {
    amount,
    currency,
    handleClick,
    oddsBookmaker,
    theme: theme2,
    currencyPosition
  }));
};

// src/molecules/StakesDisplayCustom/StakesDisplayCustom.tsx
import { defaultHandleBettingMarketValueClick as defaultHandleBettingMarketValueClick3, getLabelValue as getLabelValue5, isMobileUserAgent as isMobileUserAgent5 } from "@sportal365/smp-widget-utils";
import { useCallback as useCallback4, useContext as useContext10, useEffect as useEffect21, useState as useState24 } from "react";
var getResponsiveInputWidth = (number) => {
  const numDigits = number.toString().length;
  const digitsArray = Array.from({ length: numDigits }, (_2, i3) => i3 % 2 === 0 ? "1" : "0");
  return digitsArray.length * 10 + 5;
};
var StakesDisplayCustom = ({
  initialAmount = 10,
  handleClick,
  odds,
  size,
  theme: theme2,
  currencyPosition = "prefix"
}) => {
  const { dataLabels } = useContext10(ConfigContext);
  const [amount, setAmount] = useState24(initialAmount);
  const [selectedIndex, setSelectedIndex] = useState24(0);
  const [selectedUrl, setSelectedUrl] = useState24();
  const maxAmount = 1e6;
  const calculateWins = useCallback4((teamOdds) => {
    return Math.round(amount * +teamOdds);
  }, [amount]);
  useEffect21(() => {
    var _a2;
    const selections = (_a2 = odds[0].markets["1x2"]) == null ? void 0 : _a2.selections;
    if (!selections) {
      return;
    }
    const numericOdds = selections.map((selection) => {
      var _a3;
      return Number((_a3 = selection.odds) != null ? _a3 : 0);
    });
    setSelectedIndex(selections.findIndex((selection) => {
      var _a3;
      return Number((_a3 = selection.odds) != null ? _a3 : 0) === Math.max(...numericOdds);
    }));
  }, [odds]);
  useEffect21(() => {
    var _a2, _b, _c, _d2, _e, _f;
    const selections = (_a2 = odds[0].markets["1x2"]) == null ? void 0 : _a2.selections;
    if (!selections) {
      return;
    }
    const selection = selections[selectedIndex];
    setSelectedUrl((_f = (_e = (_d2 = (_b = selection.urls) == null ? void 0 : _b.find(({ appType }) => appType === (isMobileUserAgent5() ? MOBILE : DESKTOP))) != null ? _d2 : (_c = selection.urls) == null ? void 0 : _c[0]) == null ? void 0 : _e.url) != null ? _f : void 0);
  }, [odds, selectedIndex]);
  if (odds.length === 0) {
    return null;
  }
  const oddsBookmaker = odds[0].bookmaker;
  const oddsMarket = odds[0].markets["1x2"];
  if (!oddsBookmaker || !oddsMarket || !oddsMarket.selections) {
    return null;
  }
  const currency = getLabelValue5(dataLabels == null ? void 0 : dataLabels.stakes_currency, "\u20AC");
  const wins = calculateWins(oddsMarket.selections[selectedIndex].odds);
  const handleOddCoefficientClick = (link) => defaultHandleBettingMarketValueClick3(handleClick, oddsBookmaker, OddsMarketTypes["ONEXTWO"], link);
  const isPrefix = currencyPosition === "prefix";
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    css: {
      margin: "auto",
      pt: size !== GenericSize.SMALL ? "$1" : "$2",
      pb: "$3",
      "& *": {
        boxSizing: "border-box"
      }
    }
  }, /* @__PURE__ */ React.createElement(SelectionsContainer, {
    css: {
      rowGap: size !== GenericSize.SMALL ? "$2" : "$3",
      mx: size !== GenericSize.SMALL ? "auto" : void 0,
      maxWidth: size !== GenericSize.SMALL ? "361px" : void 0
    }
  }, oddsMarket.selections.map((selection, index) => {
    var _a2;
    const selected = selectedIndex === index;
    return /* @__PURE__ */ React.createElement(SelectionButton, {
      key: selection.name,
      disabled: selection.odds === null,
      selected,
      onClick: () => setSelectedIndex(index),
      css: { gridArea: `selection-${index}`, borderColor: theme2 === "light" ? "transparent" : void 0 }
    }, /* @__PURE__ */ React.createElement(SMPText, {
      size: "4",
      variant: selected ? void 0 : "contrast"
    }, selection.name), /* @__PURE__ */ React.createElement(SMPText, {
      size: "5",
      variant: selected ? void 0 : "contrast",
      weight: "700"
    }, (_a2 = selection.odds) != null ? _a2 : "-"));
  }), /* @__PURE__ */ React.createElement(AmountInputContainer, null, /* @__PURE__ */ React.createElement(SMPText, {
    size: "2_5",
    variant: "contrast",
    style: { alignSelf: "start" }
  }, getLabelValue5(dataLabels == null ? void 0 : dataLabels.stakes_stake, "Stake")), /* @__PURE__ */ React.createElement("div", {
    style: {
      flexDirection: isPrefix ? "row-reverse" : "row"
    }
  }, /* @__PURE__ */ React.createElement("input", {
    type: "number",
    max: maxAmount,
    title: amount.toString(),
    value: amount.toString(),
    onChange: (e3) => setAmount(Math.min(Math.max(1, +e3.target.value), maxAmount)),
    style: { width: getResponsiveInputWidth(amount), maxWidth: size !== GenericSize.SMALL ? "unset" : "60px" }
  }), /* @__PURE__ */ React.createElement(SMPText, {
    size: "5",
    weight: "700",
    variant: "contrast"
  }, currency))), /* @__PURE__ */ React.createElement(SelectionButton, {
    selected: true,
    css: {
      gridArea: "payout",
      display: "grid",
      gridTemplateColumns: "max-content 1fr",
      gap: "$0",
      alignItems: "center",
      cursor: "default"
    }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "2_5",
    style: { alignSelf: "start" }
  }, getLabelValue5(dataLabels == null ? void 0 : dataLabels.stakes_payout, "Payout")), /* @__PURE__ */ React.createElement("div", {
    style: {
      display: "flex",
      gap: "2px",
      justifyContent: "end",
      flexDirection: isPrefix ? "row-reverse" : "row",
      alignItems: "center"
    }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "5",
    textAlign: "right",
    title: wins.toString(),
    weight: "700",
    style: { maxWidth: size !== GenericSize.SMALL ? "unset" : "60px", overflow: "hidden", whiteSpace: "nowrap" }
  }, wins), /* @__PURE__ */ React.createElement(SMPText, {
    size: "5",
    weight: "700",
    style: { maxWidth: size !== GenericSize.SMALL ? "unset" : "60px", overflow: "hidden", whiteSpace: "nowrap" }
  }, currency))), /* @__PURE__ */ React.createElement(CallToActionButton, {
    href: selectedUrl,
    target: "_blank",
    onClick: () => selectedUrl && handleOddCoefficientClick(selectedUrl),
    css: { mt: size !== GenericSize.SMALL ? "$3" : "$2" }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    size: "5",
    textAlign: "center",
    weight: "700",
    style: { lineHeight: "140%" }
  }, getLabelValue5(dataLabels == null ? void 0 : dataLabels.stakes_bet, "Bet now")))), /* @__PURE__ */ React.createElement(StakesFooter, {
    amount,
    currency,
    handleClick,
    oddsBookmaker,
    theme: theme2,
    currencyPosition
  }));
};
var SelectionsContainer = styled.withConfig({ componentId: "StakesDisplayCustom", displayName: "SelectionsContainer" })("div", {
  display: "grid",
  gridTemplateColumns: "repeat(6, 1fr)",
  gridTemplateAreas: `
    'selection-0 selection-0 selection-1 selection-1 selection-2 selection-2'
    'input input input payout payout payout'
    'call-to-action call-to-action call-to-action call-to-action call-to-action call-to-action'
  `,
  columnGap: "$3",
  mb: "$2"
});
var SelectionButton = styled.withConfig({ componentId: "StakesDisplayCustom", displayName: "SelectionButton" })("button", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "1px solid $gray7",
  borderRadius: "$1",
  py: "$2",
  px: "$2_5",
  backgroundColor: "$stakesSelectionBgColor",
  cursor: "pointer",
  variants: {
    disabled: {
      true: {
        pointerEvents: "none",
        opacity: 0.7
      }
    },
    selected: {
      true: {
        borderColor: "transparent",
        backgroundColor: "$stakesSelectedBgColor",
        color: "$selectedStakeColor"
      }
    }
  }
});
var AmountInputContainer = styled.withConfig({ componentId: "StakesDisplayCustom", displayName: "AmountInputContainer" })("div", {
  gridArea: "input",
  display: "grid",
  gridTemplateColumns: "max-content 1fr",
  justifyContent: "space-between",
  gap: "$0",
  alignItems: "center",
  border: "1px solid $stakeInputBorderColor",
  borderRadius: "$1",
  py: "$2",
  px: "$2_5",
  backgroundColor: "$stakesSelectionBgColor",
  "& > div": {
    display: "flex",
    gap: "2px",
    justifyContent: "end",
    alignItems: "center"
  },
  input: {
    border: "none",
    p: "0",
    textAlign: "end",
    backgroundColor: "transparent",
    fontSize: "$5",
    fontWeight: "700",
    outline: "none",
    color: "$hiContrast",
    "-moz-appearance": "textfield",
    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  }
});
var CallToActionButton = styled.withConfig({ componentId: "StakesDisplayCustom", displayName: "CallToActionButton" })("a", {
  gridArea: "call-to-action",
  borderRadius: "$1",
  py: "$2",
  px: "$2_5",
  backgroundColor: "$accentPrimaryBgColor",
  color: "$accentContrastColor",
  textDecoration: "none",
  cursor: "pointer"
});

// src/molecules/EventDate/EventDate.tsx
import { breakText, formatGameTime, getMatchDate as getMatchDate2 } from "@sportal365/smp-widget-utils";
import { useContext as useContext11 } from "react";
var EventDate = ({ startTime }) => {
  const { sdkOptions } = useContext11(ConfigContext);
  const date = getMatchDate2(startTime, sdkOptions, "dd MMM").toUpperCase();
  const time = formatGameTime(startTime, sdkOptions);
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    className: "date-and-status-wrapper",
    direction: "column",
    align: "center",
    justify: "spaceEvenly",
    gap: "sm",
    style: { width: "50px" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    align: "center"
  }, /* @__PURE__ */ React.createElement(SMPText, {
    textAlign: "center",
    size: "2_5",
    variant: "primaryGray"
  }, breakText(date))), /* @__PURE__ */ React.createElement(SMPText, {
    display: "flex",
    variant: "primaryGray",
    size: "2_5",
    weight: "400",
    style: { justifyContent: "unset" }
  }, time));
};

// src/molecules/EventGame/GameStatus.tsx
import { useContext as useContext12 } from "react";
import { classNames as classNames13 } from "@sportal365/smp-widget-utils";
var GameStatus = ({ status, firstTeam, secondTeam, isLive }) => {
  var _a2;
  const { dataLabels } = useContext12(ConfigContext);
  const hasPenalties = Boolean(firstTeam.penaltyScore && secondTeam.penaltyScore);
  return /* @__PURE__ */ React.createElement("div", {
    className: "status text-center"
  }, /* @__PURE__ */ React.createElement("span", {
    className: classNames13({
      "block py-[6px] text-3 font-bold text-fullTimeMatchStatusColor": true,
      "text-liveMatchStatusColor": isLive
    })
  }, status), hasPenalties && !isLive ? /* @__PURE__ */ React.createElement("span", {
    className: "block text-3 text-roundColor"
  }, `(${firstTeam.penaltyScore}:${secondTeam.penaltyScore} ${(_a2 = dataLabels == null ? void 0 : dataLabels.after_penalties) != null ? _a2 : "After penalties"})`) : null, hasPenalties && isLive ? /* @__PURE__ */ React.createElement("span", {
    className: "block text-3 font-bold text-hiContrast"
  }, `(${firstTeam.penaltyScore} - ${secondTeam.penaltyScore})`) : null);
};
var GameStatus_default = GameStatus;

// src/molecules/EventGame/GameResult.tsx
import { defaultHandleEventClick, defaultHandleTeamClick } from "@sportal365/smp-widget-utils";
var GameResult = (props) => {
  const { id, firstTeam, secondTeam, startTime, isStarted, url, target, handleClick } = props;
  const handleFirstTeamClick = () => firstTeam.url ? defaultHandleTeamClick(handleClick, { id: firstTeam.id, name: firstTeam.name }) : void 0;
  const handleSecondTeamClick = () => secondTeam.url ? defaultHandleTeamClick(handleClick, { id: secondTeam.id, name: secondTeam.name }) : void 0;
  const handleMatchClick = () => url ? defaultHandleEventClick(handleClick, id) : void 0;
  return /* @__PURE__ */ React.createElement("div", {
    className: "game-result-container grid grid-cols-[1fr_minmax(20%,max-content)_1fr] items-center w-full mt-4"
  }, /* @__PURE__ */ React.createElement("a", {
    href: firstTeam.url,
    target,
    className: `home-team-${firstTeam.id} flex items-center w-full gap-2 no-underline sm:flex-row flex-col-reverse justify-end h-full`,
    onClick: handleFirstTeamClick
  }, /* @__PURE__ */ React.createElement("span", {
    className: `home-team-${firstTeam.id}-name text-center text-4 font-semibold text-hiContrast`
  }, firstTeam.name), /* @__PURE__ */ React.createElement("img", {
    src: firstTeam.logo,
    className: `home-team-${firstTeam.id}-image w-7 h-7`,
    alt: `${firstTeam.name} Logo`
  })), /* @__PURE__ */ React.createElement("div", {
    className: "score-container text-center min-w-[100px]"
  }, isStarted ? /* @__PURE__ */ React.createElement("a", {
    href: url,
    target,
    onClick: handleMatchClick,
    className: "no-underline"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "score flex justify-center items-center text-7 font-bold gap-[6px] text-hiContrast"
  }, /* @__PURE__ */ React.createElement("span", {
    className: `home-team-${firstTeam.id}-score`
  }, firstTeam.score), /* @__PURE__ */ React.createElement("span", null, ":"), /* @__PURE__ */ React.createElement("span", {
    className: `away-team-${secondTeam.id}-score`
  }, secondTeam.score))) : /* @__PURE__ */ React.createElement("span", {
    className: "text-7 font-bold text-hiContrast"
  }, startTime), /* @__PURE__ */ React.createElement(GameStatus_default, __spreadValues({}, props))), /* @__PURE__ */ React.createElement("a", {
    href: secondTeam.url,
    target,
    onClick: handleSecondTeamClick,
    className: `away-team-${secondTeam.id} flex w-full items-center gap-2 no-underline flex-col sm:flex-row justify-start h-full`
  }, /* @__PURE__ */ React.createElement("img", {
    src: secondTeam.logo,
    className: `away-team-${secondTeam.id}-image w-7 h-7`,
    alt: `${secondTeam.name} Logo`
  }), /* @__PURE__ */ React.createElement("span", {
    className: `away-team-${secondTeam.id}-name text-center text-4 font-semibold text-hiContrast`
  }, secondTeam.name)));
};
var GameResult_default = GameResult;

// src/molecules/EventGame/Game.tsx
import { defaultHandleTournamentClick as defaultHandleTournamentClick2 } from "@sportal365/smp-widget-utils/src/clickHandlers";
var Game = ({ game, handleClick, showInfo }) => {
  const { competition, target } = game;
  const handleTournamentClick = () => competition.url ? defaultHandleTournamentClick2(handleClick, competition.id, competition.name) : void 0;
  return /* @__PURE__ */ React.createElement("div", {
    className: "game-container"
  }, showInfo && /* @__PURE__ */ React.createElement("a", {
    href: competition.url,
    target,
    onClick: handleTournamentClick,
    className: "competition-container text-center no-underline block"
  }, /* @__PURE__ */ React.createElement("p", {
    className: "competition-name text-4 font-bold text-hiContrast mt-0 mb-2 mx-0"
  }, competition.name), /* @__PURE__ */ React.createElement("p", {
    className: "competition-date text-3 font-normal text-roundColor m-0"
  }, competition.date)), /* @__PURE__ */ React.createElement(GameResult_default, __spreadProps(__spreadValues({}, game), {
    handleClick
  })));
};

// src/molecules/EventSection/TournamentEventList/TournamentEvents.tsx
import React26, { useContext as useContext15 } from "react";

// src/molecules/EventSection/Event/Event.tsx
import { useContext as useContext14, useState as useState25 } from "react";
import { classNames as classNames16 } from "@sportal365/smp-widget-utils";

// src/molecules/EventSection/Event/Participant.tsx
import { useContext as useContext13 } from "react";
import { classNames as classNames14 } from "@sportal365/smp-widget-utils";

// ../hooks/multi-sport/useDynamicResults.ts
import { useMemo as useMemo15 } from "react";
var useDynamicResults = ({ isLive, isMobile, element, data }) => {
  const results = useMemo15(() => {
    if (isMobile) {
      return data.filter((label) => label === element);
    }
    return sortLabelsByType(data, element, isLive);
  }, [data, isLive, isMobile]);
  return results;
};

// src/molecules/EventSection/Event/Participant.tsx
var Participant = ({ logo, name, isWinner, results, isLive, isNational, eventUrl, target, isFirstTeam, isMobile }) => {
  const { dataLabels } = useContext13(ConfigContext);
  const scoreResult = results == null ? void 0 : results.find(({ label }) => label === "S");
  const normalizedResults = useDynamicResults({ isLive, isMobile, data: results, element: scoreResult });
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames14("flex items-center justify-between", isFirstTeam ? "first-team" : "second-team")
  }, /* @__PURE__ */ React.createElement("a", {
    href: eventUrl,
    target,
    className: "flex items-center gap-2 no-underline",
    rel: "noreferrer"
  }, /* @__PURE__ */ React.createElement("img", {
    src: logo,
    className: classNames14("h-6 w-6", { "rounded-full": isNational })
  }), /* @__PURE__ */ React.createElement("span", {
    className: classNames14("text-hiContrast text-4 overflow-hidden text-ellipsis whitespace-nowrap max-w-[140px] sm:whitespace-normal sm:max-w-none", {
      "font-bold": isWinner,
      "font-normal": !isWinner
    })
  }, name)), /* @__PURE__ */ React.createElement("div", {
    className: classNames14("flex gap-1", isFirstTeam ? "first-team-scores" : "second-team-scores")
  }, normalizedResults.map(({ label, value, isWinner: isWinner2, isFinal }, index) => {
    var _a2, _b;
    return /* @__PURE__ */ React.createElement("a", {
      href: eventUrl,
      target,
      key: index,
      className: classNames14("flex items-center justify-center h-[26px] w-[26px] text-4 no-underline", {
        "font-bold": isWinner2 && !isFinal || isFinal,
        "font-normal": !isWinner2 && !isFinal,
        "text-accentPrimaryBgColor": isFinal,
        "text-hiContrast": (isWinner2 || value === "-") && !isFinal,
        "text-primaryGray": !isWinner2 && value !== "-" && !isFinal,
        "ml-1": label === ((_a2 = dataLabels == null ? void 0 : dataLabels.score) != null ? _a2 : "S") && !isLive,
        "mr-1": label === ((_b = dataLabels == null ? void 0 : dataLabels.score) != null ? _b : "S") && isLive
      }),
      rel: "noreferrer"
    }, value);
  })));
};

// src/molecules/EventSection/Event/EventStatus.tsx
import { breakText as breakText2, classNames as classNames15 } from "@sportal365/smp-widget-utils";
var EventStatus = ({ date, status, isLive, startTime, statusType, isInlineOddsHidden, elapsed }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col text-2 min-w-7 h-[56px] text-center justify-center match-status-container"
  }, /* @__PURE__ */ React.createElement("p", {
    className: "m-0 text-primaryGray match-date"
  }, isInlineOddsHidden ? breakText2(date) : date), isLive && elapsed !== "" && /* @__PURE__ */ React.createElement("p", {
    className: "m-0 pt-[5px] text-[#4CAF50] font-semibold"
  }, elapsed, "'"), /* @__PURE__ */ React.createElement("p", {
    className: classNames15("m-0 pt-[5px] font-semibold", {
      "text-[#4CAF50]": isLive,
      "text-fullTimeMatchStatusColor": !isLive,
      "match-start-time": statusType === NOT_STARTED,
      "match-status": statusType !== NOT_STARTED
    })
  }, statusType === NOT_STARTED ? startTime : status));
};

// src/molecules/EventSection/Event/Event.tsx
import { defaultHandleEventClick as defaultHandleEventClick2 } from "@sportal365/smp-widget-utils/src/clickHandlers";
var Event = (props) => {
  var _a2;
  const { dataOddsDisplay, dataBettingLogoOverlap, dataAllowInlineOdds, dataLabels, dataOddsBettingId } = useContext14(ConfigContext);
  const { id, isLive, eventUrl, target, participants, labels, odds, handleClick } = props;
  const [showInlineOdds, setShowInlineOdds] = useState25(dataAllowInlineOdds != null ? dataAllowInlineOdds : true);
  const [isDateSingleRow, setIsDateSingleRow] = useState25(false);
  const [isMobile, setIsMobile] = useState25(false);
  const measuredRef = useResizeObserver((fieldElement) => {
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
    dataAllowInlineOdds && setShowInlineOdds(fieldElement.offsetWidth > INLINE_ODDS_BREAKPOINT);
    setIsDateSingleRow(fieldElement.offsetWidth < INLINE_ODDS_BREAKPOINT);
  });
  const normalizedLabels = useDynamicResults({ isLive, isMobile, data: labels, element: (_a2 = dataLabels == null ? void 0 : dataLabels.score) != null ? _a2 : "S" });
  const normalizedOdds = useProcessedOdds({ odds, dataOddsBettingId, showOdds: dataOddsDisplay });
  const { areBettingOddsOverlapVisible } = useOverlapOdds({ dataBettingLogoOverlap });
  const handleEventClick = () => eventUrl ? defaultHandleEventClick2(handleClick, id) : void 0;
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex w-full bg-rowBackgroundColor relative match-row-container",
    ref: measuredRef
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex-1 match-info"
  }, /* @__PURE__ */ React.createElement("a", {
    href: eventUrl,
    target,
    className: "flex flex-col font-sans p-4 justify-between gap-1 flex-1 no-underline",
    onClick: handleEventClick,
    rel: "noreferrer"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex gap-1 flex-1 justify-end"
  }, normalizedLabels.map((label) => {
    var _a3, _b;
    return /* @__PURE__ */ React.createElement("div", {
      key: label,
      className: classNames16("flex items-center justify-center w-[26px] h-3 text-3 text-primaryGray", {
        "ml-1": label === ((_a3 = dataLabels == null ? void 0 : dataLabels.score) != null ? _a3 : "S") && !isLive,
        "mr-1": label === ((_b = dataLabels == null ? void 0 : dataLabels.score) != null ? _b : "S") && isLive
      })
    }, label);
  })), /* @__PURE__ */ React.createElement("div", {
    className: "flex gap-4"
  }, /* @__PURE__ */ React.createElement(EventStatus, __spreadProps(__spreadValues({}, props), {
    isInlineOddsHidden: isDateSingleRow
  })), /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col gap-2 flex-1"
  }, participants == null ? void 0 : participants.map((participant, index) => /* @__PURE__ */ React.createElement(Participant, __spreadProps(__spreadValues({
    key: participant.id
  }, participant), {
    isLive,
    eventUrl,
    isFirstTeam: index === 0,
    target,
    isMobile
  })))))), /* @__PURE__ */ React.createElement("div", {
    className: classNames16({ block: !showInlineOdds, hidden: showInlineOdds })
  }, /* @__PURE__ */ React.createElement(OddsDisplayV2, {
    alignment: GenericLayout.HORIZONTAL,
    fullOdds: normalizedOdds,
    handleClick,
    marketSelectionDisplay: false,
    areBettingOddsOverlapVisible
  }))), /* @__PURE__ */ React.createElement("div", {
    className: classNames16("flex justify-center items-center py-2 border-l border-l-primaryBackgroundColor", {
      hidden: !showInlineOdds,
      "w-[132px]": normalizedOdds.length < 1 && showInlineOdds
    })
  }, /* @__PURE__ */ React.createElement(OddsDisplayV2, {
    alignment: GenericLayout.VERTICAL,
    fullOdds: normalizedOdds,
    handleClick,
    marketSelectionDisplay: false,
    areBettingOddsOverlapVisible
  })), /* @__PURE__ */ React.createElement("div", {
    className: classNames16("h-[72px] w-1 absolute bg-[#4CAF50] rounded-tr-2 rounded-br-2 top-5 bottom-4", {
      block: isLive,
      hidden: !isLive
    })
  }));
};

// src/molecules/EventSection/EventList.tsx
var EventList = ({ events, handleClick }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col gap-[1px]"
  }, events.map((event) => /* @__PURE__ */ React.createElement(Event, __spreadProps(__spreadValues({
    key: event.id
  }, event), {
    handleClick
  }))));
};

// src/molecules/EventSection/TournamentEventList/TournamentEvents.tsx
var TournamentEvents = ({ data, handleClick, selectedFilter }) => {
  const { dataLabels, dataOddsBettingId = "" } = useContext15(ConfigContext);
  const bettingIdValue = dataOddsBettingId && typeof dataOddsBettingId === "string" ? dataOddsBettingId : dataOddsBettingId == null ? void 0 : dataOddsBettingId.toString();
  const getFilteredEvents = (events, selectedFilter2) => {
    const selectedBookmakers = bettingIdValue == null ? void 0 : bettingIdValue.split(/,\s*/).filter((id) => id);
    if (selectedFilter2 !== ODDS) {
      return events;
    }
    if ((selectedBookmakers == null ? void 0 : selectedBookmakers.length) === 0) {
      return events.filter((event) => event.odds.length > 0);
    }
    return events.filter((event) => event.odds.some(({ bookmaker }) => bookmaker && (selectedBookmakers == null ? void 0 : selectedBookmakers.includes(bookmaker == null ? void 0 : bookmaker.id))));
  };
  const normalizedData = data == null ? void 0 : data.map(({ competition, events }) => ({
    competition,
    filteredEvents: getFilteredEvents(events, selectedFilter)
  }));
  const hasEvents = normalizedData == null ? void 0 : normalizedData.some(({ filteredEvents }) => filteredEvents.length > 0);
  if (!hasEvents) {
    return /* @__PURE__ */ React26.createElement(TextBlockTailwind, {
      text: dataLabels == null ? void 0 : dataLabels.no_games
    });
  }
  return /* @__PURE__ */ React26.createElement(React26.Fragment, null, normalizedData == null ? void 0 : normalizedData.map(({ competition, filteredEvents }) => filteredEvents.length > 0 && /* @__PURE__ */ React26.createElement("div", {
    key: competition.id
  }, /* @__PURE__ */ React26.createElement(TournamentHeader, __spreadProps(__spreadValues({}, competition), {
    handleClick
  })), /* @__PURE__ */ React26.createElement(EventList, {
    events: filteredEvents,
    handleClick
  }))));
};

// src/molecules/EventSection/RoundEventList/RoundEvents.tsx
import React27, { useContext as useContext16 } from "react";
import { defaultHandleTournamentClick as defaultHandleTournamentClick3, getLabelValue as getLabelValue6 } from "@sportal365/smp-widget-utils";
var RoundEvents = ({ stage, standingsLabel, standingsUrl, data, handleClick }) => {
  const { dataLabels } = useContext16(ConfigContext);
  const handleCompetitionClick = () => defaultHandleTournamentClick3(handleClick, stage.id || "", stage.name);
  return /* @__PURE__ */ React27.createElement("div", {
    key: stage.id
  }, /* @__PURE__ */ React27.createElement(GroupSection, {
    name: stage == null ? void 0 : stage.name,
    url: stage.url,
    target: stage.target,
    locator: "stage",
    standingsLabel,
    standingsUrl,
    withStandings: true,
    handleClick: handleCompetitionClick
  }), data.map(({ round, events }) => events.length > 0 && /* @__PURE__ */ React27.createElement("div", {
    key: round.id
  }, /* @__PURE__ */ React27.createElement(GroupSection, {
    name: `${getLabelValue6(dataLabels == null ? void 0 : dataLabels.round, "")} ${round.name}`,
    locator: "round"
  }), /* @__PURE__ */ React27.createElement(EventList, {
    events,
    handleClick
  }))));
};

// src/molecules/HeaderV2/HeaderV2.tsx
import React31 from "react";

// src/molecules/DropdownV2/DropdownV2.tsx
import React30 from "react";

// src/molecules/DropdownV2/DropdownMenu.tsx
import React29 from "react";

// src/molecules/DropdownV2/DropdownOption.tsx
import React28 from "react";
import { classNames as classNames17 } from "@sportal365/smp-widget-utils";
var DropdownOption = ({ label, value, selectedOption, onChange }) => {
  const isSelected = (selectedOption == null ? void 0 : selectedOption.value) === value;
  return /* @__PURE__ */ React28.createElement("div", {
    onClick: () => onChange(value),
    className: classNames17({
      "dropdown-menu-option-container p-4 text-4 font-bold border-[0.5px] border-selectOptionBorderColor hover:text-pillActiveBackgroundColor text-hiContrast hover:bg-dropdownActiveBgColor bg-dropdownBtnColor": true,
      "text-pillActiveBackgroundColor bg-dropdownActiveBgColor": isSelected
    })
  }, /* @__PURE__ */ React28.createElement("span", {
    className: "dropdown-menu-option-value"
  }, label));
};

// src/molecules/DropdownV2/DropdownMenu.tsx
import { classNames as classNames18 } from "@sportal365/smp-widget-utils";
var DropdownMenu = ({ selectedOption, options, onChange }) => {
  return /* @__PURE__ */ React29.createElement("div", {
    className: classNames18({
      "dropdown-menu-container shadow-[0px_4px_10px_0px_rgba(0,0,0,0.10)] rounded-3 w-full overflow-auto z-[99] sm:min-w-[320px] absolute top-[100%] mt-3 right-0 max-h-[250px]": true
    })
  }, options.map((option) => /* @__PURE__ */ React29.createElement(DropdownOption, __spreadProps(__spreadValues({
    key: option.value
  }, option), {
    selectedOption,
    onChange
  }))));
};

// src/molecules/DropdownV2/DropdownV2.tsx
import { classNames as classNames19 } from "@sportal365/smp-widget-utils";
var DropdownV2 = ({ value, options, onChange }) => {
  var _a2;
  const { isComponentVisible, setIsComponentVisible, ref } = useDetectClickOutside();
  const selectedOption = options == null ? void 0 : options.find((option) => option.value === value);
  const selectedMultipleValueOption = options.find((option) => option.value.split(",").length > 1);
  const toggleDropdownMenu = () => setIsComponentVisible((prevValue) => !prevValue);
  const selectedValue = selectedMultipleValueOption && !selectedOption ? selectedMultipleValueOption : selectedOption;
  return /* @__PURE__ */ React30.createElement("div", {
    ref,
    className: classNames19({
      "dropdown-container flex justify-between items-center gap-2 py-2 px-3 rounded-3 cursor-pointer relative bg-pillBackgroundColor border-[1px] border-dropdownBorderColor h-[40px]": true,
      "border-pillActiveBackgroundColor": isComponentVisible
    }),
    onClick: toggleDropdownMenu
  }, /* @__PURE__ */ React30.createElement("span", {
    className: "dropdown-value text-4 font-bold whitespace-nowrap text-hiContrast"
  }, (_a2 = selectedValue == null ? void 0 : selectedValue.label) != null ? _a2 : ""), /* @__PURE__ */ React30.createElement(ArrowDownIcon, {
    isActive: isComponentVisible
  }), isComponentVisible && /* @__PURE__ */ React30.createElement(DropdownMenu, {
    selectedOption: selectedValue,
    options,
    onChange
  }));
};

// src/molecules/HeaderV2/HeaderV2.tsx
import { classNames as classNames20 } from "@sportal365/smp-widget-utils";
var HeaderV2 = ({
  title = "",
  subTitle = "",
  logo,
  url,
  urlTarget,
  selectedSeason,
  selectedPillTab,
  pillTabOptions,
  seasonOptions,
  displayPillTabs,
  displaySeasonDropdown,
  hideBoxShadow,
  withStickyHeader,
  handleHeaderClick,
  handlePillTabChange,
  handleSeasonChange
}) => {
  if (!displayPillTabs && !displaySeasonDropdown)
    return null;
  return /* @__PURE__ */ React31.createElement("div", {
    className: classNames20({
      "header-container bg-rowBackgroundColor py-3 px-4": true,
      "sticky top-0 z-[1]": withStickyHeader,
      "shadow-[0px_2px_10px_0px] shadow-headerBoxShadowColor": !hideBoxShadow && withStickyHeader,
      "shadow-none": hideBoxShadow && withStickyHeader
    })
  }, displaySeasonDropdown && /* @__PURE__ */ React31.createElement("div", {
    className: classNames20({
      "header-information-container flex justify-between gap-4 flex-col sm:flex-row": true,
      "mb-3": displayPillTabs
    })
  }, /* @__PURE__ */ React31.createElement("a", {
    href: url,
    target: urlTarget,
    className: "flex items-center w-full gap-2 no-underline",
    onClick: handleHeaderClick
  }, /* @__PURE__ */ React31.createElement("img", {
    src: logo,
    className: "header-information-image w-7 h-7 rounded-6"
  }), /* @__PURE__ */ React31.createElement("div", {
    className: "flex flex-col"
  }, /* @__PURE__ */ React31.createElement("span", {
    className: "header-information-title text-4 font-bold text-hiContrast mb-1"
  }, title), /* @__PURE__ */ React31.createElement("span", {
    className: "header-information-subTitle text-2 text-hiContrast"
  }, subTitle))), /* @__PURE__ */ React31.createElement(DropdownV2, {
    value: selectedSeason,
    options: seasonOptions,
    onChange: handleSeasonChange
  })), displayPillTabs && /* @__PURE__ */ React31.createElement(PillTabsV2, {
    selectedPillTab,
    pillTabOptions,
    handlePillTabChange
  }));
};

// src/molecules/Standings/Table/StandingsTable.tsx
import React39, { useContext as useContext22, useState as useState27 } from "react";

// src/molecules/Standings/Table/Header/StandingsTableHeader.tsx
import React33, { useContext as useContext18 } from "react";

// src/molecules/Standings/Table/Header/StandingsTableHeaderCell.tsx
import React32, { useContext as useContext17, useState as useState26 } from "react";
import { translateTableLabel } from "@sportal365/smp-widget-utils";
var StandingsTableHeaderCell = ({ type, value, locator }) => {
  const { dataLabels } = useContext17(ConfigContext);
  const [isHovered, setIsHovered] = useState26(false);
  return /* @__PURE__ */ React32.createElement("th", {
    className: `text-center bg-tableHeaderBG text-4 text-hiContrast font-semibold py-3 px-1.5 relative ${locator}`,
    onMouseOver: () => setIsHovered(true),
    onMouseOut: () => setIsHovered(false)
  }, isHovered && /* @__PURE__ */ React32.createElement("div", {
    className: `absolute rounded-2 bg-standingsTooltipContainerPrimaryBgColor whitespace-nowrap text-3 z-10 cursor-pointer transform -translate-x-1/2 p-1 px-2 -bottom-8 left-1/2 text-standingsTooltipContainerTextColor ${locator}-tooltip`
  }, translateTableLabel(type, dataLabels, true)), /* @__PURE__ */ React32.createElement("span", {
    className: `${locator}-label`
  }, value));
};

// ../hooks/standings/useResponsiveTableCells.ts
import { useMemo as useMemo16 } from "react";

// ../constants/standings.ts
var BASKETBALL_MOBILE_TYPES = ["WINS", "LOSSES", "PERCENTAGE"];
var ICE_HOCKEY_MOBILE_TYPES = ["PLAYED", "GOAL_DIFFERENCES", "POINTS"];

// ../hooks/standings/useResponsiveTableCells.ts
var useResponsiveTableCells = ({ cells, sport, isResponsive }) => {
  return useMemo16(() => {
    if (!isResponsive) {
      return { cells };
    }
    const mobileTypes = sport === SportTypes.BASKETBALL ? BASKETBALL_MOBILE_TYPES : ICE_HOCKEY_MOBILE_TYPES;
    return {
      cells: cells == null ? void 0 : cells.filter(({ type }) => mobileTypes.includes(type))
    };
  }, [cells, sport, isResponsive]);
};

// src/molecules/Standings/Table/Header/StandingsTableHeader.tsx
import { getLabelValue as getLabelValue7 } from "@sportal365/smp-widget-utils";
var StandingsTableHeader = ({ type, labels, sport, isTable }) => {
  const { dataLabels } = useContext18(ConfigContext);
  const { cells } = useResponsiveTableCells({ cells: labels, sport, isResponsive: isTable });
  return /* @__PURE__ */ React33.createElement("thead", {
    className: `table-${type}-header`
  }, /* @__PURE__ */ React33.createElement("tr", {
    className: `table-${type}-header-row-0 h-[40px]`
  }, /* @__PURE__ */ React33.createElement("th", {
    colSpan: 12,
    className: "p-3 px-4 text-4 font-bold text-hiContrast border-t border-tableBorderColor bg-tableHeaderBG w-full text-left header-row-0-cell-TYPE"
  }, /* @__PURE__ */ React33.createElement("span", {
    className: "header-row-0-cell-TYPE-label"
  }, type))), /* @__PURE__ */ React33.createElement("tr", {
    className: `border-y border-tableBorderColor table-${type}-header-row-1 h-[40px]`
  }, /* @__PURE__ */ React33.createElement("th", {
    className: "bg-tableHeaderBG py-3 pl-4 pr-0 text-left text-4 text-hiContrast font-semibold w-full header-row-1-cell-TEAM"
  }, /* @__PURE__ */ React33.createElement("div", {
    className: "flex gap-2 cell-TEAM-info-container"
  }, /* @__PURE__ */ React33.createElement("span", {
    className: "cell-TEAM-symbol"
  }, "#"), /* @__PURE__ */ React33.createElement("span", {
    className: "cell-TEAM-label"
  }, getLabelValue7(dataLabels == null ? void 0 : dataLabels.team, "Team")))), cells == null ? void 0 : cells.map((cell) => /* @__PURE__ */ React33.createElement(StandingsTableHeaderCell, __spreadProps(__spreadValues({
    key: cell.type
  }, cell), {
    locator: `header-row-1-cell-${cell.type}`
  }))), !isTable && /* @__PURE__ */ React33.createElement(StandingsTableHeaderCell, {
    type: "FORM",
    value: getLabelValue7(dataLabels == null ? void 0 : dataLabels.team_form_short, "FORM"),
    locator: "header-row-1-cell-FORM"
  })));
};

// src/molecules/Standings/Table/Body/StandingsTableBody.tsx
import React37, { useContext as useContext21 } from "react";

// src/molecules/Standings/Team/StandingsTeamProfile.tsx
import React34, { useContext as useContext19 } from "react";
import { classNames as classNames21 } from "@sportal365/smp-widget-utils";
var StandingsTeamProfile = ({ name, logo, rank, withBadge, isMobile }) => {
  const { dataImageDisplay = true } = useContext19(ConfigContext);
  return /* @__PURE__ */ React34.createElement("div", {
    className: classNames21("cell-TEAM-info-container", "flex items-center gap-2 py-2 relative", { "max-w-[200px]": isMobile })
  }, withBadge && /* @__PURE__ */ React34.createElement("div", {
    className: "cell-TEAM-badge absolute w-[6px] h-[40px] bg-tableRankHighlightColor rounded-r-3"
  }), /* @__PURE__ */ React34.createElement("span", {
    className: "cell-TEAM-rank text-4 text-hiContrast mx-3"
  }, rank), dataImageDisplay && /* @__PURE__ */ React34.createElement("img", {
    src: logo,
    className: "cell-TEAM-image w-6 h-6",
    alt: name
  }), /* @__PURE__ */ React34.createElement("span", {
    className: "cell-TEAM-name text-4 text-hiContrast whitespace-nowrap overflow-hidden truncate"
  }, name));
};

// src/molecules/Standings/Form/StandingsFormResults.tsx
import React35, { useContext as useContext20 } from "react";
import dayjs3 from "dayjs";
var StandingsFormResults = ({ data, handleFormEventClick }) => {
  const { dataTheme, dataLabels } = useContext20(ConfigContext);
  if (!data || !data.length)
    return null;
  return /* @__PURE__ */ React35.createElement("div", {
    className: "cell-FORM-info-container flex justify-center gap-1 px-4"
  }, data.map((element) => {
    const form = __spreadProps(__spreadValues({}, element), { startTime: element.startTime ? dayjs3(element.startTime).format("DD.MM.YYYY") : "" });
    return /* @__PURE__ */ React35.createElement(TeamForm, {
      key: element.matchId,
      dataTheme: dataTheme != null ? dataTheme : THEME_VARIANTS.LIGHT,
      dataLabels,
      form,
      handleEventClick: handleFormEventClick
    });
  }));
};

// src/molecules/Standings/Table/Body/StandingTableBodyCells.tsx
import React36 from "react";
import { trimGoalDifferenceValue, classNames as classNames22 } from "@sportal365/smp-widget-utils";
var StandingTableBodyCells = ({ values, sport, locator, isHighlighted, isMobile, isTable }) => {
  const { cells } = useResponsiveTableCells({ cells: values, sport, isResponsive: isTable });
  return /* @__PURE__ */ React36.createElement(React36.Fragment, null, cells && cells.map(({ type, value }, index) => /* @__PURE__ */ React36.createElement("td", {
    key: index,
    className: classNames22(`${locator}-${type} text-center px-[6px] py-3 whitespace-nowrap text-hiContrast`, {
      "bg-highLighted": isHighlighted,
      "bg-rowBackgroundColor": !isHighlighted
    })
  }, /* @__PURE__ */ React36.createElement("span", {
    className: `${locator}-${type}-label align-middle`
  }, trimGoalDifferenceValue(type, value, isMobile)))));
};

// src/molecules/Standings/Table/Body/StandingsTableBody.tsx
import { defaultHandleEventClick as defaultHandleEventClick3, defaultHandleTeamClick as defaultHandleTeamClick2, classNames as classNames23 } from "@sportal365/smp-widget-utils";
var StandingsTableBody = ({ type, data, sport, handleClick, isMobile, isTable }) => {
  const { dataHighlightEntities } = useContext21(ConfigContext);
  const handleTeamClick = (id, name) => defaultHandleTeamClick2(handleClick, { id, name });
  const handleFormEventClick = (id) => defaultHandleEventClick3(handleClick, id);
  return /* @__PURE__ */ React37.createElement("tbody", {
    className: `table-${type}-body`
  }, data == null ? void 0 : data.map(({ values, team, form, url, urlTarget }, index) => {
    const isHighlighted = Boolean(dataHighlightEntities == null ? void 0 : dataHighlightEntities.find((value) => value === team.id));
    return /* @__PURE__ */ React37.createElement("a", {
      key: index,
      href: url,
      target: urlTarget,
      onClick: () => handleTeamClick(team.id, team.name),
      className: "contents cursor-pointer no-underline"
    }, /* @__PURE__ */ React37.createElement("tr", {
      key: index,
      className: `table-${type}-body-row-${index} border-b border-tableBorderColor h-[44px]`
    }, /* @__PURE__ */ React37.createElement("td", {
      className: classNames23(`body-row-${index}-cell-TEAM text-left w-full`, {
        "bg-highLighted": isHighlighted,
        "bg-rowBackgroundColor": !isHighlighted
      })
    }, /* @__PURE__ */ React37.createElement(StandingsTeamProfile, __spreadProps(__spreadValues({}, team), {
      rank: index + 1,
      isMobile
    }))), /* @__PURE__ */ React37.createElement(StandingTableBodyCells, {
      values,
      sport,
      locator: `body-row-${index}-cell`,
      isHighlighted,
      isMobile,
      isTable
    }), !isTable && /* @__PURE__ */ React37.createElement("td", {
      className: classNames23(`body-row-${index}-cell-FORM`, "text-center align-middle", {
        "bg-highLighted": isHighlighted,
        "bg-rowBackgroundColor": !isHighlighted
      }),
      onClick: (e3) => e3.stopPropagation()
    }, /* @__PURE__ */ React37.createElement(StandingsFormResults, {
      data: form,
      handleFormEventClick
    }))));
  }));
};

// src/molecules/Standings/Table/Footer/StandingsTableFooter.tsx
import React38 from "react";
import { classNames as classNames24 } from "@sportal365/smp-widget-utils";
var StandingsTableFooter = ({ rules, isMobile, type }) => {
  return /* @__PURE__ */ React38.createElement("tfoot", {
    className: `table-${type}-footer`
  }, /* @__PURE__ */ React38.createElement("tr", {
    className: `table-${type}-footer-row-0 h-[40px]`
  }, /* @__PURE__ */ React38.createElement("td", {
    colSpan: 12,
    className: classNames24(`footer-row-0-cell-RULES`, "bg-tableHeaderBG py-3 px-4 w-full")
  }, /* @__PURE__ */ React38.createElement("div", {
    className: classNames24("cell-RULES-rules-container", "flex gap-3", {
      "flex-col": isMobile,
      "flex-row": !isMobile
    })
  }, rules == null ? void 0 : rules.map(({ id, name }) => /* @__PURE__ */ React38.createElement("div", {
    key: id,
    className: "cell-RULES-rule-container flex items-center gap-2 whitespace-nowrap"
  }, /* @__PURE__ */ React38.createElement("div", {
    className: "bg-tableRankHighlightColor w-3 h-3 rounded-full"
  }), /* @__PURE__ */ React38.createElement("span", {
    className: `cell-RULES-rule-${name}-name text-hiContrast text-2`
  }, name)))))));
};

// src/molecules/Standings/Table/StandingsTable.tsx
var StandingsTable = ({ standings, sport, handleClick }) => {
  const { dataLabels } = useContext22(ConfigContext);
  const [isMobile, setIsMobile] = useState27(false);
  const [isTable, setIsTable] = useState27(false);
  const tableBreakpoint = sport === SportTypes.BASKETBALL ? 650 : 800;
  const measuredRef = useResizeObserver((fieldElement) => {
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
    setIsTable(fieldElement.offsetWidth < tableBreakpoint);
  });
  if (!standings || (standings == null ? void 0 : standings.length) === 0)
    return /* @__PURE__ */ React39.createElement(TextBlock, {
      text: dataLabels == null ? void 0 : dataLabels.no_data
    });
  return /* @__PURE__ */ React39.createElement("div", {
    ref: measuredRef,
    className: "tables-container"
  }, standings == null ? void 0 : standings.map(({ group, labels, data, rules }, index) => {
    const isLast = index === standings.length - 1;
    return /* @__PURE__ */ React39.createElement("table", {
      key: index,
      className: `w-full border-collapse table-${group == null ? void 0 : group.name}`
    }, /* @__PURE__ */ React39.createElement(StandingsTableHeader, {
      type: group == null ? void 0 : group.name,
      labels,
      sport,
      isTable
    }), /* @__PURE__ */ React39.createElement(StandingsTableBody, {
      type: group == null ? void 0 : group.name,
      data,
      sport,
      isMobile,
      isTable,
      handleClick
    }), isLast && /* @__PURE__ */ React39.createElement(StandingsTableFooter, {
      type: group == null ? void 0 : group.name,
      rules,
      isMobile
    }));
  }));
};

// src/molecules/TournamentHeader/TournamentHeader.tsx
import { defaultHandleTournamentClick as defaultHandleTournamentClick4 } from "@sportal365/smp-widget-utils/src/clickHandlers";
var TournamentHeader = ({
  id,
  title,
  subTitle,
  target,
  competitionUrl,
  competitionLogo,
  hideStandingsIcon,
  standingsLabel,
  standingsUrl,
  handleClick
}) => {
  const handleTournamentClick = () => competitionUrl ? defaultHandleTournamentClick4(handleClick, id, title) : void 0;
  const handleStandingsClick = () => standingsUrl ? defaultHandleTournamentClick4(handleClick, id, title) : void 0;
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-between items-end px-4 py-2 font-sans h-[50px] tournament-container"
  }, /* @__PURE__ */ React.createElement("a", {
    href: competitionUrl,
    target,
    className: "no-underline tournament",
    onClick: handleTournamentClick,
    rel: "noreferrer"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex gap-2 items-center"
  }, /* @__PURE__ */ React.createElement("img", {
    src: competitionLogo,
    className: "h-7 w-7 rounded-full",
    alt: `${title} Logo`
  }), /* @__PURE__ */ React.createElement("div", {
    className: "text-hiContrast"
  }, /* @__PURE__ */ React.createElement("p", {
    className: "text-4 font-bold m-0 mb-2"
  }, title), /* @__PURE__ */ React.createElement("p", {
    className: "text-2 m-0"
  }, subTitle)))), hideStandingsIcon ? null : /* @__PURE__ */ React.createElement("a", {
    href: standingsUrl,
    target,
    className: "text-standingsLinkColor underline decoration-standingsLinkColor ml-3 text-2 standings",
    onClick: handleStandingsClick,
    rel: "noreferrer"
  }, standingsLabel));
};

// src/molecules/TooltipV2/TooltipV2.tsx
import React40 from "react";
import { classNames as classNames25 } from "@sportal365/smp-widget-utils";
var TooltipV2 = ({ children, showTooltip }) => {
  return /* @__PURE__ */ React40.createElement("div", {
    className: classNames25("tooltip-container absolute bottom-[calc(100%+8px)] left-1/2 rounded-2 bg-standingsTooltipContainerPrimaryBgColor whitespace-nowrap text-3 z-[1050] cursor-pointer -translate-x-1/2 px-2 py-1 flex-col", {
      block: showTooltip,
      hidden: !showTooltip
    })
  }, children, /* @__PURE__ */ React40.createElement("span", {
    className: "content-[''] absolute top-full left-1/2 border-8 border-solid border-transparent border-t-standingsTooltipContainerPrimaryBgColor -translate-x-1/2 pointer-events-none"
  }));
};

// src/molecules/GroupSection/GroupSection.tsx
import React41 from "react";
import { classNames as classNames26 } from "@sportal365/smp-widget-utils";
var GroupSection = ({ url, target, handleClick, name, locator, standingsLabel, standingsUrl, withStandings }) => {
  return /* @__PURE__ */ React41.createElement("div", {
    className: classNames26("flex justify-between px-4 py-2 bg-primaryBackgroundColor border-b-2 border-b-loContrast font-sans h-[30px] gap-2", `${locator}-container`)
  }, /* @__PURE__ */ React41.createElement("a", {
    href: url != null ? url : "#",
    target,
    className: classNames26("text-2 font-bold text-hiContrast align-middle no-underline text-ellipsis overflow-hidden whitespace-pre", `${locator}-name`),
    onClick: handleClick
  }, name), withStandings && /* @__PURE__ */ React41.createElement("a", {
    href: standingsUrl != null ? standingsUrl : "#",
    target,
    className: "standings text-standingsLinkColor underline decoration-standingsLinkColor text-2",
    onClick: handleClick
  }, standingsLabel));
};

// ../hooks/useArrowScroll.ts
import { useState as useState28, useRef as useRef9, useEffect as useEffect22 } from "react";
function useArrowScroll(scrollValue) {
  var _a2;
  const [showNextArrow, setShowNextArrow] = useState28(false);
  const [showPrevArrow, setShowPrevArrow] = useState28(false);
  const wrapperRef = useRef9(null);
  useEffect22(() => {
    handleShowArrows();
  }, [wrapperRef.current]);
  const handlePrevToShow = () => {
    var _a3;
    if (wrapperRef && wrapperRef.current) {
      wrapperRef.current.scrollLeft -= scrollValue;
    }
    if (wrapperRef.current && wrapperRef.current.scrollLeft >= wrapperRef.current.scrollWidth - wrapperRef.current.offsetWidth) {
      setShowNextArrow(true);
    }
    if (((_a3 = wrapperRef.current) == null ? void 0 : _a3.scrollLeft) === 0) {
      setShowPrevArrow(false);
      setShowNextArrow(true);
    }
  };
  const handleNextToShow = () => {
    if (wrapperRef && wrapperRef.current) {
      wrapperRef.current.scrollLeft += scrollValue;
    }
    if (wrapperRef.current && wrapperRef.current.scrollLeft + wrapperRef.current.clientWidth === wrapperRef.current.scrollWidth) {
      setShowNextArrow(false);
    }
  };
  const handleShowArrows = () => {
    if (wrapperRef.current) {
      const { scrollLeft, scrollWidth: scrollWidth2, clientWidth } = wrapperRef.current;
      if (scrollLeft + clientWidth === scrollWidth2) {
        setShowNextArrow(false);
      }
      if (scrollLeft + clientWidth < scrollWidth2) {
        setShowNextArrow(true);
      }
      if (scrollLeft === 0) {
        setShowPrevArrow(false);
      }
      if (scrollLeft > 0) {
        setShowPrevArrow(true);
      }
    }
  };
  const onScroll = () => handleShowArrows();
  const scrollWidth = (_a2 = wrapperRef.current) == null ? void 0 : _a2.scrollWidth;
  return {
    wrapperRef,
    scrollWidth,
    showNextArrow,
    showPrevArrow,
    onScroll,
    handlePrevToShow,
    handleNextToShow
  };
}

// src/ogranisms/Knockout/components/KnockoutHead.tsx
var KnockoutHead = ({ name, isMobile }) => {
  return /* @__PURE__ */ React.createElement(SMPFlex, {
    css: {
      width: "100%",
      py: "$3",
      px: "$3",
      borderRadius: "$2",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: isMobile ? "$knockoutHeaderBgColor" : void 0,
      border: isMobile ? "1px solid $knockoutHeaderBorderColor" : void 0
    }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    css: { textAlign: "center", width: "100%" },
    variant: "contrast",
    size: "3",
    weight: "700"
  }, name));
};

// src/ogranisms/Knockout/components/KnockoutGame.tsx
import { useMemo as useMemo17 } from "react";
var KnockoutGame = ({ isNational, group, handleEventClick, groupName, sport }) => {
  var _a2, _b, _c, _d2, _e, _f, _g;
  const upcomingMatchDate = useMemo17(() => {
    const match12 = group.matches[0];
    if (!match12 || match12.statusType !== NOT_STARTED || !match12.kickOffTime) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(EventDate, {
      startTime: match12.kickOffTime
    });
  }, [group.matches]);
  return /* @__PURE__ */ React.createElement("div", {
    style: { marginBottom: "8px", display: "grid" }
  }, /* @__PURE__ */ React.createElement(SMPLinkWrapper, {
    href: group.matchLink,
    target: group.urlTarget,
    onClick: () => handleEventClick && handleEventClick(group.id)
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "livescoreMatch",
    css: {
      border: "1px solid $knockoutGameBorderColor",
      borderRadius: "$3",
      width: "100%",
      py: "$1",
      px: "$3",
      backgroundColor: "$knockoutGameBgColor",
      minWidth: KNOCKOUT_GAME_MIN_WIDTH + "px"
    },
    justify: "spaceBetween"
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "column",
    align: "start",
    css: { pr: "$1", height: "auto" }
  }, (_a2 = group == null ? void 0 : group.teams) == null ? void 0 : _a2.map((team, _index, teams) => {
    var _a3, _b2, _c2, _d3, _e2, _f2, _g2, _h, _i, _j, _k;
    if (!team || !teams[0] || !teams[1]) {
      return null;
    }
    const latestMatch = group.matches[group.matches.length - 1];
    const isWinner = ((_a3 = team.winner) == null ? void 0 : _a3.value) === "YES" ? true : ((_b2 = team.winner) == null ? void 0 : _b2.value) === "NO" ? false : void 0;
    const winnerReason = latestMatch == null ? void 0 : latestMatch.winner;
    return /* @__PURE__ */ React.createElement(GameTeam, {
      isWinner,
      team,
      key: team.id,
      imageVariant: "mediumLivescoreEntityLogo",
      teamName: team.name,
      teamLogo: team.logo,
      isNational,
      winnerId: isWinner ? team.id.toString() : void 0,
      aggregateWinnerId: (_c2 = winnerReason == null ? void 0 : winnerReason.aggregate) == null ? void 0 : _c2.id,
      winnerReason: ((_e2 = (_d3 = winnerReason == null ? void 0 : winnerReason.match) == null ? void 0 : _d3.reason) == null ? void 0 : _e2.name) || ((_g2 = (_f2 = winnerReason == null ? void 0 : winnerReason.aggregate) == null ? void 0 : _f2.reason) == null ? void 0 : _g2.name),
      scoreDetails: (latestMatch == null ? void 0 : latestMatch.aggregateScore) || (latestMatch == null ? void 0 : latestMatch.penaltyShootoutScore) ? {
        homeTeam: { id: teams[0].id.toString(), name: teams[0].name },
        awayTeam: { id: teams[1].id.toString(), name: teams[1].name },
        aggregateScore: {
          home: (_h = latestMatch.aggregateScore) == null ? void 0 : _h.away,
          away: (_i = latestMatch.aggregateScore) == null ? void 0 : _i.home
        },
        penaltyShootoutScore: group.matches.length === 1 ? latestMatch.penaltyShootoutScore : {
          home: (_j = latestMatch.penaltyShootoutScore) == null ? void 0 : _j.away,
          away: (_k = latestMatch.penaltyShootoutScore) == null ? void 0 : _k.home
        }
      } : void 0
    });
  })), /* @__PURE__ */ React.createElement(SMPFlex, null, ((_b = group.matches[0]) == null ? void 0 : _b.statusType) === NOT_STARTED ? upcomingMatchDate : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(GameScore, {
    eventId: group.id,
    handleEventClick,
    verticalAlign: true,
    homeTeamScore: group == null ? void 0 : group.totalScoreHomeTeamFirstMatch,
    awayTeamScore: group == null ? void 0 : group.totalScoreAwayTeamFirstMatch,
    penaltyShootoutScore: (_c = group.matches[0]) == null ? void 0 : _c.penaltyShootoutScore,
    homeTeamWeight: group.totalScoreHomeTeamFirstMatch > group.totalScoreAwayTeamFirstMatch ? "700" : "400",
    awayTeamWeight: group.totalScoreAwayTeamFirstMatch > group.totalScoreHomeTeamFirstMatch ? "700" : "400",
    groupName,
    sport
  }), group.matches.length > 1 && /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { paddingLeft: "$3" }
  }, /* @__PURE__ */ React.createElement(GameScore, {
    eventId: group.id,
    handleEventClick,
    verticalAlign: true,
    homeTeamScore: group == null ? void 0 : group.totalScoreAwayTeamSecondMatch,
    awayTeamScore: group == null ? void 0 : group.totalScoreHomeTeamSecondMatch,
    penaltyShootoutScore: {
      home: (_e = (_d2 = group.matches[group.matches.length - 1]) == null ? void 0 : _d2.penaltyShootoutScore) == null ? void 0 : _e.away,
      away: (_g = (_f = group.matches[group.matches.length - 1]) == null ? void 0 : _f.penaltyShootoutScore) == null ? void 0 : _g.home
    },
    homeTeamWeight: group.totalScoreAwayTeamSecondMatch > group.totalScoreHomeTeamSecondMatch ? "700" : "400",
    awayTeamWeight: group.totalScoreHomeTeamSecondMatch > group.totalScoreAwayTeamSecondMatch ? "700" : "400",
    groupName,
    sport
  })))))));
};

// src/ogranisms/Knockout/components/KnockoutDesktop.tsx
import { isKnouckoutGameDoubles as isKnouckoutGameDoubles2 } from "@sportal365/smp-widget-utils";

// src/ogranisms/Knockout/components/KnockoutGameType.tsx
import { isKnouckoutGameDoubles } from "@sportal365/smp-widget-utils/src/isKnouckoutGameDoubles";

// src/ogranisms/PlayoffKnockout/components/KnockoutGame.tsx
import { useEffect as useEffect23, useMemo as useMemo18, useRef as useRef10, useState as useState29 } from "react";
var mapAggEvents = (aggEvents) => {
  return aggEvents.map((event) => {
    var _a2, _b, _c;
    const participantsCodes = (_a2 = event.participants) == null ? void 0 : _a2.map((participant) => participant.threeLetterCode);
    const formattedDate = format(new Date((_b = event.scheduledStartTime) != null ? _b : ""), "dd.MM");
    const gameResults = (_c = event.results) == null ? void 0 : _c.filter((result) => {
      var _a3;
      return ((_a3 = result.resultType) == null ? void 0 : _a3.type) === "FINALRESULT";
    }).map((result) => {
      var _a3;
      return (_a3 = result.participants) == null ? void 0 : _a3.map((participant) => participant.value);
    });
    const winnerIndex = gameResults && gameResults[0] && gameResults[0][0] && gameResults[0][1] && gameResults[0][0] !== void 0 && gameResults[0][1] !== void 0 && gameResults[0][0] > gameResults[0][1] ? 0 : 1;
    return {
      participantsCodes,
      formattedDate,
      gameResults,
      winnerIndex
    };
  });
};
var KnockoutGame2 = ({
  group,
  handleEventClick,
  sport,
  isNational,
  groupName,
  isMobile,
  showAggEvents,
  handleOpenMenu,
  parentRefHeight,
  handleEnableScroll
}) => {
  var _a2, _b, _c, _d2, _e, _f;
  const groupResult = ((_a2 = group == null ? void 0 : group.results) == null ? void 0 : _a2.find((result) => {
    var _a3;
    return ((_a3 = result == null ? void 0 : result.resultType) == null ? void 0 : _a3.type) === resultTypeForDisplaying;
  })) || null;
  const firstTeam = group && group.participants && group.participants[0] || null;
  const secondTeam = group && group.participants && group.participants[1] || null;
  const [showEventList, setShowEventList] = useState29(false);
  const containerRef = useRef10(null);
  const dropdownEventsRef = useRef10(null);
  const showEvents = () => {
    setShowEventList(!showEventList);
    handleOpenMenu && handleOpenMenu(!showEventList);
    showAggEvents && showAggEvents(!showEventList);
  };
  const mappedAggEvents = mapAggEvents((group == null ? void 0 : group.events) || []);
  const upcomingMatchDate = useMemo18(() => {
    var _a3;
    if (!group.events) {
      return null;
    }
    const firstEvent = group.events[0];
    if (!firstEvent || ((_a3 = firstEvent.status) == null ? void 0 : _a3.type) !== NOT_STARTED || !firstEvent.scheduledStartTime) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(EventDate, {
      startTime: firstEvent.scheduledStartTime
    });
  }, [group.events]);
  useEffect23(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowEventList(false);
        handleOpenMenu && handleOpenMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);
  useEffect23(() => {
    var _a3, _b2, _c2;
    if (showEventList && containerRef.current && dropdownEventsRef.current && parentRefHeight) {
      const containerRect = (_a3 = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a3.getBoundingClientRect();
      const dropdownHeight = ((_c2 = (_b2 = dropdownEventsRef == null ? void 0 : dropdownEventsRef.current) == null ? void 0 : _b2.getBoundingClientRect()) == null ? void 0 : _c2.height) + 38;
      const availableSpaceBelow = parentRefHeight - containerRect.bottom;
      if (availableSpaceBelow < dropdownHeight) {
        handleEnableScroll && handleEnableScroll(true);
      }
    }
    return () => {
      handleEnableScroll && handleEnableScroll(false);
    };
  }, [showEventList]);
  return /* @__PURE__ */ React.createElement("div", {
    ref: containerRef,
    style: { marginBottom: "8px", display: "grid", position: "relative" }
  }, /* @__PURE__ */ React.createElement(SMPLinkWrapper, {
    href: (_b = group.matchLink) != null ? _b : void 0,
    target: group.urlTarget,
    onClick: () => handleEventClick && handleEventClick(group.id)
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "livescoreMatch",
    style: {
      border: "1px solid var(--colors-knockoutGameBorderColor)",
      borderRadius: showEventList ? "8px 8px 0 0" : "8px",
      width: "100%",
      paddingTop: "4px",
      paddingBottom: "4px",
      paddingLeft: "16px",
      paddingRight: "16px",
      minWidth: KNOCKOUT_GAME_MIN_WIDTH + "px",
      backgroundColor: showEventList ? "var(--colors-gray12)" : "var(--colors-knockoutGameBgColor)",
      overflow: "hidden",
      borderBottom: showEventList ? "none" : "1px solid var(--colors-knockoutGameBorderColor)",
      marginBottom: showEventList ? "1px" : "0px"
    },
    justify: "spaceBetween"
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "column",
    align: "start"
  }, [firstTeam, secondTeam].map((team, index) => {
    var _a3, _b2, _c2, _d3;
    const isWinner = ((_a3 = team == null ? void 0 : team.winner) == null ? void 0 : _a3.value) === "YES" ? true : ((_b2 = team == null ? void 0 : team.winner) == null ? void 0 : _b2.value) === "NO" ? false : void 0;
    const logo = (team == null ? void 0 : team.entityType) === TEAM_ENTITY ? assetsPlaceholder[TEAM_ENTITY] : assetsPlaceholder.tennisParticipant;
    return /* @__PURE__ */ React.createElement(GameTeam, {
      isWinner,
      key: `${team == null ? void 0 : team.id}${index}`,
      imageVariant: sport === Sports.TENNIS && !(team == null ? void 0 : team.logo) ? "tennisParticipantPlayoffLogo" : "mediumLivescoreEntityLogo",
      teamName: team == null ? void 0 : team.name,
      teamLogo: (_c2 = team == null ? void 0 : team.logo) != null ? _c2 : logo,
      team,
      isNational,
      winnerId: isWinner ? (_d3 = team == null ? void 0 : team.id) == null ? void 0 : _d3.toString() : void 0,
      sport,
      showAggEvents: showEvents,
      showAggEventsList: showEventList
    });
  })), groupResult && groupResult.participants && groupResult.participants.length > 0 && /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { paddingLeft: "$3" }
  }, ((_d2 = (_c = group.events) == null ? void 0 : _c[0].status) == null ? void 0 : _d2.type) === NOT_STARTED ? upcomingMatchDate : /* @__PURE__ */ React.createElement(GameScore, {
    eventId: group.id,
    verticalAlign: true,
    homeTeamScore: (_e = groupResult.participants.find((participant) => participant.id === (firstTeam == null ? void 0 : firstTeam.id))) == null ? void 0 : _e.value,
    awayTeamScore: (_f = groupResult.participants.find((participant) => participant.id === (secondTeam == null ? void 0 : secondTeam.id))) == null ? void 0 : _f.value,
    groupName,
    sport: sport || "",
    isMobile,
    showAggEvents: showEventList
  })))), showEventList ? /* @__PURE__ */ React.createElement(SMPFlex, {
    ref: dropdownEventsRef,
    style: {
      width: "100%",
      position: "absolute",
      top: "100%",
      left: 0,
      flexDirection: "column",
      display: "flex",
      border: "1px solid var(--colors-knockoutAggEventsBorderColor)",
      borderRadius: "0 0 8px 8px",
      minWidth: KNOCKOUT_GAME_MIN_WIDTH + "px",
      overflow: "hidden",
      zIndex: 10,
      borderTop: "1px solid var(--colors-knockoutGameBorderColor)"
    }
  }, mappedAggEvents.map((event, key) => /* @__PURE__ */ React.createElement(SMPFlex, {
    key: `${key}-${event.formattedDate}`,
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      padding: "13px 16px",
      gap: "8px",
      display: "flex",
      borderBottomLeftRadius: key === mappedAggEvents.length - 1 ? "8px" : "0px",
      borderBottomRightRadius: key === mappedAggEvents.length - 1 ? "8px" : "0px",
      borderTop: key !== 0 ? "1px solid var(--colors-knockoutAggEventsBorderColor)" : "none",
      backgroundColor: "var(--colors-knockoutAggEventsBgColor)"
    }
  }, /* @__PURE__ */ React.createElement(SMPText, {
    style: {
      fontWeight: 400,
      fontSize: "12px",
      display: "flex",
      flexDirection: "column-reverse",
      height: "13px",
      color: "var(--colors-gray6)"
    }
  }, event.formattedDate), /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    style: {
      fontWeight: event.winnerIndex === 0 ? 700 : 400,
      color: "var(--colors-hiContrast)"
    }
  }, `${event.participantsCodes && event.participantsCodes[0]}`), /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    style: { fontWeight: 400, color: "var(--colors-hiContrast)" }
  }, "-"), /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    style: {
      fontWeight: event.winnerIndex === 1 ? 700 : 400,
      flexGrow: 1,
      color: "var(--colors-hiContrast)"
    }
  }, `${event.participantsCodes && event.participantsCodes[1]}`), /* @__PURE__ */ React.createElement(SMPText, {
    size: "3",
    style: {
      fontWeight: 400,
      textAlign: "right",
      color: "var(--colors-hiContrast)"
    }
  }, `${(event == null ? void 0 : event.gameResults) && (event == null ? void 0 : event.gameResults[0]) && event.gameResults[0][0]} - ${event.gameResults && (event == null ? void 0 : event.gameResults[0]) && event.gameResults[0][1]}`)))) : void 0);
};

// src/ogranisms/PlayoffKnockout/components/KnockoutGameDoubles.tsx
var KnockoutGameDoubles = ({ group, handleEventClick, sport, isNational }) => {
  var _a2, _b, _c, _d2, _e;
  const groupResult = ((_a2 = group == null ? void 0 : group.results) == null ? void 0 : _a2.find((result) => {
    var _a3;
    return ((_a3 = result == null ? void 0 : result.resultType) == null ? void 0 : _a3.type) === resultTypeForDisplaying;
  })) || null;
  const firstDouble = group && group.participants && group.participants[0] || null;
  const secondDouble = group && group.participants && group.participants[1] || null;
  return /* @__PURE__ */ React.createElement("div", {
    style: { marginBottom: "8px", display: "grid" }
  }, /* @__PURE__ */ React.createElement(SMPLinkWrapper, {
    href: group.matchLink,
    target: group.urlTarget,
    onClick: () => handleEventClick && handleEventClick(group.id)
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "livescoreMatch",
    css: {
      border: "2px solid #707070",
      borderRadius: "$3",
      width: "100%",
      py: "$1",
      px: "$3",
      backgroundColor: "$rowBackgroundColor",
      minWidth: "max-content"
    },
    justify: "spaceBetween"
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "column",
    align: "start",
    css: { width: "100%" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    justify: "spaceBetween",
    css: { width: "100%" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "column",
    align: "start"
  }, (_b = firstDouble == null ? void 0 : firstDouble.details) == null ? void 0 : _b.map((team, index) => {
    var _a3, _b2, _c2, _d3, _e2, _f, _g, _h;
    const winner = ((_a3 = firstDouble == null ? void 0 : firstDouble.winner) == null ? void 0 : _a3.value) === "YES";
    const logo = (firstDouble == null ? void 0 : firstDouble.entityType) === TEAM_ENTITY ? assetsPlaceholder[TEAM_ENTITY] : assetsPlaceholder.tennisParticipant;
    const teamName = team == null ? void 0 : team.name;
    return /* @__PURE__ */ React.createElement(GameTeam, {
      isWinner: winner,
      key: `${team == null ? void 0 : team.id}${index}`,
      imageVariant: sport === Sports.TENNIS && !((_d3 = (_c2 = (_b2 = team == null ? void 0 : team.country) == null ? void 0 : _b2.assets) == null ? void 0 : _c2.flag) == null ? void 0 : _d3.url) ? "tennisParticipantPlayoffLogo" : "mediumLivescoreEntityLogo",
      teamName,
      teamLogo: (_h = (_g = (_f = (_e2 = team == null ? void 0 : team.country) == null ? void 0 : _e2.assets) == null ? void 0 : _f.flag) == null ? void 0 : _g.url) != null ? _h : logo,
      team,
      isNational
    });
  })), groupResult && groupResult.participants && groupResult.participants.length > 0 && /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { paddingLeft: "$3" }
  }, /* @__PURE__ */ React.createElement(GameScore, {
    eventId: group.id,
    verticalAlign: true,
    homeTeamScore: (_c = groupResult.participants.find((participant) => participant.id === (firstDouble == null ? void 0 : firstDouble.id))) == null ? void 0 : _c.value
  }))), /* @__PURE__ */ React.createElement(SMPDivider, null), /* @__PURE__ */ React.createElement(SMPFlex, {
    justify: "spaceBetween",
    css: { width: "100%" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "column",
    align: "start"
  }, (_d2 = secondDouble == null ? void 0 : secondDouble.details) == null ? void 0 : _d2.map((team, index) => {
    var _a3, _b2, _c2, _d3, _e2, _f, _g, _h;
    const winner = ((_a3 = secondDouble == null ? void 0 : secondDouble.winner) == null ? void 0 : _a3.value) === "YES";
    const logo = (secondDouble == null ? void 0 : secondDouble.entityType) === TEAM_ENTITY ? assetsPlaceholder[TEAM_ENTITY] : assetsPlaceholder.tennisParticipant;
    return /* @__PURE__ */ React.createElement(GameTeam, {
      isWinner: winner,
      key: `${team == null ? void 0 : team.id}${index}`,
      imageVariant: sport === Sports.TENNIS && !((_d3 = (_c2 = (_b2 = team == null ? void 0 : team.country) == null ? void 0 : _b2.assets) == null ? void 0 : _c2.flag) == null ? void 0 : _d3.url) ? "tennisParticipantPlayoffLogo" : "mediumLivescoreEntityLogo",
      teamName: team == null ? void 0 : team.name,
      teamLogo: (_h = (_g = (_f = (_e2 = team == null ? void 0 : team.country) == null ? void 0 : _e2.assets) == null ? void 0 : _f.flag) == null ? void 0 : _g.url) != null ? _h : logo,
      team,
      isNational
    });
  })), groupResult && groupResult.participants && groupResult.participants.length > 0 && /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { paddingLeft: "$3" }
  }, /* @__PURE__ */ React.createElement(GameScore, {
    eventId: group.id,
    verticalAlign: true,
    awayTeamScore: (_e = groupResult.participants.find((participant) => participant.id === (secondDouble == null ? void 0 : secondDouble.id))) == null ? void 0 : _e.value
  })))))));
};

// src/ogranisms/Knockout/components/KnockoutGameType.tsx
var renderKnockoutGameType = (group, handleEventClick, sport, type, isNational, groupName, handleOpenMenu, isMobile, parentRefHeight, handleEnableScroll) => {
  if (isKnouckoutGameDoubles(type)) {
    return /* @__PURE__ */ React.createElement(KnockoutGameDoubles, {
      isNational,
      handleEventClick,
      group,
      sport
    });
  }
  return /* @__PURE__ */ React.createElement(KnockoutGame2, {
    isNational,
    handleEventClick,
    group,
    sport,
    groupName,
    isMobile,
    handleOpenMenu,
    parentRefHeight,
    handleEnableScroll
  });
};

// src/ogranisms/Knockout/components/KnockoutDesktop.tsx
import { useState as useState30 } from "react";
var arrowCss = {
  width: "10px",
  position: "absolute",
  zIndex: 20,
  top: "34px",
  "transition-timing-function": "ease-out",
  "&:hover": {
    color: "orange",
    cursor: "pointer",
    transition: "color 0.3s"
  },
  "&:active": {
    height: "14px",
    transition: "height 0.3s",
    "transition-timing-function": "ease-out"
  }
};
var nextArrowCss = {
  right: "25px"
};
var prevArrowCss = {
  left: "25px"
};
var KnockoutDesktop = ({
  knockoutGroupNames,
  knockoutGroupGames,
  smallFinalName = SMALL_FINAL,
  hasSmallFinal,
  handleEventClick,
  isPlayoff,
  sport,
  type,
  isNational
}) => {
  const { wrapperRef, showPrevArrow, showNextArrow, onScroll, handlePrevToShow, handleNextToShow } = useArrowScroll(320);
  const [hasOpenMenu, setHasOpenMenu] = useState30(false);
  const [enableScroll, setEnableScroll] = useState30(false);
  const isPlayoffGroup = (group) => {
    return isPlayoff;
  };
  const smallFinalWithTwoKnockoutGroups = hasSmallFinal && knockoutGroupGames.length === 2 && !isPlayoff;
  return /* @__PURE__ */ React.createElement(SMPKnockoutDesktopContainer, {
    onScroll,
    ref: wrapperRef,
    style: hasOpenMenu && enableScroll ? { overflow: "unset" } : {}
  }, /* @__PURE__ */ React.createElement(React.Fragment, null, showPrevArrow && /* @__PURE__ */ React.createElement(SMPArrowLeftIcon, {
    onClick: handlePrevToShow,
    css: __spreadValues(__spreadValues({}, arrowCss), prevArrowCss)
  }), /* @__PURE__ */ React.createElement(SMPKnockoutHeaderContainer, {
    css: {
      display: "flex",
      left: 0,
      position: "sticky",
      width: "100%"
    }
  }), /* @__PURE__ */ React.createElement("div", {
    style: {
      height: "48px",
      left: 0,
      marginTop: "-40px",
      width: "100%",
      zIndex: 3,
      display: "flex",
      position: "sticky",
      top: 0
    }
  }), /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { borderRadius: "$3", flexDirection: "column" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    className: "knockout-rounds-container",
    css: {
      marginTop: "-48px",
      zIndex: 3,
      gridAutoFlow: "column",
      justifyContent: "initial",
      gridGap: "50px",
      display: (knockoutGroupGames == null ? void 0 : knockoutGroupGames.length) < 3 ? "inherit" : "grid",
      width: "calc(100% - 20px)"
    }
  }, knockoutGroupNames == null ? void 0 : knockoutGroupNames.map((name, index) => {
    var _a2;
    const increaseRowGap = smallFinalWithTwoKnockoutGroups && knockoutGroupNames.length - 1 === index;
    return /* @__PURE__ */ React.createElement("div", {
      key: name,
      style: {
        display: "grid",
        gridTemplateRows: "28px",
        rowGap: increaseRowGap ? "130px" : "12px"
      }
    }, /* @__PURE__ */ React.createElement(KnockoutHead, {
      name
    }), /* @__PURE__ */ React.createElement("div", {
      style: knockoutGroupNames.length - 1 === index && index > 0 && hasSmallFinal ? {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginTop: "24px"
      } : { marginTop: "24px", display: "grid", zIndex: 1 }
    }, (_a2 = knockoutGroupGames == null ? void 0 : knockoutGroupGames[index]) == null ? void 0 : _a2.map((group, idx) => {
      var _a3;
      const removeConnectingLines = knockoutGroupGames.length - 1 === index;
      return /* @__PURE__ */ React.createElement(SMPKnockoutGameContainer, {
        smallFinalWithTwoKnockoutGroups,
        smallFinal: hasSmallFinal === true && knockoutGroupNames.length - 2 === index,
        removeConnectingLines,
        even: idx % 2 === 0,
        odd: removeConnectingLines ? false : Math.abs(idx % 2) == 1,
        firstGroup: index === 0,
        doublesVariant: isPlayoffGroup(group) && isKnouckoutGameDoubles2(type),
        variant: "group",
        key: group.id
      }, knockoutGroupNames.length - 1 === index && index > 0 && hasSmallFinal && Math.abs(idx % 2) == 1 ? /* @__PURE__ */ React.createElement(SMPKnockoutSmallFinal, null, /* @__PURE__ */ React.createElement(SMPText, {
        size: "3",
        variant: "contrast",
        css: { textAlign: "center" }
      }, smallFinalName)) : null, isPlayoffGroup(group) ? renderKnockoutGameType(group, handleEventClick, sport, type, isNational, name, setHasOpenMenu, false, (_a3 = wrapperRef == null ? void 0 : wrapperRef.current) == null ? void 0 : _a3.offsetHeight, setEnableScroll) : /* @__PURE__ */ React.createElement(KnockoutGame, {
        handleEventClick,
        group,
        isNational
      }));
    })));
  }))), showNextArrow && /* @__PURE__ */ React.createElement(SMPArrowRightIcon, {
    onClick: handleNextToShow,
    css: __spreadValues(__spreadValues({}, arrowCss), nextArrowCss)
  })));
};

// src/ogranisms/Knockout/components/KnockoutMobile.tsx
import { useCallback as useCallback5, useEffect as useEffect24, useMemo as useMemo19, useRef as useRef11, useState as useState31 } from "react";
import Slider from "react-slick";

// src/ogranisms/Knockout/components/KnockoutRoundConnectingLine.tsx
var KnockoutRoundConnectingLine = ({ idx, index, lastGroupNameIndex, hasSmallFinal }) => {
  if (index !== 0 && index < lastGroupNameIndex || lastGroupNameIndex === index && !hasSmallFinal) {
    return /* @__PURE__ */ React.createElement(ConnectingLine, {
      style: { top: "32px" }
    });
  }
  if (lastGroupNameIndex === index && hasSmallFinal && Math.abs(idx % 2) == 1) {
    return /* @__PURE__ */ React.createElement(ConnectingLine, {
      style: { top: "-42px" }
    });
  }
  return null;
};
var ConnectingLine = styled.withConfig({ componentId: "KnockoutRoundConnectingLine", displayName: "ConnectingLine" })("div", {
  position: "absolute",
  width: "16px",
  background: "$knockoutGameBorderColor",
  height: "1px",
  left: "-16px"
});

// src/ogranisms/Knockout/components/KnockoutMobile.tsx
import { isKnouckoutGameDoubles as isKnouckoutGameDoubles3 } from "@sportal365/smp-widget-utils";
var arrowCss2 = {
  width: "10px",
  zIndex: 2,
  "&:hover": {
    color: "orange",
    cursor: "pointer"
  },
  "&:active": {
    height: "14px"
  }
};
var KnockoutMobile = ({
  knockoutGroupNames,
  knockoutGroupGames,
  maxSteps,
  activeStep,
  smallFinalName = SMALL_FINAL,
  hasSmallFinal,
  handleEventClick,
  isMobile,
  isPlayoff,
  sport,
  type,
  isNational
}) => {
  const [activeGroup, setActiveGroup] = useState31(activeStep || 0);
  const [hasOpenMenu, setHasOpenMenu] = useState31(false);
  const slider = useRef11(null);
  const sliderContainer = useRef11(null);
  const [pointerStart, setPointerStart] = useState31(null);
  const [pointerEnd, setPointerEnd] = useState31(null);
  const settings = useMemo19(() => {
    return {
      dots: false,
      infinite: false,
      speed: 250,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      className: hasOpenMenu ? "knockoutMobileSlickSliderWithMenu" : "knockoutMobileSlickSlider",
      swipe: false,
      draggable: true,
      initialSlide: activeStep,
      afterChange: (current) => setActiveGroup(current)
    };
  }, [hasOpenMenu, activeStep, setActiveGroup]);
  const handlePointerDown = useCallback5((e3) => {
    setPointerStart(e3.clientX);
  }, []);
  const handlePointerMove = useCallback5((e3) => {
    if (pointerStart !== null) {
      setPointerEnd(e3.clientX);
    }
  }, [pointerStart]);
  const handlePointerUp = useCallback5(() => {
    var _a2, _b;
    if (pointerStart === null || pointerEnd === null)
      return;
    const diff = pointerStart - pointerEnd;
    if (diff > 50) {
      (_a2 = slider.current) == null ? void 0 : _a2.slickNext();
    } else if (diff < -50) {
      (_b = slider.current) == null ? void 0 : _b.slickPrev();
    }
    setPointerStart(null);
    setPointerEnd(null);
  }, [pointerStart, pointerEnd]);
  useEffect24(() => {
    const currentContainer = sliderContainer.current;
    if (currentContainer) {
      currentContainer.addEventListener("pointerdown", handlePointerDown);
      currentContainer.addEventListener("pointermove", handlePointerMove);
      currentContainer.addEventListener("pointerup", handlePointerUp);
      currentContainer.addEventListener("pointercancel", handlePointerUp);
      return () => {
        currentContainer.removeEventListener("pointerdown", handlePointerDown);
        currentContainer.removeEventListener("pointermove", handlePointerMove);
        currentContainer.removeEventListener("pointerup", handlePointerUp);
        currentContainer.removeEventListener("pointercancel", handlePointerUp);
      };
    }
  }, [handlePointerDown, handlePointerMove, handlePointerUp]);
  useEffect24(() => {
    if (slider.current) {
      slider.current.slickGoTo(activeGroup);
    }
  }, [activeGroup]);
  const isPlayoffGroup = (group) => {
    return isPlayoff;
  };
  return /* @__PURE__ */ React.createElement(SMPKnockoutMobileContainer, {
    css: { display: isMobile ? "block" : "none" }
  }, knockoutGroupNames && /* @__PURE__ */ React.createElement("div", {
    ref: sliderContainer,
    style: { touchAction: "pan-y" }
  }, /* @__PURE__ */ React.createElement(Slider, __spreadValues({
    ref: slider
  }, settings), knockoutGroupNames.map((name, index) => {
    var _a2;
    return /* @__PURE__ */ React.createElement("div", {
      style: { marginTop: "8px" },
      key: name
    }, /* @__PURE__ */ React.createElement(SMPFlex, {
      css: { px: "$3", alignItems: "center", position: "relative" }
    }, activeGroup !== 0 && /* @__PURE__ */ React.createElement("div", {
      style: { position: "absolute", left: "30px", top: "15px" }
    }, /* @__PURE__ */ React.createElement(SMPArrowLeftIcon, {
      onClick: () => {
        var _a3;
        return (_a3 = slider == null ? void 0 : slider.current) == null ? void 0 : _a3.slickPrev();
      },
      css: __spreadValues({}, arrowCss2)
    })), /* @__PURE__ */ React.createElement(KnockoutHead, {
      name,
      isMobile: true
    }), maxSteps && activeGroup !== maxSteps - 1 && /* @__PURE__ */ React.createElement("div", {
      style: { position: "absolute", right: "30px", top: "15px" }
    }, /* @__PURE__ */ React.createElement(SMPArrowRightIcon, {
      onClick: () => {
        var _a3;
        return (_a3 = slider == null ? void 0 : slider.current) == null ? void 0 : _a3.slickNext();
      },
      css: __spreadValues({}, arrowCss2)
    }))), /* @__PURE__ */ React.createElement(SMPFlex, {
      css: {
        marginTop: "20px",
        display: "grid",
        justifyContent: "normal",
        paddingLeft: "$3"
      }
    }, (_a2 = knockoutGroupGames == null ? void 0 : knockoutGroupGames[index]) == null ? void 0 : _a2.map((group, idx) => {
      const removeConnectingLines = knockoutGroupGames.length - 1 === index;
      return /* @__PURE__ */ React.createElement(SMPKnockoutMobileGameContainer, {
        smallFinal: hasSmallFinal === true && knockoutGroupNames.length - 2 === index,
        removeConnectingLines,
        even: idx % 2 === 0,
        odd: removeConnectingLines ? false : Math.abs(idx % 2) == 1,
        firstGroup: index === 0,
        doublesVariant: isPlayoffGroup(group) && isKnouckoutGameDoubles3(type),
        variant: "group",
        key: group.id
      }, knockoutGroupNames.length - 1 === index && index > 0 && hasSmallFinal && Math.abs(idx % 2) == 1 ? /* @__PURE__ */ React.createElement(SMPKnockoutSmallFinal, null, /* @__PURE__ */ React.createElement(SMPText, {
        size: "3",
        variant: "contrast",
        css: { textAlign: "center" }
      }, smallFinalName)) : null, /* @__PURE__ */ React.createElement(KnockoutRoundConnectingLine, {
        lastGroupNameIndex: knockoutGroupNames.length - 1,
        hasSmallFinal,
        index,
        idx
      }), isPlayoffGroup(group) ? renderKnockoutGameType(group, handleEventClick, sport, type, isNational, name, setHasOpenMenu, isMobile) : /* @__PURE__ */ React.createElement(KnockoutGame, {
        handleEventClick,
        group,
        isNational,
        groupName: name,
        sport
      }));
    })));
  }))));
};

// src/ogranisms/Knockout/Knockout.tsx
import { useMemo as useMemo20, useRef as useRef12 } from "react";
var getKnockoutData = (normalizedKnockoutData) => {
  if (!normalizedKnockoutData || normalizedKnockoutData.length === 0) {
    return { names: [], groupGames: [], maxSteps: 0, activeStep: 0 };
  }
  const names = normalizedKnockoutData.map(({ name }) => name);
  const groupGames = normalizedKnockoutData.map(({ groups }) => groups);
  const maxSteps = normalizedKnockoutData.length;
  const activeRound = normalizedKnockoutData.findIndex(({ status }) => status === ACTIVE);
  const activeStep = activeRound < 0 || void 0 ? 0 : activeRound;
  return { names, groupGames, maxSteps, activeStep };
};
var Knockout = ({ normalizedKnockoutData, smallFinalName, hasSmallFinal, handleEventClick }) => {
  const ref = useRef12(null);
  const { isMobile } = useIsSmartphoneDevice(ref);
  const { names, groupGames, maxSteps, activeStep } = useMemo20(() => {
    return getKnockoutData(normalizedKnockoutData);
  }, [normalizedKnockoutData]);
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    ref,
    style: { paddingRight: isMobile ? "0" : "$3", paddingLeft: isMobile ? "0" : "$3" },
    css: {
      paddingBottom: "$3",
      paddingTop: "$3",
      position: "relative",
      backgroundColor: "$knockoutBgColor"
    }
  }, /* @__PURE__ */ React.createElement(KnockoutMobile, {
    isMobile,
    activeStep,
    maxSteps,
    knockoutGroupGames: groupGames,
    knockoutGroupNames: names,
    smallFinalName,
    hasSmallFinal,
    handleEventClick,
    isPlayoff: false
  }), !isMobile && /* @__PURE__ */ React.createElement(KnockoutDesktop, {
    handleEventClick,
    knockoutGroupGames: groupGames,
    knockoutGroupNames: names,
    smallFinalName,
    hasSmallFinal,
    isPlayoff: false
  }));
};

// src/ogranisms/PlayoffKnockout/PlayoffKnockout.tsx
import { useRef as useRef13 } from "react";
var PlayoffKnockout = ({
  smallFinal,
  groupsEvents,
  roundNames,
  dataLabels,
  handleEventClick,
  sport,
  type,
  isNational
}) => {
  const ref = useRef13(null);
  const maxSteps = roundNames && roundNames.length;
  const { isMobile } = useIsSmartphoneDevice(ref);
  if (roundNames && roundNames.length === 0) {
    return /* @__PURE__ */ React.createElement(SMPContainer, {
      css: {
        paddingBottom: "$3",
        paddingTop: "$3",
        paddingRight: 0,
        paddingLeft: isMobile ? 0 : "$3",
        position: "relative",
        textAlign: "center",
        color: "$hiContrast"
      }
    }, dataLabels && dataLabels["no_games"]);
  }
  const hasSmallFinal = Boolean(smallFinal && smallFinal.id);
  return /* @__PURE__ */ React.createElement(SMPContainer, {
    ref,
    style: { paddingRight: isMobile ? "0" : "$3", paddingLeft: isMobile ? "0" : "$3" },
    css: {
      paddingBottom: "$3",
      paddingTop: "$3",
      position: "relative",
      backgroundColor: "$knockoutBgColor"
    }
  }, /* @__PURE__ */ React.createElement(KnockoutMobile, {
    isMobile,
    maxSteps,
    knockoutGroupGames: groupsEvents,
    knockoutGroupNames: roundNames,
    hasSmallFinal,
    handleEventClick,
    isPlayoff: true,
    sport,
    type,
    isNational
  }), !isMobile && /* @__PURE__ */ React.createElement(KnockoutDesktop, {
    handleEventClick,
    knockoutGroupGames: groupsEvents,
    knockoutGroupNames: roundNames,
    hasSmallFinal,
    isPlayoff: true,
    sport,
    type,
    isNational
  }));
};

// src/ogranisms/playoff-knockout-new/playoff-knockout-new.tsx
import React44, { useContext as useContext26, useRef as useRef15 } from "react";

// src/ogranisms/playoff-knockout-new/components/desktop/knockout-desktop.tsx
import React42, { useRef as useRef14 } from "react";

// src/ogranisms/playoff-knockout-new/components/general/knockout-head.tsx
import { classNames as classNames27 } from "@sportal365/smp-widget-utils";
var KnockoutHead2 = ({ name, isMobile, isFirstElement, isLastElement }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    className: classNames27({
      "h-12 py-3 flex items-center justify-center bg-knockoutHeaderBgColor border-t border-b border-knockoutHeaderBorderColor z-2": true,
      "-mx-[50px] w-[calc(100%+100px)]": !isMobile,
      "border-r rounded-r-2 mr-0": !isMobile && isLastElement,
      "border-l rounded-l-2 ml-0": !isMobile && isFirstElement,
      "border rounded-r-2 rounded-l-2": isMobile
    })
  }, /* @__PURE__ */ React.createElement("span", {
    className: classNames27({
      "font-bold text-hiContrast text-4": true,
      "-ml-[100px]": !isMobile && isFirstElement
    })
  }, name)));
};
var knockout_head_default = KnockoutHead2;

// src/ogranisms/playoff-knockout-new/components/desktop/knockout-desktop.tsx
import { classNames as classNames33, mapFirstEventAsLink } from "@sportal365/smp-widget-utils";

// src/ogranisms/playoff-knockout-new/components/desktop/position-container.tsx
var EventPositionContainer = ({ children, isEven, withConnectionLines, isSmallFinal }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "grid items-center relative w-[calc(100%-20px)] md:w-full md:[&>div_a>span]:whitespace-nowrap md:[&>div_a>span]:overflow-hidden md:[&>div_a>span]:text-ellipsis md:[&>div_a>span]:max-w-[110px]"
  }, children, withConnectionLines && isEven && /* @__PURE__ */ React.createElement("div", {
    className: "absolute right-[-10px] bottom-[-50%] h-[calc(50%+1px)] w-[10px] border-b border-r rounded-br border-knockoutGameBorderColor z-[-1] md:right-[-20px] md:w-[30px]"
  }), withConnectionLines && !isEven && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    className: "absolute right-[-10px] top-[-50%] h-[calc(50%+1px)] w-[10px] border-t border-r rounded-tr border-knockoutGameBorderColor z-[-1] md:right-[-20px] md:w-[30px]"
  }), /* @__PURE__ */ React.createElement("div", {
    className: "absolute right-[-19px] top-0 h-full w-[9px] border-t border-knockoutGameBorderColor z-[-1] md:right-[-60px] md:w-[40px]"
  })), isSmallFinal && /* @__PURE__ */ React.createElement("div", {
    className: "absolute right-[-30px] top-[50%] h-px w-[50px] bg-knockoutGameBorderColor z-[-1] md:right-[-60px] md:w-[80px]"
  }));
};
var position_container_default = EventPositionContainer;

// src/ogranisms/playoff-knockout-new/components/general/event-popup/events-popup.tsx
import { classNames as classNames29 } from "@sportal365/smp-widget-utils";

// src/ogranisms/playoff-knockout-new/components/general/event-popup/participant-text.tsx
import { classNames as classNames28 } from "@sportal365/smp-widget-utils";
var ParticipantPopupText = ({ participant }) => {
  return /* @__PURE__ */ React.createElement("span", {
    className: classNames28({
      "text-4": true,
      "font-semibold text-hiContrast": participant == null ? void 0 : participant.isWinner,
      "font-normal text-teamLostColor": !(participant == null ? void 0 : participant.isWinner)
    })
  }, participant == null ? void 0 : participant.three_letter_code);
};

// src/ogranisms/playoff-knockout-new/components/general/event-popup/events-popup.tsx
var KnockoutEventsPopup = ({ events, direction, isMobile, handleEventClick }) => {
  const handleLinkClick = (eventId) => {
    handleEventClick && handleEventClick(eventId);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames29({
      "event-popup-container absolute left-0 border border-knockoutGameBorderColor rounded-4 overflow-hidden bg-knockoutAggEventsBgColor z-50": true,
      "w-64 mx-2": !isMobile,
      "w-full": isMobile,
      "top-full -mt-2 rounded-t-none": direction === "down",
      "bottom-full -mb-2 rounded-b-none": direction === "up"
    })
  }, events.map((event, index) => {
    const totalScoreResult = event.results[0];
    const firstParticipant = totalScoreResult.participants[0];
    const secondParticipant = totalScoreResult.participants[1];
    return /* @__PURE__ */ React.createElement("a", {
      key: index,
      href: event.url,
      target: event.url_target,
      onClick: () => handleLinkClick(event.id),
      className: classNames29({
        "aggregate-match-link flex items-center px-4 py-2": true,
        "border-b border-gray-200": index !== events.length - 1
      })
    }, /* @__PURE__ */ React.createElement("div", {
      className: "font-normal text-4 flex flex-col-reverse text-gray6"
    }, event.scheduled_start_time), /* @__PURE__ */ React.createElement("div", {
      className: "flex-1 flex items-center space-x-2 ml-4"
    }, /* @__PURE__ */ React.createElement(ParticipantPopupText, {
      participant: firstParticipant
    }), /* @__PURE__ */ React.createElement("span", {
      className: "font-normal text-hiContrast text-4"
    }, "-"), /* @__PURE__ */ React.createElement(ParticipantPopupText, {
      participant: secondParticipant
    })), /* @__PURE__ */ React.createElement("div", {
      className: "w-16 text-right font-normal text-hiContrast text-4"
    }, firstParticipant == null ? void 0 : firstParticipant.value, " - ", secondParticipant == null ? void 0 : secondParticipant.value));
  }));
};

// src/ogranisms/playoff-knockout-new/components/general/event/group.tsx
import { classNames as classNames31 } from "@sportal365/smp-widget-utils";

// src/ogranisms/playoff-knockout-new/components/general/event/participant.tsx
import { useContext as useContext24 } from "react";

// src/ogranisms/playoff-knockout-new/components/general/event/aggregate-label.tsx
import { useContext as useContext23 } from "react";
import { getLabelValue as getLabelValue8 } from "@sportal365/smp-widget-utils";
var AggregateLabel = () => {
  const { dataLabels } = useContext23(ConfigContext);
  return /* @__PURE__ */ React.createElement("span", {
    className: "inline-flex items-center justify-center text-3 rounded-2 px-1 w-[52px] font-normal bg-statusBadgeBgColor text-statusBadgeTextColor h-4"
  }, getLabelValue8(dataLabels == null ? void 0 : dataLabels.aggregate, "AGG"), " \u2713");
};

// src/ogranisms/playoff-knockout-new/components/general/event/participant.tsx
import { classNames as classNames30, getParticipantName } from "@sportal365/smp-widget-utils";

// src/ogranisms/playoff-knockout-new/components/general/cup-icon.tsx
var FinalCupIcon = () => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "w-6 h-6"
  }, /* @__PURE__ */ React.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#FFD800"
  }), /* @__PURE__ */ React.createElement("mask", {
    id: "mask0_1437_94076",
    style: { maskType: "alpha" },
    maskUnits: "userSpaceOnUse",
    x: "4",
    y: "4",
    width: "16",
    height: "16"
  }, /* @__PURE__ */ React.createElement("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    fill: "black"
  })), /* @__PURE__ */ React.createElement("g", {
    mask: "url(#mask0_1437_94076)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M8.66667 18V16.6667H11.3333V14.6C10.7889 14.4778 10.3028 14.2472 9.875 13.9083C9.44722 13.5694 9.13333 13.1444 8.93333 12.6333C8.1 12.5333 7.40278 12.1694 6.84167 11.5417C6.28056 10.9139 6 10.1778 6 9.33333V8.66667C6 8.3 6.13056 7.98611 6.39167 7.725C6.65278 7.46389 6.96667 7.33333 7.33333 7.33333H8.66667V6H15.3333V7.33333H16.6667C17.0333 7.33333 17.3472 7.46389 17.6083 7.725C17.8694 7.98611 18 8.3 18 8.66667V9.33333C18 10.1778 17.7194 10.9139 17.1583 11.5417C16.5972 12.1694 15.9 12.5333 15.0667 12.6333C14.8667 13.1444 14.5528 13.5694 14.125 13.9083C13.6972 14.2472 13.2111 14.4778 12.6667 14.6V16.6667H15.3333V18H8.66667ZM8.66667 11.2V8.66667H7.33333V9.33333C7.33333 9.75556 7.45556 10.1361 7.7 10.475C7.94444 10.8139 8.26667 11.0556 8.66667 11.2ZM12 13.3333C12.5556 13.3333 13.0278 13.1389 13.4167 12.75C13.8056 12.3611 14 11.8889 14 11.3333V7.33333H10V11.3333C10 11.8889 10.1944 12.3611 10.5833 12.75C10.9722 13.1389 11.4444 13.3333 12 13.3333ZM15.3333 11.2C15.7333 11.0556 16.0556 10.8139 16.3 10.475C16.5444 10.1361 16.6667 9.75556 16.6667 9.33333V8.66667H15.3333V11.2Z",
    fill: "black"
  }))));
};

// src/ogranisms/playoff-knockout-new/components/general/event/participant.tsx
var KnockoutParticipant = ({
  participant,
  isDirectLink,
  isAggregateOpen,
  isFinal
}) => {
  var _a2, _b;
  const { dataTeamNameType } = useContext24(ConfigContext);
  const defaultImage = (participant == null ? void 0 : participant.entity_type) === TEAM_ENTITY ? assetsPlaceholder.team : assetsPlaceholder.player;
  const winnerClassnames = {
    "font-bold text-hiContrast": participant == null ? void 0 : participant.isWinner,
    "font-normal text-teamLostColor": !(participant == null ? void 0 : participant.isWinner),
    "text-white": isAggregateOpen
  };
  return /* @__PURE__ */ React.createElement("div", {
    key: participant.id,
    className: "participants-container flex items-center px-2 py-1"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center gap-2 flex-1 min-w-0"
  }, /* @__PURE__ */ React.createElement("img", {
    src: ((_b = (_a2 = participant == null ? void 0 : participant.assets) == null ? void 0 : _a2.logo_150x150) == null ? void 0 : _b.url) || defaultImage,
    className: classNames30({
      "w-6 h-6 shrink-0 object-contain": true,
      "rounded-full ring-1 ring-countryLogoBorderColor": (participant == null ? void 0 : participant.type) === NATIONAL
    })
  }), /* @__PURE__ */ React.createElement("span", {
    className: classNames30(__spreadValues({
      "text-4 overflow-hidden truncate whitespace-nowrap": true
    }, winnerClassnames))
  }, getParticipantName(participant, dataTeamNameType || ""))), /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center gap-2 ml-4 shrink-0 relative"
  }, (participant == null ? void 0 : participant.isWinner) && !isDirectLink && /* @__PURE__ */ React.createElement(AggregateLabel, null), /* @__PURE__ */ React.createElement("span", {
    className: classNames30(__spreadValues({
      "text-4 min-w-[1ch] text-right": true
    }, winnerClassnames))
  }, participant == null ? void 0 : participant.score), isFinal && (participant == null ? void 0 : participant.isWinner) && /* @__PURE__ */ React.createElement("div", {
    className: "absolute -right-8 top-1/2 -translate-y-1/2"
  }, /* @__PURE__ */ React.createElement(FinalCupIcon, null))));
};

// src/ogranisms/playoff-knockout-new/components/general/event/group.tsx
var KnockoutGroup = ({
  group,
  directLink,
  popupDirection,
  isMobile,
  isFinal,
  handleEventClick
}) => {
  const { participants, events } = group;
  const onGroupClick = () => !directLink && setIsComponentVisible(!isComponentVisible);
  const { isComponentVisible, setIsComponentVisible, ref } = useDetectClickOutside();
  const onLinkWrapperClick = () => {
    directLink && handleEventClick && handleEventClick(group.events[0].id);
  };
  return /* @__PURE__ */ React.createElement("div", {
    onClick: onGroupClick,
    ref,
    className: "relative"
  }, /* @__PURE__ */ React.createElement(LinkWrapper, {
    shouldWrap: !!directLink,
    url: directLink == null ? void 0 : directLink.url,
    target: directLink == null ? void 0 : directLink.target,
    onClick: onLinkWrapperClick
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames31({
      "group-container border border-knockoutGameBorderColor rounded-4 p-2 cursor-pointer": true,
      "bg-knockoutGameBgColor": !isComponentVisible,
      "bg-gray12": isComponentVisible,
      "rounded-b-none": isComponentVisible && popupDirection === "down",
      "rounded-t-none": isComponentVisible && popupDirection === "up",
      "w-64 m-2": !isMobile,
      "w-full mt-2": isMobile
    })
  }, participants.map((p2) => /* @__PURE__ */ React.createElement(KnockoutParticipant, {
    key: p2.id,
    participant: p2,
    isDirectLink: !!directLink,
    isAggregateOpen: !!isComponentVisible,
    isFinal
  }))), !directLink && isComponentVisible && /* @__PURE__ */ React.createElement(KnockoutEventsPopup, {
    events,
    direction: popupDirection,
    isMobile,
    handleEventClick
  })));
};

// src/ogranisms/playoff-knockout-new/components/desktop/stage-scroller.tsx
import { useContext as useContext25, useEffect as useEffect25, useState as useState32 } from "react";
import { classNames as classNames32, getLabelValue as getLabelValue9 } from "@sportal365/smp-widget-utils";

// ../constants/knockout.ts
var PREV_POSITION = "prev";
var NEXT_POSITION = "next";

// src/ogranisms/playoff-knockout-new/components/desktop/stage-scroller.tsx
var KnockoutStageScroller = ({ containerRef }) => {
  const [canScrollLeft, setCanScrollLeft] = useState32(false);
  const [canScrollRight, setCanScrollRight] = useState32(true);
  const { dataLabels } = useContext25(ConfigContext);
  const buttons = [
    {
      direction: PREV_POSITION,
      label: getLabelValue9(dataLabels == null ? void 0 : dataLabels.prev_stage_btn, "Previous stage"),
      disabled: !canScrollLeft
    },
    {
      direction: NEXT_POSITION,
      label: getLabelValue9(dataLabels == null ? void 0 : dataLabels.next_stage_btn, "Next stage"),
      disabled: !canScrollRight
    }
  ];
  useEffect25(() => {
    const container = containerRef.current;
    const checkScrollPosition = () => {
      if (container) {
        setCanScrollLeft(container.scrollLeft > 0);
        setCanScrollRight(container.scrollLeft < container.scrollWidth - container.clientWidth);
      }
    };
    checkScrollPosition();
    if (container) {
      container.addEventListener("scroll", checkScrollPosition);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", checkScrollPosition);
      }
    };
  }, []);
  const onArrowClick = (arrowDirection) => {
    const container = containerRef.current;
    if (!container)
      return;
    const scrollAmount = 300;
    if (arrowDirection === NEXT_POSITION) {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    } else {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    }
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-between mb-2"
  }, buttons.map(({ direction, disabled, label }) => /* @__PURE__ */ React.createElement("button", {
    key: direction,
    onClick: () => onArrowClick(direction),
    disabled,
    className: classNames32("flex items-center hover:cursor-pointer rounded-4 border border-gray-200 px-4 py-3 gap-2 transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed bg-knockoutHeaderBgColor", {
      "flex-row-reverse": direction === NEXT_POSITION
    })
  }, /* @__PURE__ */ React.createElement("svg", {
    height: "14",
    width: "8",
    className: classNames32("w-[10px] z-20 top-[17px] text-hiContrast transition-colors duration-300 ease-out", {
      "rotate-180": direction === NEXT_POSITION
    })
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(-19.599 -9.969)"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(27.599 9.969) rotate(90)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })))), /* @__PURE__ */ React.createElement("span", {
    className: "text-4 font-semibold text-hiContrast"
  }, label))));
};

// src/ogranisms/playoff-knockout-new/components/desktop/knockout-desktop.tsx
var KnockoutDesktop2 = ({ playoff, handleEventClick }) => {
  const { groups_events, round_names, small_final } = playoff;
  const containerRef = useRef14(null);
  const groupEventsLength = (groups_events == null ? void 0 : groups_events.length) || 0;
  const knockoutGroupNamesLength = (round_names == null ? void 0 : round_names.length) || 0;
  const isLastGroup = (indexGroup) => knockoutGroupNamesLength - 1 === indexGroup;
  return /* @__PURE__ */ React42.createElement(React42.Fragment, null, /* @__PURE__ */ React42.createElement(KnockoutStageScroller, {
    containerRef
  }), /* @__PURE__ */ React42.createElement("div", {
    ref: containerRef,
    className: "overflow-x-auto overflow-y-hidden scroll-smooth relative pb-2"
  }, /* @__PURE__ */ React42.createElement("div", {
    className: classNames33("knockout-rounds-container flex rounded-4 flex-col relative z-[3] gap-[50px] w-[calc(100%-20px)] justify-start", {
      flex: groupEventsLength < 3,
      "grid grid-flow-col": groupEventsLength >= 3
    })
  }, round_names.map((name, index) => {
    var _a2;
    return /* @__PURE__ */ React42.createElement("div", {
      key: name,
      className: "grid grid-rows-[28px]"
    }, /* @__PURE__ */ React42.createElement(knockout_head_default, {
      name,
      isFirstElement: index === 0,
      isLastElement: isLastGroup(index)
    }), /* @__PURE__ */ React42.createElement("div", {
      className: "mt-6 grid z-[1]"
    }, (_a2 = groups_events == null ? void 0 : groups_events[index]) == null ? void 0 : _a2.map((group, groupIndex) => {
      var _a3;
      const groupsLength = ((_a3 = groups_events == null ? void 0 : groups_events[index]) == null ? void 0 : _a3.length) || 0;
      const isGroupNameEven = groupIndex % 2 === 0;
      const directLink = mapFirstEventAsLink(group);
      return /* @__PURE__ */ React42.createElement(position_container_default, {
        key: group.id,
        isEven: isGroupNameEven,
        withConnectionLines: groupEventsLength - 1 !== index,
        isSmallFinal: !!small_final && groupEventsLength - 2 === index
      }, /* @__PURE__ */ React42.createElement(KnockoutGroup, {
        key: group.id,
        group,
        directLink,
        popupDirection: groupsLength / 2 > groupIndex ? "down" : "up",
        isFinal: isLastGroup(index) && groupsLength === 1,
        handleEventClick
      }));
    })));
  }))));
};

// src/ogranisms/playoff-knockout-new/components/mobile/knockout-mobile.tsx
import React43, { useState as useState33 } from "react";
import { mapFirstEventAsLink as mapFirstEventAsLink2 } from "@sportal365/smp-widget-utils";

// src/ogranisms/playoff-knockout-new/components/mobile/knockout-arrow.tsx
import { classNames as classNames34 } from "@sportal365/smp-widget-utils";
var KnockoutArrow = ({ position, action }) => {
  const isLeft = position === PREV_POSITION;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames34({
      "absolute z-20 flex space-x-2": true,
      "left-0": isLeft,
      "right-0": !isLeft
    }),
    onClick: action
  }, /* @__PURE__ */ React.createElement("svg", {
    className: classNames34({
      "w-[10px] absolute z-20 top-[17px] text-hiContrast hover:text-accentPrimaryBgColor hover:cursor-pointer transition-colors duration-300 ease-out active:h-[14px] active:transition-[height] active:duration-300 active:ease-out": true,
      "right-[25px]": !isLeft,
      "left-[25px]": isLeft
    }),
    height: "14",
    width: "8"
  }, isLeft ? /* @__PURE__ */ React.createElement("g", {
    transform: "translate(-19.599 -9.969)"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(27.599 9.969) rotate(90)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))) : /* @__PURE__ */ React.createElement("g", {
    transform: "translate(0 14.041) rotate(-90)"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M14.042,1.12a1.468,1.468,0,0,1-.468.738q-2.9,2.895-5.8,5.8a.969.969,0,0,1-1.071.285A1.146,1.146,0,0,1,6.3,7.675Q3.3,4.7.322,1.707A.952.952,0,0,1,.069.639.936.936,0,0,1,.9,0a.989.989,0,0,1,.823.327q.686.69,1.376,1.377l3.8,3.8a.863.863,0,0,0,.154.144.645.645,0,0,1,.083-.142Q9.722,2.926,12.306.343A.981.981,0,0,1,13.352.05a.934.934,0,0,1,.64.641l.05.155Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })))));
};

// src/ogranisms/playoff-knockout-new/components/mobile/knockout-mobile.tsx
var KnockoutMobile2 = ({ playoff, handleEventClick }) => {
  var _a2;
  const { groups_events, round_names, active_round } = playoff;
  const lastStageIndex = round_names.length - 1 || 0;
  const activeStageIndex = round_names.findIndex((roundName) => roundName === active_round) || 0;
  const [stageIndex, setStageIndex] = useState33(activeStageIndex);
  const isLastGroup = !(stageIndex >= 0 && stageIndex < lastStageIndex);
  const onArrowClick = (arrowDirection) => {
    if (arrowDirection === NEXT_POSITION && stageIndex < lastStageIndex) {
      setStageIndex((prev) => prev + 1);
    } else if (arrowDirection === PREV_POSITION && stageIndex > 0) {
      setStageIndex((prev) => prev - 1);
    }
  };
  return /* @__PURE__ */ React43.createElement("div", {
    className: "flex rounded-4 flex-col p-4"
  }, stageIndex > 0 && /* @__PURE__ */ React43.createElement(KnockoutArrow, {
    position: PREV_POSITION,
    action: () => onArrowClick(PREV_POSITION)
  }), /* @__PURE__ */ React43.createElement(knockout_head_default, {
    isMobile: true,
    name: round_names[stageIndex],
    isFirstElement: stageIndex >= 0 && stageIndex < lastStageIndex,
    isLastElement: stageIndex > 0
  }), !isLastGroup && /* @__PURE__ */ React43.createElement(KnockoutArrow, {
    position: NEXT_POSITION,
    action: () => onArrowClick(NEXT_POSITION)
  }), /* @__PURE__ */ React43.createElement("div", {
    className: "mt-6"
  }, (_a2 = groups_events == null ? void 0 : groups_events[stageIndex]) == null ? void 0 : _a2.map((group) => {
    var _a3;
    const groupsLength = ((_a3 = groups_events == null ? void 0 : groups_events[stageIndex]) == null ? void 0 : _a3.length) || 0;
    const directLink = mapFirstEventAsLink2(group);
    return /* @__PURE__ */ React43.createElement(KnockoutGroup, {
      key: group.id,
      isMobile: true,
      group,
      directLink,
      popupDirection: "down",
      isFinal: isLastGroup && groupsLength === 1,
      handleEventClick
    });
  })));
};

// src/ogranisms/playoff-knockout-new/playoff-knockout-new.tsx
import { getLabelValue as getLabelValue10 } from "@sportal365/smp-widget-utils";
var PlayoffKnockoutNew = ({ playoff, handleEventClick }) => {
  var _a2;
  const ref = useRef15(null);
  const { isMobile } = useIsSmartphoneDevice(ref);
  const { dataLabels } = useContext26(ConfigContext);
  const maxSteps = ((_a2 = playoff == null ? void 0 : playoff.round_names) == null ? void 0 : _a2.length) || 0;
  if (maxSteps === 0 || !playoff) {
    return /* @__PURE__ */ React44.createElement("div", {
      className: "playoff-empty-container py-3 pr-0 text-center text-hiContrast relative pl-0 md:pl-3 bg-primaryBackgroundColor"
    }, getLabelValue10(dataLabels == null ? void 0 : dataLabels.no_games, "No games for the selected playoff"));
  }
  return /* @__PURE__ */ React44.createElement("div", {
    ref,
    className: "playoff-container box-border flex-shrink-0 font-sans mx-auto p-0 md:p-3 relative bg-knockoutBgColor pb-3"
  }, isMobile ? /* @__PURE__ */ React44.createElement(KnockoutMobile2, {
    playoff,
    handleEventClick
  }) : /* @__PURE__ */ React44.createElement(KnockoutDesktop2, {
    playoff,
    handleEventClick
  }));
};

// src/ogranisms/Standings/Standings.tsx
import { useEffect as useEffect26, useMemo as useMemo21 } from "react";

// src/ogranisms/Standings/components/StandingsFooter.tsx
import { formatRuleType } from "@sportal365/smp-widget-utils";
var StandingsFooter = ({ rules, sport, dataLabels }) => {
  var _a2, _b, _c;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "standingsMarginals",
    wrap: "wrap",
    gap: "md",
    style: { backgroundColor: "var(--colors-subHeaderBgColor)" }
  }, rules == null ? void 0 : rules.map((rule) => {
    const ruleType = formatRuleType(rule.type);
    return /* @__PURE__ */ React.createElement(SMPFlex, {
      key: rule.id,
      css: { mr: "$2" }
    }, /* @__PURE__ */ React.createElement(SMPRulesColorCircle, {
      rule: ruleType
    }), /* @__PURE__ */ React.createElement(SMPText, {
      variant: "contrast",
      size: "2"
    }, rule.name));
  })), sport === Sports.FOOTBALL && /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "standingsMarginals",
    style: { backgroundColor: "var(--colors-subHeaderBgColor)" }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { alignItems: "center", mr: "$2" }
  }, /* @__PURE__ */ React.createElement(SMPWinIcon, {
    width: "3",
    height: "3"
  }), /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "2",
    css: { ml: "$1" }
  }, (_a2 = dataLabels == null ? void 0 : dataLabels.footer_win) != null ? _a2 : "Win")), /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { alignItems: "center", mr: "$2" }
  }, /* @__PURE__ */ React.createElement(SMPLossIcon, {
    width: "3",
    height: "3"
  }), /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "2",
    css: { ml: "$1" }
  }, (_b = dataLabels == null ? void 0 : dataLabels.footer_loss) != null ? _b : "Loss")), /* @__PURE__ */ React.createElement(SMPFlex, {
    css: { alignItems: "center", mr: "$2" }
  }, /* @__PURE__ */ React.createElement(SMPDrawIcon, {
    width: "3",
    height: "3"
  }), /* @__PURE__ */ React.createElement(SMPText, {
    variant: "contrast",
    size: "2",
    css: { ml: "$1" }
  }, (_c = dataLabels == null ? void 0 : dataLabels.footer_draw) != null ? _c : "Draw"))));
};

// src/ogranisms/Body/Body.tsx
import { getLabelValue as getLabelValue11 } from "@sportal365/smp-widget-utils";
var Body = ({
  data,
  handleClick,
  handleTeamClick,
  noDataMessage,
  measuredRef,
  sport,
  isMobile,
  isTeamSquad,
  displayImage,
  tableVariant,
  hasPlayoff,
  containerSize
}) => {
  const { isMobile: isSmartphoneDevice } = useIsSmartphoneDevice();
  const getColumns = (item) => {
    const isSmallSize = containerSize && containerSize + 16 < TABULAR_WIDGET_BREAKPOINT_1;
    const isIceHockey = sport === Sports.ICE_HOCKEY;
    const isMobileDevice = isMobile != null ? isMobile : isSmartphoneDevice;
    if (isIceHockey) {
      return isSmallSize ? item == null ? void 0 : item.mobileColumns : item == null ? void 0 : item.desktopColumns;
    }
    return isMobileDevice ? item == null ? void 0 : item.mobileColumns : item == null ? void 0 : item.desktopColumns;
  };
  if (tableVariant === TableVariants.STANDINGS && (data == null ? void 0 : data.length) < 1 && !hasPlayoff) {
    return /* @__PURE__ */ React.createElement(SMPContainer, {
      style: {
        paddingBottom: "16px",
        paddingTop: "16px",
        paddingRight: 0,
        paddingLeft: isMobile ? 0 : "$3",
        position: "relative",
        textAlign: "center",
        color: "$hiContrast"
      },
      variant: "paddinglessContainer",
      ref: measuredRef
    }, /* @__PURE__ */ React.createElement(SMPFlex, null, /* @__PURE__ */ React.createElement(SMPText, {
      variant: "contrast"
    }, getLabelValue11(noDataMessage, "No games available"))));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, data && /* @__PURE__ */ React.createElement(SMPContainer, {
    variant: "paddinglessContainer",
    ref: measuredRef
  }, data.map(({ name, item, position }, index) => {
    return /* @__PURE__ */ React.createElement(Table, {
      sport,
      key: index,
      groupName: name,
      columns: getColumns(item != null ? item : {}),
      rows: item == null ? void 0 : item.data,
      handleClick,
      handleTeamClick,
      noDataMessage,
      isMobile: isMobile != null ? isMobile : isSmartphoneDevice,
      isTeamSquad,
      position,
      displayImage,
      tableVariant
    });
  })));
};

// src/contexts/SizeContext.tsx
import React45, { createContext as createContext2, useState as useState34, useContext as useContext27 } from "react";
var SizeContext = createContext2({
  setIsMobile: () => {
  },
  isMobile: false
});
var useSizeContext = () => useContext27(SizeContext);
var SizeProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState34(false);
  return /* @__PURE__ */ React45.createElement(SizeContext.Provider, {
    value: { isMobile, setIsMobile }
  }, children);
};

// src/ogranisms/Standings/Standings.tsx
var Standings = ({
  rules,
  stageId,
  seasonId,
  knockout,
  standings,
  stageList,
  competition,
  dataLabels,
  secondaryHeader,
  dataHeaderDisplay,
  dataOptionsDisplay,
  mobileDropdown,
  handleTeamClick,
  handleSeasonChange,
  handleTournamentClick,
  handleActiveStageChange,
  sport,
  playoffStage,
  handleEventClick,
  measuredRef: propMeasuredRef,
  handleSubscriptionClick,
  isNational,
  isMobile,
  displayImage,
  tableVariant
}) => {
  var _a2;
  useEffect26(() => {
    if (!stageId && seasonId && stageList) {
      const foundStage = stageList.find((stage) => stage.status === ACTIVE);
      if (foundStage) {
        handleActiveStageChange && handleActiveStageChange(foundStage.id);
      }
    }
  }, [seasonId, stageId, stageList, handleActiveStageChange]);
  const tabOptions = useMemo21(() => stageList && stageList.map((stage) => ({
    name: stage.name,
    value: stage.id
  })), [stageList]);
  const options = useMemo21(() => (competition == null ? void 0 : competition.seasons) && competition.seasons.map((season) => ({
    label: season.name,
    value: season.id
  })), [competition == null ? void 0 : competition.seasons]);
  const { setIsMobile } = useSizeContext();
  const standingsMeasuredRef = useResizeObserver((fieldElement) => {
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Header, {
    logo: (competition == null ? void 0 : competition.logo) || (competition == null ? void 0 : competition.tournamentImage),
    link: competition == null ? void 0 : competition.tournamentLink,
    urlTarget: competition == null ? void 0 : competition.urlTarget,
    title: competition == null ? void 0 : competition.name,
    secondaryTitle: (_a2 = competition == null ? void 0 : competition.country) == null ? void 0 : _a2.name,
    selectedOption: seasonId,
    tabOptions,
    options,
    selectedTab: stageId,
    secondaryHeader: dataOptionsDisplay ? secondaryHeader : void 0,
    handleSubscriptionClick,
    handleChange: handleSeasonChange,
    handleClick: handleTournamentClick,
    handleTabOptionClick: handleActiveStageChange,
    isMainImageRound: playoffStage ? false : isNational,
    displayMainHeader: dataHeaderDisplay == true,
    dataOptionsDisplay,
    mobileDropdown
  }), /* @__PURE__ */ React.createElement(Body, {
    data: standings,
    handleClick: handleTeamClick,
    measuredRef: propMeasuredRef ? propMeasuredRef : standingsMeasuredRef,
    sport,
    isMobile,
    displayImage,
    tableVariant
  }), knockout && /* @__PURE__ */ React.createElement("div", {
    className: "standings-knockout-container",
    ref: standingsMeasuredRef
  }, /* @__PURE__ */ React.createElement(Knockout, {
    hasSmallFinal: knockout.hasSmallFinal,
    smallFinalName: knockout.smallFinalName,
    handleEventClick,
    normalizedKnockoutData: knockout.data
  })), playoffStage && /* @__PURE__ */ React.createElement("div", {
    className: "standings-knockout-container",
    ref: standingsMeasuredRef
  }, /* @__PURE__ */ React.createElement(PlayoffKnockout, {
    handleEventClick,
    smallFinal: playoffStage.smallFinal,
    roundNames: playoffStage.roundNames,
    groupsEvents: playoffStage.groupsEvents,
    dataLabels: playoffStage.dataLabels,
    sport,
    type: playoffStage.type,
    isNational
  })), knockout || playoffStage ? null : /* @__PURE__ */ React.createElement(StandingsFooter, {
    rules,
    sport,
    dataLabels
  }));
};

// src/ogranisms/Tabs/Tabs.tsx
import { defaultHandleUserInteractionClick as defaultHandleUserInteractionClick8 } from "@sportal365/smp-widget-utils/src/clickHandlers";
import React46, { useEffect as useEffect27, useMemo as useMemo22, useState as useState35 } from "react";
var Tabs = ({ tabs, displayTabs, defaultTab, tabsContent, handleSubscriptionClick }) => {
  var _a2;
  const tabsData = useMemo22(() => {
    if (tabs) {
      return Object.entries(tabs).map(([key, value]) => ({ key, value }));
    }
    return [];
  }, [tabs]);
  const [selectedTab, setSelectedTab] = useState35(defaultTab && (tabs == null ? void 0 : tabs[defaultTab]) ? defaultTab : (_a2 = tabsData[0]) == null ? void 0 : _a2.key);
  const selectTab = (tab) => {
    setSelectedTab(tab);
    defaultHandleUserInteractionClick8(handleSubscriptionClick, USER_INTERACTION, TAB_SELECTION_SUBSCRIBE_TYPE);
  };
  useEffect27(() => {
    var _a3;
    if (!(tabs == null ? void 0 : tabs[selectedTab])) {
      setSelectedTab(defaultTab && (tabs == null ? void 0 : tabs[defaultTab]) ? defaultTab : (_a3 = tabsData[0]) == null ? void 0 : _a3.key);
    }
  }, [defaultTab, selectedTab, tabs, tabsData]);
  const tabsBody = tabsContent && Object.entries(tabsContent);
  return /* @__PURE__ */ React46.createElement(React46.Fragment, null, displayTabs && /* @__PURE__ */ React46.createElement(SMPContainer, {
    css: {
      background: "$tabRowBackgroundColor",
      display: "flex",
      gap: "20px",
      borderTop: "1px solid $tabBorderColor",
      borderBottom: "1px solid $tabBorderColor",
      paddingLeft: "0px",
      overflow: "hidden",
      overflowX: "auto",
      scrollbarWidth: "none",
      height: "52px"
    }
  }, tabsData == null ? void 0 : tabsData.map((tab) => {
    return /* @__PURE__ */ React46.createElement(Tab, {
      key: tab.key,
      tab,
      selectTab,
      isSelected: selectedTab === tab.key
    });
  })), tabsBody == null ? void 0 : tabsBody.map(([key, value]) => {
    return /* @__PURE__ */ React46.createElement("div", {
      style: { display: key === selectedTab ? "block" : "none" },
      key
    }, /* @__PURE__ */ React46.createElement(TabBody, {
      data: value
    }));
  }));
};

// src/ogranisms/Match/Match.tsx
import { useRef as useRef16 } from "react";
var Match = ({ odds, match: match12, handleClick, handleTeamClick, handleEventClick, oddsMarketScope }) => {
  var _a2, _b;
  const ref = useRef16(null);
  const { isMobile } = useIsSmartphoneDevice(ref);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, match12 && /* @__PURE__ */ React.createElement(SMPContainer, {
    ref,
    size: "4",
    variant: "footballSingleEventContainer",
    css: { mt: "$4", "@bp0": { px: "16px" }, "@bp1": { px: "32px" } }
  }, /* @__PURE__ */ React.createElement(SMPFlex, {
    variant: "eventInfo",
    css: { pt: "$5" }
  }, /* @__PURE__ */ React.createElement(GameTeam, {
    sportEntityVariant: "homeTeam",
    handleTeamClick,
    team: match12 == null ? void 0 : match12.homeTeam,
    teamLink: match12 == null ? void 0 : match12.homeTeam.url,
    teamName: (_a2 = match12 == null ? void 0 : match12.homeTeam) == null ? void 0 : _a2.name,
    teamLogo: match12 == null ? void 0 : match12.homeTeam.logo,
    urlTarget: match12 == null ? void 0 : match12.urlTarget,
    isMobile
  }), /* @__PURE__ */ React.createElement(EventInfo, {
    match: match12,
    matchLink: match12.matchLink,
    handleEventClick
  }), /* @__PURE__ */ React.createElement(GameTeam, {
    sportEntityVariant: "awayTeam",
    handleTeamClick,
    team: match12 == null ? void 0 : match12.awayTeam,
    teamLink: match12 == null ? void 0 : match12.awayTeam.url,
    teamName: (_b = match12 == null ? void 0 : match12.awayTeam) == null ? void 0 : _b.name,
    teamLogo: match12 == null ? void 0 : match12.awayTeam.logo,
    urlTarget: match12 == null ? void 0 : match12.urlTarget,
    isMobile
  }))), odds && match12 && /* @__PURE__ */ React.createElement(OddsDisplay, {
    odds,
    handleClick,
    marketSelectionDisplay: false,
    isStandalone: true,
    oddsMarketScope
  }));
};

// src/ogranisms/Ranking/Ranking.tsx
import { useState as useState36 } from "react";
var Ranking = ({ data, handleParticipantClick }) => {
  const { setIsMobile } = useSizeContext();
  const [isTableMobile, setIsTableMobile] = useState36(false);
  const measuredRef = useResizeObserver((fieldElement) => {
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
    setIsTableMobile(fieldElement.offsetWidth < TABULAR_WIDGET_BREAKPOINT_1);
  });
  const { isMobile: isSmartphoneDevice } = useIsSmartphoneDevice();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, data ? /* @__PURE__ */ React.createElement(SMPContainer, {
    ref: measuredRef,
    variant: "paddinglessContainer"
  }, data.map(({ name, item }, index) => {
    return /* @__PURE__ */ React.createElement(Table, {
      key: `ranking-row-${index}`,
      groupName: name,
      columns: (isTableMobile != null ? isTableMobile : isSmartphoneDevice) ? item == null ? void 0 : item.mobileColumns : item == null ? void 0 : item.desktopColumns,
      rows: item == null ? void 0 : item.data,
      handleClick: handleParticipantClick,
      borderedLogo: true,
      addCustomStyles: true,
      tableVariant: TableVariants.DEFAULT
    });
  })) : null);
};

// src/ogranisms/MatchInfo/MatchInfo.tsx
var MatchInfoItem = ({ icon, label, value, additionalAsset, isMobile }) => {
  if (value === void 0 || value === "null")
    return null;
  return /* @__PURE__ */ React.createElement("div", {
    className: "match-general-info",
    style: {
      display: isMobile ? "flex" : "inline-flex",
      flexWrap: "wrap",
      alignItems: "center",
      minWidth: isMobile ? "calc(100% - 16px)" : "calc(25% - 32px)",
      marginBottom: isMobile ? "16px" : "unset",
      marginLeft: isMobile ? "16px" : 0
    }
  }, /* @__PURE__ */ React.createElement("div", {
    style: {
      backgroundImage: `url("${icon}")`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "24px",
      height: "24px",
      marginRight: "8px"
    }
  }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    style: { fontSize: "12px", fontFamily: "var(--fonts-primaryFontFamily)", lineHeight: "20px", color: "var(--colors-gray6)" }
  }, label), /* @__PURE__ */ React.createElement("div", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      lineHeight: "20px"
    }
  }, additionalAsset && /* @__PURE__ */ React.createElement("img", {
    src: additionalAsset,
    alt: label,
    width: "16",
    height: "16",
    style: { display: "inline-flex", marginRight: "4px" }
  }), /* @__PURE__ */ React.createElement("span", {
    style: {
      fontSize: "14px",
      fontWeight: "600",
      fontFamily: "var(--fonts-primaryFontFamily)",
      color: "var(--colors-hiContrast)",
      display: isMobile ? "flex" : "inline-flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, value))));
};

// src/ogranisms/TeamForm/TeamForm.tsx
import { useMemo as useMemo23, useState as useState37 } from "react";
import { getLabelValue as getLabelValue12, classNames as classNames35 } from "@sportal365/smp-widget-utils";
var TeamForm = ({ form, dataLabels, dataTheme, showNextUpcomingGame, handleEventClick }) => {
  const [show, setShow] = useState37(false);
  const handlePointerEnter = () => setShow(true);
  const handlePointerLeave = () => setShow(false);
  const outcome = useMemo23(() => {
    if (!(form == null ? void 0 : form.outcome))
      return null;
    switch (form == null ? void 0 : form.outcome) {
      case TeamFormOutcomeTypes.WIN:
        return { backgroundColor: "bg-winOutcomeBG", text: getLabelValue12(dataLabels == null ? void 0 : dataLabels.win_short, "W"), withElement: false };
      case TeamFormOutcomeTypes.WIN_OVERTIME:
        return {
          backgroundColor: "bg-winOutcomeBG",
          text: getLabelValue12(dataLabels == null ? void 0 : dataLabels.win_overtime_short, "W"),
          withElement: true
        };
      case TeamFormOutcomeTypes.WIN_AFTER_PENALTY:
        return {
          backgroundColor: "bg-winOutcomeBG",
          text: getLabelValue12(dataLabels == null ? void 0 : dataLabels.win_after_penalty_short, "W"),
          withElement: true
        };
      case TeamFormOutcomeTypes.DRAW:
        return { backgroundColor: "bg-drawOutcomeBG", text: getLabelValue12(dataLabels == null ? void 0 : dataLabels.draw_short, "D"), withElement: false };
      case TeamFormOutcomeTypes.LOSS:
        return { backgroundColor: "bg-lossOutcomeBG", text: getLabelValue12(dataLabels == null ? void 0 : dataLabels.loss_short, "L"), withElement: false };
      case TeamFormOutcomeTypes.LOSS_OVERTIME:
        return {
          backgroundColor: "bg-lossOutcomeBG",
          text: getLabelValue12(dataLabels == null ? void 0 : dataLabels.loss_overtime_short, "L"),
          withElement: true
        };
      case TeamFormOutcomeTypes.LOSS_AFTER_PENALTY:
        return {
          backgroundColor: "bg-lossOutcomeBG",
          text: getLabelValue12(dataLabels == null ? void 0 : dataLabels.loss_after_penalty_short, "L"),
          withElement: true
        };
    }
  }, [form, dataLabels]);
  return /* @__PURE__ */ React.createElement("a", {
    key: `team-form-${form.matchSummary}`,
    href: form == null ? void 0 : form.matchLink,
    target: form == null ? void 0 : form.urlTarget,
    onClick: () => handleEventClick && (form == null ? void 0 : form.matchId) && handleEventClick(form.matchId),
    className: "no-underline contents"
  }, /* @__PURE__ */ React.createElement("div", {
    onPointerOver: handlePointerEnter,
    onPointerLeave: handlePointerLeave,
    className: "inline-flex items-center gap-1 flex-row relative"
  }, showNextUpcomingGame && /* @__PURE__ */ React.createElement("div", {
    className: classNames35("bg-upcomingMatch w-6 h-6 relative rounded-2 flex items-center justify-center text-4 font-bold", {
      "text-black": dataTheme === THEME_VARIANTS.DARK,
      "text-white": dataTheme !== THEME_VARIANTS.DARK
    })
  }, "?"), outcome && /* @__PURE__ */ React.createElement("div", {
    className: classNames35(`${outcome.backgroundColor} w-6 h-6 relative rounded-2 flex items-center justify-center text-4 font-bold`, {
      "text-black": dataTheme === THEME_VARIANTS.DARK,
      "text-white": dataTheme !== THEME_VARIANTS.DARK
    })
  }, outcome.text.toUpperCase().slice(0, 1), outcome.withElement && /* @__PURE__ */ React.createElement("div", {
    className: "absolute bottom-0 right-0 w-0 h-0 border-solid border-b-[12px] border-l-[12px] border-t-transparent border-l-transparent border-r-transparent border-b-overtimeBG rounded-br-2"
  })), show && /* @__PURE__ */ React.createElement(TooltipV2, {
    showTooltip: show
  }, /* @__PURE__ */ React.createElement("span", {
    className: "text-center font-bold text-3 block leading-5 m-0 text-standingsTooltipContainerTextColor"
  }, form == null ? void 0 : form.matchSummary), /* @__PURE__ */ React.createElement("span", {
    className: "whitespace-nowrap text-3 block text-left leading-5 m-0 text-standingsTooltipContainerDateTextColor"
  }, form == null ? void 0 : form.startTime))));
};
export {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  Body,
  CalendarIcon,
  Collapsible,
  ComparisonRow,
  ConfigContext,
  Dropdown,
  DropdownBtn,
  DropdownListWrapper,
  DropdownV2,
  EventDate,
  EventInfo,
  FacebookIcon,
  FansUnitedFullTimeOutcome,
  Field,
  Filters,
  FormIcon,
  Game,
  GameScore,
  GameTeam,
  GroupSection,
  GroupSectionTitle,
  H2hHeaderDelimiter,
  Header,
  HeaderV2,
  InstagramIcon,
  Knockout,
  Match,
  MatchInfoItem,
  MatchParticipant,
  MatchScore,
  OddsDisplay,
  OddsDisplayV2,
  PillTabs,
  PillTabsHeader,
  PillTabsV2,
  PlayoffKnockout,
  PlayoffKnockoutNew,
  ProfileHead,
  ProfileInfo,
  ProfileSeasonStatistics,
  Ranking,
  RankingFilters,
  Round,
  RoundEvents,
  SMPArrowButton,
  SMPArrowLeftIcon,
  SMPArrowRightIcon,
  SMPArrowUpIcon,
  SMPBirthdateIcon,
  SMPCalendarIcon,
  SMPCarretDownIcon,
  SMPChevronDownIcon,
  SMPContainer,
  SMPCountBadge,
  SMPDivider,
  SMPDrawIcon,
  SMPFlex,
  SMPGroupCountBadge,
  SMPIcon,
  SMPImage,
  SMPKnockoutDesktopContainer,
  SMPKnockoutGameContainer,
  SMPKnockoutHeaderContainer,
  SMPKnockoutMobileContainer,
  SMPKnockoutMobileGameContainer,
  SMPKnockoutSmallFinal,
  SMPLinkWrapper,
  SMPLoader,
  SMPLossIcon,
  SMPMatchesPlayedIcon,
  SMPMinutesIcon,
  SMPOddEntity,
  SMPOpacitorContainer,
  SMPProgressBar,
  SMPProviderLogo,
  SMPRedCardsIcon,
  SMPRulesColorCircle,
  SMPScore,
  SMPSportEntity,
  SMPSportIcon,
  SMPStandingsIcon,
  SMPStandingsRow,
  SMPStatsWrapper,
  SMPText,
  SMPTooltip,
  SMPWinIcon,
  SMPYellowCardsIcon,
  ShowMore,
  SizeProvider,
  StakesDisplayCustom,
  StakesDisplayFixed,
  Standings,
  StandingsTable,
  SubHeader,
  Tab,
  TabBody,
  Table,
  Tabs,
  TeamForm,
  TeamImagePlaceholderIcon,
  TextBlock,
  TextBlockTailwind,
  Tooltip,
  TooltipV2,
  Tournament,
  TournamentEvents,
  TournamentHeader,
  TwitterIcon,
  WebIcon,
  YouTubeIcon,
  config2 as config,
  createTheme,
  css,
  darkThemeStyles,
  getCssText,
  globalCss,
  keyframes,
  styled,
  theme,
  useSizeContext
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
